import mock from "@/@fake-db/mock";

const data = [
    {
        "Id": 27004158,
        "Time": "2022-02-22T10:53:40",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3764038,
        "Lon": 86.67884,
        "Speed": 0.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 53,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28536,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27006463,
        "Time": "2022-02-22T11:10:20",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3764038,
        "Lon": 86.67884,
        "Speed": 0.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 59,
        "FuelTemperature": 0,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28199,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27007366,
        "Time": "2022-02-22T11:16:51",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.38014,
        "Lon": 86.6900558,
        "Speed": 63.7,
        "Height": 263,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 70,
        "FuelTemperature": 0,
        "EngineRPM": 1587.0,
        "OnboardVoltage": 28179,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27009188,
        "Time": "2022-02-22T11:30:34",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.39083,
        "Lon": 86.70272,
        "Speed": 15.0,
        "Height": 259,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28129,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27010723,
        "Time": "2022-02-22T11:41:53",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3511047,
        "Lon": 86.7145157,
        "Speed": 24.8,
        "Height": 223,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28151,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27012270,
        "Time": "2022-02-22T11:54:26",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.35187,
        "Lon": 86.70285,
        "Speed": 0.0,
        "Height": 216,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28096,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27013741,
        "Time": "2022-02-22T12:06:57",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3680954,
        "Lon": 86.56761,
        "Speed": 67.5,
        "Height": 251,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1502.0,
        "OnboardVoltage": 28158,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27015126,
        "Time": "2022-02-22T12:20:13",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.4360657,
        "Lon": 86.41243,
        "Speed": 79.2,
        "Height": 211,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1334.0,
        "OnboardVoltage": 28033,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27016388,
        "Time": "2022-02-22T12:29:39",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.49102,
        "Lon": 86.36296,
        "Speed": 40.9,
        "Height": 192,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 0,
        "EngineRPM": 1355.0,
        "OnboardVoltage": 28100,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27017423,
        "Time": "2022-02-22T12:41:13",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.4310036,
        "Lon": 86.2823,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 1471.0,
        "OnboardVoltage": 28131,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27018440,
        "Time": "2022-02-22T12:52:18",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.36471,
        "Lon": 86.16971,
        "Speed": 72.2,
        "Height": 229,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 1442.0,
        "OnboardVoltage": 28015,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27019896,
        "Time": "2022-02-22T13:03:43",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3060455,
        "Lon": 86.11088,
        "Speed": 42.5,
        "Height": 226,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 987.0,
        "OnboardVoltage": 28119,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27020895,
        "Time": "2022-02-22T13:13:01",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27719,
        "Lon": 86.14375,
        "Speed": 41.6,
        "Height": 294,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1311.0,
        "OnboardVoltage": 28143,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27022089,
        "Time": "2022-02-22T13:25:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27038,
        "Lon": 86.1517,
        "Speed": 8.8,
        "Height": 291,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28077,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27023553,
        "Time": "2022-02-22T13:38:57",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2678642,
        "Lon": 86.15526,
        "Speed": 0.0,
        "Height": 289,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28480,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27024820,
        "Time": "2022-02-22T13:50:10",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2709236,
        "Lon": 86.154274,
        "Speed": 17.5,
        "Height": 297,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 0,
        "EngineRPM": 631.0,
        "OnboardVoltage": 28348,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27026746,
        "Time": "2022-02-22T14:04:09",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28440,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27028812,
        "Time": "2022-02-22T14:18:42",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2702,
        "Lon": 86.1521454,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28225,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27031205,
        "Time": "2022-02-22T14:35:22",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28184,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27033290,
        "Time": "2022-02-22T14:52:02",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707558,
        "Lon": 86.15153,
        "Speed": 0.0,
        "Height": 278,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26282,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27035598,
        "Time": "2022-02-22T15:08:42",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707558,
        "Lon": 86.15153,
        "Speed": 0.0,
        "Height": 278,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28696,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27037907,
        "Time": "2022-02-22T15:24:44",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.268974299999996,
        "Lon": 86.15733,
        "Speed": 0.0,
        "Height": 261,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28646,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27039960,
        "Time": "2022-02-22T15:41:12",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27081,
        "Lon": 86.1515,
        "Speed": 0.0,
        "Height": 282,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28788,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27041846,
        "Time": "2022-02-22T15:57:52",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27081,
        "Lon": 86.1515,
        "Speed": 0.0,
        "Height": 282,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28701,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27043851,
        "Time": "2022-02-22T16:14:32",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27081,
        "Lon": 86.1515,
        "Speed": 0.0,
        "Height": 282,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28775,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27045831,
        "Time": "2022-02-22T16:27:19",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27186,
        "Lon": 86.14738,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28689,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27047302,
        "Time": "2022-02-22T16:40:20",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27269,
        "Lon": 86.15133,
        "Speed": 5.5,
        "Height": 61,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 49,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28173,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27049455,
        "Time": "2022-02-22T16:56:43",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27103,
        "Lon": 86.15136,
        "Speed": 0.0,
        "Height": 250,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 59,
        "FuelTemperature": 0,
        "EngineRPM": 649.0,
        "OnboardVoltage": 28106,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27051203,
        "Time": "2022-02-22T17:09:51",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2704659,
        "Lon": 86.15086,
        "Speed": 0.0,
        "Height": 284,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 65,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28159,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27052644,
        "Time": "2022-02-22T17:23:29",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2704849,
        "Lon": 86.1519852,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 69,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 27870,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27054326,
        "Time": "2022-02-22T17:38:32",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2724876,
        "Lon": 86.1485443,
        "Speed": 32.2,
        "Height": 295,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 1462.0,
        "OnboardVoltage": 28074,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27055724,
        "Time": "2022-02-22T17:51:41",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25704,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27057551,
        "Time": "2022-02-22T18:08:21",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25708,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27059419,
        "Time": "2022-02-22T18:25:01",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25242,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27061355,
        "Time": "2022-02-22T18:41:41",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25649,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27063745,
        "Time": "2022-02-22T18:58:21",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25521,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27066047,
        "Time": "2022-02-22T19:15:01",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25599,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27068248,
        "Time": "2022-02-22T19:31:41",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25555,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27070475,
        "Time": "2022-02-22T19:47:51",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25208,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27072826,
        "Time": "2022-02-22T20:04:25",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25526,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27075381,
        "Time": "2022-02-22T20:20:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25116,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27077686,
        "Time": "2022-02-22T20:37:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25491,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27079937,
        "Time": "2022-02-22T20:54:16",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25432,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27082349,
        "Time": "2022-02-22T21:10:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25442,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27084325,
        "Time": "2022-02-22T21:27:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25403,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27086561,
        "Time": "2022-02-22T21:44:16",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25400,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27088902,
        "Time": "2022-02-22T22:00:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25384,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27091184,
        "Time": "2022-02-22T22:17:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25363,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27093202,
        "Time": "2022-02-22T22:34:16",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25342,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27095237,
        "Time": "2022-02-22T22:50:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24989,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27097498,
        "Time": "2022-02-22T23:07:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25317,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27099655,
        "Time": "2022-02-22T23:24:16",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24958,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27101881,
        "Time": "2022-02-22T23:40:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25284,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27104072,
        "Time": "2022-02-22T23:57:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24913,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27106032,
        "Time": "2022-02-23T00:14:16",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25250,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27108276,
        "Time": "2022-02-23T00:30:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25119,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27109343,
        "Time": "2022-02-23T00:47:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25225,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27111387,
        "Time": "2022-02-23T01:04:13",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2852554,
        "Lon": 86.1323547,
        "Speed": 0.0,
        "Height": 303,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 10,
        "FuelTemperature": 0,
        "EngineRPM": 661.0,
        "OnboardVoltage": 28101,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27113113,
        "Time": "2022-02-23T01:19:54",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.28509,
        "Lon": 86.13237,
        "Speed": 11.2,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 58,
        "FuelTemperature": 0,
        "EngineRPM": 1012.0,
        "OnboardVoltage": 28039,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27114169,
        "Time": "2022-02-23T01:29:20",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.26837,
        "Lon": 86.15961,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 1621.0,
        "OnboardVoltage": 28020,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27115239,
        "Time": "2022-02-23T01:37:46",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2716827,
        "Lon": 86.165184,
        "Speed": 40.1,
        "Height": 68,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 935.0,
        "OnboardVoltage": 28083,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27116135,
        "Time": "2022-02-23T01:43:57",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2755775,
        "Lon": 86.1770859,
        "Speed": 19.6,
        "Height": 104,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 0,
        "EngineRPM": 1269.0,
        "OnboardVoltage": 28075,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27117454,
        "Time": "2022-02-23T01:52:49",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2791977,
        "Lon": 86.1934738,
        "Speed": 0.0,
        "Height": 256,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26460,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27119318,
        "Time": "2022-02-23T02:06:57",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.26872,
        "Lon": 86.18625,
        "Speed": 47.4,
        "Height": 208,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 1451.0,
        "OnboardVoltage": 28216,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27120261,
        "Time": "2022-02-23T02:12:42",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27254,
        "Lon": 86.1647644,
        "Speed": 27.0,
        "Height": 56,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 951.0,
        "OnboardVoltage": 28192,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27121159,
        "Time": "2022-02-23T02:19:54",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.25619,
        "Lon": 86.16422,
        "Speed": 12.4,
        "Height": 282,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 0,
        "EngineRPM": 1001.0,
        "OnboardVoltage": 28221,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27122322,
        "Time": "2022-02-23T02:29:04",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2711372,
        "Lon": 86.15115,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28255,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27124747,
        "Time": "2022-02-23T02:45:44",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28477,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.8
    },
    {
        "Id": 27126611,
        "Time": "2022-02-23T02:59:44",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2700653,
        "Lon": 86.15426,
        "Speed": 0.0,
        "Height": 269,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28600,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.8
    },
    {
        "Id": 27128861,
        "Time": "2022-02-23T03:14:38",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.271904,
        "Lon": 86.150856,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28641,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.8
    },
    {
        "Id": 27130160,
        "Time": "2022-02-23T03:25:07",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2708,
        "Lon": 86.1516,
        "Speed": 4.2,
        "Height": 285,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 61,
        "FuelTemperature": 0,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28666,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.0
    },
    {
        "Id": 27131950,
        "Time": "2022-02-23T03:36:46",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27019,
        "Lon": 86.1524048,
        "Speed": 0.0,
        "Height": 281,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 69,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28661,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.8
    },
    {
        "Id": 27133898,
        "Time": "2022-02-23T03:51:10",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2716255,
        "Lon": 86.15078,
        "Speed": 0.0,
        "Height": 293,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28212,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27136468,
        "Time": "2022-02-23T04:07:50",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2716255,
        "Lon": 86.15078,
        "Speed": 0.0,
        "Height": 293,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28217,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27138952,
        "Time": "2022-02-23T04:23:19",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2787743,
        "Lon": 86.16787,
        "Speed": 0.0,
        "Height": -111,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28215,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27141186,
        "Time": "2022-02-23T04:37:11",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707367,
        "Lon": 86.15133,
        "Speed": 4.0,
        "Height": 285,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 657.0,
        "OnboardVoltage": 28216,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27142958,
        "Time": "2022-02-23T04:49:39",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2699,
        "Lon": 86.1522446,
        "Speed": 0.0,
        "Height": 279,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28211,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27144854,
        "Time": "2022-02-23T05:05:13",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2699776,
        "Lon": 86.15233,
        "Speed": 0.0,
        "Height": 278,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28202,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27146429,
        "Time": "2022-02-23T05:21:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.26988,
        "Lon": 86.1521759,
        "Speed": 0.0,
        "Height": 285,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28200,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27148060,
        "Time": "2022-02-23T05:38:16",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.26988,
        "Lon": 86.1521759,
        "Speed": 0.0,
        "Height": 285,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 0,
        "EngineRPM": 648.0,
        "OnboardVoltage": 28517,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.8
    },
    {
        "Id": 27149853,
        "Time": "2022-02-23T05:52:57",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2689857,
        "Lon": 86.15344,
        "Speed": 20.5,
        "Height": 283,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 68,
        "FuelTemperature": 0,
        "EngineRPM": 1243.0,
        "OnboardVoltage": 28210,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27151342,
        "Time": "2022-02-23T06:03:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2481766,
        "Lon": 86.1410751,
        "Speed": 11.6,
        "Height": 367,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 1003.0,
        "OnboardVoltage": 28155,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27153424,
        "Time": "2022-02-23T06:18:44",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2478638,
        "Lon": 86.14217,
        "Speed": 0.0,
        "Height": 392,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26149,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27155281,
        "Time": "2022-02-23T06:33:50",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.24838,
        "Lon": 86.14112,
        "Speed": 12.7,
        "Height": 365,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25394,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27157527,
        "Time": "2022-02-23T06:50:07",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2482033,
        "Lon": 86.14013,
        "Speed": 0.0,
        "Height": 355,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25313,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27159390,
        "Time": "2022-02-23T07:03:45",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2475853,
        "Lon": 86.1425858,
        "Speed": 0.0,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 53,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28179,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27161952,
        "Time": "2022-02-23T07:20:25",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2475853,
        "Lon": 86.1425858,
        "Speed": 0.0,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 52,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25281,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27164229,
        "Time": "2022-02-23T07:37:05",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2475853,
        "Lon": 86.1425858,
        "Speed": 0.0,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 52,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28329,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27166714,
        "Time": "2022-02-23T07:53:45",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2475853,
        "Lon": 86.1425858,
        "Speed": 0.0,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 52,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28645,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27168660,
        "Time": "2022-02-23T08:10:25",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2475853,
        "Lon": 86.1425858,
        "Speed": 0.0,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 35,
        "FuelTemperature": 0,
        "EngineRPM": 649.0,
        "OnboardVoltage": 28564,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27170859,
        "Time": "2022-02-23T08:27:05",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2475853,
        "Lon": 86.1425858,
        "Speed": 0.0,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 51,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28743,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27172866,
        "Time": "2022-02-23T08:43:45",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2475853,
        "Lon": 86.1425858,
        "Speed": 0.0,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 57,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28201,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27174968,
        "Time": "2022-02-23T09:00:17",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.247673,
        "Lon": 86.14187,
        "Speed": 5.3,
        "Height": 362,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 59,
        "FuelTemperature": 0,
        "EngineRPM": 1268.0,
        "OnboardVoltage": 28114,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27175901,
        "Time": "2022-02-23T09:07:57",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2697754,
        "Lon": 86.15238,
        "Speed": 38.3,
        "Height": 276,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 1105.0,
        "OnboardVoltage": 28242,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27177813,
        "Time": "2022-02-23T09:24:34",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707176,
        "Lon": 86.15142,
        "Speed": 0.0,
        "Height": 293,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28459,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27179318,
        "Time": "2022-02-23T09:36:13",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27022,
        "Lon": 86.15079,
        "Speed": 6.1,
        "Height": 265,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28553,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27181451,
        "Time": "2022-02-23T09:51:08",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27111,
        "Lon": 86.15069,
        "Speed": 0.0,
        "Height": 245,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28497,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27183645,
        "Time": "2022-02-23T10:07:48",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27111,
        "Lon": 86.15069,
        "Speed": 0.0,
        "Height": 245,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28689,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27185804,
        "Time": "2022-02-23T10:23:59",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707176,
        "Lon": 86.15112,
        "Speed": 12.4,
        "Height": 268,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28594,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27187666,
        "Time": "2022-02-23T10:39:42",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28729,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27190061,
        "Time": "2022-02-23T10:56:22",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28850,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27192268,
        "Time": "2022-02-23T11:12:58",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.26842,
        "Lon": 86.1518,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28713,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27194374,
        "Time": "2022-02-23T11:29:31",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707634,
        "Lon": 86.15146,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28746,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27196179,
        "Time": "2022-02-23T11:42:23",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27272,
        "Lon": 86.15781,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28795,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27198109,
        "Time": "2022-02-23T11:58:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2706375,
        "Lon": 86.152,
        "Speed": 11.6,
        "Height": 284,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28838,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.8
    },
    {
        "Id": 27199938,
        "Time": "2022-02-23T12:15:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2706528,
        "Lon": 86.15203,
        "Speed": 0.0,
        "Height": 284,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25558,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27201445,
        "Time": "2022-02-23T12:32:07",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2705421,
        "Lon": 86.15148,
        "Speed": 0.0,
        "Height": 281,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 43,
        "FuelTemperature": 0,
        "EngineRPM": 648.0,
        "OnboardVoltage": 28151,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27202762,
        "Time": "2022-02-23T12:46:20",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.27073,
        "Lon": 86.1513,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 53,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28158,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27204363,
        "Time": "2022-02-23T13:02:31",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707634,
        "Lon": 86.1513748,
        "Speed": 0.0,
        "Height": 281,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 59,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28163,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27206090,
        "Time": "2022-02-23T13:19:11",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2707634,
        "Lon": 86.1513748,
        "Speed": 0.0,
        "Height": 281,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 65,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28164,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27208087,
        "Time": "2022-02-23T13:33:36",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2704163,
        "Lon": 86.15182,
        "Speed": 0.0,
        "Height": 283,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 69,
        "FuelTemperature": 0,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28166,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27210196,
        "Time": "2022-02-23T13:49:24",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2699966,
        "Lon": 86.1524353,
        "Speed": 0.0,
        "Height": 279,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 0,
        "EngineRPM": 648.0,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.4
    },
    {
        "Id": 27211516,
        "Time": "2022-02-23T14:00:43",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.2966042,
        "Lon": 86.11292,
        "Speed": 60.9,
        "Height": 249,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 1439.0,
        "OnboardVoltage": 28148,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.4
    },
    {
        "Id": 27212908,
        "Time": "2022-02-23T14:10:31",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3190346,
        "Lon": 86.07173,
        "Speed": 57.9,
        "Height": 220,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 1586.0,
        "OnboardVoltage": 28022,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27214800,
        "Time": "2022-02-23T14:23:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.40243,
        "Lon": 86.24911,
        "Speed": 44.6,
        "Height": 179,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1258.0,
        "OnboardVoltage": 28103,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.8
    },
    {
        "Id": 27216234,
        "Time": "2022-02-23T14:34:38",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.4346275,
        "Lon": 86.29351,
        "Speed": 0.0,
        "Height": 212,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28227,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27217739,
        "Time": "2022-02-23T14:46:23",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.4742928,
        "Lon": 86.32348,
        "Speed": 62.5,
        "Height": 208,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1500.0,
        "OnboardVoltage": 28137,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27218770,
        "Time": "2022-02-23T14:55:48",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.4536629,
        "Lon": 86.40408,
        "Speed": 84.2,
        "Height": 198,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 0,
        "EngineRPM": 1517.0,
        "OnboardVoltage": 28115,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27220215,
        "Time": "2022-02-23T15:06:59",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3835754,
        "Lon": 86.52426,
        "Speed": 65.9,
        "Height": 208,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1180.0,
        "OnboardVoltage": 28026,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27221765,
        "Time": "2022-02-23T15:19:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3514557,
        "Lon": 86.71117,
        "Speed": 42.5,
        "Height": 204,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1289.0,
        "OnboardVoltage": 28126,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27222962,
        "Time": "2022-02-23T15:27:54",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37782,
        "Lon": 86.68617,
        "Speed": 14.2,
        "Height": 268,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 0,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28106,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27224385,
        "Time": "2022-02-23T15:38:28",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37641,
        "Lon": 86.6790161,
        "Speed": 0.0,
        "Height": 279,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26295,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27226824,
        "Time": "2022-02-23T15:54:22",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37791,
        "Lon": 86.67602,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25452,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27229117,
        "Time": "2022-02-23T16:11:02",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25628,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27231255,
        "Time": "2022-02-23T16:27:42",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25150,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27233300,
        "Time": "2022-02-23T16:44:21",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25545,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27235610,
        "Time": "2022-02-23T17:01:01",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25477,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27237367,
        "Time": "2022-02-23T17:17:33",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25489,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27239045,
        "Time": "2022-02-23T17:33:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25439,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27241177,
        "Time": "2022-02-23T17:50:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25039,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27243368,
        "Time": "2022-02-23T18:07:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25389,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27245444,
        "Time": "2022-02-23T18:23:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25260,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27247514,
        "Time": "2022-02-23T18:40:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25339,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27249776,
        "Time": "2022-02-23T18:57:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25300,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27252180,
        "Time": "2022-02-23T19:13:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25301,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27254357,
        "Time": "2022-02-23T19:30:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25259,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27256465,
        "Time": "2022-02-23T19:47:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24890,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27258975,
        "Time": "2022-02-23T20:03:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25228,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27261282,
        "Time": "2022-02-23T20:20:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24841,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27263496,
        "Time": "2022-02-23T20:37:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25206,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27265588,
        "Time": "2022-02-23T20:53:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25150,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27267695,
        "Time": "2022-02-23T21:10:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24818,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27269925,
        "Time": "2022-02-23T21:27:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25128,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27272209,
        "Time": "2022-02-23T21:43:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24771,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27274660,
        "Time": "2022-02-23T22:00:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25110,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27276926,
        "Time": "2022-02-23T22:17:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24752,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27279415,
        "Time": "2022-02-23T22:33:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25120,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27281828,
        "Time": "2022-02-23T22:50:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25056,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27284215,
        "Time": "2022-02-23T23:07:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24740,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27286771,
        "Time": "2022-02-23T23:23:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25052,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27289142,
        "Time": "2022-02-23T23:40:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24699,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27291528,
        "Time": "2022-02-23T23:57:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25037,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27293912,
        "Time": "2022-02-24T00:13:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24993,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27296068,
        "Time": "2022-02-24T00:30:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24697,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27297175,
        "Time": "2022-02-24T00:47:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37645,
        "Lon": 86.6789856,
        "Speed": 0.0,
        "Height": 277,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24991,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27298657,
        "Time": "2022-02-24T01:02:17",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3766556,
        "Lon": 86.67963,
        "Speed": 27.5,
        "Height": 282,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 42,
        "FuelTemperature": 0,
        "EngineRPM": 652.0,
        "OnboardVoltage": 28084,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27300659,
        "Time": "2022-02-24T01:19:01",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3765,
        "Lon": 86.67898,
        "Speed": 0.0,
        "Height": 283,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 69,
        "FuelTemperature": 0,
        "EngineRPM": 649.0,
        "OnboardVoltage": 28311,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27302983,
        "Time": "2022-02-24T01:35:22",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37655,
        "Lon": 86.67896,
        "Speed": 0.0,
        "Height": 269,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28451,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27305439,
        "Time": "2022-02-24T01:52:02",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37652,
        "Lon": 86.67902,
        "Speed": 0.0,
        "Height": 283,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28247,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27307494,
        "Time": "2022-02-24T02:05:30",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.37641,
        "Lon": 86.67922,
        "Speed": 17.4,
        "Height": 281,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25562,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27309591,
        "Time": "2022-02-24T02:18:56",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3762932,
        "Lon": 86.6798859,
        "Speed": 0.0,
        "Height": 275,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25432,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27311615,
        "Time": "2022-02-24T02:32:55",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 67,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25278,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27313949,
        "Time": "2022-02-24T02:49:35",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 67,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28291,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27316450,
        "Time": "2022-02-24T03:06:15",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 0.0,
        "Lon": 0.0,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 67,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28427,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27318565,
        "Time": "2022-02-24T03:22:18",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3760643,
        "Lon": 86.67924,
        "Speed": 0.0,
        "Height": 285,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25401,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27320742,
        "Time": "2022-02-24T03:36:38",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3773727,
        "Lon": 86.679184,
        "Speed": 10.7,
        "Height": 144,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25242,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27323058,
        "Time": "2022-02-24T03:50:59",
        "TruckId": 1994,
        "Imei": "861774057963462",
        "Lat": 54.3765335,
        "Lon": 86.67962,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25332,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27004193,
        "Time": "2022-02-22T10:53:37",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40961,
        "Lon": 87.30045,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27990,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27006499,
        "Time": "2022-02-22T11:10:17",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40961,
        "Lon": 87.30045,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27978,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27008617,
        "Time": "2022-02-22T11:26:49",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40961,
        "Lon": 87.30045,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27960,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27010953,
        "Time": "2022-02-22T11:43:26",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40961,
        "Lon": 87.30045,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27952,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27012958,
        "Time": "2022-02-22T11:59:55",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40961,
        "Lon": 87.30045,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27939,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27014733,
        "Time": "2022-02-22T12:16:35",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40961,
        "Lon": 87.30045,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27721,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27016795,
        "Time": "2022-02-22T12:33:15",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40961,
        "Lon": 87.30045,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27724,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27018117,
        "Time": "2022-02-22T12:48:45",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40996,
        "Lon": 87.30035,
        "Speed": 0.0,
        "Height": 245,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24409,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27020108,
        "Time": "2022-02-22T13:05:08",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40996,
        "Lon": 87.30035,
        "Speed": 0.0,
        "Height": 245,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 67,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27722,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.8
    },
    {
        "Id": 27021678,
        "Time": "2022-02-22T13:21:27",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099846,
        "Lon": 87.30054,
        "Speed": 5.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 986.0,
        "OnboardVoltage": 27670,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27022548,
        "Time": "2022-02-22T13:30:12",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4076424,
        "Lon": 87.31871,
        "Speed": 0.0,
        "Height": 259,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27730,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27023634,
        "Time": "2022-02-22T13:39:20",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097443,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 222,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27812,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27025115,
        "Time": "2022-02-22T13:52:01",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4106827,
        "Lon": 87.2973,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.0
    },
    {
        "Id": 27026750,
        "Time": "2022-02-22T14:03:57",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40981,
        "Lon": 87.30035,
        "Speed": 0.0,
        "Height": 232,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27822,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27029056,
        "Time": "2022-02-22T14:20:31",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40981,
        "Lon": 87.30035,
        "Speed": 0.0,
        "Height": 232,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27766,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27031122,
        "Time": "2022-02-22T14:34:19",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4094734,
        "Lon": 87.38946,
        "Speed": 49.2,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 0,
        "EngineRPM": 1599.0,
        "OnboardVoltage": 27549,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27032813,
        "Time": "2022-02-22T14:48:39",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4900055,
        "Lon": 87.4438248,
        "Speed": 45.3,
        "Height": 413,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1487.0,
        "OnboardVoltage": 27501,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27034545,
        "Time": "2022-02-22T15:00:29",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184975,
        "Lon": 87.43593,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27757,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27036803,
        "Time": "2022-02-22T15:17:08",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184975,
        "Lon": 87.43593,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27772,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27039089,
        "Time": "2022-02-22T15:33:41",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184975,
        "Lon": 87.43593,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27040803,
        "Time": "2022-02-22T15:48:34",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184021,
        "Lon": 87.4352951,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 28078,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27042731,
        "Time": "2022-02-22T16:05:09",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5179138,
        "Lon": 87.43429,
        "Speed": 0.0,
        "Height": 288,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25175,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27045162,
        "Time": "2022-02-22T16:21:35",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5179138,
        "Lon": 87.43429,
        "Speed": 0.0,
        "Height": 288,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24306,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27047098,
        "Time": "2022-02-22T16:38:15",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5179138,
        "Lon": 87.43429,
        "Speed": 0.0,
        "Height": 288,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 23971,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27049204,
        "Time": "2022-02-22T16:54:40",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51777,
        "Lon": 87.435,
        "Speed": 4.2,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 23534,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27051415,
        "Time": "2022-02-22T17:11:06",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51778,
        "Lon": 87.43498,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24016,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27053218,
        "Time": "2022-02-22T17:27:45",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51778,
        "Lon": 87.43498,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 23989,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27055045,
        "Time": "2022-02-22T17:44:25",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51778,
        "Lon": 87.43498,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24000,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27056720,
        "Time": "2022-02-22T18:00:38",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5178223,
        "Lon": 87.43444,
        "Speed": 0.0,
        "Height": 242,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 23961,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27058559,
        "Time": "2022-02-22T18:16:48",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5179749,
        "Lon": 87.43459,
        "Speed": 0.0,
        "Height": 256,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 17691,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27060290,
        "Time": "2022-02-22T18:32:33",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5177727,
        "Lon": 87.43518,
        "Speed": 4.0,
        "Height": 287,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 19654,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27062268,
        "Time": "2022-02-22T18:48:13",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51777,
        "Lon": 87.4351044,
        "Speed": 0.0,
        "Height": 403,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 62,
        "FuelTemperature": 0,
        "EngineRPM": 1202.0,
        "OnboardVoltage": 27732,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27064661,
        "Time": "2022-02-22T19:03:49",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5186844,
        "Lon": 87.43416,
        "Speed": 4.6,
        "Height": 254,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27867,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27066803,
        "Time": "2022-02-22T19:19:57",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5175552,
        "Lon": 87.43502,
        "Speed": 0.0,
        "Height": 339,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27948,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27068887,
        "Time": "2022-02-22T19:36:25",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51744,
        "Lon": 87.43532,
        "Speed": 0.0,
        "Height": 359,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27967,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27071073,
        "Time": "2022-02-22T19:51:05",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.517704,
        "Lon": 87.43513,
        "Speed": 0.0,
        "Height": 289,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27988,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27073307,
        "Time": "2022-02-22T20:07:33",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51856,
        "Lon": 87.43474,
        "Speed": 0.0,
        "Height": 254,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27840,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27075063,
        "Time": "2022-02-22T20:18:38",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4867973,
        "Lon": 87.4447556,
        "Speed": 43.3,
        "Height": 432,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 92,
        "FuelTemperature": 0,
        "EngineRPM": 1425.0,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.0
    },
    {
        "Id": 27077128,
        "Time": "2022-02-22T20:33:04",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4094467,
        "Lon": 87.38894,
        "Speed": 42.5,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1354.0,
        "OnboardVoltage": 27544,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.0
    },
    {
        "Id": 27078834,
        "Time": "2022-02-22T20:46:12",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27804,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 97.200005
    },
    {
        "Id": 27081253,
        "Time": "2022-02-22T21:02:48",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27733,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.200005
    },
    {
        "Id": 27083331,
        "Time": "2022-02-22T21:19:05",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27749,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27085536,
        "Time": "2022-02-22T21:35:45",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27684,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.8
    },
    {
        "Id": 27087666,
        "Time": "2022-02-22T21:52:25",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27666,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27090261,
        "Time": "2022-02-22T22:09:05",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27749,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.8
    },
    {
        "Id": 27092197,
        "Time": "2022-02-22T22:25:45",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27700,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27094100,
        "Time": "2022-02-22T22:42:25",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27726,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.8
    },
    {
        "Id": 27096428,
        "Time": "2022-02-22T22:59:05",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 598.0,
        "OnboardVoltage": 27726,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 97.200005
    },
    {
        "Id": 27098446,
        "Time": "2022-02-22T23:15:18",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27721,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27100759,
        "Time": "2022-02-22T23:31:40",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27707,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.8
    },
    {
        "Id": 27102894,
        "Time": "2022-02-22T23:48:11",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.8
    },
    {
        "Id": 27104787,
        "Time": "2022-02-23T00:04:42",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27762,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.0
    },
    {
        "Id": 27106945,
        "Time": "2022-02-23T00:20:58",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27735,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27108724,
        "Time": "2022-02-23T00:37:22",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40966,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27740,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27109825,
        "Time": "2022-02-23T00:52:07",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097557,
        "Lon": 87.3005753,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27111524,
        "Time": "2022-02-23T01:05:06",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097672,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27828,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27113338,
        "Time": "2022-02-23T01:21:42",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097672,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27115378,
        "Time": "2022-02-23T01:38:19",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097672,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27765,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27117279,
        "Time": "2022-02-23T01:51:41",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4092827,
        "Lon": 87.30227,
        "Speed": 15.7,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 950.0,
        "OnboardVoltage": 27860,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27119069,
        "Time": "2022-02-23T02:04:44",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099846,
        "Lon": 87.35568,
        "Speed": 54.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 92,
        "FuelTemperature": 0,
        "EngineRPM": 1736.0,
        "OnboardVoltage": 27795,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27120831,
        "Time": "2022-02-23T02:17:39",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.45508,
        "Lon": 87.42717,
        "Speed": 9.0,
        "Height": 283,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 94,
        "FuelTemperature": 0,
        "EngineRPM": 1551.0,
        "OnboardVoltage": 27892,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27122338,
        "Time": "2022-02-23T02:28:55",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4577522,
        "Lon": 87.42567,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27932,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27124751,
        "Time": "2022-02-23T02:45:31",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4577522,
        "Lon": 87.42567,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27880,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27126977,
        "Time": "2022-02-23T03:02:11",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4577522,
        "Lon": 87.42567,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27861,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27129426,
        "Time": "2022-02-23T03:18:51",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4577522,
        "Lon": 87.42567,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27131060,
        "Time": "2022-02-23T03:30:20",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4508743,
        "Lon": 87.42773,
        "Speed": 28.7,
        "Height": 266,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 919.0,
        "OnboardVoltage": 27887,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27132215,
        "Time": "2022-02-23T03:38:32",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.42209,
        "Lon": 87.4183,
        "Speed": 41.1,
        "Height": 343,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 0,
        "EngineRPM": 1343.0,
        "OnboardVoltage": 27856,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27133630,
        "Time": "2022-02-23T03:48:39",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4107933,
        "Lon": 87.40783,
        "Speed": 8.5,
        "Height": 347,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 0,
        "EngineRPM": 1038.0,
        "OnboardVoltage": 27842,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27135741,
        "Time": "2022-02-23T04:03:00",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41189,
        "Lon": 87.4062958,
        "Speed": 0.0,
        "Height": 343,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27885,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27137128,
        "Time": "2022-02-23T04:10:49",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41369,
        "Lon": 87.40799,
        "Speed": 9.8,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27895,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27138569,
        "Time": "2022-02-23T04:20:18",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4101028,
        "Lon": 87.35645,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27877,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27140398,
        "Time": "2022-02-23T04:30:51",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41187,
        "Lon": 87.40634,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27859,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27142614,
        "Time": "2022-02-23T04:47:20",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41187,
        "Lon": 87.40634,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27844,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27144772,
        "Time": "2022-02-23T05:04:00",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41187,
        "Lon": 87.40634,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27846,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27146347,
        "Time": "2022-02-23T05:20:22",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41187,
        "Lon": 87.40634,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27147932,
        "Time": "2022-02-23T05:36:54",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41187,
        "Lon": 87.40634,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27149610,
        "Time": "2022-02-23T05:51:04",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4533577,
        "Lon": 87.4350739,
        "Speed": 41.1,
        "Height": 364,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 93,
        "FuelTemperature": 0,
        "EngineRPM": 1319.0,
        "OnboardVoltage": 27774,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27151493,
        "Time": "2022-02-23T06:04:29",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5175552,
        "Lon": 87.44303,
        "Speed": 33.1,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 0,
        "EngineRPM": 1023.0,
        "OnboardVoltage": 27779,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27152812,
        "Time": "2022-02-23T06:13:04",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5120659,
        "Lon": 87.42737,
        "Speed": 23.3,
        "Height": 306,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1583.0,
        "OnboardVoltage": 27838,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27153930,
        "Time": "2022-02-23T06:22:17",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5345535,
        "Lon": 87.43596,
        "Speed": 4.0,
        "Height": 432,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 92,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27929,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27155592,
        "Time": "2022-02-23T06:36:17",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5347939,
        "Lon": 87.43566,
        "Speed": 0.0,
        "Height": 430,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27913,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27157841,
        "Time": "2022-02-23T06:52:46",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5347939,
        "Lon": 87.43566,
        "Speed": 0.0,
        "Height": 430,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27871,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27160006,
        "Time": "2022-02-23T07:07:24",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5397263,
        "Lon": 87.43808,
        "Speed": 28.8,
        "Height": 407,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 925.0,
        "OnboardVoltage": 27859,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27161557,
        "Time": "2022-02-23T07:17:32",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5327835,
        "Lon": 87.42986,
        "Speed": 0.0,
        "Height": 375,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27850,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27163848,
        "Time": "2022-02-23T07:34:00",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5327225,
        "Lon": 87.43015,
        "Speed": 10.5,
        "Height": 376,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 1387.0,
        "OnboardVoltage": 27809,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27165339,
        "Time": "2022-02-23T07:43:52",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5338326,
        "Lon": 87.4354248,
        "Speed": 7.4,
        "Height": 436,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 1054.0,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27167260,
        "Time": "2022-02-23T07:57:35",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5345345,
        "Lon": 87.4358,
        "Speed": 0.0,
        "Height": 431,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27863,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27169221,
        "Time": "2022-02-23T08:14:02",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5345345,
        "Lon": 87.4358,
        "Speed": 0.0,
        "Height": 431,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 68,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27862,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27171257,
        "Time": "2022-02-23T08:30:34",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5345345,
        "Lon": 87.4358,
        "Speed": 0.0,
        "Height": 431,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 64,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27172278,
        "Time": "2022-02-23T08:38:30",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.52056,
        "Lon": 87.43691,
        "Speed": 39.4,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 0,
        "EngineRPM": 1284.0,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27173711,
        "Time": "2022-02-23T08:49:10",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4966736,
        "Lon": 87.43726,
        "Speed": 0.0,
        "Height": 361,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27905,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27175664,
        "Time": "2022-02-23T09:05:50",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4966736,
        "Lon": 87.43726,
        "Speed": 0.0,
        "Height": 361,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27861,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27177570,
        "Time": "2022-02-23T09:22:30",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4966736,
        "Lon": 87.43726,
        "Speed": 0.0,
        "Height": 361,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27850,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27179752,
        "Time": "2022-02-23T09:39:07",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4966736,
        "Lon": 87.43726,
        "Speed": 0.0,
        "Height": 361,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 69,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27181915,
        "Time": "2022-02-23T09:53:27",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4538231,
        "Lon": 87.43489,
        "Speed": 50.0,
        "Height": 362,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 1617.0,
        "OnboardVoltage": 27783,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27183595,
        "Time": "2022-02-23T10:07:03",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.43418,
        "Lon": 87.42911,
        "Speed": 0.0,
        "Height": 310,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27875,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27185798,
        "Time": "2022-02-23T10:23:37",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.43418,
        "Lon": 87.42911,
        "Speed": 0.0,
        "Height": 310,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27896,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27187366,
        "Time": "2022-02-23T10:37:24",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4082375,
        "Lon": 87.38018,
        "Speed": 46.1,
        "Height": 340,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 597.0,
        "OnboardVoltage": 27758,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27189003,
        "Time": "2022-02-23T10:48:27",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4100838,
        "Lon": 87.3001,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27792,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27191257,
        "Time": "2022-02-23T11:05:00",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4100838,
        "Lon": 87.3001,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27773,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27193444,
        "Time": "2022-02-23T11:21:31",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4100838,
        "Lon": 87.3001,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27800,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27195647,
        "Time": "2022-02-23T11:38:04",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4100838,
        "Lon": 87.3001,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27796,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27197601,
        "Time": "2022-02-23T11:54:04",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.409893,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 244,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27199400,
        "Time": "2022-02-23T12:10:31",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.409893,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 244,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27807,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27201043,
        "Time": "2022-02-23T12:26:53",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.409893,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 244,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27787,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27202253,
        "Time": "2022-02-23T12:40:45",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4094,
        "Lon": 87.30235,
        "Speed": 17.4,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 1512.0,
        "OnboardVoltage": 27718,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27203286,
        "Time": "2022-02-23T12:52:21",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4077072,
        "Lon": 87.3186951,
        "Speed": 8.8,
        "Height": 256,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 0,
        "EngineRPM": 1456.0,
        "OnboardVoltage": 27736,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27204328,
        "Time": "2022-02-23T13:01:59",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097366,
        "Lon": 87.30031,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27724,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27206008,
        "Time": "2022-02-23T13:18:30",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097366,
        "Lon": 87.30031,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27208319,
        "Time": "2022-02-23T13:34:46",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097366,
        "Lon": 87.30031,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27210414,
        "Time": "2022-02-23T13:50:07",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40987,
        "Lon": 87.30079,
        "Speed": 8.7,
        "Height": 238,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 875.0,
        "OnboardVoltage": 27709,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27211954,
        "Time": "2022-02-23T14:03:42",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41021,
        "Lon": 87.29928,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25387,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27214309,
        "Time": "2022-02-23T14:20:06",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41021,
        "Lon": 87.29928,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24382,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27216479,
        "Time": "2022-02-23T14:36:36",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41021,
        "Lon": 87.29928,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24312,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27218563,
        "Time": "2022-02-23T14:53:16",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41021,
        "Lon": 87.29928,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24169,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27220580,
        "Time": "2022-02-23T15:09:56",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41021,
        "Lon": 87.29928,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 23894,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27222820,
        "Time": "2022-02-23T15:26:36",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41021,
        "Lon": 87.29928,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 55,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 22106,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27225091,
        "Time": "2022-02-23T15:42:23",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4102173,
        "Lon": 87.29935,
        "Speed": 10.0,
        "Height": 232,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 51,
        "FuelTemperature": 0,
        "EngineRPM": 1437.0,
        "OnboardVoltage": 27636,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27226927,
        "Time": "2022-02-23T15:54:37",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099045,
        "Lon": 87.30074,
        "Speed": 6.8,
        "Height": 239,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 64,
        "FuelTemperature": 0,
        "EngineRPM": 1081.0,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27228634,
        "Time": "2022-02-23T16:07:11",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099045,
        "Lon": 87.3004,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27687,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27230787,
        "Time": "2022-02-23T16:23:51",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099045,
        "Lon": 87.3004,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27686,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27232494,
        "Time": "2022-02-23T16:37:49",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40952,
        "Lon": 87.38938,
        "Speed": 45.1,
        "Height": 319,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1473.0,
        "OnboardVoltage": 27503,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27234598,
        "Time": "2022-02-23T16:52:49",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.48643,
        "Lon": 87.44492,
        "Speed": 41.4,
        "Height": 431,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 93,
        "FuelTemperature": 0,
        "EngineRPM": 1366.0,
        "OnboardVoltage": 27483,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27236106,
        "Time": "2022-02-23T17:04:50",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51852,
        "Lon": 87.43601,
        "Speed": 0.0,
        "Height": 315,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27610,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27237725,
        "Time": "2022-02-23T17:21:09",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51852,
        "Lon": 87.43601,
        "Speed": 0.0,
        "Height": 315,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27648,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27239567,
        "Time": "2022-02-23T17:37:46",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.51852,
        "Lon": 87.43601,
        "Speed": 0.0,
        "Height": 315,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27811,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27241642,
        "Time": "2022-02-23T17:53:31",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.2
    },
    {
        "Id": 27243740,
        "Time": "2022-02-23T18:10:08",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27886,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27245773,
        "Time": "2022-02-23T18:26:48",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27247901,
        "Time": "2022-02-23T18:43:13",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27853,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27250267,
        "Time": "2022-02-23T18:59:53",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27884,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27252481,
        "Time": "2022-02-23T19:16:33",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27840,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27254691,
        "Time": "2022-02-23T19:33:13",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27880,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27256944,
        "Time": "2022-02-23T19:49:53",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27745,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27259346,
        "Time": "2022-02-23T20:06:33",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27738,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27261698,
        "Time": "2022-02-23T20:23:13",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5184555,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27263883,
        "Time": "2022-02-23T20:39:35",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5186462,
        "Lon": 87.4353,
        "Speed": 0.0,
        "Height": 294,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27714,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27265915,
        "Time": "2022-02-23T20:56:05",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5186462,
        "Lon": 87.4353,
        "Speed": 0.0,
        "Height": 294,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27733,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27268023,
        "Time": "2022-02-23T21:12:32",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5182648,
        "Lon": 87.4354858,
        "Speed": 0.0,
        "Height": 347,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 616.0,
        "OnboardVoltage": 27758,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27269356,
        "Time": "2022-02-23T21:22:57",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.52161,
        "Lon": 87.44372,
        "Speed": 9.0,
        "Height": 320,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1369.0,
        "OnboardVoltage": 27606,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.2
    },
    {
        "Id": 27271216,
        "Time": "2022-02-23T21:36:22",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.5196,
        "Lon": 87.43406,
        "Speed": 29.8,
        "Height": 316,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1327.0,
        "OnboardVoltage": 27563,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.2
    },
    {
        "Id": 27272627,
        "Time": "2022-02-23T21:46:28",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4968338,
        "Lon": 87.4371,
        "Speed": 0.0,
        "Height": 361,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27635,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.2
    },
    {
        "Id": 27274734,
        "Time": "2022-02-23T22:00:54",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4780769,
        "Lon": 87.45452,
        "Speed": 47.7,
        "Height": 414,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 0,
        "EngineRPM": 1568.0,
        "OnboardVoltage": 27473,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27276820,
        "Time": "2022-02-23T22:16:26",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40938,
        "Lon": 87.3650742,
        "Speed": 39.8,
        "Height": 343,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 0,
        "EngineRPM": 1803.0,
        "OnboardVoltage": 27547,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27278803,
        "Time": "2022-02-23T22:29:41",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.409935,
        "Lon": 87.3003845,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27596,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27281098,
        "Time": "2022-02-23T22:46:10",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.409935,
        "Lon": 87.3003845,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27732,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27283591,
        "Time": "2022-02-23T23:02:38",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.409935,
        "Lon": 87.3003845,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27775,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27286126,
        "Time": "2022-02-23T23:19:10",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.409935,
        "Lon": 87.3003845,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27750,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27287886,
        "Time": "2022-02-23T23:32:02",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.41095,
        "Lon": 87.29706,
        "Speed": 0.0,
        "Height": 229,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27718,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27289787,
        "Time": "2022-02-23T23:45:08",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40968,
        "Lon": 87.30049,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.8
    },
    {
        "Id": 27292207,
        "Time": "2022-02-24T00:01:48",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.40968,
        "Lon": 87.30049,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27784,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27294533,
        "Time": "2022-02-24T00:18:14",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4097328,
        "Lon": 87.30054,
        "Speed": 7.4,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 1168.0,
        "OnboardVoltage": 27738,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27296270,
        "Time": "2022-02-24T00:33:25",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099045,
        "Lon": 87.3002548,
        "Speed": 0.0,
        "Height": 221,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27297435,
        "Time": "2022-02-24T00:49:58",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099045,
        "Lon": 87.3002548,
        "Speed": 0.0,
        "Height": 221,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27769,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27299184,
        "Time": "2022-02-24T01:06:22",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099045,
        "Lon": 87.3002548,
        "Speed": 0.0,
        "Height": 221,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27712,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27300963,
        "Time": "2022-02-24T01:21:06",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27801,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27303303,
        "Time": "2022-02-24T01:37:40",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27945,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27305735,
        "Time": "2022-02-24T01:54:20",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27889,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27308401,
        "Time": "2022-02-24T02:11:00",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27902,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27310913,
        "Time": "2022-02-24T02:27:40",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27858,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27313279,
        "Time": "2022-02-24T02:44:20",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27855,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27315667,
        "Time": "2022-02-24T03:00:55",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27852,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27317832,
        "Time": "2022-02-24T03:17:19",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27891,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27320304,
        "Time": "2022-02-24T03:33:41",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 0,
        "EngineRPM": 602.0,
        "OnboardVoltage": 27879,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27323011,
        "Time": "2022-02-24T03:50:19",
        "TruckId": 1807,
        "Imei": "862095055764861",
        "Lat": 53.4099,
        "Lon": 87.30037,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27858,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27004168,
        "Time": "2022-02-22T10:53:43",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5593071,
        "Lon": 86.55835,
        "Speed": 0.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26058,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27006460,
        "Time": "2022-02-22T11:10:19",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5593071,
        "Lon": 86.55835,
        "Speed": 0.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25336,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27008568,
        "Time": "2022-02-22T11:26:43",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5593071,
        "Lon": 86.55835,
        "Speed": 0.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25259,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27010360,
        "Time": "2022-02-22T11:39:16",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5775032,
        "Lon": 86.54318,
        "Speed": 48.5,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 1174.0,
        "OnboardVoltage": 27424,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27012651,
        "Time": "2022-02-22T11:53:00",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965538,
        "Lon": 86.50378,
        "Speed": 0.0,
        "Height": 292,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25705,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27013899,
        "Time": "2022-02-22T12:08:40",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965538,
        "Lon": 86.50378,
        "Speed": 0.0,
        "Height": 292,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25206,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27015402,
        "Time": "2022-02-22T12:22:40",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5599976,
        "Lon": 86.55651,
        "Speed": 23.8,
        "Height": 322,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 768.0,
        "OnboardVoltage": 27305,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27016990,
        "Time": "2022-02-22T12:35:53",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5591545,
        "Lon": 86.55799,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26210,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27018450,
        "Time": "2022-02-22T12:52:26",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5591545,
        "Lon": 86.55799,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28019,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27020481,
        "Time": "2022-02-22T13:08:57",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5591545,
        "Lon": 86.55799,
        "Speed": 0.0,
        "Height": 341,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27966,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.4
    },
    {
        "Id": 27021930,
        "Time": "2022-02-22T13:24:00",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.56023,
        "Lon": 86.55775,
        "Speed": 0.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27215,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.4
    },
    {
        "Id": 27023232,
        "Time": "2022-02-22T13:35:57",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.50437,
        "Lon": 86.4432755,
        "Speed": 59.0,
        "Height": 288,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1914.0,
        "OnboardVoltage": 27303,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27024540,
        "Time": "2022-02-22T13:47:57",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.49612,
        "Lon": 86.3721542,
        "Speed": 27.7,
        "Height": 189,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1703.0,
        "OnboardVoltage": 27381,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27025309,
        "Time": "2022-02-22T13:53:27",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.4758835,
        "Lon": 86.39763,
        "Speed": 92.0,
        "Height": 187,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1651.0,
        "OnboardVoltage": 27343,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27026716,
        "Time": "2022-02-22T14:03:56",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3961,
        "Lon": 86.48974,
        "Speed": 73.8,
        "Height": 194,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1767.0,
        "OnboardVoltage": 27389,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27028597,
        "Time": "2022-02-22T14:16:56",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3518333,
        "Lon": 86.6937,
        "Speed": 61.3,
        "Height": 205,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1450.0,
        "OnboardVoltage": 27352,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27030543,
        "Time": "2022-02-22T14:30:39",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3516846,
        "Lon": 86.7034454,
        "Speed": 9.2,
        "Height": 205,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 0,
        "EngineRPM": 767.0,
        "OnboardVoltage": 27416,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27032013,
        "Time": "2022-02-22T14:41:58",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.394043,
        "Lon": 86.7300644,
        "Speed": 30.3,
        "Height": 204,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1836.0,
        "OnboardVoltage": 27731,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27033187,
        "Time": "2022-02-22T14:51:02",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.39052,
        "Lon": 86.72806,
        "Speed": 17.7,
        "Height": 207,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1150.0,
        "OnboardVoltage": 27724,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27035260,
        "Time": "2022-02-22T15:06:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28045,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27037595,
        "Time": "2022-02-22T15:22:48",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 28003,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27039709,
        "Time": "2022-02-22T15:39:28",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27987,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27041634,
        "Time": "2022-02-22T15:56:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27987,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27043582,
        "Time": "2022-02-22T16:12:48",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27974,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27046065,
        "Time": "2022-02-22T16:29:28",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27973,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27048041,
        "Time": "2022-02-22T16:46:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24717,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27050241,
        "Time": "2022-02-22T17:02:48",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24698,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27052208,
        "Time": "2022-02-22T17:19:28",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24661,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27054058,
        "Time": "2022-02-22T17:36:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24616,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27055833,
        "Time": "2022-02-22T17:52:48",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24609,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27057687,
        "Time": "2022-02-22T18:09:28",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24546,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27059531,
        "Time": "2022-02-22T18:26:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24511,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27061503,
        "Time": "2022-02-22T18:42:48",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24461,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27063907,
        "Time": "2022-02-22T18:59:23",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24404,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27066140,
        "Time": "2022-02-22T19:15:53",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24326,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27068379,
        "Time": "2022-02-22T19:32:25",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3910751,
        "Lon": 86.72736,
        "Speed": 0.0,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24469,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27069795,
        "Time": "2022-02-22T19:43:24",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.37756,
        "Lon": 86.75788,
        "Speed": 20.5,
        "Height": 208,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 633.0,
        "OnboardVoltage": 27980,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27071631,
        "Time": "2022-02-22T19:55:32",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.35176,
        "Lon": 86.7027359,
        "Speed": 0.0,
        "Height": 205,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27418,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27073778,
        "Time": "2022-02-22T20:10:11",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.35252,
        "Lon": 86.61646,
        "Speed": 72.0,
        "Height": 245,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1716.0,
        "OnboardVoltage": 27449,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27075543,
        "Time": "2022-02-22T20:22:19",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.4056625,
        "Lon": 86.42248,
        "Speed": 92.2,
        "Height": 222,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1672.0,
        "OnboardVoltage": 27498,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27076847,
        "Time": "2022-02-22T20:31:24",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.494175,
        "Lon": 86.37539,
        "Speed": 33.3,
        "Height": 189,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1473.0,
        "OnboardVoltage": 27557,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27078502,
        "Time": "2022-02-22T20:43:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5094032,
        "Lon": 86.4648056,
        "Speed": 54.4,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1727.0,
        "OnboardVoltage": 27617,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27079984,
        "Time": "2022-02-22T20:54:35",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5594025,
        "Lon": 86.55851,
        "Speed": 4.2,
        "Height": 325,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 865.0,
        "OnboardVoltage": 27448,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27082332,
        "Time": "2022-02-22T21:10:45",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55928,
        "Lon": 86.55828,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26778,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27084304,
        "Time": "2022-02-22T21:27:25",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55928,
        "Lon": 86.55828,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25359,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27086501,
        "Time": "2022-02-22T21:43:47",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55928,
        "Lon": 86.55828,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25268,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27088484,
        "Time": "2022-02-22T21:58:26",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55981,
        "Lon": 86.55815,
        "Speed": 15.0,
        "Height": 322,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 1269.0,
        "OnboardVoltage": 27586,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27090450,
        "Time": "2022-02-22T22:10:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965271,
        "Lon": 86.5038,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26194,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27092404,
        "Time": "2022-02-22T22:27:37",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965271,
        "Lon": 86.5038,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25491,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27094290,
        "Time": "2022-02-22T22:44:17",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965271,
        "Lon": 86.5038,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25378,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27096676,
        "Time": "2022-02-22T23:00:57",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965271,
        "Lon": 86.5038,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25336,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27098740,
        "Time": "2022-02-22T23:17:37",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965271,
        "Lon": 86.5038,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25298,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27101119,
        "Time": "2022-02-22T23:34:17",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965271,
        "Lon": 86.5038,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25237,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27103267,
        "Time": "2022-02-22T23:50:57",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965271,
        "Lon": 86.5038,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25229,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27104885,
        "Time": "2022-02-23T00:05:41",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.568985,
        "Lon": 86.5482559,
        "Speed": 53.3,
        "Height": 313,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 0,
        "EngineRPM": 1290.0,
        "OnboardVoltage": 27482,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27106541,
        "Time": "2022-02-23T00:18:50",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5593719,
        "Lon": 86.5585,
        "Speed": 0.0,
        "Height": 325,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 811.0,
        "OnboardVoltage": 27406,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27108603,
        "Time": "2022-02-23T00:35:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5592041,
        "Lon": 86.55814,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25226,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27109717,
        "Time": "2022-02-23T00:51:42",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5592041,
        "Lon": 86.55814,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25036,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.2
    },
    {
        "Id": 27111590,
        "Time": "2022-02-23T01:06:03",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5602455,
        "Lon": 86.55773,
        "Speed": 0.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27231,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27112957,
        "Time": "2022-02-23T01:18:19",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.60197,
        "Lon": 86.44056,
        "Speed": 58.1,
        "Height": 316,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1393.0,
        "OnboardVoltage": 27355,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27114003,
        "Time": "2022-02-23T01:27:27",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5945053,
        "Lon": 86.3507,
        "Speed": 56.6,
        "Height": 200,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1364.0,
        "OnboardVoltage": 27847,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27115221,
        "Time": "2022-02-23T01:37:36",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59625,
        "Lon": 86.34294,
        "Speed": 0.0,
        "Height": 214,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27547,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27117608,
        "Time": "2022-02-23T01:54:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59625,
        "Lon": 86.34294,
        "Speed": 0.0,
        "Height": 214,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27588,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27119602,
        "Time": "2022-02-23T02:08:57",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5965462,
        "Lon": 86.34383,
        "Speed": 9.0,
        "Height": 209,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 1596.0,
        "OnboardVoltage": 28060,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27121539,
        "Time": "2022-02-23T02:22:34",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26117,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27123780,
        "Time": "2022-02-23T02:38:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25229,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27126080,
        "Time": "2022-02-23T02:55:39",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25079,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27128586,
        "Time": "2022-02-23T03:12:19",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25185,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27130749,
        "Time": "2022-02-23T03:28:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27881,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27133176,
        "Time": "2022-02-23T03:45:39",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27923,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27135614,
        "Time": "2022-02-23T04:02:19",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27937,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27138318,
        "Time": "2022-02-23T04:18:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27941,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27141005,
        "Time": "2022-02-23T04:35:39",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25331,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27143391,
        "Time": "2022-02-23T04:52:19",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25107,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27145171,
        "Time": "2022-02-23T05:08:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24974,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27146840,
        "Time": "2022-02-23T05:25:39",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24938,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27148461,
        "Time": "2022-02-23T05:42:03",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24870,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27150592,
        "Time": "2022-02-23T05:58:34",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25258,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27152978,
        "Time": "2022-02-23T06:15:07",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59576,
        "Lon": 86.34464,
        "Speed": 0.0,
        "Height": 219,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 44,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25555,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27154870,
        "Time": "2022-02-23T06:29:50",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5953331,
        "Lon": 86.34432,
        "Speed": 0.0,
        "Height": 228,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 48,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25517,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27156625,
        "Time": "2022-02-23T06:43:16",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59184,
        "Lon": 86.33558,
        "Speed": 30.1,
        "Height": 212,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 53,
        "FuelTemperature": 0,
        "EngineRPM": 1284.0,
        "OnboardVoltage": 27670,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27157593,
        "Time": "2022-02-23T06:50:43",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5933456,
        "Lon": 86.3366241,
        "Speed": 0.0,
        "Height": 200,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 69,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27512,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27159090,
        "Time": "2022-02-23T07:02:26",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5930138,
        "Lon": 86.33218,
        "Speed": 0.0,
        "Height": 213,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27465,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27160955,
        "Time": "2022-02-23T07:13:22",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.60115,
        "Lon": 86.33056,
        "Speed": 0.0,
        "Height": 206,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27442,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27162363,
        "Time": "2022-02-23T07:23:24",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5922432,
        "Lon": 86.33656,
        "Speed": 50.3,
        "Height": 206,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 0,
        "EngineRPM": 1621.0,
        "OnboardVoltage": 27522,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27164345,
        "Time": "2022-02-23T07:37:57",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5913124,
        "Lon": 86.3351,
        "Speed": 0.0,
        "Height": 213,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27654,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27165773,
        "Time": "2022-02-23T07:47:06",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.602356,
        "Lon": 86.40204,
        "Speed": 57.0,
        "Height": 260,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1388.0,
        "OnboardVoltage": 27693,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27167079,
        "Time": "2022-02-23T07:56:32",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.62753,
        "Lon": 86.49988,
        "Speed": 55.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1745.0,
        "OnboardVoltage": 27672,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27168010,
        "Time": "2022-02-23T08:04:17",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.6037865,
        "Lon": 86.5572,
        "Speed": 45.7,
        "Height": 262,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1459.0,
        "OnboardVoltage": 27625,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27168971,
        "Time": "2022-02-23T08:12:22",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.62115,
        "Lon": 86.55674,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27465,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27170152,
        "Time": "2022-02-23T08:21:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.60362,
        "Lon": 86.5573349,
        "Speed": 35.3,
        "Height": 264,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1194.0,
        "OnboardVoltage": 27661,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27171069,
        "Time": "2022-02-23T08:29:05",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.561203,
        "Lon": 86.60317,
        "Speed": 43.8,
        "Height": 270,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1434.0,
        "OnboardVoltage": 27628,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27172234,
        "Time": "2022-02-23T08:38:25",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5583038,
        "Lon": 86.55445,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27504,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27173589,
        "Time": "2022-02-23T08:48:34",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 23912,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27175536,
        "Time": "2022-02-23T09:05:07",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25096,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27177460,
        "Time": "2022-02-23T09:21:45",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25001,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27179589,
        "Time": "2022-02-23T09:38:25",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24919,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27182126,
        "Time": "2022-02-23T09:55:05",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24863,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27184131,
        "Time": "2022-02-23T10:11:27",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24827,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27186307,
        "Time": "2022-02-23T10:28:07",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25020,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27188434,
        "Time": "2022-02-23T10:44:47",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24999,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27190690,
        "Time": "2022-02-23T11:01:27",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24988,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27192974,
        "Time": "2022-02-23T11:18:07",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24972,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27195193,
        "Time": "2022-02-23T11:34:47",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24971,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27197313,
        "Time": "2022-02-23T11:51:27",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24971,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27199118,
        "Time": "2022-02-23T12:08:07",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24946,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27200836,
        "Time": "2022-02-23T12:24:47",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 44,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24935,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27202261,
        "Time": "2022-02-23T12:41:14",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55916,
        "Lon": 86.5581,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 42,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24387,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27203743,
        "Time": "2022-02-23T12:56:43",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5593758,
        "Lon": 86.55842,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 46,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27327,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27205051,
        "Time": "2022-02-23T13:10:06",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5156174,
        "Lon": 86.46555,
        "Speed": 45.1,
        "Height": 291,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1467.0,
        "OnboardVoltage": 27595,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.6
    },
    {
        "Id": 27206450,
        "Time": "2022-02-23T13:21:56",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.49389,
        "Lon": 86.37963,
        "Speed": 35.9,
        "Height": 188,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1655.0,
        "OnboardVoltage": 27592,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.6
    },
    {
        "Id": 27207282,
        "Time": "2022-02-23T13:27:45",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.48145,
        "Lon": 86.39299,
        "Speed": 91.1,
        "Height": 183,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1634.0,
        "OnboardVoltage": 27650,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27208783,
        "Time": "2022-02-23T13:38:32",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3975639,
        "Lon": 86.4813843,
        "Speed": 68.8,
        "Height": 200,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1616.0,
        "OnboardVoltage": 27614,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.0
    },
    {
        "Id": 27210738,
        "Time": "2022-02-23T13:53:15",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.35148,
        "Lon": 86.6871948,
        "Speed": 62.7,
        "Height": 204,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1485.0,
        "OnboardVoltage": 27575,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27212667,
        "Time": "2022-02-23T14:09:03",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.35166,
        "Lon": 86.7034149,
        "Speed": 0.0,
        "Height": 207,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27446,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27214303,
        "Time": "2022-02-23T14:20:30",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3653526,
        "Lon": 86.78205,
        "Speed": 11.6,
        "Height": 225,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1875.0,
        "OnboardVoltage": 27529,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27215274,
        "Time": "2022-02-23T14:27:24",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.36437,
        "Lon": 86.78938,
        "Speed": 23.5,
        "Height": 246,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 795.0,
        "OnboardVoltage": 27612,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27216832,
        "Time": "2022-02-23T14:39:43",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.365593,
        "Lon": 86.80338,
        "Speed": 0.0,
        "Height": 191,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27496,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27218747,
        "Time": "2022-02-23T14:55:31",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.365593,
        "Lon": 86.803215,
        "Speed": 0.0,
        "Height": 191,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 602.0,
        "OnboardVoltage": 27600,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27220197,
        "Time": "2022-02-23T15:06:50",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3821945,
        "Lon": 86.77566,
        "Speed": 30.5,
        "Height": 211,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1047.0,
        "OnboardVoltage": 27596,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27221608,
        "Time": "2022-02-23T15:18:17",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.4083633,
        "Lon": 86.80109,
        "Speed": 0.0,
        "Height": 247,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 597.0,
        "OnboardVoltage": 27462,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27223128,
        "Time": "2022-02-23T15:28:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3820648,
        "Lon": 86.7757339,
        "Speed": 30.5,
        "Height": 212,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 993.0,
        "OnboardVoltage": 27964,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27224508,
        "Time": "2022-02-23T15:39:08",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3906975,
        "Lon": 86.72795,
        "Speed": 0.0,
        "Height": 207,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 601.0,
        "OnboardVoltage": 27562,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27226092,
        "Time": "2022-02-23T15:49:43",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3810959,
        "Lon": 86.74911,
        "Speed": 56.6,
        "Height": 206,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1360.0,
        "OnboardVoltage": 27667,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27227780,
        "Time": "2022-02-23T16:00:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.35064,
        "Lon": 86.63045,
        "Speed": 67.5,
        "Height": 249,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1616.0,
        "OnboardVoltage": 27616,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27229494,
        "Time": "2022-02-23T16:14:25",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.3993645,
        "Lon": 86.42665,
        "Speed": 35.5,
        "Height": 242,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1200.0,
        "OnboardVoltage": 27569,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27230732,
        "Time": "2022-02-23T16:23:38",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.49507,
        "Lon": 86.37397,
        "Speed": 40.9,
        "Height": 191,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 0,
        "EngineRPM": 1840.0,
        "OnboardVoltage": 27557,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27231979,
        "Time": "2022-02-23T16:33:40",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5101776,
        "Lon": 86.46551,
        "Speed": 60.1,
        "Height": 289,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1454.0,
        "OnboardVoltage": 27544,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27233326,
        "Time": "2022-02-23T16:44:36",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.558136,
        "Lon": 86.55487,
        "Speed": 17.0,
        "Height": 324,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 772.0,
        "OnboardVoltage": 27886,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27234950,
        "Time": "2022-02-23T16:56:10",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26541,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27236818,
        "Time": "2022-02-23T17:12:43",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26693,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27238494,
        "Time": "2022-02-23T17:29:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25788,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27240569,
        "Time": "2022-02-23T17:45:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25613,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27242773,
        "Time": "2022-02-23T18:02:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25564,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27244831,
        "Time": "2022-02-23T18:19:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25523,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27246830,
        "Time": "2022-02-23T18:35:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25495,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27249146,
        "Time": "2022-02-23T18:52:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25478,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27251486,
        "Time": "2022-02-23T19:09:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25458,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27253728,
        "Time": "2022-02-23T19:25:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25437,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27255888,
        "Time": "2022-02-23T19:42:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25407,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27258327,
        "Time": "2022-02-23T19:59:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25386,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27260455,
        "Time": "2022-02-23T20:15:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25386,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27262850,
        "Time": "2022-02-23T20:32:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25355,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27265079,
        "Time": "2022-02-23T20:49:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25347,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27267066,
        "Time": "2022-02-23T21:05:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25325,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27269169,
        "Time": "2022-02-23T21:22:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25330,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27271596,
        "Time": "2022-02-23T21:39:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25311,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27273996,
        "Time": "2022-02-23T21:55:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25287,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27276271,
        "Time": "2022-02-23T22:12:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25282,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27278713,
        "Time": "2022-02-23T22:29:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25263,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27281027,
        "Time": "2022-02-23T22:45:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25265,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27283538,
        "Time": "2022-02-23T23:02:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25230,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27286117,
        "Time": "2022-02-23T23:19:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25222,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27288451,
        "Time": "2022-02-23T23:35:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25207,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27290905,
        "Time": "2022-02-23T23:52:29",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25203,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27293232,
        "Time": "2022-02-24T00:09:09",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25189,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27295571,
        "Time": "2022-02-24T00:25:49",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25170,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27296805,
        "Time": "2022-02-24T00:42:23",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 28,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25047,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27298319,
        "Time": "2022-02-24T00:58:41",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 28,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25108,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27300157,
        "Time": "2022-02-24T01:14:59",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.55918,
        "Lon": 86.5581055,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 28,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24887,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27301778,
        "Time": "2022-02-24T01:27:46",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.6014328,
        "Lon": 86.49621,
        "Speed": 44.8,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 1468.0,
        "OnboardVoltage": 28043,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27303383,
        "Time": "2022-02-24T01:38:37",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5910759,
        "Lon": 86.37682,
        "Speed": 57.0,
        "Height": 205,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 0,
        "EngineRPM": 1842.0,
        "OnboardVoltage": 27608,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27304568,
        "Time": "2022-02-24T01:46:15",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5934258,
        "Lon": 86.3369751,
        "Speed": 0.0,
        "Height": 200,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 599.0,
        "OnboardVoltage": 27409,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27307004,
        "Time": "2022-02-24T02:02:38",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59347,
        "Lon": 86.33677,
        "Speed": 0.0,
        "Height": 202,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27410,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.200005
    },
    {
        "Id": 27308716,
        "Time": "2022-02-24T02:12:47",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5940323,
        "Lon": 86.34223,
        "Speed": 27.2,
        "Height": 204,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 0,
        "EngineRPM": 1757.0,
        "OnboardVoltage": 27619,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27310715,
        "Time": "2022-02-24T02:26:33",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5957756,
        "Lon": 86.3447342,
        "Speed": 0.0,
        "Height": 214,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 26383,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.4
    },
    {
        "Id": 27313055,
        "Time": "2022-02-24T02:43:02",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5957756,
        "Lon": 86.3447342,
        "Speed": 0.0,
        "Height": 214,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25631,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27315375,
        "Time": "2022-02-24T02:59:33",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.59596,
        "Lon": 86.34415,
        "Speed": 0.0,
        "Height": 126,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 0,
        "EngineRPM": 600.0,
        "OnboardVoltage": 27427,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27316954,
        "Time": "2022-02-24T03:10:04",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.6033669,
        "Lon": 86.40863,
        "Speed": 62.7,
        "Height": 268,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1509.0,
        "OnboardVoltage": 27565,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27318307,
        "Time": "2022-02-24T03:20:39",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.6270943,
        "Lon": 86.5002,
        "Speed": 43.5,
        "Height": 282,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 0,
        "EngineRPM": 1386.0,
        "OnboardVoltage": 27612,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.0
    },
    {
        "Id": 27319830,
        "Time": "2022-02-24T03:30:45",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.6016655,
        "Lon": 86.5576553,
        "Speed": 42.0,
        "Height": 255,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 0,
        "EngineRPM": 1954.0,
        "OnboardVoltage": 27416,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.6
    },
    {
        "Id": 27321154,
        "Time": "2022-02-24T03:39:24",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.5958633,
        "Lon": 86.56198,
        "Speed": 29.4,
        "Height": 253,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 0,
        "EngineRPM": 1980.0,
        "OnboardVoltage": 27817,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.6
    },
    {
        "Id": 27322576,
        "Time": "2022-02-24T03:47:54",
        "TruckId": 1993,
        "Imei": "862095055789991",
        "Lat": 54.610157,
        "Lon": 86.53378,
        "Speed": 8.3,
        "Height": 217,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 0,
        "EngineRPM": 1218.0,
        "OnboardVoltage": 27575,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.0
    },
    {
        "Id": 27004194,
        "Time": "2022-02-22T10:53:50",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3967438,
        "Lon": 86.84434,
        "Speed": 26.6,
        "Height": 275,
        "Mileage": 2998997,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27007025,
        "Time": "2022-02-22T11:14:16",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40669,
        "Lon": 86.8265152,
        "Speed": 9.6,
        "Height": 208,
        "Mileage": 3004199,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27009656,
        "Time": "2022-02-22T11:34:44",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40264,
        "Lon": 86.84764,
        "Speed": 17.0,
        "Height": 292,
        "Mileage": 3008694,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27011786,
        "Time": "2022-02-22T11:50:19",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3981934,
        "Lon": 86.8159943,
        "Speed": 25.3,
        "Height": 240,
        "Mileage": 3014492,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27014439,
        "Time": "2022-02-22T12:13:40",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4024162,
        "Lon": 86.8174744,
        "Speed": 23.1,
        "Height": 225,
        "Mileage": 3020785,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27019601,
        "Time": "2022-02-22T13:01:30",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3974,
        "Lon": 86.8176651,
        "Speed": 22.0,
        "Height": 256,
        "Mileage": 3023523,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27022828,
        "Time": "2022-02-22T13:32:47",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40704,
        "Lon": 86.8262939,
        "Speed": 17.2,
        "Height": 208,
        "Mileage": 3030627,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27024386,
        "Time": "2022-02-22T13:46:25",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4030876,
        "Lon": 86.84763,
        "Speed": 0.0,
        "Height": 293,
        "Mileage": 3035204,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27026834,
        "Time": "2022-02-22T14:04:42",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4038925,
        "Lon": 86.82273,
        "Speed": 19.2,
        "Height": 184,
        "Mileage": 3040179,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27029896,
        "Time": "2022-02-22T14:26:06",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3884,
        "Lon": 86.84801,
        "Speed": 18.1,
        "Height": 327,
        "Mileage": 3046161,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27032633,
        "Time": "2022-02-22T14:46:59",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.39402,
        "Lon": 86.84314,
        "Speed": 21.2,
        "Height": 277,
        "Mileage": 3049744,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27034903,
        "Time": "2022-02-22T15:03:38",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3893242,
        "Lon": 86.84842,
        "Speed": 15.3,
        "Height": 318,
        "Mileage": 3054712,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27037276,
        "Time": "2022-02-22T15:20:32",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3947,
        "Lon": 86.84222,
        "Speed": 25.0,
        "Height": 286,
        "Mileage": 3058347,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27039333,
        "Time": "2022-02-22T15:36:13",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4031639,
        "Lon": 86.84795,
        "Speed": 5.7,
        "Height": 291,
        "Mileage": 3061611,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27041327,
        "Time": "2022-02-22T15:53:12",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40319,
        "Lon": 86.8479843,
        "Speed": 0.0,
        "Height": 299,
        "Mileage": 3065980,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27043820,
        "Time": "2022-02-22T16:14:22",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4031143,
        "Lon": 86.84798,
        "Speed": 5.0,
        "Height": 295,
        "Mileage": 3070388,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27046984,
        "Time": "2022-02-22T16:37:29",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40322,
        "Lon": 86.84797,
        "Speed": 4.6,
        "Height": 284,
        "Mileage": 3074747,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27049654,
        "Time": "2022-02-22T16:58:21",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40327,
        "Lon": 86.84793,
        "Speed": 5.9,
        "Height": 287,
        "Mileage": 3079160,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27054074,
        "Time": "2022-02-22T17:36:19",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4019165,
        "Lon": 86.84706,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": 3083284,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27060353,
        "Time": "2022-02-22T18:33:35",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.39252,
        "Lon": 86.84463,
        "Speed": 20.7,
        "Height": 280,
        "Mileage": 3086880,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27062921,
        "Time": "2022-02-22T18:53:25",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3888435,
        "Lon": 86.84918,
        "Speed": 22.4,
        "Height": 313,
        "Mileage": 3091756,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27065680,
        "Time": "2022-02-22T19:11:36",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3890839,
        "Lon": 86.84892,
        "Speed": 21.8,
        "Height": 321,
        "Mileage": 3096135,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27068123,
        "Time": "2022-02-22T19:30:52",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3881035,
        "Lon": 86.8466644,
        "Speed": 16.2,
        "Height": 334,
        "Mileage": 3100716,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27070616,
        "Time": "2022-02-22T19:48:25",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3886375,
        "Lon": 86.8487244,
        "Speed": 20.9,
        "Height": 308,
        "Mileage": 3104889,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27074032,
        "Time": "2022-02-22T20:11:42",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3893547,
        "Lon": 86.84802,
        "Speed": 15.3,
        "Height": 308,
        "Mileage": 3109144,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27077064,
        "Time": "2022-02-22T20:33:02",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3902931,
        "Lon": 86.84696,
        "Speed": 13.8,
        "Height": 322,
        "Mileage": 3113347,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27079323,
        "Time": "2022-02-22T20:49:48",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3967857,
        "Lon": 86.84441,
        "Speed": 35.0,
        "Height": 271,
        "Mileage": 3116851,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27082104,
        "Time": "2022-02-22T21:09:03",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40324,
        "Lon": 86.84794,
        "Speed": 6.4,
        "Height": 285,
        "Mileage": 3120421,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27085083,
        "Time": "2022-02-22T21:33:01",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4032173,
        "Lon": 86.84805,
        "Speed": 0.0,
        "Height": 296,
        "Mileage": 3124712,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27088169,
        "Time": "2022-02-22T21:55:57",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4032936,
        "Lon": 86.8484,
        "Speed": 5.3,
        "Height": 288,
        "Mileage": 3129176,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27090860,
        "Time": "2022-02-22T22:14:58",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40334,
        "Lon": 86.84777,
        "Speed": 6.8,
        "Height": 298,
        "Mileage": 3133602,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27093717,
        "Time": "2022-02-22T22:39:13",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4033,
        "Lon": 86.84772,
        "Speed": 11.8,
        "Height": 298,
        "Mileage": 3138073,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27096404,
        "Time": "2022-02-22T22:59:04",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40289,
        "Lon": 86.84781,
        "Speed": 16.2,
        "Height": 307,
        "Mileage": 3142439,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27099533,
        "Time": "2022-02-22T23:23:21",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4030724,
        "Lon": 86.84782,
        "Speed": 11.4,
        "Height": 295,
        "Mileage": 3146935,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27102611,
        "Time": "2022-02-22T23:46:20",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4029236,
        "Lon": 86.84779,
        "Speed": 16.8,
        "Height": 295,
        "Mileage": 3151386,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27104777,
        "Time": "2022-02-23T00:04:40",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40146,
        "Lon": 86.84736,
        "Speed": 17.9,
        "Height": 297,
        "Mileage": 3155626,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27107231,
        "Time": "2022-02-23T00:22:36",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.39524,
        "Lon": 86.84138,
        "Speed": 18.3,
        "Height": 278,
        "Mileage": 3159297,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27112907,
        "Time": "2022-02-23T01:17:52",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4033737,
        "Lon": 86.84803,
        "Speed": 6.2,
        "Height": 277,
        "Mileage": 3164629,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27115798,
        "Time": "2022-02-23T01:41:20",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4032326,
        "Lon": 86.84786,
        "Speed": 7.5,
        "Height": 292,
        "Mileage": 3169083,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118936,
        "Time": "2022-02-23T02:03:29",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4004173,
        "Lon": 86.84682,
        "Speed": 23.3,
        "Height": 289,
        "Mileage": 3173781,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27121814,
        "Time": "2022-02-23T02:24:16",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4010468,
        "Lon": 86.84701,
        "Speed": 27.4,
        "Height": 289,
        "Mileage": 3178137,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27123533,
        "Time": "2022-02-23T02:36:36",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40321,
        "Lon": 86.84804,
        "Speed": 0.0,
        "Height": 293,
        "Mileage": 3182209,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27126069,
        "Time": "2022-02-23T02:55:28",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4034653,
        "Lon": 86.84796,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": 3186694,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27128964,
        "Time": "2022-02-23T03:15:44",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4033165,
        "Lon": 86.84792,
        "Speed": 4.6,
        "Height": 293,
        "Mileage": 3191114,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27132146,
        "Time": "2022-02-23T03:38:17",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4015846,
        "Lon": 86.8471146,
        "Speed": 25.7,
        "Height": 292,
        "Mileage": 3195599,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27135329,
        "Time": "2022-02-23T04:00:21",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40256,
        "Lon": 86.8472061,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": 3200134,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27138640,
        "Time": "2022-02-23T04:21:06",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40252,
        "Lon": 86.84724,
        "Speed": 0.0,
        "Height": 298,
        "Mileage": 3204628,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27142065,
        "Time": "2022-02-23T04:43:53",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3950958,
        "Lon": 86.84189,
        "Speed": 25.7,
        "Height": 295,
        "Mileage": 3208232,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27144700,
        "Time": "2022-02-23T05:03:39",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3885956,
        "Lon": 86.84688,
        "Speed": 10.3,
        "Height": 345,
        "Mileage": 3211776,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27149300,
        "Time": "2022-02-23T05:48:42",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4016228,
        "Lon": 86.84711,
        "Speed": 21.6,
        "Height": 304,
        "Mileage": 3214228,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27152337,
        "Time": "2022-02-23T06:11:13",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4034729,
        "Lon": 86.8478241,
        "Speed": 4.8,
        "Height": 300,
        "Mileage": 3218447,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27155003,
        "Time": "2022-02-23T06:30:55",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4034348,
        "Lon": 86.84796,
        "Speed": 4.8,
        "Height": 289,
        "Mileage": 3222904,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27158232,
        "Time": "2022-02-23T06:55:25",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4024124,
        "Lon": 86.8472748,
        "Speed": 8.3,
        "Height": 289,
        "Mileage": 3227147,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27160274,
        "Time": "2022-02-23T07:09:18",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38906,
        "Lon": 86.84563,
        "Speed": 7.7,
        "Height": 345,
        "Mileage": 3229639,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27163020,
        "Time": "2022-02-23T07:27:58",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38913,
        "Lon": 86.84587,
        "Speed": 6.8,
        "Height": 345,
        "Mileage": 3234088,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27165980,
        "Time": "2022-02-23T07:48:30",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3886642,
        "Lon": 86.84912,
        "Speed": 18.1,
        "Height": 328,
        "Mileage": 3238299,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27168386,
        "Time": "2022-02-23T08:08:16",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.39692,
        "Lon": 86.8449,
        "Speed": 34.0,
        "Height": 274,
        "Mileage": 3241746,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27176011,
        "Time": "2022-02-23T09:09:12",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3904266,
        "Lon": 86.84575,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": 3243793,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27180511,
        "Time": "2022-02-23T09:44:40",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3884048,
        "Lon": 86.8482742,
        "Speed": 23.1,
        "Height": 330,
        "Mileage": 3247910,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27183394,
        "Time": "2022-02-23T10:05:21",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3886337,
        "Lon": 86.84899,
        "Speed": 21.6,
        "Height": 324,
        "Mileage": 3252417,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27187217,
        "Time": "2022-02-23T10:36:20",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.395153,
        "Lon": 86.84177,
        "Speed": 20.1,
        "Height": 282,
        "Mileage": 3256061,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27189919,
        "Time": "2022-02-23T10:55:28",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3997536,
        "Lon": 86.84679,
        "Speed": 25.9,
        "Height": 291,
        "Mileage": 3259958,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27192566,
        "Time": "2022-02-23T11:15:22",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4034576,
        "Lon": 86.84802,
        "Speed": 9.8,
        "Height": 301,
        "Mileage": 3264105,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27195072,
        "Time": "2022-02-23T11:33:50",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4035454,
        "Lon": 86.8479843,
        "Speed": 5.0,
        "Height": 303,
        "Mileage": 3268640,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27197359,
        "Time": "2022-02-23T11:51:46",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4034348,
        "Lon": 86.84796,
        "Speed": 6.6,
        "Height": 301,
        "Mileage": 3273107,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27199426,
        "Time": "2022-02-23T12:10:31",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3947372,
        "Lon": 86.8400345,
        "Speed": 27.7,
        "Height": 274,
        "Mileage": 3276706,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27205929,
        "Time": "2022-02-23T13:18:09",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40213,
        "Lon": 86.8471451,
        "Speed": 0.0,
        "Height": 281,
        "Mileage": 3281731,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27209012,
        "Time": "2022-02-23T13:40:47",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3949547,
        "Lon": 86.84195,
        "Speed": 21.4,
        "Height": 277,
        "Mileage": 3285384,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27211677,
        "Time": "2022-02-23T14:01:39",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3951,
        "Lon": 86.84192,
        "Speed": 19.8,
        "Height": 274,
        "Mileage": 3289934,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27213908,
        "Time": "2022-02-23T14:17:45",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38917,
        "Lon": 86.84883,
        "Speed": 21.4,
        "Height": 330,
        "Mileage": 3293626,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27216660,
        "Time": "2022-02-23T14:38:30",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3889847,
        "Lon": 86.84886,
        "Speed": 14.8,
        "Height": 339,
        "Mileage": 3298187,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27218972,
        "Time": "2022-02-23T14:57:39",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.389328,
        "Lon": 86.84859,
        "Speed": 20.1,
        "Height": 340,
        "Mileage": 3302782,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27221110,
        "Time": "2022-02-23T15:14:26",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.388607,
        "Lon": 86.84567,
        "Speed": 4.6,
        "Height": 355,
        "Mileage": 3306963,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27223926,
        "Time": "2022-02-23T15:35:13",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3885727,
        "Lon": 86.8457947,
        "Speed": 5.7,
        "Height": 351,
        "Mileage": 3311423,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27226955,
        "Time": "2022-02-23T15:54:50",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38846,
        "Lon": 86.84694,
        "Speed": 12.7,
        "Height": 344,
        "Mileage": 3316031,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27230661,
        "Time": "2022-02-23T16:23:06",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38864,
        "Lon": 86.8490448,
        "Speed": 20.7,
        "Height": 321,
        "Mileage": 3320369,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27233407,
        "Time": "2022-02-23T16:45:25",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3885422,
        "Lon": 86.84886,
        "Speed": 19.2,
        "Height": 312,
        "Mileage": 3324943,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27238482,
        "Time": "2022-02-23T17:29:05",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4038048,
        "Lon": 86.84747,
        "Speed": 0.0,
        "Height": 275,
        "Mileage": 3327588,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27240696,
        "Time": "2022-02-23T17:46:46",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4022751,
        "Lon": 86.84714,
        "Speed": 6.1,
        "Height": 275,
        "Mileage": 3331963,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27243192,
        "Time": "2022-02-23T18:06:00",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.39625,
        "Lon": 86.84373,
        "Speed": 18.8,
        "Height": 250,
        "Mileage": 3335741,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27245546,
        "Time": "2022-02-23T18:24:40",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38958,
        "Lon": 86.84802,
        "Speed": 23.7,
        "Height": 318,
        "Mileage": 3339410,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27247859,
        "Time": "2022-02-23T18:43:09",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38803,
        "Lon": 86.8463745,
        "Speed": 9.6,
        "Height": 335,
        "Mileage": 3343643,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27250896,
        "Time": "2022-02-23T19:04:31",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3875847,
        "Lon": 86.84604,
        "Speed": 0.0,
        "Height": 338,
        "Mileage": 3348154,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27253467,
        "Time": "2022-02-23T19:23:30",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3883133,
        "Lon": 86.8474045,
        "Speed": 15.1,
        "Height": 336,
        "Mileage": 3352560,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27256715,
        "Time": "2022-02-23T19:48:35",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3884,
        "Lon": 86.84537,
        "Speed": 7.0,
        "Height": 344,
        "Mileage": 3357270,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27259330,
        "Time": "2022-02-23T20:06:43",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3884773,
        "Lon": 86.8488159,
        "Speed": 18.8,
        "Height": 326,
        "Mileage": 3361625,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27261670,
        "Time": "2022-02-23T20:23:20",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3971024,
        "Lon": 86.84507,
        "Speed": 23.5,
        "Height": 272,
        "Mileage": 3364995,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27264046,
        "Time": "2022-02-23T20:41:16",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4006958,
        "Lon": 86.84698,
        "Speed": 22.0,
        "Height": 294,
        "Mileage": 3369155,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27266289,
        "Time": "2022-02-23T20:59:39",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4017525,
        "Lon": 86.84721,
        "Speed": 20.0,
        "Height": 288,
        "Mileage": 3373661,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27269547,
        "Time": "2022-02-23T21:24:40",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4031563,
        "Lon": 86.84798,
        "Speed": 14.8,
        "Height": 289,
        "Mileage": 3378173,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27272328,
        "Time": "2022-02-23T21:44:35",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4036636,
        "Lon": 86.8482,
        "Speed": 5.7,
        "Height": 293,
        "Mileage": 3382698,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27275950,
        "Time": "2022-02-23T22:10:07",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4039,
        "Lon": 86.8475,
        "Speed": 0.0,
        "Height": 287,
        "Mileage": 3387281,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27279016,
        "Time": "2022-02-23T22:31:26",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40361,
        "Lon": 86.84752,
        "Speed": 5.0,
        "Height": 285,
        "Mileage": 3391818,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27281723,
        "Time": "2022-02-23T22:49:50",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38902,
        "Lon": 86.84876,
        "Speed": 15.7,
        "Height": 332,
        "Mileage": 3394566,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27285682,
        "Time": "2022-02-23T23:16:02",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3882942,
        "Lon": 86.84724,
        "Speed": 14.4,
        "Height": 333,
        "Mileage": 3398996,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27288909,
        "Time": "2022-02-23T23:39:03",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38798,
        "Lon": 86.8460846,
        "Speed": 8.1,
        "Height": 337,
        "Mileage": 3403481,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27292202,
        "Time": "2022-02-24T00:02:01",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3877754,
        "Lon": 86.8465042,
        "Speed": 4.4,
        "Height": 332,
        "Mileage": 3408011,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27295121,
        "Time": "2022-02-24T00:22:50",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3876953,
        "Lon": 86.84562,
        "Speed": 4.8,
        "Height": 336,
        "Mileage": 3412569,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27297913,
        "Time": "2022-02-24T00:54:50",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3950844,
        "Lon": 86.82816,
        "Speed": 23.8,
        "Height": 281,
        "Mileage": 3417249,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27300756,
        "Time": "2022-02-24T01:19:29",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3885345,
        "Lon": 86.84499,
        "Speed": 4.2,
        "Height": 351,
        "Mileage": 3421621,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27303561,
        "Time": "2022-02-24T01:39:38",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3887749,
        "Lon": 86.84866,
        "Speed": 12.0,
        "Height": 314,
        "Mileage": 3425999,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27306745,
        "Time": "2022-02-24T02:01:03",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.38879,
        "Lon": 86.84877,
        "Speed": 12.7,
        "Height": 322,
        "Mileage": 3430574,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27309655,
        "Time": "2022-02-24T02:19:13",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3951454,
        "Lon": 86.84179,
        "Speed": 19.6,
        "Height": 280,
        "Mileage": 3434367,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27313098,
        "Time": "2022-02-24T02:43:19",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.40412,
        "Lon": 86.84763,
        "Speed": 6.1,
        "Height": 318,
        "Mileage": 3438365,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27315865,
        "Time": "2022-02-24T03:02:36",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.404,
        "Lon": 86.84754,
        "Speed": 4.4,
        "Height": 290,
        "Mileage": 3443036,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27318971,
        "Time": "2022-02-24T03:25:02",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.4040833,
        "Lon": 86.8476639,
        "Speed": 5.5,
        "Height": 319,
        "Mileage": 3447708,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27321139,
        "Time": "2022-02-24T03:39:15",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3952026,
        "Lon": 86.84193,
        "Speed": 22.2,
        "Height": 295,
        "Mileage": 3451224,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27323999,
        "Time": "2022-02-24T03:56:50",
        "TruckId": 663,
        "Imei": "862846040546726",
        "Lat": 54.3970833,
        "Lon": 86.8453445,
        "Speed": 21.6,
        "Height": 288,
        "Mileage": 3456139,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27004179,
        "Time": "2022-02-22T10:53:45",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3949623,
        "Lon": 86.83338,
        "Speed": 31.4,
        "Height": 287,
        "Mileage": 5075264,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27757,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27005731,
        "Time": "2022-02-22T11:06:28",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3973122,
        "Lon": 86.82035,
        "Speed": 29.0,
        "Height": 255,
        "Mileage": 5079857,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27758,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27008869,
        "Time": "2022-02-22T11:28:31",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.4019547,
        "Lon": 86.82131,
        "Speed": 22.9,
        "Height": 207,
        "Mileage": 5086101,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27789,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27010803,
        "Time": "2022-02-22T11:42:35",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.40253,
        "Lon": 86.84718,
        "Speed": 12.2,
        "Height": 298,
        "Mileage": 5091138,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27883,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27013396,
        "Time": "2022-02-22T12:03:25",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.4067268,
        "Lon": 86.82662,
        "Speed": 0.0,
        "Height": 209,
        "Mileage": 5095711,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27020398,
        "Time": "2022-02-22T13:07:58",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3947754,
        "Lon": 86.83592,
        "Speed": 34.6,
        "Height": 282,
        "Mileage": 5098731,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27023752,
        "Time": "2022-02-22T13:40:43",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.39786,
        "Lon": 86.81644,
        "Speed": 28.3,
        "Height": 254,
        "Mileage": 5103225,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27599,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27025156,
        "Time": "2022-02-22T13:52:43",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.395,
        "Lon": 86.83123,
        "Speed": 13.3,
        "Height": 283,
        "Mileage": 5107479,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27616,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27027350,
        "Time": "2022-02-22T14:08:32",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.4025078,
        "Lon": 86.8166351,
        "Speed": 20.1,
        "Height": 229,
        "Mileage": 5112669,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27634,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27029243,
        "Time": "2022-02-22T14:22:07",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3897324,
        "Lon": 86.84749,
        "Speed": 4.2,
        "Height": 320,
        "Mileage": 5117636,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27612,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27032381,
        "Time": "2022-02-22T14:44:33",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36436,
        "Lon": 86.84825,
        "Speed": 22.9,
        "Height": 247,
        "Mileage": 5123958,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27640,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27034882,
        "Time": "2022-02-22T15:03:32",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3554535,
        "Lon": 86.85854,
        "Speed": 0.0,
        "Height": 306,
        "Mileage": 5128642,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27829,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27038228,
        "Time": "2022-02-22T15:27:23",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3562927,
        "Lon": 86.85655,
        "Speed": 16.6,
        "Height": 313,
        "Mileage": 5134421,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27654,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27041899,
        "Time": "2022-02-22T15:58:25",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3641129,
        "Lon": 86.84832,
        "Speed": 25.7,
        "Height": 250,
        "Mileage": 5139371,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27724,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27045058,
        "Time": "2022-02-22T16:21:07",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3721046,
        "Lon": 86.85414,
        "Speed": 37.4,
        "Height": 287,
        "Mileage": 5144297,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27047463,
        "Time": "2022-02-22T16:41:32",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3769836,
        "Lon": 86.85034,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": 5149531,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27852,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27050757,
        "Time": "2022-02-22T17:06:22",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3771667,
        "Lon": 86.8508,
        "Speed": 10.5,
        "Height": 319,
        "Mileage": 5155455,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27802,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27056174,
        "Time": "2022-02-22T17:55:55",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3564072,
        "Lon": 86.85622,
        "Speed": 19.2,
        "Height": 309,
        "Mileage": 5158755,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27763,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27058092,
        "Time": "2022-02-22T18:12:40",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3553772,
        "Lon": 86.85856,
        "Speed": 0.0,
        "Height": 299,
        "Mileage": 5164507,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27802,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27060391,
        "Time": "2022-02-22T18:33:57",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36397,
        "Lon": 86.84875,
        "Speed": 26.1,
        "Height": 247,
        "Mileage": 5169427,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27705,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27063222,
        "Time": "2022-02-22T18:55:22",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3736725,
        "Lon": 86.8550644,
        "Speed": 23.1,
        "Height": 298,
        "Mileage": 5173987,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27065947,
        "Time": "2022-02-22T19:14:17",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36375,
        "Lon": 86.84952,
        "Speed": 29.8,
        "Height": 247,
        "Mileage": 1142,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27760,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27067732,
        "Time": "2022-02-22T19:27:44",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.35552,
        "Lon": 86.85833,
        "Speed": 6.1,
        "Height": 310,
        "Mileage": 5879,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27070976,
        "Time": "2022-02-22T19:50:42",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.35716,
        "Lon": 86.85479,
        "Speed": 20.0,
        "Height": 297,
        "Mileage": 11503,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27686,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27074724,
        "Time": "2022-02-22T20:15:43",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3765755,
        "Lon": 86.85084,
        "Speed": 7.4,
        "Height": 318,
        "Mileage": 14846,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27773,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27076926,
        "Time": "2022-02-22T20:32:02",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36421,
        "Lon": 86.84846,
        "Speed": 23.8,
        "Height": 253,
        "Mileage": 18894,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27746,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27081295,
        "Time": "2022-02-22T20:55:24",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3617554,
        "Lon": 86.85688,
        "Speed": 20.3,
        "Height": 201,
        "Mileage": 23405,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27691,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27082258,
        "Time": "2022-02-22T21:10:10",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.376297,
        "Lon": 86.85052,
        "Speed": 4.0,
        "Height": 312,
        "Mileage": 26522,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27745,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27085143,
        "Time": "2022-02-22T21:31:32",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36165,
        "Lon": 86.85707,
        "Speed": 17.5,
        "Height": 196,
        "Mileage": 29585,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27771,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27086995,
        "Time": "2022-02-22T21:47:22",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36517,
        "Lon": 86.85306,
        "Speed": 14.2,
        "Height": 232,
        "Mileage": 34545,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27680,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27089392,
        "Time": "2022-02-22T22:03:04",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3643646,
        "Lon": 86.84842,
        "Speed": 25.3,
        "Height": 248,
        "Mileage": 36580,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27784,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27093114,
        "Time": "2022-02-22T22:33:27",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3653526,
        "Lon": 86.85353,
        "Speed": 24.4,
        "Height": 229,
        "Mileage": 40716,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27095290,
        "Time": "2022-02-22T22:51:16",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37738,
        "Lon": 86.8511353,
        "Speed": 16.2,
        "Height": 317,
        "Mileage": 44289,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27760,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27098177,
        "Time": "2022-02-22T23:07:58",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3606834,
        "Lon": 86.8579,
        "Speed": 5.7,
        "Height": 197,
        "Mileage": 47244,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27772,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27099601,
        "Time": "2022-02-22T23:23:42",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37345,
        "Lon": 86.85523,
        "Speed": 36.2,
        "Height": 297,
        "Mileage": 50786,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27767,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27102132,
        "Time": "2022-02-22T23:41:47",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3653755,
        "Lon": 86.85323,
        "Speed": 19.6,
        "Height": 229,
        "Mileage": 53923,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27734,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27105590,
        "Time": "2022-02-22T23:56:07",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36226,
        "Lon": 86.85654,
        "Speed": 12.2,
        "Height": 207,
        "Mileage": 58801,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27880,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27106200,
        "Time": "2022-02-23T00:15:44",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3769264,
        "Lon": 86.85064,
        "Speed": 14.4,
        "Height": 325,
        "Mileage": 61944,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27652,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27111334,
        "Time": "2022-02-23T01:03:50",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3639832,
        "Lon": 86.85171,
        "Speed": 27.0,
        "Height": 239,
        "Mileage": 64149,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27768,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27112928,
        "Time": "2022-02-23T01:18:05",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3757858,
        "Lon": 86.85228,
        "Speed": 5.0,
        "Height": 311,
        "Mileage": 67807,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27801,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27114912,
        "Time": "2022-02-23T01:32:44",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36062,
        "Lon": 86.85742,
        "Speed": 3.8,
        "Height": 193,
        "Mileage": 70836,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27854,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27116416,
        "Time": "2022-02-23T01:46:00",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3665962,
        "Lon": 86.85089,
        "Speed": 32.7,
        "Height": 263,
        "Mileage": 74855,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118400,
        "Time": "2022-02-23T01:58:03",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3652649,
        "Lon": 86.85359,
        "Speed": 20.0,
        "Height": 227,
        "Mileage": 77171,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27817,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27121338,
        "Time": "2022-02-23T02:13:31",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36202,
        "Lon": 86.8567047,
        "Speed": 16.8,
        "Height": 196,
        "Mileage": 82176,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27903,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27122074,
        "Time": "2022-02-23T02:26:58",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37599,
        "Lon": 86.8527756,
        "Speed": 16.1,
        "Height": 310,
        "Mileage": 85088,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27897,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27124650,
        "Time": "2022-02-23T02:41:53",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3608055,
        "Lon": 86.85777,
        "Speed": 7.7,
        "Height": 197,
        "Mileage": 88353,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27876,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27126098,
        "Time": "2022-02-23T02:55:51",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3646469,
        "Lon": 86.84809,
        "Speed": 29.6,
        "Height": 264,
        "Mileage": 92955,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27812,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27128380,
        "Time": "2022-02-23T03:09:28",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3634872,
        "Lon": 86.84996,
        "Speed": 17.4,
        "Height": 243,
        "Mileage": 95265,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27871,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27130880,
        "Time": "2022-02-23T03:23:25",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36057,
        "Lon": 86.85768,
        "Speed": 5.1,
        "Height": 190,
        "Mileage": 100114,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27861,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27132296,
        "Time": "2022-02-23T03:39:19",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37696,
        "Lon": 86.8528,
        "Speed": 17.5,
        "Height": 321,
        "Mileage": 103263,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27814,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27135261,
        "Time": "2022-02-23T03:55:14",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3609047,
        "Lon": 86.85776,
        "Speed": 14.0,
        "Height": 188,
        "Mileage": 106285,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27877,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27136720,
        "Time": "2022-02-23T04:09:07",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3643761,
        "Lon": 86.84811,
        "Speed": 32.0,
        "Height": 252,
        "Mileage": 110764,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27923,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27139069,
        "Time": "2022-02-23T04:23:54",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3648453,
        "Lon": 86.84846,
        "Speed": 21.2,
        "Height": 257,
        "Mileage": 113304,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27853,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27142463,
        "Time": "2022-02-23T04:38:30",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36069,
        "Lon": 86.85811,
        "Speed": 8.8,
        "Height": 185,
        "Mileage": 117705,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27144430,
        "Time": "2022-02-23T04:50:39",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36303,
        "Lon": 86.85723,
        "Speed": 27.4,
        "Height": 209,
        "Mileage": 119552,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27887,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27145055,
        "Time": "2022-02-23T05:07:31",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3652649,
        "Lon": 86.85163,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": 121095,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27756,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27152098,
        "Time": "2022-02-23T05:44:06",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3605042,
        "Lon": 86.8579254,
        "Speed": 7.4,
        "Height": 181,
        "Mileage": 122628,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27843,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27152482,
        "Time": "2022-02-23T06:01:01",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3759956,
        "Lon": 86.850914,
        "Speed": 7.4,
        "Height": 319,
        "Mileage": 125592,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27875,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27154736,
        "Time": "2022-02-23T06:23:49",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3606148,
        "Lon": 86.85755,
        "Speed": 4.0,
        "Height": 190,
        "Mileage": 128540,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27155786,
        "Time": "2022-02-23T06:37:46",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3759766,
        "Lon": 86.8521,
        "Speed": 12.4,
        "Height": 315,
        "Mileage": 131520,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27789,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27159284,
        "Time": "2022-02-23T07:00:52",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3616753,
        "Lon": 86.85703,
        "Speed": 19.4,
        "Height": 187,
        "Mileage": 134576,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27888,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27161593,
        "Time": "2022-02-23T07:18:06",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3701439,
        "Lon": 86.85258,
        "Speed": 34.6,
        "Height": 274,
        "Mileage": 138230,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27824,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27165975,
        "Time": "2022-02-23T07:43:26",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.360836,
        "Lon": 86.85778,
        "Speed": 8.3,
        "Height": 191,
        "Mileage": 140361,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27875,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27167130,
        "Time": "2022-02-23T07:56:39",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3640671,
        "Lon": 86.84832,
        "Speed": 28.1,
        "Height": 247,
        "Mileage": 144760,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27882,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27169224,
        "Time": "2022-02-23T08:12:58",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3652878,
        "Lon": 86.8532,
        "Speed": 24.2,
        "Height": 222,
        "Mileage": 146851,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27172608,
        "Time": "2022-02-23T08:41:15",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37757,
        "Lon": 86.85202,
        "Speed": 0.0,
        "Height": 322,
        "Mileage": 149379,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27919,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27176907,
        "Time": "2022-02-23T09:12:24",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36073,
        "Lon": 86.8572845,
        "Speed": 0.0,
        "Height": 194,
        "Mileage": 152324,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27894,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27178163,
        "Time": "2022-02-23T09:27:20",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3686752,
        "Lon": 86.85183,
        "Speed": 34.4,
        "Height": 275,
        "Mileage": 156285,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27826,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27180500,
        "Time": "2022-02-23T09:42:50",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3653755,
        "Lon": 86.85356,
        "Speed": 17.2,
        "Height": 223,
        "Mileage": 158893,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27900,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27182424,
        "Time": "2022-02-23T09:56:30",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36531,
        "Lon": 86.8536,
        "Speed": 24.4,
        "Height": 226,
        "Mileage": 163295,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27852,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27184401,
        "Time": "2022-02-23T10:11:10",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3638725,
        "Lon": 86.84929,
        "Speed": 23.3,
        "Height": 243,
        "Mileage": 165140,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27792,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27187449,
        "Time": "2022-02-23T10:26:53",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3609428,
        "Lon": 86.85785,
        "Speed": 16.1,
        "Height": 192,
        "Mileage": 169703,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27853,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27188483,
        "Time": "2022-02-23T10:45:02",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37572,
        "Lon": 86.8511353,
        "Speed": 9.4,
        "Height": 314,
        "Mileage": 172693,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27811,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27190913,
        "Time": "2022-02-23T10:56:20",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.360672,
        "Lon": 86.85737,
        "Speed": 8.1,
        "Height": 184,
        "Mileage": 175584,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27191891,
        "Time": "2022-02-23T11:09:49",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3758163,
        "Lon": 86.85112,
        "Speed": 7.7,
        "Height": 311,
        "Mileage": 178439,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27900,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27194652,
        "Time": "2022-02-23T11:25:02",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36059,
        "Lon": 86.85757,
        "Speed": 5.0,
        "Height": 201,
        "Mileage": 181565,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27802,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27195889,
        "Time": "2022-02-23T11:39:48",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3763428,
        "Lon": 86.85261,
        "Speed": 3.3,
        "Height": 317,
        "Mileage": 184621,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27197924,
        "Time": "2022-02-23T11:56:49",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3653374,
        "Lon": 86.8533859,
        "Speed": 16.8,
        "Height": 225,
        "Mileage": 188118,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27754,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27203292,
        "Time": "2022-02-23T12:52:39",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3725128,
        "Lon": 86.85452,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": 191639,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27867,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27206015,
        "Time": "2022-02-23T13:16:04",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36278,
        "Lon": 86.8574,
        "Speed": 14.0,
        "Height": 210,
        "Mileage": 194320,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27721,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27207636,
        "Time": "2022-02-23T13:29:51",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3652878,
        "Lon": 86.85366,
        "Speed": 29.0,
        "Height": 229,
        "Mileage": 199019,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27809,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27209645,
        "Time": "2022-02-23T13:45:27",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37147,
        "Lon": 86.85365,
        "Speed": 32.2,
        "Height": 288,
        "Mileage": 201890,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27769,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27212529,
        "Time": "2022-02-23T13:59:34",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36037,
        "Lon": 86.85714,
        "Speed": 0.0,
        "Height": 190,
        "Mileage": 205588,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27452,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27213356,
        "Time": "2022-02-23T14:13:22",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3748322,
        "Lon": 86.8511047,
        "Speed": 5.1,
        "Height": 309,
        "Mileage": 208586,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27680,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27216132,
        "Time": "2022-02-23T14:32:18",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3619156,
        "Lon": 86.8568649,
        "Speed": 17.2,
        "Height": 191,
        "Mileage": 211848,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27683,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27217664,
        "Time": "2022-02-23T14:45:50",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3633728,
        "Lon": 86.85003,
        "Speed": 22.7,
        "Height": 251,
        "Mileage": 216377,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27732,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27219829,
        "Time": "2022-02-23T15:03:17",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36399,
        "Lon": 86.84879,
        "Speed": 26.2,
        "Height": 247,
        "Mileage": 218698,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27678,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27222810,
        "Time": "2022-02-23T15:16:30",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36033,
        "Lon": 86.85781,
        "Speed": 13.5,
        "Height": 199,
        "Mileage": 223384,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27223683,
        "Time": "2022-02-23T15:33:13",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3752251,
        "Lon": 86.85089,
        "Speed": 5.5,
        "Height": 316,
        "Mileage": 226407,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27744,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27226531,
        "Time": "2022-02-23T15:47:37",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3608131,
        "Lon": 86.8570251,
        "Speed": 8.3,
        "Height": 193,
        "Mileage": 229401,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27724,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27227837,
        "Time": "2022-02-23T16:01:26",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.376,
        "Lon": 86.85176,
        "Speed": 18.1,
        "Height": 320,
        "Mileage": 232505,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27230664,
        "Time": "2022-02-23T16:21:18",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3624,
        "Lon": 86.857254,
        "Speed": 20.3,
        "Height": 197,
        "Mileage": 235667,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27744,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27231991,
        "Time": "2022-02-23T16:33:53",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3647537,
        "Lon": 86.8481445,
        "Speed": 32.0,
        "Height": 253,
        "Mileage": 239997,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27708,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27234641,
        "Time": "2022-02-23T16:50:30",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3653755,
        "Lon": 86.85345,
        "Speed": 21.8,
        "Height": 225,
        "Mileage": 242150,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27728,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27236070,
        "Time": "2022-02-23T17:02:53",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3607635,
        "Lon": 86.85821,
        "Speed": 19.2,
        "Height": 193,
        "Mileage": 247059,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27240161,
        "Time": "2022-02-23T17:42:16",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3760757,
        "Lon": 86.8518753,
        "Speed": 23.8,
        "Height": 317,
        "Mileage": 249990,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27756,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27241887,
        "Time": "2022-02-23T17:55:25",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3630829,
        "Lon": 86.8855743,
        "Speed": 23.5,
        "Height": 284,
        "Mileage": 255963,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27248017,
        "Time": "2022-02-23T18:44:08",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3479538,
        "Lon": 86.79522,
        "Speed": 3.5,
        "Height": 249,
        "Mileage": 264140,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27753,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27250794,
        "Time": "2022-02-23T19:03:49",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36408,
        "Lon": 86.88193,
        "Speed": 27.4,
        "Height": 283,
        "Mileage": 274255,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27709,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27253197,
        "Time": "2022-02-23T19:19:15",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36079,
        "Lon": 86.85771,
        "Speed": 10.9,
        "Height": 197,
        "Mileage": 277878,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27330,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27254334,
        "Time": "2022-02-23T19:30:24",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3759956,
        "Lon": 86.8523,
        "Speed": 24.0,
        "Height": 315,
        "Mileage": 281035,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27634,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27256761,
        "Time": "2022-02-23T19:46:20",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36117,
        "Lon": 86.8575439,
        "Speed": 17.7,
        "Height": 199,
        "Mileage": 283993,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27258162,
        "Time": "2022-02-23T19:58:03",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3724136,
        "Lon": 86.8545761,
        "Speed": 33.3,
        "Height": 291,
        "Mileage": 287500,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27750,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27260759,
        "Time": "2022-02-23T20:15:23",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3653946,
        "Lon": 86.8536453,
        "Speed": 20.7,
        "Height": 226,
        "Mileage": 290586,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27666,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27265363,
        "Time": "2022-02-23T20:51:45",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37285,
        "Lon": 86.85571,
        "Speed": 0.0,
        "Height": 285,
        "Mileage": 293552,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27908,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27267665,
        "Time": "2022-02-23T21:07:33",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3628464,
        "Lon": 86.85732,
        "Speed": 15.3,
        "Height": 208,
        "Mileage": 296279,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27715,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27268755,
        "Time": "2022-02-23T21:19:17",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37315,
        "Lon": 86.85524,
        "Speed": 22.4,
        "Height": 296,
        "Mileage": 299555,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27672,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27272709,
        "Time": "2022-02-23T21:45:37",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.365284,
        "Lon": 86.85325,
        "Speed": 20.1,
        "Height": 225,
        "Mileage": 302652,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27787,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27274393,
        "Time": "2022-02-23T21:58:44",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3644943,
        "Lon": 86.8480453,
        "Speed": 30.5,
        "Height": 249,
        "Mileage": 306646,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27762,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27277809,
        "Time": "2022-02-23T22:23:06",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3634567,
        "Lon": 86.85042,
        "Speed": 12.7,
        "Height": 250,
        "Mileage": 308973,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27677,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27281159,
        "Time": "2022-02-23T22:37:36",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3647766,
        "Lon": 86.85456,
        "Speed": 28.1,
        "Height": 219,
        "Mileage": 313297,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27751,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27281923,
        "Time": "2022-02-23T22:51:15",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37333,
        "Lon": 86.85534,
        "Speed": 25.5,
        "Height": 295,
        "Mileage": 316346,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27752,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27284604,
        "Time": "2022-02-23T23:02:22",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3605347,
        "Lon": 86.85744,
        "Speed": 9.4,
        "Height": 193,
        "Mileage": 319974,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27285767,
        "Time": "2022-02-23T23:16:43",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3748131,
        "Lon": 86.8522339,
        "Speed": 5.9,
        "Height": 310,
        "Mileage": 323102,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27602,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27289937,
        "Time": "2022-02-23T23:40:03",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36079,
        "Lon": 86.8572,
        "Speed": 3.7,
        "Height": 186,
        "Mileage": 326188,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27640,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27291181,
        "Time": "2022-02-23T23:54:19",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3756065,
        "Lon": 86.8511,
        "Speed": 14.2,
        "Height": 312,
        "Mileage": 329364,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27793,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27293419,
        "Time": "2022-02-24T00:07:11",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3626328,
        "Lon": 86.85737,
        "Speed": 9.6,
        "Height": 193,
        "Mileage": 332525,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27753,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27295649,
        "Time": "2022-02-24T00:26:26",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3723564,
        "Lon": 86.85475,
        "Speed": 0.0,
        "Height": 285,
        "Mileage": 335969,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27867,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27301858,
        "Time": "2022-02-24T01:22:08",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3607,
        "Lon": 86.8566742,
        "Speed": 0.0,
        "Height": 177,
        "Mileage": 338370,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27303021,
        "Time": "2022-02-24T01:35:14",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.37457,
        "Lon": 86.85212,
        "Speed": 5.5,
        "Height": 310,
        "Mileage": 341490,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27722,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27307185,
        "Time": "2022-02-24T01:56:45",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3609428,
        "Lon": 86.857,
        "Speed": 6.8,
        "Height": 202,
        "Mileage": 344780,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27786,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27308497,
        "Time": "2022-02-24T02:11:31",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3754234,
        "Lon": 86.85124,
        "Speed": 8.8,
        "Height": 319,
        "Mileage": 347974,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27310647,
        "Time": "2022-02-24T02:23:34",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36239,
        "Lon": 86.85737,
        "Speed": 16.1,
        "Height": 197,
        "Mileage": 351148,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27825,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27312298,
        "Time": "2022-02-24T02:37:39",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36449,
        "Lon": 86.84803,
        "Speed": 24.6,
        "Height": 253,
        "Mileage": 355600,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27825,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27315363,
        "Time": "2022-02-24T02:53:09",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36354,
        "Lon": 86.84993,
        "Speed": 18.3,
        "Height": 247,
        "Mileage": 358042,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27887,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27318221,
        "Time": "2022-02-24T03:06:40",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36478,
        "Lon": 86.85451,
        "Speed": 27.7,
        "Height": 227,
        "Mileage": 362330,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27800,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27318714,
        "Time": "2022-02-24T03:23:05",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.366127,
        "Lon": 86.85068,
        "Speed": 21.8,
        "Height": 252,
        "Mileage": 364572,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27322221,
        "Time": "2022-02-24T03:36:27",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.36048,
        "Lon": 86.85774,
        "Speed": 10.5,
        "Height": 193,
        "Mileage": 369026,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27877,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27323263,
        "Time": "2022-02-24T03:52:18",
        "TruckId": 1315,
        "Imei": "862846040547104",
        "Lat": 54.3748,
        "Lon": 86.85213,
        "Speed": 3.7,
        "Height": 309,
        "Mileage": 372133,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 27910,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27004157,
        "Time": "2022-02-22T10:53:37",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40314,
        "Lon": 86.82267,
        "Speed": 31.8,
        "Height": 199,
        "Mileage": 71129568,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 87,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27148,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19101,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7578.0,
        "AxleLoad4": 7194.0,
        "AxleLoad5": 14495.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27006481,
        "Time": "2022-02-22T11:10:26",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.403244,
        "Lon": 86.84763,
        "Speed": 6.1,
        "Height": 289,
        "Mileage": 71134000,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1127.0,
        "OnboardVoltage": 27096,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 33,
        "LoadPercentage": 21,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19101,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6681.0,
        "AxleLoad4": 6682.0,
        "AxleLoad5": -13799.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27008836,
        "Time": "2022-02-22T11:28:20",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40216,
        "Lon": 86.82176,
        "Speed": 30.5,
        "Height": 206,
        "Mileage": 71139080,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 780.5,
        "OnboardVoltage": 27233,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19102,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6421.0,
        "AxleLoad4": 6427.0,
        "AxleLoad5": -15073.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27011744,
        "Time": "2022-02-22T11:49:52",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3948479,
        "Lon": 86.83538,
        "Speed": 24.4,
        "Height": 285,
        "Mileage": 71144112,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 1795.875,
        "OnboardVoltage": 27140,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 76,
        "LoadPercentage": 63,
        "FuelConsumption": 284,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19102,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6421.0,
        "AxleLoad4": 12315.0,
        "AxleLoad5": 12314.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27013682,
        "Time": "2022-02-22T12:06:30",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4023323,
        "Lon": 86.81589,
        "Speed": 18.5,
        "Height": 234,
        "Mileage": 71149176,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 84,
        "EngineRPM": 1798.875,
        "OnboardVoltage": 27115,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 81,
        "LoadPercentage": 71,
        "FuelConsumption": 235,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19102,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7958.0,
        "AxleLoad4": 6297.0,
        "AxleLoad5": 15005.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27021942,
        "Time": "2022-02-22T13:24:05",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4030838,
        "Lon": 86.84801,
        "Speed": 7.9,
        "Height": 292,
        "Mileage": 71152336,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 757.625,
        "OnboardVoltage": 27144,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 10,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19104,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6551.0,
        "AxleLoad4": 7067.0,
        "AxleLoad5": 15005.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27023693,
        "Time": "2022-02-22T13:40:02",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4070854,
        "Lon": 86.82623,
        "Speed": 19.6,
        "Height": 209,
        "Mileage": 71156792,
        "EngineOilPressure": 204,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 676.5,
        "OnboardVoltage": 27532,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19104,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7066.0,
        "AxleLoad4": 15644.0,
        "AxleLoad5": 13342.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27025796,
        "Time": "2022-02-22T13:56:53",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.39775,
        "Lon": 86.84584,
        "Speed": 25.5,
        "Height": 290,
        "Mileage": 71161440,
        "EngineOilPressure": 292,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 83,
        "EngineRPM": 658.5,
        "OnboardVoltage": 27534,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 46,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19104,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6171.0,
        "AxleLoad4": 7195.0,
        "AxleLoad5": 14492.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27027562,
        "Time": "2022-02-22T14:09:57",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40085,
        "Lon": 86.81619,
        "Speed": 32.5,
        "Height": 229,
        "Mileage": 71166368,
        "EngineOilPressure": 488,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 83,
        "EngineRPM": 1705.25,
        "OnboardVoltage": 27132,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 365,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19104,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6171.0,
        "AxleLoad4": 6808.0,
        "AxleLoad5": -15078.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27030880,
        "Time": "2022-02-22T14:33:03",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3885536,
        "Lon": 86.84841,
        "Speed": 21.2,
        "Height": 333,
        "Mileage": 71172120,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 793.0,
        "OnboardVoltage": 27044,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 40,
        "LoadPercentage": 33,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19105,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": -13280.0,
        "AxleLoad4": 14365.0,
        "AxleLoad5": 11812.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27033842,
        "Time": "2022-02-22T14:56:04",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38859,
        "Lon": 86.84781,
        "Speed": 10.5,
        "Height": 336,
        "Mileage": 71176688,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 82,
        "EngineRPM": 1283.75,
        "OnboardVoltage": 27102,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 78,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19105,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6548.0,
        "AxleLoad4": 6553.0,
        "AxleLoad5": -16358.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27036261,
        "Time": "2022-02-22T15:13:28",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.388237,
        "Lon": 86.8463,
        "Speed": 13.1,
        "Height": 345,
        "Mileage": 71181472,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 82,
        "EngineRPM": 859.375,
        "OnboardVoltage": 27529,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 30,
        "FuelConsumption": 126,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19105,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 5909.0,
        "AxleLoad4": 6423.0,
        "AxleLoad5": 14625.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27038790,
        "Time": "2022-02-22T15:31:25",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3885841,
        "Lon": 86.8469,
        "Speed": 18.5,
        "Height": 341,
        "Mileage": 71186032,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 83,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27094,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 79,
        "FuelConsumption": 344,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19106,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 5909.0,
        "AxleLoad4": 11167.0,
        "AxleLoad5": 13610.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27040833,
        "Time": "2022-02-22T15:48:48",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3884735,
        "Lon": 86.84826,
        "Speed": 23.5,
        "Height": 334,
        "Mileage": 71190832,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 83,
        "EngineRPM": 1817.375,
        "OnboardVoltage": 27092,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 77,
        "FuelConsumption": 370,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19106,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 5909.0,
        "AxleLoad4": 11548.0,
        "AxleLoad5": 12195.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27042919,
        "Time": "2022-02-22T16:07:06",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.388607,
        "Lon": 86.84679,
        "Speed": 14.6,
        "Height": 340,
        "Mileage": 71195856,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 78,
        "EngineRPM": 1774.5,
        "OnboardVoltage": 27063,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 76,
        "LoadPercentage": 61,
        "FuelConsumption": 328,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19106,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 5909.0,
        "AxleLoad4": -15836.0,
        "AxleLoad5": -14946.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27045610,
        "Time": "2022-02-22T16:25:18",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4016571,
        "Lon": 86.84726,
        "Speed": 25.9,
        "Height": 290,
        "Mileage": 71198336,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 83,
        "EngineRPM": 1092.75,
        "OnboardVoltage": 27062,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 62,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19107,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 5909.0,
        "AxleLoad4": 8348.0,
        "AxleLoad5": 13985.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27048757,
        "Time": "2022-02-22T16:50:55",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4006577,
        "Lon": 86.84696,
        "Speed": 26.4,
        "Height": 296,
        "Mileage": 71203176,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 80,
        "EngineRPM": 1376.625,
        "OnboardVoltage": 27516,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 52,
        "LoadPercentage": 37,
        "FuelConsumption": 108,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19107,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": -10466.0,
        "AxleLoad4": 6554.0,
        "AxleLoad5": 9630.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27055425,
        "Time": "2022-02-22T17:48:35",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4024963,
        "Lon": 86.84721,
        "Speed": 0.0,
        "Height": 295,
        "Mileage": 71207728,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 79,
        "EngineRPM": 1129.625,
        "OnboardVoltage": 27574,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19108,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6937.0,
        "AxleLoad4": 7066.0,
        "AxleLoad5": 13206.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27059027,
        "Time": "2022-02-22T18:21:29",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4017677,
        "Lon": 86.8472748,
        "Speed": 22.5,
        "Height": 289,
        "Mileage": 71209840,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 72,
        "EngineRPM": 1261.875,
        "OnboardVoltage": 27525,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19109,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6937.0,
        "AxleLoad4": 6557.0,
        "AxleLoad5": 9118.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27061092,
        "Time": "2022-02-22T18:39:23",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40243,
        "Lon": 86.8476639,
        "Speed": 19.0,
        "Height": 288,
        "Mileage": 71214432,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 72,
        "EngineRPM": 937.875,
        "OnboardVoltage": 27508,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 26,
        "LoadPercentage": 65,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19109,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 9502.0,
        "AxleLoad4": 6553.0,
        "AxleLoad5": 8472.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27064101,
        "Time": "2022-02-22T19:00:26",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3951759,
        "Lon": 86.8416,
        "Speed": 20.7,
        "Height": 278,
        "Mileage": 71220272,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 69,
        "EngineRPM": 1345.25,
        "OnboardVoltage": 27008,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 55,
        "LoadPercentage": 68,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19109,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6169.0,
        "AxleLoad4": 7835.0,
        "AxleLoad5": -13530.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27066665,
        "Time": "2022-02-22T19:19:15",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3924065,
        "Lon": 86.84468,
        "Speed": 22.0,
        "Height": 301,
        "Mileage": 71225408,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 74,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27531,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 84,
        "FuelConsumption": 351,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19110,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6936.0,
        "AxleLoad4": 13979.0,
        "AxleLoad5": 11036.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27069359,
        "Time": "2022-02-22T19:39:58",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3891525,
        "Lon": 86.84894,
        "Speed": 22.5,
        "Height": 325,
        "Mileage": 71230792,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 71,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 26998,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19110,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6810.0,
        "AxleLoad4": 12061.0,
        "AxleLoad5": -13917.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27072407,
        "Time": "2022-02-22T20:01:05",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38888,
        "Lon": 86.84914,
        "Speed": 18.5,
        "Height": 329,
        "Mileage": 71235664,
        "EngineOilPressure": 480,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 69,
        "EngineRPM": 1807.125,
        "OnboardVoltage": 27100,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 366,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19110,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6682.0,
        "AxleLoad4": -15716.0,
        "AxleLoad5": 14501.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27075391,
        "Time": "2022-02-22T20:21:02",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3955,
        "Lon": 86.84187,
        "Speed": 18.1,
        "Height": 280,
        "Mileage": 71239344,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 75,
        "EngineRPM": 1302.5,
        "OnboardVoltage": 27539,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19111,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6684.0,
        "AxleLoad4": 6554.0,
        "AxleLoad5": 15398.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27078159,
        "Time": "2022-02-22T20:41:05",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3974266,
        "Lon": 86.8455,
        "Speed": 25.5,
        "Height": 279,
        "Mileage": 71243664,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 76,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27556,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 69,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19111,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6806.0,
        "AxleLoad4": -15964.0,
        "AxleLoad5": -15841.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27081124,
        "Time": "2022-02-22T21:02:01",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4032249,
        "Lon": 86.8480148,
        "Speed": 5.9,
        "Height": 294,
        "Mileage": 71247552,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 76,
        "EngineRPM": 1127.625,
        "OnboardVoltage": 27023,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19111,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6806.0,
        "AxleLoad4": -14426.0,
        "AxleLoad5": -15587.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27083805,
        "Time": "2022-02-22T21:22:57",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.403183,
        "Lon": 86.8481445,
        "Speed": 7.2,
        "Height": 286,
        "Mileage": 71252360,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 80,
        "EngineRPM": 855.0,
        "OnboardVoltage": 25903,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 63,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19112,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 6428.0,
        "AxleLoad5": 10909.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27086434,
        "Time": "2022-02-22T21:43:05",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40299,
        "Lon": 86.8477554,
        "Speed": 11.2,
        "Height": 297,
        "Mileage": 71257000,
        "EngineOilPressure": 300,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 78,
        "EngineRPM": 1128.5,
        "OnboardVoltage": 27597,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19112,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 6683.0,
        "AxleLoad5": -16102.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27089307,
        "Time": "2022-02-22T22:03:14",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4025841,
        "Lon": 86.84739,
        "Speed": 5.3,
        "Height": 296,
        "Mileage": 71261904,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 76,
        "EngineRPM": 719.875,
        "OnboardVoltage": 27578,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19112,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 7065.0,
        "AxleLoad5": -14563.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27091948,
        "Time": "2022-02-22T22:23:22",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.402523,
        "Lon": 86.84732,
        "Speed": 8.1,
        "Height": 291,
        "Mileage": 71266632,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 78,
        "EngineRPM": 757.125,
        "OnboardVoltage": 27017,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19113,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 7067.0,
        "AxleLoad5": 11418.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27094392,
        "Time": "2022-02-22T22:45:03",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40031,
        "Lon": 86.84709,
        "Speed": 10.0,
        "Height": 294,
        "Mileage": 71271096,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 77,
        "EngineRPM": 1453.625,
        "OnboardVoltage": 26546,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 60,
        "LoadPercentage": 69,
        "FuelConsumption": 144,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19113,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6802.0,
        "AxleLoad4": 7066.0,
        "AxleLoad5": 15006.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27097225,
        "Time": "2022-02-22T23:04:01",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3891029,
        "Lon": 86.84874,
        "Speed": 16.2,
        "Height": 329,
        "Mileage": 71274640,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 79,
        "EngineRPM": 1288.375,
        "OnboardVoltage": 27098,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19113,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6802.0,
        "AxleLoad4": 6939.0,
        "AxleLoad5": -15972.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27099788,
        "Time": "2022-02-22T23:25:34",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38829,
        "Lon": 86.84667,
        "Speed": 21.8,
        "Height": 340,
        "Mileage": 71279080,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 77,
        "EngineRPM": 798.75,
        "OnboardVoltage": 27133,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 43,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19114,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6802.0,
        "AxleLoad4": 15258.0,
        "AxleLoad5": 9755.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27102621,
        "Time": "2022-02-22T23:46:23",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38789,
        "Lon": 86.84641,
        "Speed": 0.0,
        "Height": 338,
        "Mileage": 71283704,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 77,
        "EngineRPM": 1179.25,
        "OnboardVoltage": 27128,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 33,
        "LoadPercentage": 33,
        "FuelConsumption": 136,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19114,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6802.0,
        "AxleLoad4": 14239.0,
        "AxleLoad5": 13218.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27105594,
        "Time": "2022-02-23T00:11:28",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3879852,
        "Lon": 86.84601,
        "Speed": 5.0,
        "Height": 342,
        "Mileage": 71288656,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 80,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27447,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 84,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19114,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6802.0,
        "AxleLoad4": 12699.0,
        "AxleLoad5": 11550.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27110210,
        "Time": "2022-02-23T00:55:16",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3977852,
        "Lon": 86.81651,
        "Speed": 21.8,
        "Height": 242,
        "Mileage": 71291832,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 80,
        "EngineRPM": 893.625,
        "OnboardVoltage": 27618,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 13,
        "LoadPercentage": 8,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19115,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6802.0,
        "AxleLoad4": 6682.0,
        "AxleLoad5": 11550.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27112326,
        "Time": "2022-02-23T01:12:45",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3879662,
        "Lon": 86.84638,
        "Speed": 4.2,
        "Height": 337,
        "Mileage": 71297320,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 77,
        "EngineRPM": 1440.5,
        "OnboardVoltage": 26691,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 66,
        "LoadPercentage": 50,
        "FuelConsumption": 230,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19115,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": -14430.0,
        "AxleLoad5": -15452.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27114888,
        "Time": "2022-02-23T01:35:03",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38796,
        "Lon": 86.84656,
        "Speed": 8.5,
        "Height": 334,
        "Mileage": 71302144,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 80,
        "EngineRPM": 1612.125,
        "OnboardVoltage": 27112,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 90,
        "LoadPercentage": 90,
        "FuelConsumption": 276,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19116,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7319.0,
        "AxleLoad4": 13085.0,
        "AxleLoad5": 14503.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27117520,
        "Time": "2022-02-23T01:53:22",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3893471,
        "Lon": 86.848465,
        "Speed": 16.6,
        "Height": 326,
        "Mileage": 71306776,
        "EngineOilPressure": 488,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27116,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19116,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7319.0,
        "AxleLoad4": 6939.0,
        "AxleLoad5": -14566.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118992,
        "Time": "2022-02-23T02:03:44",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4033432,
        "Lon": 86.84781,
        "Speed": 4.6,
        "Height": 288,
        "Mileage": 71309304,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 82,
        "EngineRPM": 823.25,
        "OnboardVoltage": 27071,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 15,
        "LoadPercentage": 0,
        "FuelConsumption": 58,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19116,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6167.0,
        "AxleLoad4": 7194.0,
        "AxleLoad5": -14054.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27122033,
        "Time": "2022-02-23T02:26:29",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3950577,
        "Lon": 86.84098,
        "Speed": 9.6,
        "Height": 280,
        "Mileage": 71313280,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 78,
        "EngineRPM": 971.25,
        "OnboardVoltage": 27093,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 14,
        "LoadPercentage": 58,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19117,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6167.0,
        "AxleLoad4": 6938.0,
        "AxleLoad5": -13922.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27124464,
        "Time": "2022-02-23T02:44:00",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3926659,
        "Lon": 86.844574,
        "Speed": 29.8,
        "Height": 302,
        "Mileage": 71317912,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 78,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27112,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19117,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6939.0,
        "AxleLoad4": 7066.0,
        "AxleLoad5": 16025.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27127107,
        "Time": "2022-02-23T03:03:08",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38825,
        "Lon": 86.84574,
        "Speed": 7.5,
        "Height": 349,
        "Mileage": 71322032,
        "EngineOilPressure": 200,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 78,
        "EngineRPM": 781.75,
        "OnboardVoltage": 27085,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 37,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19117,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6939.0,
        "AxleLoad4": 14749.0,
        "AxleLoad5": 16169.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27129420,
        "Time": "2022-02-23T03:19:07",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3880577,
        "Lon": 86.84587,
        "Speed": 5.5,
        "Height": 341,
        "Mileage": 71326888,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 70,
        "EngineRPM": 1319.0,
        "OnboardVoltage": 25815,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 47,
        "LoadPercentage": 78,
        "FuelConsumption": 164,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19118,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7448.0,
        "AxleLoad4": 7065.0,
        "AxleLoad5": 15772.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27132339,
        "Time": "2022-02-23T03:39:41",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3886337,
        "Lon": 86.8491,
        "Speed": 16.8,
        "Height": 329,
        "Mileage": 71331736,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 70,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27155,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19118,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7448.0,
        "AxleLoad4": 14108.0,
        "AxleLoad5": -15719.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27135034,
        "Time": "2022-02-23T03:58:42",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3954926,
        "Lon": 86.8418045,
        "Speed": 16.2,
        "Height": 283,
        "Mileage": 71335408,
        "EngineOilPressure": 280,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 73,
        "EngineRPM": 1020.75,
        "OnboardVoltage": 27124,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19118,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 11037.0,
        "AxleLoad5": 14628.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27137881,
        "Time": "2022-02-23T04:15:36",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4033928,
        "Lon": 86.84798,
        "Speed": 7.0,
        "Height": 297,
        "Mileage": 71339104,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 74,
        "EngineRPM": 770.75,
        "OnboardVoltage": 26610,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 19,
        "LoadPercentage": 12,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19118,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 7066.0,
        "AxleLoad5": -7126.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27141404,
        "Time": "2022-02-23T04:38:58",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4036331,
        "Lon": 86.8478,
        "Speed": 7.0,
        "Height": 318,
        "Mileage": 71343904,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 76,
        "EngineRPM": 1123.125,
        "OnboardVoltage": 27589,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19119,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 6553.0,
        "AxleLoad5": -14696.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27143825,
        "Time": "2022-02-23T04:55:49",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.404583,
        "Lon": 86.8235245,
        "Speed": 30.0,
        "Height": 198,
        "Mileage": 71349288,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 77,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27622,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19119,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 6939.0,
        "AxleLoad5": -12644.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27147879,
        "Time": "2022-02-23T05:36:50",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40323,
        "Lon": 86.8475647,
        "Speed": 9.4,
        "Height": 296,
        "Mileage": 71353064,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 77,
        "EngineRPM": 842.625,
        "OnboardVoltage": 27165,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 9,
        "LoadPercentage": 77,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19120,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 6554.0,
        "AxleLoad5": -12644.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27149756,
        "Time": "2022-02-23T05:50:41",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38885,
        "Lon": 86.8488159,
        "Speed": 12.7,
        "Height": 330,
        "Mileage": 71355992,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 833.0,
        "OnboardVoltage": 27116,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 33,
        "LoadPercentage": 30,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19120,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": -14313.0,
        "AxleLoad5": -10599.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27152081,
        "Time": "2022-02-23T06:09:39",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38792,
        "Lon": 86.8457947,
        "Speed": 0.0,
        "Height": 340,
        "Mileage": 71360624,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 78,
        "EngineRPM": 1106.75,
        "OnboardVoltage": 27632,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 50,
        "LoadPercentage": 72,
        "FuelConsumption": 80,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19120,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": -9830.0,
        "AxleLoad4": 14107.0,
        "AxleLoad5": 15267.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27155129,
        "Time": "2022-02-23T06:32:19",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3879852,
        "Lon": 86.84667,
        "Speed": 9.4,
        "Height": 341,
        "Mileage": 71365336,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 76,
        "EngineRPM": 1616.0,
        "OnboardVoltage": 27620,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 48,
        "LoadPercentage": 0,
        "FuelConsumption": 364,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19121,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6168.0,
        "AxleLoad4": 15256.0,
        "AxleLoad5": 16284.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27158690,
        "Time": "2022-02-23T06:58:57",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3913422,
        "Lon": 86.84592,
        "Speed": 20.0,
        "Height": 306,
        "Mileage": 71369600,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 80,
        "EngineRPM": 1807.125,
        "OnboardVoltage": 27188,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19121,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 6682.0,
        "AxleLoad5": -15462.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27161389,
        "Time": "2022-02-23T07:16:22",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3954124,
        "Lon": 86.841835,
        "Speed": 16.1,
        "Height": 284,
        "Mileage": 71373768,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 80,
        "EngineRPM": 874.0,
        "OnboardVoltage": 27110,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 13,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19122,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6551.0,
        "AxleLoad4": 7067.0,
        "AxleLoad5": 12057.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27162963,
        "Time": "2022-02-23T07:27:39",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4030037,
        "Lon": 86.8477554,
        "Speed": 10.1,
        "Height": 297,
        "Mileage": 71377464,
        "EngineOilPressure": 200,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 77,
        "EngineRPM": 1412.125,
        "OnboardVoltage": 27146,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 58,
        "FuelConsumption": 117,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19122,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6808.0,
        "AxleLoad4": 6939.0,
        "AxleLoad5": 15381.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27166094,
        "Time": "2022-02-23T07:49:16",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40235,
        "Lon": 86.8472061,
        "Speed": 14.0,
        "Height": 297,
        "Mileage": 71382000,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 78,
        "EngineRPM": 738.25,
        "OnboardVoltage": 27253,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19122,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6808.0,
        "AxleLoad4": 7064.0,
        "AxleLoad5": -14048.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27168411,
        "Time": "2022-02-23T08:08:26",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3949661,
        "Lon": 86.84194,
        "Speed": 27.4,
        "Height": 277,
        "Mileage": 71385784,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27158,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19122,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6808.0,
        "AxleLoad4": 6940.0,
        "AxleLoad5": -15589.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27171307,
        "Time": "2022-02-23T08:31:26",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38852,
        "Lon": 86.8487,
        "Speed": 22.9,
        "Height": 332,
        "Mileage": 71389656,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 944.0,
        "OnboardVoltage": 27166,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 30,
        "LoadPercentage": 77,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19123,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6808.0,
        "AxleLoad4": 6298.0,
        "AxleLoad5": -14310.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27174089,
        "Time": "2022-02-23T08:52:22",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3881836,
        "Lon": 86.84682,
        "Speed": 15.1,
        "Height": 338,
        "Mileage": 71394424,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 80,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27148,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 82,
        "FuelConsumption": 349,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19123,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6808.0,
        "AxleLoad4": 15642.0,
        "AxleLoad5": 15770.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27175940,
        "Time": "2022-02-23T09:08:22",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.392395,
        "Lon": 86.8447342,
        "Speed": 20.1,
        "Height": 296,
        "Mileage": 71398344,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27111,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 352,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19123,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": -13540.0,
        "AxleLoad4": -14822.0,
        "AxleLoad5": 9498.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27177978,
        "Time": "2022-02-23T09:25:45",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.39575,
        "Lon": 86.84247,
        "Speed": 19.8,
        "Height": 278,
        "Mileage": 71402680,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 1297.125,
        "OnboardVoltage": 27058,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19124,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 9109.0,
        "AxleLoad4": 6557.0,
        "AxleLoad5": 16283.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27181035,
        "Time": "2022-02-23T09:48:17",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.400444,
        "Lon": 86.84691,
        "Speed": 19.6,
        "Height": 294,
        "Mileage": 71406792,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 82,
        "EngineRPM": 1187.125,
        "OnboardVoltage": 27081,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 66,
        "LoadPercentage": 29,
        "FuelConsumption": 93,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19124,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 9109.0,
        "AxleLoad4": 10011.0,
        "AxleLoad5": -15837.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27183169,
        "Time": "2022-02-23T10:02:37",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40348,
        "Lon": 86.84746,
        "Speed": 5.0,
        "Height": 297,
        "Mileage": 71411112,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 78,
        "EngineRPM": 1072.125,
        "OnboardVoltage": 27109,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 30,
        "LoadPercentage": 23,
        "FuelConsumption": 82,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19124,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 9109.0,
        "AxleLoad4": 6424.0,
        "AxleLoad5": -14558.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27185986,
        "Time": "2022-02-23T10:25:39",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4017,
        "Lon": 86.84686,
        "Speed": 0.0,
        "Height": 295,
        "Mileage": 71415648,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 82,
        "EngineRPM": 1124.375,
        "OnboardVoltage": 27247,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19125,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 9109.0,
        "AxleLoad4": 6810.0,
        "AxleLoad5": -15335.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27189482,
        "Time": "2022-02-23T10:52:14",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3950958,
        "Lon": 86.84187,
        "Speed": 21.4,
        "Height": 285,
        "Mileage": 71419448,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27132,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19125,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 9109.0,
        "AxleLoad4": 6939.0,
        "AxleLoad5": -14183.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27191894,
        "Time": "2022-02-23T11:09:48",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.388,
        "Lon": 86.84645,
        "Speed": 9.4,
        "Height": 346,
        "Mileage": 71423248,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 81,
        "EngineRPM": 853.75,
        "OnboardVoltage": 27122,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 10,
        "LoadPercentage": 0,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19125,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6680.0,
        "AxleLoad4": -13160.0,
        "AxleLoad5": -11489.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27194354,
        "Time": "2022-02-23T11:29:19",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38782,
        "Lon": 86.84627,
        "Speed": 4.2,
        "Height": 340,
        "Mileage": 71428288,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 80,
        "EngineRPM": 1089.75,
        "OnboardVoltage": 26691,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 34,
        "LoadPercentage": 32,
        "FuelConsumption": 254,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19126,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6676.0,
        "AxleLoad4": 9116.0,
        "AxleLoad5": 16026.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27202941,
        "Time": "2022-02-23T12:48:51",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4000473,
        "Lon": 86.8179855,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": 71431224,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1125.125,
        "OnboardVoltage": 27597,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19127,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6676.0,
        "AxleLoad4": 6809.0,
        "AxleLoad5": 16026.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27207423,
        "Time": "2022-02-23T13:28:41",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38888,
        "Lon": 86.84917,
        "Speed": 21.6,
        "Height": 322,
        "Mileage": 71436768,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 85,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27005,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19128,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 14233.0,
        "AxleLoad5": 12064.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27210182,
        "Time": "2022-02-23T13:49:15",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3890038,
        "Lon": 86.8491,
        "Speed": 23.1,
        "Height": 326,
        "Mileage": 71441680,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 88,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27040,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 365,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19128,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 11295.0,
        "AxleLoad5": 14371.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27213271,
        "Time": "2022-02-23T14:13:11",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3974724,
        "Lon": 86.84555,
        "Speed": 22.9,
        "Height": 284,
        "Mileage": 71445568,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 72,
        "EngineRPM": 961.25,
        "OnboardVoltage": 27112,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19128,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 10395.0,
        "AxleLoad5": 15395.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27215910,
        "Time": "2022-02-23T14:32:05",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40304,
        "Lon": 86.8478851,
        "Speed": 15.7,
        "Height": 289,
        "Mileage": 71449760,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 71,
        "EngineRPM": 1355.25,
        "OnboardVoltage": 27047,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 56,
        "LoadPercentage": 50,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19129,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6425.0,
        "AxleLoad4": 6810.0,
        "AxleLoad5": 14878.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27217943,
        "Time": "2022-02-23T14:48:13",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4036942,
        "Lon": 86.84797,
        "Speed": 0.0,
        "Height": 297,
        "Mileage": 71454672,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 67,
        "EngineRPM": 1126.875,
        "OnboardVoltage": 27118,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19129,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6423.0,
        "AxleLoad4": 6684.0,
        "AxleLoad5": -15714.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27220294,
        "Time": "2022-02-23T15:07:29",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40382,
        "Lon": 86.84795,
        "Speed": 8.1,
        "Height": 299,
        "Mileage": 71459616,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 70,
        "EngineRPM": 1124.375,
        "OnboardVoltage": 27111,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19129,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7191.0,
        "AxleLoad4": 6683.0,
        "AxleLoad5": 13337.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27222352,
        "Time": "2022-02-23T15:23:28",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4030647,
        "Lon": 86.8477554,
        "Speed": 18.5,
        "Height": 302,
        "Mileage": 71464544,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 67,
        "EngineRPM": 1001.375,
        "OnboardVoltage": 27062,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 28,
        "LoadPercentage": 0,
        "FuelConsumption": 70,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19130,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7191.0,
        "AxleLoad4": 6811.0,
        "AxleLoad5": 15391.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27225177,
        "Time": "2022-02-23T15:43:08",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.39714,
        "Lon": 86.8452,
        "Speed": 19.8,
        "Height": 285,
        "Mileage": 71468848,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 67,
        "EngineRPM": 884.25,
        "OnboardVoltage": 26993,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19130,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7191.0,
        "AxleLoad4": 7067.0,
        "AxleLoad5": -14810.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27227971,
        "Time": "2022-02-23T16:02:27",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.39564,
        "Lon": 86.84235,
        "Speed": 29.6,
        "Height": 279,
        "Mileage": 71473688,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 71,
        "EngineRPM": 1296.875,
        "OnboardVoltage": 27014,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19130,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 13210.0,
        "AxleLoad4": 6812.0,
        "AxleLoad5": -15584.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27230503,
        "Time": "2022-02-23T16:22:04",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4023438,
        "Lon": 86.84734,
        "Speed": 27.2,
        "Height": 290,
        "Mileage": 71479624,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 1055.25,
        "OnboardVoltage": 27044,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 37,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19131,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6551.0,
        "AxleLoad4": 6556.0,
        "AxleLoad5": -15201.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27232984,
        "Time": "2022-02-23T16:42:11",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3980064,
        "Lon": 86.84614,
        "Speed": 23.7,
        "Height": 284,
        "Mileage": 71484016,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 69,
        "EngineRPM": 1433.375,
        "OnboardVoltage": 27051,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 56,
        "LoadPercentage": 63,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19131,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6551.0,
        "AxleLoad4": 7706.0,
        "AxleLoad5": -15843.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27236454,
        "Time": "2022-02-23T17:08:09",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38788,
        "Lon": 86.84666,
        "Speed": 0.0,
        "Height": 339,
        "Mileage": 71487440,
        "EngineOilPressure": 300,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 76,
        "EngineRPM": 1127.625,
        "OnboardVoltage": 27105,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19131,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6680.0,
        "AxleLoad4": 6683.0,
        "AxleLoad5": 6694.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27240355,
        "Time": "2022-02-23T17:43:57",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4036179,
        "Lon": 86.84807,
        "Speed": 6.8,
        "Height": 283,
        "Mileage": 71489840,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 72,
        "EngineRPM": 1043.5,
        "OnboardVoltage": 25767,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 5,
        "LoadPercentage": 0,
        "FuelConsumption": 155,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19132,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6296.0,
        "AxleLoad4": 6938.0,
        "AxleLoad5": 6694.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27242603,
        "Time": "2022-02-23T18:01:00",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4028473,
        "Lon": 86.84775,
        "Speed": 17.5,
        "Height": 294,
        "Mileage": 71494624,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 73,
        "EngineRPM": 652.5,
        "OnboardVoltage": 27043,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19132,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6296.0,
        "AxleLoad4": 6938.0,
        "AxleLoad5": -15075.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27244922,
        "Time": "2022-02-23T18:19:42",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4020081,
        "Lon": 86.84714,
        "Speed": 21.6,
        "Height": 289,
        "Mileage": 71499648,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 1391.375,
        "OnboardVoltage": 27087,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 82,
        "LoadPercentage": 83,
        "FuelConsumption": 87,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19133,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6420.0,
        "AxleLoad4": 6811.0,
        "AxleLoad5": -13029.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27247106,
        "Time": "2022-02-23T18:37:45",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.39397,
        "Lon": 86.84335,
        "Speed": 33.1,
        "Height": 288,
        "Mileage": 71503536,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 75,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27055,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19133,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6420.0,
        "AxleLoad4": 6812.0,
        "AxleLoad5": 15639.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27249821,
        "Time": "2022-02-23T18:57:26",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3886032,
        "Lon": 86.8486557,
        "Speed": 20.5,
        "Height": 329,
        "Mileage": 71508032,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 76,
        "EngineRPM": 920.625,
        "OnboardVoltage": 26946,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 21,
        "LoadPercentage": 67,
        "FuelConsumption": 76,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19133,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7191.0,
        "AxleLoad4": 6809.0,
        "AxleLoad5": 11931.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27252638,
        "Time": "2022-02-23T19:17:47",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.388237,
        "Lon": 86.84689,
        "Speed": 18.1,
        "Height": 334,
        "Mileage": 71512936,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 74,
        "EngineRPM": 737.375,
        "OnboardVoltage": 27068,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19134,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 7191.0,
        "AxleLoad4": 15129.0,
        "AxleLoad5": -13157.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27255279,
        "Time": "2022-02-23T19:37:49",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3876648,
        "Lon": 86.846405,
        "Speed": 4.4,
        "Height": 335,
        "Mileage": 71517784,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 75,
        "EngineRPM": 1024.625,
        "OnboardVoltage": 25866,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19134,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 15261.0,
        "AxleLoad5": 16026.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27258476,
        "Time": "2022-02-23T20:00:12",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3879128,
        "Lon": 86.8465958,
        "Speed": 17.0,
        "Height": 337,
        "Mileage": 71522736,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 75,
        "EngineRPM": 1806.5,
        "OnboardVoltage": 26688,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 78,
        "FuelConsumption": 349,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19134,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 14621.0,
        "AxleLoad5": 16280.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27261082,
        "Time": "2022-02-23T20:19:27",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3882332,
        "Lon": 86.84708,
        "Speed": 17.0,
        "Height": 336,
        "Mileage": 71527792,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 72,
        "EngineRPM": 1802.625,
        "OnboardVoltage": 27069,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 80,
        "LoadPercentage": 63,
        "FuelConsumption": 295,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19135,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6299.0,
        "AxleLoad4": 14492.0,
        "AxleLoad5": -14952.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27263840,
        "Time": "2022-02-23T20:39:32",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3886833,
        "Lon": 86.849144,
        "Speed": 20.3,
        "Height": 331,
        "Mileage": 71532680,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 74,
        "EngineRPM": 1807.375,
        "OnboardVoltage": 26994,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19135,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": -13798.0,
        "AxleLoad5": 13853.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27266098,
        "Time": "2022-02-23T20:58:03",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.38913,
        "Lon": 86.8490143,
        "Speed": 22.4,
        "Height": 329,
        "Mileage": 71537760,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 77,
        "EngineRPM": 1807.375,
        "OnboardVoltage": 27070,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 367,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19135,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 15385.0,
        "AxleLoad5": 11672.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27268879,
        "Time": "2022-02-23T21:20:10",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3976631,
        "Lon": 86.84576,
        "Speed": 26.1,
        "Height": 284,
        "Mileage": 71541344,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 73,
        "EngineRPM": 1037.625,
        "OnboardVoltage": 26912,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 159,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19136,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 7322.0,
        "AxleLoad5": -15592.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27271855,
        "Time": "2022-02-23T21:41:18",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3970642,
        "Lon": 86.84507,
        "Speed": 24.4,
        "Height": 278,
        "Mileage": 71546608,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 76,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27090,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19136,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 12320.0,
        "AxleLoad5": 12576.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27275289,
        "Time": "2022-02-23T22:05:03",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4037933,
        "Lon": 86.84784,
        "Speed": 6.6,
        "Height": 306,
        "Mileage": 71550840,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 76,
        "EngineRPM": 1126.875,
        "OnboardVoltage": 27037,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19136,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6043.0,
        "AxleLoad4": 6298.0,
        "AxleLoad5": 12192.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27278419,
        "Time": "2022-02-23T22:27:10",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4039536,
        "Lon": 86.84763,
        "Speed": 6.6,
        "Height": 287,
        "Mileage": 71556088,
        "EngineOilPressure": 328,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 77,
        "EngineRPM": 1126.625,
        "OnboardVoltage": 27110,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19137,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 5916.0,
        "AxleLoad4": 6811.0,
        "AxleLoad5": -15080.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27280938,
        "Time": "2022-02-23T22:45:14",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40317,
        "Lon": 86.84766,
        "Speed": 10.0,
        "Height": 292,
        "Mileage": 71560872,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 74,
        "EngineRPM": 1502.875,
        "OnboardVoltage": 27154,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 87,
        "LoadPercentage": 73,
        "FuelConsumption": 297,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19137,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6171.0,
        "AxleLoad4": 7065.0,
        "AxleLoad5": 12309.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27284975,
        "Time": "2022-02-23T23:11:31",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40309,
        "Lon": 86.84768,
        "Speed": 21.8,
        "Height": 292,
        "Mileage": 71565904,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 76,
        "EngineRPM": 1120.75,
        "OnboardVoltage": 27111,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19137,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 6812.0,
        "AxleLoad5": 10141.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27288292,
        "Time": "2022-02-23T23:34:32",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40161,
        "Lon": 86.84699,
        "Speed": 33.7,
        "Height": 291,
        "Mileage": 71570464,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 73,
        "EngineRPM": 1209.25,
        "OnboardVoltage": 27052,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 34,
        "LoadPercentage": 0,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19138,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 7705.0,
        "AxleLoad5": -9314.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27291448,
        "Time": "2022-02-23T23:56:29",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3950233,
        "Lon": 86.841835,
        "Speed": 30.9,
        "Height": 280,
        "Mileage": 71574368,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 76,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27068,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19138,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 7196.0,
        "AxleLoad5": -14566.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27294393,
        "Time": "2022-02-24T00:17:26",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.407093,
        "Lon": 86.8262,
        "Speed": 18.3,
        "Height": 204,
        "Mileage": 71579688,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1809.0,
        "OnboardVoltage": 27099,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 84,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19138,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6680.0,
        "AxleLoad4": -15973.0,
        "AxleLoad5": -15841.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27299447,
        "Time": "2022-02-24T01:08:36",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4033051,
        "Lon": 86.847496,
        "Speed": 0.0,
        "Height": 299,
        "Mileage": 71584184,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 73,
        "EngineRPM": 1123.75,
        "OnboardVoltage": 27087,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19139,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6421.0,
        "AxleLoad4": 6553.0,
        "AxleLoad5": 11672.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27302145,
        "Time": "2022-02-24T01:29:46",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4033,
        "Lon": 86.8477554,
        "Speed": 6.2,
        "Height": 298,
        "Mileage": 71589400,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 75,
        "EngineRPM": 1138.25,
        "OnboardVoltage": 27103,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6424.0,
        "AxleLoad4": 6810.0,
        "AxleLoad5": 9633.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27304670,
        "Time": "2022-02-24T01:46:54",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.39076,
        "Lon": 86.8465652,
        "Speed": 31.6,
        "Height": 315,
        "Mileage": 71592688,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 74,
        "EngineRPM": 1268.75,
        "OnboardVoltage": 26965,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 11,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 14497.0,
        "AxleLoad4": 7322.0,
        "AxleLoad5": -15845.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27308129,
        "Time": "2022-02-24T02:09:01",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.3952751,
        "Lon": 86.84174,
        "Speed": 22.5,
        "Height": 282,
        "Mileage": 71598264,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 73,
        "EngineRPM": 1293.125,
        "OnboardVoltage": 26741,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 18,
        "FuelConsumption": 48,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6807.0,
        "AxleLoad4": 6937.0,
        "AxleLoad5": -13926.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27311285,
        "Time": "2022-02-24T02:30:17",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.39685,
        "Lon": 86.84471,
        "Speed": 33.3,
        "Height": 277,
        "Mileage": 71603360,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 75,
        "EngineRPM": 1171.25,
        "OnboardVoltage": 27156,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19141,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6807.0,
        "AxleLoad4": 6940.0,
        "AxleLoad5": -12899.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27313354,
        "Time": "2022-02-24T02:45:05",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.395565,
        "Lon": 86.8420944,
        "Speed": 22.4,
        "Height": 283,
        "Mileage": 71607720,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 76,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27139,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19141,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6807.0,
        "AxleLoad4": 7576.0,
        "AxleLoad5": 13863.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27316323,
        "Time": "2022-02-24T03:05:25",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40316,
        "Lon": 86.84765,
        "Speed": 18.5,
        "Height": 302,
        "Mileage": 71613256,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 73,
        "EngineRPM": 704.875,
        "OnboardVoltage": 27158,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19141,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6422.0,
        "AxleLoad4": 6553.0,
        "AxleLoad5": 16281.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27319476,
        "Time": "2022-02-24T03:28:24",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.4040947,
        "Lon": 86.84771,
        "Speed": 0.0,
        "Height": 307,
        "Mileage": 71617952,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 75,
        "EngineRPM": 1125.75,
        "OnboardVoltage": 27106,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19142,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6422.0,
        "AxleLoad4": 6682.0,
        "AxleLoad5": 13971.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27322050,
        "Time": "2022-02-24T03:45:13",
        "TruckId": 1314,
        "Imei": "862846040548102",
        "Lat": 54.40399,
        "Lon": 86.84747,
        "Speed": 7.7,
        "Height": 301,
        "Mileage": 71622736,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 74,
        "EngineRPM": 1126.25,
        "OnboardVoltage": 27147,
        "EngineSpeed": null,
        "TotalMileage": 219555350,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 19142,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 6423.0,
        "AxleLoad4": 6938.0,
        "AxleLoad5": -8409.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27004197,
        "Time": "2022-02-22T10:53:43",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12111,
        "Lon": 86.491066,
        "Speed": 0.0,
        "Height": 59,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27005030,
        "Time": "2022-02-22T11:00:02",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1161957,
        "Lon": 86.49283,
        "Speed": 11.0,
        "Height": 120,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27006378,
        "Time": "2022-02-22T11:09:42",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.11463,
        "Lon": 86.49118,
        "Speed": 38.0,
        "Height": 170,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27007943,
        "Time": "2022-02-22T11:21:28",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1462326,
        "Lon": 86.4561,
        "Speed": 0.0,
        "Height": 309,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27008916,
        "Time": "2022-02-22T11:28:37",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1605568,
        "Lon": 86.4342,
        "Speed": 18.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27010911,
        "Time": "2022-02-22T11:43:03",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.15974,
        "Lon": 86.43359,
        "Speed": 4.0,
        "Height": 324,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27012888,
        "Time": "2022-02-22T11:59:35",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1597328,
        "Lon": 86.4336243,
        "Speed": 0.0,
        "Height": 324,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27014670,
        "Time": "2022-02-22T12:16:14",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1597328,
        "Lon": 86.4336243,
        "Speed": 0.0,
        "Height": 324,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27016735,
        "Time": "2022-02-22T12:32:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.15938,
        "Lon": 86.43407,
        "Speed": 0.0,
        "Height": 325,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27018102,
        "Time": "2022-02-22T12:48:54",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1591225,
        "Lon": 86.43426,
        "Speed": 0.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27020150,
        "Time": "2022-02-22T13:05:34",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1591225,
        "Lon": 86.43426,
        "Speed": 0.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27021733,
        "Time": "2022-02-22T13:22:14",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1591225,
        "Lon": 86.43426,
        "Speed": 0.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27023545,
        "Time": "2022-02-22T13:38:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1591225,
        "Lon": 86.43426,
        "Speed": 0.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27025132,
        "Time": "2022-02-22T13:52:31",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607,
        "Lon": 86.43568,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27027453,
        "Time": "2022-02-22T14:09:11",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607,
        "Lon": 86.43568,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27029861,
        "Time": "2022-02-22T14:25:50",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607,
        "Lon": 86.43568,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27032088,
        "Time": "2022-02-22T14:42:30",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607,
        "Lon": 86.43568,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27033661,
        "Time": "2022-02-22T14:54:55",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16451,
        "Lon": 86.43813,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27034951,
        "Time": "2022-02-22T15:03:46",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16504,
        "Lon": 86.45509,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27036537,
        "Time": "2022-02-22T15:15:18",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1943359,
        "Lon": 86.43368,
        "Speed": 34.0,
        "Height": 332,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27037930,
        "Time": "2022-02-22T15:24:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1989822,
        "Lon": 86.43148,
        "Speed": 0.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27039982,
        "Time": "2022-02-22T15:41:14",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1989822,
        "Lon": 86.43148,
        "Speed": 0.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27041849,
        "Time": "2022-02-22T15:57:54",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1989822,
        "Lon": 86.43148,
        "Speed": 0.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27043684,
        "Time": "2022-02-22T16:13:25",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1989822,
        "Lon": 86.43148,
        "Speed": 0.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27045135,
        "Time": "2022-02-22T16:21:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.19486,
        "Lon": 86.43678,
        "Speed": 32.0,
        "Height": 354,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27046339,
        "Time": "2022-02-22T16:31:45",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.21263,
        "Lon": 86.42192,
        "Speed": 0.0,
        "Height": 266,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27047634,
        "Time": "2022-02-22T16:42:54",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.2036629,
        "Lon": 86.44254,
        "Speed": 0.0,
        "Height": 376,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27049304,
        "Time": "2022-02-22T16:55:29",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1973228,
        "Lon": 86.43084,
        "Speed": 0.0,
        "Height": 310,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27050866,
        "Time": "2022-02-22T17:06:52",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1976967,
        "Lon": 86.43734,
        "Speed": 8.0,
        "Height": 290,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27051697,
        "Time": "2022-02-22T17:14:03",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.20156,
        "Lon": 86.43807,
        "Speed": 0.0,
        "Height": 257,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27053490,
        "Time": "2022-02-22T17:30:33",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.20156,
        "Lon": 86.43807,
        "Speed": 0.0,
        "Height": 257,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27055284,
        "Time": "2022-02-22T17:47:03",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.20156,
        "Lon": 86.43807,
        "Speed": 0.0,
        "Height": 257,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27057012,
        "Time": "2022-02-22T18:03:13",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.20156,
        "Lon": 86.43807,
        "Speed": 0.0,
        "Height": 257,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27057763,
        "Time": "2022-02-22T18:10:01",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1993752,
        "Lon": 86.44023,
        "Speed": 7.0,
        "Height": 271,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27058393,
        "Time": "2022-02-22T18:14:51",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.19712,
        "Lon": 86.42887,
        "Speed": 12.0,
        "Height": 305,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27060058,
        "Time": "2022-02-22T18:30:29",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1973457,
        "Lon": 86.4288254,
        "Speed": 0.0,
        "Height": 305,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27061677,
        "Time": "2022-02-22T18:44:03",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1912766,
        "Lon": 86.4355,
        "Speed": 33.0,
        "Height": 347,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27063024,
        "Time": "2022-02-22T18:53:53",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16343,
        "Lon": 86.45288,
        "Speed": 20.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27064700,
        "Time": "2022-02-22T19:04:22",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1412849,
        "Lon": 86.48908,
        "Speed": 5.0,
        "Height": 298,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27066186,
        "Time": "2022-02-22T19:16:07",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1389236,
        "Lon": 86.479,
        "Speed": 17.0,
        "Height": 313,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27067858,
        "Time": "2022-02-22T19:28:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12355,
        "Lon": 86.48524,
        "Speed": 23.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27069629,
        "Time": "2022-02-22T19:41:56",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1195221,
        "Lon": 86.49394,
        "Speed": 0.0,
        "Height": 53,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27071126,
        "Time": "2022-02-22T19:51:40",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1163177,
        "Lon": 86.48947,
        "Speed": 54.0,
        "Height": 153,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27072796,
        "Time": "2022-02-22T20:04:02",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1462059,
        "Lon": 86.4560852,
        "Speed": 0.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27074055,
        "Time": "2022-02-22T20:11:48",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27076379,
        "Time": "2022-02-22T20:28:18",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27078689,
        "Time": "2022-02-22T20:44:58",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27081077,
        "Time": "2022-02-22T21:01:38",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27083235,
        "Time": "2022-02-22T21:18:17",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27085423,
        "Time": "2022-02-22T21:34:57",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27087514,
        "Time": "2022-02-22T21:51:37",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27090083,
        "Time": "2022-02-22T22:08:17",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27092141,
        "Time": "2022-02-22T22:24:57",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27094002,
        "Time": "2022-02-22T22:41:37",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27096285,
        "Time": "2022-02-22T22:58:17",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27098413,
        "Time": "2022-02-22T23:14:57",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27100742,
        "Time": "2022-02-22T23:31:36",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27102898,
        "Time": "2022-02-22T23:48:16",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27104826,
        "Time": "2022-02-23T00:04:56",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27107067,
        "Time": "2022-02-23T00:21:35",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27108784,
        "Time": "2022-02-23T00:38:15",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27110189,
        "Time": "2022-02-23T00:54:56",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27112209,
        "Time": "2022-02-23T01:11:36",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27114080,
        "Time": "2022-02-23T01:28:06",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27116261,
        "Time": "2022-02-23T01:44:36",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27118668,
        "Time": "2022-02-23T02:01:16",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27120888,
        "Time": "2022-02-23T02:17:56",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27123088,
        "Time": "2022-02-23T02:34:36",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1607742,
        "Lon": 86.4356155,
        "Speed": 0.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27125083,
        "Time": "2022-02-23T02:47:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1602,
        "Lon": 86.43771,
        "Speed": 0.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27127009,
        "Time": "2022-02-23T03:02:18",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.15966,
        "Lon": 86.43625,
        "Speed": 16.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27128537,
        "Time": "2022-02-23T03:11:54",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14512,
        "Lon": 86.43694,
        "Speed": 49.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27129593,
        "Time": "2022-02-23T03:20:26",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14186,
        "Lon": 86.49551,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27132005,
        "Time": "2022-02-23T03:36:56",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14186,
        "Lon": 86.49551,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27133555,
        "Time": "2022-02-23T03:48:25",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1326256,
        "Lon": 86.49474,
        "Speed": 33.0,
        "Height": 316,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27135112,
        "Time": "2022-02-23T03:59:06",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1116524,
        "Lon": 86.49956,
        "Speed": 0.0,
        "Height": 188,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27137258,
        "Time": "2022-02-23T04:11:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12451,
        "Lon": 86.48393,
        "Speed": 36.0,
        "Height": 118,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27138848,
        "Time": "2022-02-23T04:22:38",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1285553,
        "Lon": 86.4787445,
        "Speed": 0.0,
        "Height": 217,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27140451,
        "Time": "2022-02-23T04:31:31",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12477,
        "Lon": 86.48446,
        "Speed": 0.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27142727,
        "Time": "2022-02-23T04:48:01",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12477,
        "Lon": 86.48446,
        "Speed": 0.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27144826,
        "Time": "2022-02-23T05:04:41",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12477,
        "Lon": 86.48446,
        "Speed": 0.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27146162,
        "Time": "2022-02-23T05:18:31",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12477,
        "Lon": 86.48446,
        "Speed": 0.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27147563,
        "Time": "2022-02-23T05:34:01",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12477,
        "Lon": 86.48446,
        "Speed": 0.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27149546,
        "Time": "2022-02-23T05:50:41",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12477,
        "Lon": 86.48446,
        "Speed": 0.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27151125,
        "Time": "2022-02-23T06:02:19",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1246758,
        "Lon": 86.48366,
        "Speed": 32.0,
        "Height": 122,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27153108,
        "Time": "2022-02-23T06:15:55",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1118736,
        "Lon": 86.52454,
        "Speed": 0.0,
        "Height": 355,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27155188,
        "Time": "2022-02-23T06:32:35",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1118736,
        "Lon": 86.52454,
        "Speed": 0.0,
        "Height": 355,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27156867,
        "Time": "2022-02-23T06:44:50",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.13785,
        "Lon": 86.47679,
        "Speed": 32.0,
        "Height": 310,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27158082,
        "Time": "2022-02-23T06:54:29",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1603127,
        "Lon": 86.4327,
        "Speed": 32.0,
        "Height": 324,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27160845,
        "Time": "2022-02-23T07:02:19",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1429138,
        "Lon": 86.4407043,
        "Speed": 48.0,
        "Height": 331,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27160788,
        "Time": "2022-02-23T07:12:24",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1622467,
        "Lon": 86.5569153,
        "Speed": 65.0,
        "Height": 261,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27162775,
        "Time": "2022-02-23T07:26:16",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.0602875,
        "Lon": 86.6790848,
        "Speed": 71.0,
        "Height": 278,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27164171,
        "Time": "2022-02-23T07:36:37",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.00884,
        "Lon": 86.64281,
        "Speed": 44.0,
        "Height": 370,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27165330,
        "Time": "2022-02-23T07:44:05",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.98067,
        "Lon": 86.6392059,
        "Speed": 26.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27167111,
        "Time": "2022-02-23T07:56:39",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.975,
        "Lon": 86.6433258,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27169054,
        "Time": "2022-02-23T08:12:59",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.975,
        "Lon": 86.6433258,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27171154,
        "Time": "2022-02-23T08:29:38",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.975,
        "Lon": 86.6433258,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27173282,
        "Time": "2022-02-23T08:46:18",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.975,
        "Lon": 86.6433258,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27175286,
        "Time": "2022-02-23T09:02:58",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.975,
        "Lon": 86.6433258,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27177258,
        "Time": "2022-02-23T09:19:38",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.975,
        "Lon": 86.6433258,
        "Speed": 0.0,
        "Height": 335,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27178855,
        "Time": "2022-02-23T09:32:44",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.9725342,
        "Lon": 86.63081,
        "Speed": 28.0,
        "Height": 334,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27180080,
        "Time": "2022-02-23T09:41:45",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 53.9972,
        "Lon": 86.6482239,
        "Speed": 30.0,
        "Height": 339,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27181624,
        "Time": "2022-02-23T09:52:04",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.03497,
        "Lon": 86.70568,
        "Speed": 42.0,
        "Height": 308,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27183411,
        "Time": "2022-02-23T10:05:25",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1356049,
        "Lon": 86.62,
        "Speed": 62.0,
        "Height": 269,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27184970,
        "Time": "2022-02-23T10:18:04",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14966,
        "Lon": 86.4729462,
        "Speed": 37.0,
        "Height": 293,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27185959,
        "Time": "2022-02-23T10:25:19",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1605225,
        "Lon": 86.43302,
        "Speed": 36.0,
        "Height": 324,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27187730,
        "Time": "2022-02-23T10:39:57",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1597061,
        "Lon": 86.43339,
        "Speed": 0.0,
        "Height": 325,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27189680,
        "Time": "2022-02-23T10:53:30",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27191951,
        "Time": "2022-02-23T11:10:10",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27194039,
        "Time": "2022-02-23T11:26:50",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27196328,
        "Time": "2022-02-23T11:43:30",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27198202,
        "Time": "2022-02-23T12:00:10",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27200084,
        "Time": "2022-02-23T12:16:50",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27201600,
        "Time": "2022-02-23T12:33:30",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27203077,
        "Time": "2022-02-23T12:50:10",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27204764,
        "Time": "2022-02-23T13:06:49",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27206714,
        "Time": "2022-02-23T13:23:29",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27208949,
        "Time": "2022-02-23T13:40:10",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27211142,
        "Time": "2022-02-23T13:56:49",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16079,
        "Lon": 86.43563,
        "Speed": 0.0,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27212301,
        "Time": "2022-02-23T14:06:57",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16547,
        "Lon": 86.4380341,
        "Speed": 18.0,
        "Height": 327,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27213598,
        "Time": "2022-02-23T14:15:30",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.165184,
        "Lon": 86.45503,
        "Speed": 5.0,
        "Height": 316,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27215135,
        "Time": "2022-02-23T14:26:14",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.19555,
        "Lon": 86.43111,
        "Speed": 33.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27217168,
        "Time": "2022-02-23T14:42:18",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1973534,
        "Lon": 86.42881,
        "Speed": 0.0,
        "Height": 311,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27219146,
        "Time": "2022-02-23T14:58:58",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1973534,
        "Lon": 86.42881,
        "Speed": 0.0,
        "Height": 311,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27221254,
        "Time": "2022-02-23T15:15:37",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1973534,
        "Lon": 86.42881,
        "Speed": 0.0,
        "Height": 311,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27223569,
        "Time": "2022-02-23T15:32:17",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1973534,
        "Lon": 86.42881,
        "Speed": 0.0,
        "Height": 311,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27224854,
        "Time": "2022-02-23T15:41:07",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1983871,
        "Lon": 86.43065,
        "Speed": 0.0,
        "Height": 292,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27226640,
        "Time": "2022-02-23T15:53:05",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1985931,
        "Lon": 86.43552,
        "Speed": 27.0,
        "Height": 290,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27227796,
        "Time": "2022-02-23T16:01:00",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1636734,
        "Lon": 86.45524,
        "Speed": 30.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27229203,
        "Time": "2022-02-23T16:11:35",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14122,
        "Lon": 86.488266,
        "Speed": 0.0,
        "Height": 299,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27231306,
        "Time": "2022-02-23T16:28:05",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14122,
        "Lon": 86.488266,
        "Speed": 0.0,
        "Height": 299,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27233315,
        "Time": "2022-02-23T16:44:25",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14122,
        "Lon": 86.488266,
        "Speed": 0.0,
        "Height": 299,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27234734,
        "Time": "2022-02-23T16:54:07",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1127052,
        "Lon": 86.5113449,
        "Speed": 42.0,
        "Height": 275,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27236326,
        "Time": "2022-02-23T17:06:46",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1123543,
        "Lon": 86.497345,
        "Speed": 0.0,
        "Height": 184,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27237440,
        "Time": "2022-02-23T17:18:01",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1123543,
        "Lon": 86.497345,
        "Speed": 0.0,
        "Height": 184,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27238620,
        "Time": "2022-02-23T17:30:10",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1123543,
        "Lon": 86.497345,
        "Speed": 0.0,
        "Height": 184,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27240464,
        "Time": "2022-02-23T17:44:52",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1123543,
        "Lon": 86.497345,
        "Speed": 0.0,
        "Height": 184,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27241725,
        "Time": "2022-02-23T17:54:16",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1175957,
        "Lon": 86.4970245,
        "Speed": 33.0,
        "Height": 57,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27242907,
        "Time": "2022-02-23T18:03:38",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12032,
        "Lon": 86.49248,
        "Speed": 23.0,
        "Height": 56,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27243918,
        "Time": "2022-02-23T18:11:52",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1138458,
        "Lon": 86.50073,
        "Speed": 10.0,
        "Height": 84,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27244943,
        "Time": "2022-02-23T18:19:40",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.11517,
        "Lon": 86.50171,
        "Speed": 5.0,
        "Height": 71,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27245846,
        "Time": "2022-02-23T18:27:21",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1109772,
        "Lon": 86.50777,
        "Speed": 49.0,
        "Height": 256,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27247305,
        "Time": "2022-02-23T18:38:50",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1486969,
        "Lon": 86.47712,
        "Speed": 61.0,
        "Height": 287,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27248955,
        "Time": "2022-02-23T18:50:58",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1773338,
        "Lon": 86.44816,
        "Speed": 60.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27250299,
        "Time": "2022-02-23T19:00:20",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.2061539,
        "Lon": 86.42793,
        "Speed": 16.0,
        "Height": 145,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27252241,
        "Time": "2022-02-23T19:14:26",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.2067451,
        "Lon": 86.42769,
        "Speed": 0.0,
        "Height": 144,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27254387,
        "Time": "2022-02-23T19:30:46",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.2067451,
        "Lon": 86.42769,
        "Speed": 0.0,
        "Height": 144,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27255923,
        "Time": "2022-02-23T19:42:35",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.2105064,
        "Lon": 86.40885,
        "Speed": 30.0,
        "Height": 179,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27257407,
        "Time": "2022-02-23T19:53:09",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16373,
        "Lon": 86.45547,
        "Speed": 24.0,
        "Height": 308,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27258360,
        "Time": "2022-02-23T19:59:19",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1592941,
        "Lon": 86.43486,
        "Speed": 22.0,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27260134,
        "Time": "2022-02-23T20:13:40",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1589432,
        "Lon": 86.43408,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27262597,
        "Time": "2022-02-23T20:30:20",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1589432,
        "Lon": 86.43408,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27264872,
        "Time": "2022-02-23T20:47:00",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1589432,
        "Lon": 86.43408,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27266786,
        "Time": "2022-02-23T21:03:40",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1589432,
        "Lon": 86.43408,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27268286,
        "Time": "2022-02-23T21:14:48",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27270551,
        "Time": "2022-02-23T21:31:28",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27272854,
        "Time": "2022-02-23T21:48:08",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27275242,
        "Time": "2022-02-23T22:04:47",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27277497,
        "Time": "2022-02-23T22:21:27",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27280030,
        "Time": "2022-02-23T22:38:07",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27282492,
        "Time": "2022-02-23T22:54:47",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27284974,
        "Time": "2022-02-23T23:11:27",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27287331,
        "Time": "2022-02-23T23:28:07",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27289731,
        "Time": "2022-02-23T23:44:47",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27292148,
        "Time": "2022-02-24T00:01:27",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27294493,
        "Time": "2022-02-24T00:18:06",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27296357,
        "Time": "2022-02-24T00:34:46",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27297584,
        "Time": "2022-02-24T00:51:26",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27299404,
        "Time": "2022-02-24T01:08:06",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27301385,
        "Time": "2022-02-24T01:24:46",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.16081,
        "Lon": 86.43555,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27303368,
        "Time": "2022-02-24T01:38:28",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1600266,
        "Lon": 86.43418,
        "Speed": 0.0,
        "Height": 329,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27304644,
        "Time": "2022-02-24T01:46:32",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1640472,
        "Lon": 86.43398,
        "Speed": 0.0,
        "Height": 325,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27307086,
        "Time": "2022-02-24T02:03:02",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1640472,
        "Lon": 86.43398,
        "Speed": 0.0,
        "Height": 325,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27308391,
        "Time": "2022-02-24T02:10:59",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1427345,
        "Lon": 86.4416351,
        "Speed": 42.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27310155,
        "Time": "2022-02-24T02:22:45",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14327,
        "Lon": 86.49948,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27312592,
        "Time": "2022-02-24T02:39:15",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.14327,
        "Lon": 86.49948,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27314612,
        "Time": "2022-02-24T02:54:01",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1418533,
        "Lon": 86.49552,
        "Speed": 0.0,
        "Height": 289,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27317033,
        "Time": "2022-02-24T03:10:41",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1418533,
        "Lon": 86.49552,
        "Speed": 0.0,
        "Height": 289,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27318671,
        "Time": "2022-02-24T03:22:36",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.13741,
        "Lon": 86.47757,
        "Speed": 42.0,
        "Height": 304,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27320645,
        "Time": "2022-02-24T03:36:02",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.12986,
        "Lon": 86.48814,
        "Speed": 28.0,
        "Height": 172,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27321894,
        "Time": "2022-02-24T03:44:18",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1309967,
        "Lon": 86.48779,
        "Speed": 27.0,
        "Height": 181,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27324036,
        "Time": "2022-02-24T03:56:58",
        "TruckId": null,
        "Imei": "865905020920397",
        "Lat": 54.1247635,
        "Lon": 86.48449,
        "Speed": 0.0,
        "Height": 115,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27004152,
        "Time": "2022-02-22T10:53:37",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.24779,
        "Lon": 86.14219,
        "Speed": 21.8,
        "Height": 361,
        "Mileage": 12130152,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 91,
        "EngineRPM": 1805.625,
        "OnboardVoltage": 27624,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 34,
        "FuelConsumption": 196,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34381,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.0
    },
    {
        "Id": 27007239,
        "Time": "2022-02-22T11:15:52",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.28352,
        "Lon": 86.13781,
        "Speed": 11.1,
        "Height": 288,
        "Mileage": 12136029,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 777.625,
        "OnboardVoltage": 27562,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.600002
    },
    {
        "Id": 27009776,
        "Time": "2022-02-22T11:35:32",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2482719,
        "Lon": 86.1567154,
        "Speed": 28.7,
        "Height": 331,
        "Mileage": 12142875,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 90,
        "EngineRPM": 1305.375,
        "OnboardVoltage": 27519,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 63,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.8
    },
    {
        "Id": 27011698,
        "Time": "2022-02-22T11:49:35",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.26849,
        "Lon": 86.16743,
        "Speed": 35.9,
        "Height": 106,
        "Mileage": 12147192,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 90,
        "EngineRPM": 1299.5,
        "OnboardVoltage": 27862,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 60,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27013445,
        "Time": "2022-02-22T12:04:04",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.277668,
        "Lon": 86.18943,
        "Speed": 26.6,
        "Height": 254,
        "Mileage": 12152667,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 88,
        "EngineRPM": 733.25,
        "OnboardVoltage": 27653,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27018261,
        "Time": "2022-02-22T12:50:29",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2683029,
        "Lon": 86.1747055,
        "Speed": 28.5,
        "Height": 47,
        "Mileage": 12156829,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 93,
        "EngineRPM": 1291.625,
        "OnboardVoltage": 27565,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34383,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.4
    },
    {
        "Id": 27020020,
        "Time": "2022-02-22T13:04:35",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2599373,
        "Lon": 86.15696,
        "Speed": 32.2,
        "Height": 308,
        "Mileage": 12162206,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 93,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27537,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 27,
        "FuelConsumption": 169,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34383,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27023722,
        "Time": "2022-02-22T13:40:18",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.24726,
        "Lon": 86.14537,
        "Speed": 22.0,
        "Height": 356,
        "Mileage": 12170876,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 92,
        "EngineRPM": 1667.75,
        "OnboardVoltage": 27405,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 32,
        "FuelConsumption": 210,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34384,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27027342,
        "Time": "2022-02-22T14:08:29",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2838745,
        "Lon": 86.13742,
        "Speed": 4.2,
        "Height": 289,
        "Mileage": 12177116,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 94,
        "EngineRPM": 986.5,
        "OnboardVoltage": 27726,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34384,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27030282,
        "Time": "2022-02-22T14:28:45",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2465439,
        "Lon": 86.14686,
        "Speed": 37.0,
        "Height": 355,
        "Mileage": 12183392,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 92,
        "EngineRPM": 906.75,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 36,
        "FuelConsumption": 142,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34385,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 28.800001
    },
    {
        "Id": 27034083,
        "Time": "2022-02-22T14:57:54",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.256,
        "Lon": 86.1607,
        "Speed": 42.9,
        "Height": 292,
        "Mileage": 12192484,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 90,
        "EngineRPM": 933.625,
        "OnboardVoltage": 27490,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 53,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34385,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 26.800001
    },
    {
        "Id": 27036528,
        "Time": "2022-02-22T15:15:14",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2774239,
        "Lon": 86.14502,
        "Speed": 26.8,
        "Height": 277,
        "Mileage": 12199496,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 91,
        "EngineRPM": 1809.0,
        "OnboardVoltage": 27554,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 34,
        "FuelConsumption": 187,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34386,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 21.6
    },
    {
        "Id": 27039884,
        "Time": "2022-02-22T15:40:33",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.24809,
        "Lon": 86.1409454,
        "Speed": 4.4,
        "Height": 366,
        "Mileage": 12206303,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 92,
        "EngineRPM": 752.375,
        "OnboardVoltage": 27444,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34386,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 21.2
    },
    {
        "Id": 27043916,
        "Time": "2022-02-22T16:14:56",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2662125,
        "Lon": 86.1563,
        "Speed": 21.1,
        "Height": 280,
        "Mileage": 12214574,
        "EngineOilPressure": 476,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 92,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 46,
        "FuelConsumption": 231,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34387,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 17.2
    },
    {
        "Id": 27046457,
        "Time": "2022-02-22T16:33:03",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2554,
        "Lon": 86.17273,
        "Speed": 27.2,
        "Height": 281,
        "Mileage": 12220752,
        "EngineOilPressure": 264,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 93,
        "EngineRPM": 974.125,
        "OnboardVoltage": 27514,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 82,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34387,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 19.6
    },
    {
        "Id": 27051405,
        "Time": "2022-02-22T17:11:28",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2838173,
        "Lon": 86.13731,
        "Speed": 5.1,
        "Height": 292,
        "Mileage": 12225665,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 62,
        "EngineRPM": 822.25,
        "OnboardVoltage": 27718,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 73,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34388,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27053839,
        "Time": "2022-02-22T17:33:56",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2480164,
        "Lon": 86.14076,
        "Speed": 5.5,
        "Height": 365,
        "Mileage": 12231559,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 60,
        "EngineRPM": 1528.375,
        "OnboardVoltage": 27575,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 198,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34388,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27057183,
        "Time": "2022-02-22T18:04:58",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.27868,
        "Lon": 86.14341,
        "Speed": 29.4,
        "Height": 281,
        "Mileage": 12238117,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 64,
        "EngineRPM": 1192.75,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 67,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34388,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27059460,
        "Time": "2022-02-22T18:25:26",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2556572,
        "Lon": 86.1615,
        "Speed": 36.4,
        "Height": 285,
        "Mileage": 12245305,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 62,
        "EngineRPM": 1290.25,
        "OnboardVoltage": 27658,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 63,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34389,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.8
    },
    {
        "Id": 27064197,
        "Time": "2022-02-22T19:01:08",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.24663,
        "Lon": 86.14749,
        "Speed": 28.8,
        "Height": 353,
        "Mileage": 12254383,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 66,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27386,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34389,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27068274,
        "Time": "2022-02-22T19:31:48",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.28403,
        "Lon": 86.13752,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": 12260775,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 742.5,
        "OnboardVoltage": 27648,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34390,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.8
    },
    {
        "Id": 27071202,
        "Time": "2022-02-22T19:52:14",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.24864,
        "Lon": 86.1574,
        "Speed": 30.0,
        "Height": 331,
        "Mileage": 12267793,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 78,
        "EngineRPM": 792.625,
        "OnboardVoltage": 27767,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34390,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27076467,
        "Time": "2022-02-22T20:29:03",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2656555,
        "Lon": 86.1565552,
        "Speed": 38.5,
        "Height": 284,
        "Mileage": 12275774,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 78,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27409,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 71,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34391,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27079538,
        "Time": "2022-02-22T20:51:30",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.30136,
        "Lon": 86.13992,
        "Speed": 7.2,
        "Height": 16,
        "Mileage": 12282382,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 83,
        "EngineRPM": 830.625,
        "OnboardVoltage": 27640,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34391,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27081564,
        "Time": "2022-02-22T21:05:22",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3103752,
        "Lon": 86.13314,
        "Speed": 9.6,
        "Height": 182,
        "Mileage": 12284927,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1812.875,
        "OnboardVoltage": 27502,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 381,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34391,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27084254,
        "Time": "2022-02-22T21:26:40",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3125725,
        "Lon": 86.153,
        "Speed": 38.1,
        "Height": 297,
        "Mileage": 12289972,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 85,
        "EngineRPM": 1294.5,
        "OnboardVoltage": 27287,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 70,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34392,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27085666,
        "Time": "2022-02-22T21:37:01",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3059845,
        "Lon": 86.13536,
        "Speed": 15.9,
        "Height": 144,
        "Mileage": 12292964,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 87,
        "EngineRPM": 1302.75,
        "OnboardVoltage": 27614,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 60,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34392,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27088413,
        "Time": "2022-02-22T21:57:55",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3092575,
        "Lon": 86.17283,
        "Speed": 0.0,
        "Height": 436,
        "Mileage": 12296951,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 88,
        "EngineRPM": 772.5,
        "OnboardVoltage": 27473,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 45,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34392,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27092463,
        "Time": "2022-02-22T22:28:08",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.30729,
        "Lon": 86.13812,
        "Speed": 4.0,
        "Height": 170,
        "Mileage": 12301296,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 706.875,
        "OnboardVoltage": 27666,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 67,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34393,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27094656,
        "Time": "2022-02-22T22:46:12",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.30744,
        "Lon": 86.17121,
        "Speed": 11.2,
        "Height": 425,
        "Mileage": 12305381,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 87,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27376,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34393,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27096403,
        "Time": "2022-02-22T22:59:04",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3078423,
        "Lon": 86.13554,
        "Speed": 23.5,
        "Height": 151,
        "Mileage": 12309816,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 91,
        "EngineRPM": 1837.375,
        "OnboardVoltage": 27523,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 300,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34393,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27098195,
        "Time": "2022-02-22T23:13:25",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.310997,
        "Lon": 86.13741,
        "Speed": 17.2,
        "Height": 209,
        "Mileage": 12311484,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27413,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 96,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34394,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27100558,
        "Time": "2022-02-22T23:30:44",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.30705,
        "Lon": 86.1655,
        "Speed": 35.7,
        "Height": 390,
        "Mileage": 12315227,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 93,
        "EngineRPM": 1296.5,
        "OnboardVoltage": 27299,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 61,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34394,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27102178,
        "Time": "2022-02-22T23:42:53",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3072929,
        "Lon": 86.13785,
        "Speed": 4.0,
        "Height": 157,
        "Mileage": 12319078,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 93,
        "EngineRPM": 763.875,
        "OnboardVoltage": 27506,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 8,
        "FuelConsumption": 37,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34394,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27103784,
        "Time": "2022-02-22T23:55:07",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3071976,
        "Lon": 86.13507,
        "Speed": 20.7,
        "Height": 146,
        "Mileage": 12322113,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 93,
        "EngineRPM": 703.375,
        "OnboardVoltage": 27539,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34394,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27105922,
        "Time": "2022-02-23T00:13:38",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3100624,
        "Lon": 86.1545,
        "Speed": 9.2,
        "Height": 318,
        "Mileage": 12325418,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 92,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27306,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 96,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34395,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27108070,
        "Time": "2022-02-23T00:29:03",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.282692,
        "Lon": 86.1786346,
        "Speed": 14.6,
        "Height": 268,
        "Mileage": 12330376,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 96,
        "EngineRPM": 1150.125,
        "OnboardVoltage": 27532,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 164,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34395,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27109638,
        "Time": "2022-02-23T00:50:58",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.31272,
        "Lon": 86.13936,
        "Speed": 37.4,
        "Height": 225,
        "Mileage": 12335969,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 94,
        "EngineRPM": 1310.625,
        "OnboardVoltage": 27332,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 60,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34395,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27113077,
        "Time": "2022-02-23T01:19:28",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3012962,
        "Lon": 86.1394958,
        "Speed": 0.0,
        "Height": 34,
        "Mileage": 12339132,
        "EngineOilPressure": 264,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 93,
        "EngineRPM": 835.0,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 63,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27116874,
        "Time": "2022-02-23T01:49:13",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2961655,
        "Lon": 86.1453247,
        "Speed": 5.5,
        "Height": -42,
        "Mileage": 12341167,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 90,
        "EngineRPM": 828.875,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27119400,
        "Time": "2022-02-23T02:07:31",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.27307,
        "Lon": 86.163826,
        "Speed": 4.6,
        "Height": 40,
        "Mileage": 12345950,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 90,
        "EngineRPM": 712.75,
        "OnboardVoltage": 27594,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27121560,
        "Time": "2022-02-23T02:22:40",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2715836,
        "Lon": 86.1665,
        "Speed": 22.0,
        "Height": 47,
        "Mileage": 12351331,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 1805.25,
        "OnboardVoltage": 27440,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 37,
        "FuelConsumption": 208,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34397,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.0
    },
    {
        "Id": 27129471,
        "Time": "2022-02-23T03:19:32",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.26413,
        "Lon": 86.1723251,
        "Speed": 15.1,
        "Height": 148,
        "Mileage": 12353174,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 90,
        "EngineRPM": 1801.25,
        "OnboardVoltage": 27624,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 91,
        "FuelConsumption": 290,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34398,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27132568,
        "Time": "2022-02-23T03:41:20",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2841263,
        "Lon": 86.138504,
        "Speed": 4.2,
        "Height": 288,
        "Mileage": 12359762,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 96,
        "EngineRPM": 1274.375,
        "OnboardVoltage": 27507,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 60,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34398,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.4
    },
    {
        "Id": 27134924,
        "Time": "2022-02-23T03:58:02",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2684135,
        "Lon": 86.16701,
        "Speed": 30.1,
        "Height": 102,
        "Mileage": 12366897,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 93,
        "EngineRPM": 1292.125,
        "OnboardVoltage": 27528,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 6,
        "FuelConsumption": 57,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34398,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.4
    },
    {
        "Id": 27138564,
        "Time": "2022-02-23T04:20:28",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2687836,
        "Lon": 86.15498,
        "Speed": 30.1,
        "Height": 276,
        "Mileage": 12372395,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 93,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27452,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 60,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34399,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27141710,
        "Time": "2022-02-23T04:41:12",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2637,
        "Lon": 86.17322,
        "Speed": 35.3,
        "Height": 158,
        "Mileage": 12381004,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27513,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 63,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34399,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27143988,
        "Time": "2022-02-23T04:57:21",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2773438,
        "Lon": 86.1845245,
        "Speed": 23.5,
        "Height": 259,
        "Mileage": 12386901,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 92,
        "EngineRPM": 828.625,
        "OnboardVoltage": 27591,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 60,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34399,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27154821,
        "Time": "2022-02-23T06:29:31",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.266716,
        "Lon": 86.18696,
        "Speed": 19.4,
        "Height": 200,
        "Mileage": 12389331,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 82,
        "EngineRPM": 1289.25,
        "OnboardVoltage": 27957,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 8,
        "FuelConsumption": 64,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.8
    },
    {
        "Id": 27155991,
        "Time": "2022-02-23T06:39:09",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2698135,
        "Lon": 86.16474,
        "Speed": 9.8,
        "Height": 100,
        "Mileage": 12393520,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 82,
        "EngineRPM": 781.125,
        "OnboardVoltage": 27762,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27158733,
        "Time": "2022-02-23T06:59:20",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2628555,
        "Lon": 86.1556854,
        "Speed": 31.1,
        "Height": 303,
        "Mileage": 12398104,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 82,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27538,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 31,
        "FuelConsumption": 174,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.0
    },
    {
        "Id": 27162253,
        "Time": "2022-02-23T07:22:32",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2620964,
        "Lon": 86.17201,
        "Speed": 19.6,
        "Height": 224,
        "Mileage": 12406418,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 87,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27627,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 63,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.8
    },
    {
        "Id": 27165129,
        "Time": "2022-02-23T07:42:42",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2621269,
        "Lon": 86.1718,
        "Speed": 17.2,
        "Height": 224,
        "Mileage": 12410397,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 88,
        "EngineRPM": 1801.25,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 82,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27168358,
        "Time": "2022-02-23T08:08:00",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2599373,
        "Lon": 86.15672,
        "Speed": 29.6,
        "Height": 298,
        "Mileage": 12418960,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 91,
        "EngineRPM": 1589.0,
        "OnboardVoltage": 27621,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 17,
        "FuelConsumption": 96,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27171198,
        "Time": "2022-02-23T08:30:08",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2682953,
        "Lon": 86.167366,
        "Speed": 6.8,
        "Height": 103,
        "Mileage": 12423530,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 88,
        "EngineRPM": 728.0,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 45,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.4
    },
    {
        "Id": 27173982,
        "Time": "2022-02-23T08:51:28",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2835274,
        "Lon": 86.13812,
        "Speed": 14.6,
        "Height": 286,
        "Mileage": 12430505,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 90,
        "EngineRPM": 1644.5,
        "OnboardVoltage": 27649,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 49,
        "FuelConsumption": 288,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.6
    },
    {
        "Id": 27175913,
        "Time": "2022-02-23T09:08:02",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2566338,
        "Lon": 86.17256,
        "Speed": 4.0,
        "Height": 278,
        "Mileage": 12435428,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 767.5,
        "OnboardVoltage": 27707,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.6
    },
    {
        "Id": 27184385,
        "Time": "2022-02-23T10:13:23",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.26917,
        "Lon": 86.16545,
        "Speed": 0.0,
        "Height": 95,
        "Mileage": 12438347,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 64,
        "EngineRPM": 1123.75,
        "OnboardVoltage": 27776,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 57,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27187751,
        "Time": "2022-02-23T10:40:18",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2557831,
        "Lon": 86.16789,
        "Speed": 32.7,
        "Height": 284,
        "Mileage": 12441760,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 58,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27436,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 40,
        "FuelConsumption": 205,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34371,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27190842,
        "Time": "2022-02-23T11:02:48",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2568474,
        "Lon": 86.17532,
        "Speed": 31.6,
        "Height": 269,
        "Mileage": 12450702,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 67,
        "EngineRPM": 1297.625,
        "OnboardVoltage": 27650,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 56,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34371,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27193910,
        "Time": "2022-02-23T11:25:45",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2595,
        "Lon": 86.17616,
        "Speed": 11.1,
        "Height": 192,
        "Mileage": 12454868,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 69,
        "EngineRPM": 1813.0,
        "OnboardVoltage": 27731,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 92,
        "FuelConsumption": 374,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27197273,
        "Time": "2022-02-23T11:51:09",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.25669,
        "Lon": 86.159584,
        "Speed": 39.6,
        "Height": 296,
        "Mileage": 12464299,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 68,
        "EngineRPM": 880.75,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 61,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27200585,
        "Time": "2022-02-23T12:21:50",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2594337,
        "Lon": 86.1764,
        "Speed": 16.8,
        "Height": 189,
        "Mileage": 12469395,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 81,
        "EngineRPM": 1570.625,
        "OnboardVoltage": 27504,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 55,
        "FuelConsumption": 238,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27203886,
        "Time": "2022-02-23T12:57:51",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.27976,
        "Lon": 86.14644,
        "Speed": 18.7,
        "Height": 224,
        "Mileage": 12474787,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 81,
        "EngineRPM": 710.0,
        "OnboardVoltage": 27539,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 43,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27209235,
        "Time": "2022-02-23T13:42:39",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2477,
        "Lon": 86.14137,
        "Speed": 14.6,
        "Height": 361,
        "Mileage": 12480383,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 85,
        "EngineRPM": 977.125,
        "OnboardVoltage": 27461,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 167,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34374,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27219793,
        "Time": "2022-02-23T15:03:14",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2564125,
        "Lon": 86.17111,
        "Speed": 0.0,
        "Height": 279,
        "Mileage": 12483360,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 87,
        "EngineRPM": 1129.25,
        "OnboardVoltage": 27833,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 61,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34375,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27236860,
        "Time": "2022-02-23T17:12:13",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2555656,
        "Lon": 86.1739044,
        "Speed": 24.4,
        "Height": 277,
        "Mileage": 12483703,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 90,
        "EngineRPM": 1499.625,
        "OnboardVoltage": 28043,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 60,
        "FuelConsumption": 239,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27237704,
        "Time": "2022-02-23T17:20:56",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2697525,
        "Lon": 86.17707,
        "Speed": 9.4,
        "Height": 64,
        "Mileage": 12487969,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 87,
        "EngineRPM": 1819.875,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 54,
        "FuelConsumption": 364,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27241205,
        "Time": "2022-02-23T17:50:47",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2594681,
        "Lon": 86.1766357,
        "Speed": 14.6,
        "Height": 189,
        "Mileage": 12491231,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 90,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27686,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27248019,
        "Time": "2022-02-23T18:41:48",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.24101,
        "Lon": 86.14529,
        "Speed": 19.4,
        "Height": 323,
        "Mileage": 12495402,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 88,
        "EngineRPM": 1301.625,
        "OnboardVoltage": 27528,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 71,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34379,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27249352,
        "Time": "2022-02-23T18:54:04",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2636566,
        "Lon": 86.1732559,
        "Speed": 36.8,
        "Height": 151,
        "Mileage": 12500759,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1296.375,
        "OnboardVoltage": 27423,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 68,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34379,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27252532,
        "Time": "2022-02-23T19:17:08",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2726135,
        "Lon": 86.17783,
        "Speed": 21.1,
        "Height": 100,
        "Mileage": 12503918,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27569,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 92,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34380,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27255634,
        "Time": "2022-02-23T19:40:15",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.30789,
        "Lon": 86.1712646,
        "Speed": 12.7,
        "Height": 422,
        "Mileage": 12510832,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 91,
        "EngineRPM": 1559.875,
        "OnboardVoltage": 27310,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 41,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34380,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27259969,
        "Time": "2022-02-23T20:12:08",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2784157,
        "Lon": 86.19029,
        "Speed": 0.0,
        "Height": 256,
        "Mileage": 12515718,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 753.875,
        "OnboardVoltage": 27772,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34380,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27276328,
        "Time": "2022-02-23T22:12:57",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.27437,
        "Lon": 86.17897,
        "Speed": 37.0,
        "Height": 122,
        "Mileage": 12518440,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 85,
        "EngineRPM": 1306.75,
        "OnboardVoltage": 27746,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 69,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27277649,
        "Time": "2022-02-23T22:22:20",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2693138,
        "Lon": 86.16459,
        "Speed": 11.6,
        "Height": 99,
        "Mileage": 12521652,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 87,
        "EngineRPM": 1121.375,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 112,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34383,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27282507,
        "Time": "2022-02-23T22:55:00",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2561569,
        "Lon": 86.16417,
        "Speed": 25.1,
        "Height": 286,
        "Mileage": 12525304,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 88,
        "EngineRPM": 771.5,
        "OnboardVoltage": 27455,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 47,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34383,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27284724,
        "Time": "2022-02-23T23:10:19",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2559128,
        "Lon": 86.17513,
        "Speed": 34.0,
        "Height": 276,
        "Mileage": 12530967,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 88,
        "EngineRPM": 912.25,
        "OnboardVoltage": 27415,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34383,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27287987,
        "Time": "2022-02-23T23:32:44",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.27118,
        "Lon": 86.1704941,
        "Speed": 5.3,
        "Height": 16,
        "Mileage": 12534841,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 90,
        "EngineRPM": 818.25,
        "OnboardVoltage": 27790,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34384,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27290411,
        "Time": "2022-02-23T23:49:11",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2817879,
        "Lon": 86.17983,
        "Speed": 26.4,
        "Height": 272,
        "Mileage": 12539808,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 91,
        "EngineRPM": 1815.625,
        "OnboardVoltage": 27332,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 42,
        "FuelConsumption": 208,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34384,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27294085,
        "Time": "2022-02-24T00:15:01",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3066864,
        "Lon": 86.16984,
        "Speed": 17.7,
        "Height": 410,
        "Mileage": 12543850,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 94,
        "EngineRPM": 1256.75,
        "OnboardVoltage": 27729,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 48,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34384,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27297153,
        "Time": "2022-02-24T00:46:53",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2723274,
        "Lon": 86.17799,
        "Speed": 23.1,
        "Height": 107,
        "Mileage": 12550616,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 90,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27774,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 28,
        "FuelConsumption": 170,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34385,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.0
    },
    {
        "Id": 27301611,
        "Time": "2022-02-24T01:26:25",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2709923,
        "Lon": 86.17062,
        "Speed": 0.0,
        "Height": 17,
        "Mileage": 12552275,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 89,
        "EngineRPM": 1120.375,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 9,
        "FuelConsumption": 64,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34386,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27304123,
        "Time": "2022-02-24T01:43:11",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.27508,
        "Lon": 86.18377,
        "Speed": 32.7,
        "Height": 259,
        "Mileage": 12556521,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 91,
        "EngineRPM": 1801.875,
        "OnboardVoltage": 27428,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 75,
        "FuelConsumption": 312,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34386,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.4
    },
    {
        "Id": 27306577,
        "Time": "2022-02-24T02:00:07",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.30702,
        "Lon": 86.16511,
        "Speed": 28.8,
        "Height": 394,
        "Mileage": 12561690,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 95,
        "EngineRPM": 1297.625,
        "OnboardVoltage": 27550,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 65,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34386,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 35.2
    },
    {
        "Id": 27308861,
        "Time": "2022-02-24T02:13:19",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3072929,
        "Lon": 86.1387939,
        "Speed": 6.6,
        "Height": 162,
        "Mileage": 12565371,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 93,
        "EngineRPM": 712.875,
        "OnboardVoltage": 27529,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34386,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.600002
    },
    {
        "Id": 27311611,
        "Time": "2022-02-24T02:32:51",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.30904,
        "Lon": 86.1591949,
        "Speed": 10.1,
        "Height": 352,
        "Mileage": 12568676,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 93,
        "EngineRPM": 1809.0,
        "OnboardVoltage": 27237,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 96,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34387,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27313632,
        "Time": "2022-02-24T02:47:15",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.3132172,
        "Lon": 86.14636,
        "Speed": 12.0,
        "Height": 277,
        "Mileage": 12572349,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 94,
        "EngineRPM": 733.25,
        "OnboardVoltage": 27667,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 40,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34387,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27316040,
        "Time": "2022-02-24T03:03:34",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2991676,
        "Lon": 86.13761,
        "Speed": 5.1,
        "Height": 14,
        "Mileage": 12576276,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 92,
        "EngineRPM": 1236.875,
        "OnboardVoltage": 27861,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 66,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34387,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27318772,
        "Time": "2022-02-24T03:23:26",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.28145,
        "Lon": 86.16605,
        "Speed": 16.4,
        "Height": 30,
        "Mileage": 12581455,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 91,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27533,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 383,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34388,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 29.6
    },
    {
        "Id": 27321488,
        "Time": "2022-02-24T03:41:40",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2620659,
        "Lon": 86.1717,
        "Speed": 16.8,
        "Height": 224,
        "Mileage": 12586775,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 94,
        "EngineRPM": 1806.25,
        "OnboardVoltage": 27478,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 76,
        "FuelConsumption": 323,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34388,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 26.800001
    },
    {
        "Id": 27324100,
        "Time": "2022-02-24T03:57:28",
        "TruckId": 611,
        "Imei": "866557055991295",
        "Lat": 54.2477226,
        "Lon": 86.15533,
        "Speed": 38.5,
        "Height": 333,
        "Mileage": 12592068,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 95,
        "EngineRPM": 1099.125,
        "OnboardVoltage": 27638,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 69,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 34388,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 24.4
    },
    {
        "Id": 27004169,
        "Time": "2022-02-22T10:53:42",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2563667,
        "Lon": 86.1721954,
        "Speed": 5.3,
        "Height": 267,
        "Mileage": 21810948,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27007516,
        "Time": "2022-02-22T11:13:48",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2690659,
        "Lon": 86.1749039,
        "Speed": 18.5,
        "Height": 52,
        "Mileage": 21815250,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27880,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27010033,
        "Time": "2022-02-22T11:37:15",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2612,
        "Lon": 86.17553,
        "Speed": 16.2,
        "Height": 176,
        "Mileage": 21818416,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27868,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27012373,
        "Time": "2022-02-22T11:55:21",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.24242,
        "Lon": 86.14154,
        "Speed": 5.1,
        "Height": 330,
        "Mileage": 21823124,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27829,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27016193,
        "Time": "2022-02-22T12:27:58",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.25665,
        "Lon": 86.17135,
        "Speed": 17.9,
        "Height": 280,
        "Mileage": 21828662,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27953,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27020436,
        "Time": "2022-02-22T13:08:28",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.26813,
        "Lon": 86.17232,
        "Speed": 26.4,
        "Height": 27,
        "Mileage": 21832762,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27703,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27026802,
        "Time": "2022-02-22T14:04:28",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.26949,
        "Lon": 86.17769,
        "Speed": 17.2,
        "Height": 61,
        "Mileage": 21833664,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27649,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27029518,
        "Time": "2022-02-22T14:23:41",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2962456,
        "Lon": 86.17517,
        "Speed": 15.9,
        "Height": 326,
        "Mileage": 21839582,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27821,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27031677,
        "Time": "2022-02-22T14:39:16",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30589,
        "Lon": 86.1348,
        "Speed": 17.4,
        "Height": 142,
        "Mileage": 21845126,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27821,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27035843,
        "Time": "2022-02-22T15:10:33",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.31356,
        "Lon": 86.14991,
        "Speed": 18.3,
        "Height": 266,
        "Mileage": 21847846,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27919,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27037990,
        "Time": "2022-02-22T15:25:18",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3137436,
        "Lon": 86.14998,
        "Speed": 36.4,
        "Height": 273,
        "Mileage": 21851978,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27553,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27041581,
        "Time": "2022-02-22T15:55:25",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30619,
        "Lon": 86.13474,
        "Speed": 11.1,
        "Height": 144,
        "Mileage": 21854838,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27852,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27043949,
        "Time": "2022-02-22T16:15:06",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3069344,
        "Lon": 86.16986,
        "Speed": 26.8,
        "Height": 411,
        "Mileage": 21859056,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27838,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27047063,
        "Time": "2022-02-22T16:38:10",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3071938,
        "Lon": 86.13789,
        "Speed": 0.0,
        "Height": 151,
        "Mileage": 21863148,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27900,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27049660,
        "Time": "2022-02-22T16:58:22",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3068542,
        "Lon": 86.16949,
        "Speed": 16.2,
        "Height": 402,
        "Mileage": 21867124,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27991,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27052989,
        "Time": "2022-02-22T17:26:24",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3128471,
        "Lon": 86.1471,
        "Speed": 0.0,
        "Height": 263,
        "Mileage": 21869908,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27055964,
        "Time": "2022-02-22T17:53:45",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3071938,
        "Lon": 86.138,
        "Speed": 0.0,
        "Height": 160,
        "Mileage": 21872338,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27927,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27058127,
        "Time": "2022-02-22T18:13:06",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30797,
        "Lon": 86.17143,
        "Speed": 10.3,
        "Height": 423,
        "Mileage": 21876548,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27854,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27061455,
        "Time": "2022-02-22T18:42:26",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.31331,
        "Lon": 86.14599,
        "Speed": 5.0,
        "Height": 267,
        "Mileage": 21879350,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27663,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27066176,
        "Time": "2022-02-22T19:16:09",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3069649,
        "Lon": 86.13854,
        "Speed": 0.0,
        "Height": 150,
        "Mileage": 21881796,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27954,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27070086,
        "Time": "2022-02-22T19:45:37",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3110542,
        "Lon": 86.13761,
        "Speed": 16.1,
        "Height": 205,
        "Mileage": 21883524,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27792,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27072620,
        "Time": "2022-02-22T20:02:31",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30683,
        "Lon": 86.16433,
        "Speed": 24.2,
        "Height": 389,
        "Mileage": 21887360,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27074570,
        "Time": "2022-02-22T20:15:17",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30601,
        "Lon": 86.13549,
        "Speed": 8.8,
        "Height": 132,
        "Mileage": 21891428,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27676,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27077350,
        "Time": "2022-02-22T20:34:57",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3084946,
        "Lon": 86.17191,
        "Speed": 18.5,
        "Height": 432,
        "Mileage": 21895518,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27830,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27080971,
        "Time": "2022-02-22T21:01:08",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30731,
        "Lon": 86.13797,
        "Speed": 8.7,
        "Height": 154,
        "Mileage": 21899736,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27765,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27084771,
        "Time": "2022-02-22T21:31:07",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3107224,
        "Lon": 86.1534348,
        "Speed": 13.5,
        "Height": 307,
        "Mileage": 21902596,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27779,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27086699,
        "Time": "2022-02-22T21:45:23",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3138657,
        "Lon": 86.1471558,
        "Speed": 30.0,
        "Height": 255,
        "Mileage": 21906526,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27570,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27088883,
        "Time": "2022-02-22T22:00:49",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3101921,
        "Lon": 86.1326752,
        "Speed": 14.4,
        "Height": 181,
        "Mileage": 21909652,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27091249,
        "Time": "2022-02-22T22:18:15",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3073654,
        "Lon": 86.17076,
        "Speed": 18.5,
        "Height": 424,
        "Mileage": 21913348,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27094188,
        "Time": "2022-02-22T22:43:22",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3071938,
        "Lon": 86.1381149,
        "Speed": 4.4,
        "Height": 156,
        "Mileage": 21917440,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27741,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27097083,
        "Time": "2022-02-22T23:03:55",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3075142,
        "Lon": 86.17117,
        "Speed": 13.1,
        "Height": 420,
        "Mileage": 21921572,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27933,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27110167,
        "Time": "2022-02-23T00:54:55",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3071861,
        "Lon": 86.17151,
        "Speed": 0.0,
        "Height": 427,
        "Mileage": 21922184,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27886,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27114398,
        "Time": "2022-02-23T01:30:42",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2669334,
        "Lon": 86.18608,
        "Speed": 35.5,
        "Height": 187,
        "Mileage": 21927544,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27785,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27118604,
        "Time": "2022-02-23T02:00:42",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.26985,
        "Lon": 86.16504,
        "Speed": 8.1,
        "Height": 92,
        "Mileage": 21931634,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27760,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27125016,
        "Time": "2022-02-23T02:24:00",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.24138,
        "Lon": 86.14562,
        "Speed": 9.8,
        "Height": 325,
        "Mileage": 21937228,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27807,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27124512,
        "Time": "2022-02-23T02:37:38",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2688179,
        "Lon": 86.16713,
        "Speed": 37.7,
        "Height": 92,
        "Mileage": 21943302,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27126493,
        "Time": "2022-02-23T02:58:43",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2693367,
        "Lon": 86.16999,
        "Speed": 12.2,
        "Height": 31,
        "Mileage": 21945090,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27842,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27130498,
        "Time": "2022-02-23T03:27:14",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2680359,
        "Lon": 86.17102,
        "Speed": 9.4,
        "Height": 33,
        "Mileage": 21947056,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 28010,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27139735,
        "Time": "2022-02-23T04:27:30",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.26801,
        "Lon": 86.17105,
        "Speed": 9.8,
        "Height": 31,
        "Mileage": 21948114,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27946,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27143725,
        "Time": "2022-02-23T04:54:34",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.27128,
        "Lon": 86.1705551,
        "Speed": 9.6,
        "Height": 15,
        "Mileage": 21949644,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27986,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27146803,
        "Time": "2022-02-23T05:25:09",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.27076,
        "Lon": 86.16991,
        "Speed": 9.4,
        "Height": 19,
        "Mileage": 21950894,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27852,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27148620,
        "Time": "2022-02-23T05:43:10",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2713,
        "Lon": 86.17023,
        "Speed": 14.0,
        "Height": 17,
        "Mileage": 21952694,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27963,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27155155,
        "Time": "2022-02-23T06:32:29",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.271183,
        "Lon": 86.1707153,
        "Speed": 12.5,
        "Height": 8,
        "Mileage": 21953776,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27939,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27157268,
        "Time": "2022-02-23T06:47:56",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.27113,
        "Lon": 86.17083,
        "Speed": 7.0,
        "Height": 8,
        "Mileage": 21955424,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27985,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27159300,
        "Time": "2022-02-23T07:03:18",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.27127,
        "Lon": 86.17045,
        "Speed": 10.7,
        "Height": 15,
        "Mileage": 21957066,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 28003,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27162664,
        "Time": "2022-02-23T07:25:35",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2711143,
        "Lon": 86.1708,
        "Speed": 9.2,
        "Height": 12,
        "Mileage": 21958704,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 28021,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27164991,
        "Time": "2022-02-23T07:41:54",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.27111,
        "Lon": 86.17078,
        "Speed": 12.0,
        "Height": 9,
        "Mileage": 21960382,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27971,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27167851,
        "Time": "2022-02-23T08:02:45",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.27018,
        "Lon": 86.17012,
        "Speed": 11.2,
        "Height": 29,
        "Mileage": 21961564,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27902,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27171962,
        "Time": "2022-02-23T08:36:24",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2702522,
        "Lon": 86.17694,
        "Speed": 4.8,
        "Height": 67,
        "Mileage": 21962772,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27883,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27176890,
        "Time": "2022-02-23T09:17:27",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2703857,
        "Lon": 86.17694,
        "Speed": 7.7,
        "Height": 64,
        "Mileage": 21963678,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 28057,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27181010,
        "Time": "2022-02-23T09:48:08",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2694,
        "Lon": 86.17666,
        "Speed": 10.3,
        "Height": 57,
        "Mileage": 21964630,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27955,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27184012,
        "Time": "2022-02-23T10:10:43",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2684135,
        "Lon": 86.1749,
        "Speed": 0.0,
        "Height": 51,
        "Mileage": 21965680,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27837,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27191523,
        "Time": "2022-02-23T11:07:07",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.26953,
        "Lon": 86.1761551,
        "Speed": 0.0,
        "Height": 63,
        "Mileage": 21966744,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27826,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27195440,
        "Time": "2022-02-23T11:36:40",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2736931,
        "Lon": 86.178,
        "Speed": 26.8,
        "Height": 93,
        "Mileage": 21968306,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27973,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27202239,
        "Time": "2022-02-23T12:40:56",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2773476,
        "Lon": 86.18582,
        "Speed": 14.4,
        "Height": 251,
        "Mileage": 21971696,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27798,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27203767,
        "Time": "2022-02-23T12:56:57",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.31085,
        "Lon": 86.13659,
        "Speed": 34.0,
        "Height": 197,
        "Mileage": 21978302,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27579,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27205569,
        "Time": "2022-02-23T13:15:15",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30047,
        "Lon": 86.1408539,
        "Speed": 12.0,
        "Height": 11,
        "Mileage": 21981404,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27676,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27207807,
        "Time": "2022-02-23T13:31:34",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3097725,
        "Lon": 86.158165,
        "Speed": 11.6,
        "Height": 340,
        "Mileage": 21985804,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27669,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27209842,
        "Time": "2022-02-23T13:46:55",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2761726,
        "Lon": 86.18387,
        "Speed": 18.5,
        "Height": 259,
        "Mileage": 21990986,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27906,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27211720,
        "Time": "2022-02-23T14:01:59",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30993,
        "Lon": 86.13248,
        "Speed": 15.5,
        "Height": 177,
        "Mileage": 21997918,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 28003,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27213365,
        "Time": "2022-02-23T14:13:57",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.299984,
        "Lon": 86.14547,
        "Speed": 17.9,
        "Height": 37,
        "Mileage": 22001072,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27904,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27216101,
        "Time": "2022-02-23T14:33:35",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30706,
        "Lon": 86.17071,
        "Speed": 9.0,
        "Height": 421,
        "Mileage": 22006010,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27217609,
        "Time": "2022-02-23T14:45:30",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30438,
        "Lon": 86.1419,
        "Speed": 34.6,
        "Height": 92,
        "Mileage": 22010940,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27789,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27221523,
        "Time": "2022-02-23T15:17:44",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2986031,
        "Lon": 86.13885,
        "Speed": 11.2,
        "Height": 10,
        "Mileage": 22012686,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27891,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27223561,
        "Time": "2022-02-23T15:32:22",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.31382,
        "Lon": 86.1497,
        "Speed": 20.3,
        "Height": 274,
        "Mileage": 22016558,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27918,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27225640,
        "Time": "2022-02-23T15:46:45",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3111954,
        "Lon": 86.1536,
        "Speed": 33.7,
        "Height": 301,
        "Mileage": 22020368,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27641,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27227337,
        "Time": "2022-02-23T15:57:10",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2989845,
        "Lon": 86.1445,
        "Speed": 5.5,
        "Height": -4,
        "Mileage": 22024822,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27229960,
        "Time": "2022-02-23T16:17:48",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3104324,
        "Lon": 86.13314,
        "Speed": 12.7,
        "Height": 182,
        "Mileage": 22027680,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27891,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27232425,
        "Time": "2022-02-23T16:37:21",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30707,
        "Lon": 86.16782,
        "Speed": 27.0,
        "Height": 396,
        "Mileage": 22031646,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27797,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27239232,
        "Time": "2022-02-23T17:35:13",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.31367,
        "Lon": 86.14717,
        "Speed": 14.4,
        "Height": 262,
        "Mileage": 22033870,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27844,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27240884,
        "Time": "2022-02-23T17:48:15",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.29919,
        "Lon": 86.13785,
        "Speed": 15.1,
        "Height": 11,
        "Mileage": 22037710,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27860,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27243051,
        "Time": "2022-02-23T18:04:54",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3130455,
        "Lon": 86.15194,
        "Speed": 14.8,
        "Height": 279,
        "Mileage": 22041900,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27822,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27244952,
        "Time": "2022-02-23T18:19:55",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.31381,
        "Lon": 86.1493759,
        "Speed": 35.3,
        "Height": 266,
        "Mileage": 22045936,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27582,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27246632,
        "Time": "2022-02-23T18:34:20",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2958527,
        "Lon": 86.14591,
        "Speed": 7.2,
        "Height": -71,
        "Mileage": 22050690,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27651,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27248947,
        "Time": "2022-02-23T18:51:03",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.310833,
        "Lon": 86.13715,
        "Speed": 14.2,
        "Height": 204,
        "Mileage": 22054494,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27798,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27251468,
        "Time": "2022-02-23T19:08:53",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.307415,
        "Lon": 86.162674,
        "Speed": 25.7,
        "Height": 370,
        "Mileage": 22058514,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27783,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27253838,
        "Time": "2022-02-23T19:26:38",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30022,
        "Lon": 86.13771,
        "Speed": 4.0,
        "Height": 6,
        "Mileage": 22063580,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27733,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27256112,
        "Time": "2022-02-23T19:44:10",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3101158,
        "Lon": 86.13277,
        "Speed": 14.2,
        "Height": 171,
        "Mileage": 22066498,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27899,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27258938,
        "Time": "2022-02-23T20:03:26",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30716,
        "Lon": 86.16305,
        "Speed": 30.5,
        "Height": 367,
        "Mileage": 22070762,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27260809,
        "Time": "2022-02-23T20:17:55",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.307476,
        "Lon": 86.1355,
        "Speed": 5.0,
        "Height": 144,
        "Mileage": 22074630,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27785,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27265357,
        "Time": "2022-02-23T20:51:05",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.309,
        "Lon": 86.17344,
        "Speed": 6.8,
        "Height": 430,
        "Mileage": 22078796,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27897,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27267318,
        "Time": "2022-02-23T21:07:41",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2935867,
        "Lon": 86.1497,
        "Speed": 11.1,
        "Height": -24,
        "Mileage": 22084854,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27772,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27270588,
        "Time": "2022-02-23T21:31:54",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2974854,
        "Lon": 86.1476059,
        "Speed": 15.5,
        "Height": 3,
        "Mileage": 22086976,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27858,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27273893,
        "Time": "2022-02-23T21:55:02",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30808,
        "Lon": 86.17138,
        "Speed": 12.4,
        "Height": 428,
        "Mileage": 22092406,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27705,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27275792,
        "Time": "2022-02-23T22:08:54",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30453,
        "Lon": 86.1435547,
        "Speed": 27.0,
        "Height": 81,
        "Mileage": 22097344,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27951,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27279355,
        "Time": "2022-02-23T22:33:30",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3015175,
        "Lon": 86.14201,
        "Speed": 17.0,
        "Height": 17,
        "Mileage": 22099318,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27282358,
        "Time": "2022-02-23T22:53:45",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3066254,
        "Lon": 86.16431,
        "Speed": 11.6,
        "Height": 385,
        "Mileage": 22104194,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27868,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27284491,
        "Time": "2022-02-23T23:09:07",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3060875,
        "Lon": 86.13463,
        "Speed": 30.1,
        "Height": 138,
        "Mileage": 22108888,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27812,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27287735,
        "Time": "2022-02-23T23:30:42",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3016052,
        "Lon": 86.14205,
        "Speed": 13.1,
        "Height": 11,
        "Mileage": 22111406,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27894,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27291980,
        "Time": "2022-02-24T00:00:30",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3114624,
        "Lon": 86.15337,
        "Speed": 7.0,
        "Height": 296,
        "Mileage": 22115370,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27295030,
        "Time": "2022-02-24T00:22:09",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3101044,
        "Lon": 86.15702,
        "Speed": 18.5,
        "Height": 330,
        "Mileage": 22118508,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27667,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27298915,
        "Time": "2022-02-24T01:04:15",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3125763,
        "Lon": 86.1472549,
        "Speed": 5.9,
        "Height": 266,
        "Mileage": 22120434,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 28041,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27300782,
        "Time": "2022-02-24T01:20:03",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3002777,
        "Lon": 86.14013,
        "Speed": 8.5,
        "Height": 18,
        "Mileage": 22124158,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27920,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27305371,
        "Time": "2022-02-24T01:51:38",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2999763,
        "Lon": 86.1455841,
        "Speed": 6.1,
        "Height": 31,
        "Mileage": 22125478,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27825,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27308666,
        "Time": "2022-02-24T02:12:29",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3082161,
        "Lon": 86.17145,
        "Speed": 11.1,
        "Height": 429,
        "Mileage": 22130608,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27871,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27310446,
        "Time": "2022-02-24T02:25:06",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30462,
        "Lon": 86.14294,
        "Speed": 27.5,
        "Height": 79,
        "Mileage": 22135410,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27688,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27313493,
        "Time": "2022-02-24T02:46:03",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.2944756,
        "Lon": 86.14455,
        "Speed": 15.3,
        "Height": -45,
        "Mileage": 22138012,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27316580,
        "Time": "2022-02-24T03:07:12",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.3099747,
        "Lon": 86.15706,
        "Speed": 11.6,
        "Height": 337,
        "Mileage": 22143146,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27318524,
        "Time": "2022-02-24T03:22:04",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.31101,
        "Lon": 86.13698,
        "Speed": 32.5,
        "Height": 213,
        "Mileage": 22147554,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27320741,
        "Time": "2022-02-24T03:36:38",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30001,
        "Lon": 86.13949,
        "Speed": 10.3,
        "Height": 14,
        "Mileage": 22150886,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27919,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27324132,
        "Time": "2022-02-24T03:57:43",
        "TruckId": 699,
        "Imei": "866557056019211",
        "Lat": 54.30669,
        "Lon": 86.16357,
        "Speed": 13.5,
        "Height": 382,
        "Mileage": 22155916,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 883.25,
        "OnboardVoltage": 27841,
        "EngineSpeed": null,
        "TotalMileage": 73504125,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 13474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27004213,
        "Time": "2022-02-22T10:53:58",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.27251,
        "Lon": 86.1537247,
        "Speed": 24.6,
        "Height": 257,
        "Mileage": 41329120,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 95,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27910,
        "EngineSpeed": null,
        "TotalMileage": 362408755,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18340,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27008331,
        "Time": "2022-02-22T11:24:24",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2479935,
        "Lon": 86.14095,
        "Speed": 5.7,
        "Height": 364,
        "Mileage": 41336780,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 94,
        "EngineRPM": 762.0,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 362416490,
        "AcceleratorPedalPosition": 41,
        "LoadPercentage": 69,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18341,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27011889,
        "Time": "2022-02-22T11:51:02",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2708931,
        "Lon": 86.15513,
        "Speed": 20.5,
        "Height": 263,
        "Mileage": 41344660,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 96,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27847,
        "EngineSpeed": null,
        "TotalMileage": 362424010,
        "AcceleratorPedalPosition": 62,
        "LoadPercentage": 47,
        "FuelConsumption": 165,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18341,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27013896,
        "Time": "2022-02-22T12:08:37",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2500153,
        "Lon": 86.14059,
        "Speed": 4.2,
        "Height": 367,
        "Mileage": 41349376,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 96,
        "EngineRPM": 657.5,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 362428935,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18342,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27016807,
        "Time": "2022-02-22T12:33:41",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2561378,
        "Lon": 86.16211,
        "Speed": 25.7,
        "Height": 290,
        "Mileage": 41358580,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 96,
        "EngineRPM": 1302.375,
        "OnboardVoltage": 27699,
        "EngineSpeed": null,
        "TotalMileage": 362437990,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18342,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27020486,
        "Time": "2022-02-22T13:09:01",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.28345,
        "Lon": 86.13761,
        "Speed": 12.9,
        "Height": 298,
        "Mileage": 41364552,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 95,
        "EngineRPM": 1290.75,
        "OnboardVoltage": 27811,
        "EngineSpeed": null,
        "TotalMileage": 362443760,
        "AcceleratorPedalPosition": 43,
        "LoadPercentage": 48,
        "FuelConsumption": 157,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18343,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27023167,
        "Time": "2022-02-22T13:35:16",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2482,
        "Lon": 86.1411057,
        "Speed": 15.1,
        "Height": 362,
        "Mileage": 41370588,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 93,
        "EngineRPM": 960.5,
        "OnboardVoltage": 27688,
        "EngineSpeed": null,
        "TotalMileage": 362449915,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18343,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27027213,
        "Time": "2022-02-22T14:07:37",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.268177,
        "Lon": 86.15488,
        "Speed": 23.5,
        "Height": 277,
        "Mileage": 41378516,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 96,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27672,
        "EngineSpeed": null,
        "TotalMileage": 362457820,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18344,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27030254,
        "Time": "2022-02-22T14:28:33",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2735863,
        "Lon": 86.1524,
        "Speed": 33.3,
        "Height": 251,
        "Mileage": 41386160,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 98,
        "EngineRPM": 1140.125,
        "OnboardVoltage": 27682,
        "EngineSpeed": null,
        "TotalMileage": 362465705,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18344,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.8
    },
    {
        "Id": 27033831,
        "Time": "2022-02-22T14:56:03",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2482834,
        "Lon": 86.14074,
        "Speed": 6.1,
        "Height": 359,
        "Mileage": 41393544,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 98,
        "EngineRPM": 756.25,
        "OnboardVoltage": 27647,
        "EngineSpeed": null,
        "TotalMileage": 362473225,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 7,
        "FuelConsumption": 140,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18344,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27037058,
        "Time": "2022-02-22T15:18:53",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2696342,
        "Lon": 86.15498,
        "Speed": 20.0,
        "Height": 267,
        "Mileage": 41401244,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 98,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27676,
        "EngineSpeed": null,
        "TotalMileage": 362481195,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18345,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27039557,
        "Time": "2022-02-22T15:38:08",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.27024,
        "Lon": 86.15541,
        "Speed": 27.4,
        "Height": 263,
        "Mileage": 41408660,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 98,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27777,
        "EngineSpeed": null,
        "TotalMileage": 362488780,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18345,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27043761,
        "Time": "2022-02-22T16:13:58",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2480927,
        "Lon": 86.1407,
        "Speed": 10.3,
        "Height": 365,
        "Mileage": 41416456,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 99,
        "EngineRPM": 856.5,
        "OnboardVoltage": 27741,
        "EngineSpeed": null,
        "TotalMileage": 362496785,
        "AcceleratorPedalPosition": 18,
        "LoadPercentage": 16,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18346,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27047044,
        "Time": "2022-02-22T16:38:00",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.27474,
        "Lon": 86.1495743,
        "Speed": 33.3,
        "Height": 267,
        "Mileage": 41423484,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 98,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27764,
        "EngineSpeed": null,
        "TotalMileage": 362503745,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18346,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27049556,
        "Time": "2022-02-22T16:57:31",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2640762,
        "Lon": 86.15607,
        "Speed": 34.6,
        "Height": 297,
        "Mileage": 41430868,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 100,
        "EngineRPM": 1215.875,
        "OnboardVoltage": 27784,
        "EngineSpeed": null,
        "TotalMileage": 362511520,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18346,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27053921,
        "Time": "2022-02-22T17:34:43",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.24737,
        "Lon": 86.145256,
        "Speed": 25.9,
        "Height": 363,
        "Mileage": 41438892,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 100,
        "EngineRPM": 1200.0,
        "OnboardVoltage": 27702,
        "EngineSpeed": null,
        "TotalMileage": 362519690,
        "AcceleratorPedalPosition": 44,
        "LoadPercentage": 17,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18347,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.2
    },
    {
        "Id": 27057519,
        "Time": "2022-02-22T18:08:02",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2806549,
        "Lon": 86.14057,
        "Speed": 28.1,
        "Height": 280,
        "Mileage": 41445400,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 99,
        "EngineRPM": 869.5,
        "OnboardVoltage": 27774,
        "EngineSpeed": null,
        "TotalMileage": 362526280,
        "AcceleratorPedalPosition": 18,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18348,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27059920,
        "Time": "2022-02-22T18:29:29",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.26545,
        "Lon": 86.15665,
        "Speed": 32.0,
        "Height": 284,
        "Mileage": 41453792,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 100,
        "EngineRPM": 1289.875,
        "OnboardVoltage": 27771,
        "EngineSpeed": null,
        "TotalMileage": 362534990,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18348,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27064689,
        "Time": "2022-02-22T19:04:11",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.24777,
        "Lon": 86.1445541,
        "Speed": 27.4,
        "Height": 356,
        "Mileage": 41461760,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 99,
        "EngineRPM": 1717.875,
        "OnboardVoltage": 27712,
        "EngineSpeed": null,
        "TotalMileage": 362543110,
        "AcceleratorPedalPosition": 61,
        "LoadPercentage": 56,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18349,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27068683,
        "Time": "2022-02-22T19:34:47",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2838936,
        "Lon": 86.13788,
        "Speed": 0.0,
        "Height": 286,
        "Mileage": 41467864,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 931.875,
        "OnboardVoltage": 27792,
        "EngineSpeed": null,
        "TotalMileage": 362549530,
        "AcceleratorPedalPosition": 21,
        "LoadPercentage": 26,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18349,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27071996,
        "Time": "2022-02-22T19:58:02",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2474556,
        "Lon": 86.14475,
        "Speed": 22.7,
        "Height": 353,
        "Mileage": 41473872,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 99,
        "EngineRPM": 915.625,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 362555535,
        "AcceleratorPedalPosition": 16,
        "LoadPercentage": 14,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18350,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27074210,
        "Time": "2022-02-22T20:13:04",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2694435,
        "Lon": 86.17067,
        "Speed": 15.0,
        "Height": 32,
        "Mileage": 41480408,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 99,
        "EngineRPM": 1296.5,
        "OnboardVoltage": 27712,
        "EngineSpeed": null,
        "TotalMileage": 362561720,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18350,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27077598,
        "Time": "2022-02-22T20:36:49",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2725258,
        "Lon": 86.1779251,
        "Speed": 22.2,
        "Height": 99,
        "Mileage": 41482352,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 100,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 362563570,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18350,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27080446,
        "Time": "2022-02-22T20:58:10",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30726,
        "Lon": 86.17088,
        "Speed": 10.5,
        "Height": 415,
        "Mileage": 41489020,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 105,
        "EngineRPM": 1399.5,
        "OnboardVoltage": 27790,
        "EngineSpeed": null,
        "TotalMileage": 362570640,
        "AcceleratorPedalPosition": 58,
        "LoadPercentage": 59,
        "FuelConsumption": 217,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18350,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27084508,
        "Time": "2022-02-22T21:29:05",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3129578,
        "Lon": 86.14608,
        "Speed": 7.9,
        "Height": 270,
        "Mileage": 41491848,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 104,
        "EngineRPM": 1125.875,
        "OnboardVoltage": 27656,
        "EngineSpeed": null,
        "TotalMileage": 362573490,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18351,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27090242,
        "Time": "2022-02-22T22:09:20",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3001251,
        "Lon": 86.14531,
        "Speed": 21.6,
        "Height": 31,
        "Mileage": 41495032,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 73,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27778,
        "EngineSpeed": null,
        "TotalMileage": 362576625,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18352,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.8
    },
    {
        "Id": 27093735,
        "Time": "2022-02-22T22:39:23",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.29943,
        "Lon": 86.14452,
        "Speed": 0.0,
        "Height": 1,
        "Mileage": 41496532,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 71,
        "EngineRPM": 1125.625,
        "OnboardVoltage": 27950,
        "EngineSpeed": null,
        "TotalMileage": 362578225,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18352,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27096822,
        "Time": "2022-02-22T23:01:59",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31023,
        "Lon": 86.13287,
        "Speed": 10.9,
        "Height": 185,
        "Mileage": 41499320,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 73,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27771,
        "EngineSpeed": null,
        "TotalMileage": 362580935,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18352,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27098953,
        "Time": "2022-02-22T23:19:41",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3071823,
        "Lon": 86.1705246,
        "Speed": 21.1,
        "Height": 416,
        "Mileage": 41503208,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 75,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 362584570,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18353,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27100731,
        "Time": "2022-02-22T23:31:42",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2996368,
        "Lon": 86.14149,
        "Speed": 6.8,
        "Height": 14,
        "Mileage": 41508592,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 72,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27754,
        "EngineSpeed": null,
        "TotalMileage": 362590205,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18353,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27105050,
        "Time": "2022-02-23T00:06:58",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.300224299999996,
        "Lon": 86.14618,
        "Speed": 14.6,
        "Height": 37,
        "Mileage": 41509800,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 75,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27763,
        "EngineSpeed": null,
        "TotalMileage": 362591265,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18354,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27107769,
        "Time": "2022-02-23T00:27:00",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30765,
        "Lon": 86.1711655,
        "Speed": 14.6,
        "Height": 425,
        "Mileage": 41514740,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 84,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27804,
        "EngineSpeed": null,
        "TotalMileage": 362596510,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 383,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18354,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27112616,
        "Time": "2022-02-23T01:15:14",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3124466,
        "Lon": 86.14707,
        "Speed": 10.1,
        "Height": 263,
        "Mileage": 41517272,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 771.125,
        "OnboardVoltage": 27824,
        "EngineSpeed": null,
        "TotalMileage": 362599130,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 60,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18355,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27115628,
        "Time": "2022-02-23T01:40:34",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3004532,
        "Lon": 86.13952,
        "Speed": 7.0,
        "Height": 9,
        "Mileage": 41521008,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 93,
        "EngineRPM": 1009.875,
        "OnboardVoltage": 27732,
        "EngineSpeed": null,
        "TotalMileage": 362602940,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18355,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27119084,
        "Time": "2022-02-23T02:04:53",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3012047,
        "Lon": 86.13923,
        "Speed": 5.9,
        "Height": 18,
        "Mileage": 41522276,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 93,
        "EngineRPM": 818.375,
        "OnboardVoltage": 27855,
        "EngineSpeed": null,
        "TotalMileage": 362603950,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 40,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18356,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27121813,
        "Time": "2022-02-23T02:23:50",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30988,
        "Lon": 86.1576,
        "Speed": 12.9,
        "Height": 338,
        "Mileage": 41526416,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 96,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27868,
        "EngineSpeed": null,
        "TotalMileage": 362608535,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18356,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27123708,
        "Time": "2022-02-23T02:38:27",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3033867,
        "Lon": 86.13689,
        "Speed": 35.7,
        "Height": 114,
        "Mileage": 41531724,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 96,
        "EngineRPM": 1299.625,
        "OnboardVoltage": 27860,
        "EngineSpeed": null,
        "TotalMileage": 362613910,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18356,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27125740,
        "Time": "2022-02-23T02:52:49",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3044548,
        "Lon": 86.1355057,
        "Speed": 10.7,
        "Height": 126,
        "Mileage": 41535140,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 96,
        "EngineRPM": 1707.875,
        "OnboardVoltage": 27845,
        "EngineSpeed": null,
        "TotalMileage": 362617625,
        "AcceleratorPedalPosition": 85,
        "LoadPercentage": 100,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18356,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27128468,
        "Time": "2022-02-23T03:11:22",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3070869,
        "Lon": 86.17017,
        "Speed": 33.1,
        "Height": 418,
        "Mileage": 41539508,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 100,
        "EngineRPM": 844.75,
        "OnboardVoltage": 27828,
        "EngineSpeed": null,
        "TotalMileage": 362621985,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18357,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27130413,
        "Time": "2022-02-23T03:26:55",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3079033,
        "Lon": 86.13669,
        "Speed": 14.4,
        "Height": 156,
        "Mileage": 41543568,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 101,
        "EngineRPM": 1267.125,
        "OnboardVoltage": 27840,
        "EngineSpeed": null,
        "TotalMileage": 362626270,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 67,
        "FuelConsumption": 138,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18357,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27133160,
        "Time": "2022-02-23T03:44:11",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30979,
        "Lon": 86.172,
        "Speed": 10.3,
        "Height": 441,
        "Mileage": 41547872,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 103,
        "EngineRPM": 1389.375,
        "OnboardVoltage": 27924,
        "EngineSpeed": null,
        "TotalMileage": 362630635,
        "AcceleratorPedalPosition": 97,
        "LoadPercentage": 100,
        "FuelConsumption": 387,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18357,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.2
    },
    {
        "Id": 27134878,
        "Time": "2022-02-23T03:57:48",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30717,
        "Lon": 86.13814,
        "Speed": 7.7,
        "Height": 164,
        "Mileage": 41552112,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 775.0,
        "OnboardVoltage": 27820,
        "EngineSpeed": null,
        "TotalMileage": 362635200,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18357,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.2
    },
    {
        "Id": 27137926,
        "Time": "2022-02-23T04:16:00",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3067856,
        "Lon": 86.16645,
        "Speed": 11.8,
        "Height": 395,
        "Mileage": 41556100,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 105,
        "EngineRPM": 1806.5,
        "OnboardVoltage": 27784,
        "EngineSpeed": null,
        "TotalMileage": 362638955,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 392,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18358,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27139970,
        "Time": "2022-02-23T04:28:28",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3036575,
        "Lon": 86.136055,
        "Speed": 35.9,
        "Height": 121,
        "Mileage": 41560788,
        "EngineOilPressure": 300,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 1267.125,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 362643660,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18358,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27141647,
        "Time": "2022-02-23T04:40:47",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.294487,
        "Lon": 86.14448,
        "Speed": 12.0,
        "Height": -48,
        "Mileage": 41563476,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 103,
        "EngineRPM": 1365.125,
        "OnboardVoltage": 27836,
        "EngineSpeed": null,
        "TotalMileage": 362646530,
        "AcceleratorPedalPosition": 77,
        "LoadPercentage": 58,
        "FuelConsumption": 202,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18358,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27144521,
        "Time": "2022-02-23T05:01:53",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30986,
        "Lon": 86.15548,
        "Speed": 13.1,
        "Height": 325,
        "Mileage": 41568604,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 106,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27878,
        "EngineSpeed": null,
        "TotalMileage": 362651680,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 392,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18359,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.2
    },
    {
        "Id": 27146044,
        "Time": "2022-02-23T05:17:17",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3102875,
        "Lon": 86.13256,
        "Speed": 12.9,
        "Height": 187,
        "Mileage": 41573500,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 106,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27860,
        "EngineSpeed": null,
        "TotalMileage": 362656485,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18359,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.6
    },
    {
        "Id": 27149429,
        "Time": "2022-02-23T05:49:38",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.29903,
        "Lon": 86.1429749,
        "Speed": 0.0,
        "Height": 8,
        "Mileage": 41576040,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 103,
        "EngineRPM": 808.625,
        "OnboardVoltage": 27831,
        "EngineSpeed": null,
        "TotalMileage": 362659320,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18359,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27152070,
        "Time": "2022-02-23T06:09:34",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3107529,
        "Lon": 86.15334,
        "Speed": 17.4,
        "Height": 307,
        "Mileage": 41580048,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 107,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27887,
        "EngineSpeed": null,
        "TotalMileage": 362663600,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 392,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18360,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27154059,
        "Time": "2022-02-23T06:23:23",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3104172,
        "Lon": 86.1329651,
        "Speed": 21.4,
        "Height": 190,
        "Mileage": 41584788,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1088.875,
        "OnboardVoltage": 27842,
        "EngineSpeed": null,
        "TotalMileage": 362668525,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 124,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18360,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27156790,
        "Time": "2022-02-23T06:44:23",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3005676,
        "Lon": 86.1409454,
        "Speed": 11.6,
        "Height": 17,
        "Mileage": 41587560,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 104,
        "EngineRPM": 1020.875,
        "OnboardVoltage": 27856,
        "EngineSpeed": null,
        "TotalMileage": 362671515,
        "AcceleratorPedalPosition": 9,
        "LoadPercentage": 0,
        "FuelConsumption": 134,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18360,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27159383,
        "Time": "2022-02-23T07:03:42",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3065262,
        "Lon": 86.16407,
        "Speed": 11.4,
        "Height": 387,
        "Mileage": 41592312,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 106,
        "EngineRPM": 1670.75,
        "OnboardVoltage": 27878,
        "EngineSpeed": null,
        "TotalMileage": 362676650,
        "AcceleratorPedalPosition": 85,
        "LoadPercentage": 93,
        "FuelConsumption": 235,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18361,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27161305,
        "Time": "2022-02-23T07:15:44",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3063927,
        "Lon": 86.13442,
        "Speed": 34.8,
        "Height": 154,
        "Mileage": 41596744,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 108,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27854,
        "EngineSpeed": null,
        "TotalMileage": 362680870,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18361,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27163071,
        "Time": "2022-02-23T07:28:15",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3015442,
        "Lon": 86.14232,
        "Speed": 19.2,
        "Height": 26,
        "Mileage": 41599244,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 103,
        "EngineRPM": 1523.375,
        "OnboardVoltage": 27861,
        "EngineSpeed": null,
        "TotalMileage": 362683670,
        "AcceleratorPedalPosition": 70,
        "LoadPercentage": 67,
        "FuelConsumption": 218,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18361,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27165786,
        "Time": "2022-02-23T07:47:11",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3067245,
        "Lon": 86.1693954,
        "Speed": 17.5,
        "Height": 412,
        "Mileage": 41604048,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 108,
        "EngineRPM": 1796.375,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 362689115,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18361,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27167697,
        "Time": "2022-02-23T08:01:35",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.28778,
        "Lon": 86.17635,
        "Speed": 32.0,
        "Height": 286,
        "Mileage": 41608140,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 106,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 362693380,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 85,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18362,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27173166,
        "Time": "2022-02-23T08:45:38",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31255,
        "Lon": 86.1464,
        "Speed": 8.7,
        "Height": 270,
        "Mileage": 41612392,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 83,
        "EngineRPM": 917.625,
        "OnboardVoltage": 27916,
        "EngineSpeed": null,
        "TotalMileage": 362697980,
        "AcceleratorPedalPosition": 29,
        "LoadPercentage": 76,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18362,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27176008,
        "Time": "2022-02-23T09:09:10",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3003654,
        "Lon": 86.13852,
        "Speed": 0.0,
        "Height": 15,
        "Mileage": 41616164,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 68,
        "EngineRPM": 667.875,
        "OnboardVoltage": 27895,
        "EngineSpeed": null,
        "TotalMileage": 362701895,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18363,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.200005
    },
    {
        "Id": 27178288,
        "Time": "2022-02-23T09:28:03",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3103371,
        "Lon": 86.15378,
        "Speed": 15.0,
        "Height": 314,
        "Mileage": 41620340,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 66,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27835,
        "EngineSpeed": null,
        "TotalMileage": 362706190,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18363,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27180045,
        "Time": "2022-02-23T09:41:32",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3134537,
        "Lon": 86.14048,
        "Speed": 35.0,
        "Height": 232,
        "Mileage": 41624608,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 66,
        "EngineRPM": 1059.5,
        "OnboardVoltage": 27832,
        "EngineSpeed": null,
        "TotalMileage": 362710400,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 125,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18363,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.6
    },
    {
        "Id": 27181669,
        "Time": "2022-02-23T09:52:35",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30006,
        "Lon": 86.14516,
        "Speed": 20.0,
        "Height": 32,
        "Mileage": 41628244,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 69,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27836,
        "EngineSpeed": null,
        "TotalMileage": 362714275,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18363,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27184324,
        "Time": "2022-02-23T10:12:15",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3087044,
        "Lon": 86.17324,
        "Speed": 13.7,
        "Height": 428,
        "Mileage": 41633144,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 69,
        "EngineRPM": 892.0,
        "OnboardVoltage": 27891,
        "EngineSpeed": null,
        "TotalMileage": 362719625,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18364,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.4
    },
    {
        "Id": 27185936,
        "Time": "2022-02-23T10:25:20",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2942162,
        "Lon": 86.14977,
        "Speed": 27.0,
        "Height": -16,
        "Mileage": 41638824,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 74,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27856,
        "EngineSpeed": null,
        "TotalMileage": 362725580,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 6,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18364,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27187884,
        "Time": "2022-02-23T10:41:17",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2936249,
        "Lon": 86.14958,
        "Speed": 10.9,
        "Height": -23,
        "Mileage": 41640324,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 74,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27784,
        "EngineSpeed": null,
        "TotalMileage": 362727250,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18364,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27190880,
        "Time": "2022-02-23T11:02:54",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3066521,
        "Lon": 86.1637955,
        "Speed": 11.8,
        "Height": 386,
        "Mileage": 41645624,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 80,
        "EngineRPM": 1806.75,
        "OnboardVoltage": 27893,
        "EngineSpeed": null,
        "TotalMileage": 362732615,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18364,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27192650,
        "Time": "2022-02-23T11:15:53",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3034363,
        "Lon": 86.1365051,
        "Speed": 33.8,
        "Height": 124,
        "Mileage": 41650276,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 87,
        "EngineRPM": 1299.875,
        "OnboardVoltage": 27862,
        "EngineSpeed": null,
        "TotalMileage": 362737450,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18365,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27197542,
        "Time": "2022-02-23T11:53:46",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2960548,
        "Lon": 86.14552,
        "Speed": 0.0,
        "Height": -43,
        "Mileage": 41652936,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 90,
        "EngineRPM": 651.125,
        "OnboardVoltage": 27897,
        "EngineSpeed": null,
        "TotalMileage": 362740420,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18365,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27201019,
        "Time": "2022-02-23T12:26:54",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3040924,
        "Lon": 86.14458,
        "Speed": 0.0,
        "Height": 75,
        "Mileage": 41655840,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 1124.625,
        "OnboardVoltage": 27841,
        "EngineSpeed": null,
        "TotalMileage": 362742550,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18366,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27205491,
        "Time": "2022-02-23T13:14:48",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30683,
        "Lon": 86.16736,
        "Speed": 12.0,
        "Height": 401,
        "Mileage": 41660364,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 96,
        "EngineRPM": 1751.25,
        "OnboardVoltage": 27683,
        "EngineSpeed": null,
        "TotalMileage": 362746745,
        "AcceleratorPedalPosition": 90,
        "LoadPercentage": 90,
        "FuelConsumption": 357,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27207250,
        "Time": "2022-02-23T13:27:11",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30841,
        "Lon": 86.13302,
        "Speed": 28.7,
        "Height": 166,
        "Mileage": 41664416,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27761,
        "EngineSpeed": null,
        "TotalMileage": 362750595,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27208846,
        "Time": "2022-02-23T13:38:57",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.300224299999996,
        "Lon": 86.1462,
        "Speed": 10.5,
        "Height": 31,
        "Mileage": 41667460,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 97,
        "EngineRPM": 1108.375,
        "OnboardVoltage": 27704,
        "EngineSpeed": null,
        "TotalMileage": 362753935,
        "AcceleratorPedalPosition": 30,
        "LoadPercentage": 22,
        "FuelConsumption": 96,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27211679,
        "Time": "2022-02-23T14:01:45",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30256,
        "Lon": 86.1706161,
        "Speed": 16.4,
        "Height": 386,
        "Mileage": 41673032,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 103,
        "EngineRPM": 1296.25,
        "OnboardVoltage": 27780,
        "EngineSpeed": null,
        "TotalMileage": 362759185,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27214944,
        "Time": "2022-02-23T14:24:46",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2850456,
        "Lon": 86.179184,
        "Speed": 0.0,
        "Height": 275,
        "Mileage": 41675980,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 101,
        "EngineRPM": 1432.25,
        "OnboardVoltage": 27905,
        "EngineSpeed": null,
        "TotalMileage": 362762530,
        "AcceleratorPedalPosition": 64,
        "LoadPercentage": 7,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27216764,
        "Time": "2022-02-23T14:39:19",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3110352,
        "Lon": 86.1371,
        "Speed": 27.2,
        "Height": 207,
        "Mileage": 41681784,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 362768185,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27219197,
        "Time": "2022-02-23T14:59:23",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.299633,
        "Lon": 86.14421,
        "Speed": 10.0,
        "Height": 12,
        "Mileage": 41684988,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 101,
        "EngineRPM": 1334.25,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 362771435,
        "AcceleratorPedalPosition": 60,
        "LoadPercentage": 54,
        "FuelConsumption": 186,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27221676,
        "Time": "2022-02-23T15:18:44",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31071,
        "Lon": 86.15338,
        "Speed": 13.3,
        "Height": 315,
        "Mileage": 41689644,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 104,
        "EngineRPM": 1753.75,
        "OnboardVoltage": 27713,
        "EngineSpeed": null,
        "TotalMileage": 362775790,
        "AcceleratorPedalPosition": 90,
        "LoadPercentage": 92,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27224054,
        "Time": "2022-02-23T15:36:10",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3111763,
        "Lon": 86.13732,
        "Speed": 27.0,
        "Height": 216,
        "Mileage": 41694568,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 102,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27792,
        "EngineSpeed": null,
        "TotalMileage": 362780385,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27225855,
        "Time": "2022-02-23T15:48:10",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.29904,
        "Lon": 86.13938,
        "Speed": 14.6,
        "Height": 20,
        "Mileage": 41697928,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 1546.0,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 362783740,
        "AcceleratorPedalPosition": 66,
        "LoadPercentage": 61,
        "FuelConsumption": 246,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27228732,
        "Time": "2022-02-23T16:08:15",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30991,
        "Lon": 86.15779,
        "Speed": 11.6,
        "Height": 333,
        "Mileage": 41702824,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 1712.5,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 362788345,
        "AcceleratorPedalPosition": 87,
        "LoadPercentage": 82,
        "FuelConsumption": 329,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27230961,
        "Time": "2022-02-23T16:25:29",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31032,
        "Lon": 86.1326141,
        "Speed": 27.4,
        "Height": 185,
        "Mileage": 41707836,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 105,
        "EngineRPM": 1300.875,
        "OnboardVoltage": 27797,
        "EngineSpeed": null,
        "TotalMileage": 362793010,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.6
    },
    {
        "Id": 27232797,
        "Time": "2022-02-23T16:40:54",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2962265,
        "Lon": 86.1446457,
        "Speed": 12.5,
        "Height": -44,
        "Mileage": 41711480,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 105,
        "EngineRPM": 748.625,
        "OnboardVoltage": 27705,
        "EngineSpeed": null,
        "TotalMileage": 362796710,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 21,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.6
    },
    {
        "Id": 27239845,
        "Time": "2022-02-23T17:39:48",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30432,
        "Lon": 86.14091,
        "Speed": 8.8,
        "Height": 94,
        "Mileage": 41714164,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 104,
        "EngineRPM": 1678.125,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 362798750,
        "AcceleratorPedalPosition": 82,
        "LoadPercentage": 74,
        "FuelConsumption": 312,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18371,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27242792,
        "Time": "2022-02-23T18:02:41",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3095627,
        "Lon": 86.17268,
        "Speed": 5.9,
        "Height": 439,
        "Mileage": 41719064,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 108,
        "EngineRPM": 848.625,
        "OnboardVoltage": 27776,
        "EngineSpeed": null,
        "TotalMileage": 362803565,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27246872,
        "Time": "2022-02-23T18:35:35",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3136024,
        "Lon": 86.14708,
        "Speed": 17.0,
        "Height": 261,
        "Mileage": 41721776,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 90,
        "EngineRPM": 749.0,
        "OnboardVoltage": 27821,
        "EngineSpeed": null,
        "TotalMileage": 362806160,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27248645,
        "Time": "2022-02-23T18:49:33",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.29943,
        "Lon": 86.14392,
        "Speed": 0.0,
        "Height": 2,
        "Mileage": 41725624,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 84,
        "EngineRPM": 698.125,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 362810010,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 14,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27251484,
        "Time": "2022-02-23T19:09:06",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31021,
        "Lon": 86.1328659,
        "Speed": 11.1,
        "Height": 181,
        "Mileage": 41728552,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 75,
        "EngineRPM": 1755.25,
        "OnboardVoltage": 27695,
        "EngineSpeed": null,
        "TotalMileage": 362812695,
        "AcceleratorPedalPosition": 90,
        "LoadPercentage": 87,
        "FuelConsumption": 351,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27253986,
        "Time": "2022-02-23T19:27:51",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.307003,
        "Lon": 86.16862,
        "Speed": 26.4,
        "Height": 404,
        "Mileage": 41732696,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 75,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 362816405,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.0
    },
    {
        "Id": 27255571,
        "Time": "2022-02-23T19:39:54",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.29946,
        "Lon": 86.14187,
        "Speed": 17.4,
        "Height": 10,
        "Mileage": 41738216,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 77,
        "EngineRPM": 808.875,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 362821980,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.200005
    },
    {
        "Id": 27257565,
        "Time": "2022-02-23T19:54:21",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30595,
        "Lon": 86.13552,
        "Speed": 15.1,
        "Height": 139,
        "Mileage": 41740556,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 77,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 362824220,
        "AcceleratorPedalPosition": 85,
        "LoadPercentage": 82,
        "FuelConsumption": 327,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.4
    },
    {
        "Id": 27259737,
        "Time": "2022-02-23T20:10:13",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3138542,
        "Lon": 86.1420746,
        "Speed": 15.3,
        "Height": 240,
        "Mileage": 41742936,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 77,
        "EngineRPM": 1770.375,
        "OnboardVoltage": 27710,
        "EngineSpeed": null,
        "TotalMileage": 362826580,
        "AcceleratorPedalPosition": 92,
        "LoadPercentage": 92,
        "FuelConsumption": 371,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18374,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27262386,
        "Time": "2022-02-23T20:28:56",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31035,
        "Lon": 86.1544342,
        "Speed": 31.6,
        "Height": 314,
        "Mileage": 41747372,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 82,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27761,
        "EngineSpeed": null,
        "TotalMileage": 362830365,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18374,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27264470,
        "Time": "2022-02-23T20:43:58",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.295948,
        "Lon": 86.1457748,
        "Speed": 5.0,
        "Height": -38,
        "Mileage": 41752660,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 83,
        "EngineRPM": 833.75,
        "OnboardVoltage": 27693,
        "EngineSpeed": null,
        "TotalMileage": 362836195,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 35,
        "FuelConsumption": 56,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18374,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27267009,
        "Time": "2022-02-23T21:05:25",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3109169,
        "Lon": 86.13731,
        "Speed": 15.1,
        "Height": 205,
        "Mileage": 41756648,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 90,
        "EngineRPM": 1773.625,
        "OnboardVoltage": 27745,
        "EngineSpeed": null,
        "TotalMileage": 362839805,
        "AcceleratorPedalPosition": 92,
        "LoadPercentage": 92,
        "FuelConsumption": 371,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18375,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27269458,
        "Time": "2022-02-23T21:24:05",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.307003,
        "Lon": 86.17006,
        "Speed": 22.9,
        "Height": 408,
        "Mileage": 41760548,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 95,
        "EngineRPM": 1301.625,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 362843300,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18375,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27275114,
        "Time": "2022-02-23T22:03:52",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31042,
        "Lon": 86.13287,
        "Speed": 30.7,
        "Height": 185,
        "Mileage": 41763876,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 92,
        "EngineRPM": 1296.5,
        "OnboardVoltage": 27784,
        "EngineSpeed": null,
        "TotalMileage": 362846650,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18376,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27277540,
        "Time": "2022-02-23T22:21:49",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.31306,
        "Lon": 86.13654,
        "Speed": 19.2,
        "Height": 221,
        "Mileage": 41766568,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 94,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 362849370,
        "AcceleratorPedalPosition": 98,
        "LoadPercentage": 95,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18376,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27280012,
        "Time": "2022-02-23T22:38:10",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3073845,
        "Lon": 86.137825,
        "Speed": 11.6,
        "Height": 161,
        "Mileage": 41769068,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 97,
        "EngineRPM": 886.125,
        "OnboardVoltage": 27647,
        "EngineSpeed": null,
        "TotalMileage": 362851835,
        "AcceleratorPedalPosition": 17,
        "LoadPercentage": 0,
        "FuelConsumption": 94,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18376,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.8
    },
    {
        "Id": 27282281,
        "Time": "2022-02-23T22:53:26",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.304615,
        "Lon": 86.1429,
        "Speed": 20.3,
        "Height": 85,
        "Mileage": 41773324,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 96,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27688,
        "EngineSpeed": null,
        "TotalMileage": 362855735,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18376,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27285371,
        "Time": "2022-02-23T23:14:11",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2945938,
        "Lon": 86.14696,
        "Speed": 17.4,
        "Height": -38,
        "Mileage": 41776264,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 97,
        "EngineRPM": 1692.0,
        "OnboardVoltage": 27758,
        "EngineSpeed": null,
        "TotalMileage": 362858565,
        "AcceleratorPedalPosition": 85,
        "LoadPercentage": 81,
        "FuelConsumption": 324,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18377,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27289009,
        "Time": "2022-02-23T23:39:49",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30988,
        "Lon": 86.1577454,
        "Speed": 10.7,
        "Height": 334,
        "Mileage": 41781944,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 100,
        "EngineRPM": 1712.125,
        "OnboardVoltage": 27776,
        "EngineSpeed": null,
        "TotalMileage": 362863520,
        "AcceleratorPedalPosition": 86,
        "LoadPercentage": 82,
        "FuelConsumption": 323,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18377,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27292020,
        "Time": "2022-02-24T00:00:42",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.312973,
        "Lon": 86.13964,
        "Speed": 26.2,
        "Height": 221,
        "Mileage": 41786416,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 102,
        "EngineRPM": 1301.625,
        "OnboardVoltage": 27711,
        "EngineSpeed": null,
        "TotalMileage": 362867605,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27293515,
        "Time": "2022-02-24T00:10:50",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2958679,
        "Lon": 86.1459351,
        "Speed": 4.8,
        "Height": -55,
        "Mileage": 41790516,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 102,
        "EngineRPM": 730.875,
        "OnboardVoltage": 27723,
        "EngineSpeed": null,
        "TotalMileage": 362871745,
        "AcceleratorPedalPosition": 31,
        "LoadPercentage": 74,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.6
    },
    {
        "Id": 27299433,
        "Time": "2022-02-24T01:08:28",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.303997,
        "Lon": 86.14459,
        "Speed": 0.0,
        "Height": 68,
        "Mileage": 41792740,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 99,
        "EngineRPM": 1124.75,
        "OnboardVoltage": 27868,
        "EngineSpeed": null,
        "TotalMileage": 362873885,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18379,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27304894,
        "Time": "2022-02-24T01:47:43",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3092575,
        "Lon": 86.1723557,
        "Speed": 11.6,
        "Height": 433,
        "Mileage": 41797596,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 106,
        "EngineRPM": 825.125,
        "OnboardVoltage": 27771,
        "EngineSpeed": null,
        "TotalMileage": 362878595,
        "AcceleratorPedalPosition": 26,
        "LoadPercentage": 0,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18379,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27306622,
        "Time": "2022-02-24T02:00:20",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30303,
        "Lon": 86.14393,
        "Speed": 30.7,
        "Height": 58,
        "Mileage": 41802348,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 106,
        "EngineRPM": 1301.5,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 362883445,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18380,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.200005
    },
    {
        "Id": 27309271,
        "Time": "2022-02-24T02:16:17",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.300312,
        "Lon": 86.137825,
        "Speed": 9.4,
        "Height": 15,
        "Mileage": 41803856,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 103,
        "EngineRPM": 1355.5,
        "OnboardVoltage": 27757,
        "EngineSpeed": null,
        "TotalMileage": 362885005,
        "AcceleratorPedalPosition": 66,
        "LoadPercentage": 55,
        "FuelConsumption": 186,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18380,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27312023,
        "Time": "2022-02-24T02:36:02",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.30672,
        "Lon": 86.1647644,
        "Speed": 17.0,
        "Height": 385,
        "Mileage": 41808816,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 106,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27780,
        "EngineSpeed": null,
        "TotalMileage": 362890395,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 389,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18380,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.2
    },
    {
        "Id": 27313548,
        "Time": "2022-02-24T02:46:30",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3108444,
        "Lon": 86.13634,
        "Speed": 34.0,
        "Height": 209,
        "Mileage": 41812412,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 107,
        "EngineRPM": 1302.5,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 362894045,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18380,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27317485,
        "Time": "2022-02-24T03:14:19",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.2988,
        "Lon": 86.14294,
        "Speed": 5.9,
        "Height": 9,
        "Mileage": 41815212,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 101,
        "EngineRPM": 905.75,
        "OnboardVoltage": 27741,
        "EngineSpeed": null,
        "TotalMileage": 362897245,
        "AcceleratorPedalPosition": 16,
        "LoadPercentage": 32,
        "FuelConsumption": 52,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18381,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.8
    },
    {
        "Id": 27320925,
        "Time": "2022-02-24T03:37:44",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3134079,
        "Lon": 86.1505661,
        "Speed": 16.1,
        "Height": 276,
        "Mileage": 41819000,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 106,
        "EngineRPM": 1584.875,
        "OnboardVoltage": 27853,
        "EngineSpeed": null,
        "TotalMileage": 362901205,
        "AcceleratorPedalPosition": 77,
        "LoadPercentage": 77,
        "FuelConsumption": 324,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18381,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27323341,
        "Time": "2022-02-24T03:52:51",
        "TruckId": 1156,
        "Imei": "866557056020516",
        "Lat": 54.3140068,
        "Lon": 86.14198,
        "Speed": 34.4,
        "Height": 245,
        "Mileage": 41823368,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 106,
        "EngineRPM": 1302.125,
        "OnboardVoltage": 27828,
        "EngineSpeed": null,
        "TotalMileage": 362905525,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 18381,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.6
    },
    {
        "Id": 27004255,
        "Time": "2022-02-22T10:54:20",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.28071,
        "Lon": 86.1449,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": 39808836,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 91,
        "EngineRPM": 1126.5,
        "OnboardVoltage": 27052,
        "EngineSpeed": null,
        "TotalMileage": 508077265,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27008161,
        "Time": "2022-02-22T11:21:23",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.242,
        "Lon": 86.14295,
        "Speed": 16.2,
        "Height": 328,
        "Mileage": 39814360,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 93,
        "EngineRPM": 1284.5,
        "OnboardVoltage": 26740,
        "EngineSpeed": null,
        "TotalMileage": 508083265,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 75,
        "FuelConsumption": 208,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27012257,
        "Time": "2022-02-22T11:54:19",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.28139,
        "Lon": 86.14461,
        "Speed": 5.3,
        "Height": 229,
        "Mileage": 39820036,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 93,
        "EngineRPM": 743.75,
        "OnboardVoltage": 26364,
        "EngineSpeed": null,
        "TotalMileage": 508089620,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27014925,
        "Time": "2022-02-22T12:18:35",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2422333,
        "Lon": 86.14205,
        "Speed": 11.1,
        "Height": 333,
        "Mileage": 39825720,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 94,
        "EngineRPM": 782.875,
        "OnboardVoltage": 26763,
        "EngineSpeed": null,
        "TotalMileage": 508096265,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27018233,
        "Time": "2022-02-22T12:50:05",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2621536,
        "Lon": 86.17234,
        "Speed": 26.6,
        "Height": 225,
        "Mileage": 39830160,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 26960,
        "EngineSpeed": null,
        "TotalMileage": 508100390,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27020306,
        "Time": "2022-02-22T13:07:09",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2995338,
        "Lon": 86.14172,
        "Speed": 4.0,
        "Height": 5,
        "Mileage": 39837672,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 91,
        "EngineRPM": 662.0,
        "OnboardVoltage": 26994,
        "EngineSpeed": null,
        "TotalMileage": 508108900,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27026458,
        "Time": "2022-02-22T14:01:20",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.30405,
        "Lon": 86.14379,
        "Speed": 14.6,
        "Height": 74,
        "Mileage": 39839260,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 96,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 26647,
        "EngineSpeed": null,
        "TotalMileage": 508110710,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27029213,
        "Time": "2022-02-22T14:21:57",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3089371,
        "Lon": 86.17309,
        "Speed": 0.0,
        "Height": 425,
        "Mileage": 39844004,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 758.25,
        "OnboardVoltage": 26790,
        "EngineSpeed": null,
        "TotalMileage": 508117180,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 14,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27030824,
        "Time": "2022-02-22T14:32:32",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3014832,
        "Lon": 86.14166,
        "Speed": 17.2,
        "Height": 12,
        "Mileage": 39849692,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 1302.5,
        "OnboardVoltage": 26736,
        "EngineSpeed": null,
        "TotalMileage": 508122680,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27034495,
        "Time": "2022-02-22T15:00:18",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.30016,
        "Lon": 86.1462555,
        "Speed": 8.8,
        "Height": 36,
        "Mileage": 39851036,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 1692.0,
        "OnboardVoltage": 26875,
        "EngineSpeed": null,
        "TotalMileage": 508124445,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 368,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27037271,
        "Time": "2022-02-22T15:20:29",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3091774,
        "Lon": 86.17148,
        "Speed": 13.3,
        "Height": 435,
        "Mileage": 39855928,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 103,
        "EngineRPM": 817.375,
        "OnboardVoltage": 26736,
        "EngineSpeed": null,
        "TotalMileage": 508131105,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27038627,
        "Time": "2022-02-22T15:30:05",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3042,
        "Lon": 86.14366,
        "Speed": 32.7,
        "Height": 76,
        "Mileage": 39860664,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 26759,
        "EngineSpeed": null,
        "TotalMileage": 508135960,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27042422,
        "Time": "2022-02-22T16:03:00",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.299427,
        "Lon": 86.1428452,
        "Speed": 14.6,
        "Height": 0,
        "Mileage": 39862192,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 100,
        "EngineRPM": 1793.625,
        "OnboardVoltage": 26772,
        "EngineSpeed": null,
        "TotalMileage": 508137745,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27044866,
        "Time": "2022-02-22T16:20:01",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3100548,
        "Lon": 86.1544647,
        "Speed": 10.0,
        "Height": 308,
        "Mileage": 39866340,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 104,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 26810,
        "EngineSpeed": null,
        "TotalMileage": 508143290,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27046551,
        "Time": "2022-02-22T16:33:50",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.309803,
        "Lon": 86.1324,
        "Speed": 41.1,
        "Height": 173,
        "Mileage": 39871396,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 104,
        "EngineRPM": 1298.125,
        "OnboardVoltage": 26865,
        "EngineSpeed": null,
        "TotalMileage": 508148795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27048238,
        "Time": "2022-02-22T16:47:24",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2994537,
        "Lon": 86.14211,
        "Speed": 15.7,
        "Height": 15,
        "Mileage": 39874232,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 102,
        "EngineRPM": 1617.375,
        "OnboardVoltage": 26722,
        "EngineSpeed": null,
        "TotalMileage": 508151930,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 72,
        "FuelConsumption": 319,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27050299,
        "Time": "2022-02-22T17:03:23",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3113365,
        "Lon": 86.15331,
        "Speed": 14.2,
        "Height": 299,
        "Mileage": 39878128,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 26808,
        "EngineSpeed": null,
        "TotalMileage": 508157275,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27051904,
        "Time": "2022-02-22T17:16:17",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.313015,
        "Lon": 86.14629,
        "Speed": 21.4,
        "Height": 267,
        "Mileage": 39882224,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 106,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 26989,
        "EngineSpeed": null,
        "TotalMileage": 508161620,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27054242,
        "Time": "2022-02-22T17:37:46",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3013649,
        "Lon": 86.1417,
        "Speed": 20.5,
        "Height": 15,
        "Mileage": 39885820,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 93,
        "EngineRPM": 1309.625,
        "OnboardVoltage": 26921,
        "EngineSpeed": null,
        "TotalMileage": 508165555,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27058259,
        "Time": "2022-02-22T18:14:09",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3002739,
        "Lon": 86.14618,
        "Speed": 8.3,
        "Height": 31,
        "Mileage": 39887052,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 81,
        "EngineRPM": 1635.875,
        "OnboardVoltage": 26913,
        "EngineSpeed": null,
        "TotalMileage": 508167255,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 355,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27060586,
        "Time": "2022-02-22T18:35:16",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3093338,
        "Lon": 86.17257,
        "Speed": 11.8,
        "Height": 421,
        "Mileage": 39892156,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 78,
        "EngineRPM": 1193.875,
        "OnboardVoltage": 26762,
        "EngineSpeed": null,
        "TotalMileage": 508174015,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 160,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27061930,
        "Time": "2022-02-22T18:46:00",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.30134,
        "Lon": 86.14358,
        "Speed": 25.9,
        "Height": 16,
        "Mileage": 39897664,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 76,
        "EngineRPM": 1304.125,
        "OnboardVoltage": 26775,
        "EngineSpeed": null,
        "TotalMileage": 508179625,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27064127,
        "Time": "2022-02-22T19:00:33",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.30473,
        "Lon": 86.14321,
        "Speed": 13.1,
        "Height": 74,
        "Mileage": 39899568,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 76,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 26868,
        "EngineSpeed": null,
        "TotalMileage": 508181890,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27066867,
        "Time": "2022-02-22T19:20:33",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3092651,
        "Lon": 86.17115,
        "Speed": 6.6,
        "Height": 431,
        "Mileage": 39904120,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 78,
        "EngineRPM": 1059.25,
        "OnboardVoltage": 26883,
        "EngineSpeed": null,
        "TotalMileage": 508188090,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27068516,
        "Time": "2022-02-22T19:31:37",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3016167,
        "Lon": 86.14232,
        "Speed": 22.4,
        "Height": 11,
        "Mileage": 39909436,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 77,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 26772,
        "EngineSpeed": null,
        "TotalMileage": 508193550,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27071733,
        "Time": "2022-02-22T19:56:09",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3002739,
        "Lon": 86.14617,
        "Speed": 6.2,
        "Height": 39,
        "Mileage": 39910824,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 80,
        "EngineRPM": 1361.0,
        "OnboardVoltage": 26881,
        "EngineSpeed": null,
        "TotalMileage": 508195335,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 36,
        "FuelConsumption": 262,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27074825,
        "Time": "2022-02-22T20:16:51",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3078842,
        "Lon": 86.1711655,
        "Speed": 14.4,
        "Height": 419,
        "Mileage": 39915848,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 77,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 26839,
        "EngineSpeed": null,
        "TotalMileage": 508201730,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 95,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27076459,
        "Time": "2022-02-22T20:28:58",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2999535,
        "Lon": 86.1458054,
        "Speed": 16.2,
        "Height": 35,
        "Mileage": 39921104,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 77,
        "EngineRPM": 1301.375,
        "OnboardVoltage": 27062,
        "EngineSpeed": null,
        "TotalMileage": 508207140,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27078722,
        "Time": "2022-02-22T20:45:21",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3001022,
        "Lon": 86.14618,
        "Speed": 7.0,
        "Height": 28,
        "Mileage": 39922740,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 78,
        "EngineRPM": 1640.375,
        "OnboardVoltage": 26893,
        "EngineSpeed": null,
        "TotalMileage": 508209150,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 69,
        "FuelConsumption": 254,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27081774,
        "Time": "2022-02-22T21:06:06",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3094,
        "Lon": 86.1724243,
        "Speed": 7.9,
        "Height": 426,
        "Mileage": 39927788,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 77,
        "EngineRPM": 1136.75,
        "OnboardVoltage": 26671,
        "EngineSpeed": null,
        "TotalMileage": 508215745,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 76,
        "FuelConsumption": 113,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27083142,
        "Time": "2022-02-22T21:17:33",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.29998,
        "Lon": 86.14573,
        "Speed": 18.8,
        "Height": 37,
        "Mileage": 39933144,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 76,
        "EngineRPM": 1293.625,
        "OnboardVoltage": 26923,
        "EngineSpeed": null,
        "TotalMileage": 508221240,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27085341,
        "Time": "2022-02-22T21:34:28",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.300045,
        "Lon": 86.14529,
        "Speed": 17.2,
        "Height": 26,
        "Mileage": 39934844,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 76,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 26935,
        "EngineSpeed": null,
        "TotalMileage": 508223260,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27087856,
        "Time": "2022-02-22T21:53:54",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3071938,
        "Lon": 86.17077,
        "Speed": 10.9,
        "Height": 419,
        "Mileage": 39939584,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 77,
        "EngineRPM": 1805.625,
        "OnboardVoltage": 26781,
        "EngineSpeed": null,
        "TotalMileage": 508229555,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27089491,
        "Time": "2022-02-22T22:04:24",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3045959,
        "Lon": 86.14283,
        "Speed": 31.6,
        "Height": 74,
        "Mileage": 39944560,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 77,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 26859,
        "EngineSpeed": null,
        "TotalMileage": 508234530,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27093164,
        "Time": "2022-02-22T22:33:55",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3016357,
        "Lon": 86.1425552,
        "Speed": 21.8,
        "Height": 12,
        "Mileage": 39946532,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 80,
        "EngineRPM": 1332.625,
        "OnboardVoltage": 26803,
        "EngineSpeed": null,
        "TotalMileage": 508236965,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27095555,
        "Time": "2022-02-22T22:52:55",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3067169,
        "Lon": 86.16366,
        "Speed": 15.1,
        "Height": 381,
        "Mileage": 39951088,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 77,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 26646,
        "EngineSpeed": null,
        "TotalMileage": 508242795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 405,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27097128,
        "Time": "2022-02-22T23:04:22",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.30582,
        "Lon": 86.13477,
        "Speed": 42.0,
        "Height": 141,
        "Mileage": 39955916,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 78,
        "EngineRPM": 1295.75,
        "OnboardVoltage": 26700,
        "EngineSpeed": null,
        "TotalMileage": 508247915,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27101836,
        "Time": "2022-02-22T23:40:32",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.29913,
        "Lon": 86.144165,
        "Speed": 0.0,
        "Height": -11,
        "Mileage": 39958180,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 78,
        "EngineRPM": 811.75,
        "OnboardVoltage": 27110,
        "EngineSpeed": null,
        "TotalMileage": 508250545,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 11,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27104349,
        "Time": "2022-02-23T00:00:10",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.31048,
        "Lon": 86.13334,
        "Speed": 15.0,
        "Height": 183,
        "Mileage": 39960932,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 79,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 26848,
        "EngineSpeed": null,
        "TotalMileage": 508253860,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 405,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27106509,
        "Time": "2022-02-23T00:18:31",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2938232,
        "Lon": 86.17501,
        "Speed": 40.0,
        "Height": 315,
        "Mileage": 39965924,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1296.0,
        "OnboardVoltage": 26792,
        "EngineSpeed": null,
        "TotalMileage": 508259800,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27108845,
        "Time": "2022-02-23T00:39:27",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2820244,
        "Lon": 86.17955,
        "Speed": 18.5,
        "Height": 281,
        "Mileage": 39969392,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 928.375,
        "OnboardVoltage": 26914,
        "EngineSpeed": null,
        "TotalMileage": 508263495,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 43,
        "FuelConsumption": 128,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27110196,
        "Time": "2022-02-23T00:55:07",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3036423,
        "Lon": 86.1360245,
        "Speed": 32.7,
        "Height": 118,
        "Mileage": 39976400,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1300.875,
        "OnboardVoltage": 26733,
        "EngineSpeed": null,
        "TotalMileage": 508270600,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27115782,
        "Time": "2022-02-23T01:41:46",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3000221,
        "Lon": 86.1454239,
        "Speed": 11.6,
        "Height": 27,
        "Mileage": 39978588,
        "EngineOilPressure": 280,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 77,
        "EngineRPM": 1285.875,
        "OnboardVoltage": 26891,
        "EngineSpeed": null,
        "TotalMileage": 508273240,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 59,
        "FuelConsumption": 177,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118084,
        "Time": "2022-02-23T01:57:33",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.28148,
        "Lon": 86.16649,
        "Speed": 16.6,
        "Height": 17,
        "Mileage": 39985636,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 77,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 26999,
        "EngineSpeed": null,
        "TotalMileage": 508280635,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 70,
        "FuelConsumption": 313,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27119449,
        "Time": "2022-02-23T02:07:53",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2682,
        "Lon": 86.16738,
        "Speed": 17.7,
        "Height": 102,
        "Mileage": 39989552,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1173.75,
        "OnboardVoltage": 26990,
        "EngineSpeed": null,
        "TotalMileage": 508284750,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 66,
        "FuelConsumption": 146,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27128213,
        "Time": "2022-02-23T03:09:49",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.26905,
        "Lon": 86.16594,
        "Speed": 7.0,
        "Height": 98,
        "Mileage": 39990564,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 79,
        "EngineRPM": 930.125,
        "OnboardVoltage": 27032,
        "EngineSpeed": null,
        "TotalMileage": 508285790,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 79,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27130744,
        "Time": "2022-02-23T03:28:25",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.24248,
        "Lon": 86.1425,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": 39995876,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 79,
        "EngineRPM": 750.75,
        "OnboardVoltage": 26926,
        "EngineSpeed": null,
        "TotalMileage": 508292300,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27134412,
        "Time": "2022-02-23T03:54:33",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2570953,
        "Lon": 86.17072,
        "Speed": 10.9,
        "Height": 281,
        "Mileage": 39999404,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 81,
        "EngineRPM": 802.25,
        "OnboardVoltage": 27029,
        "EngineSpeed": null,
        "TotalMileage": 508295950,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 26,
        "FuelConsumption": 55,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27136255,
        "Time": "2022-02-23T04:06:31",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2693253,
        "Lon": 86.17536,
        "Speed": 20.0,
        "Height": 58,
        "Mileage": 40003728,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 77,
        "EngineRPM": 1326.375,
        "OnboardVoltage": 26961,
        "EngineSpeed": null,
        "TotalMileage": 508300450,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 75,
        "FuelConsumption": 229,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27139915,
        "Time": "2022-02-23T04:28:15",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2602272,
        "Lon": 86.17646,
        "Speed": 15.5,
        "Height": 179,
        "Mileage": 40006976,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 78,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 26887,
        "EngineSpeed": null,
        "TotalMileage": 508304335,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27142645,
        "Time": "2022-02-23T04:43:19",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.24216,
        "Lon": 86.142334,
        "Speed": 17.2,
        "Height": 323,
        "Mileage": 40011188,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 1111.875,
        "OnboardVoltage": 26801,
        "EngineSpeed": null,
        "TotalMileage": 508309590,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 160,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27143858,
        "Time": "2022-02-23T04:56:08",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2681046,
        "Lon": 86.17245,
        "Speed": 24.0,
        "Height": 23,
        "Mileage": 40018092,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 77,
        "EngineRPM": 769.0,
        "OnboardVoltage": 26970,
        "EngineSpeed": null,
        "TotalMileage": 508316555,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27145655,
        "Time": "2022-02-23T05:13:46",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2675629,
        "Lon": 86.168,
        "Speed": 14.4,
        "Height": 109,
        "Mileage": 40020696,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 76,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 26944,
        "EngineSpeed": null,
        "TotalMileage": 508319725,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27147838,
        "Time": "2022-02-23T05:30:35",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.24279,
        "Lon": 86.14137,
        "Speed": 7.7,
        "Height": 330,
        "Mileage": 40025796,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 78,
        "EngineRPM": 703.0,
        "OnboardVoltage": 26963,
        "EngineSpeed": null,
        "TotalMileage": 508326100,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27148829,
        "Time": "2022-02-23T05:45:07",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2722626,
        "Lon": 86.1647,
        "Speed": 15.3,
        "Height": 64,
        "Mileage": 40032004,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1300.25,
        "OnboardVoltage": 26983,
        "EngineSpeed": null,
        "TotalMileage": 508332440,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27150894,
        "Time": "2022-02-23T06:00:48",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3009262,
        "Lon": 86.1456,
        "Speed": 21.8,
        "Height": 48,
        "Mileage": 40039696,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 75,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 26826,
        "EngineSpeed": null,
        "TotalMileage": 508340355,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 47,
        "FuelConsumption": 231,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27155770,
        "Time": "2022-02-23T06:37:23",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.3122177,
        "Lon": 86.14664,
        "Speed": 7.4,
        "Height": 266,
        "Mileage": 40042668,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 75,
        "EngineRPM": 1126.75,
        "OnboardVoltage": 27038,
        "EngineSpeed": null,
        "TotalMileage": 508344490,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27159779,
        "Time": "2022-02-23T07:06:24",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.27806,
        "Lon": 86.16875,
        "Speed": 22.0,
        "Height": 5,
        "Mileage": 40049656,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 74,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 26839,
        "EngineSpeed": null,
        "TotalMileage": 508351615,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 57,
        "FuelConsumption": 273,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27162744,
        "Time": "2022-02-23T07:21:49",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2726059,
        "Lon": 86.1647339,
        "Speed": 9.0,
        "Height": 66,
        "Mileage": 40053328,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 26922,
        "EngineSpeed": null,
        "TotalMileage": 508355660,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 99,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27165500,
        "Time": "2022-02-23T07:41:00",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2430077,
        "Lon": 86.1474152,
        "Speed": 5.5,
        "Height": 338,
        "Mileage": 40058856,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 77,
        "EngineRPM": 1709.375,
        "OnboardVoltage": 27055,
        "EngineSpeed": null,
        "TotalMileage": 508362390,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 48,
        "FuelConsumption": 193,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27166468,
        "Time": "2022-02-23T07:51:50",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.25661,
        "Lon": 86.1716,
        "Speed": 20.9,
        "Height": 279,
        "Mileage": 40062772,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 76,
        "EngineRPM": 1437.625,
        "OnboardVoltage": 26948,
        "EngineSpeed": null,
        "TotalMileage": 508366500,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 71,
        "FuelConsumption": 219,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27169595,
        "Time": "2022-02-23T08:13:56",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2697678,
        "Lon": 86.16457,
        "Speed": 9.0,
        "Height": 88,
        "Mileage": 40066012,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 60,
        "EngineRPM": 993.125,
        "OnboardVoltage": 26989,
        "EngineSpeed": null,
        "TotalMileage": 508369885,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27172125,
        "Time": "2022-02-23T08:34:38",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2486572,
        "Lon": 86.157074,
        "Speed": 30.5,
        "Height": 328,
        "Mileage": 40070312,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 59,
        "EngineRPM": 1814.125,
        "OnboardVoltage": 26693,
        "EngineSpeed": null,
        "TotalMileage": 508375215,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 62,
        "FuelConsumption": 275,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27173596,
        "Time": "2022-02-23T08:48:37",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2605438,
        "Lon": 86.1742,
        "Speed": 32.9,
        "Height": 211,
        "Mileage": 40075820,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 60,
        "EngineRPM": 945.125,
        "OnboardVoltage": 26798,
        "EngineSpeed": null,
        "TotalMileage": 508381255,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 36,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27176814,
        "Time": "2022-02-23T09:16:58",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2598534,
        "Lon": 86.17556,
        "Speed": 17.2,
        "Height": 196,
        "Mileage": 40079200,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 54,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 26912,
        "EngineSpeed": null,
        "TotalMileage": 508385195,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27179158,
        "Time": "2022-02-23T09:34:33",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.256073,
        "Lon": 86.16515,
        "Speed": 36.1,
        "Height": 277,
        "Mileage": 40085080,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 62,
        "EngineRPM": 1308.25,
        "OnboardVoltage": 26755,
        "EngineSpeed": null,
        "TotalMileage": 508391790,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27182581,
        "Time": "2022-02-23T09:57:42",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.26604,
        "Lon": 86.16917,
        "Speed": 8.7,
        "Height": 130,
        "Mileage": 40089104,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 58,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 26992,
        "EngineSpeed": null,
        "TotalMileage": 508396345,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 99,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27189843,
        "Time": "2022-02-23T10:15:58",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2428169,
        "Lon": 86.14747,
        "Speed": 21.6,
        "Height": 337,
        "Mileage": 40093976,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 65,
        "EngineRPM": 1184.75,
        "OnboardVoltage": 26786,
        "EngineSpeed": null,
        "TotalMileage": 508402220,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 51,
        "FuelConsumption": 217,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27186714,
        "Time": "2022-02-23T10:28:38",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.26739,
        "Lon": 86.17416,
        "Speed": 21.4,
        "Height": 38,
        "Mileage": 40100316,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 67,
        "EngineRPM": 1145.625,
        "OnboardVoltage": 26792,
        "EngineSpeed": null,
        "TotalMileage": 508408820,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 62,
        "FuelConsumption": 133,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27191475,
        "Time": "2022-02-23T11:06:47",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.26925,
        "Lon": 86.17022,
        "Speed": 20.3,
        "Height": 35,
        "Mileage": 40101684,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 70,
        "EngineRPM": 1387.375,
        "OnboardVoltage": 26978,
        "EngineSpeed": null,
        "TotalMileage": 508410420,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27194992,
        "Time": "2022-02-23T11:27:42",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.243885,
        "Lon": 86.15099,
        "Speed": 35.5,
        "Height": 337,
        "Mileage": 40107476,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 71,
        "EngineRPM": 1674.875,
        "OnboardVoltage": 26737,
        "EngineSpeed": null,
        "TotalMileage": 508417035,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 32,
        "FuelConsumption": 205,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27196264,
        "Time": "2022-02-23T11:43:00",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.26881,
        "Lon": 86.1658554,
        "Speed": 0.0,
        "Height": 102,
        "Mileage": 40113300,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 72,
        "EngineRPM": 1127.0,
        "OnboardVoltage": 27153,
        "EngineSpeed": null,
        "TotalMileage": 508423725,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27199845,
        "Time": "2022-02-23T12:14:43",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.26947,
        "Lon": 86.1777649,
        "Speed": 22.5,
        "Height": 73,
        "Mileage": 40115616,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 74,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 26669,
        "EngineSpeed": null,
        "TotalMileage": 508426160,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 95,
        "FuelConsumption": 346,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27201613,
        "Time": "2022-02-23T12:33:48",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2828636,
        "Lon": 86.17851,
        "Speed": 5.1,
        "Height": 264,
        "Mileage": 40119748,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 79,
        "EngineRPM": 1016.375,
        "OnboardVoltage": 26853,
        "EngineSpeed": null,
        "TotalMileage": 508431275,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27202678,
        "Time": "2022-02-23T12:45:12",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2674828,
        "Lon": 86.17444,
        "Speed": 26.1,
        "Height": 38,
        "Mileage": 40124496,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 73,
        "EngineRPM": 1296.0,
        "OnboardVoltage": 26890,
        "EngineSpeed": null,
        "TotalMileage": 508436190,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27205499,
        "Time": "2022-02-23T13:14:52",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.27916,
        "Lon": 86.14701,
        "Speed": 0.0,
        "Height": 218,
        "Mileage": 40132368,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1125.375,
        "OnboardVoltage": 27042,
        "EngineSpeed": null,
        "TotalMileage": 508444495,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27211416,
        "Time": "2022-02-23T13:58:28",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.24249,
        "Lon": 86.14677,
        "Speed": 10.7,
        "Height": 332,
        "Mileage": 40137720,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 72,
        "EngineRPM": 1613.375,
        "OnboardVoltage": 26683,
        "EngineSpeed": null,
        "TotalMileage": 508450215,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 53,
        "FuelConsumption": 201,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27212852,
        "Time": "2022-02-23T14:10:05",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.25636,
        "Lon": 86.1717453,
        "Speed": 0.0,
        "Height": 279,
        "Mileage": 40141344,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 76,
        "EngineRPM": 663.125,
        "OnboardVoltage": 26982,
        "EngineSpeed": null,
        "TotalMileage": 508454370,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27217842,
        "Time": "2022-02-23T14:47:30",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2508,
        "Lon": 86.15864,
        "Speed": 20.3,
        "Height": 333,
        "Mileage": 40149240,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 75,
        "EngineRPM": 1813.625,
        "OnboardVoltage": 26663,
        "EngineSpeed": null,
        "TotalMileage": 508462865,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 372,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27219890,
        "Time": "2022-02-23T15:03:55",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2763824,
        "Lon": 86.15157,
        "Speed": 35.0,
        "Height": 231,
        "Mileage": 40155868,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 75,
        "EngineRPM": 1269.875,
        "OnboardVoltage": 26722,
        "EngineSpeed": null,
        "TotalMileage": 508470010,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 11,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27223673,
        "Time": "2022-02-23T15:33:11",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2481728,
        "Lon": 86.1411362,
        "Speed": 6.2,
        "Height": 369,
        "Mileage": 40161964,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 73,
        "EngineRPM": 711.625,
        "OnboardVoltage": 26876,
        "EngineSpeed": null,
        "TotalMileage": 508476875,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27228209,
        "Time": "2022-02-23T16:04:16",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2626953,
        "Lon": 86.1554947,
        "Speed": 22.4,
        "Height": 299,
        "Mileage": 40169584,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 72,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 26838,
        "EngineSpeed": null,
        "TotalMileage": 508484850,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27230819,
        "Time": "2022-02-23T16:24:20",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2805939,
        "Lon": 86.14506,
        "Speed": 0.0,
        "Height": 232,
        "Mileage": 40177512,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 72,
        "EngineRPM": 777.875,
        "OnboardVoltage": 27020,
        "EngineSpeed": null,
        "TotalMileage": 508493675,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27234671,
        "Time": "2022-02-23T16:53:51",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2482948,
        "Lon": 86.14069,
        "Speed": 4.4,
        "Height": 356,
        "Mileage": 40182940,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 753.875,
        "OnboardVoltage": 26735,
        "EngineSpeed": null,
        "TotalMileage": 508499545,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27239019,
        "Time": "2022-02-23T17:33:41",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2816467,
        "Lon": 86.14425,
        "Speed": 7.2,
        "Height": 227,
        "Mileage": 40188540,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 75,
        "EngineRPM": 774.0,
        "OnboardVoltage": 26734,
        "EngineSpeed": null,
        "TotalMileage": 508505300,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27245379,
        "Time": "2022-02-23T18:23:27",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2483025,
        "Lon": 86.143486,
        "Speed": 0.0,
        "Height": 359,
        "Mileage": 40193888,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 72,
        "EngineRPM": 1128.125,
        "OnboardVoltage": 27071,
        "EngineSpeed": null,
        "TotalMileage": 508511375,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27251452,
        "Time": "2022-02-23T19:08:54",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2704239,
        "Lon": 86.1551743,
        "Speed": 18.8,
        "Height": 262,
        "Mileage": 40200488,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 73,
        "EngineRPM": 1805.875,
        "OnboardVoltage": 26749,
        "EngineSpeed": null,
        "TotalMileage": 508518315,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 368,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27254129,
        "Time": "2022-02-23T19:28:44",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2730637,
        "Lon": 86.15437,
        "Speed": 32.7,
        "Height": 246,
        "Mileage": 40208128,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 74,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 26718,
        "EngineSpeed": null,
        "TotalMileage": 508526575,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27257668,
        "Time": "2022-02-23T19:54:56",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2481766,
        "Lon": 86.14066,
        "Speed": 7.0,
        "Height": 372,
        "Mileage": 40214580,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 929.0,
        "OnboardVoltage": 26753,
        "EngineSpeed": null,
        "TotalMileage": 508533625,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27261713,
        "Time": "2022-02-23T20:23:43",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.28093,
        "Lon": 86.14505,
        "Speed": 17.2,
        "Height": 234,
        "Mileage": 40220060,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 75,
        "EngineRPM": 1014.25,
        "OnboardVoltage": 26798,
        "EngineSpeed": null,
        "TotalMileage": 508539645,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 25,
        "FuelConsumption": 98,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27264467,
        "Time": "2022-02-23T20:44:00",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2563057,
        "Lon": 86.16057,
        "Speed": 32.0,
        "Height": 293,
        "Mileage": 40227172,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 75,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 26712,
        "EngineSpeed": null,
        "TotalMileage": 508547235,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27267879,
        "Time": "2022-02-23T21:11:43",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2481041,
        "Lon": 86.1407852,
        "Speed": 12.4,
        "Height": 368,
        "Mileage": 40235492,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 72,
        "EngineRPM": 680.875,
        "OnboardVoltage": 26945,
        "EngineSpeed": null,
        "TotalMileage": 508556635,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27271842,
        "Time": "2022-02-23T21:41:12",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.26575,
        "Lon": 86.15643,
        "Speed": 22.7,
        "Height": 282,
        "Mileage": 40242976,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 73,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 26667,
        "EngineSpeed": null,
        "TotalMileage": 508564425,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 52,
        "FuelConsumption": 252,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27274425,
        "Time": "2022-02-23T21:58:58",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2670822,
        "Lon": 86.156,
        "Speed": 34.4,
        "Height": 269,
        "Mileage": 40249564,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 75,
        "EngineRPM": 1298.25,
        "OnboardVoltage": 26859,
        "EngineSpeed": null,
        "TotalMileage": 508571600,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27280471,
        "Time": "2022-02-23T22:40:07",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2479362,
        "Lon": 86.15503,
        "Speed": 29.8,
        "Height": 333,
        "Mileage": 40255648,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 73,
        "EngineRPM": 1488.5,
        "OnboardVoltage": 26622,
        "EngineSpeed": null,
        "TotalMileage": 508578460,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 25,
        "FuelConsumption": 146,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27285389,
        "Time": "2022-02-23T23:14:17",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2816429,
        "Lon": 86.14389,
        "Speed": 5.1,
        "Height": 239,
        "Mileage": 40262024,
        "EngineOilPressure": 264,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 75,
        "EngineRPM": 910.875,
        "OnboardVoltage": 27055,
        "EngineSpeed": null,
        "TotalMileage": 508585435,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27289061,
        "Time": "2022-02-23T23:40:07",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.24825,
        "Lon": 86.14061,
        "Speed": 7.4,
        "Height": 360,
        "Mileage": 40267260,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 75,
        "EngineRPM": 888.75,
        "OnboardVoltage": 26664,
        "EngineSpeed": null,
        "TotalMileage": 508591285,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 70,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27291819,
        "Time": "2022-02-23T23:59:29",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.28054,
        "Lon": 86.14513,
        "Speed": 0.0,
        "Height": 225,
        "Mileage": 40272892,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 76,
        "EngineRPM": 865.0,
        "OnboardVoltage": 27003,
        "EngineSpeed": null,
        "TotalMileage": 508597250,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27295700,
        "Time": "2022-02-24T00:26:45",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2569122,
        "Lon": 86.1710358,
        "Speed": 15.7,
        "Height": 291,
        "Mileage": 40277312,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 72,
        "EngineRPM": 1023.875,
        "OnboardVoltage": 26927,
        "EngineSpeed": null,
        "TotalMileage": 508601990,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 77,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27299173,
        "Time": "2022-02-24T01:05:55",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2421532,
        "Lon": 86.1414948,
        "Speed": 7.2,
        "Height": 327,
        "Mileage": 40280664,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 797.75,
        "OnboardVoltage": 26729,
        "EngineSpeed": null,
        "TotalMileage": 508605545,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27301987,
        "Time": "2022-02-24T01:28:48",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2816162,
        "Lon": 86.14421,
        "Speed": 7.0,
        "Height": 224,
        "Mileage": 40286112,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 75,
        "EngineRPM": 840.625,
        "OnboardVoltage": 26701,
        "EngineSpeed": null,
        "TotalMileage": 508611755,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 14,
        "FuelConsumption": 51,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27305311,
        "Time": "2022-02-24T01:51:10",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2413445,
        "Lon": 86.1440048,
        "Speed": 22.7,
        "Height": 320,
        "Mileage": 40291852,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 74,
        "EngineRPM": 848.125,
        "OnboardVoltage": 26792,
        "EngineSpeed": null,
        "TotalMileage": 508618245,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 35,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27310961,
        "Time": "2022-02-24T02:28:12",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2560158,
        "Lon": 86.1721039,
        "Speed": 13.5,
        "Height": 279,
        "Mileage": 40294956,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 67,
        "EngineRPM": 769.125,
        "OnboardVoltage": 27017,
        "EngineSpeed": null,
        "TotalMileage": 508621765,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27315058,
        "Time": "2022-02-24T02:57:25",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2553024,
        "Lon": 86.16154,
        "Speed": 27.2,
        "Height": 296,
        "Mileage": 40302284,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 58,
        "EngineRPM": 1317.0,
        "OnboardVoltage": 27032,
        "EngineSpeed": null,
        "TotalMileage": 508629455,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27317270,
        "Time": "2022-02-24T03:12:54",
        "TruckId": 831,
        "Imei": "866557056020706",
        "Lat": 54.2619858,
        "Lon": 86.17262,
        "Speed": 30.3,
        "Height": 222,
        "Mileage": 40307844,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 58,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 26966,
        "EngineSpeed": null,
        "TotalMileage": 508635420,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27004208,
        "Time": "2022-02-22T10:53:52",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40957,
        "Lon": 87.3004,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27008538,
        "Time": "2022-02-22T11:26:25",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40957,
        "Lon": 87.3004,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27012841,
        "Time": "2022-02-22T11:59:16",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40957,
        "Lon": 87.3004,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27016621,
        "Time": "2022-02-22T12:31:45",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40957,
        "Lon": 87.3004,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27019721,
        "Time": "2022-02-22T13:02:20",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4099655,
        "Lon": 87.30028,
        "Speed": 0.0,
        "Height": 241,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27022226,
        "Time": "2022-02-22T13:26:35",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4076576,
        "Lon": 87.31906,
        "Speed": 10.0,
        "Height": 260,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27024282,
        "Time": "2022-02-22T13:45:29",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.41035,
        "Lon": 87.29734,
        "Speed": 12.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27027699,
        "Time": "2022-02-22T14:10:58",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4097672,
        "Lon": 87.30029,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27031520,
        "Time": "2022-02-22T14:37:39",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4235649,
        "Lon": 87.41958,
        "Speed": 45.0,
        "Height": 349,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27034638,
        "Time": "2022-02-22T15:01:45",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.5185356,
        "Lon": 87.4360046,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27039147,
        "Time": "2022-02-22T15:34:34",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.5185356,
        "Lon": 87.4360046,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27042558,
        "Time": "2022-02-22T16:04:11",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51794,
        "Lon": 87.43473,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27046942,
        "Time": "2022-02-22T16:37:12",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51794,
        "Lon": 87.43473,
        "Speed": 0.0,
        "Height": 314,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27051126,
        "Time": "2022-02-22T17:09:05",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51737,
        "Lon": 87.43539,
        "Speed": 0.0,
        "Height": 367,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27054714,
        "Time": "2022-02-22T17:41:56",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51787,
        "Lon": 87.43484,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27058154,
        "Time": "2022-02-22T18:13:21",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51853,
        "Lon": 87.43464,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27061383,
        "Time": "2022-02-22T18:41:49",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51809,
        "Lon": 87.435,
        "Speed": 0.0,
        "Height": 261,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27065880,
        "Time": "2022-02-22T19:13:52",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51809,
        "Lon": 87.435,
        "Speed": 0.0,
        "Height": 261,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27070268,
        "Time": "2022-02-22T19:46:42",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51809,
        "Lon": 87.435,
        "Speed": 0.0,
        "Height": 261,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27074196,
        "Time": "2022-02-22T20:12:53",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.512043,
        "Lon": 87.42696,
        "Speed": 23.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27077816,
        "Time": "2022-02-22T20:38:35",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4111137,
        "Lon": 87.32338,
        "Speed": 47.0,
        "Height": 259,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27081851,
        "Time": "2022-02-22T21:07:14",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409668,
        "Lon": 87.3000641,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27086040,
        "Time": "2022-02-22T21:39:51",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409668,
        "Lon": 87.3000641,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27090607,
        "Time": "2022-02-22T22:12:40",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409668,
        "Lon": 87.3000641,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27094400,
        "Time": "2022-02-22T22:45:01",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409668,
        "Lon": 87.3000641,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27098763,
        "Time": "2022-02-22T23:17:44",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409668,
        "Lon": 87.3000641,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27103218,
        "Time": "2022-02-22T23:50:34",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409668,
        "Lon": 87.3000641,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27107309,
        "Time": "2022-02-23T00:23:17",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409668,
        "Lon": 87.3000641,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27109886,
        "Time": "2022-02-23T00:52:47",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4097443,
        "Lon": 87.30046,
        "Speed": 0.0,
        "Height": 237,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27113094,
        "Time": "2022-02-23T01:19:39",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40976,
        "Lon": 87.30021,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27116638,
        "Time": "2022-02-23T01:47:26",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4102745,
        "Lon": 87.30029,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27120008,
        "Time": "2022-02-23T02:11:07",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4259148,
        "Lon": 87.421814,
        "Speed": 43.0,
        "Height": 346,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27122666,
        "Time": "2022-02-23T02:31:33",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4577026,
        "Lon": 87.42564,
        "Speed": 0.0,
        "Height": 319,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27127276,
        "Time": "2022-02-23T03:04:06",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4577026,
        "Lon": 87.42564,
        "Speed": 0.0,
        "Height": 319,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27130845,
        "Time": "2022-02-23T03:29:34",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4546852,
        "Lon": 87.42691,
        "Speed": 39.0,
        "Height": 285,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27132633,
        "Time": "2022-02-23T03:41:31",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4112,
        "Lon": 87.4059143,
        "Speed": 11.0,
        "Height": 345,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27135890,
        "Time": "2022-02-23T04:04:19",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.41168,
        "Lon": 87.40614,
        "Speed": 6.0,
        "Height": 347,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27137871,
        "Time": "2022-02-23T04:15:30",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4108963,
        "Lon": 87.39429,
        "Speed": 0.0,
        "Height": 328,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27140948,
        "Time": "2022-02-23T04:35:02",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4118,
        "Lon": 87.40625,
        "Speed": 0.0,
        "Height": 343,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27145005,
        "Time": "2022-02-23T05:06:41",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4118,
        "Lon": 87.40625,
        "Speed": 0.0,
        "Height": 343,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27148043,
        "Time": "2022-02-23T05:38:09",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4118,
        "Lon": 87.40625,
        "Speed": 0.0,
        "Height": 343,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27151146,
        "Time": "2022-02-23T06:02:31",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.5109367,
        "Lon": 87.42733,
        "Speed": 32.0,
        "Height": 306,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27153161,
        "Time": "2022-02-23T06:16:20",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.5256538,
        "Lon": 87.43829,
        "Speed": 30.0,
        "Height": 348,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27155636,
        "Time": "2022-02-23T06:36:49",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.53474,
        "Lon": 87.4356,
        "Speed": 0.0,
        "Height": 435,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27159890,
        "Time": "2022-02-23T07:06:51",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.53732,
        "Lon": 87.438385,
        "Speed": 26.0,
        "Height": 416,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27162951,
        "Time": "2022-02-23T07:27:26",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.5328331,
        "Lon": 87.4298248,
        "Speed": 0.0,
        "Height": 377,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27165441,
        "Time": "2022-02-23T07:44:49",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.534584,
        "Lon": 87.43588,
        "Speed": 4.0,
        "Height": 432,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27169412,
        "Time": "2022-02-23T08:16:05",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.53459,
        "Lon": 87.43577,
        "Speed": 0.0,
        "Height": 433,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27171987,
        "Time": "2022-02-23T08:36:34",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.52965,
        "Lon": 87.4449,
        "Speed": 44.0,
        "Height": 357,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27174442,
        "Time": "2022-02-23T08:55:24",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4967232,
        "Lon": 87.43723,
        "Speed": 0.0,
        "Height": 362,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27178234,
        "Time": "2022-02-23T09:27:54",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4967232,
        "Lon": 87.43723,
        "Speed": 0.0,
        "Height": 362,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27182284,
        "Time": "2022-02-23T09:55:54",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.43548,
        "Lon": 87.4278,
        "Speed": 46.0,
        "Height": 319,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27185857,
        "Time": "2022-02-23T10:24:27",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4341354,
        "Lon": 87.4291458,
        "Speed": 0.0,
        "Height": 312,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27188557,
        "Time": "2022-02-23T10:45:23",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4098625,
        "Lon": 87.3005447,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27192845,
        "Time": "2022-02-23T11:17:14",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409935,
        "Lon": 87.3003,
        "Speed": 0.0,
        "Height": 241,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27196714,
        "Time": "2022-02-23T11:46:57",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4097939,
        "Lon": 87.30035,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27200307,
        "Time": "2022-02-23T12:19:20",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4097939,
        "Lon": 87.30035,
        "Speed": 0.0,
        "Height": 231,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27202539,
        "Time": "2022-02-23T12:44:15",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4076576,
        "Lon": 87.31929,
        "Speed": 11.0,
        "Height": 258,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27204246,
        "Time": "2022-02-23T13:01:27",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40978,
        "Lon": 87.3002853,
        "Speed": 0.0,
        "Height": 232,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27208130,
        "Time": "2022-02-23T13:33:51",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40978,
        "Lon": 87.3002853,
        "Speed": 0.0,
        "Height": 232,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27211425,
        "Time": "2022-02-23T13:59:34",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4101944,
        "Lon": 87.2993546,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27215958,
        "Time": "2022-02-23T14:32:30",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4101944,
        "Lon": 87.2993546,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27220040,
        "Time": "2022-02-23T15:05:06",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4101944,
        "Lon": 87.2993546,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27224038,
        "Time": "2022-02-23T15:36:05",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4101944,
        "Lon": 87.2993546,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27227233,
        "Time": "2022-02-23T15:56:24",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.41013,
        "Lon": 87.3002243,
        "Speed": 0.0,
        "Height": 236,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27231292,
        "Time": "2022-02-23T16:27:53",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40992,
        "Lon": 87.3004,
        "Speed": 6.0,
        "Height": 239,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27234583,
        "Time": "2022-02-23T16:53:06",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.48832,
        "Lon": 87.44388,
        "Speed": 50.0,
        "Height": 427,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27237341,
        "Time": "2022-02-23T17:17:08",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.5185356,
        "Lon": 87.43609,
        "Speed": 0.0,
        "Height": 318,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27240950,
        "Time": "2022-02-23T17:48:42",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51843,
        "Lon": 87.43536,
        "Speed": 0.0,
        "Height": 316,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27245129,
        "Time": "2022-02-23T18:21:07",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51838,
        "Lon": 87.4349,
        "Speed": 0.0,
        "Height": 303,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27249300,
        "Time": "2022-02-23T18:53:42",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51838,
        "Lon": 87.4349,
        "Speed": 0.0,
        "Height": 303,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27253833,
        "Time": "2022-02-23T19:26:32",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51838,
        "Lon": 87.4349,
        "Speed": 0.0,
        "Height": 303,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27258328,
        "Time": "2022-02-23T19:59:07",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51838,
        "Lon": 87.4349,
        "Speed": 0.0,
        "Height": 303,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27262783,
        "Time": "2022-02-23T20:31:58",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51838,
        "Lon": 87.4349,
        "Speed": 0.0,
        "Height": 303,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27266931,
        "Time": "2022-02-23T21:04:50",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.51838,
        "Lon": 87.4349,
        "Speed": 0.0,
        "Height": 303,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27269804,
        "Time": "2022-02-23T21:26:23",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.52299,
        "Lon": 87.44776,
        "Speed": 0.0,
        "Height": 330,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27272144,
        "Time": "2022-02-23T21:43:25",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4968872,
        "Lon": 87.43707,
        "Speed": 0.0,
        "Height": 363,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27275757,
        "Time": "2022-02-23T22:08:54",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.42712,
        "Lon": 87.42222,
        "Speed": 34.0,
        "Height": 343,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27279581,
        "Time": "2022-02-23T22:34:58",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4099579,
        "Lon": 87.3001862,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27284304,
        "Time": "2022-02-23T23:07:40",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.4099579,
        "Lon": 87.3001862,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27288015,
        "Time": "2022-02-23T23:32:53",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.41081,
        "Lon": 87.29759,
        "Speed": 4.0,
        "Height": 233,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27292026,
        "Time": "2022-02-24T00:00:41",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40965,
        "Lon": 87.30041,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27296036,
        "Time": "2022-02-24T00:30:13",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40995,
        "Lon": 87.30019,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27298746,
        "Time": "2022-02-24T01:02:47",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.40995,
        "Lon": 87.30019,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27302527,
        "Time": "2022-02-24T01:32:19",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409935,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27307432,
        "Time": "2022-02-24T02:04:58",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409935,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27312322,
        "Time": "2022-02-24T02:37:48",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409935,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27316989,
        "Time": "2022-02-24T03:10:23",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409935,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27321696,
        "Time": "2022-02-24T03:43:14",
        "TruckId": null,
        "Imei": "868204005431647",
        "Lat": 53.409935,
        "Lon": 87.30024,
        "Speed": 0.0,
        "Height": 235,
        "Mileage": null,
        "EngineOilPressure": null,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": null,
        "FuelTemperature": null,
        "EngineRPM": null,
        "OnboardVoltage": null,
        "EngineSpeed": null,
        "TotalMileage": null,
        "AcceleratorPedalPosition": null,
        "LoadPercentage": null,
        "FuelConsumption": null,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": null,
        "ServiceBrakePedalPosition": null,
        "TachographSpeed": null,
        "DailyMileage": null,
        "TotalEngineRunningTime": null,
        "DailyFuelConsumption": null,
        "TotalFuelConsumption": null,
        "AxleLoad1": null,
        "AxleLoad2": null,
        "AxleLoad3": null,
        "AxleLoad4": null,
        "AxleLoad5": null,
        "OilTemperature": null,
        "InstantOilConsumption": null,
        "FuelLevel": null
    },
    {
        "Id": 27004161,
        "Time": "2022-02-22T10:53:41",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 54.3081436,
        "Lon": 86.49162,
        "Speed": 78.7,
        "Height": 272,
        "Mileage": 29007110,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14245,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27005602,
        "Time": "2022-02-22T11:05:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 54.44369,
        "Lon": 86.40786,
        "Speed": 82.2,
        "Height": 213,
        "Mileage": 29023270,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14184,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27007389,
        "Time": "2022-02-22T11:17:02",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 54.569355,
        "Lon": 86.3274155,
        "Speed": 82.0,
        "Height": 213,
        "Mileage": 29038866,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14198,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27008991,
        "Time": "2022-02-22T11:29:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 54.6862869,
        "Lon": 86.26972,
        "Speed": 81.6,
        "Height": 256,
        "Mileage": 29053556,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14228,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27010646,
        "Time": "2022-02-22T11:41:15",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 54.8165131,
        "Lon": 86.22343,
        "Speed": 79.6,
        "Height": 242,
        "Mileage": 29069244,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14209,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27012166,
        "Time": "2022-02-22T11:53:25",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 54.9408073,
        "Lon": 86.3332062,
        "Speed": 77.7,
        "Height": 163,
        "Mileage": 29085214,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14270,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27013713,
        "Time": "2022-02-22T12:06:47",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.03888,
        "Lon": 86.27725,
        "Speed": 0.0,
        "Height": 234,
        "Mileage": 29097140,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14087,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27015118,
        "Time": "2022-02-22T12:20:06",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.1390648,
        "Lon": 86.22357,
        "Speed": 74.8,
        "Height": 175,
        "Mileage": 29109114,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14300,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27016747,
        "Time": "2022-02-22T12:33:01",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.2704048,
        "Lon": 86.15704,
        "Speed": 71.3,
        "Height": 217,
        "Mileage": 29125092,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14308,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27017760,
        "Time": "2022-02-22T12:45:44",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.31879,
        "Lon": 86.0696,
        "Speed": 19.4,
        "Height": 142,
        "Mileage": 29135678,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14091,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27018844,
        "Time": "2022-02-22T12:56:26",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3466721,
        "Lon": 86.04941,
        "Speed": 18.8,
        "Height": 143,
        "Mileage": 29140154,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14319,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27020287,
        "Time": "2022-02-22T13:06:58",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3596954,
        "Lon": 86.05017,
        "Speed": 4.8,
        "Height": 142,
        "Mileage": 29142400,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 13007,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27021884,
        "Time": "2022-02-22T13:23:29",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.359745,
        "Lon": 86.0499649,
        "Speed": 0.0,
        "Height": 112,
        "Mileage": 29142448,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12911,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27023244,
        "Time": "2022-02-22T13:36:05",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.36113,
        "Lon": 86.0467,
        "Speed": 13.7,
        "Height": 128,
        "Mileage": 29143214,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14214,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27024685,
        "Time": "2022-02-22T13:49:03",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3629036,
        "Lon": 86.04134,
        "Speed": 0.0,
        "Height": 138,
        "Mileage": 29143742,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12937,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27026618,
        "Time": "2022-02-22T14:03:05",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3626442,
        "Lon": 86.041626,
        "Speed": 0.0,
        "Height": 133,
        "Mileage": 29144476,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12889,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27028792,
        "Time": "2022-02-22T14:18:27",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3626747,
        "Lon": 86.04105,
        "Speed": 0.0,
        "Height": 160,
        "Mileage": 29145116,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12889,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27030647,
        "Time": "2022-02-22T14:31:22",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.36259,
        "Lon": 86.04107,
        "Speed": 0.0,
        "Height": 99,
        "Mileage": 29145884,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12890,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27032639,
        "Time": "2022-02-22T14:47:07",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3620338,
        "Lon": 86.04551,
        "Speed": 26.8,
        "Height": 208,
        "Mileage": 29146738,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12854,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27034580,
        "Time": "2022-02-22T15:01:18",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3624954,
        "Lon": 86.04117,
        "Speed": 0.0,
        "Height": 80,
        "Mileage": 29147704,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12868,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27036550,
        "Time": "2022-02-22T15:15:28",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3623238,
        "Lon": 86.0421143,
        "Speed": 6.2,
        "Height": 176,
        "Mileage": 29148416,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12844,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27038638,
        "Time": "2022-02-22T15:30:17",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3626137,
        "Lon": 86.0414,
        "Speed": 0.0,
        "Height": 201,
        "Mileage": 29148956,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12857,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27040552,
        "Time": "2022-02-22T15:46:38",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.362793,
        "Lon": 86.04392,
        "Speed": 0.0,
        "Height": 166,
        "Mileage": 29149898,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12807,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27042410,
        "Time": "2022-02-22T16:02:52",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12841,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27044806,
        "Time": "2022-02-22T16:19:36",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12828,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27046826,
        "Time": "2022-02-22T16:36:16",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12823,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27048991,
        "Time": "2022-02-22T16:52:56",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12812,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27051179,
        "Time": "2022-02-22T17:09:38",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12812,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27052994,
        "Time": "2022-02-22T17:26:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12800,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27054830,
        "Time": "2022-02-22T17:43:03",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12775,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27056592,
        "Time": "2022-02-22T17:59:43",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12809,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27058507,
        "Time": "2022-02-22T18:16:25",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12780,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27060310,
        "Time": "2022-02-22T18:33:08",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12783,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27062439,
        "Time": "2022-02-22T18:49:48",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12779,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27065014,
        "Time": "2022-02-22T19:06:28",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12755,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27067102,
        "Time": "2022-02-22T19:22:59",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12774,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27069316,
        "Time": "2022-02-22T19:39:39",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12751,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27071771,
        "Time": "2022-02-22T19:56:19",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12763,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27074201,
        "Time": "2022-02-22T20:13:00",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12761,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27076557,
        "Time": "2022-02-22T20:29:41",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12761,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27078822,
        "Time": "2022-02-22T20:46:22",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12694,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27081241,
        "Time": "2022-02-22T21:03:03",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12733,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27083376,
        "Time": "2022-02-22T21:19:43",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12754,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27085580,
        "Time": "2022-02-22T21:36:23",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12725,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27087690,
        "Time": "2022-02-22T21:53:03",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12727,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27090296,
        "Time": "2022-02-22T22:09:45",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12703,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27092273,
        "Time": "2022-02-22T22:26:27",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12710,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27094169,
        "Time": "2022-02-22T22:43:08",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12710,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27096509,
        "Time": "2022-02-22T22:59:49",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12696,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27098602,
        "Time": "2022-02-22T23:16:30",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12686,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27100958,
        "Time": "2022-02-22T23:33:10",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12692,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27103106,
        "Time": "2022-02-22T23:49:50",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12689,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27104989,
        "Time": "2022-02-23T00:06:31",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12670,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27107305,
        "Time": "2022-02-23T00:23:13",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12658,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27108878,
        "Time": "2022-02-23T00:39:54",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12674,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27110356,
        "Time": "2022-02-23T00:56:35",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12674,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27112388,
        "Time": "2022-02-23T01:13:15",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12682,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27114262,
        "Time": "2022-02-23T01:29:58",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12688,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27116498,
        "Time": "2022-02-23T01:46:38",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12663,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118911,
        "Time": "2022-02-23T02:03:18",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12640,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27121175,
        "Time": "2022-02-23T02:19:59",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12679,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27123442,
        "Time": "2022-02-23T02:36:39",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12663,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27125790,
        "Time": "2022-02-23T02:53:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12653,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27128260,
        "Time": "2022-02-23T03:10:01",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12674,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27130395,
        "Time": "2022-02-23T03:26:41",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12650,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27132880,
        "Time": "2022-02-23T03:43:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12665,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27135305,
        "Time": "2022-02-23T04:00:05",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12650,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27138047,
        "Time": "2022-02-23T04:16:47",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12655,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27140714,
        "Time": "2022-02-23T04:33:30",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12654,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27143036,
        "Time": "2022-02-23T04:50:10",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12646,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27145016,
        "Time": "2022-02-23T05:06:52",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12649,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27146636,
        "Time": "2022-02-23T05:23:33",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12640,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27148268,
        "Time": "2022-02-23T05:40:14",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12619,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27150380,
        "Time": "2022-02-23T05:56:56",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12630,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27152787,
        "Time": "2022-02-23T06:13:36",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12664,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27154917,
        "Time": "2022-02-23T06:30:16",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12662,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27157126,
        "Time": "2022-02-23T06:46:56",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12645,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27159362,
        "Time": "2022-02-23T07:03:37",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12664,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27161942,
        "Time": "2022-02-23T07:20:18",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12639,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27164215,
        "Time": "2022-02-23T07:36:58",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12633,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27166709,
        "Time": "2022-02-23T07:53:39",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12641,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27168664,
        "Time": "2022-02-23T08:10:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12648,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27170867,
        "Time": "2022-02-23T08:27:03",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12606,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27172877,
        "Time": "2022-02-23T08:43:44",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12642,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27174990,
        "Time": "2022-02-23T09:00:25",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12626,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27176845,
        "Time": "2022-02-23T09:17:08",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12637,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27179007,
        "Time": "2022-02-23T09:33:49",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12631,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27181375,
        "Time": "2022-02-23T09:50:30",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12637,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27183593,
        "Time": "2022-02-23T10:07:13",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12642,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27185795,
        "Time": "2022-02-23T10:23:53",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12604,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27187782,
        "Time": "2022-02-23T10:40:34",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12605,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27190182,
        "Time": "2022-02-23T10:57:15",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12636,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27192370,
        "Time": "2022-02-23T11:13:55",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12616,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27194543,
        "Time": "2022-02-23T11:30:37",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12631,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27196746,
        "Time": "2022-02-23T11:47:18",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12628,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27198665,
        "Time": "2022-02-23T12:03:59",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12603,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27200463,
        "Time": "2022-02-23T12:20:41",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12629,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27201939,
        "Time": "2022-02-23T12:37:24",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12639,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27203448,
        "Time": "2022-02-23T12:54:04",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12610,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27205113,
        "Time": "2022-02-23T13:10:47",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12613,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27207261,
        "Time": "2022-02-23T13:27:27",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12605,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27209455,
        "Time": "2022-02-23T13:44:07",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12616,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27211533,
        "Time": "2022-02-23T14:00:49",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12615,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27213861,
        "Time": "2022-02-23T14:17:31",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12629,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27216182,
        "Time": "2022-02-23T14:34:11",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12608,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27218230,
        "Time": "2022-02-23T14:50:52",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12632,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27220299,
        "Time": "2022-02-23T15:07:32",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12604,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27222435,
        "Time": "2022-02-23T15:24:12",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12586,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27224789,
        "Time": "2022-02-23T15:40:52",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12614,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27227386,
        "Time": "2022-02-23T15:57:32",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12619,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27229467,
        "Time": "2022-02-23T16:14:13",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12616,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27231644,
        "Time": "2022-02-23T16:30:53",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12616,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27233721,
        "Time": "2022-02-23T16:47:33",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12598,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27236031,
        "Time": "2022-02-23T17:04:15",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12613,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27237674,
        "Time": "2022-02-23T17:20:55",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12617,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27239512,
        "Time": "2022-02-23T17:37:37",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12610,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27241712,
        "Time": "2022-02-23T17:54:17",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12583,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27243791,
        "Time": "2022-02-23T18:10:58",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12587,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27245881,
        "Time": "2022-02-23T18:27:40",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12599,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27248056,
        "Time": "2022-02-23T18:44:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12590,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27250391,
        "Time": "2022-02-23T19:01:01",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12595,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27252626,
        "Time": "2022-02-23T19:17:42",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12600,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27254808,
        "Time": "2022-02-23T19:34:22",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12613,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27257070,
        "Time": "2022-02-23T19:51:02",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12586,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27259426,
        "Time": "2022-02-23T20:07:42",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12590,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27261818,
        "Time": "2022-02-23T20:24:22",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12597,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27264016,
        "Time": "2022-02-23T20:41:03",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12590,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27266053,
        "Time": "2022-02-23T20:57:45",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12581,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27268229,
        "Time": "2022-02-23T21:14:26",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12610,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27270474,
        "Time": "2022-02-23T21:31:06",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12602,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27272783,
        "Time": "2022-02-23T21:47:46",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12576,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27275190,
        "Time": "2022-02-23T22:04:28",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12595,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27277421,
        "Time": "2022-02-23T22:21:08",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12589,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27279958,
        "Time": "2022-02-23T22:37:48",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12582,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27282417,
        "Time": "2022-02-23T22:54:29",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12599,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27284896,
        "Time": "2022-02-23T23:11:09",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12610,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27287264,
        "Time": "2022-02-23T23:27:49",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12590,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27289658,
        "Time": "2022-02-23T23:44:31",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12591,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27292083,
        "Time": "2022-02-24T00:01:12",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12584,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27294453,
        "Time": "2022-02-24T00:17:52",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12614,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27296338,
        "Time": "2022-02-24T00:34:32",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12580,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27297553,
        "Time": "2022-02-24T00:51:14",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12590,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27299359,
        "Time": "2022-02-24T01:07:57",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12604,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27301346,
        "Time": "2022-02-24T01:24:38",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12592,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27303836,
        "Time": "2022-02-24T01:41:18",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12585,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27306253,
        "Time": "2022-02-24T01:57:59",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12583,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27309059,
        "Time": "2022-02-24T02:14:40",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12584,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27311376,
        "Time": "2022-02-24T02:31:20",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12579,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27313714,
        "Time": "2022-02-24T02:48:00",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12579,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27316206,
        "Time": "2022-02-24T03:04:40",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12585,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27318426,
        "Time": "2022-02-24T03:21:21",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3578873,
        "Lon": 86.04553,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 29150610,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 12573,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27320956,
        "Time": "2022-02-24T03:37:55",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3625641,
        "Lon": 86.04151,
        "Speed": 0.0,
        "Height": 140,
        "Mileage": 29150696,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14359,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27322948,
        "Time": "2022-02-24T03:50:03",
        "TruckId": 1977,
        "Imei": "868328057553188",
        "Lat": 55.3623,
        "Lon": 86.04153,
        "Speed": 8.1,
        "Height": 136,
        "Mileage": 29151698,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": -40,
        "FuelTemperature": 0,
        "EngineRPM": 0.0,
        "OnboardVoltage": 14050,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27004196,
        "Time": "2022-02-22T10:53:51",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30071,
        "Lon": 86.14581,
        "Speed": 13.8,
        "Height": 43,
        "Mileage": 48995024,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 83,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27869,
        "EngineSpeed": null,
        "TotalMileage": 95734970,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5644,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27007169,
        "Time": "2022-02-22T11:15:13",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3089943,
        "Lon": 86.17298,
        "Speed": 5.0,
        "Height": 429,
        "Mileage": 49000212,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 84,
        "EngineRPM": 1314.0,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 95740720,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 15,
        "FuelConsumption": 105,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5645,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27011107,
        "Time": "2022-02-22T11:44:48",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3008728,
        "Lon": 86.14547,
        "Speed": 21.4,
        "Height": 39,
        "Mileage": 49005268,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 82,
        "EngineRPM": 1299.625,
        "OnboardVoltage": 27822,
        "EngineSpeed": null,
        "TotalMileage": 95745690,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5645,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27015182,
        "Time": "2022-02-22T12:20:47",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.27589,
        "Lon": 86.17637,
        "Speed": 20.1,
        "Height": 97,
        "Mileage": 49011072,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1805.25,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 95751455,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 82,
        "FuelConsumption": 368,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5646,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27017884,
        "Time": "2022-02-22T12:46:56",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30725,
        "Lon": 86.1629257,
        "Speed": 39.4,
        "Height": 379,
        "Mileage": 49017700,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 85,
        "EngineRPM": 1258.5,
        "OnboardVoltage": 27796,
        "EngineSpeed": null,
        "TotalMileage": 95758145,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5646,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27019768,
        "Time": "2022-02-22T13:02:41",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30013,
        "Lon": 86.14515,
        "Speed": 23.3,
        "Height": 32,
        "Mileage": 49022288,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 86,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27775,
        "EngineSpeed": null,
        "TotalMileage": 95762985,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5646,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27024507,
        "Time": "2022-02-22T13:47:27",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30155,
        "Lon": 86.142334,
        "Speed": 20.5,
        "Height": 23,
        "Mileage": 49023576,
        "EngineOilPressure": 484,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 87,
        "EngineRPM": 1366.0,
        "OnboardVoltage": 27768,
        "EngineSpeed": null,
        "TotalMileage": 95764175,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5647,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27027450,
        "Time": "2022-02-22T14:08:47",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3069839,
        "Lon": 86.17008,
        "Speed": 14.8,
        "Height": 412,
        "Mileage": 49028820,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 86,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 95769985,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5648,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27029008,
        "Time": "2022-02-22T14:20:17",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30446,
        "Lon": 86.14357,
        "Speed": 28.8,
        "Height": 79,
        "Mileage": 49033648,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 82,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 95774885,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5648,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27033274,
        "Time": "2022-02-22T14:51:40",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30142,
        "Lon": 86.14185,
        "Speed": 17.0,
        "Height": 16,
        "Mileage": 49035412,
        "EngineOilPressure": 476,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 85,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27779,
        "EngineSpeed": null,
        "TotalMileage": 95776825,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5648,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.2
    },
    {
        "Id": 27036123,
        "Time": "2022-02-22T15:12:26",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3068542,
        "Lon": 86.1674957,
        "Speed": 13.8,
        "Height": 400,
        "Mileage": 49040520,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1745.5,
        "OnboardVoltage": 27788,
        "EngineSpeed": null,
        "TotalMileage": 95782410,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 369,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5649,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.4
    },
    {
        "Id": 27037874,
        "Time": "2022-02-22T15:24:29",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3002434,
        "Lon": 86.146225,
        "Speed": 22.2,
        "Height": 36,
        "Mileage": 49046320,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 81,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 95787795,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5649,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27041351,
        "Time": "2022-02-22T15:53:22",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3001442,
        "Lon": 86.14519,
        "Speed": 18.5,
        "Height": 29,
        "Mileage": 49047912,
        "EngineOilPressure": 484,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 75,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 95789680,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5649,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27043923,
        "Time": "2022-02-22T16:14:03",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30836,
        "Lon": 86.17205,
        "Speed": 19.2,
        "Height": 427,
        "Mileage": 49053016,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 74,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 95795480,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5650,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.4
    },
    {
        "Id": 27047439,
        "Time": "2022-02-22T16:41:17",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3141136,
        "Lon": 86.14269,
        "Speed": 38.8,
        "Height": 244,
        "Mileage": 49055984,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 65,
        "EngineRPM": 1463.75,
        "OnboardVoltage": 27771,
        "EngineSpeed": null,
        "TotalMileage": 95798220,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 179,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5650,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 65.200005
    },
    {
        "Id": 27048471,
        "Time": "2022-02-22T16:48:48",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2991257,
        "Lon": 86.1445,
        "Speed": 5.1,
        "Height": -4,
        "Mileage": 49059640,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 65,
        "EngineRPM": 994.5,
        "OnboardVoltage": 27804,
        "EngineSpeed": null,
        "TotalMileage": 95802010,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5650,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.8
    },
    {
        "Id": 27054187,
        "Time": "2022-02-22T17:37:25",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3103447,
        "Lon": 86.1329,
        "Speed": 9.8,
        "Height": 186,
        "Mileage": 49062344,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 56,
        "EngineRPM": 1794.75,
        "OnboardVoltage": 27770,
        "EngineSpeed": null,
        "TotalMileage": 95804945,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5651,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.4
    },
    {
        "Id": 27056229,
        "Time": "2022-02-22T17:56:19",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3121567,
        "Lon": 86.15338,
        "Speed": 39.6,
        "Height": 296,
        "Mileage": 49067400,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 63,
        "EngineRPM": 1302.125,
        "OnboardVoltage": 27785,
        "EngineSpeed": null,
        "TotalMileage": 95810225,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 43,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5651,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27058226,
        "Time": "2022-02-22T18:13:57",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2990952,
        "Lon": 86.14441,
        "Speed": 6.8,
        "Height": -7,
        "Mileage": 49071676,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 66,
        "EngineRPM": 943.875,
        "OnboardVoltage": 27874,
        "EngineSpeed": null,
        "TotalMileage": 95814730,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5652,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.6
    },
    {
        "Id": 27061146,
        "Time": "2022-02-22T18:39:56",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31041,
        "Lon": 86.13322,
        "Speed": 10.7,
        "Height": 178,
        "Mileage": 49074428,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 57,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27775,
        "EngineSpeed": null,
        "TotalMileage": 95817680,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5652,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.200005
    },
    {
        "Id": 27063757,
        "Time": "2022-02-22T18:58:11",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3109665,
        "Lon": 86.15364,
        "Speed": 35.9,
        "Height": 304,
        "Mileage": 49079320,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 70,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27729,
        "EngineSpeed": null,
        "TotalMileage": 95822665,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5652,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27066735,
        "Time": "2022-02-22T19:19:38",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2990646,
        "Lon": 86.14432,
        "Speed": 7.2,
        "Height": 1,
        "Mileage": 49083752,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 76,
        "EngineRPM": 823.0,
        "OnboardVoltage": 27813,
        "EngineSpeed": null,
        "TotalMileage": 95827460,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5653,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27070157,
        "Time": "2022-02-22T19:46:01",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3138,
        "Lon": 86.14163,
        "Speed": 16.8,
        "Height": 232,
        "Mileage": 49086916,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 77,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27787,
        "EngineSpeed": null,
        "TotalMileage": 95831035,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5653,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27072601,
        "Time": "2022-02-22T20:02:19",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3135834,
        "Lon": 86.150856,
        "Speed": 33.3,
        "Height": 279,
        "Mileage": 49091528,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 76,
        "EngineRPM": 1386.875,
        "OnboardVoltage": 27778,
        "EngineSpeed": null,
        "TotalMileage": 95835610,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5654,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27074653,
        "Time": "2022-02-22T20:15:41",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2991066,
        "Lon": 86.1442,
        "Speed": 4.2,
        "Height": 2,
        "Mileage": 49095628,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 1202.75,
        "OnboardVoltage": 27858,
        "EngineSpeed": null,
        "TotalMileage": 95839990,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 128,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5654,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27077541,
        "Time": "2022-02-22T20:36:26",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31387,
        "Lon": 86.14195,
        "Speed": 15.7,
        "Height": 239,
        "Mileage": 49098876,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27783,
        "EngineSpeed": null,
        "TotalMileage": 95843670,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5654,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.6
    },
    {
        "Id": 27079721,
        "Time": "2022-02-22T20:52:47",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3109131,
        "Lon": 86.15366,
        "Speed": 39.4,
        "Height": 307,
        "Mileage": 49103232,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 1289.75,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 95847770,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5654,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27082301,
        "Time": "2022-02-22T21:10:34",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2995148,
        "Lon": 86.1443253,
        "Speed": 0.0,
        "Height": -3,
        "Mileage": 49107492,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 85,
        "EngineRPM": 830.0,
        "OnboardVoltage": 27881,
        "EngineSpeed": null,
        "TotalMileage": 95852570,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 59,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5655,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27085147,
        "Time": "2022-02-22T21:33:21",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31014,
        "Lon": 86.1326447,
        "Speed": 14.4,
        "Height": 183,
        "Mileage": 49110236,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 81,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 95855250,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5655,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27087323,
        "Time": "2022-02-22T21:50:08",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.307,
        "Lon": 86.16994,
        "Speed": 28.1,
        "Height": 414,
        "Mileage": 49114024,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 81,
        "EngineRPM": 1045.875,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 95859475,
        "AcceleratorPedalPosition": 43,
        "LoadPercentage": 57,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5655,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27088861,
        "Time": "2022-02-22T22:00:41",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.29976,
        "Lon": 86.1416245,
        "Speed": 23.7,
        "Height": 19,
        "Mileage": 49119344,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 958.25,
        "OnboardVoltage": 27793,
        "EngineSpeed": null,
        "TotalMileage": 95864905,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5655,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27092607,
        "Time": "2022-02-22T22:29:09",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30424,
        "Lon": 86.14047,
        "Speed": 15.3,
        "Height": 99,
        "Mileage": 49121340,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 85,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27785,
        "EngineSpeed": null,
        "TotalMileage": 95867055,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5656,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27095056,
        "Time": "2022-02-22T22:49:34",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3093643,
        "Lon": 86.17121,
        "Speed": 7.7,
        "Height": 434,
        "Mileage": 49125928,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 951.375,
        "OnboardVoltage": 27768,
        "EngineSpeed": null,
        "TotalMileage": 95872155,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5656,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27096798,
        "Time": "2022-02-22T23:01:46",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30126,
        "Lon": 86.14172,
        "Speed": 14.8,
        "Height": 26,
        "Mileage": 49131340,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27772,
        "EngineSpeed": null,
        "TotalMileage": 95877580,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5656,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27102636,
        "Time": "2022-02-22T23:46:30",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.29997,
        "Lon": 86.14562,
        "Speed": 9.2,
        "Height": 38,
        "Mileage": 49132772,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 85,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27779,
        "EngineSpeed": null,
        "TotalMileage": 95878955,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5657,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.2
    },
    {
        "Id": 27105541,
        "Time": "2022-02-23T00:11:14",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3072777,
        "Lon": 86.1708755,
        "Speed": 10.5,
        "Height": 421,
        "Mileage": 49138620,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1799.375,
        "OnboardVoltage": 27826,
        "EngineSpeed": null,
        "TotalMileage": 95884455,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5658,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27108253,
        "Time": "2022-02-23T00:30:42",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3133049,
        "Lon": 86.1471252,
        "Speed": 5.0,
        "Height": 261,
        "Mileage": 49142040,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 845.0,
        "OnboardVoltage": 27741,
        "EngineSpeed": null,
        "TotalMileage": 95888140,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5658,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27110966,
        "Time": "2022-02-23T00:56:52",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2994156,
        "Lon": 86.14283,
        "Speed": 19.0,
        "Height": 6,
        "Mileage": 49145724,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 83,
        "EngineRPM": 1357.375,
        "OnboardVoltage": 27754,
        "EngineSpeed": null,
        "TotalMileage": 95891575,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 50,
        "FuelConsumption": 129,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5658,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27114225,
        "Time": "2022-02-23T01:29:42",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3035851,
        "Lon": 86.1364,
        "Speed": 13.1,
        "Height": 108,
        "Mileage": 49147736,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 87,
        "EngineRPM": 1813.875,
        "OnboardVoltage": 27780,
        "EngineSpeed": null,
        "TotalMileage": 95894030,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 99,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5659,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27116623,
        "Time": "2022-02-23T01:47:25",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.309433,
        "Lon": 86.17258,
        "Speed": 4.2,
        "Height": 430,
        "Mileage": 49152056,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 86,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 95898810,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 9,
        "FuelConsumption": 66,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5659,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27118352,
        "Time": "2022-02-23T01:59:21",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3012,
        "Lon": 86.1415253,
        "Speed": 18.5,
        "Height": 12,
        "Mileage": 49157676,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 87,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27841,
        "EngineSpeed": null,
        "TotalMileage": 95904335,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5659,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27122990,
        "Time": "2022-02-23T02:34:01",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30317,
        "Lon": 86.144104,
        "Speed": 14.4,
        "Height": 61,
        "Mileage": 49159316,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 86,
        "EngineRPM": 1809.0,
        "OnboardVoltage": 27829,
        "EngineSpeed": null,
        "TotalMileage": 95906130,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 390,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5660,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27125803,
        "Time": "2022-02-23T02:53:28",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3095856,
        "Lon": 86.17115,
        "Speed": 9.0,
        "Height": 434,
        "Mileage": 49164148,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 86,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27807,
        "EngineSpeed": null,
        "TotalMileage": 95911540,
        "AcceleratorPedalPosition": 89,
        "LoadPercentage": 99,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5660,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27127431,
        "Time": "2022-02-23T03:05:04",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3002472,
        "Lon": 86.14512,
        "Speed": 25.1,
        "Height": 30,
        "Mileage": 49169312,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 88,
        "EngineRPM": 1309.25,
        "OnboardVoltage": 27851,
        "EngineSpeed": null,
        "TotalMileage": 95916790,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5661,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27131116,
        "Time": "2022-02-23T03:30:49",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3041229,
        "Lon": 86.13575,
        "Speed": 11.8,
        "Height": 125,
        "Mileage": 49171776,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 86,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27834,
        "EngineSpeed": null,
        "TotalMileage": 95919390,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 387,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5661,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.4
    },
    {
        "Id": 27133802,
        "Time": "2022-02-23T03:50:26",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3084641,
        "Lon": 86.17131,
        "Speed": 17.2,
        "Height": 429,
        "Mileage": 49176272,
        "EngineOilPressure": 328,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 85,
        "EngineRPM": 783.25,
        "OnboardVoltage": 27799,
        "EngineSpeed": null,
        "TotalMileage": 95924180,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5661,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.4
    },
    {
        "Id": 27135425,
        "Time": "2022-02-23T04:00:50",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30032,
        "Lon": 86.13982,
        "Speed": 15.1,
        "Height": 16,
        "Mileage": 49181952,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 1298.125,
        "OnboardVoltage": 27820,
        "EngineSpeed": null,
        "TotalMileage": 95929870,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 154,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5661,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.8
    },
    {
        "Id": 27138573,
        "Time": "2022-02-23T04:20:30",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31261,
        "Lon": 86.13948,
        "Speed": 15.5,
        "Height": 223,
        "Mileage": 49185256,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 95933405,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5662,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 35.600002
    },
    {
        "Id": 27141216,
        "Time": "2022-02-23T04:37:13",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31188,
        "Lon": 86.15346,
        "Speed": 38.7,
        "Height": 299,
        "Mileage": 49189908,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27829,
        "EngineSpeed": null,
        "TotalMileage": 95938115,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5662,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27142844,
        "Time": "2022-02-23T04:48:54",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2962646,
        "Lon": 86.14551,
        "Speed": 5.0,
        "Height": -41,
        "Mileage": 49195136,
        "EngineOilPressure": 300,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 956.375,
        "OnboardVoltage": 27764,
        "EngineSpeed": null,
        "TotalMileage": 95943500,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5662,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27145286,
        "Time": "2022-02-23T05:10:04",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3137474,
        "Lon": 86.14545,
        "Speed": 17.0,
        "Height": 254,
        "Mileage": 49199420,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27838,
        "EngineSpeed": null,
        "TotalMileage": 95948225,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 99,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5663,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.6
    },
    {
        "Id": 27146931,
        "Time": "2022-02-23T05:26:23",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3132629,
        "Lon": 86.1469,
        "Speed": 9.4,
        "Height": 266,
        "Mileage": 49204260,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1298.25,
        "OnboardVoltage": 27779,
        "EngineSpeed": null,
        "TotalMileage": 95953135,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5663,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.800001
    },
    {
        "Id": 27150897,
        "Time": "2022-02-23T06:00:46",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30128,
        "Lon": 86.14153,
        "Speed": 20.9,
        "Height": 22,
        "Mileage": 49207868,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 63,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 95956745,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5663,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27153487,
        "Time": "2022-02-23T06:19:08",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3138733,
        "Lon": 86.14295,
        "Speed": 20.7,
        "Height": 241,
        "Mileage": 49211480,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 63,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27830,
        "EngineSpeed": null,
        "TotalMileage": 95960765,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5664,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27155544,
        "Time": "2022-02-23T06:35:58",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3139267,
        "Lon": 86.14431,
        "Speed": 40.1,
        "Height": 249,
        "Mileage": 49216736,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 58,
        "EngineRPM": 853.25,
        "OnboardVoltage": 27836,
        "EngineSpeed": null,
        "TotalMileage": 95965865,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5664,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27157876,
        "Time": "2022-02-23T06:53:06",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3,
        "Lon": 86.14539,
        "Speed": 17.4,
        "Height": 35,
        "Mileage": 49220832,
        "EngineOilPressure": 472,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 61,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27846,
        "EngineSpeed": null,
        "TotalMileage": 95970120,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5664,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27161177,
        "Time": "2022-02-23T07:14:42",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3079529,
        "Lon": 86.17151,
        "Speed": 13.5,
        "Height": 435,
        "Mileage": 49226072,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 60,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27838,
        "EngineSpeed": null,
        "TotalMileage": 95975670,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5665,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27162930,
        "Time": "2022-02-23T07:27:20",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2986946,
        "Lon": 86.14717,
        "Speed": 36.1,
        "Height": 30,
        "Mileage": 49231684,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 60,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27851,
        "EngineSpeed": null,
        "TotalMileage": 95981170,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5665,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27168604,
        "Time": "2022-02-23T08:10:09",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2945137,
        "Lon": 86.14451,
        "Speed": 17.2,
        "Height": -51,
        "Mileage": 49233332,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 71,
        "EngineRPM": 1246.25,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 95982920,
        "AcceleratorPedalPosition": 59,
        "LoadPercentage": 56,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5666,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.0
    },
    {
        "Id": 27171454,
        "Time": "2022-02-23T08:32:39",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30659,
        "Lon": 86.16401,
        "Speed": 11.1,
        "Height": 386,
        "Mileage": 49238904,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 73,
        "EngineRPM": 1579.0,
        "OnboardVoltage": 27862,
        "EngineSpeed": null,
        "TotalMileage": 95989155,
        "AcceleratorPedalPosition": 75,
        "LoadPercentage": 84,
        "FuelConsumption": 330,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5666,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27172948,
        "Time": "2022-02-23T08:44:20",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3035049,
        "Lon": 86.13796,
        "Speed": 38.7,
        "Height": 104,
        "Mileage": 49244128,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 74,
        "EngineRPM": 1288.875,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 95993860,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5666,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27174926,
        "Time": "2022-02-23T08:59:58",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2942924,
        "Lon": 86.1451,
        "Speed": 18.3,
        "Height": -49,
        "Mileage": 49246908,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 79,
        "EngineRPM": 1461.5,
        "OnboardVoltage": 27815,
        "EngineSpeed": null,
        "TotalMileage": 95996955,
        "AcceleratorPedalPosition": 64,
        "LoadPercentage": 60,
        "FuelConsumption": 225,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5666,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27177611,
        "Time": "2022-02-23T09:22:55",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3066521,
        "Lon": 86.16381,
        "Speed": 10.7,
        "Height": 382,
        "Mileage": 49252516,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 78,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27841,
        "EngineSpeed": null,
        "TotalMileage": 96003190,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5667,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27179150,
        "Time": "2022-02-23T09:35:03",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3035927,
        "Lon": 86.13837,
        "Speed": 37.5,
        "Height": 107,
        "Mileage": 49257800,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 81,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27788,
        "EngineSpeed": null,
        "TotalMileage": 96008145,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5667,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27182139,
        "Time": "2022-02-23T09:55:09",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3011932,
        "Lon": 86.14372,
        "Speed": 17.2,
        "Height": 16,
        "Mileage": 49259976,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 82,
        "EngineRPM": 1236.625,
        "OnboardVoltage": 27780,
        "EngineSpeed": null,
        "TotalMileage": 96010455,
        "AcceleratorPedalPosition": 40,
        "LoadPercentage": 38,
        "FuelConsumption": 120,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5667,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27184269,
        "Time": "2022-02-23T10:12:24",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3065376,
        "Lon": 86.1699448,
        "Speed": 22.7,
        "Height": 407,
        "Mileage": 49264504,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 78,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27864,
        "EngineSpeed": null,
        "TotalMileage": 96015700,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5668,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27186173,
        "Time": "2022-02-23T10:27:04",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2991753,
        "Lon": 86.17446,
        "Speed": 31.4,
        "Height": 357,
        "Mileage": 49269900,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 82,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27854,
        "EngineSpeed": null,
        "TotalMileage": 96020850,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 84,
        "FuelConsumption": 350,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5668,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27188513,
        "Time": "2022-02-23T10:45:09",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3034172,
        "Lon": 86.1372,
        "Speed": 33.3,
        "Height": 113,
        "Mileage": 49275452,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 80,
        "EngineRPM": 1302.75,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 96026380,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5668,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27191248,
        "Time": "2022-02-23T11:05:20",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.29997,
        "Lon": 86.1457,
        "Speed": 18.8,
        "Height": 35,
        "Mileage": 49277748,
        "EngineOilPressure": 472,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 83,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 96029015,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5669,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27193858,
        "Time": "2022-02-23T11:25:23",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2990074,
        "Lon": 86.17446,
        "Speed": 17.5,
        "Height": 349,
        "Mileage": 49283160,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 82,
        "EngineRPM": 1310.75,
        "OnboardVoltage": 27778,
        "EngineSpeed": null,
        "TotalMileage": 96035020,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 6,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5669,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27195876,
        "Time": "2022-02-23T11:39:11",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3034935,
        "Lon": 86.1703644,
        "Speed": 32.4,
        "Height": 393,
        "Mileage": 49287996,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 96039910,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5669,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27196945,
        "Time": "2022-02-23T11:48:51",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3015366,
        "Lon": 86.14177,
        "Speed": 21.1,
        "Height": 17,
        "Mileage": 49293832,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 82,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27754,
        "EngineSpeed": null,
        "TotalMileage": 96045505,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5669,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27198811,
        "Time": "2022-02-23T12:05:22",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3064766,
        "Lon": 86.13462,
        "Speed": 12.7,
        "Height": 145,
        "Mileage": 49296208,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1806.125,
        "OnboardVoltage": 27809,
        "EngineSpeed": null,
        "TotalMileage": 96048235,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5670,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27203182,
        "Time": "2022-02-23T12:51:31",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3043327,
        "Lon": 86.14424,
        "Speed": 0.0,
        "Height": 75,
        "Mileage": 49299796,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 83,
        "EngineRPM": 1125.25,
        "OnboardVoltage": 27864,
        "EngineSpeed": null,
        "TotalMileage": 96052140,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5670,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27214313,
        "Time": "2022-02-23T14:20:33",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2992744,
        "Lon": 86.1427,
        "Speed": 11.4,
        "Height": 10,
        "Mileage": 49301136,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 88,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 96053215,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5672,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.0
    },
    {
        "Id": 27217300,
        "Time": "2022-02-23T14:43:23",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3048,
        "Lon": 86.14313,
        "Speed": 13.1,
        "Height": 81,
        "Mileage": 49302788,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 88,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27724,
        "EngineSpeed": null,
        "TotalMileage": 96054820,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5672,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27219882,
        "Time": "2022-02-23T15:03:54",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30897,
        "Lon": 86.17242,
        "Speed": 13.3,
        "Height": 433,
        "Mileage": 49307376,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 88,
        "EngineRPM": 732.25,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 96060120,
        "AcceleratorPedalPosition": 32,
        "LoadPercentage": 75,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5672,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27221283,
        "Time": "2022-02-23T15:15:53",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2937851,
        "Lon": 86.1492538,
        "Speed": 24.4,
        "Height": -21,
        "Mileage": 49313108,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 88,
        "EngineRPM": 1301.375,
        "OnboardVoltage": 27757,
        "EngineSpeed": null,
        "TotalMileage": 96065930,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5673,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27223898,
        "Time": "2022-02-23T15:35:00",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3021965,
        "Lon": 86.14489,
        "Speed": 15.1,
        "Height": 51,
        "Mileage": 49315828,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27732,
        "EngineSpeed": null,
        "TotalMileage": 96068820,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5673,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27227303,
        "Time": "2022-02-23T15:56:13",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30926,
        "Lon": 86.17323,
        "Speed": 7.4,
        "Height": 433,
        "Mileage": 49320968,
        "EngineOilPressure": 292,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1145.125,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 96074395,
        "AcceleratorPedalPosition": 37,
        "LoadPercentage": 42,
        "FuelConsumption": 131,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5673,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.0
    },
    {
        "Id": 27228966,
        "Time": "2022-02-23T16:09:30",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2936974,
        "Lon": 86.14994,
        "Speed": 15.9,
        "Height": -20,
        "Mileage": 49327076,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 86,
        "EngineRPM": 1300.375,
        "OnboardVoltage": 27752,
        "EngineSpeed": null,
        "TotalMileage": 96080330,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5674,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27231954,
        "Time": "2022-02-23T16:33:37",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2938347,
        "Lon": 86.15005,
        "Speed": 11.1,
        "Height": -29,
        "Mileage": 49328772,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 86,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 96082115,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5674,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.8
    },
    {
        "Id": 27235216,
        "Time": "2022-02-23T16:57:56",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30841,
        "Lon": 86.1723251,
        "Speed": 11.8,
        "Height": 424,
        "Mileage": 49334748,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 86,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 96088620,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 389,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5674,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.4
    },
    {
        "Id": 27238033,
        "Time": "2022-02-23T17:25:22",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31308,
        "Lon": 86.1466141,
        "Speed": 13.5,
        "Height": 253,
        "Mileage": 49337552,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 71,
        "EngineRPM": 916.125,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 96091445,
        "AcceleratorPedalPosition": 25,
        "LoadPercentage": 35,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5675,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27242397,
        "Time": "2022-02-23T17:59:35",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3016624,
        "Lon": 86.14233,
        "Speed": 19.8,
        "Height": 10,
        "Mileage": 49341100,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 61,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 96095065,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5675,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.200005
    },
    {
        "Id": 27244812,
        "Time": "2022-02-23T18:19:01",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3036156,
        "Lon": 86.13757,
        "Speed": 15.1,
        "Height": 111,
        "Mileage": 49343464,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 57,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 96097705,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5676,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27247311,
        "Time": "2022-02-23T18:39:02",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3083572,
        "Lon": 86.1716156,
        "Speed": 20.1,
        "Height": 429,
        "Mileage": 49347980,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 61,
        "EngineRPM": 770.125,
        "OnboardVoltage": 27719,
        "EngineSpeed": null,
        "TotalMileage": 96102595,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 18,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5676,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27248874,
        "Time": "2022-02-23T18:50:41",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.300457,
        "Lon": 86.13988,
        "Speed": 27.0,
        "Height": 11,
        "Mileage": 49353428,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 63,
        "EngineRPM": 837.0,
        "OnboardVoltage": 27790,
        "EngineSpeed": null,
        "TotalMileage": 96108185,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 50,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5676,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27251067,
        "Time": "2022-02-23T19:05:36",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31008,
        "Lon": 86.13261,
        "Speed": 15.1,
        "Height": 185,
        "Mileage": 49356392,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 62,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27792,
        "EngineSpeed": null,
        "TotalMileage": 96111550,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5677,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27253358,
        "Time": "2022-02-23T19:22:47",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3069534,
        "Lon": 86.16958,
        "Speed": 20.3,
        "Height": 412,
        "Mileage": 49360184,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 65,
        "EngineRPM": 1300.25,
        "OnboardVoltage": 27783,
        "EngineSpeed": null,
        "TotalMileage": 96115750,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5677,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27255063,
        "Time": "2022-02-23T19:36:19",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.295753500000004,
        "Lon": 86.1437,
        "Speed": 12.0,
        "Height": -51,
        "Mileage": 49366332,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 70,
        "EngineRPM": 774.0,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 96121980,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5677,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27257723,
        "Time": "2022-02-23T19:55:13",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3037567,
        "Lon": 86.1361542,
        "Speed": 10.7,
        "Height": 118,
        "Mileage": 49369232,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 73,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 96125160,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5677,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.0
    },
    {
        "Id": 27260403,
        "Time": "2022-02-23T20:15:25",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3072052,
        "Lon": 86.1629944,
        "Speed": 38.8,
        "Height": 377,
        "Mileage": 49374196,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 79,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27746,
        "EngineSpeed": null,
        "TotalMileage": 96130390,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5678,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.0
    },
    {
        "Id": 27263683,
        "Time": "2022-02-23T20:38:31",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.29981,
        "Lon": 86.13755,
        "Speed": 4.4,
        "Height": 28,
        "Mileage": 49379292,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 808.875,
        "OnboardVoltage": 27831,
        "EngineSpeed": null,
        "TotalMileage": 96135755,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5678,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27265528,
        "Time": "2022-02-23T20:53:19",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3103027,
        "Lon": 86.13301,
        "Speed": 10.3,
        "Height": 184,
        "Mileage": 49382112,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 78,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 96138860,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5678,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27267592,
        "Time": "2022-02-23T21:09:54",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30689,
        "Lon": 86.1638,
        "Speed": 34.0,
        "Height": 383,
        "Mileage": 49386044,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 78,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27771,
        "EngineSpeed": null,
        "TotalMileage": 96142635,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5679,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27270289,
        "Time": "2022-02-23T21:29:44",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30028,
        "Lon": 86.13785,
        "Speed": 4.6,
        "Height": 17,
        "Mileage": 49391108,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 83,
        "EngineRPM": 671.875,
        "OnboardVoltage": 27766,
        "EngineSpeed": null,
        "TotalMileage": 96148485,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 34,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5679,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27272595,
        "Time": "2022-02-23T21:46:29",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30941,
        "Lon": 86.13274,
        "Speed": 12.4,
        "Height": 168,
        "Mileage": 49393960,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 80,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27797,
        "EngineSpeed": null,
        "TotalMileage": 96151435,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5679,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27275183,
        "Time": "2022-02-23T22:04:22",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3070564,
        "Lon": 86.16339,
        "Speed": 35.0,
        "Height": 378,
        "Mileage": 49398268,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1306.0,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 96155915,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5680,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27277039,
        "Time": "2022-02-23T22:18:08",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2959862,
        "Lon": 86.14571,
        "Speed": 4.0,
        "Height": -39,
        "Mileage": 49404020,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 81,
        "EngineRPM": 657.75,
        "OnboardVoltage": 27842,
        "EngineSpeed": null,
        "TotalMileage": 96162100,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5680,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 65.6
    },
    {
        "Id": 27279840,
        "Time": "2022-02-23T22:36:52",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3081169,
        "Lon": 86.13354,
        "Speed": 15.3,
        "Height": 151,
        "Mileage": 49407248,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 80,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27781,
        "EngineSpeed": null,
        "TotalMileage": 96165345,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5680,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27282565,
        "Time": "2022-02-23T22:55:20",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30701,
        "Lon": 86.16991,
        "Speed": 24.4,
        "Height": 412,
        "Mileage": 49411368,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 1293.375,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 96169675,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5680,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27284150,
        "Time": "2022-02-23T23:06:46",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30007,
        "Lon": 86.1376648,
        "Speed": 0.0,
        "Height": 15,
        "Mileage": 49416808,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 82,
        "EngineRPM": 825.25,
        "OnboardVoltage": 27842,
        "EngineSpeed": null,
        "TotalMileage": 96175490,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5681,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27286943,
        "Time": "2022-02-23T23:25:27",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3103828,
        "Lon": 86.1329346,
        "Speed": 10.0,
        "Height": 189,
        "Mileage": 49419680,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 81,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27774,
        "EngineSpeed": null,
        "TotalMileage": 96178510,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5681,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27289270,
        "Time": "2022-02-23T23:41:24",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3076172,
        "Lon": 86.1709442,
        "Speed": 25.0,
        "Height": 422,
        "Mileage": 49423200,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 832.5,
        "OnboardVoltage": 27781,
        "EngineSpeed": null,
        "TotalMileage": 96182270,
        "AcceleratorPedalPosition": 19,
        "LoadPercentage": 73,
        "FuelConsumption": 104,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5681,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27291073,
        "Time": "2022-02-23T23:53:33",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.29454,
        "Lon": 86.14659,
        "Speed": 16.1,
        "Height": -50,
        "Mileage": 49429200,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 82,
        "EngineRPM": 1304.75,
        "OnboardVoltage": 27783,
        "EngineSpeed": null,
        "TotalMileage": 96188240,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5681,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27293942,
        "Time": "2022-02-24T00:14:09",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.303960000000004,
        "Lon": 86.1437759,
        "Speed": 9.4,
        "Height": 70,
        "Mileage": 49431976,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 1676.5,
        "OnboardVoltage": 27730,
        "EngineSpeed": null,
        "TotalMileage": 96191105,
        "AcceleratorPedalPosition": 83,
        "LoadPercentage": 82,
        "FuelConsumption": 325,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5682,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27298151,
        "Time": "2022-02-24T00:57:06",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30993,
        "Lon": 86.15699,
        "Speed": 11.8,
        "Height": 332,
        "Mileage": 49435560,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27745,
        "EngineSpeed": null,
        "TotalMileage": 96194975,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5682,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27299533,
        "Time": "2022-02-24T01:09:15",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3128967,
        "Lon": 86.13952,
        "Speed": 41.1,
        "Height": 233,
        "Mileage": 49439948,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 86,
        "EngineRPM": 829.875,
        "OnboardVoltage": 27726,
        "EngineSpeed": null,
        "TotalMileage": 96199035,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5683,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27302256,
        "Time": "2022-02-24T01:30:26",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.2994537,
        "Lon": 86.14186,
        "Speed": 15.9,
        "Height": 9,
        "Mileage": 49443416,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 87,
        "EngineRPM": 1503.375,
        "OnboardVoltage": 27793,
        "EngineSpeed": null,
        "TotalMileage": 96202510,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 69,
        "FuelConsumption": 253,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5683,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27305069,
        "Time": "2022-02-24T01:49:31",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3068771,
        "Lon": 86.1631851,
        "Speed": 17.4,
        "Height": 373,
        "Mileage": 49448200,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 85,
        "EngineRPM": 1753.625,
        "OnboardVoltage": 27869,
        "EngineSpeed": null,
        "TotalMileage": 96207950,
        "AcceleratorPedalPosition": 90,
        "LoadPercentage": 93,
        "FuelConsumption": 342,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5683,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27306805,
        "Time": "2022-02-24T02:01:22",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3061447,
        "Lon": 86.13558,
        "Speed": 19.6,
        "Height": 142,
        "Mileage": 49453172,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 86,
        "EngineRPM": 1301.375,
        "OnboardVoltage": 27829,
        "EngineSpeed": null,
        "TotalMileage": 96212740,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5683,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27309255,
        "Time": "2022-02-24T02:15:42",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31022,
        "Lon": 86.1326,
        "Speed": 12.2,
        "Height": 183,
        "Mileage": 49454816,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 85,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27879,
        "EngineSpeed": null,
        "TotalMileage": 96214475,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 377,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5684,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.0
    },
    {
        "Id": 27311684,
        "Time": "2022-02-24T02:33:24",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3071938,
        "Lon": 86.16304,
        "Speed": 36.4,
        "Height": 374,
        "Mileage": 49459156,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 85,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27844,
        "EngineSpeed": null,
        "TotalMileage": 96218880,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5684,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27313242,
        "Time": "2022-02-24T02:43:25",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3078957,
        "Lon": 86.13653,
        "Speed": 17.5,
        "Height": 150,
        "Mileage": 49463200,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 1250.625,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 96222800,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5684,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.8
    },
    {
        "Id": 27315496,
        "Time": "2022-02-24T03:00:17",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3084068,
        "Lon": 86.17271,
        "Speed": 13.8,
        "Height": 430,
        "Mileage": 49467428,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1777.75,
        "OnboardVoltage": 27795,
        "EngineSpeed": null,
        "TotalMileage": 96227375,
        "AcceleratorPedalPosition": 95,
        "LoadPercentage": 100,
        "FuelConsumption": 347,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5684,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.600002
    },
    {
        "Id": 27316951,
        "Time": "2022-02-24T03:10:03",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.30791,
        "Lon": 86.13646,
        "Speed": 16.4,
        "Height": 154,
        "Mileage": 49471884,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 1260.375,
        "OnboardVoltage": 27825,
        "EngineSpeed": null,
        "TotalMileage": 96231480,
        "AcceleratorPedalPosition": 59,
        "LoadPercentage": 31,
        "FuelConsumption": 121,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5685,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27319613,
        "Time": "2022-02-24T03:29:12",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.3107529,
        "Lon": 86.1533356,
        "Speed": 13.3,
        "Height": 317,
        "Mileage": 49474968,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 82,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27850,
        "EngineSpeed": null,
        "TotalMileage": 96234910,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 390,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5685,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27321999,
        "Time": "2022-02-24T03:44:58",
        "TruckId": 1743,
        "Imei": "868328058741436",
        "Lat": 54.31397,
        "Lon": 86.14166,
        "Speed": 31.6,
        "Height": 246,
        "Mileage": 49479420,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 81,
        "EngineRPM": 1291.75,
        "OnboardVoltage": 27757,
        "EngineSpeed": null,
        "TotalMileage": 96239195,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5685,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 29.2
    },
    {
        "Id": 27004283,
        "Time": "2022-02-22T10:54:31",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30169,
        "Lon": 86.14297,
        "Speed": 0.0,
        "Height": 11,
        "Mileage": 52477632,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 106,
        "EngineRPM": 659.0,
        "OnboardVoltage": 27757,
        "EngineSpeed": null,
        "TotalMileage": 2200520,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27011684,
        "Time": "2022-02-22T11:47:19",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3118629,
        "Lon": 86.15321,
        "Speed": 28.3,
        "Height": 292,
        "Mileage": 52481528,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 102,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27707,
        "EngineSpeed": null,
        "TotalMileage": 2203940,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 85,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27013167,
        "Time": "2022-02-22T12:01:41",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.27816,
        "Lon": 86.18816,
        "Speed": 11.2,
        "Height": 252,
        "Mileage": 52489088,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 105,
        "EngineRPM": 1311.5,
        "OnboardVoltage": 27757,
        "EngineSpeed": null,
        "TotalMileage": 2211060,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 79,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.8
    },
    {
        "Id": 27017252,
        "Time": "2022-02-22T12:39:03",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3069534,
        "Lon": 86.1696548,
        "Speed": 16.6,
        "Height": 415,
        "Mileage": 52493392,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 108,
        "EngineRPM": 1213.625,
        "OnboardVoltage": 27656,
        "EngineSpeed": null,
        "TotalMileage": 2215035,
        "AcceleratorPedalPosition": 64,
        "LoadPercentage": 42,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.800001
    },
    {
        "Id": 27019141,
        "Time": "2022-02-22T12:59:08",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.294632,
        "Lon": 86.14723,
        "Speed": 28.8,
        "Height": -32,
        "Mileage": 52499028,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1290.75,
        "OnboardVoltage": 27606,
        "EngineSpeed": null,
        "TotalMileage": 2220445,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.8
    },
    {
        "Id": 27022266,
        "Time": "2022-02-22T13:26:54",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29363,
        "Lon": 86.15016,
        "Speed": 10.5,
        "Height": -15,
        "Mileage": 52500532,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 104,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27593,
        "EngineSpeed": null,
        "TotalMileage": 2221995,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 359,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.2
    },
    {
        "Id": 27024494,
        "Time": "2022-02-22T13:47:28",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30658,
        "Lon": 86.1639938,
        "Speed": 10.9,
        "Height": 387,
        "Mileage": 52505688,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27661,
        "EngineSpeed": null,
        "TotalMileage": 2226985,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 370,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 25.6
    },
    {
        "Id": 27025951,
        "Time": "2022-02-22T13:57:49",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.313606300000004,
        "Lon": 86.14704,
        "Speed": 17.7,
        "Height": 260,
        "Mileage": 52508820,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 107,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27768,
        "EngineSpeed": null,
        "TotalMileage": 2229855,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 26.4
    },
    {
        "Id": 27030089,
        "Time": "2022-02-22T14:27:09",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2945938,
        "Lon": 86.14705,
        "Speed": 28.1,
        "Height": -42,
        "Mileage": 52513188,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 76,
        "EngineRPM": 1295.0,
        "OnboardVoltage": 27492,
        "EngineSpeed": null,
        "TotalMileage": 2233980,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27032592,
        "Time": "2022-02-22T14:46:36",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3002625,
        "Lon": 86.14626,
        "Speed": 17.5,
        "Height": 33,
        "Mileage": 52515456,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 57,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27641,
        "EngineSpeed": null,
        "TotalMileage": 2236050,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 85,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27035412,
        "Time": "2022-02-22T15:07:11",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3069572,
        "Lon": 86.17013,
        "Speed": 16.8,
        "Height": 416,
        "Mileage": 52520504,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 57,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27649,
        "EngineSpeed": null,
        "TotalMileage": 2240970,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.8
    },
    {
        "Id": 27037064,
        "Time": "2022-02-22T15:18:53",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30461,
        "Lon": 86.1431656,
        "Speed": 35.3,
        "Height": 78,
        "Mileage": 52525752,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 60,
        "EngineRPM": 1306.0,
        "OnboardVoltage": 27520,
        "EngineSpeed": null,
        "TotalMileage": 2245405,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27039926,
        "Time": "2022-02-22T15:40:55",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29362,
        "Lon": 86.14964,
        "Speed": 10.3,
        "Height": -14,
        "Mileage": 52528656,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 63,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27586,
        "EngineSpeed": null,
        "TotalMileage": 2248375,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27042064,
        "Time": "2022-02-22T15:59:59",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3098,
        "Lon": 86.15792,
        "Speed": 9.4,
        "Height": 341,
        "Mileage": 52533384,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 61,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27527,
        "EngineSpeed": null,
        "TotalMileage": 2253040,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27043792,
        "Time": "2022-02-22T16:14:11",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30796,
        "Lon": 86.13339,
        "Speed": 41.8,
        "Height": 159,
        "Mileage": 52538564,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 61,
        "EngineRPM": 1080.375,
        "OnboardVoltage": 27636,
        "EngineSpeed": null,
        "TotalMileage": 2257345,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.8
    },
    {
        "Id": 27048466,
        "Time": "2022-02-22T16:48:47",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2965279,
        "Lon": 86.14433,
        "Speed": 11.8,
        "Height": -42,
        "Mileage": 52541972,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 82,
        "EngineRPM": 726.25,
        "OnboardVoltage": 27660,
        "EngineSpeed": null,
        "TotalMileage": 2260800,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27050572,
        "Time": "2022-02-22T17:05:17",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3138657,
        "Lon": 86.1416855,
        "Speed": 15.0,
        "Height": 244,
        "Mileage": 52545964,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 82,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27507,
        "EngineSpeed": null,
        "TotalMileage": 2264725,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27051984,
        "Time": "2022-02-22T17:16:57",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3092079,
        "Lon": 86.17294,
        "Speed": 4.4,
        "Height": 430,
        "Mileage": 52548768,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 90,
        "EngineRPM": 1361.375,
        "OnboardVoltage": 27586,
        "EngineSpeed": null,
        "TotalMileage": 2267395,
        "AcceleratorPedalPosition": 48,
        "LoadPercentage": 36,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27053295,
        "Time": "2022-02-22T17:29:00",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29441,
        "Lon": 86.1496,
        "Speed": 31.1,
        "Height": -12,
        "Mileage": 52554824,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 90,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27507,
        "EngineSpeed": null,
        "TotalMileage": 2272560,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27059311,
        "Time": "2022-02-22T18:24:09",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29616,
        "Lon": 86.14502,
        "Speed": 0.0,
        "Height": -43,
        "Mileage": 52555784,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 92,
        "EngineRPM": 788.0,
        "OnboardVoltage": 27622,
        "EngineSpeed": null,
        "TotalMileage": 2273795,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27061609,
        "Time": "2022-02-22T18:43:39",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3120651,
        "Lon": 86.1387939,
        "Speed": 15.5,
        "Height": 216,
        "Mileage": 52559488,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 99,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27578,
        "EngineSpeed": null,
        "TotalMileage": 2277385,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 83,
        "FuelConsumption": 367,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27063881,
        "Time": "2022-02-22T18:59:13",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3071,
        "Lon": 86.16759,
        "Speed": 33.1,
        "Height": 403,
        "Mileage": 52563064,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 100,
        "EngineRPM": 1302.75,
        "OnboardVoltage": 27641,
        "EngineSpeed": null,
        "TotalMileage": 2280515,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27065422,
        "Time": "2022-02-22T19:09:29",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2948532,
        "Lon": 86.14436,
        "Speed": 17.7,
        "Height": -51,
        "Mileage": 52569104,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 1298.375,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 2286135,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27067435,
        "Time": "2022-02-22T19:25:34",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3039436,
        "Lon": 86.1357,
        "Speed": 10.9,
        "Height": 119,
        "Mileage": 52572060,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1806.5,
        "OnboardVoltage": 27672,
        "EngineSpeed": null,
        "TotalMileage": 2289115,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 85,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20382,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27070261,
        "Time": "2022-02-22T19:43:44",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.309288,
        "Lon": 86.17287,
        "Speed": 5.7,
        "Height": 428,
        "Mileage": 52576428,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 103,
        "EngineRPM": 969.875,
        "OnboardVoltage": 27695,
        "EngineSpeed": null,
        "TotalMileage": 2293300,
        "AcceleratorPedalPosition": 35,
        "LoadPercentage": 19,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27071776,
        "Time": "2022-02-22T19:56:21",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.293705,
        "Lon": 86.14983,
        "Speed": 15.1,
        "Height": -20,
        "Mileage": 52582440,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 101,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27626,
        "EngineSpeed": null,
        "TotalMileage": 2298805,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 65.200005
    },
    {
        "Id": 27074623,
        "Time": "2022-02-22T20:15:29",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29378,
        "Lon": 86.1501846,
        "Speed": 12.2,
        "Height": -24,
        "Mileage": 52584104,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 102,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27631,
        "EngineSpeed": null,
        "TotalMileage": 2300450,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 359,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27077695,
        "Time": "2022-02-22T20:37:44",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30666,
        "Lon": 86.16365,
        "Speed": 12.5,
        "Height": 369,
        "Mileage": 52589552,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 107,
        "EngineRPM": 1814.125,
        "OnboardVoltage": 27548,
        "EngineSpeed": null,
        "TotalMileage": 2305570,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 372,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27079140,
        "Time": "2022-02-22T20:48:40",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3140831,
        "Lon": 86.1422,
        "Speed": 32.5,
        "Height": 244,
        "Mileage": 52592932,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 106,
        "EngineRPM": 1297.125,
        "OnboardVoltage": 27577,
        "EngineSpeed": null,
        "TotalMileage": 2308470,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27081155,
        "Time": "2022-02-22T21:02:01",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29626,
        "Lon": 86.14557,
        "Speed": 4.0,
        "Height": -43,
        "Mileage": 52597128,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 105,
        "EngineRPM": 647.0,
        "OnboardVoltage": 27513,
        "EngineSpeed": null,
        "TotalMileage": 2312840,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 129,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27086359,
        "Time": "2022-02-22T21:42:31",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3093338,
        "Lon": 86.13272,
        "Speed": 10.1,
        "Height": 171,
        "Mileage": 52600780,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27644,
        "EngineSpeed": null,
        "TotalMileage": 2316030,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 366,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27088917,
        "Time": "2022-02-22T22:01:04",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3124,
        "Lon": 86.13897,
        "Speed": 40.5,
        "Height": 220,
        "Mileage": 52606716,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 108,
        "EngineRPM": 767.75,
        "OnboardVoltage": 27642,
        "EngineSpeed": null,
        "TotalMileage": 2321185,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 62,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27090432,
        "Time": "2022-02-22T22:10:52",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29631,
        "Lon": 86.14573,
        "Speed": 4.6,
        "Height": -44,
        "Mileage": 52610636,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 108,
        "EngineRPM": 943.125,
        "OnboardVoltage": 27570,
        "EngineSpeed": null,
        "TotalMileage": 2325140,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27092374,
        "Time": "2022-02-22T22:27:16",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3081436,
        "Lon": 86.13357,
        "Speed": 15.1,
        "Height": 157,
        "Mileage": 52613728,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 108,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27479,
        "EngineSpeed": null,
        "TotalMileage": 2328085,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27094306,
        "Time": "2022-02-22T22:43:58",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.31341,
        "Lon": 86.14044,
        "Speed": 40.0,
        "Height": 236,
        "Mileage": 52619300,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 108,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27648,
        "EngineSpeed": null,
        "TotalMileage": 2333070,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27097831,
        "Time": "2022-02-22T23:10:35",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2963676,
        "Lon": 86.14563,
        "Speed": 10.9,
        "Height": -41,
        "Mileage": 52623388,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 107,
        "EngineRPM": 671.25,
        "OnboardVoltage": 27604,
        "EngineSpeed": null,
        "TotalMileage": 2337330,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 59,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27100218,
        "Time": "2022-02-22T23:28:37",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.31024,
        "Lon": 86.13281,
        "Speed": 12.5,
        "Height": 182,
        "Mileage": 52626792,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 108,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27632,
        "EngineSpeed": null,
        "TotalMileage": 2340565,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27102525,
        "Time": "2022-02-22T23:45:49",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3071022,
        "Lon": 86.17033,
        "Speed": 25.0,
        "Height": 410,
        "Mileage": 52630600,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 108,
        "EngineRPM": 1272.75,
        "OnboardVoltage": 27653,
        "EngineSpeed": null,
        "TotalMileage": 2343995,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.8
    },
    {
        "Id": 27103955,
        "Time": "2022-02-22T23:56:33",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2945824,
        "Lon": 86.14442,
        "Speed": 20.9,
        "Height": -49,
        "Mileage": 52636704,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 108,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27540,
        "EngineSpeed": null,
        "TotalMileage": 2349810,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27107946,
        "Time": "2022-02-23T00:27:33",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2937164,
        "Lon": 86.15,
        "Speed": 7.7,
        "Height": -15,
        "Mileage": 52638036,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 104,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27614,
        "EngineSpeed": null,
        "TotalMileage": 2351040,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27114383,
        "Time": "2022-02-23T01:31:04",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3104668,
        "Lon": 86.13326,
        "Speed": 12.4,
        "Height": 187,
        "Mileage": 52640944,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 106,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27834,
        "EngineSpeed": null,
        "TotalMileage": 2353700,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27116813,
        "Time": "2022-02-23T01:48:48",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30737,
        "Lon": 86.17074,
        "Speed": 20.5,
        "Height": 419,
        "Mileage": 52644864,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 108,
        "EngineRPM": 733.125,
        "OnboardVoltage": 27866,
        "EngineSpeed": null,
        "TotalMileage": 2357200,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.0
    },
    {
        "Id": 27118422,
        "Time": "2022-02-23T01:59:46",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29369,
        "Lon": 86.1496353,
        "Speed": 16.6,
        "Height": -30,
        "Mileage": 52650248,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 108,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27740,
        "EngineSpeed": null,
        "TotalMileage": 2362500,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.0
    },
    {
        "Id": 27122422,
        "Time": "2022-02-23T02:29:56",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2945633,
        "Lon": 86.14726,
        "Speed": 18.5,
        "Height": -32,
        "Mileage": 52651632,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 106,
        "EngineRPM": 1815.625,
        "OnboardVoltage": 27817,
        "EngineSpeed": null,
        "TotalMileage": 2363920,
        "AcceleratorPedalPosition": 95,
        "LoadPercentage": 85,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27125682,
        "Time": "2022-02-23T02:52:13",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3090935,
        "Lon": 86.15904,
        "Speed": 9.0,
        "Height": 345,
        "Mileage": 52657044,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 108,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27828,
        "EngineSpeed": null,
        "TotalMileage": 2368925,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27127555,
        "Time": "2022-02-23T03:05:56",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3130379,
        "Lon": 86.14571,
        "Speed": 0.0,
        "Height": 270,
        "Mileage": 52660816,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 109,
        "EngineRPM": 773.0,
        "OnboardVoltage": 27762,
        "EngineSpeed": null,
        "TotalMileage": 2372400,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 14,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27131302,
        "Time": "2022-02-23T03:32:14",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2943726,
        "Lon": 86.14513,
        "Speed": 36.2,
        "Height": -43,
        "Mileage": 52664796,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 70,
        "EngineRPM": 1301.5,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 2376200,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.6
    },
    {
        "Id": 27134935,
        "Time": "2022-02-23T03:58:12",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3049,
        "Lon": 86.14299,
        "Speed": 14.2,
        "Height": 85,
        "Mileage": 52667444,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 64,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27843,
        "EngineSpeed": null,
        "TotalMileage": 2378865,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27138600,
        "Time": "2022-02-23T04:20:28",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3086,
        "Lon": 86.17177,
        "Speed": 22.0,
        "Height": 433,
        "Mileage": 52672512,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 66,
        "EngineRPM": 1104.25,
        "OnboardVoltage": 27814,
        "EngineSpeed": null,
        "TotalMileage": 2383595,
        "AcceleratorPedalPosition": 43,
        "LoadPercentage": 62,
        "FuelConsumption": 95,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27140939,
        "Time": "2022-02-23T04:32:20",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30782,
        "Lon": 86.1373138,
        "Speed": 0.0,
        "Height": 151,
        "Mileage": 52676784,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 69,
        "EngineRPM": 758.875,
        "OnboardVoltage": 27857,
        "EngineSpeed": null,
        "TotalMileage": 2387665,
        "AcceleratorPedalPosition": 22,
        "LoadPercentage": 50,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27146623,
        "Time": "2022-02-23T05:23:32",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3135719,
        "Lon": 86.14108,
        "Speed": 13.7,
        "Height": 240,
        "Mileage": 52678868,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 69,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27800,
        "EngineSpeed": null,
        "TotalMileage": 2389375,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 359,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27148229,
        "Time": "2022-02-23T05:39:56",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3083572,
        "Lon": 86.1611938,
        "Speed": 30.1,
        "Height": 369,
        "Mileage": 52682868,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 78,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27780,
        "EngineSpeed": null,
        "TotalMileage": 2392725,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 90,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27149699,
        "Time": "2022-02-23T05:51:57",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.295753500000004,
        "Lon": 86.14424,
        "Speed": 9.2,
        "Height": -42,
        "Mileage": 52688096,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 83,
        "EngineRPM": 705.625,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 2398205,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 38,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27152044,
        "Time": "2022-02-23T06:09:24",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30357,
        "Lon": 86.13695,
        "Speed": 12.7,
        "Height": 120,
        "Mileage": 52690940,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 88,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27767,
        "EngineSpeed": null,
        "TotalMileage": 2400855,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27154984,
        "Time": "2022-02-23T06:30:48",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30824,
        "Lon": 86.17322,
        "Speed": 0.0,
        "Height": 430,
        "Mileage": 52695796,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 91,
        "EngineRPM": 1513.125,
        "OnboardVoltage": 27805,
        "EngineSpeed": null,
        "TotalMileage": 2405135,
        "AcceleratorPedalPosition": 68,
        "LoadPercentage": 10,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27156067,
        "Time": "2022-02-23T06:39:37",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3033333,
        "Lon": 86.1437454,
        "Speed": 36.4,
        "Height": 68,
        "Mileage": 52700664,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 88,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27801,
        "EngineSpeed": null,
        "TotalMileage": 2409255,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27158598,
        "Time": "2022-02-23T06:58:19",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29439,
        "Lon": 86.14602,
        "Speed": 10.9,
        "Height": -36,
        "Mileage": 52703108,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 56,
        "FuelTemperature": 88,
        "EngineRPM": 1488.125,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 2411720,
        "AcceleratorPedalPosition": 66,
        "LoadPercentage": 66,
        "FuelConsumption": 273,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27162489,
        "Time": "2022-02-23T07:22:59",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3080177,
        "Lon": 86.1613541,
        "Speed": 12.9,
        "Height": 371,
        "Mileage": 52709020,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 56,
        "FuelTemperature": 88,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27804,
        "EngineSpeed": null,
        "TotalMileage": 2417170,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 353,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27164284,
        "Time": "2022-02-23T07:37:23",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3033752,
        "Lon": 86.13735,
        "Speed": 34.8,
        "Height": 116,
        "Mileage": 52714396,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 95,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27828,
        "EngineSpeed": null,
        "TotalMileage": 2421975,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27168389,
        "Time": "2022-02-23T08:07:57",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30038,
        "Lon": 86.13862,
        "Speed": 4.6,
        "Height": 25,
        "Mileage": 52716292,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 96,
        "EngineRPM": 707.25,
        "OnboardVoltage": 27637,
        "EngineSpeed": null,
        "TotalMileage": 2424095,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27170744,
        "Time": "2022-02-23T08:26:04",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3135948,
        "Lon": 86.14985,
        "Speed": 21.2,
        "Height": 274,
        "Mileage": 52720256,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 101,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 2427695,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27172601,
        "Time": "2022-02-23T08:41:12",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3131447,
        "Lon": 86.1523,
        "Speed": 34.6,
        "Height": 286,
        "Mileage": 52724516,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 102,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27787,
        "EngineSpeed": null,
        "TotalMileage": 2431390,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27174824,
        "Time": "2022-02-23T08:59:10",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2961044,
        "Lon": 86.14506,
        "Speed": 7.4,
        "Height": -54,
        "Mileage": 52729448,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 737.875,
        "OnboardVoltage": 27712,
        "EngineSpeed": null,
        "TotalMileage": 2436260,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27177147,
        "Time": "2022-02-23T09:19:00",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3101158,
        "Lon": 86.13256,
        "Speed": 11.2,
        "Height": 181,
        "Mileage": 52733220,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 104,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27802,
        "EngineSpeed": null,
        "TotalMileage": 2439525,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 351,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27179535,
        "Time": "2022-02-23T09:38:04",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30699,
        "Lon": 86.16981,
        "Speed": 31.8,
        "Height": 410,
        "Mileage": 52737336,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 106,
        "EngineRPM": 1289.0,
        "OnboardVoltage": 27776,
        "EngineSpeed": null,
        "TotalMileage": 2443110,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27180932,
        "Time": "2022-02-23T09:47:29",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30035,
        "Lon": 86.13965,
        "Speed": 14.0,
        "Height": 13,
        "Mileage": 52742684,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 105,
        "EngineRPM": 1305.625,
        "OnboardVoltage": 27728,
        "EngineSpeed": null,
        "TotalMileage": 2448220,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27183602,
        "Time": "2022-02-23T10:07:18",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3138847,
        "Lon": 86.14242,
        "Speed": 16.8,
        "Height": 241,
        "Mileage": 52746120,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 107,
        "EngineRPM": 1807.0,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 2451645,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 364,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27185553,
        "Time": "2022-02-23T10:22:05",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3094521,
        "Lon": 86.15879,
        "Speed": 37.9,
        "Height": 345,
        "Mileage": 52749972,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 107,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27779,
        "EngineSpeed": null,
        "TotalMileage": 2455145,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27186618,
        "Time": "2022-02-23T10:31:05",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3003,
        "Lon": 86.13946,
        "Speed": 10.7,
        "Height": 11,
        "Mileage": 52754420,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 107,
        "EngineRPM": 1434.25,
        "OnboardVoltage": 27826,
        "EngineSpeed": null,
        "TotalMileage": 2459535,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 51,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27190462,
        "Time": "2022-02-23T10:59:29",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3048248,
        "Lon": 86.14321,
        "Speed": 12.4,
        "Height": 80,
        "Mileage": 52755872,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 106,
        "EngineRPM": 1807.125,
        "OnboardVoltage": 27847,
        "EngineSpeed": null,
        "TotalMileage": 2460915,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 352,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27192886,
        "Time": "2022-02-23T11:17:29",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30717,
        "Lon": 86.17099,
        "Speed": 12.7,
        "Height": 423,
        "Mileage": 52760332,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 108,
        "EngineRPM": 1807.5,
        "OnboardVoltage": 27866,
        "EngineSpeed": null,
        "TotalMileage": 2465270,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.4
    },
    {
        "Id": 27194383,
        "Time": "2022-02-23T11:29:36",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3035545,
        "Lon": 86.13835,
        "Speed": 31.4,
        "Height": 113,
        "Mileage": 52764684,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 2469215,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27196733,
        "Time": "2022-02-23T11:47:11",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30387,
        "Lon": 86.1438446,
        "Speed": 11.8,
        "Height": 74,
        "Mileage": 52767588,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 107,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27702,
        "EngineSpeed": null,
        "TotalMileage": 2472295,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.4
    },
    {
        "Id": 27199410,
        "Time": "2022-02-23T12:09:13",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30939,
        "Lon": 86.17274,
        "Speed": 11.1,
        "Height": 430,
        "Mileage": 52772908,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 108,
        "EngineRPM": 1248.75,
        "OnboardVoltage": 27689,
        "EngineSpeed": null,
        "TotalMileage": 2477040,
        "AcceleratorPedalPosition": 59,
        "LoadPercentage": 65,
        "FuelConsumption": 158,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.0
    },
    {
        "Id": 27203025,
        "Time": "2022-02-23T12:49:50",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3127556,
        "Lon": 86.1469345,
        "Speed": 7.7,
        "Height": 272,
        "Mileage": 52775312,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 103,
        "EngineRPM": 874.0,
        "OnboardVoltage": 27611,
        "EngineSpeed": null,
        "TotalMileage": 2479390,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.8
    },
    {
        "Id": 27205429,
        "Time": "2022-02-23T13:14:12",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29625,
        "Lon": 86.1450043,
        "Speed": 7.2,
        "Height": -44,
        "Mileage": 52779888,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 101,
        "EngineRPM": 729.75,
        "OnboardVoltage": 27500,
        "EngineSpeed": null,
        "TotalMileage": 2483600,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.0
    },
    {
        "Id": 27207835,
        "Time": "2022-02-23T13:31:52",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3045769,
        "Lon": 86.135376,
        "Speed": 10.9,
        "Height": 128,
        "Mileage": 52782976,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 105,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27523,
        "EngineSpeed": null,
        "TotalMileage": 2486340,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 353,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.2
    },
    {
        "Id": 27209799,
        "Time": "2022-02-23T13:46:22",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2942734,
        "Lon": 86.14494,
        "Speed": 26.8,
        "Height": -42,
        "Mileage": 52788108,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 107,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27515,
        "EngineSpeed": null,
        "TotalMileage": 2490885,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.600002
    },
    {
        "Id": 27213879,
        "Time": "2022-02-23T14:17:38",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2994957,
        "Lon": 86.14685,
        "Speed": 20.0,
        "Height": 27,
        "Mileage": 52790088,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 105,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27557,
        "EngineSpeed": null,
        "TotalMileage": 2492805,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 353,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.0
    },
    {
        "Id": 27216670,
        "Time": "2022-02-23T14:38:30",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3068352,
        "Lon": 86.1686,
        "Speed": 16.2,
        "Height": 410,
        "Mileage": 52795216,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 106,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27566,
        "EngineSpeed": null,
        "TotalMileage": 2497590,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 368,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.0
    },
    {
        "Id": 27218118,
        "Time": "2022-02-23T14:49:47",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3035,
        "Lon": 86.13789,
        "Speed": 38.8,
        "Height": 111,
        "Mileage": 52800048,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27610,
        "EngineSpeed": null,
        "TotalMileage": 2501885,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.600002
    },
    {
        "Id": 27222682,
        "Time": "2022-02-23T15:23:44",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29862,
        "Lon": 86.1390152,
        "Speed": 5.5,
        "Height": 20,
        "Mileage": 52802088,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 103,
        "EngineRPM": 867.5,
        "OnboardVoltage": 27620,
        "EngineSpeed": null,
        "TotalMileage": 2503895,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 58,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27224160,
        "Time": "2022-02-23T15:37:00",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.31391,
        "Lon": 86.14322,
        "Speed": 21.2,
        "Height": 250,
        "Mileage": 52805404,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 106,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27550,
        "EngineSpeed": null,
        "TotalMileage": 2507220,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 357,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.6
    },
    {
        "Id": 27226139,
        "Time": "2022-02-23T15:50:01",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30699,
        "Lon": 86.16971,
        "Speed": 35.0,
        "Height": 411,
        "Mileage": 52808400,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 109,
        "EngineRPM": 1411.0,
        "OnboardVoltage": 27517,
        "EngineSpeed": null,
        "TotalMileage": 2510065,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 48,
        "FuelConsumption": 126,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 24.0
    },
    {
        "Id": 27227658,
        "Time": "2022-02-23T15:59:53",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.300312,
        "Lon": 86.13971,
        "Speed": 16.1,
        "Height": 8,
        "Mileage": 52813756,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 105,
        "EngineRPM": 1367.125,
        "OnboardVoltage": 27490,
        "EngineSpeed": null,
        "TotalMileage": 2515245,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 74,
        "FuelConsumption": 52,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 26.4
    },
    {
        "Id": 27230876,
        "Time": "2022-02-23T16:24:45",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30421,
        "Lon": 86.1404343,
        "Speed": 13.7,
        "Height": 92,
        "Mileage": 52815784,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 106,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27580,
        "EngineSpeed": null,
        "TotalMileage": 2517110,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 26.800001
    },
    {
        "Id": 27233329,
        "Time": "2022-02-23T16:44:29",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3091431,
        "Lon": 86.1731949,
        "Speed": 6.4,
        "Height": 425,
        "Mileage": 52820532,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 107,
        "EngineRPM": 1399.25,
        "OnboardVoltage": 27631,
        "EngineSpeed": null,
        "TotalMileage": 2521620,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 20.800001
    },
    {
        "Id": 27235025,
        "Time": "2022-02-23T16:56:39",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30151,
        "Lon": 86.14169,
        "Speed": 22.5,
        "Height": 17,
        "Mileage": 52826304,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 106,
        "EngineRPM": 1303.375,
        "OnboardVoltage": 27529,
        "EngineSpeed": null,
        "TotalMileage": 2526705,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 20.800001
    },
    {
        "Id": 27238852,
        "Time": "2022-02-23T17:32:15",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.300293,
        "Lon": 86.14608,
        "Speed": 10.3,
        "Height": 35,
        "Mileage": 52827780,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 103,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27663,
        "EngineSpeed": null,
        "TotalMileage": 2528180,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 18.0
    },
    {
        "Id": 27241498,
        "Time": "2022-02-23T17:52:54",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.31331,
        "Lon": 86.14592,
        "Speed": 0.0,
        "Height": 262,
        "Mileage": 52831348,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 109,
        "EngineRPM": 809.125,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 2531205,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 17.6
    },
    {
        "Id": 27246724,
        "Time": "2022-02-23T18:35:07",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30699,
        "Lon": 86.1697845,
        "Speed": 32.2,
        "Height": 412,
        "Mileage": 52834368,
        "EngineOilPressure": 200,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 55,
        "EngineRPM": 748.5,
        "OnboardVoltage": 27628,
        "EngineSpeed": null,
        "TotalMileage": 2533640,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27248215,
        "Time": "2022-02-23T18:45:40",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2998734,
        "Lon": 86.13779,
        "Speed": 8.3,
        "Height": 13,
        "Mileage": 52839740,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 58,
        "EngineRPM": 1045.25,
        "OnboardVoltage": 27693,
        "EngineSpeed": null,
        "TotalMileage": 2538985,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 139,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27250553,
        "Time": "2022-02-23T19:01:59",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.31075,
        "Lon": 86.13693,
        "Speed": 12.0,
        "Height": 203,
        "Mileage": 52843192,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 55,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27596,
        "EngineSpeed": null,
        "TotalMileage": 2541920,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 365,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27253075,
        "Time": "2022-02-23T19:21:09",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3100433,
        "Lon": 86.15545,
        "Speed": 40.5,
        "Height": 321,
        "Mileage": 52848076,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 55,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27516,
        "EngineSpeed": null,
        "TotalMileage": 2546270,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27255322,
        "Time": "2022-02-23T19:37:54",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2998734,
        "Lon": 86.13762,
        "Speed": 0.0,
        "Height": 15,
        "Mileage": 52852748,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 55,
        "EngineRPM": 814.5,
        "OnboardVoltage": 27641,
        "EngineSpeed": null,
        "TotalMileage": 2550775,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27260478,
        "Time": "2022-02-23T20:16:00",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3038177,
        "Lon": 86.1359558,
        "Speed": 10.0,
        "Height": 116,
        "Mileage": 52854964,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 62,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27663,
        "EngineSpeed": null,
        "TotalMileage": 2552730,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 364,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27263581,
        "Time": "2022-02-23T20:35:45",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3087234,
        "Lon": 86.1721344,
        "Speed": 12.5,
        "Height": 428,
        "Mileage": 52859404,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 74,
        "EngineRPM": 911.75,
        "OnboardVoltage": 27685,
        "EngineSpeed": null,
        "TotalMileage": 2556980,
        "AcceleratorPedalPosition": 16,
        "LoadPercentage": 25,
        "FuelConsumption": 63,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27264660,
        "Time": "2022-02-23T20:45:25",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30164,
        "Lon": 86.14214,
        "Speed": 30.1,
        "Height": 15,
        "Mileage": 52864860,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 958.125,
        "OnboardVoltage": 27653,
        "EngineSpeed": null,
        "TotalMileage": 2561865,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27267121,
        "Time": "2022-02-23T21:06:13",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30369,
        "Lon": 86.13646,
        "Speed": 12.2,
        "Height": 118,
        "Mileage": 52867352,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 2564400,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 87,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27269797,
        "Time": "2022-02-23T21:26:24",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3078079,
        "Lon": 86.17099,
        "Speed": 29.0,
        "Height": 422,
        "Mileage": 52872028,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 88,
        "EngineRPM": 1177.875,
        "OnboardVoltage": 27688,
        "EngineSpeed": null,
        "TotalMileage": 2568720,
        "AcceleratorPedalPosition": 61,
        "LoadPercentage": 73,
        "FuelConsumption": 96,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27271590,
        "Time": "2022-02-23T21:39:06",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3001022,
        "Lon": 86.1376953,
        "Speed": 0.0,
        "Height": 12,
        "Mileage": 52877780,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 88,
        "EngineRPM": 747.75,
        "OnboardVoltage": 27682,
        "EngineSpeed": null,
        "TotalMileage": 2574180,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 42,
        "FuelConsumption": 61,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27274768,
        "Time": "2022-02-23T22:01:21",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30956,
        "Lon": 86.1326,
        "Speed": 9.2,
        "Height": 178,
        "Mileage": 52880856,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 88,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27651,
        "EngineSpeed": null,
        "TotalMileage": 2576840,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27277396,
        "Time": "2022-02-23T22:20:37",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3090477,
        "Lon": 86.17262,
        "Speed": 12.0,
        "Height": 436,
        "Mileage": 52884944,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 96,
        "EngineRPM": 886.5,
        "OnboardVoltage": 27626,
        "EngineSpeed": null,
        "TotalMileage": 2580350,
        "AcceleratorPedalPosition": 13,
        "LoadPercentage": 19,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27279059,
        "Time": "2022-02-23T22:31:40",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3011322,
        "Lon": 86.14147,
        "Speed": 30.3,
        "Height": 23,
        "Mileage": 52890348,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 96,
        "EngineRPM": 1253.875,
        "OnboardVoltage": 27732,
        "EngineSpeed": null,
        "TotalMileage": 2585425,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 55,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27282074,
        "Time": "2022-02-23T22:52:13",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30494,
        "Lon": 86.14301,
        "Speed": 11.8,
        "Height": 91,
        "Mileage": 52892344,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 95,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 2587340,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 85,
        "FuelConsumption": 359,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27284283,
        "Time": "2022-02-23T23:07:35",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3138,
        "Lon": 86.14818,
        "Speed": 33.8,
        "Height": 267,
        "Mileage": 52896244,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27622,
        "EngineSpeed": null,
        "TotalMileage": 2590645,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 83,
        "FuelConsumption": 349,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27286152,
        "Time": "2022-02-23T23:19:26",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.27867,
        "Lon": 86.1891861,
        "Speed": 6.1,
        "Height": 254,
        "Mileage": 52902296,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 100,
        "EngineRPM": 788.75,
        "OnboardVoltage": 27592,
        "EngineSpeed": null,
        "TotalMileage": 2596525,
        "AcceleratorPedalPosition": 6,
        "LoadPercentage": 0,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27288931,
        "Time": "2022-02-23T23:39:10",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2776146,
        "Lon": 86.18808,
        "Speed": 18.3,
        "Height": 251,
        "Mileage": 52908104,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 1019.5,
        "OnboardVoltage": 27643,
        "EngineSpeed": null,
        "TotalMileage": 2601815,
        "AcceleratorPedalPosition": 24,
        "LoadPercentage": 35,
        "FuelConsumption": 67,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27296960,
        "Time": "2022-02-24T00:44:11",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.28123,
        "Lon": 86.16602,
        "Speed": 27.2,
        "Height": 30,
        "Mileage": 52912044,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 97,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27776,
        "EngineSpeed": null,
        "TotalMileage": 2605425,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27300767,
        "Time": "2022-02-24T01:19:57",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.29588,
        "Lon": 86.14576,
        "Speed": 5.7,
        "Height": -29,
        "Mileage": 52916408,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 98,
        "EngineRPM": 745.625,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 2609835,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27303004,
        "Time": "2022-02-24T01:35:33",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.31001,
        "Lon": 86.1326,
        "Speed": 12.4,
        "Height": 184,
        "Mileage": 52920108,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 1812.875,
        "OnboardVoltage": 27770,
        "EngineSpeed": null,
        "TotalMileage": 2613070,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27305797,
        "Time": "2022-02-24T01:54:27",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30816,
        "Lon": 86.17105,
        "Speed": 17.0,
        "Height": 430,
        "Mileage": 52924216,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 103,
        "EngineRPM": 925.5,
        "OnboardVoltage": 27799,
        "EngineSpeed": null,
        "TotalMileage": 2616505,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27308245,
        "Time": "2022-02-24T02:03:49",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.2994461,
        "Lon": 86.14697,
        "Speed": 12.4,
        "Height": 19,
        "Mileage": 52929284,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 103,
        "EngineRPM": 738.0,
        "OnboardVoltage": 27630,
        "EngineSpeed": null,
        "TotalMileage": 2621305,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27310322,
        "Time": "2022-02-24T02:24:13",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3063049,
        "Lon": 86.13549,
        "Speed": 14.8,
        "Height": 134,
        "Mileage": 52931668,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 103,
        "EngineRPM": 1343.25,
        "OnboardVoltage": 27677,
        "EngineSpeed": null,
        "TotalMileage": 2623635,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 154,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27313096,
        "Time": "2022-02-24T02:42:25",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.309536,
        "Lon": 86.17284,
        "Speed": 5.9,
        "Height": 428,
        "Mileage": 52935948,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 104,
        "EngineRPM": 1348.75,
        "OnboardVoltage": 27677,
        "EngineSpeed": null,
        "TotalMileage": 2627670,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 170,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27314582,
        "Time": "2022-02-24T02:53:53",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30743,
        "Lon": 86.1381454,
        "Speed": 0.0,
        "Height": 158,
        "Mileage": 52940156,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 106,
        "EngineRPM": 659.0,
        "OnboardVoltage": 27853,
        "EngineSpeed": null,
        "TotalMileage": 2631815,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 51,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27318734,
        "Time": "2022-02-24T03:14:07",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.30994,
        "Lon": 86.1576,
        "Speed": 11.4,
        "Height": 343,
        "Mileage": 52943536,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27778,
        "EngineSpeed": null,
        "TotalMileage": 2634855,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 352,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.8
    },
    {
        "Id": 27319763,
        "Time": "2022-02-24T03:30:15",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.31025,
        "Lon": 86.13242,
        "Speed": 27.0,
        "Height": 192,
        "Mileage": 52948660,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27675,
        "EngineSpeed": null,
        "TotalMileage": 2638965,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.8
    },
    {
        "Id": 27321743,
        "Time": "2022-02-24T03:43:29",
        "TruckId": 1305,
        "Imei": "868328058759586",
        "Lat": 54.3138733,
        "Lon": 86.14216,
        "Speed": 14.0,
        "Height": 245,
        "Mileage": 52951608,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1809.0,
        "OnboardVoltage": 27793,
        "EngineSpeed": null,
        "TotalMileage": 2642055,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 86,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 20396,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27004173,
        "Time": "2022-02-22T10:53:44",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2554321,
        "Lon": 86.1732,
        "Speed": 20.3,
        "Height": 281,
        "Mileage": 45475324,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 108,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27797,
        "EngineSpeed": null,
        "TotalMileage": 544267485,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 381,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29224,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27006178,
        "Time": "2022-02-22T11:08:49",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2555847,
        "Lon": 86.17298,
        "Speed": 19.8,
        "Height": 279,
        "Mileage": 45481544,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 108,
        "EngineRPM": 1092.0,
        "OnboardVoltage": 27775,
        "EngineSpeed": null,
        "TotalMileage": 544273545,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29224,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.0
    },
    {
        "Id": 27012824,
        "Time": "2022-02-22T11:59:11",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26823,
        "Lon": 86.16618,
        "Speed": 22.2,
        "Height": 105,
        "Mileage": 45484836,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 80,
        "EngineRPM": 1297.375,
        "OnboardVoltage": 27636,
        "EngineSpeed": null,
        "TotalMileage": 544276425,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29225,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.600002
    },
    {
        "Id": 27016851,
        "Time": "2022-02-22T12:34:20",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2563553,
        "Lon": 86.1715851,
        "Speed": 16.4,
        "Height": 280,
        "Mileage": 45487900,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 75,
        "EngineRPM": 907.875,
        "OnboardVoltage": 27597,
        "EngineSpeed": null,
        "TotalMileage": 544279810,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29226,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27019248,
        "Time": "2022-02-22T12:58:36",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2481537,
        "Lon": 86.15648,
        "Speed": 32.4,
        "Height": 332,
        "Mileage": 45491876,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 78,
        "EngineRPM": 947.625,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 544284060,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29226,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27022303,
        "Time": "2022-02-22T13:27:21",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2672653,
        "Lon": 86.16831,
        "Speed": 13.3,
        "Height": 114,
        "Mileage": 45496900,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 80,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27575,
        "EngineSpeed": null,
        "TotalMileage": 544288960,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 375,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29227,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27025388,
        "Time": "2022-02-22T13:46:42",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2422752,
        "Lon": 86.14152,
        "Speed": 5.0,
        "Height": 327,
        "Mileage": 45502292,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 87,
        "EngineRPM": 837.75,
        "OnboardVoltage": 27777,
        "EngineSpeed": null,
        "TotalMileage": 544294970,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 40,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29227,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27026437,
        "Time": "2022-02-22T14:00:01",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2686958,
        "Lon": 86.16595,
        "Speed": 13.7,
        "Height": 99,
        "Mileage": 45507988,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 90,
        "EngineRPM": 1314.625,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 544300405,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 52,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29227,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27029284,
        "Time": "2022-02-22T14:22:23",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2622375,
        "Lon": 86.17212,
        "Speed": 18.3,
        "Height": 211,
        "Mileage": 45510576,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 90,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27287,
        "EngineSpeed": null,
        "TotalMileage": 544303065,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29228,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27031744,
        "Time": "2022-02-22T14:39:00",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2449,
        "Lon": 86.1525345,
        "Speed": 28.1,
        "Height": 332,
        "Mileage": 45515384,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 96,
        "EngineRPM": 694.75,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 544308070,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29228,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27035816,
        "Time": "2022-02-22T15:10:24",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26979,
        "Lon": 86.16517,
        "Speed": 0.0,
        "Height": 91,
        "Mileage": 45520452,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 96,
        "EngineRPM": 668.5,
        "OnboardVoltage": 27704,
        "EngineSpeed": null,
        "TotalMileage": 544313095,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 28,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29229,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27038778,
        "Time": "2022-02-22T15:31:19",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.241848,
        "Lon": 86.14614,
        "Speed": 12.4,
        "Height": 337,
        "Mileage": 45525808,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 95,
        "EngineRPM": 1222.0,
        "OnboardVoltage": 27631,
        "EngineSpeed": null,
        "TotalMileage": 544318645,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29229,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27040239,
        "Time": "2022-02-22T15:43:34",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2595177,
        "Lon": 86.17702,
        "Speed": 31.1,
        "Height": 193,
        "Mileage": 45530468,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 100,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27326,
        "EngineSpeed": null,
        "TotalMileage": 544323245,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29229,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27046466,
        "Time": "2022-02-22T16:33:05",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2658043,
        "Lon": 86.16946,
        "Speed": 16.4,
        "Height": 129,
        "Mileage": 45532724,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 95,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 544325635,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 92,
        "FuelConsumption": 376,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29230,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27048940,
        "Time": "2022-02-22T16:52:19",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.28402,
        "Lon": 86.13774,
        "Speed": 0.0,
        "Height": 287,
        "Mileage": 45539392,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 100,
        "EngineRPM": 1348.25,
        "OnboardVoltage": 27815,
        "EngineSpeed": null,
        "TotalMileage": 544332705,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 60,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29230,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.0
    },
    {
        "Id": 27051212,
        "Time": "2022-02-22T17:09:56",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26813,
        "Lon": 86.1724854,
        "Speed": 24.4,
        "Height": 19,
        "Mileage": 45547404,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 98,
        "EngineRPM": 773.25,
        "OnboardVoltage": 27777,
        "EngineSpeed": null,
        "TotalMileage": 544340425,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29230,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27057116,
        "Time": "2022-02-22T18:04:16",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2678566,
        "Lon": 86.17479,
        "Speed": 18.7,
        "Height": 40,
        "Mileage": 45548608,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 96,
        "EngineRPM": 1271.75,
        "OnboardVoltage": 27744,
        "EngineSpeed": null,
        "TotalMileage": 544341580,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29231,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27062679,
        "Time": "2022-02-22T18:51:43",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25673,
        "Lon": 86.17507,
        "Speed": 16.6,
        "Height": 261,
        "Mileage": 45552284,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 103,
        "EngineRPM": 1806.5,
        "OnboardVoltage": 27651,
        "EngineSpeed": null,
        "TotalMileage": 544345710,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 376,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29232,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27065806,
        "Time": "2022-02-22T19:13:22",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2561035,
        "Lon": 86.16465,
        "Speed": 29.0,
        "Height": 278,
        "Mileage": 45560836,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 757.75,
        "OnboardVoltage": 27769,
        "EngineSpeed": null,
        "TotalMileage": 544354395,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29233,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27071219,
        "Time": "2022-02-22T19:52:27",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2667236,
        "Lon": 86.1687,
        "Speed": 12.0,
        "Height": 122,
        "Mileage": 45564812,
        "EngineOilPressure": 472,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 95,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 544358200,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 92,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29233,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27074396,
        "Time": "2022-02-22T20:14:17",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.27889,
        "Lon": 86.1429749,
        "Speed": 28.3,
        "Height": 270,
        "Mileage": 45572228,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 90,
        "EngineRPM": 1251.25,
        "OnboardVoltage": 27659,
        "EngineSpeed": null,
        "TotalMileage": 544365565,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29234,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.8
    },
    {
        "Id": 27079002,
        "Time": "2022-02-22T20:47:48",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2697563,
        "Lon": 86.16502,
        "Speed": 5.9,
        "Height": 93,
        "Mileage": 45578800,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 846.375,
        "OnboardVoltage": 27678,
        "EngineSpeed": null,
        "TotalMileage": 544372440,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29234,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.4
    },
    {
        "Id": 27081817,
        "Time": "2022-02-22T21:07:02",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2837029,
        "Lon": 86.13749,
        "Speed": 10.5,
        "Height": 285,
        "Mileage": 45585980,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 86,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27731,
        "EngineSpeed": null,
        "TotalMileage": 544379740,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 51,
        "FuelConsumption": 174,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29234,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27083904,
        "Time": "2022-02-22T21:23:46",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26814,
        "Lon": 86.1663361,
        "Speed": 15.9,
        "Height": 102,
        "Mileage": 45592976,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 83,
        "EngineRPM": 1172.25,
        "OnboardVoltage": 27702,
        "EngineSpeed": null,
        "TotalMileage": 544386800,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29235,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27086690,
        "Time": "2022-02-22T21:45:15",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2609329,
        "Lon": 86.15644,
        "Speed": 35.0,
        "Height": 300,
        "Mileage": 45597424,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1661.0,
        "OnboardVoltage": 27738,
        "EngineSpeed": null,
        "TotalMileage": 544391565,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 355,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29235,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27089089,
        "Time": "2022-02-22T22:02:00",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2681,
        "Lon": 86.15514,
        "Speed": 34.0,
        "Height": 278,
        "Mileage": 45603492,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 85,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27326,
        "EngineSpeed": null,
        "TotalMileage": 544397455,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29235,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27091697,
        "Time": "2022-02-22T22:21:30",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2696457,
        "Lon": 86.16456,
        "Speed": 0.0,
        "Height": 95,
        "Mileage": 45608836,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 83,
        "EngineRPM": 847.875,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 544402710,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29236,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27094390,
        "Time": "2022-02-22T22:45:01",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.273613,
        "Lon": 86.1525,
        "Speed": 30.1,
        "Height": 265,
        "Mileage": 45614524,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 81,
        "EngineRPM": 1157.125,
        "OnboardVoltage": 27708,
        "EngineSpeed": null,
        "TotalMileage": 544408540,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29236,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27097299,
        "Time": "2022-02-22T23:05:47",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25636,
        "Lon": 86.17237,
        "Speed": 0.0,
        "Height": 278,
        "Mileage": 45620712,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 85,
        "EngineRPM": 720.75,
        "OnboardVoltage": 27704,
        "EngineSpeed": null,
        "TotalMileage": 544414930,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 32,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29236,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27101483,
        "Time": "2022-02-22T23:37:13",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26926,
        "Lon": 86.17524,
        "Speed": 15.3,
        "Height": 54,
        "Mileage": 45625052,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 60,
        "EngineRPM": 1557.5,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 544418880,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 72,
        "FuelConsumption": 268,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29237,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27103775,
        "Time": "2022-02-22T23:55:01",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2653542,
        "Lon": 86.17007,
        "Speed": 18.3,
        "Height": 142,
        "Mileage": 45627792,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 55,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 544421565,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29237,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27105707,
        "Time": "2022-02-23T00:12:12",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.28397,
        "Lon": 86.1373138,
        "Speed": 5.5,
        "Height": 288,
        "Mileage": 45634352,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 58,
        "EngineRPM": 947.875,
        "OnboardVoltage": 27283,
        "EngineSpeed": null,
        "TotalMileage": 544428585,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 48,
        "FuelConsumption": 109,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29238,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27109668,
        "Time": "2022-02-23T00:51:21",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25563,
        "Lon": 86.17431,
        "Speed": 30.0,
        "Height": 277,
        "Mileage": 45639364,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 60,
        "EngineRPM": 1098.0,
        "OnboardVoltage": 27367,
        "EngineSpeed": null,
        "TotalMileage": 544433080,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 31,
        "FuelConsumption": 94,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29238,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.6
    },
    {
        "Id": 27114191,
        "Time": "2022-02-23T01:29:30",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2596,
        "Lon": 86.17685,
        "Speed": 17.7,
        "Height": 185,
        "Mileage": 45643816,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 58,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27770,
        "EngineSpeed": null,
        "TotalMileage": 544437270,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 381,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29239,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27117058,
        "Time": "2022-02-23T01:50:23",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26538,
        "Lon": 86.15651,
        "Speed": 35.9,
        "Height": 281,
        "Mileage": 45651972,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 72,
        "EngineRPM": 1295.375,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 544445485,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 38,
        "FuelConsumption": 136,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29239,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27123746,
        "Time": "2022-02-23T02:38:46",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2699852,
        "Lon": 86.16488,
        "Speed": 4.8,
        "Height": 101,
        "Mileage": 45656956,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 80,
        "EngineRPM": 740.25,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 544450510,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29240,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27126913,
        "Time": "2022-02-23T03:01:44",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2571259,
        "Lon": 86.15887,
        "Speed": 22.7,
        "Height": 306,
        "Mileage": 45660900,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 80,
        "EngineRPM": 1802.25,
        "OnboardVoltage": 27526,
        "EngineSpeed": null,
        "TotalMileage": 544454200,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 81,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29240,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27129910,
        "Time": "2022-02-23T03:23:11",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2616768,
        "Lon": 86.17182,
        "Speed": 30.9,
        "Height": 233,
        "Mileage": 45669776,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1301.625,
        "OnboardVoltage": 27764,
        "EngineSpeed": null,
        "TotalMileage": 544463180,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29241,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27135047,
        "Time": "2022-02-23T03:58:48",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2595673,
        "Lon": 86.17613,
        "Speed": 13.1,
        "Height": 192,
        "Mileage": 45673408,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 87,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27750,
        "EngineSpeed": null,
        "TotalMileage": 544466790,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 95,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29241,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27138608,
        "Time": "2022-02-23T04:20:51",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.27167,
        "Lon": 86.1546555,
        "Speed": 24.2,
        "Height": 259,
        "Mileage": 45681192,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 87,
        "EngineRPM": 778.625,
        "OnboardVoltage": 27776,
        "EngineSpeed": null,
        "TotalMileage": 544474485,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29242,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27141659,
        "Time": "2022-02-23T04:40:51",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26858,
        "Lon": 86.1665955,
        "Speed": 17.2,
        "Height": 111,
        "Mileage": 45687252,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 87,
        "EngineRPM": 1357.125,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 544480080,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 54,
        "FuelConsumption": 191,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29242,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27143701,
        "Time": "2022-02-23T04:54:40",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2671165,
        "Lon": 86.1873,
        "Speed": 18.3,
        "Height": 204,
        "Mileage": 45691264,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 86,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27492,
        "EngineSpeed": null,
        "TotalMileage": 544484315,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 392,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29242,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27145665,
        "Time": "2022-02-23T05:13:55",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.3068962,
        "Lon": 86.1636047,
        "Speed": 38.8,
        "Height": 384,
        "Mileage": 45697352,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 93,
        "FuelTemperature": 86,
        "EngineRPM": 1297.125,
        "OnboardVoltage": 27759,
        "EngineSpeed": null,
        "TotalMileage": 544490480,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29243,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27150549,
        "Time": "2022-02-23T05:58:07",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.3069725,
        "Lon": 86.13402,
        "Speed": 36.6,
        "Height": 155,
        "Mileage": 45701668,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 81,
        "EngineRPM": 1288.875,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 544493550,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 92,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29243,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27152999,
        "Time": "2022-02-23T06:15:15",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.27249,
        "Lon": 86.1650848,
        "Speed": 20.9,
        "Height": 56,
        "Mileage": 45710168,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 79,
        "EngineRPM": 1805.625,
        "OnboardVoltage": 27763,
        "EngineSpeed": null,
        "TotalMileage": 544501795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 72,
        "FuelConsumption": 337,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29244,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27156391,
        "Time": "2022-02-23T06:41:48",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2615738,
        "Lon": 86.17168,
        "Speed": 20.0,
        "Height": 225,
        "Mileage": 45713016,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 1813.0,
        "OnboardVoltage": 27818,
        "EngineSpeed": null,
        "TotalMileage": 544504620,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 404,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29244,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27159676,
        "Time": "2022-02-23T07:05:43",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25547,
        "Lon": 86.17388,
        "Speed": 35.7,
        "Height": 283,
        "Mileage": 45722864,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 84,
        "EngineRPM": 742.0,
        "OnboardVoltage": 27214,
        "EngineSpeed": null,
        "TotalMileage": 544514520,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29244,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27163253,
        "Time": "2022-02-23T07:29:41",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2652435,
        "Lon": 86.17016,
        "Speed": 19.2,
        "Height": 137,
        "Mileage": 45726956,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 84,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27741,
        "EngineSpeed": null,
        "TotalMileage": 544518030,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29245,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27165861,
        "Time": "2022-02-23T07:47:42",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.28413,
        "Lon": 86.13849,
        "Speed": 10.5,
        "Height": 281,
        "Mileage": 45733464,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 87,
        "EngineRPM": 1191.875,
        "OnboardVoltage": 27761,
        "EngineSpeed": null,
        "TotalMileage": 544525000,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 70,
        "FuelConsumption": 76,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29245,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 65.6
    },
    {
        "Id": 27168065,
        "Time": "2022-02-23T08:04:55",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2694473,
        "Lon": 86.16513,
        "Speed": 9.4,
        "Height": 95,
        "Mileage": 45740836,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 88,
        "EngineRPM": 730.125,
        "OnboardVoltage": 27245,
        "EngineSpeed": null,
        "TotalMileage": 544531920,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29245,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27171048,
        "Time": "2022-02-23T08:28:54",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2669563,
        "Lon": 86.15604,
        "Speed": 29.2,
        "Height": 280,
        "Mileage": 45745840,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 89,
        "EngineRPM": 1297.375,
        "OnboardVoltage": 27801,
        "EngineSpeed": null,
        "TotalMileage": 544537025,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29246,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27173457,
        "Time": "2022-02-23T08:47:35",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25938,
        "Lon": 86.17677,
        "Speed": 34.2,
        "Height": 199,
        "Mileage": 45754128,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 1292.25,
        "OnboardVoltage": 27283,
        "EngineSpeed": null,
        "TotalMileage": 544545000,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29246,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27176097,
        "Time": "2022-02-23T09:10:15",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2556458,
        "Lon": 86.17415,
        "Speed": 14.4,
        "Height": 279,
        "Mileage": 45758456,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 96,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27654,
        "EngineSpeed": null,
        "TotalMileage": 544549565,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 96,
        "FuelConsumption": 389,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29246,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27178824,
        "Time": "2022-02-23T09:32:35",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25938,
        "Lon": 86.17668,
        "Speed": 28.3,
        "Height": 187,
        "Mileage": 45768576,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 95,
        "EngineRPM": 1291.75,
        "OnboardVoltage": 27895,
        "EngineSpeed": null,
        "TotalMileage": 544559355,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29247,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27182574,
        "Time": "2022-02-23T09:57:38",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25604,
        "Lon": 86.17503,
        "Speed": 16.2,
        "Height": 269,
        "Mileage": 45772876,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 92,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27753,
        "EngineSpeed": null,
        "TotalMileage": 544563970,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29247,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27184874,
        "Time": "2022-02-23T10:17:24",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2558823,
        "Lon": 86.1668243,
        "Speed": 34.2,
        "Height": 261,
        "Mileage": 45782016,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 88,
        "EngineRPM": 1248.375,
        "OnboardVoltage": 27745,
        "EngineSpeed": null,
        "TotalMileage": 544572330,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29248,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27189015,
        "Time": "2022-02-23T10:48:44",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26976,
        "Lon": 86.16493,
        "Speed": 7.7,
        "Height": 104,
        "Mileage": 45787216,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 88,
        "EngineRPM": 806.375,
        "OnboardVoltage": 27704,
        "EngineSpeed": null,
        "TotalMileage": 544575665,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29248,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27191769,
        "Time": "2022-02-23T11:08:48",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26926,
        "Lon": 86.15512,
        "Speed": 26.6,
        "Height": 278,
        "Mileage": 45792388,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 84,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 544580515,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29248,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27194009,
        "Time": "2022-02-23T11:26:31",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2602234,
        "Lon": 86.1767,
        "Speed": 40.3,
        "Height": 190,
        "Mileage": 45800584,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 83,
        "EngineRPM": 1300.0,
        "OnboardVoltage": 27700,
        "EngineSpeed": null,
        "TotalMileage": 544588330,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29249,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27198509,
        "Time": "2022-02-23T12:02:59",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.27011,
        "Lon": 86.17967,
        "Speed": 15.9,
        "Height": 80,
        "Mileage": 45804180,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 544592020,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 376,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29249,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.4
    },
    {
        "Id": 27200963,
        "Time": "2022-02-23T12:26:20",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.28044,
        "Lon": 86.18152,
        "Speed": 25.9,
        "Height": 264,
        "Mileage": 45808664,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 85,
        "EngineRPM": 760.5,
        "OnboardVoltage": 27719,
        "EngineSpeed": null,
        "TotalMileage": 544596910,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 12,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29250,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27202540,
        "Time": "2022-02-23T12:44:15",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2704353,
        "Lon": 86.16786,
        "Speed": 25.5,
        "Height": 28,
        "Mileage": 45814060,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 79,
        "EngineRPM": 959.625,
        "OnboardVoltage": 27734,
        "EngineSpeed": null,
        "TotalMileage": 544602085,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 93,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29250,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27205487,
        "Time": "2022-02-23T13:14:39",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2629,
        "Lon": 86.17394,
        "Speed": 12.9,
        "Height": 152,
        "Mileage": 45816464,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 80,
        "EngineRPM": 1812.875,
        "OnboardVoltage": 27729,
        "EngineSpeed": null,
        "TotalMileage": 544604620,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29251,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.4
    },
    {
        "Id": 27207978,
        "Time": "2022-02-23T13:30:29",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.24284,
        "Lon": 86.1477356,
        "Speed": 23.8,
        "Height": 333,
        "Mileage": 45821768,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 79,
        "EngineRPM": 1706.75,
        "OnboardVoltage": 27713,
        "EngineSpeed": null,
        "TotalMileage": 544610195,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 92,
        "FuelConsumption": 316,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29251,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27209915,
        "Time": "2022-02-23T13:47:20",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26798,
        "Lon": 86.16703,
        "Speed": 20.9,
        "Height": 102,
        "Mileage": 45827668,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 81,
        "EngineRPM": 695.125,
        "OnboardVoltage": 27672,
        "EngineSpeed": null,
        "TotalMileage": 544615600,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29251,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27213730,
        "Time": "2022-02-23T14:16:24",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25553,
        "Lon": 86.16273,
        "Speed": 23.1,
        "Height": 289,
        "Mileage": 45831504,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 78,
        "EngineRPM": 1308.75,
        "OnboardVoltage": 27715,
        "EngineSpeed": null,
        "TotalMileage": 544619615,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 19,
        "FuelConsumption": 100,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29252,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27215744,
        "Time": "2022-02-23T14:30:39",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2559624,
        "Lon": 86.17523,
        "Speed": 36.1,
        "Height": 279,
        "Mileage": 45837192,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 783.875,
        "OnboardVoltage": 27687,
        "EngineSpeed": null,
        "TotalMileage": 544625190,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 24,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29252,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27218133,
        "Time": "2022-02-23T14:49:51",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2700539,
        "Lon": 86.1773148,
        "Speed": 10.0,
        "Height": 65,
        "Mileage": 45841636,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 80,
        "EngineRPM": 817.875,
        "OnboardVoltage": 27684,
        "EngineSpeed": null,
        "TotalMileage": 544629540,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 35,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29252,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.6
    },
    {
        "Id": 27220096,
        "Time": "2022-02-23T15:05:41",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25575,
        "Lon": 86.16491,
        "Speed": 39.8,
        "Height": 298,
        "Mileage": 45846568,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 79,
        "EngineRPM": 1281.0,
        "OnboardVoltage": 27698,
        "EngineSpeed": null,
        "TotalMileage": 544634390,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 17,
        "FuelConsumption": 74,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29252,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27222027,
        "Time": "2022-02-23T15:20:51",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25554,
        "Lon": 86.1730347,
        "Speed": 22.2,
        "Height": 290,
        "Mileage": 45852236,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 1260.375,
        "OnboardVoltage": 27668,
        "EngineSpeed": null,
        "TotalMileage": 544640155,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 64,
        "FuelConsumption": 120,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29253,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27225760,
        "Time": "2022-02-23T15:47:33",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2675171,
        "Lon": 86.1746,
        "Speed": 15.9,
        "Height": 43,
        "Mileage": 45856784,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 58,
        "EngineRPM": 1366.25,
        "OnboardVoltage": 27654,
        "EngineSpeed": null,
        "TotalMileage": 544644340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 64,
        "FuelConsumption": 200,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29253,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27230620,
        "Time": "2022-02-23T16:22:50",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2725525,
        "Lon": 86.1649246,
        "Speed": 10.9,
        "Height": 58,
        "Mileage": 45858616,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 59,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27695,
        "EngineSpeed": null,
        "TotalMileage": 544646290,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 387,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29254,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27233042,
        "Time": "2022-02-23T16:41:19",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2421,
        "Lon": 86.14217,
        "Speed": 12.9,
        "Height": 324,
        "Mileage": 45864456,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 60,
        "EngineRPM": 1529.75,
        "OnboardVoltage": 27636,
        "EngineSpeed": null,
        "TotalMileage": 544652555,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 91,
        "FuelConsumption": 320,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29254,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27234378,
        "Time": "2022-02-23T16:51:43",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25946,
        "Lon": 86.17606,
        "Speed": 34.6,
        "Height": 192,
        "Mileage": 45869140,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 59,
        "EngineRPM": 1364.375,
        "OnboardVoltage": 27262,
        "EngineSpeed": null,
        "TotalMileage": 544656825,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 107,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29254,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27236028,
        "Time": "2022-02-23T17:04:13",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2679138,
        "Lon": 86.17472,
        "Speed": 20.9,
        "Height": 35,
        "Mileage": 45872796,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 61,
        "EngineRPM": 1315.375,
        "OnboardVoltage": 27199,
        "EngineSpeed": null,
        "TotalMileage": 544660460,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 116,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29254,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27237905,
        "Time": "2022-02-23T17:23:31",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2429,
        "Lon": 86.14735,
        "Speed": 23.8,
        "Height": 334,
        "Mileage": 45879128,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 55,
        "EngineRPM": 1253.25,
        "OnboardVoltage": 27252,
        "EngineSpeed": null,
        "TotalMileage": 544667250,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 63,
        "FuelConsumption": 112,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29255,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27239116,
        "Time": "2022-02-23T17:34:17",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.26078,
        "Lon": 86.17389,
        "Speed": 33.1,
        "Height": 209,
        "Mileage": 45883652,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 65,
        "EngineRPM": 1302.5,
        "OnboardVoltage": 27205,
        "EngineSpeed": null,
        "TotalMileage": 544671685,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29255,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27243690,
        "Time": "2022-02-23T18:09:36",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2704124,
        "Lon": 86.17696,
        "Speed": 0.0,
        "Height": 70,
        "Mileage": 45887008,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 68,
        "EngineRPM": 1130.0,
        "OnboardVoltage": 27768,
        "EngineSpeed": null,
        "TotalMileage": 544675155,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29256,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27248734,
        "Time": "2022-02-23T18:50:04",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2845573,
        "Lon": 86.1749039,
        "Speed": 27.0,
        "Height": 263,
        "Mileage": 45891492,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 68,
        "EngineRPM": 1319.875,
        "OnboardVoltage": 27689,
        "EngineSpeed": null,
        "TotalMileage": 544679595,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29256,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27250873,
        "Time": "2022-02-23T19:04:19",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.3127441,
        "Lon": 86.15283,
        "Speed": 37.4,
        "Height": 284,
        "Mileage": 45896352,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 91,
        "FuelTemperature": 75,
        "EngineRPM": 1295.0,
        "OnboardVoltage": 27712,
        "EngineSpeed": null,
        "TotalMileage": 544684625,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29256,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27257494,
        "Time": "2022-02-23T19:53:50",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.28981,
        "Lon": 86.17476,
        "Speed": 35.0,
        "Height": 297,
        "Mileage": 45900948,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 75,
        "EngineRPM": 850.25,
        "OnboardVoltage": 27698,
        "EngineSpeed": null,
        "TotalMileage": 544688965,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29257,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.4
    },
    {
        "Id": 27259505,
        "Time": "2022-02-23T20:08:25",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2704124,
        "Lon": 86.17661,
        "Speed": 0.0,
        "Height": 76,
        "Mileage": 45906452,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 77,
        "EngineRPM": 710.625,
        "OnboardVoltage": 27214,
        "EngineSpeed": null,
        "TotalMileage": 544694310,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29257,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27261825,
        "Time": "2022-02-23T20:24:27",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2552032,
        "Lon": 86.16221,
        "Speed": 14.4,
        "Height": 291,
        "Mileage": 45911484,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 77,
        "EngineRPM": 1438.625,
        "OnboardVoltage": 27191,
        "EngineSpeed": null,
        "TotalMileage": 544699500,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 65,
        "FuelConsumption": 220,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29258,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27263642,
        "Time": "2022-02-23T20:38:18",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25992,
        "Lon": 86.17708,
        "Speed": 35.3,
        "Height": 188,
        "Mileage": 45917872,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 78,
        "EngineRPM": 1299.625,
        "OnboardVoltage": 27209,
        "EngineSpeed": null,
        "TotalMileage": 544705515,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29258,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27266043,
        "Time": "2022-02-23T20:57:42",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2678871,
        "Lon": 86.17481,
        "Speed": 22.0,
        "Height": 41,
        "Mileage": 45921448,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1296.75,
        "OnboardVoltage": 27127,
        "EngineSpeed": null,
        "TotalMileage": 544708985,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 16,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29258,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27269393,
        "Time": "2022-02-23T21:15:25",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2430153,
        "Lon": 86.148674,
        "Speed": 30.7,
        "Height": 326,
        "Mileage": 45927752,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 77,
        "EngineRPM": 1194.25,
        "OnboardVoltage": 27176,
        "EngineSpeed": null,
        "TotalMileage": 544715500,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 97,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27269832,
        "Time": "2022-02-23T21:26:33",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2596626,
        "Lon": 86.17707,
        "Speed": 33.1,
        "Height": 187,
        "Mileage": 45933068,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 78,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27201,
        "EngineSpeed": null,
        "TotalMileage": 544720590,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27272470,
        "Time": "2022-02-23T21:45:45",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2610054,
        "Lon": 86.171936,
        "Speed": 19.2,
        "Height": 226,
        "Mileage": 45936716,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1812.875,
        "OnboardVoltage": 27423,
        "EngineSpeed": null,
        "TotalMileage": 544724360,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 95,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27274497,
        "Time": "2022-02-23T21:59:36",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.245575,
        "Lon": 86.15313,
        "Speed": 33.8,
        "Height": 329,
        "Mileage": 45941488,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1323.125,
        "OnboardVoltage": 27181,
        "EngineSpeed": null,
        "TotalMileage": 544729320,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 29,
        "FuelConsumption": 164,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27275920,
        "Time": "2022-02-23T22:09:54",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2712555,
        "Lon": 86.17062,
        "Speed": 8.7,
        "Height": 11,
        "Mileage": 45947616,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 84,
        "EngineRPM": 1322.75,
        "OnboardVoltage": 27222,
        "EngineSpeed": null,
        "TotalMileage": 544735085,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 7,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27279135,
        "Time": "2022-02-23T22:32:06",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25595,
        "Lon": 86.17502,
        "Speed": 22.0,
        "Height": 275,
        "Mileage": 45951440,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 88,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27208,
        "EngineSpeed": null,
        "TotalMileage": 544738975,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27280773,
        "Time": "2022-02-23T22:43:56",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2514954,
        "Lon": 86.15942,
        "Speed": 39.2,
        "Height": 322,
        "Mileage": 45956384,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 90,
        "EngineRPM": 1047.25,
        "OnboardVoltage": 27710,
        "EngineSpeed": null,
        "TotalMileage": 544743765,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 76,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27282242,
        "Time": "2022-02-23T22:53:10",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.271,
        "Lon": 86.170845,
        "Speed": 4.4,
        "Height": 12,
        "Mileage": 45961792,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 89,
        "EngineRPM": 808.25,
        "OnboardVoltage": 27632,
        "EngineSpeed": null,
        "TotalMileage": 544748920,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 41,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27284990,
        "Time": "2022-02-23T23:11:39",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2553978,
        "Lon": 86.1724854,
        "Speed": 24.8,
        "Height": 279,
        "Mileage": 45965652,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 93,
        "EngineRPM": 1716.0,
        "OnboardVoltage": 27720,
        "EngineSpeed": null,
        "TotalMileage": 544753145,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 81,
        "FuelConsumption": 327,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27287101,
        "Time": "2022-02-23T23:25:43",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2560654,
        "Lon": 86.16448,
        "Speed": 35.9,
        "Height": 290,
        "Mileage": 45971048,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 95,
        "EngineRPM": 1298.375,
        "OnboardVoltage": 27140,
        "EngineSpeed": null,
        "TotalMileage": 544758520,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29261,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27290217,
        "Time": "2022-02-23T23:47:48",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2678452,
        "Lon": 86.1677856,
        "Speed": 9.8,
        "Height": 99,
        "Mileage": 45975228,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 95,
        "EngineRPM": 1295.125,
        "OnboardVoltage": 27200,
        "EngineSpeed": null,
        "TotalMileage": 544762440,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 115,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29261,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27293168,
        "Time": "2022-02-24T00:08:27",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.24217,
        "Lon": 86.14629,
        "Speed": 4.0,
        "Height": 320,
        "Mileage": 45980420,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 95,
        "EngineRPM": 1620.875,
        "OnboardVoltage": 27124,
        "EngineSpeed": null,
        "TotalMileage": 544767965,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29261,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27297290,
        "Time": "2022-02-24T00:48:37",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.25613,
        "Lon": 86.1721954,
        "Speed": 8.1,
        "Height": 286,
        "Mileage": 45984056,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 95,
        "EngineRPM": 1130.75,
        "OnboardVoltage": 27221,
        "EngineSpeed": null,
        "TotalMileage": 544771050,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29262,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27300288,
        "Time": "2022-02-24T01:15:58",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2626648,
        "Lon": 86.15551,
        "Speed": 25.0,
        "Height": 302,
        "Mileage": 45991776,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 97,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27796,
        "EngineSpeed": null,
        "TotalMileage": 544778165,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 381,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29263,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27302032,
        "Time": "2022-02-24T01:28:53",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.249073,
        "Lon": 86.15771,
        "Speed": 29.2,
        "Height": 326,
        "Mileage": 45996088,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 900.375,
        "OnboardVoltage": 27756,
        "EngineSpeed": null,
        "TotalMileage": 544782310,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29263,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27307630,
        "Time": "2022-02-24T02:03:35",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.24926,
        "Lon": 86.15763,
        "Speed": 26.1,
        "Height": 329,
        "Mileage": 46005248,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 94,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27359,
        "EngineSpeed": null,
        "TotalMileage": 544791625,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29263,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27309947,
        "Time": "2022-02-24T02:21:15",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.28207,
        "Lon": 86.13898,
        "Speed": 0.0,
        "Height": 279,
        "Mileage": 46012084,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 87,
        "EngineRPM": 740.875,
        "OnboardVoltage": 27356,
        "EngineSpeed": null,
        "TotalMileage": 544798400,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29264,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27314709,
        "Time": "2022-02-24T02:54:51",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2426,
        "Lon": 86.14112,
        "Speed": 10.5,
        "Height": 330,
        "Mileage": 46018676,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 781.25,
        "OnboardVoltage": 27811,
        "EngineSpeed": null,
        "TotalMileage": 544804565,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29264,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27316641,
        "Time": "2022-02-24T03:07:58",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.2644,
        "Lon": 86.1720657,
        "Speed": 30.5,
        "Height": 165,
        "Mileage": 46023984,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 83,
        "EngineRPM": 1298.375,
        "OnboardVoltage": 27696,
        "EngineSpeed": null,
        "TotalMileage": 544809255,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29264,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27319173,
        "Time": "2022-02-24T03:26:29",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.30035,
        "Lon": 86.14493,
        "Speed": 31.8,
        "Height": 40,
        "Mileage": 46031984,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1179.5,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 544817795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 64,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29265,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27320960,
        "Time": "2022-02-24T03:37:52",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.3047562,
        "Lon": 86.14354,
        "Speed": 17.2,
        "Height": 80,
        "Mileage": 46034364,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 83,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 544820410,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29265,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27323949,
        "Time": "2022-02-24T03:56:27",
        "TruckId": 818,
        "Imei": "868328058771169",
        "Lat": 54.30783,
        "Lon": 86.17111,
        "Speed": 14.0,
        "Height": 427,
        "Mileage": 46038924,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 82,
        "EngineRPM": 1814.125,
        "OnboardVoltage": 27804,
        "EngineSpeed": null,
        "TotalMileage": 544825135,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 91,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 29265,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27004207,
        "Time": "2022-02-22T10:53:54",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2727,
        "Lon": 86.15446,
        "Speed": 27.4,
        "Height": 248,
        "Mileage": 74002392,
        "EngineOilPressure": 476,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 97,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27659,
        "EngineSpeed": null,
        "TotalMileage": 103448020,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 88,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27006150,
        "Time": "2022-02-22T11:08:44",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.24768,
        "Lon": 86.15525,
        "Speed": 35.1,
        "Height": 329,
        "Mileage": 74008104,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 98,
        "EngineRPM": 1593.25,
        "OnboardVoltage": 27650,
        "EngineSpeed": null,
        "TotalMileage": 103453550,
        "AcceleratorPedalPosition": 20,
        "LoadPercentage": 0,
        "FuelConsumption": 130,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27009586,
        "Time": "2022-02-22T11:34:10",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2556152,
        "Lon": 86.1612,
        "Speed": 33.3,
        "Height": 294,
        "Mileage": 74015080,
        "EngineOilPressure": 264,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 98,
        "EngineRPM": 1391.125,
        "OnboardVoltage": 27681,
        "EngineSpeed": null,
        "TotalMileage": 103461395,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 52,
        "FuelConsumption": 102,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27011541,
        "Time": "2022-02-22T11:48:07",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2652779,
        "Lon": 86.15653,
        "Speed": 35.0,
        "Height": 291,
        "Mileage": 74020536,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 100,
        "EngineRPM": 710.0,
        "OnboardVoltage": 27591,
        "EngineSpeed": null,
        "TotalMileage": 103467275,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.2
    },
    {
        "Id": 27015241,
        "Time": "2022-02-22T12:16:46",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.24786,
        "Lon": 86.15538,
        "Speed": 30.7,
        "Height": 335,
        "Mileage": 74027288,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 98,
        "EngineRPM": 1389.625,
        "OnboardVoltage": 27652,
        "EngineSpeed": null,
        "TotalMileage": 103473810,
        "AcceleratorPedalPosition": 65,
        "LoadPercentage": 36,
        "FuelConsumption": 127,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27016391,
        "Time": "2022-02-22T12:29:40",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25601,
        "Lon": 86.1721954,
        "Speed": 9.2,
        "Height": 284,
        "Mileage": 74031168,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 101,
        "EngineRPM": 1015.375,
        "OnboardVoltage": 27636,
        "EngineSpeed": null,
        "TotalMileage": 103478450,
        "AcceleratorPedalPosition": 13,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27018810,
        "Time": "2022-02-22T12:56:16",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26981,
        "Lon": 86.165,
        "Speed": 0.0,
        "Height": 100,
        "Mileage": 74033736,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 96,
        "EngineRPM": 1072.875,
        "OnboardVoltage": 27667,
        "EngineSpeed": null,
        "TotalMileage": 103481730,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 33,
        "FuelConsumption": 111,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27021085,
        "Time": "2022-02-22T13:14:45",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2657433,
        "Lon": 86.1565247,
        "Speed": 37.2,
        "Height": 287,
        "Mileage": 74038880,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 99,
        "EngineRPM": 1300.0,
        "OnboardVoltage": 27547,
        "EngineSpeed": null,
        "TotalMileage": 103486345,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27022715,
        "Time": "2022-02-22T13:31:57",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2608,
        "Lon": 86.17378,
        "Speed": 38.3,
        "Height": 208,
        "Mileage": 74045808,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 100,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27564,
        "EngineSpeed": null,
        "TotalMileage": 103494525,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27025490,
        "Time": "2022-02-22T13:54:38",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2622566,
        "Lon": 86.1718,
        "Speed": 17.9,
        "Height": 225,
        "Mileage": 74049456,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 100,
        "EngineRPM": 1807.125,
        "OnboardVoltage": 27667,
        "EngineSpeed": null,
        "TotalMileage": 103498250,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27027854,
        "Time": "2022-02-22T14:12:08",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2718468,
        "Lon": 86.1543655,
        "Speed": 27.5,
        "Height": 252,
        "Mileage": 74056296,
        "EngineOilPressure": 300,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 828.25,
        "OnboardVoltage": 27561,
        "EngineSpeed": null,
        "TotalMileage": 103505530,
        "AcceleratorPedalPosition": 3,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27031645,
        "Time": "2022-02-22T14:38:47",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.269928,
        "Lon": 86.16483,
        "Speed": 4.8,
        "Height": 105,
        "Mileage": 74060840,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 98,
        "EngineRPM": 736.375,
        "OnboardVoltage": 27763,
        "EngineSpeed": null,
        "TotalMileage": 103511405,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27035015,
        "Time": "2022-02-22T15:00:45",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.24233,
        "Lon": 86.14663,
        "Speed": 10.1,
        "Height": 329,
        "Mileage": 74067064,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 101,
        "EngineRPM": 1699.75,
        "OnboardVoltage": 27561,
        "EngineSpeed": null,
        "TotalMileage": 103516925,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27037503,
        "Time": "2022-02-22T15:21:57",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.255825,
        "Lon": 86.1748657,
        "Speed": 38.8,
        "Height": 275,
        "Mileage": 74069704,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 80,
        "EngineRPM": 891.0,
        "OnboardVoltage": 27649,
        "EngineSpeed": null,
        "TotalMileage": 103519995,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 97.200005
    },
    {
        "Id": 27042156,
        "Time": "2022-02-22T16:00:46",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.266777,
        "Lon": 86.1688156,
        "Speed": 11.1,
        "Height": 122,
        "Mileage": 74072144,
        "EngineOilPressure": 480,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 75,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27485,
        "EngineSpeed": null,
        "TotalMileage": 103523205,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 97.6
    },
    {
        "Id": 27044662,
        "Time": "2022-02-22T16:18:39",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2840271,
        "Lon": 86.1381149,
        "Speed": 4.4,
        "Height": 288,
        "Mileage": 74079120,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 72,
        "EngineRPM": 1202.5,
        "OnboardVoltage": 27698,
        "EngineSpeed": null,
        "TotalMileage": 103530185,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 61,
        "FuelConsumption": 95,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.8
    },
    {
        "Id": 27047053,
        "Time": "2022-02-22T16:38:05",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2693253,
        "Lon": 86.16472,
        "Speed": 0.0,
        "Height": 110,
        "Mileage": 74085192,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 75,
        "EngineRPM": 790.375,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 103537545,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.4
    },
    {
        "Id": 27050605,
        "Time": "2022-02-22T17:05:28",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2559738,
        "Lon": 86.1664047,
        "Speed": 39.2,
        "Height": 280,
        "Mileage": 74089176,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 72,
        "EngineRPM": 1412.875,
        "OnboardVoltage": 27620,
        "EngineSpeed": null,
        "TotalMileage": 103540590,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.4
    },
    {
        "Id": 27052651,
        "Time": "2022-02-22T17:23:33",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25767,
        "Lon": 86.17473,
        "Speed": 40.9,
        "Height": 263,
        "Mileage": 74096832,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 73,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27579,
        "EngineSpeed": null,
        "TotalMileage": 103549620,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.200005
    },
    {
        "Id": 27055154,
        "Time": "2022-02-22T17:45:47",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.259655,
        "Lon": 86.17689,
        "Speed": 19.0,
        "Height": 191,
        "Mileage": 74100304,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 73,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27543,
        "EngineSpeed": null,
        "TotalMileage": 103553680,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 381,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27056915,
        "Time": "2022-02-22T18:02:42",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2806778,
        "Lon": 86.14083,
        "Speed": 33.7,
        "Height": 285,
        "Mileage": 74106664,
        "EngineOilPressure": 196,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 84,
        "EngineRPM": 1427.25,
        "OnboardVoltage": 27531,
        "EngineSpeed": null,
        "TotalMileage": 103560055,
        "AcceleratorPedalPosition": 38,
        "LoadPercentage": 0,
        "FuelConsumption": 149,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27060161,
        "Time": "2022-02-22T18:31:32",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26981,
        "Lon": 86.16489,
        "Speed": 4.0,
        "Height": 110,
        "Mileage": 74112256,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 85,
        "EngineRPM": 816.0,
        "OnboardVoltage": 27728,
        "EngineSpeed": null,
        "TotalMileage": 103567240,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 34,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27061986,
        "Time": "2022-02-22T18:45:57",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2656555,
        "Lon": 86.15656,
        "Speed": 37.4,
        "Height": 281,
        "Mileage": 74117392,
        "EngineOilPressure": 280,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 85,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27554,
        "EngineSpeed": null,
        "TotalMileage": 103571615,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27064227,
        "Time": "2022-02-22T19:01:23",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2559357,
        "Lon": 86.17511,
        "Speed": 37.5,
        "Height": 271,
        "Mileage": 74123520,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 90,
        "EngineRPM": 1035.25,
        "OnboardVoltage": 27607,
        "EngineSpeed": null,
        "TotalMileage": 103578530,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27066666,
        "Time": "2022-02-22T19:19:15",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2622375,
        "Lon": 86.172554,
        "Speed": 22.2,
        "Height": 215,
        "Mileage": 74127856,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 91,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27637,
        "EngineSpeed": null,
        "TotalMileage": 103583275,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 370,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27068919,
        "Time": "2022-02-22T19:36:49",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.27178,
        "Lon": 86.15446,
        "Speed": 26.6,
        "Height": 261,
        "Mileage": 74134864,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 93,
        "EngineRPM": 1283.875,
        "OnboardVoltage": 27604,
        "EngineSpeed": null,
        "TotalMileage": 103590360,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 40,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27072353,
        "Time": "2022-02-22T20:00:46",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26809,
        "Lon": 86.16633,
        "Speed": 13.5,
        "Height": 108,
        "Mileage": 74139496,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 96,
        "EngineRPM": 1092.125,
        "OnboardVoltage": 27552,
        "EngineSpeed": null,
        "TotalMileage": 103596445,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27074351,
        "Time": "2022-02-22T20:13:56",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2685051,
        "Lon": 86.1550446,
        "Speed": 33.8,
        "Height": 265,
        "Mileage": 74145016,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 96,
        "EngineRPM": 817.0,
        "OnboardVoltage": 27656,
        "EngineSpeed": null,
        "TotalMileage": 103601265,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27076481,
        "Time": "2022-02-22T20:29:04",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2563972,
        "Lon": 86.17542,
        "Speed": 36.4,
        "Height": 264,
        "Mileage": 74150848,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 95,
        "EngineRPM": 1549.5,
        "OnboardVoltage": 27609,
        "EngineSpeed": null,
        "TotalMileage": 103608255,
        "AcceleratorPedalPosition": 67,
        "LoadPercentage": 24,
        "FuelConsumption": 108,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27081107,
        "Time": "2022-02-22T21:01:58",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2598953,
        "Lon": 86.1769,
        "Speed": 15.7,
        "Height": 184,
        "Mileage": 74154320,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 96,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27616,
        "EngineSpeed": null,
        "TotalMileage": 103612500,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.4
    },
    {
        "Id": 27083020,
        "Time": "2022-02-22T21:16:47",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.28397,
        "Lon": 86.13884,
        "Speed": 4.2,
        "Height": 283,
        "Mileage": 74160392,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 96,
        "EngineRPM": 1106.875,
        "OnboardVoltage": 27672,
        "EngineSpeed": null,
        "TotalMileage": 103618630,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.4
    },
    {
        "Id": 27084739,
        "Time": "2022-02-22T21:30:55",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.269455,
        "Lon": 86.16457,
        "Speed": 6.2,
        "Height": 98,
        "Mileage": 74166400,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 96,
        "EngineRPM": 1315.75,
        "OnboardVoltage": 27614,
        "EngineSpeed": null,
        "TotalMileage": 103625880,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 97,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27088262,
        "Time": "2022-02-22T21:56:27",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25594,
        "Lon": 86.17497,
        "Speed": 16.8,
        "Height": 278,
        "Mileage": 74169800,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 100,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27648,
        "EngineSpeed": null,
        "TotalMileage": 103628670,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27090909,
        "Time": "2022-02-22T22:15:12",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25596,
        "Lon": 86.16393,
        "Speed": 28.7,
        "Height": 288,
        "Mileage": 74177480,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 101,
        "EngineRPM": 854.0,
        "OnboardVoltage": 27539,
        "EngineSpeed": null,
        "TotalMileage": 103637140,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 204,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 65.6
    },
    {
        "Id": 27093657,
        "Time": "2022-02-22T22:38:44",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2594757,
        "Lon": 86.1765,
        "Speed": 15.5,
        "Height": 195,
        "Mileage": 74181960,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 100,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27663,
        "EngineSpeed": null,
        "TotalMileage": 103642115,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27096040,
        "Time": "2022-02-22T22:56:34",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2755852,
        "Lon": 86.14828,
        "Speed": 38.1,
        "Height": 269,
        "Mileage": 74189032,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 101,
        "EngineRPM": 794.0,
        "OnboardVoltage": 27546,
        "EngineSpeed": null,
        "TotalMileage": 103649215,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27098232,
        "Time": "2022-02-22T23:13:38",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2694931,
        "Lon": 86.16672,
        "Speed": 41.6,
        "Height": 89,
        "Mileage": 74194128,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 100,
        "EngineRPM": 1044.75,
        "OnboardVoltage": 27672,
        "EngineSpeed": null,
        "TotalMileage": 103655575,
        "AcceleratorPedalPosition": 24,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27099542,
        "Time": "2022-02-22T23:23:27",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2685165,
        "Lon": 86.17152,
        "Speed": 29.6,
        "Height": 30,
        "Mileage": 74196344,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1209.75,
        "OnboardVoltage": 27705,
        "EngineSpeed": null,
        "TotalMileage": 103658045,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 73,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27102340,
        "Time": "2022-02-22T23:44:28",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2804565,
        "Lon": 86.1409,
        "Speed": 27.5,
        "Height": 279,
        "Mileage": 74204264,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1516.375,
        "OnboardVoltage": 27601,
        "EngineSpeed": null,
        "TotalMileage": 103665805,
        "AcceleratorPedalPosition": 89,
        "LoadPercentage": 54,
        "FuelConsumption": 91,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27104905,
        "Time": "2022-02-23T00:05:52",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2749672,
        "Lon": 86.15264,
        "Speed": 15.9,
        "Height": 240,
        "Mileage": 74208272,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 103,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27639,
        "EngineSpeed": null,
        "TotalMileage": 103670475,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 375,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27107813,
        "Time": "2022-02-23T00:24:12",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2411766,
        "Lon": 86.14507,
        "Speed": 20.1,
        "Height": 323,
        "Mileage": 74214240,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 103,
        "EngineRPM": 734.875,
        "OnboardVoltage": 27580,
        "EngineSpeed": null,
        "TotalMileage": 103675595,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 52,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27109859,
        "Time": "2022-02-23T00:52:41",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25937,
        "Lon": 86.17653,
        "Speed": 36.1,
        "Height": 190,
        "Mileage": 74218248,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 102,
        "EngineRPM": 1148.5,
        "OnboardVoltage": 27692,
        "EngineSpeed": null,
        "TotalMileage": 103679755,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27113457,
        "Time": "2022-02-23T01:22:58",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2622147,
        "Lon": 86.17186,
        "Speed": 19.0,
        "Height": 214,
        "Mileage": 74221888,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 98,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 103683385,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 374,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27115992,
        "Time": "2022-02-23T01:43:02",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2624435,
        "Lon": 86.15559,
        "Speed": 35.3,
        "Height": 302,
        "Mileage": 74230216,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 102,
        "EngineRPM": 1640.75,
        "OnboardVoltage": 27634,
        "EngineSpeed": null,
        "TotalMileage": 103691590,
        "AcceleratorPedalPosition": 97,
        "LoadPercentage": 84,
        "FuelConsumption": 147,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27117722,
        "Time": "2022-02-23T01:53:51",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26934,
        "Lon": 86.16485,
        "Speed": 5.1,
        "Height": 77,
        "Mileage": 74234360,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 101,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27561,
        "EngineSpeed": null,
        "TotalMileage": 103696630,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27120851,
        "Time": "2022-02-23T02:17:42",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2619972,
        "Lon": 86.17164,
        "Speed": 19.0,
        "Height": 218,
        "Mileage": 74236600,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27713,
        "EngineSpeed": null,
        "TotalMileage": 103698550,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27124388,
        "Time": "2022-02-23T02:43:32",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.27898,
        "Lon": 86.1429,
        "Speed": 30.9,
        "Height": 281,
        "Mileage": 74243312,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 103,
        "EngineRPM": 1252.375,
        "OnboardVoltage": 27721,
        "EngineSpeed": null,
        "TotalMileage": 103704715,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.600002
    },
    {
        "Id": 27127316,
        "Time": "2022-02-23T03:04:25",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2629929,
        "Lon": 86.15569,
        "Speed": 37.7,
        "Height": 311,
        "Mileage": 74251440,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1101.875,
        "OnboardVoltage": 27633,
        "EngineSpeed": null,
        "TotalMileage": 103712740,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.600002
    },
    {
        "Id": 27130866,
        "Time": "2022-02-23T03:29:42",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.24788,
        "Lon": 86.14087,
        "Speed": 13.3,
        "Height": 367,
        "Mileage": 74260288,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 101,
        "EngineRPM": 1734.375,
        "OnboardVoltage": 27707,
        "EngineSpeed": null,
        "TotalMileage": 103721595,
        "AcceleratorPedalPosition": 91,
        "LoadPercentage": 74,
        "FuelConsumption": 194,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27133406,
        "Time": "2022-02-23T03:47:17",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.28392,
        "Lon": 86.1372147,
        "Speed": 4.6,
        "Height": 304,
        "Mileage": 74265792,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 101,
        "EngineRPM": 754.875,
        "OnboardVoltage": 27728,
        "EngineSpeed": null,
        "TotalMileage": 103727555,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.8
    },
    {
        "Id": 27137184,
        "Time": "2022-02-23T04:11:38",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.24791,
        "Lon": 86.14136,
        "Speed": 9.4,
        "Height": 365,
        "Mileage": 74272144,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 101,
        "EngineRPM": 855.75,
        "OnboardVoltage": 27750,
        "EngineSpeed": null,
        "TotalMileage": 103733450,
        "AcceleratorPedalPosition": 23,
        "LoadPercentage": 19,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27140982,
        "Time": "2022-02-23T04:35:28",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2836533,
        "Lon": 86.13765,
        "Speed": 10.0,
        "Height": 294,
        "Mileage": 74277240,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 100,
        "EngineRPM": 822.75,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 103739305,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 45,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.600002
    },
    {
        "Id": 27143601,
        "Time": "2022-02-23T04:53:54",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2479,
        "Lon": 86.15506,
        "Speed": 40.5,
        "Height": 332,
        "Mileage": 74284280,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 99,
        "EngineRPM": 1154.875,
        "OnboardVoltage": 27723,
        "EngineSpeed": null,
        "TotalMileage": 103745830,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.4
    },
    {
        "Id": 27147216,
        "Time": "2022-02-23T05:29:54",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.27043,
        "Lon": 86.1553345,
        "Speed": 35.1,
        "Height": 269,
        "Mileage": 74288320,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 70,
        "FuelTemperature": 77,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27702,
        "EngineSpeed": null,
        "TotalMileage": 103750625,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.6
    },
    {
        "Id": 27150486,
        "Time": "2022-02-23T05:57:38",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.24804,
        "Lon": 86.14067,
        "Speed": 14.8,
        "Height": 363,
        "Mileage": 74296592,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 73,
        "EngineRPM": 693.125,
        "OnboardVoltage": 27641,
        "EngineSpeed": null,
        "TotalMileage": 103758430,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.6
    },
    {
        "Id": 27156422,
        "Time": "2022-02-23T06:41:26",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.28344,
        "Lon": 86.13745,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": 74301640,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 71,
        "EngineRPM": 1022.875,
        "OnboardVoltage": 27699,
        "EngineSpeed": null,
        "TotalMileage": 103764365,
        "AcceleratorPedalPosition": 29,
        "LoadPercentage": 79,
        "FuelConsumption": 127,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27159253,
        "Time": "2022-02-23T07:03:10",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2481155,
        "Lon": 86.14071,
        "Speed": 4.0,
        "Height": 364,
        "Mileage": 74307456,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 66,
        "EngineRPM": 1102.125,
        "OnboardVoltage": 27625,
        "EngineSpeed": null,
        "TotalMileage": 103770290,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 147,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27162554,
        "Time": "2022-02-23T07:24:51",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26864,
        "Lon": 86.1547852,
        "Speed": 17.5,
        "Height": 278,
        "Mileage": 74314976,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 73,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27711,
        "EngineSpeed": null,
        "TotalMileage": 103778010,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27165112,
        "Time": "2022-02-23T07:42:36",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2519722,
        "Lon": 86.16007,
        "Speed": 37.5,
        "Height": 324,
        "Mileage": 74320416,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 73,
        "EngineRPM": 661.875,
        "OnboardVoltage": 27738,
        "EngineSpeed": null,
        "TotalMileage": 103783390,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 45,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.4
    },
    {
        "Id": 27168639,
        "Time": "2022-02-23T08:09:01",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.248745,
        "Lon": 86.15728,
        "Speed": 27.9,
        "Height": 332,
        "Mileage": 74329360,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 80,
        "EngineRPM": 1420.0,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 103792450,
        "AcceleratorPedalPosition": 69,
        "LoadPercentage": 55,
        "FuelConsumption": 311,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.8
    },
    {
        "Id": 27170840,
        "Time": "2022-02-23T08:26:52",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2838631,
        "Lon": 86.137085,
        "Speed": 7.0,
        "Height": 289,
        "Mileage": 74335928,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 698.5,
        "OnboardVoltage": 27671,
        "EngineSpeed": null,
        "TotalMileage": 103799640,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 48,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27173794,
        "Time": "2022-02-23T08:49:51",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2482147,
        "Lon": 86.14063,
        "Speed": 5.3,
        "Height": 366,
        "Mileage": 74342208,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 85,
        "EngineRPM": 707.375,
        "OnboardVoltage": 27739,
        "EngineSpeed": null,
        "TotalMileage": 103805450,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.0
    },
    {
        "Id": 27176614,
        "Time": "2022-02-23T09:15:08",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26868,
        "Lon": 86.1548,
        "Speed": 21.4,
        "Height": 279,
        "Mileage": 74350168,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 87,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27654,
        "EngineSpeed": null,
        "TotalMileage": 103813450,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 370,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27178727,
        "Time": "2022-02-23T09:31:46",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2692871,
        "Lon": 86.15514,
        "Speed": 37.0,
        "Height": 270,
        "Mileage": 74356928,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 89,
        "EngineRPM": 748.75,
        "OnboardVoltage": 27714,
        "EngineSpeed": null,
        "TotalMileage": 103820690,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27182834,
        "Time": "2022-02-23T09:59:22",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2466125,
        "Lon": 86.14695,
        "Speed": 29.8,
        "Height": 353,
        "Mileage": 74364432,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 89,
        "EngineRPM": 1814.5,
        "OnboardVoltage": 27587,
        "EngineSpeed": null,
        "TotalMileage": 103827890,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27186121,
        "Time": "2022-02-23T10:26:38",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.284,
        "Lon": 86.13746,
        "Speed": 5.5,
        "Height": 294,
        "Mileage": 74370032,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 93,
        "EngineRPM": 765.0,
        "OnboardVoltage": 27722,
        "EngineSpeed": null,
        "TotalMileage": 103834940,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27189457,
        "Time": "2022-02-23T10:50:50",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2477,
        "Lon": 86.14154,
        "Speed": 5.1,
        "Height": 360,
        "Mileage": 74376104,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 93,
        "EngineRPM": 754.25,
        "OnboardVoltage": 27647,
        "EngineSpeed": null,
        "TotalMileage": 103840950,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27190873,
        "Time": "2022-02-23T11:02:59",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26341,
        "Lon": 86.1736,
        "Speed": 35.5,
        "Height": 159,
        "Mileage": 74380232,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 93,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27673,
        "EngineSpeed": null,
        "TotalMileage": 103845380,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27192283,
        "Time": "2022-02-23T11:12:58",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26699,
        "Lon": 86.18732,
        "Speed": 28.8,
        "Height": 206,
        "Mileage": 74384920,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 93,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27769,
        "EngineSpeed": null,
        "TotalMileage": 103850030,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 84,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27200688,
        "Time": "2022-02-23T12:23:01",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2667046,
        "Lon": 86.18656,
        "Speed": 33.7,
        "Height": 195,
        "Mileage": 74388000,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 94,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27530,
        "EngineSpeed": null,
        "TotalMileage": 103853400,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27202355,
        "Time": "2022-02-23T12:42:20",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2687263,
        "Lon": 86.16532,
        "Speed": 0.0,
        "Height": 97,
        "Mileage": 74392616,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 92,
        "EngineRPM": 699.125,
        "OnboardVoltage": 27702,
        "EngineSpeed": null,
        "TotalMileage": 103858810,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 37,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27205258,
        "Time": "2022-02-23T13:12:17",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2561226,
        "Lon": 86.16486,
        "Speed": 35.0,
        "Height": 272,
        "Mileage": 74396648,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 98,
        "EngineRPM": 794.5,
        "OnboardVoltage": 27563,
        "EngineSpeed": null,
        "TotalMileage": 103862135,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 16,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27207698,
        "Time": "2022-02-23T13:30:47",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2686539,
        "Lon": 86.15488,
        "Speed": 33.8,
        "Height": 277,
        "Mileage": 74402360,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 97,
        "EngineRPM": 1655.125,
        "OnboardVoltage": 27545,
        "EngineSpeed": null,
        "TotalMileage": 103868310,
        "AcceleratorPedalPosition": 79,
        "LoadPercentage": 61,
        "FuelConsumption": 275,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27210387,
        "Time": "2022-02-23T13:50:20",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26386,
        "Lon": 86.17298,
        "Speed": 34.8,
        "Height": 149,
        "Mileage": 74406456,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 1516.625,
        "OnboardVoltage": 27513,
        "EngineSpeed": null,
        "TotalMileage": 103873130,
        "AcceleratorPedalPosition": 74,
        "LoadPercentage": 65,
        "FuelConsumption": 188,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27214370,
        "Time": "2022-02-23T14:21:04",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2609749,
        "Lon": 86.17195,
        "Speed": 19.6,
        "Height": 229,
        "Mileage": 74410064,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 81,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27654,
        "EngineSpeed": null,
        "TotalMileage": 103876335,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 370,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.4
    },
    {
        "Id": 27217194,
        "Time": "2022-02-23T14:42:03",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2560463,
        "Lon": 86.1653,
        "Speed": 23.8,
        "Height": 287,
        "Mileage": 74418520,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 1339.125,
        "OnboardVoltage": 27597,
        "EngineSpeed": null,
        "TotalMileage": 103885530,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.0
    },
    {
        "Id": 27220514,
        "Time": "2022-02-23T15:09:47",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2699051,
        "Lon": 86.16429,
        "Speed": 0.0,
        "Height": 103,
        "Mileage": 74421288,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 82,
        "EngineRPM": 720.875,
        "OnboardVoltage": 27824,
        "EngineSpeed": null,
        "TotalMileage": 103889170,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.0
    },
    {
        "Id": 27223124,
        "Time": "2022-02-23T15:28:57",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.27881,
        "Lon": 86.14324,
        "Speed": 31.8,
        "Height": 282,
        "Mileage": 74428192,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27559,
        "EngineSpeed": null,
        "TotalMileage": 103895575,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27225170,
        "Time": "2022-02-23T15:43:02",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26217,
        "Lon": 86.17246,
        "Speed": 32.2,
        "Height": 222,
        "Mileage": 74433696,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27563,
        "EngineSpeed": null,
        "TotalMileage": 103901810,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27227864,
        "Time": "2022-02-23T16:01:38",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2623329,
        "Lon": 86.17211,
        "Speed": 18.3,
        "Height": 219,
        "Mileage": 74437664,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 85,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27606,
        "EngineSpeed": null,
        "TotalMileage": 103905885,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 374,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.200005
    },
    {
        "Id": 27230332,
        "Time": "2022-02-23T16:20:38",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2680473,
        "Lon": 86.1551361,
        "Speed": 35.1,
        "Height": 275,
        "Mileage": 74444920,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 85,
        "EngineRPM": 1639.75,
        "OnboardVoltage": 27497,
        "EngineSpeed": null,
        "TotalMileage": 103913515,
        "AcceleratorPedalPosition": 86,
        "LoadPercentage": 75,
        "FuelConsumption": 270,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27232608,
        "Time": "2022-02-23T16:39:12",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2614975,
        "Lon": 86.17528,
        "Speed": 21.2,
        "Height": 165,
        "Mileage": 74450208,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 88,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27596,
        "EngineSpeed": null,
        "TotalMileage": 103919895,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 387,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.8
    },
    {
        "Id": 27235166,
        "Time": "2022-02-23T16:57:49",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.27876,
        "Lon": 86.14327,
        "Speed": 34.6,
        "Height": 273,
        "Mileage": 74457360,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 91,
        "EngineRPM": 1185.875,
        "OnboardVoltage": 27502,
        "EngineSpeed": null,
        "TotalMileage": 103926775,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 119,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27236938,
        "Time": "2022-02-23T17:13:53",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26976,
        "Lon": 86.16442,
        "Speed": 5.5,
        "Height": 114,
        "Mileage": 74462712,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 90,
        "EngineRPM": 795.75,
        "OnboardVoltage": 27549,
        "EngineSpeed": null,
        "TotalMileage": 103933800,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 32,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27238845,
        "Time": "2022-02-23T17:32:13",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2803345,
        "Lon": 86.14118,
        "Speed": 29.8,
        "Height": 280,
        "Mileage": 74469800,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 95,
        "EngineRPM": 1780.75,
        "OnboardVoltage": 27680,
        "EngineSpeed": null,
        "TotalMileage": 103940500,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27240603,
        "Time": "2022-02-23T17:46:07",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2595329,
        "Lon": 86.17701,
        "Speed": 35.7,
        "Height": 185,
        "Mileage": 74475232,
        "EngineOilPressure": 328,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 93,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27593,
        "EngineSpeed": null,
        "TotalMileage": 103946915,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27243317,
        "Time": "2022-02-23T18:04:55",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2561035,
        "Lon": 86.16496,
        "Speed": 31.4,
        "Height": 280,
        "Mileage": 74480560,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 96,
        "EngineRPM": 1517.25,
        "OnboardVoltage": 27593,
        "EngineSpeed": null,
        "TotalMileage": 103951660,
        "AcceleratorPedalPosition": 73,
        "LoadPercentage": 22,
        "FuelConsumption": 218,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27245294,
        "Time": "2022-02-23T18:21:30",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2566948,
        "Lon": 86.15926,
        "Speed": 32.0,
        "Height": 299,
        "Mileage": 74487224,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 97,
        "EngineRPM": 667.375,
        "OnboardVoltage": 27511,
        "EngineSpeed": null,
        "TotalMileage": 103959390,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 46,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27248530,
        "Time": "2022-02-23T18:48:45",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26892,
        "Lon": 86.16517,
        "Speed": 13.7,
        "Height": 101,
        "Mileage": 74490248,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 96,
        "EngineRPM": 1093.625,
        "OnboardVoltage": 27650,
        "EngineSpeed": null,
        "TotalMileage": 103963665,
        "AcceleratorPedalPosition": 22,
        "LoadPercentage": 27,
        "FuelConsumption": 97,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27251346,
        "Time": "2022-02-23T19:08:03",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2839928,
        "Lon": 86.13723,
        "Speed": 4.0,
        "Height": 287,
        "Mileage": 74497736,
        "EngineOilPressure": 328,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 97,
        "EngineRPM": 936.75,
        "OnboardVoltage": 27457,
        "EngineSpeed": null,
        "TotalMileage": 103970895,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 141,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27253370,
        "Time": "2022-02-23T19:22:51",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.269,
        "Lon": 86.16498,
        "Speed": 14.2,
        "Height": 97,
        "Mileage": 74503816,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 972.125,
        "OnboardVoltage": 27556,
        "EngineSpeed": null,
        "TotalMileage": 103978055,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27256911,
        "Time": "2022-02-23T19:50:00",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2625237,
        "Lon": 86.15573,
        "Speed": 35.1,
        "Height": 301,
        "Mileage": 74508952,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 98,
        "EngineRPM": 1797.875,
        "OnboardVoltage": 27585,
        "EngineSpeed": null,
        "TotalMileage": 103982500,
        "AcceleratorPedalPosition": 27,
        "LoadPercentage": 0,
        "FuelConsumption": 299,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27259284,
        "Time": "2022-02-23T20:06:19",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2570038,
        "Lon": 86.17522,
        "Speed": 37.9,
        "Height": 265,
        "Mileage": 74515504,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 98,
        "EngineRPM": 1298.125,
        "OnboardVoltage": 27595,
        "EngineSpeed": null,
        "TotalMileage": 103990280,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27262266,
        "Time": "2022-02-23T20:28:08",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25941,
        "Lon": 86.17654,
        "Speed": 18.3,
        "Height": 185,
        "Mileage": 74519632,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 98,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27580,
        "EngineSpeed": null,
        "TotalMileage": 103994545,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 389,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27264845,
        "Time": "2022-02-23T20:46:57",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2746544,
        "Lon": 86.15018,
        "Speed": 37.9,
        "Height": 259,
        "Mileage": 74526744,
        "EngineOilPressure": 308,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 101,
        "EngineRPM": 846.5,
        "OnboardVoltage": 27497,
        "EngineSpeed": null,
        "TotalMileage": 104001650,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 22,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27269653,
        "Time": "2022-02-23T21:25:18",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2699,
        "Lon": 86.16414,
        "Speed": 6.4,
        "Height": 107,
        "Mileage": 74531792,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 68,
        "FuelTemperature": 97,
        "EngineRPM": 759.625,
        "OnboardVoltage": 27637,
        "EngineSpeed": null,
        "TotalMileage": 104007925,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27273047,
        "Time": "2022-02-23T21:48:01",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2690544,
        "Lon": 86.1551,
        "Speed": 32.4,
        "Height": 269,
        "Mileage": 74537560,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27650,
        "EngineSpeed": null,
        "TotalMileage": 104013045,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27275312,
        "Time": "2022-02-23T22:05:04",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.262,
        "Lon": 86.17272,
        "Speed": 32.9,
        "Height": 214,
        "Mileage": 74544104,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 1302.125,
        "OnboardVoltage": 27511,
        "EngineSpeed": null,
        "TotalMileage": 104020530,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27279685,
        "Time": "2022-02-23T22:35:43",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25953,
        "Lon": 86.17675,
        "Speed": 19.4,
        "Height": 189,
        "Mileage": 74547592,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 99,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27603,
        "EngineSpeed": null,
        "TotalMileage": 104024375,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 375,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27282124,
        "Time": "2022-02-23T22:52:34",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.27757,
        "Lon": 86.14491,
        "Speed": 27.0,
        "Height": 277,
        "Mileage": 74554440,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 101,
        "EngineRPM": 1400.875,
        "OnboardVoltage": 27618,
        "EngineSpeed": null,
        "TotalMileage": 104031160,
        "AcceleratorPedalPosition": 58,
        "LoadPercentage": 32,
        "FuelConsumption": 162,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27284664,
        "Time": "2022-02-23T23:10:00",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2698746,
        "Lon": 86.16434,
        "Speed": 4.6,
        "Height": 108,
        "Mileage": 74559584,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 98,
        "EngineRPM": 704.25,
        "OnboardVoltage": 27504,
        "EngineSpeed": null,
        "TotalMileage": 104037885,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 19,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27287321,
        "Time": "2022-02-23T23:28:08",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2814636,
        "Lon": 86.13983,
        "Speed": 27.0,
        "Height": 282,
        "Mileage": 74566808,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1415.375,
        "OnboardVoltage": 27533,
        "EngineSpeed": null,
        "TotalMileage": 104044490,
        "AcceleratorPedalPosition": 71,
        "LoadPercentage": 48,
        "FuelConsumption": 146,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27289089,
        "Time": "2022-02-23T23:40:09",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2619438,
        "Lon": 86.17272,
        "Speed": 33.3,
        "Height": 209,
        "Mileage": 74571568,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27593,
        "EngineSpeed": null,
        "TotalMileage": 104050475,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27292343,
        "Time": "2022-02-24T00:03:00",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2622948,
        "Lon": 86.1719,
        "Speed": 17.0,
        "Height": 221,
        "Mileage": 74575336,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 100,
        "EngineRPM": 1807.0,
        "OnboardVoltage": 27666,
        "EngineSpeed": null,
        "TotalMileage": 104054515,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 375,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.600002
    },
    {
        "Id": 27295414,
        "Time": "2022-02-24T00:24:43",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.26293,
        "Lon": 86.15563,
        "Speed": 28.5,
        "Height": 298,
        "Mileage": 74584312,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 101,
        "EngineRPM": 1662.0,
        "OnboardVoltage": 27619,
        "EngineSpeed": null,
        "TotalMileage": 104062775,
        "AcceleratorPedalPosition": 74,
        "LoadPercentage": 65,
        "FuelConsumption": 301,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.8
    },
    {
        "Id": 27298141,
        "Time": "2022-02-24T00:57:02",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2770729,
        "Lon": 86.1480942,
        "Speed": 31.4,
        "Height": 250,
        "Mileage": 74589528,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 98,
        "EngineRPM": 1602.75,
        "OnboardVoltage": 27610,
        "EngineSpeed": null,
        "TotalMileage": 104067710,
        "AcceleratorPedalPosition": 76,
        "LoadPercentage": 69,
        "FuelConsumption": 276,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.8
    },
    {
        "Id": 27303711,
        "Time": "2022-02-24T01:33:13",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.24127,
        "Lon": 86.14535,
        "Speed": 18.1,
        "Height": 323,
        "Mileage": 74596056,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 97,
        "EngineRPM": 1299.875,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 104074130,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.0
    },
    {
        "Id": 27304200,
        "Time": "2022-02-24T01:43:45",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2609138,
        "Lon": 86.17363,
        "Speed": 34.4,
        "Height": 212,
        "Mileage": 74599688,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 97,
        "EngineRPM": 1302.5,
        "OnboardVoltage": 27657,
        "EngineSpeed": null,
        "TotalMileage": 104078445,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27305812,
        "Time": "2022-02-24T01:55:05",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2685242,
        "Lon": 86.16717,
        "Speed": 12.7,
        "Height": 100,
        "Mileage": 74602560,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 98,
        "EngineRPM": 717.75,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 104081880,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 57,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.2
    },
    {
        "Id": 27308420,
        "Time": "2022-02-24T02:11:20",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2823029,
        "Lon": 86.17911,
        "Speed": 35.7,
        "Height": 269,
        "Mileage": 74609696,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 99,
        "EngineRPM": 1609.875,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 104087525,
        "AcceleratorPedalPosition": 78,
        "LoadPercentage": 60,
        "FuelConsumption": 306,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.0
    },
    {
        "Id": 27310014,
        "Time": "2022-02-24T02:21:43",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.27581,
        "Lon": 86.1762848,
        "Speed": 22.5,
        "Height": 96,
        "Mileage": 74613608,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27650,
        "EngineSpeed": null,
        "TotalMileage": 104091885,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.8
    },
    {
        "Id": 27311913,
        "Time": "2022-02-24T02:35:11",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.25624,
        "Lon": 86.17512,
        "Speed": 32.0,
        "Height": 267,
        "Mileage": 74619536,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 101,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27639,
        "EngineSpeed": null,
        "TotalMileage": 104096805,
        "AcceleratorPedalPosition": 97,
        "LoadPercentage": 86,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27317079,
        "Time": "2022-02-24T03:11:13",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2699966,
        "Lon": 86.15498,
        "Speed": 20.3,
        "Height": 272,
        "Mileage": 74624672,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 98,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27745,
        "EngineSpeed": null,
        "TotalMileage": 104102630,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.8
    },
    {
        "Id": 27319542,
        "Time": "2022-02-24T03:28:48",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.28165,
        "Lon": 86.14409,
        "Speed": 8.3,
        "Height": 244,
        "Mileage": 74630880,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 98,
        "EngineRPM": 773.25,
        "OnboardVoltage": 27635,
        "EngineSpeed": null,
        "TotalMileage": 104108605,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 43,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.4
    },
    {
        "Id": 27322611,
        "Time": "2022-02-24T03:48:05",
        "TruckId": 1752,
        "Imei": "868328058784261",
        "Lat": 54.2614326,
        "Lon": 86.14404,
        "Speed": 33.1,
        "Height": 373,
        "Mileage": 74635888,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1293.625,
        "OnboardVoltage": 27743,
        "EngineSpeed": null,
        "TotalMileage": 104112755,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 35.600002
    },
    {
        "Id": 27004210,
        "Time": "2022-02-22T10:53:54",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2571526,
        "Lon": 86.17485,
        "Speed": 10.7,
        "Height": 265,
        "Mileage": 6650741,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 87,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27246,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 91,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7408,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27006319,
        "Time": "2022-02-22T11:09:27",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.25369,
        "Lon": 86.16142,
        "Speed": 25.1,
        "Height": 302,
        "Mileage": 6656150,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 87,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27250,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7409,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27008535,
        "Time": "2022-02-22T11:26:22",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2659836,
        "Lon": 86.1692,
        "Speed": 12.4,
        "Height": 130,
        "Mileage": 6660490,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 87,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27262,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 353,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7409,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27011901,
        "Time": "2022-02-22T11:44:48",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.24286,
        "Lon": 86.14733,
        "Speed": 21.1,
        "Height": 336,
        "Mileage": 6665557,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 89,
        "EngineRPM": 1275.625,
        "OnboardVoltage": 27483,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 31,
        "FuelConsumption": 184,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7409,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27014585,
        "Time": "2022-02-22T12:15:25",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.26989,
        "Lon": 86.16469,
        "Speed": 0.0,
        "Height": 107,
        "Mileage": 6670979,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 88,
        "EngineRPM": 750.625,
        "OnboardVoltage": 27789,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7410,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27018736,
        "Time": "2022-02-22T12:55:25",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2565422,
        "Lon": 86.17145,
        "Speed": 6.6,
        "Height": 284,
        "Mileage": 6674046,
        "EngineOilPressure": 292,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 87,
        "EngineRPM": 777.0,
        "OnboardVoltage": 27571,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 42,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7411,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27020875,
        "Time": "2022-02-22T13:12:48",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2489128,
        "Lon": 86.15766,
        "Speed": 32.9,
        "Height": 334,
        "Mileage": 6678821,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 83,
        "EngineRPM": 1160.125,
        "OnboardVoltage": 27341,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 19,
        "FuelConsumption": 76,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7411,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27025779,
        "Time": "2022-02-22T13:56:45",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2639771,
        "Lon": 86.1727142,
        "Speed": 33.7,
        "Height": 144,
        "Mileage": 6682657,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 85,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27221,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7412,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27030609,
        "Time": "2022-02-22T14:31:04",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3062553,
        "Lon": 86.13558,
        "Speed": 12.2,
        "Height": 140,
        "Mileage": 6690027,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 85,
        "EngineRPM": 1145.125,
        "OnboardVoltage": 27428,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 36,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7412,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27033871,
        "Time": "2022-02-22T14:56:17",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31,
        "Lon": 86.15473,
        "Speed": 9.8,
        "Height": 317,
        "Mileage": 6693227,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 85,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27390,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7412,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27036272,
        "Time": "2022-02-22T15:13:32",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3103,
        "Lon": 86.1327057,
        "Speed": 30.0,
        "Height": 179,
        "Mileage": 6698063,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 88,
        "EngineRPM": 1300.375,
        "OnboardVoltage": 27195,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7413,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27040571,
        "Time": "2022-02-22T15:46:42",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3065338,
        "Lon": 86.13456,
        "Speed": 12.2,
        "Height": 147,
        "Mileage": 6699620,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 86,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27370,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 333,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7413,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27043054,
        "Time": "2022-02-22T16:07:55",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3084335,
        "Lon": 86.1724548,
        "Speed": 4.2,
        "Height": 429,
        "Mileage": 6703527,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 90,
        "EngineRPM": 758.25,
        "OnboardVoltage": 27396,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7414,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27045205,
        "Time": "2022-02-22T16:22:11",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30724,
        "Lon": 86.137825,
        "Speed": 0.0,
        "Height": 154,
        "Mileage": 6707772,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 88,
        "EngineRPM": 792.375,
        "OnboardVoltage": 27566,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7414,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27047876,
        "Time": "2022-02-22T16:45:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3073845,
        "Lon": 86.17107,
        "Speed": 8.8,
        "Height": 418,
        "Mileage": 6711843,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 89,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27401,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7414,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27053139,
        "Time": "2022-02-22T17:27:33",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31261,
        "Lon": 86.1461,
        "Speed": 8.8,
        "Height": 265,
        "Mileage": 6714568,
        "EngineOilPressure": 280,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 808.75,
        "OnboardVoltage": 27394,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 45,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7415,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27055017,
        "Time": "2022-02-22T17:44:31",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30737,
        "Lon": 86.13401,
        "Speed": 18.5,
        "Height": 153,
        "Mileage": 6717454,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 87,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27318,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 350,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7415,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27057263,
        "Time": "2022-02-22T18:05:32",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3085823,
        "Lon": 86.1718445,
        "Speed": 13.3,
        "Height": 432,
        "Mileage": 6721295,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 92,
        "EngineRPM": 988.125,
        "OnboardVoltage": 27373,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 42,
        "FuelConsumption": 75,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7416,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27059714,
        "Time": "2022-02-22T18:27:57",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3063049,
        "Lon": 86.13563,
        "Speed": 8.7,
        "Height": 136,
        "Mileage": 6725225,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 89,
        "EngineRPM": 1363.0,
        "OnboardVoltage": 27247,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 45,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7416,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27061480,
        "Time": "2022-02-22T18:42:37",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3137054,
        "Lon": 86.1489258,
        "Speed": 20.5,
        "Height": 263,
        "Mileage": 6728025,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 88,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27362,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 80,
        "FuelConsumption": 332,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7416,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27064012,
        "Time": "2022-02-22T18:59:55",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31318,
        "Lon": 86.15198,
        "Speed": 29.4,
        "Height": 280,
        "Mileage": 6732079,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 89,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27160,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7417,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27068465,
        "Time": "2022-02-22T19:33:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3079338,
        "Lon": 86.1368256,
        "Speed": 13.5,
        "Height": 150,
        "Mileage": 6734773,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 67,
        "EngineRPM": 1344.625,
        "OnboardVoltage": 27168,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 31,
        "FuelConsumption": 146,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7417,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27072459,
        "Time": "2022-02-22T20:01:10",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3082275,
        "Lon": 86.16117,
        "Speed": 13.8,
        "Height": 367,
        "Mileage": 6738311,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 64,
        "EngineRPM": 1807.5,
        "OnboardVoltage": 27351,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7418,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27074772,
        "Time": "2022-02-22T20:16:21",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31001,
        "Lon": 86.13241,
        "Speed": 32.2,
        "Height": 182,
        "Mileage": 6742694,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 65,
        "EngineRPM": 1297.0,
        "OnboardVoltage": 27378,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7418,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27076794,
        "Time": "2022-02-22T20:31:03",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3138351,
        "Lon": 86.1422348,
        "Speed": 14.4,
        "Height": 228,
        "Mileage": 6745494,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 62,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27345,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 355,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7418,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27079025,
        "Time": "2022-02-22T20:47:55",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30602,
        "Lon": 86.1348648,
        "Speed": 18.7,
        "Height": 140,
        "Mileage": 6751210,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 68,
        "EngineRPM": 1181.375,
        "OnboardVoltage": 27150,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7418,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27081463,
        "Time": "2022-02-22T21:03:29",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3115768,
        "Lon": 86.15329,
        "Speed": 12.7,
        "Height": 299,
        "Mileage": 6754332,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 63,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27169,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 354,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7419,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27083021,
        "Time": "2022-02-22T21:16:47",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3064537,
        "Lon": 86.1355057,
        "Speed": 17.2,
        "Height": 141,
        "Mileage": 6759278,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 69,
        "EngineRPM": 1292.125,
        "OnboardVoltage": 27381,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 6,
        "FuelConsumption": 57,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7419,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27086135,
        "Time": "2022-02-22T21:39:43",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30997,
        "Lon": 86.15478,
        "Speed": 8.3,
        "Height": 316,
        "Mileage": 6762535,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 73,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27337,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7419,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27088260,
        "Time": "2022-02-22T21:56:44",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3136978,
        "Lon": 86.14104,
        "Speed": 33.1,
        "Height": 233,
        "Mileage": 6766653,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1296.0,
        "OnboardVoltage": 27338,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7420,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27092346,
        "Time": "2022-02-22T22:27:02",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30595,
        "Lon": 86.1349945,
        "Speed": 12.2,
        "Height": 139,
        "Mileage": 6768855,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 80,
        "EngineRPM": 1255.625,
        "OnboardVoltage": 27417,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 76,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7420,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27094765,
        "Time": "2022-02-22T22:47:13",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31408,
        "Lon": 86.14251,
        "Speed": 34.6,
        "Height": 242,
        "Mileage": 6774492,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 81,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27364,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7420,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27096400,
        "Time": "2022-02-22T22:59:02",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3061,
        "Lon": 86.1348648,
        "Speed": 12.2,
        "Height": 142,
        "Mileage": 6776972,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 83,
        "EngineRPM": 879.25,
        "OnboardVoltage": 27175,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7421,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27098724,
        "Time": "2022-02-22T23:17:22",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3130875,
        "Lon": 86.15231,
        "Speed": 32.7,
        "Height": 283,
        "Mileage": 6781931,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 84,
        "EngineRPM": 1297.375,
        "OnboardVoltage": 27362,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7421,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27100615,
        "Time": "2022-02-22T23:31:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30692,
        "Lon": 86.13527,
        "Speed": 18.8,
        "Height": 145,
        "Mileage": 6784934,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 85,
        "EngineRPM": 921.25,
        "OnboardVoltage": 27450,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7421,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27103051,
        "Time": "2022-02-22T23:49:31",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3105431,
        "Lon": 86.1539459,
        "Speed": 35.0,
        "Height": 309,
        "Mileage": 6789686,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 87,
        "EngineRPM": 1175.0,
        "OnboardVoltage": 27373,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7421,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27104533,
        "Time": "2022-02-23T00:02:12",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.306263,
        "Lon": 86.1356354,
        "Speed": 14.0,
        "Height": 136,
        "Mileage": 6793056,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 87,
        "EngineRPM": 1260.375,
        "OnboardVoltage": 27210,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7422,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27107002,
        "Time": "2022-02-23T00:21:05",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3092728,
        "Lon": 86.17093,
        "Speed": 5.7,
        "Height": 433,
        "Mileage": 6796977,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 87,
        "EngineRPM": 1073.75,
        "OnboardVoltage": 27248,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 305,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7422,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27113291,
        "Time": "2022-02-23T01:21:24",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31286,
        "Lon": 86.1468353,
        "Speed": 5.1,
        "Height": 262,
        "Mileage": 6799301,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 1125.375,
        "OnboardVoltage": 27669,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7423,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27114399,
        "Time": "2022-02-23T01:31:09",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3058968,
        "Lon": 86.1352,
        "Speed": 8.7,
        "Height": 137,
        "Mileage": 6802013,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 84,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27611,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7423,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27117162,
        "Time": "2022-02-23T01:48:19",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3091164,
        "Lon": 86.17305,
        "Speed": 10.7,
        "Height": 423,
        "Mileage": 6805931,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 87,
        "EngineRPM": 1134.25,
        "OnboardVoltage": 27527,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 20,
        "FuelConsumption": 195,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7423,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118443,
        "Time": "2022-02-23T01:59:52",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3001747,
        "Lon": 86.14516,
        "Speed": 26.1,
        "Height": 27,
        "Mileage": 6811205,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 88,
        "EngineRPM": 1299.5,
        "OnboardVoltage": 27534,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7424,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27122166,
        "Time": "2022-02-23T02:27:46",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30365,
        "Lon": 86.1362152,
        "Speed": 13.1,
        "Height": 105,
        "Mileage": 6813657,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27287,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7424,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27125265,
        "Time": "2022-02-23T02:49:17",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.28486,
        "Lon": 86.17412,
        "Speed": 17.4,
        "Height": 257,
        "Mileage": 6820118,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 86,
        "EngineRPM": 1301.125,
        "OnboardVoltage": 27282,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7424,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27130886,
        "Time": "2022-02-23T03:29:51",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.28355,
        "Lon": 86.17664,
        "Speed": 10.0,
        "Height": 278,
        "Mileage": 6823925,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 85,
        "EngineRPM": 794.125,
        "OnboardVoltage": 27443,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7425,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27132954,
        "Time": "2022-02-23T03:43:57",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31033,
        "Lon": 86.1326447,
        "Speed": 19.2,
        "Height": 187,
        "Mileage": 6830078,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 86,
        "EngineRPM": 1300.375,
        "OnboardVoltage": 27264,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7425,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27135582,
        "Time": "2022-02-23T04:02:04",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3138161,
        "Lon": 86.14166,
        "Speed": 14.4,
        "Height": 239,
        "Mileage": 6832882,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 87,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27477,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 357,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7426,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27138527,
        "Time": "2022-02-23T04:20:11",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3100471,
        "Lon": 86.15548,
        "Speed": 30.1,
        "Height": 324,
        "Mileage": 6836979,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 88,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27509,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7426,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27140836,
        "Time": "2022-02-23T04:34:20",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3079147,
        "Lon": 86.136,
        "Speed": 18.1,
        "Height": 153,
        "Mileage": 6840135,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 87,
        "EngineRPM": 1162.25,
        "OnboardVoltage": 27609,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7426,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27147096,
        "Time": "2022-02-23T05:28:15",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3086166,
        "Lon": 86.1602554,
        "Speed": 6.1,
        "Height": 356,
        "Mileage": 6843313,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 86,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27300,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 349,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7427,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27148513,
        "Time": "2022-02-23T05:42:32",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3059578,
        "Lon": 86.13479,
        "Speed": 23.3,
        "Height": 136,
        "Mileage": 6848311,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 88,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27302,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7427,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27150978,
        "Time": "2022-02-23T06:01:25",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3133049,
        "Lon": 86.1512451,
        "Speed": 11.1,
        "Height": 280,
        "Mileage": 6851218,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 86,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27285,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 357,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7428,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27153252,
        "Time": "2022-02-23T06:16:58",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31322,
        "Lon": 86.1519852,
        "Speed": 32.5,
        "Height": 282,
        "Mileage": 6855017,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 88,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27453,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7428,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27170175,
        "Time": "2022-02-23T08:21:14",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31273,
        "Lon": 86.14591,
        "Speed": 0.0,
        "Height": 267,
        "Mileage": 6855625,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 75,
        "EngineRPM": 1125.125,
        "OnboardVoltage": 27875,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7360,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27182649,
        "Time": "2022-02-23T09:58:16",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30331,
        "Lon": 86.14383,
        "Speed": 33.3,
        "Height": 64,
        "Mileage": 6858334,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 74,
        "EngineRPM": 1294.375,
        "OnboardVoltage": 27295,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7361,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27185923,
        "Time": "2022-02-23T10:25:16",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3036041,
        "Lon": 86.1438,
        "Speed": 11.2,
        "Height": 67,
        "Mileage": 6860696,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27216,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 353,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7361,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27187971,
        "Time": "2022-02-23T10:41:50",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3044357,
        "Lon": 86.14352,
        "Speed": 32.7,
        "Height": 81,
        "Mileage": 6865214,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 84,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27277,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7361,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27190482,
        "Time": "2022-02-23T10:59:39",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30452,
        "Lon": 86.1437454,
        "Speed": 16.2,
        "Height": 74,
        "Mileage": 6867738,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 82,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27232,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 82,
        "FuelConsumption": 344,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7362,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27192459,
        "Time": "2022-02-23T11:14:35",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3036423,
        "Lon": 86.14368,
        "Speed": 33.8,
        "Height": 69,
        "Mileage": 6872249,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 87,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27243,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7362,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27195303,
        "Time": "2022-02-23T11:35:41",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30465,
        "Lon": 86.14355,
        "Speed": 16.6,
        "Height": 79,
        "Mileage": 6874696,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 85,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27263,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 347,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7362,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27198074,
        "Time": "2022-02-23T11:58:49",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.28691,
        "Lon": 86.17624,
        "Speed": 25.5,
        "Height": 274,
        "Mileage": 6881292,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 88,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27348,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7363,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27198958,
        "Time": "2022-02-23T12:06:52",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.28313,
        "Lon": 86.1779,
        "Speed": 15.7,
        "Height": 273,
        "Mileage": 6882631,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 88,
        "EngineRPM": 1319.875,
        "OnboardVoltage": 27396,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 17,
        "FuelConsumption": 130,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7363,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27200614,
        "Time": "2022-02-23T12:22:12",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30404,
        "Lon": 86.14065,
        "Speed": 35.5,
        "Height": 95,
        "Mileage": 6889753,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 87,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27341,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7363,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27204682,
        "Time": "2022-02-23T13:06:24",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3006172,
        "Lon": 86.1405945,
        "Speed": 16.8,
        "Height": 10,
        "Mileage": 6891505,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 87,
        "EngineRPM": 748.625,
        "OnboardVoltage": 27191,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7364,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27206505,
        "Time": "2022-02-23T13:21:49",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3099747,
        "Lon": 86.15652,
        "Speed": 14.2,
        "Height": 323,
        "Mileage": 6895825,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 89,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27147,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 359,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7364,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27208785,
        "Time": "2022-02-23T13:38:35",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2833023,
        "Lon": 86.17781,
        "Speed": 32.9,
        "Height": 272,
        "Mileage": 6901840,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 90,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27349,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 24,
        "FuelConsumption": 159,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7364,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27210346,
        "Time": "2022-02-23T13:50:11",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31334,
        "Lon": 86.14559,
        "Speed": 9.4,
        "Height": 261,
        "Mileage": 6906938,
        "EngineOilPressure": 264,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 90,
        "EngineRPM": 784.0,
        "OnboardVoltage": 27163,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7365,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27218309,
        "Time": "2022-02-23T14:51:24",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30379,
        "Lon": 86.13572,
        "Speed": 34.6,
        "Height": 122,
        "Mileage": 6909224,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 60,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27293,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7366,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27220565,
        "Time": "2022-02-23T15:10:10",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.29444,
        "Lon": 86.14835,
        "Speed": 12.9,
        "Height": -28,
        "Mileage": 6912610,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 57,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27196,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 352,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7366,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27223634,
        "Time": "2022-02-23T15:32:29",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30997,
        "Lon": 86.15675,
        "Speed": 9.6,
        "Height": 327,
        "Mileage": 6917380,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 58,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27402,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7366,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27225602,
        "Time": "2022-02-23T15:46:24",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31402,
        "Lon": 86.14189,
        "Speed": 39.4,
        "Height": 241,
        "Mileage": 6921372,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 63,
        "EngineRPM": 1300.375,
        "OnboardVoltage": 27376,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7366,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27226985,
        "Time": "2022-02-23T15:55:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3006935,
        "Lon": 86.14099,
        "Speed": 21.8,
        "Height": 17,
        "Mileage": 6925053,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 62,
        "EngineRPM": 913.375,
        "OnboardVoltage": 27383,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 73,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27229721,
        "Time": "2022-02-23T16:16:07",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.300457,
        "Lon": 86.1461,
        "Speed": 11.8,
        "Height": 29,
        "Mileage": 6926444,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 68,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27179,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 369,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27232518,
        "Time": "2022-02-23T16:38:19",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3070145,
        "Lon": 86.17035,
        "Speed": 12.2,
        "Height": 407,
        "Mileage": 6931311,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 68,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27398,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7367,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27234192,
        "Time": "2022-02-23T16:51:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3033257,
        "Lon": 86.14379,
        "Speed": 35.7,
        "Height": 59,
        "Mileage": 6936478,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 73,
        "EngineRPM": 1300.0,
        "OnboardVoltage": 27430,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27238224,
        "Time": "2022-02-23T17:27:01",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.29959,
        "Lon": 86.13927,
        "Speed": 23.1,
        "Height": 8,
        "Mileage": 6938032,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 77,
        "EngineRPM": 1759.625,
        "OnboardVoltage": 27217,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 96,
        "FuelConsumption": 370,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27240502,
        "Time": "2022-02-23T17:45:14",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3102,
        "Lon": 86.15433,
        "Speed": 10.1,
        "Height": 309,
        "Mileage": 6942353,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 77,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27395,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7368,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27242514,
        "Time": "2022-02-23T18:00:26",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3141136,
        "Lon": 86.14275,
        "Speed": 35.3,
        "Height": 240,
        "Mileage": 6946358,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 81,
        "EngineRPM": 1240.0,
        "OnboardVoltage": 27336,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 39,
        "FuelConsumption": 95,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27243638,
        "Time": "2022-02-23T18:09:20",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.295887,
        "Lon": 86.14594,
        "Speed": 4.2,
        "Height": -51,
        "Mileage": 6950646,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 80,
        "EngineRPM": 1340.0,
        "OnboardVoltage": 27138,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27246036,
        "Time": "2022-02-23T18:29:09",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.310524,
        "Lon": 86.13577,
        "Speed": 13.5,
        "Height": 193,
        "Mileage": 6954327,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 80,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27395,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7369,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27248542,
        "Time": "2022-02-23T18:48:53",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3099632,
        "Lon": 86.15768,
        "Speed": 35.0,
        "Height": 338,
        "Mileage": 6958750,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27383,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27250078,
        "Time": "2022-02-23T18:59:05",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.29989,
        "Lon": 86.13775,
        "Speed": 5.3,
        "Height": 6,
        "Mileage": 6963413,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 771.125,
        "OnboardVoltage": 27557,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27252564,
        "Time": "2022-02-23T19:17:23",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.313797,
        "Lon": 86.14207,
        "Speed": 13.7,
        "Height": 233,
        "Mileage": 6967022,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 85,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27175,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27254905,
        "Time": "2022-02-23T19:34:51",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31068,
        "Lon": 86.15382,
        "Speed": 33.3,
        "Height": 308,
        "Mileage": 6971186,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 87,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27347,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7370,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27256922,
        "Time": "2022-02-23T19:50:03",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2962151,
        "Lon": 86.14594,
        "Speed": 4.8,
        "Height": -39,
        "Mileage": 6976352,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 86,
        "EngineRPM": 717.875,
        "OnboardVoltage": 27200,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7371,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27259923,
        "Time": "2022-02-23T20:11:47",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.311367,
        "Lon": 86.138,
        "Speed": 13.3,
        "Height": 206,
        "Mileage": 6980210,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 86,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27343,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 364,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7371,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27262405,
        "Time": "2022-02-23T20:29:06",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3069839,
        "Lon": 86.16965,
        "Speed": 29.2,
        "Height": 412,
        "Mileage": 6983649,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 87,
        "EngineRPM": 1270.625,
        "OnboardVoltage": 27437,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 35,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7371,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27263836,
        "Time": "2022-02-23T20:39:35",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2994881,
        "Lon": 86.14207,
        "Speed": 21.8,
        "Height": 1,
        "Mileage": 6989068,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 87,
        "EngineRPM": 721.5,
        "OnboardVoltage": 27398,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7371,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27267098,
        "Time": "2022-02-23T21:06:01",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3050766,
        "Lon": 86.1352,
        "Speed": 13.1,
        "Height": 129,
        "Mileage": 6991284,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 87,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27383,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27269873,
        "Time": "2022-02-23T21:26:48",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.308567,
        "Lon": 86.17187,
        "Speed": 17.4,
        "Height": 427,
        "Mileage": 6995472,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 87,
        "EngineRPM": 1256.75,
        "OnboardVoltage": 27403,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 19,
        "FuelConsumption": 77,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27271293,
        "Time": "2022-02-23T21:37:09",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30083,
        "Lon": 86.14184,
        "Speed": 20.3,
        "Height": 11,
        "Mileage": 7000982,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 88,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27317,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7372,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27274553,
        "Time": "2022-02-23T21:59:56",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30624,
        "Lon": 86.1347656,
        "Speed": 12.2,
        "Height": 138,
        "Mileage": 7003480,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 88,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27398,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27277212,
        "Time": "2022-02-23T22:19:07",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30917,
        "Lon": 86.17221,
        "Speed": 12.9,
        "Height": 433,
        "Mileage": 7007451,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 88,
        "EngineRPM": 1084.0,
        "OnboardVoltage": 27367,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 37,
        "FuelConsumption": 69,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27278878,
        "Time": "2022-02-23T22:30:42",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.29438,
        "Lon": 86.1456451,
        "Speed": 26.1,
        "Height": -36,
        "Mileage": 7013664,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 90,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27161,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7373,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27282540,
        "Time": "2022-02-23T22:55:14",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.29761,
        "Lon": 86.14775,
        "Speed": 13.3,
        "Height": 22,
        "Mileage": 7015454,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 86,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27404,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 83,
        "FuelConsumption": 350,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7374,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27286054,
        "Time": "2022-02-23T23:18:39",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3067932,
        "Lon": 86.1656,
        "Speed": 19.2,
        "Height": 384,
        "Mileage": 7020383,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 89,
        "EngineRPM": 1807.5,
        "OnboardVoltage": 27430,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7374,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27288022,
        "Time": "2022-02-23T23:33:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30569,
        "Lon": 86.13474,
        "Speed": 31.6,
        "Height": 125,
        "Mileage": 7025069,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 89,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27129,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7374,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27290917,
        "Time": "2022-02-23T23:52:21",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30137,
        "Lon": 86.14159,
        "Speed": 23.3,
        "Height": 10,
        "Mileage": 7027752,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 87,
        "EngineRPM": 1522.375,
        "OnboardVoltage": 27211,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 27,
        "FuelConsumption": 187,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7375,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27293416,
        "Time": "2022-02-24T00:10:08",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30993,
        "Lon": 86.15499,
        "Speed": 9.0,
        "Height": 319,
        "Mileage": 7031893,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 88,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27183,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7375,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27295362,
        "Time": "2022-02-24T00:24:21",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.31285,
        "Lon": 86.147,
        "Speed": 8.8,
        "Height": 258,
        "Mileage": 7035750,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 90,
        "EngineRPM": 1108.125,
        "OnboardVoltage": 27428,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7375,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27299047,
        "Time": "2022-02-24T01:05:17",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30037,
        "Lon": 86.13853,
        "Speed": 8.5,
        "Height": 18,
        "Mileage": 7039480,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 86,
        "EngineRPM": 676.125,
        "OnboardVoltage": 27611,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7376,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27302069,
        "Time": "2022-02-24T01:29:19",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30092,
        "Lon": 86.14555,
        "Speed": 11.1,
        "Height": 50,
        "Mileage": 7040826,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 87,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27454,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 82,
        "FuelConsumption": 338,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7376,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27305656,
        "Time": "2022-02-24T01:53:12",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3087,
        "Lon": 86.17337,
        "Speed": 4.2,
        "Height": 424,
        "Mileage": 7045943,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 88,
        "EngineRPM": 1130.125,
        "OnboardVoltage": 27484,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 47,
        "FuelConsumption": 111,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7377,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27311168,
        "Time": "2022-02-24T02:29:50",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3136444,
        "Lon": 86.14681,
        "Speed": 6.1,
        "Height": 264,
        "Mileage": 7048543,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 71,
        "EngineRPM": 1191.75,
        "OnboardVoltage": 27409,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 20,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7377,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27314416,
        "Time": "2022-02-24T02:53:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.29606,
        "Lon": 86.14603,
        "Speed": 0.0,
        "Height": -51,
        "Mileage": 7053059,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 64,
        "EngineRPM": 688.375,
        "OnboardVoltage": 27851,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27317799,
        "Time": "2022-02-24T03:17:17",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.3095932,
        "Lon": 86.13253,
        "Speed": 9.6,
        "Height": 177,
        "Mileage": 7056467,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 57,
        "EngineRPM": 1809.0,
        "OnboardVoltage": 27453,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 356,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27320595,
        "Time": "2022-02-24T03:35:54",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.30898,
        "Lon": 86.1733856,
        "Speed": 13.7,
        "Height": 432,
        "Mileage": 7060056,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 58,
        "EngineRPM": 1823.0,
        "OnboardVoltage": 27311,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 71,
        "FuelConsumption": 359,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7378,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27322778,
        "Time": "2022-02-24T03:49:00",
        "TruckId": 609,
        "Imei": "868328058791951",
        "Lat": 54.2999649,
        "Lon": 86.14568,
        "Speed": 20.7,
        "Height": 37,
        "Mileage": 7065341,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 64,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27788,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 7379,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27004244,
        "Time": "2022-02-22T10:54:18",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2791824,
        "Lon": 86.19094,
        "Speed": 0.0,
        "Height": 278,
        "Mileage": 40179600,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 101,
        "EngineRPM": 1130.375,
        "OnboardVoltage": 27337,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1443,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27020906,
        "Time": "2022-02-22T13:13:04",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2773056,
        "Lon": 86.18429,
        "Speed": 27.2,
        "Height": 258,
        "Mileage": 40180180,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 98,
        "EngineRPM": 1407.125,
        "OnboardVoltage": 27091,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 71,
        "LoadPercentage": 71,
        "FuelConsumption": 242,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1445,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.600002
    },
    {
        "Id": 27023798,
        "Time": "2022-02-22T13:41:11",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2955856,
        "Lon": 86.144,
        "Speed": 0.0,
        "Height": -33,
        "Mileage": 40187784,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 792.375,
        "OnboardVoltage": 27153,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1446,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27026202,
        "Time": "2022-02-22T13:59:21",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2999535,
        "Lon": 86.14636,
        "Speed": 5.1,
        "Height": 28,
        "Mileage": 40189512,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 1424.75,
        "OnboardVoltage": 27075,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 60,
        "LoadPercentage": 69,
        "FuelConsumption": 217,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1446,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27029723,
        "Time": "2022-02-22T14:24:55",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3002434,
        "Lon": 86.146225,
        "Speed": 10.9,
        "Height": 37,
        "Mileage": 40191176,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 100,
        "EngineRPM": 1782.375,
        "OnboardVoltage": 27071,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1446,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27032711,
        "Time": "2022-02-22T14:47:54",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30906,
        "Lon": 86.17281,
        "Speed": 14.4,
        "Height": 429,
        "Mileage": 40196440,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 106,
        "EngineRPM": 849.5,
        "OnboardVoltage": 27017,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1447,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27034346,
        "Time": "2022-02-22T14:59:23",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2945023,
        "Lon": 86.14446,
        "Speed": 24.2,
        "Height": -55,
        "Mileage": 40202616,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 105,
        "EngineRPM": 1295.0,
        "OnboardVoltage": 27106,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1447,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.8
    },
    {
        "Id": 27038698,
        "Time": "2022-02-22T15:30:49",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30403,
        "Lon": 86.13576,
        "Speed": 10.7,
        "Height": 119,
        "Mileage": 40205520,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1780.75,
        "OnboardVoltage": 26833,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1448,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27041047,
        "Time": "2022-02-22T15:50:58",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3072,
        "Lon": 86.163,
        "Speed": 34.8,
        "Height": 378,
        "Mileage": 40210484,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 108,
        "EngineRPM": 1296.75,
        "OnboardVoltage": 27096,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1448,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.4
    },
    {
        "Id": 27044546,
        "Time": "2022-02-22T16:17:58",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30466,
        "Lon": 86.14329,
        "Speed": 36.4,
        "Height": 83,
        "Mileage": 40214596,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 65,
        "EngineRPM": 1302.5,
        "OnboardVoltage": 27121,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1448,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.8
    },
    {
        "Id": 27049401,
        "Time": "2022-02-22T16:56:19",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29373,
        "Lon": 86.14952,
        "Speed": 9.8,
        "Height": -27,
        "Mileage": 40217392,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 65,
        "EngineRPM": 1799.25,
        "OnboardVoltage": 27116,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1449,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.6
    },
    {
        "Id": 27052228,
        "Time": "2022-02-22T17:19:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3075447,
        "Lon": 86.17098,
        "Speed": 11.1,
        "Height": 429,
        "Mileage": 40223136,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 61,
        "EngineRPM": 1786.875,
        "OnboardVoltage": 26935,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1449,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27053692,
        "Time": "2022-02-22T17:32:20",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2937164,
        "Lon": 86.14977,
        "Speed": 18.5,
        "Height": -23,
        "Mileage": 40229672,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 65,
        "EngineRPM": 1298.25,
        "OnboardVoltage": 27069,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1450,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.0
    },
    {
        "Id": 27061956,
        "Time": "2022-02-22T18:46:10",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2964859,
        "Lon": 86.14451,
        "Speed": 9.6,
        "Height": -58,
        "Mileage": 40230652,
        "EngineOilPressure": 292,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 68,
        "EngineRPM": 944.625,
        "OnboardVoltage": 27215,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 17,
        "LoadPercentage": 27,
        "FuelConsumption": 66,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1451,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 97.200005
    },
    {
        "Id": 27064768,
        "Time": "2022-02-22T19:04:47",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3099747,
        "Lon": 86.1547546,
        "Speed": 11.2,
        "Height": 317,
        "Mileage": 40235476,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 79,
        "EngineRPM": 1779.625,
        "OnboardVoltage": 27050,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1451,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27066669,
        "Time": "2022-02-22T19:19:17",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3041573,
        "Lon": 86.13539,
        "Speed": 39.4,
        "Height": 129,
        "Mileage": 40241156,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 82,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 26901,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1451,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27068329,
        "Time": "2022-02-22T19:31:57",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29359,
        "Lon": 86.1497345,
        "Speed": 10.0,
        "Height": -21,
        "Mileage": 40244464,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 80,
        "EngineRPM": 1815.625,
        "OnboardVoltage": 26897,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1452,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.8
    },
    {
        "Id": 27071519,
        "Time": "2022-02-22T19:54:34",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3068848,
        "Lon": 86.1695557,
        "Speed": 16.2,
        "Height": 404,
        "Mileage": 40250056,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 89,
        "EngineRPM": 1776.5,
        "OnboardVoltage": 26797,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1452,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27073187,
        "Time": "2022-02-22T20:06:48",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30231,
        "Lon": 86.14442,
        "Speed": 37.0,
        "Height": 56,
        "Mileage": 40255400,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 87,
        "EngineRPM": 1306.625,
        "OnboardVoltage": 26989,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1452,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27075793,
        "Time": "2022-02-22T20:24:07",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.298912,
        "Lon": 86.14731,
        "Speed": 15.5,
        "Height": 24,
        "Mileage": 40258732,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 87,
        "EngineRPM": 1814.5,
        "OnboardVoltage": 26958,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1452,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27078941,
        "Time": "2022-02-22T20:47:22",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3094673,
        "Lon": 86.17106,
        "Speed": 13.8,
        "Height": 433,
        "Mileage": 40264416,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 95,
        "EngineRPM": 1502.0,
        "OnboardVoltage": 27027,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 72,
        "LoadPercentage": 65,
        "FuelConsumption": 236,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1453,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27080698,
        "Time": "2022-02-22T20:59:49",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2945328,
        "Lon": 86.14669,
        "Speed": 34.8,
        "Height": -33,
        "Mileage": 40270684,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 95,
        "EngineRPM": 1292.75,
        "OnboardVoltage": 27151,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 40,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1453,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27085144,
        "Time": "2022-02-22T21:33:19",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29734,
        "Lon": 86.14784,
        "Speed": 18.8,
        "Height": 7,
        "Mileage": 40272596,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 97,
        "EngineRPM": 1790.625,
        "OnboardVoltage": 26946,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1454,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27088200,
        "Time": "2022-02-22T21:56:06",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30952,
        "Lon": 86.17107,
        "Speed": 12.5,
        "Height": 439,
        "Mileage": 40278132,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 102,
        "EngineRPM": 1637.5,
        "OnboardVoltage": 26978,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 82,
        "LoadPercentage": 89,
        "FuelConsumption": 342,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1454,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27090038,
        "Time": "2022-02-22T22:07:56",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2936325,
        "Lon": 86.1496353,
        "Speed": 26.1,
        "Height": -19,
        "Mileage": 40284432,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 101,
        "EngineRPM": 1297.125,
        "OnboardVoltage": 27125,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1454,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27092419,
        "Time": "2022-02-22T22:27:37",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3049164,
        "Lon": 86.1434555,
        "Speed": 15.3,
        "Height": 92,
        "Mileage": 40287384,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 100,
        "EngineRPM": 1784.875,
        "OnboardVoltage": 26993,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1455,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27094030,
        "Time": "2022-02-22T22:41:54",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2938,
        "Lon": 86.14923,
        "Speed": 29.2,
        "Height": -30,
        "Mileage": 40292744,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 105,
        "EngineRPM": 1296.25,
        "OnboardVoltage": 26919,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1455,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27097468,
        "Time": "2022-02-22T23:07:16",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3031921,
        "Lon": 86.1441345,
        "Speed": 14.4,
        "Height": 70,
        "Mileage": 40295540,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 103,
        "EngineRPM": 1773.625,
        "OnboardVoltage": 26849,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1455,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27100038,
        "Time": "2022-02-22T23:27:25",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30971,
        "Lon": 86.17146,
        "Speed": 4.8,
        "Height": 439,
        "Mileage": 40300468,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 106,
        "EngineRPM": 1340.75,
        "OnboardVoltage": 27006,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 53,
        "FuelConsumption": 199,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1456,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27101612,
        "Time": "2022-02-22T23:38:26",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2942963,
        "Lon": 86.14521,
        "Speed": 39.6,
        "Height": -48,
        "Mileage": 40307080,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 106,
        "EngineRPM": 1296.0,
        "OnboardVoltage": 27132,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1456,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27105919,
        "Time": "2022-02-23T00:13:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2984467,
        "Lon": 86.14751,
        "Speed": 7.0,
        "Height": 20,
        "Mileage": 40309100,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 105,
        "EngineRPM": 1532.875,
        "OnboardVoltage": 27032,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 70,
        "LoadPercentage": 69,
        "FuelConsumption": 263,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1456,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27109784,
        "Time": "2022-02-23T00:52:02",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3066,
        "Lon": 86.16434,
        "Speed": 10.3,
        "Height": 388,
        "Mileage": 40314188,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 106,
        "EngineRPM": 1770.375,
        "OnboardVoltage": 26929,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1457,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27111406,
        "Time": "2022-02-23T01:04:21",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30457,
        "Lon": 86.14262,
        "Speed": 33.1,
        "Height": 84,
        "Mileage": 40319636,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 107,
        "EngineRPM": 1306.0,
        "OnboardVoltage": 27139,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1457,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27114606,
        "Time": "2022-02-23T01:32:59",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2942924,
        "Lon": 86.1454849,
        "Speed": 12.5,
        "Height": -52,
        "Mileage": 40322028,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 106,
        "EngineRPM": 1510.375,
        "OnboardVoltage": 27204,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 258,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1458,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27117775,
        "Time": "2022-02-23T01:55:13",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3092041,
        "Lon": 86.1590042,
        "Speed": 9.6,
        "Height": 344,
        "Mileage": 40327440,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 108,
        "EngineRPM": 1806.125,
        "OnboardVoltage": 26997,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 406,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1458,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.0
    },
    {
        "Id": 27119811,
        "Time": "2022-02-23T02:10:12",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3035,
        "Lon": 86.13643,
        "Speed": 40.7,
        "Height": 113,
        "Mileage": 40332984,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 107,
        "EngineRPM": 1306.0,
        "OnboardVoltage": 27275,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1458,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27122840,
        "Time": "2022-02-23T02:33:04",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29436,
        "Lon": 86.1448059,
        "Speed": 23.3,
        "Height": -54,
        "Mileage": 40335760,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 106,
        "EngineRPM": 1310.625,
        "OnboardVoltage": 27228,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 70,
        "FuelConsumption": 195,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1459,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27126145,
        "Time": "2022-02-23T02:56:14",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3067741,
        "Lon": 86.16331,
        "Speed": 16.4,
        "Height": 378,
        "Mileage": 40341444,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 108,
        "EngineRPM": 1754.5,
        "OnboardVoltage": 27100,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1459,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27127985,
        "Time": "2022-02-23T03:08:31",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3061752,
        "Lon": 86.13557,
        "Speed": 24.6,
        "Height": 137,
        "Mileage": 40346332,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 107,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27269,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 9,
        "FuelConsumption": 65,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1459,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 37.2
    },
    {
        "Id": 27130288,
        "Time": "2022-02-23T03:24:22",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3104324,
        "Lon": 86.1537552,
        "Speed": 12.4,
        "Height": 313,
        "Mileage": 40349720,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 108,
        "EngineRPM": 1785.25,
        "OnboardVoltage": 26987,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1460,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27132365,
        "Time": "2022-02-23T03:39:53",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3108177,
        "Lon": 86.1362,
        "Speed": 41.1,
        "Height": 206,
        "Mileage": 40354924,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 108,
        "EngineRPM": 1298.25,
        "OnboardVoltage": 27167,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 35,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1460,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.4
    },
    {
        "Id": 27134232,
        "Time": "2022-02-23T03:53:08",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3104477,
        "Lon": 86.13461,
        "Speed": 13.8,
        "Height": 188,
        "Mileage": 40357412,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 105,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27084,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1460,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.8
    },
    {
        "Id": 27137310,
        "Time": "2022-02-23T04:12:13",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.31012,
        "Lon": 86.15706,
        "Speed": 37.2,
        "Height": 319,
        "Mileage": 40362208,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 108,
        "EngineRPM": 1296.375,
        "OnboardVoltage": 27196,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1460,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.800001
    },
    {
        "Id": 27139028,
        "Time": "2022-02-23T04:23:29",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3005371,
        "Lon": 86.1386642,
        "Speed": 9.2,
        "Height": 0,
        "Mileage": 40366872,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 106,
        "EngineRPM": 870.5,
        "OnboardVoltage": 27225,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 2,
        "LoadPercentage": 13,
        "FuelConsumption": 57,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1460,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.2
    },
    {
        "Id": 27142032,
        "Time": "2022-02-23T04:43:38",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3099823,
        "Lon": 86.13255,
        "Speed": 13.7,
        "Height": 181,
        "Mileage": 40369624,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 106,
        "EngineRPM": 1780.25,
        "OnboardVoltage": 27024,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1461,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 25.2
    },
    {
        "Id": 27144468,
        "Time": "2022-02-23T05:01:31",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3085442,
        "Lon": 86.17082,
        "Speed": 7.2,
        "Height": 438,
        "Mileage": 40373468,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 108,
        "EngineRPM": 785.25,
        "OnboardVoltage": 27175,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 6,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1461,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 19.6
    },
    {
        "Id": 27149377,
        "Time": "2022-02-23T05:49:13",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2774048,
        "Lon": 86.18786,
        "Speed": 15.3,
        "Height": 255,
        "Mileage": 40377772,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 78,
        "EngineRPM": 881.5,
        "OnboardVoltage": 27142,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 118,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1462,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27153873,
        "Time": "2022-02-23T06:21:55",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3120537,
        "Lon": 86.15337,
        "Speed": 39.6,
        "Height": 300,
        "Mileage": 40383396,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 58,
        "EngineRPM": 1300.25,
        "OnboardVoltage": 27200,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1462,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27156788,
        "Time": "2022-02-23T06:44:24",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29388,
        "Lon": 86.14919,
        "Speed": 21.4,
        "Height": -29,
        "Mileage": 40388196,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 60,
        "EngineRPM": 1290.375,
        "OnboardVoltage": 27342,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1463,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27159820,
        "Time": "2022-02-23T07:06:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2938576,
        "Lon": 86.15002,
        "Speed": 12.7,
        "Height": -9,
        "Mileage": 40389804,
        "EngineOilPressure": 472,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 62,
        "EngineRPM": 1804.75,
        "OnboardVoltage": 27152,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1463,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.0
    },
    {
        "Id": 27163568,
        "Time": "2022-02-23T07:31:28",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3086,
        "Lon": 86.17291,
        "Speed": 13.8,
        "Height": 441,
        "Mileage": 40395844,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 62,
        "EngineRPM": 1795.5,
        "OnboardVoltage": 27068,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1464,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27165179,
        "Time": "2022-02-23T07:43:02",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29988,
        "Lon": 86.14644,
        "Speed": 31.6,
        "Height": 44,
        "Mileage": 40401268,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 68,
        "EngineRPM": 1304.75,
        "OnboardVoltage": 27228,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1464,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27169519,
        "Time": "2022-02-23T08:17:05",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2945328,
        "Lon": 86.1478958,
        "Speed": 11.6,
        "Height": -20,
        "Mileage": 40403288,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 73,
        "EngineRPM": 1798.875,
        "OnboardVoltage": 27223,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1464,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27172463,
        "Time": "2022-02-23T08:40:10",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3076,
        "Lon": 86.16215,
        "Speed": 17.0,
        "Height": 368,
        "Mileage": 40408844,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 85,
        "EngineRPM": 1776.5,
        "OnboardVoltage": 27009,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1465,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27174173,
        "Time": "2022-02-23T08:53:09",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30624,
        "Lon": 86.13459,
        "Speed": 30.7,
        "Height": 142,
        "Mileage": 40413652,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 84,
        "EngineRPM": 1296.0,
        "OnboardVoltage": 27224,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1465,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27176735,
        "Time": "2022-02-23T09:16:18",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29605,
        "Lon": 86.14459,
        "Speed": 8.5,
        "Height": -49,
        "Mileage": 40416576,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 85,
        "EngineRPM": 1337.5,
        "OnboardVoltage": 27299,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 122,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1465,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.6
    },
    {
        "Id": 27179615,
        "Time": "2022-02-23T09:37:54",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3107033,
        "Lon": 86.1534,
        "Speed": 12.9,
        "Height": 301,
        "Mileage": 40421772,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 91,
        "EngineRPM": 1781.125,
        "OnboardVoltage": 26959,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1466,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27181694,
        "Time": "2022-02-23T09:52:49",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3139534,
        "Lon": 86.14163,
        "Speed": 37.4,
        "Height": 232,
        "Mileage": 40426320,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 93,
        "EngineRPM": 1302.25,
        "OnboardVoltage": 27155,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1466,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27183846,
        "Time": "2022-02-23T10:09:25",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30067,
        "Lon": 86.13976,
        "Speed": 15.3,
        "Height": 11,
        "Mileage": 40430360,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 1084.0,
        "OnboardVoltage": 27129,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 33,
        "LoadPercentage": 35,
        "FuelConsumption": 142,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1466,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27186233,
        "Time": "2022-02-23T10:27:26",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3099442,
        "Lon": 86.15791,
        "Speed": 14.0,
        "Height": 334,
        "Mileage": 40434784,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 97,
        "EngineRPM": 1793.625,
        "OnboardVoltage": 27005,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1466,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27187802,
        "Time": "2022-02-23T10:40:42",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3111343,
        "Lon": 86.13731,
        "Speed": 32.9,
        "Height": 212,
        "Mileage": 40439072,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 99,
        "EngineRPM": 1302.5,
        "OnboardVoltage": 27127,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1467,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27191992,
        "Time": "2022-02-23T11:10:36",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3007,
        "Lon": 86.14087,
        "Speed": 7.2,
        "Height": 23,
        "Mileage": 40442148,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 96,
        "EngineRPM": 803.75,
        "OnboardVoltage": 27086,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 8,
        "LoadPercentage": 6,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1467,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27194622,
        "Time": "2022-02-23T11:31:00",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3100166,
        "Lon": 86.15724,
        "Speed": 10.7,
        "Height": 334,
        "Mileage": 40446488,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 1558.25,
        "OnboardVoltage": 27128,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 91,
        "LoadPercentage": 65,
        "FuelConsumption": 267,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1468,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27197277,
        "Time": "2022-02-23T11:51:11",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2846451,
        "Lon": 86.17806,
        "Speed": 5.7,
        "Height": 276,
        "Mileage": 40450548,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 98,
        "EngineRPM": 1228.25,
        "OnboardVoltage": 27176,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 70,
        "LoadPercentage": 62,
        "FuelConsumption": 145,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1468,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27201296,
        "Time": "2022-02-23T12:29:58",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.27762,
        "Lon": 86.18922,
        "Speed": 10.7,
        "Height": 250,
        "Mileage": 40452328,
        "EngineOilPressure": 280,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 99,
        "EngineRPM": 727.75,
        "OnboardVoltage": 27140,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1468,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27202556,
        "Time": "2022-02-23T12:44:21",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29625,
        "Lon": 86.1447754,
        "Speed": 20.9,
        "Height": -58,
        "Mileage": 40460288,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 98,
        "EngineRPM": 1228.375,
        "OnboardVoltage": 27092,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1469,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27204387,
        "Time": "2022-02-23T13:02:45",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3040237,
        "Lon": 86.13979,
        "Speed": 11.6,
        "Height": 93,
        "Mileage": 40462720,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 102,
        "EngineRPM": 1776.125,
        "OnboardVoltage": 26939,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1469,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27206575,
        "Time": "2022-02-23T13:21:36",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30939,
        "Lon": 86.1730957,
        "Speed": 15.0,
        "Height": 431,
        "Mileage": 40467332,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 104,
        "EngineRPM": 1321.5,
        "OnboardVoltage": 27022,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 69,
        "FuelConsumption": 208,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1469,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27207994,
        "Time": "2022-02-23T13:32:47",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.293663,
        "Lon": 86.14958,
        "Speed": 24.6,
        "Height": -34,
        "Mileage": 40473564,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 104,
        "EngineRPM": 1310.125,
        "OnboardVoltage": 27211,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 6,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1470,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27209989,
        "Time": "2022-02-23T13:47:52",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3004,
        "Lon": 86.14604,
        "Speed": 17.0,
        "Height": 31,
        "Mileage": 40475960,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 101,
        "EngineRPM": 1777.75,
        "OnboardVoltage": 26971,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1470,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27212232,
        "Time": "2022-02-23T14:06:37",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30702,
        "Lon": 86.17049,
        "Speed": 12.4,
        "Height": 415,
        "Mileage": 40480608,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 104,
        "EngineRPM": 1768.5,
        "OnboardVoltage": 27030,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1470,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27213760,
        "Time": "2022-02-23T14:16:39",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3005257,
        "Lon": 86.14459,
        "Speed": 38.5,
        "Height": 26,
        "Mileage": 40486312,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 104,
        "EngineRPM": 1294.75,
        "OnboardVoltage": 27144,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 7,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1470,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27215898,
        "Time": "2022-02-23T14:32:01",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30466,
        "Lon": 86.14363,
        "Speed": 16.4,
        "Height": 57,
        "Mileage": 40488368,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 103,
        "EngineRPM": 1796.25,
        "OnboardVoltage": 26909,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1471,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.4
    },
    {
        "Id": 27218395,
        "Time": "2022-02-23T14:52:07",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3093033,
        "Lon": 86.1729355,
        "Speed": 16.6,
        "Height": 437,
        "Mileage": 40493284,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 103,
        "EngineRPM": 837.125,
        "OnboardVoltage": 27017,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1471,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.0
    },
    {
        "Id": 27219773,
        "Time": "2022-02-23T15:02:56",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2937279,
        "Lon": 86.1498947,
        "Speed": 19.8,
        "Height": -10,
        "Mileage": 40499400,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 103,
        "EngineRPM": 1305.75,
        "OnboardVoltage": 27091,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1471,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.8
    },
    {
        "Id": 27221782,
        "Time": "2022-02-23T15:19:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30459,
        "Lon": 86.1438,
        "Speed": 16.1,
        "Height": 80,
        "Mileage": 40502312,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 105,
        "EngineRPM": 1768.5,
        "OnboardVoltage": 27038,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1471,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.4
    },
    {
        "Id": 27224751,
        "Time": "2022-02-23T15:40:38",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3079529,
        "Lon": 86.17127,
        "Speed": 30.0,
        "Height": 430,
        "Mileage": 40507268,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 108,
        "EngineRPM": 1137.0,
        "OnboardVoltage": 27137,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 68,
        "FuelConsumption": 155,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1472,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.4
    },
    {
        "Id": 27226356,
        "Time": "2022-02-23T15:51:51",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2942429,
        "Lon": 86.14528,
        "Speed": 18.1,
        "Height": -43,
        "Mileage": 40513704,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 106,
        "EngineRPM": 1295.75,
        "OnboardVoltage": 27196,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1472,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.8
    },
    {
        "Id": 27229862,
        "Time": "2022-02-23T16:17:17",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3040047,
        "Lon": 86.1438141,
        "Speed": 12.4,
        "Height": 70,
        "Mileage": 40516184,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 105,
        "EngineRPM": 1774.0,
        "OnboardVoltage": 26878,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1472,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 31.6
    },
    {
        "Id": 27232474,
        "Time": "2022-02-23T16:37:59",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30873,
        "Lon": 86.17323,
        "Speed": 11.6,
        "Height": 426,
        "Mileage": 40521204,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 108,
        "EngineRPM": 849.5,
        "OnboardVoltage": 27181,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 64,
        "LoadPercentage": 80,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1473,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 26.800001
    },
    {
        "Id": 27233951,
        "Time": "2022-02-23T16:49:10",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29913,
        "Lon": 86.146965,
        "Speed": 37.4,
        "Height": 21,
        "Mileage": 40526656,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 107,
        "EngineRPM": 1289.5,
        "OnboardVoltage": 27195,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1473,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.4
    },
    {
        "Id": 27236492,
        "Time": "2022-02-23T17:08:30",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29365,
        "Lon": 86.14973,
        "Speed": 10.3,
        "Height": -20,
        "Mileage": 40528904,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 106,
        "EngineRPM": 1774.375,
        "OnboardVoltage": 27091,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1473,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.6
    },
    {
        "Id": 27238689,
        "Time": "2022-02-23T17:30:50",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30666,
        "Lon": 86.16356,
        "Speed": 12.4,
        "Height": 375,
        "Mileage": 40534360,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 108,
        "EngineRPM": 1770.375,
        "OnboardVoltage": 27136,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 392,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 21.2
    },
    {
        "Id": 27241619,
        "Time": "2022-02-23T17:53:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.31305,
        "Lon": 86.14558,
        "Speed": 0.0,
        "Height": 261,
        "Mileage": 40537428,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 107,
        "EngineRPM": 1125.75,
        "OnboardVoltage": 27270,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 20.800001
    },
    {
        "Id": 27244546,
        "Time": "2022-02-23T18:16:06",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.29981,
        "Lon": 86.1416245,
        "Speed": 22.4,
        "Height": 8,
        "Mileage": 40541224,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 62,
        "EngineRPM": 971.125,
        "OnboardVoltage": 27106,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1474,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 98.0
    },
    {
        "Id": 27247831,
        "Time": "2022-02-23T18:42:55",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3038368,
        "Lon": 86.13593,
        "Speed": 9.6,
        "Height": 117,
        "Mileage": 40543344,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 65,
        "EngineRPM": 1781.5,
        "OnboardVoltage": 27064,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1475,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27250590,
        "Time": "2022-02-23T19:02:20",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3084869,
        "Lon": 86.17251,
        "Speed": 20.0,
        "Height": 434,
        "Mileage": 40547748,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 64,
        "EngineRPM": 679.375,
        "OnboardVoltage": 26991,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 14,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1475,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27251850,
        "Time": "2022-02-23T19:11:32",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3004074,
        "Lon": 86.13963,
        "Speed": 13.3,
        "Height": 19,
        "Mileage": 40553620,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 62,
        "EngineRPM": 1032.625,
        "OnboardVoltage": 27246,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1475,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27253290,
        "Time": "2022-02-23T19:22:25",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3047447,
        "Lon": 86.14353,
        "Speed": 17.0,
        "Height": 78,
        "Mileage": 40555648,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 58,
        "EngineRPM": 1814.5,
        "OnboardVoltage": 26993,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1475,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27261076,
        "Time": "2022-02-23T19:41:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3089066,
        "Lon": 86.1733856,
        "Speed": 4.2,
        "Height": 431,
        "Mileage": 40560320,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 61,
        "EngineRPM": 1122.25,
        "OnboardVoltage": 26956,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 80,
        "LoadPercentage": 76,
        "FuelConsumption": 117,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1476,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27260655,
        "Time": "2022-02-23T19:52:21",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3009567,
        "Lon": 86.1442,
        "Speed": 39.0,
        "Height": 17,
        "Mileage": 40565660,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 67,
        "EngineRPM": 1257.875,
        "OnboardVoltage": 27078,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1476,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27260251,
        "Time": "2022-02-23T20:10:54",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3046265,
        "Lon": 86.14212,
        "Speed": 16.2,
        "Height": 84,
        "Mileage": 40567604,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 70,
        "EngineRPM": 1785.625,
        "OnboardVoltage": 27059,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1476,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.0
    },
    {
        "Id": 27262501,
        "Time": "2022-02-23T20:29:48",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30864,
        "Lon": 86.17358,
        "Speed": 5.5,
        "Height": 425,
        "Mileage": 40572260,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 78,
        "EngineRPM": 700.0,
        "OnboardVoltage": 27057,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1477,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27264096,
        "Time": "2022-02-23T20:41:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2944641,
        "Lon": 86.14826,
        "Speed": 34.2,
        "Height": -34,
        "Mileage": 40578240,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 82,
        "EngineRPM": 1287.875,
        "OnboardVoltage": 27152,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1477,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27266547,
        "Time": "2022-02-23T21:01:26",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3048363,
        "Lon": 86.14341,
        "Speed": 14.6,
        "Height": 83,
        "Mileage": 40580996,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 85,
        "EngineRPM": 1798.375,
        "OnboardVoltage": 27005,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 403,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1477,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27269080,
        "Time": "2022-02-23T21:21:53",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3076477,
        "Lon": 86.1709747,
        "Speed": 31.6,
        "Height": 422,
        "Mileage": 40585880,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 90,
        "EngineRPM": 1288.375,
        "OnboardVoltage": 26937,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 67,
        "FuelConsumption": 188,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1477,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27270566,
        "Time": "2022-02-23T21:31:42",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30077,
        "Lon": 86.1418457,
        "Speed": 19.8,
        "Height": 8,
        "Mileage": 40591216,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 90,
        "EngineRPM": 1137.75,
        "OnboardVoltage": 27214,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1478,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27273363,
        "Time": "2022-02-23T21:51:30",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3062668,
        "Lon": 86.13481,
        "Speed": 12.2,
        "Height": 139,
        "Mileage": 40593700,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 93,
        "EngineRPM": 1782.0,
        "OnboardVoltage": 26917,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 403,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1478,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27275904,
        "Time": "2022-02-23T22:09:55",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3069077,
        "Lon": 86.1638,
        "Speed": 34.2,
        "Height": 384,
        "Mileage": 40598288,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 96,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 26940,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1478,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27277101,
        "Time": "2022-02-23T22:18:29",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2993431,
        "Lon": 86.1424942,
        "Speed": 23.3,
        "Height": 8,
        "Mileage": 40603564,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 96,
        "EngineRPM": 1294.5,
        "OnboardVoltage": 27146,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1478,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27280658,
        "Time": "2022-02-23T22:43:16",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.31032,
        "Lon": 86.13283,
        "Speed": 8.8,
        "Height": 184,
        "Mileage": 40606320,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 100,
        "EngineRPM": 1801.625,
        "OnboardVoltage": 26959,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1479,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27283336,
        "Time": "2022-02-23T23:01:05",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30698,
        "Lon": 86.16959,
        "Speed": 30.7,
        "Height": 407,
        "Mileage": 40610368,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 1294.5,
        "OnboardVoltage": 26999,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1479,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27285197,
        "Time": "2022-02-23T23:13:01",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2988243,
        "Lon": 86.14306,
        "Speed": 6.1,
        "Height": 4,
        "Mileage": 40615672,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 697.25,
        "OnboardVoltage": 27185,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1479,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27288016,
        "Time": "2022-02-23T23:32:55",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3114243,
        "Lon": 86.13812,
        "Speed": 15.3,
        "Height": 215,
        "Mileage": 40618600,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 1784.125,
        "OnboardVoltage": 26968,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1480,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27290455,
        "Time": "2022-02-23T23:48:55",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3106575,
        "Lon": 86.15372,
        "Speed": 41.6,
        "Height": 300,
        "Mileage": 40623308,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 105,
        "EngineRPM": 1288.625,
        "OnboardVoltage": 27064,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1480,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27292649,
        "Time": "2022-02-24T00:05:18",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3002548,
        "Lon": 86.1415939,
        "Speed": 20.0,
        "Height": -7,
        "Mileage": 40628056,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 105,
        "EngineRPM": 1785.25,
        "OnboardVoltage": 26998,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1480,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27295179,
        "Time": "2022-02-24T00:23:18",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3137436,
        "Lon": 86.1358643,
        "Speed": 13.1,
        "Height": 218,
        "Mileage": 40631632,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 107,
        "EngineRPM": 765.0,
        "OnboardVoltage": 26964,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1480,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27296992,
        "Time": "2022-02-24T00:44:40",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.2961731,
        "Lon": 86.1459045,
        "Speed": 5.7,
        "Height": -49,
        "Mileage": 40635672,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 105,
        "EngineRPM": 1000.5,
        "OnboardVoltage": 27189,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 67,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1481,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27299854,
        "Time": "2022-02-24T01:12:18",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3076935,
        "Lon": 86.1338348,
        "Speed": 17.9,
        "Height": 156,
        "Mileage": 40638808,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1773.25,
        "OnboardVoltage": 26943,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1481,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27302219,
        "Time": "2022-02-24T01:30:04",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30748,
        "Lon": 86.17106,
        "Speed": 29.4,
        "Height": 416,
        "Mileage": 40642972,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 107,
        "EngineRPM": 1008.375,
        "OnboardVoltage": 27148,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1482,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27303494,
        "Time": "2022-02-24T01:39:24",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3012924,
        "Lon": 86.14148,
        "Speed": 20.1,
        "Height": 21,
        "Mileage": 40648560,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 104,
        "EngineRPM": 1294.75,
        "OnboardVoltage": 27279,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1482,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.0
    },
    {
        "Id": 27308056,
        "Time": "2022-02-24T02:09:05",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.303875,
        "Lon": 86.1362457,
        "Speed": 10.9,
        "Height": 126,
        "Mileage": 40650700,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 106,
        "EngineRPM": 1779.0,
        "OnboardVoltage": 26950,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1482,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.8
    },
    {
        "Id": 27310943,
        "Time": "2022-02-24T02:28:08",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3084,
        "Lon": 86.17225,
        "Speed": 16.8,
        "Height": 431,
        "Mileage": 40655120,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 108,
        "EngineRPM": 1007.625,
        "OnboardVoltage": 27175,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 4,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1483,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27312347,
        "Time": "2022-02-24T02:37:14",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3016357,
        "Lon": 86.14265,
        "Speed": 26.6,
        "Height": 22,
        "Mileage": 40660684,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 105,
        "EngineRPM": 1361.5,
        "OnboardVoltage": 27250,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 148,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1483,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.4
    },
    {
        "Id": 27313961,
        "Time": "2022-02-24T02:49:38",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3042374,
        "Lon": 86.13555,
        "Speed": 10.7,
        "Height": 119,
        "Mileage": 40663224,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 107,
        "EngineRPM": 1795.0,
        "OnboardVoltage": 27060,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1483,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27316804,
        "Time": "2022-02-24T03:09:05",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.3083878,
        "Lon": 86.1726456,
        "Speed": 13.1,
        "Height": 440,
        "Mileage": 40667648,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 108,
        "EngineRPM": 760.375,
        "OnboardVoltage": 27208,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1483,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.8
    },
    {
        "Id": 27318055,
        "Time": "2022-02-24T03:19:18",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.31015,
        "Lon": 86.13235,
        "Speed": 31.4,
        "Height": 188,
        "Mileage": 40671268,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 108,
        "EngineRPM": 1304.0,
        "OnboardVoltage": 27148,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1483,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.8
    },
    {
        "Id": 27319894,
        "Time": "2022-02-24T03:31:14",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.31326,
        "Lon": 86.14041,
        "Speed": 14.4,
        "Height": 236,
        "Mileage": 40674020,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 107,
        "EngineRPM": 1772.0,
        "OnboardVoltage": 27105,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1484,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.8
    },
    {
        "Id": 27322380,
        "Time": "2022-02-24T03:46:52",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.31317,
        "Lon": 86.15203,
        "Speed": 40.3,
        "Height": 287,
        "Mileage": 40678712,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1307.375,
        "OnboardVoltage": 27172,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1484,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.4
    },
    {
        "Id": 27323769,
        "Time": "2022-02-24T03:55:08",
        "TruckId": 1115,
        "Imei": "868328058792553",
        "Lat": 54.30595,
        "Lon": 86.13557,
        "Speed": 19.2,
        "Height": 141,
        "Mileage": 40681888,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 105,
        "EngineRPM": 908.125,
        "OnboardVoltage": 27258,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 122,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 1484,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27004180,
        "Time": "2022-02-22T10:53:46",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2685547,
        "Lon": 86.15502,
        "Speed": 33.8,
        "Height": 275,
        "Mileage": 44531180,
        "EngineOilPressure": 264,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 65,
        "EngineRPM": 1324.25,
        "OnboardVoltage": 27604,
        "EngineSpeed": null,
        "TotalMileage": 526104895,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.200005
    },
    {
        "Id": 27007706,
        "Time": "2022-02-22T11:19:24",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2413635,
        "Lon": 86.1443,
        "Speed": 22.4,
        "Height": 327,
        "Mileage": 44538096,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 68,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27407,
        "EngineSpeed": null,
        "TotalMileage": 526112715,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27009675,
        "Time": "2022-02-22T11:34:50",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2808533,
        "Lon": 86.14292,
        "Speed": 4.0,
        "Height": 258,
        "Mileage": 44543788,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 67,
        "EngineRPM": 813.625,
        "OnboardVoltage": 27561,
        "EngineSpeed": null,
        "TotalMileage": 526119075,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 37,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27014038,
        "Time": "2022-02-22T12:10:17",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2427673,
        "Lon": 86.1415,
        "Speed": 0.0,
        "Height": 334,
        "Mileage": 44549344,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 73,
        "EngineRPM": 948.5,
        "OnboardVoltage": 27618,
        "EngineSpeed": null,
        "TotalMileage": 526125005,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 33,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.6
    },
    {
        "Id": 27016344,
        "Time": "2022-02-22T12:29:20",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25666,
        "Lon": 86.1717,
        "Speed": 0.0,
        "Height": 282,
        "Mileage": 44552868,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 75,
        "EngineRPM": 1129.125,
        "OnboardVoltage": 27582,
        "EngineSpeed": null,
        "TotalMileage": 526128615,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27023081,
        "Time": "2022-02-22T13:34:38",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28088,
        "Lon": 86.1429,
        "Speed": 0.0,
        "Height": 254,
        "Mileage": 44557132,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 77,
        "EngineRPM": 718.0,
        "OnboardVoltage": 27405,
        "EngineSpeed": null,
        "TotalMileage": 526133045,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.8
    },
    {
        "Id": 27026422,
        "Time": "2022-02-22T14:01:05",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25769,
        "Lon": 86.1584549,
        "Speed": 33.1,
        "Height": 292,
        "Mileage": 44564608,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 75,
        "EngineRPM": 1474.5,
        "OnboardVoltage": 27466,
        "EngineSpeed": null,
        "TotalMileage": 526140860,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 8,
        "FuelConsumption": 142,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27032311,
        "Time": "2022-02-22T14:44:17",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2472725,
        "Lon": 86.1510239,
        "Speed": 21.8,
        "Height": 340,
        "Mileage": 44571868,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 76,
        "EngineRPM": 1804.0,
        "OnboardVoltage": 27435,
        "EngineSpeed": null,
        "TotalMileage": 526148715,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27035029,
        "Time": "2022-02-22T15:04:26",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.280735,
        "Lon": 86.14311,
        "Speed": 0.0,
        "Height": 260,
        "Mileage": 44577780,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 80,
        "EngineRPM": 780.875,
        "OnboardVoltage": 27543,
        "EngineSpeed": null,
        "TotalMileage": 526155530,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 32,
        "FuelConsumption": 53,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27039469,
        "Time": "2022-02-22T15:37:29",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24778,
        "Lon": 86.1433,
        "Speed": 21.6,
        "Height": 366,
        "Mileage": 44583328,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 78,
        "EngineRPM": 714.0,
        "OnboardVoltage": 27442,
        "EngineSpeed": null,
        "TotalMileage": 526161280,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 28,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27043502,
        "Time": "2022-02-22T16:12:02",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2575951,
        "Lon": 86.15837,
        "Speed": 33.8,
        "Height": 300,
        "Mileage": 44591300,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 76,
        "EngineRPM": 739.875,
        "OnboardVoltage": 27395,
        "EngineSpeed": null,
        "TotalMileage": 526169510,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27046069,
        "Time": "2022-02-22T16:29:27",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2784653,
        "Lon": 86.14607,
        "Speed": 26.4,
        "Height": 256,
        "Mileage": 44598300,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 79,
        "EngineRPM": 1007.375,
        "OnboardVoltage": 27456,
        "EngineSpeed": null,
        "TotalMileage": 526177450,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 31,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27050756,
        "Time": "2022-02-22T17:06:21",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2482147,
        "Lon": 86.140686,
        "Speed": 5.0,
        "Height": 368,
        "Mileage": 44603960,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1100.5,
        "OnboardVoltage": 27369,
        "EngineSpeed": null,
        "TotalMileage": 526183640,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 30,
        "FuelConsumption": 88,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.4
    },
    {
        "Id": 27054706,
        "Time": "2022-02-22T17:41:56",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2745857,
        "Lon": 86.1528854,
        "Speed": 19.6,
        "Height": 247,
        "Mileage": 44610128,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 78,
        "EngineRPM": 1269.625,
        "OnboardVoltage": 27275,
        "EngineSpeed": null,
        "TotalMileage": 526190185,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27056522,
        "Time": "2022-02-22T17:59:09",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2478065,
        "Lon": 86.15541,
        "Speed": 28.3,
        "Height": 333,
        "Mileage": 44615908,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 79,
        "EngineRPM": 718.5,
        "OnboardVoltage": 27480,
        "EngineSpeed": null,
        "TotalMileage": 526196305,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 40,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27063854,
        "Time": "2022-02-22T18:59:03",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.26841,
        "Lon": 86.15484,
        "Speed": 21.6,
        "Height": 280,
        "Mileage": 44621844,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 78,
        "EngineRPM": 1806.5,
        "OnboardVoltage": 27242,
        "EngineSpeed": null,
        "TotalMileage": 526202750,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 390,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27066071,
        "Time": "2022-02-22T19:15:18",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2539253,
        "Lon": 86.16158,
        "Speed": 33.1,
        "Height": 306,
        "Mileage": 44627744,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 80,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27448,
        "EngineSpeed": null,
        "TotalMileage": 526209020,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27072471,
        "Time": "2022-02-22T19:58:55",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2478065,
        "Lon": 86.15531,
        "Speed": 29.0,
        "Height": 341,
        "Mileage": 44635264,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 77,
        "EngineRPM": 1261.25,
        "OnboardVoltage": 27328,
        "EngineSpeed": null,
        "TotalMileage": 526217325,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 24,
        "FuelConsumption": 117,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27074328,
        "Time": "2022-02-22T20:13:48",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2772179,
        "Lon": 86.1478348,
        "Speed": 28.1,
        "Height": 243,
        "Mileage": 44641268,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 77,
        "EngineRPM": 1806.125,
        "OnboardVoltage": 27462,
        "EngineSpeed": null,
        "TotalMileage": 526224030,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 324,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27080310,
        "Time": "2022-02-22T20:55:19",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2426567,
        "Lon": 86.1412659,
        "Speed": 10.9,
        "Height": 328,
        "Mileage": 44647224,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 78,
        "EngineRPM": 1382.125,
        "OnboardVoltage": 27343,
        "EngineSpeed": null,
        "TotalMileage": 526230670,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 57,
        "FuelConsumption": 136,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27083442,
        "Time": "2022-02-22T21:20:12",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2805824,
        "Lon": 86.14262,
        "Speed": 0.0,
        "Height": 261,
        "Mileage": 44652588,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 81,
        "EngineRPM": 1125.625,
        "OnboardVoltage": 27614,
        "EngineSpeed": null,
        "TotalMileage": 526236735,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27090259,
        "Time": "2022-02-22T22:09:00",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24205,
        "Lon": 86.14213,
        "Speed": 8.3,
        "Height": 330,
        "Mileage": 44658204,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 78,
        "EngineRPM": 1255.375,
        "OnboardVoltage": 27568,
        "EngineSpeed": null,
        "TotalMileage": 526242590,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 65.6
    },
    {
        "Id": 27093186,
        "Time": "2022-02-22T22:30:11",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28099,
        "Lon": 86.1428452,
        "Speed": 0.0,
        "Height": 258,
        "Mileage": 44663700,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 82,
        "EngineRPM": 710.5,
        "OnboardVoltage": 27620,
        "EngineSpeed": null,
        "TotalMileage": 526248665,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27096280,
        "Time": "2022-02-22T22:57:01",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24292,
        "Lon": 86.1477356,
        "Speed": 23.3,
        "Height": 336,
        "Mileage": 44669816,
        "EngineOilPressure": 328,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 82,
        "EngineRPM": 1436.375,
        "OnboardVoltage": 27363,
        "EngineSpeed": null,
        "TotalMileage": 526255060,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 67,
        "FuelConsumption": 187,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27098638,
        "Time": "2022-02-22T23:16:49",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.279808,
        "Lon": 86.1466446,
        "Speed": 21.2,
        "Height": 226,
        "Mileage": 44676656,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 80,
        "EngineRPM": 819.5,
        "OnboardVoltage": 27257,
        "EngineSpeed": null,
        "TotalMileage": 526262425,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 31,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27101255,
        "Time": "2022-02-22T23:34:07",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2430725,
        "Lon": 86.14957,
        "Speed": 31.1,
        "Height": 334,
        "Mileage": 44682732,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 78,
        "EngineRPM": 1153.25,
        "OnboardVoltage": 27635,
        "EngineSpeed": null,
        "TotalMileage": 526268765,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 44,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27104798,
        "Time": "2022-02-23T00:04:43",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2552261,
        "Lon": 86.16147,
        "Speed": 15.7,
        "Height": 297,
        "Mileage": 44690896,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 79,
        "EngineRPM": 1298.25,
        "OnboardVoltage": 27495,
        "EngineSpeed": null,
        "TotalMileage": 526277550,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27107452,
        "Time": "2022-02-23T00:24:38",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.255497,
        "Lon": 86.17303,
        "Speed": 23.1,
        "Height": 279,
        "Mileage": 44696228,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 82,
        "EngineRPM": 1132.75,
        "OnboardVoltage": 27469,
        "EngineSpeed": null,
        "TotalMileage": 526282965,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 70,
        "FuelConsumption": 55,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27110950,
        "Time": "2022-02-23T01:00:52",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25941,
        "Lon": 86.1763153,
        "Speed": 33.3,
        "Height": 191,
        "Mileage": 44699288,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 78,
        "EngineRPM": 1063.375,
        "OnboardVoltage": 27268,
        "EngineSpeed": null,
        "TotalMileage": 526286375,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 60,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27115647,
        "Time": "2022-02-23T01:40:49",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2728157,
        "Lon": 86.17768,
        "Speed": 0.0,
        "Height": 102,
        "Mileage": 44702768,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 80,
        "EngineRPM": 1122.125,
        "OnboardVoltage": 27462,
        "EngineSpeed": null,
        "TotalMileage": 526290355,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27122258,
        "Time": "2022-02-23T02:28:34",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2787933,
        "Lon": 86.18386,
        "Speed": 33.7,
        "Height": 259,
        "Mileage": 44705972,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 80,
        "EngineRPM": 1069.375,
        "OnboardVoltage": 27527,
        "EngineSpeed": null,
        "TotalMileage": 526293545,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.2
    },
    {
        "Id": 27124825,
        "Time": "2022-02-23T02:46:14",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2920265,
        "Lon": 86.17376,
        "Speed": 31.2,
        "Height": 303,
        "Mileage": 44711840,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 85,
        "EngineRPM": 1305.0,
        "OnboardVoltage": 27459,
        "EngineSpeed": null,
        "TotalMileage": 526300085,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.0
    },
    {
        "Id": 27129346,
        "Time": "2022-02-23T03:18:46",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2721825,
        "Lon": 86.17714,
        "Speed": 0.0,
        "Height": 114,
        "Mileage": 44716644,
        "EngineOilPressure": 264,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 83,
        "EngineRPM": 685.0,
        "OnboardVoltage": 27643,
        "EngineSpeed": null,
        "TotalMileage": 526305685,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27133881,
        "Time": "2022-02-23T03:50:34",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.3093452,
        "Lon": 86.17241,
        "Speed": 12.9,
        "Height": 434,
        "Mileage": 44723452,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 83,
        "EngineRPM": 1094.625,
        "OnboardVoltage": 27661,
        "EngineSpeed": null,
        "TotalMileage": 526313075,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 195,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.600002
    },
    {
        "Id": 27135919,
        "Time": "2022-02-23T04:04:30",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2757378,
        "Lon": 86.17622,
        "Speed": 21.4,
        "Height": 103,
        "Mileage": 44729784,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 82,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27598,
        "EngineSpeed": null,
        "TotalMileage": 526319975,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27138589,
        "Time": "2022-02-23T04:20:42",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2685661,
        "Lon": 86.17136,
        "Speed": 30.1,
        "Height": 37,
        "Mileage": 44731672,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 84,
        "EngineRPM": 1297.0,
        "OnboardVoltage": 27512,
        "EngineSpeed": null,
        "TotalMileage": 526321810,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.4
    },
    {
        "Id": 27142134,
        "Time": "2022-02-23T04:44:08",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2419624,
        "Lon": 86.1464,
        "Speed": 15.3,
        "Height": 337,
        "Mileage": 44737860,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 83,
        "EngineRPM": 1325.0,
        "OnboardVoltage": 27381,
        "EngineSpeed": null,
        "TotalMileage": 526328790,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 60,
        "FuelConsumption": 140,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27145131,
        "Time": "2022-02-23T05:08:35",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25628,
        "Lon": 86.17206,
        "Speed": 0.0,
        "Height": 290,
        "Mileage": 44741368,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 84,
        "EngineRPM": 750.75,
        "OnboardVoltage": 27500,
        "EngineSpeed": null,
        "TotalMileage": 526332770,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27147586,
        "Time": "2022-02-23T05:34:16",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25572,
        "Lon": 86.16131,
        "Speed": 28.1,
        "Height": 294,
        "Mileage": 44748592,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 64,
        "EngineRPM": 1302.375,
        "OnboardVoltage": 27487,
        "EngineSpeed": null,
        "TotalMileage": 526339910,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27149482,
        "Time": "2022-02-23T05:50:01",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2664528,
        "Lon": 86.1563,
        "Speed": 35.7,
        "Height": 286,
        "Mileage": 44754496,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 64,
        "EngineRPM": 1299.875,
        "OnboardVoltage": 27421,
        "EngineSpeed": null,
        "TotalMileage": 526346680,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27152722,
        "Time": "2022-02-23T06:13:11",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24253,
        "Lon": 86.14129,
        "Speed": 14.8,
        "Height": 329,
        "Mileage": 44761856,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 61,
        "EngineRPM": 968.625,
        "OnboardVoltage": 27562,
        "EngineSpeed": null,
        "TotalMileage": 526354560,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 52,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 93.200005
    },
    {
        "Id": 27157904,
        "Time": "2022-02-23T06:53:17",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28146,
        "Lon": 86.14426,
        "Speed": 9.6,
        "Height": 229,
        "Mileage": 44767248,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 63,
        "EngineRPM": 806.125,
        "OnboardVoltage": 27457,
        "EngineSpeed": null,
        "TotalMileage": 526360925,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 49,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.0
    },
    {
        "Id": 27160555,
        "Time": "2022-02-23T07:10:57",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2424469,
        "Lon": 86.14183,
        "Speed": 16.4,
        "Height": 338,
        "Mileage": 44772820,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 62,
        "EngineRPM": 1016.0,
        "OnboardVoltage": 27583,
        "EngineSpeed": null,
        "TotalMileage": 526366980,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 142,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.8
    },
    {
        "Id": 27163394,
        "Time": "2022-02-23T07:31:03",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2696762,
        "Lon": 86.15514,
        "Speed": 18.7,
        "Height": 274,
        "Mileage": 44779836,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 67,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27496,
        "EngineSpeed": null,
        "TotalMileage": 526374365,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.200005
    },
    {
        "Id": 27165406,
        "Time": "2022-02-23T07:44:14",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24406,
        "Lon": 86.15159,
        "Speed": 34.4,
        "Height": 333,
        "Mileage": 44784460,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 70,
        "EngineRPM": 1446.5,
        "OnboardVoltage": 27439,
        "EngineSpeed": null,
        "TotalMileage": 526379525,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 134,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27171797,
        "Time": "2022-02-23T08:35:16",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2685165,
        "Lon": 86.1548157,
        "Speed": 19.2,
        "Height": 279,
        "Mileage": 44790852,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 75,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27461,
        "EngineSpeed": null,
        "TotalMileage": 526386550,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 381,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.8
    },
    {
        "Id": 27174419,
        "Time": "2022-02-23T08:52:12",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2417526,
        "Lon": 86.14601,
        "Speed": 12.7,
        "Height": 327,
        "Mileage": 44795080,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 885.75,
        "OnboardVoltage": 27337,
        "EngineSpeed": null,
        "TotalMileage": 526391375,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27176877,
        "Time": "2022-02-23T09:17:21",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25662,
        "Lon": 86.15937,
        "Speed": 33.3,
        "Height": 300,
        "Mileage": 44803084,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 76,
        "EngineRPM": 1345.125,
        "OnboardVoltage": 27514,
        "EngineSpeed": null,
        "TotalMileage": 526399880,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 69,
        "FuelConsumption": 102,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27178897,
        "Time": "2022-02-23T09:32:56",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2685432,
        "Lon": 86.155,
        "Speed": 33.7,
        "Height": 278,
        "Mileage": 44809228,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 80,
        "EngineRPM": 1214.875,
        "OnboardVoltage": 27526,
        "EngineSpeed": null,
        "TotalMileage": 526406875,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27181579,
        "Time": "2022-02-23T09:51:55",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24793,
        "Lon": 86.14076,
        "Speed": 4.4,
        "Height": 361,
        "Mileage": 44816008,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 77,
        "EngineRPM": 1077.375,
        "OnboardVoltage": 27515,
        "EngineSpeed": null,
        "TotalMileage": 526414505,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.0
    },
    {
        "Id": 27184936,
        "Time": "2022-02-23T10:17:51",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.26992,
        "Lon": 86.15512,
        "Speed": 20.3,
        "Height": 266,
        "Mileage": 44822728,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 80,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27477,
        "EngineSpeed": null,
        "TotalMileage": 526421705,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27187104,
        "Time": "2022-02-23T10:35:22",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.27328,
        "Lon": 86.15421,
        "Speed": 33.1,
        "Height": 252,
        "Mileage": 44830256,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 80,
        "EngineRPM": 1301.125,
        "OnboardVoltage": 27395,
        "EngineSpeed": null,
        "TotalMileage": 526429865,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27189769,
        "Time": "2022-02-23T10:54:32",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2479134,
        "Lon": 86.14188,
        "Speed": 22.0,
        "Height": 369,
        "Mileage": 44836620,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 80,
        "EngineRPM": 1167.5,
        "OnboardVoltage": 27421,
        "EngineSpeed": null,
        "TotalMileage": 526437030,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.8
    },
    {
        "Id": 27194165,
        "Time": "2022-02-23T11:27:59",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2654152,
        "Lon": 86.15648,
        "Speed": 30.3,
        "Height": 293,
        "Mileage": 44843744,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 78,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27397,
        "EngineSpeed": null,
        "TotalMileage": 526444560,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 82,
        "FuelConsumption": 318,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27196560,
        "Time": "2022-02-23T11:45:26",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2762146,
        "Lon": 86.1517258,
        "Speed": 31.4,
        "Height": 231,
        "Mileage": 44851132,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 82,
        "EngineRPM": 1300.375,
        "OnboardVoltage": 27394,
        "EngineSpeed": null,
        "TotalMileage": 526452820,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 12,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27199047,
        "Time": "2022-02-23T12:07:00",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2469254,
        "Lon": 86.14563,
        "Speed": 32.4,
        "Height": 361,
        "Mileage": 44857472,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 1548.5,
        "OnboardVoltage": 27535,
        "EngineSpeed": null,
        "TotalMileage": 526459600,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 56,
        "FuelConsumption": 116,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27201056,
        "Time": "2022-02-23T12:26:41",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25638,
        "Lon": 86.15998,
        "Speed": 30.7,
        "Height": 294,
        "Mileage": 44865124,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 82,
        "EngineRPM": 1226.375,
        "OnboardVoltage": 27348,
        "EngineSpeed": null,
        "TotalMileage": 526468260,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27204708,
        "Time": "2022-02-23T13:05:11",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2429,
        "Lon": 86.1473541,
        "Speed": 19.2,
        "Height": 330,
        "Mileage": 44868904,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 82,
        "EngineRPM": 1478.875,
        "OnboardVoltage": 27448,
        "EngineSpeed": null,
        "TotalMileage": 526471960,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 39,
        "FuelConsumption": 168,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27206561,
        "Time": "2022-02-23T13:22:44",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28124,
        "Lon": 86.13996,
        "Speed": 27.5,
        "Height": 283,
        "Mileage": 44874876,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 82,
        "EngineRPM": 1380.875,
        "OnboardVoltage": 27408,
        "EngineSpeed": null,
        "TotalMileage": 526478785,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 61,
        "FuelConsumption": 144,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27211150,
        "Time": "2022-02-23T13:48:56",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2412338,
        "Lon": 86.1445,
        "Speed": 20.7,
        "Height": 327,
        "Mileage": 44881156,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 82,
        "EngineRPM": 1309.0,
        "OnboardVoltage": 27329,
        "EngineSpeed": null,
        "TotalMileage": 526485555,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27212462,
        "Time": "2022-02-23T14:07:53",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2839355,
        "Lon": 86.13734,
        "Speed": 4.0,
        "Height": 293,
        "Mileage": 44887232,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 84,
        "EngineRPM": 825.25,
        "OnboardVoltage": 27574,
        "EngineSpeed": null,
        "TotalMileage": 526492380,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27216316,
        "Time": "2022-02-23T14:31:50",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2428436,
        "Lon": 86.14739,
        "Speed": 20.1,
        "Height": 332,
        "Mileage": 44894020,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 84,
        "EngineRPM": 1501.0,
        "OnboardVoltage": 27313,
        "EngineSpeed": null,
        "TotalMileage": 526499320,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 79,
        "FuelConsumption": 307,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27219605,
        "Time": "2022-02-23T15:02:17",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.266552,
        "Lon": 86.15601,
        "Speed": 31.6,
        "Height": 283,
        "Mileage": 44901704,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 81,
        "EngineRPM": 1812.875,
        "OnboardVoltage": 27276,
        "EngineSpeed": null,
        "TotalMileage": 526507610,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27221755,
        "Time": "2022-02-23T15:19:28",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2549858,
        "Lon": 86.1618347,
        "Speed": 36.6,
        "Height": 309,
        "Mileage": 44907564,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 82,
        "EngineRPM": 1312.375,
        "OnboardVoltage": 27448,
        "EngineSpeed": null,
        "TotalMileage": 526513760,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.2
    },
    {
        "Id": 27225713,
        "Time": "2022-02-23T15:46:29",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24303,
        "Lon": 86.14748,
        "Speed": 23.8,
        "Height": 339,
        "Mileage": 44916468,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 1686.25,
        "OnboardVoltage": 27411,
        "EngineSpeed": null,
        "TotalMileage": 526523830,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 309,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27227868,
        "Time": "2022-02-23T16:01:40",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28097,
        "Lon": 86.1402054,
        "Speed": 23.7,
        "Height": 287,
        "Mileage": 44922412,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 81,
        "EngineRPM": 1246.0,
        "OnboardVoltage": 27315,
        "EngineSpeed": null,
        "TotalMileage": 526530365,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 42,
        "FuelConsumption": 85,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27231577,
        "Time": "2022-02-23T16:25:02",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2425766,
        "Lon": 86.14136,
        "Speed": 10.1,
        "Height": 328,
        "Mileage": 44928720,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 82,
        "EngineRPM": 1774.75,
        "OnboardVoltage": 27536,
        "EngineSpeed": null,
        "TotalMileage": 526537235,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27233487,
        "Time": "2022-02-23T16:45:58",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28363,
        "Lon": 86.13761,
        "Speed": 7.9,
        "Height": 287,
        "Mileage": 44934824,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 82,
        "EngineRPM": 768.25,
        "OnboardVoltage": 27394,
        "EngineSpeed": null,
        "TotalMileage": 526543855,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27236179,
        "Time": "2022-02-23T17:03:26",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24154,
        "Lon": 86.146,
        "Speed": 12.4,
        "Height": 326,
        "Mileage": 44941100,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 82,
        "EngineRPM": 1263.75,
        "OnboardVoltage": 27453,
        "EngineSpeed": null,
        "TotalMileage": 526550385,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27238023,
        "Time": "2022-02-23T17:25:12",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2590637,
        "Lon": 86.15732,
        "Speed": 30.0,
        "Height": 298,
        "Mileage": 44949696,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 83,
        "EngineRPM": 1221.875,
        "OnboardVoltage": 27431,
        "EngineSpeed": null,
        "TotalMileage": 526559675,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27241495,
        "Time": "2022-02-23T17:52:53",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2478065,
        "Lon": 86.1423645,
        "Speed": 10.7,
        "Height": 363,
        "Mileage": 44952428,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 82,
        "EngineRPM": 876.25,
        "OnboardVoltage": 27290,
        "EngineSpeed": null,
        "TotalMileage": 526562705,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 45,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.2
    },
    {
        "Id": 27245267,
        "Time": "2022-02-23T18:22:26",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.27358,
        "Lon": 86.15234,
        "Speed": 31.6,
        "Height": 259,
        "Mileage": 44959412,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 84,
        "EngineRPM": 1050.625,
        "OnboardVoltage": 27365,
        "EngineSpeed": null,
        "TotalMileage": 526569605,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27249576,
        "Time": "2022-02-23T18:55:45",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2487,
        "Lon": 86.15746,
        "Speed": 34.2,
        "Height": 321,
        "Mileage": 44964804,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 82,
        "EngineRPM": 1296.875,
        "OnboardVoltage": 27290,
        "EngineSpeed": null,
        "TotalMileage": 526575800,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27253221,
        "Time": "2022-02-23T19:22:05",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2475281,
        "Lon": 86.14487,
        "Speed": 23.5,
        "Height": 363,
        "Mileage": 44974280,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 80,
        "EngineRPM": 908.875,
        "OnboardVoltage": 27354,
        "EngineSpeed": null,
        "TotalMileage": 526586235,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 113,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.0
    },
    {
        "Id": 27256328,
        "Time": "2022-02-23T19:46:18",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28314,
        "Lon": 86.13839,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": 44980124,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 82,
        "EngineRPM": 679.5,
        "OnboardVoltage": 27443,
        "EngineSpeed": null,
        "TotalMileage": 526592735,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27259601,
        "Time": "2022-02-23T20:08:44",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2480621,
        "Lon": 86.1440353,
        "Speed": 13.3,
        "Height": 361,
        "Mileage": 44985964,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 82,
        "EngineRPM": 958.125,
        "OnboardVoltage": 27521,
        "EngineSpeed": null,
        "TotalMileage": 526598850,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 16,
        "FuelConsumption": 145,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.0
    },
    {
        "Id": 27264430,
        "Time": "2022-02-23T20:43:45",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2555122,
        "Lon": 86.1740341,
        "Speed": 21.8,
        "Height": 277,
        "Mileage": 44989044,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 83,
        "EngineRPM": 1007.625,
        "OnboardVoltage": 27391,
        "EngineSpeed": null,
        "TotalMileage": 526602105,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 96,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27269067,
        "Time": "2022-02-23T21:21:46",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2680168,
        "Lon": 86.1678162,
        "Speed": 11.2,
        "Height": 111,
        "Mileage": 44992424,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 65,
        "EngineRPM": 1163.0,
        "OnboardVoltage": 27227,
        "EngineSpeed": null,
        "TotalMileage": 526605490,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 64,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.4
    },
    {
        "Id": 27271671,
        "Time": "2022-02-23T21:39:34",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.24283,
        "Lon": 86.1412659,
        "Speed": 5.3,
        "Height": 330,
        "Mileage": 44997864,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 60,
        "EngineRPM": 1235.125,
        "OnboardVoltage": 27461,
        "EngineSpeed": null,
        "TotalMileage": 526611470,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 65,
        "FuelConsumption": 141,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27273721,
        "Time": "2022-02-23T21:53:54",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.27256,
        "Lon": 86.1649,
        "Speed": 16.6,
        "Height": 54,
        "Mileage": 45003776,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 63,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27293,
        "EngineSpeed": null,
        "TotalMileage": 526617875,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27275403,
        "Time": "2022-02-23T22:05:44",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.26833,
        "Lon": 86.17198,
        "Speed": 13.5,
        "Height": 31,
        "Mileage": 45005932,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 64,
        "EngineRPM": 1295.375,
        "OnboardVoltage": 27345,
        "EngineSpeed": null,
        "TotalMileage": 526620030,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 7,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.8
    },
    {
        "Id": 27278206,
        "Time": "2022-02-23T22:25:23",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2704,
        "Lon": 86.176445,
        "Speed": 8.5,
        "Height": 73,
        "Mileage": 45007056,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 67,
        "EngineRPM": 752.0,
        "OnboardVoltage": 27370,
        "EngineSpeed": null,
        "TotalMileage": 526621245,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27280052,
        "Time": "2022-02-23T22:38:19",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.27029,
        "Lon": 86.17668,
        "Speed": 5.1,
        "Height": 74,
        "Mileage": 45008556,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 67,
        "EngineRPM": 1222.375,
        "OnboardVoltage": 27551,
        "EngineSpeed": null,
        "TotalMileage": 526622725,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 33,
        "FuelConsumption": 97,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.200005
    },
    {
        "Id": 27282331,
        "Time": "2022-02-23T22:53:45",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2694,
        "Lon": 86.1753845,
        "Speed": 24.0,
        "Height": 58,
        "Mileage": 45010036,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 67,
        "EngineRPM": 1669.25,
        "OnboardVoltage": 27407,
        "EngineSpeed": null,
        "TotalMileage": 526623990,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 307,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.0
    },
    {
        "Id": 27285685,
        "Time": "2022-02-23T23:12:43",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2681541,
        "Lon": 86.17166,
        "Speed": 9.0,
        "Height": 33,
        "Mileage": 45011124,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 66,
        "EngineRPM": 759.625,
        "OnboardVoltage": 27467,
        "EngineSpeed": null,
        "TotalMileage": 526625205,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.6
    },
    {
        "Id": 27287070,
        "Time": "2022-02-23T23:26:25",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.26744,
        "Lon": 86.17374,
        "Speed": 14.8,
        "Height": 35,
        "Mileage": 45012508,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 65,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27433,
        "EngineSpeed": null,
        "TotalMileage": 526626435,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27289584,
        "Time": "2022-02-23T23:44:03",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2687759,
        "Lon": 86.17467,
        "Speed": 14.2,
        "Height": 41,
        "Mileage": 45013836,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 71,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27447,
        "EngineSpeed": null,
        "TotalMileage": 526627730,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27292128,
        "Time": "2022-02-24T00:01:26",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2696724,
        "Lon": 86.17715,
        "Speed": 14.2,
        "Height": 65,
        "Mileage": 45015096,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 75,
        "EngineRPM": 899.0,
        "OnboardVoltage": 27416,
        "EngineSpeed": null,
        "TotalMileage": 526628945,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27293775,
        "Time": "2022-02-24T00:12:05",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2702332,
        "Lon": 86.1768646,
        "Speed": 9.2,
        "Height": 65,
        "Mileage": 45016476,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 74,
        "EngineRPM": 1352.125,
        "OnboardVoltage": 27403,
        "EngineSpeed": null,
        "TotalMileage": 526630315,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 7,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.0
    },
    {
        "Id": 27295875,
        "Time": "2022-02-24T00:28:18",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.25944,
        "Lon": 86.17612,
        "Speed": 18.5,
        "Height": 195,
        "Mileage": 45019484,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 76,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27306,
        "EngineSpeed": null,
        "TotalMileage": 526633355,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 367,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.6
    },
    {
        "Id": 27298540,
        "Time": "2022-02-24T01:00:59",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2598343,
        "Lon": 86.17707,
        "Speed": 24.8,
        "Height": 187,
        "Mileage": 45022844,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 76,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27410,
        "EngineSpeed": null,
        "TotalMileage": 526636770,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.4
    },
    {
        "Id": 27300668,
        "Time": "2022-02-24T01:19:08",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.28707,
        "Lon": 86.15632,
        "Speed": 19.6,
        "Height": -58,
        "Mileage": 45030508,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 74,
        "EngineRPM": 1300.0,
        "OnboardVoltage": 27419,
        "EngineSpeed": null,
        "TotalMileage": 526644430,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.8
    },
    {
        "Id": 27303062,
        "Time": "2022-02-24T01:35:48",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.3072357,
        "Lon": 86.13825,
        "Speed": 9.8,
        "Height": 164,
        "Mileage": 45034344,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 75,
        "EngineRPM": 872.0,
        "OnboardVoltage": 27519,
        "EngineSpeed": null,
        "TotalMileage": 526648405,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 66,
        "FuelConsumption": 42,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.4
    },
    {
        "Id": 27305634,
        "Time": "2022-02-24T01:53:48",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.30666,
        "Lon": 86.1639252,
        "Speed": 9.4,
        "Height": 385,
        "Mileage": 45038220,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 78,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27556,
        "EngineSpeed": null,
        "TotalMileage": 526652155,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 383,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27307650,
        "Time": "2022-02-24T02:06:27",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.3137474,
        "Lon": 86.14696,
        "Speed": 17.7,
        "Height": 271,
        "Mileage": 45041484,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 79,
        "EngineRPM": 1221.25,
        "OnboardVoltage": 27443,
        "EngineSpeed": null,
        "TotalMileage": 526655535,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 12,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.8
    },
    {
        "Id": 27309627,
        "Time": "2022-02-24T02:19:10",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2996178,
        "Lon": 86.137146,
        "Speed": 5.0,
        "Height": 22,
        "Mileage": 45045356,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 80,
        "EngineRPM": 1062.75,
        "OnboardVoltage": 27537,
        "EngineSpeed": null,
        "TotalMileage": 526659585,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27311963,
        "Time": "2022-02-24T02:35:33",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.3139229,
        "Lon": 86.1424,
        "Speed": 17.4,
        "Height": 249,
        "Mileage": 45048856,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 80,
        "EngineRPM": 1769.125,
        "OnboardVoltage": 27582,
        "EngineSpeed": null,
        "TotalMileage": 526663090,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27314625,
        "Time": "2022-02-24T02:54:15",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.3140335,
        "Lon": 86.143486,
        "Speed": 31.1,
        "Height": 251,
        "Mileage": 45053996,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 82,
        "EngineRPM": 1303.125,
        "OnboardVoltage": 27511,
        "EngineSpeed": null,
        "TotalMileage": 526668320,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27316742,
        "Time": "2022-02-24T03:08:39",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.2959671,
        "Lon": 86.14559,
        "Speed": 4.6,
        "Height": -41,
        "Mileage": 45058428,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 80,
        "EngineRPM": 1067.5,
        "OnboardVoltage": 27338,
        "EngineSpeed": null,
        "TotalMileage": 526673060,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 68,
        "FuelConsumption": 111,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27319858,
        "Time": "2022-02-24T03:30:58",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.3139458,
        "Lon": 86.14235,
        "Speed": 15.7,
        "Height": 255,
        "Mileage": 45062852,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1813.0,
        "OnboardVoltage": 27552,
        "EngineSpeed": null,
        "TotalMileage": 526677310,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 96,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27322326,
        "Time": "2022-02-24T03:46:49",
        "TruckId": 700,
        "Imei": "868328058792736",
        "Lat": 54.3069458,
        "Lon": 86.16342,
        "Speed": 27.5,
        "Height": 388,
        "Mileage": 45066504,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 83,
        "EngineRPM": 1302.25,
        "OnboardVoltage": 27565,
        "EngineSpeed": null,
        "TotalMileage": 526680700,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27004218,
        "Time": "2022-02-22T10:53:51",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2506561,
        "Lon": 86.15853,
        "Speed": 21.4,
        "Height": 334,
        "Mileage": 40783064,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 103,
        "EngineRPM": 1816.5,
        "OnboardVoltage": 27949,
        "EngineSpeed": null,
        "TotalMileage": 416671205,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 99,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 225,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27006529,
        "Time": "2022-02-22T11:10:54",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2706528,
        "Lon": 86.1553955,
        "Speed": 30.1,
        "Height": 260,
        "Mileage": 40788940,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 102,
        "EngineRPM": 1292.625,
        "OnboardVoltage": 27887,
        "EngineSpeed": null,
        "TotalMileage": 416677315,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 225,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27010049,
        "Time": "2022-02-22T11:36:45",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.241127,
        "Lon": 86.1450653,
        "Speed": 18.7,
        "Height": 319,
        "Mileage": 40795772,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 102,
        "EngineRPM": 1276.25,
        "OnboardVoltage": 27980,
        "EngineSpeed": null,
        "TotalMileage": 416684420,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 11,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 226,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27012766,
        "Time": "2022-02-22T11:57:58",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2813759,
        "Lon": 86.1446457,
        "Speed": 6.6,
        "Height": 234,
        "Mileage": 40801512,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 102,
        "EngineRPM": 1087.875,
        "OnboardVoltage": 27894,
        "EngineSpeed": null,
        "TotalMileage": 416690590,
        "AcceleratorPedalPosition": 26,
        "LoadPercentage": 53,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 226,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27015248,
        "Time": "2022-02-22T12:20:42",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.24268,
        "Lon": 86.14143,
        "Speed": 5.9,
        "Height": 333,
        "Mileage": 40807356,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 103,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27881,
        "EngineSpeed": null,
        "TotalMileage": 416696480,
        "AcceleratorPedalPosition": 95,
        "LoadPercentage": 4,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 226,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27018814,
        "Time": "2022-02-22T12:56:12",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2562523,
        "Lon": 86.1717,
        "Speed": 9.4,
        "Height": 288,
        "Mileage": 40810884,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 103,
        "EngineRPM": 1057.0,
        "OnboardVoltage": 27793,
        "EngineSpeed": null,
        "TotalMileage": 416699975,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 227,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27024361,
        "Time": "2022-02-22T13:46:11",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2814026,
        "Lon": 86.14436,
        "Speed": 10.0,
        "Height": 232,
        "Mileage": 40814856,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 695.625,
        "OnboardVoltage": 27840,
        "EngineSpeed": null,
        "TotalMileage": 416704285,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 228,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27028148,
        "Time": "2022-02-22T14:10:20",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2411156,
        "Lon": 86.1452255,
        "Speed": 20.3,
        "Height": 320,
        "Mileage": 40820796,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 100,
        "EngineRPM": 1128.375,
        "OnboardVoltage": 27861,
        "EngineSpeed": null,
        "TotalMileage": 416710260,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 13,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 228,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27031513,
        "Time": "2022-02-22T14:37:37",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2559166,
        "Lon": 86.1636658,
        "Speed": 11.2,
        "Height": 277,
        "Mileage": 40824432,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 84,
        "EngineRPM": 1136.75,
        "OnboardVoltage": 27800,
        "EngineSpeed": null,
        "TotalMileage": 416714020,
        "AcceleratorPedalPosition": 9,
        "LoadPercentage": 0,
        "FuelConsumption": 53,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 229,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27041602,
        "Time": "2022-02-22T15:55:45",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2702827,
        "Lon": 86.1552658,
        "Speed": 20.5,
        "Height": 267,
        "Mileage": 40829384,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 56,
        "EngineRPM": 1792.5,
        "OnboardVoltage": 27775,
        "EngineSpeed": null,
        "TotalMileage": 416719175,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 230,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27044126,
        "Time": "2022-02-22T16:13:24",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2479973,
        "Lon": 86.15595,
        "Speed": 32.7,
        "Height": 332,
        "Mileage": 40834716,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 61,
        "EngineRPM": 783.75,
        "OnboardVoltage": 27811,
        "EngineSpeed": null,
        "TotalMileage": 416724695,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 230,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27048446,
        "Time": "2022-02-22T16:48:39",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.25206,
        "Lon": 86.15972,
        "Speed": 19.0,
        "Height": 318,
        "Mileage": 40842384,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 61,
        "EngineRPM": 1807.375,
        "OnboardVoltage": 27736,
        "EngineSpeed": null,
        "TotalMileage": 416732960,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 231,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27050661,
        "Time": "2022-02-22T17:00:30",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2485924,
        "Lon": 86.1573,
        "Speed": 32.0,
        "Height": 330,
        "Mileage": 40845908,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 65,
        "EngineRPM": 798.625,
        "OnboardVoltage": 27791,
        "EngineSpeed": null,
        "TotalMileage": 416736235,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 231,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27054840,
        "Time": "2022-02-22T17:43:11",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2808075,
        "Lon": 86.14478,
        "Speed": 0.0,
        "Height": 223,
        "Mileage": 40850252,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 77,
        "EngineRPM": 769.375,
        "OnboardVoltage": 27968,
        "EngineSpeed": null,
        "TotalMileage": 416741280,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 9,
        "FuelConsumption": 50,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 232,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27057823,
        "Time": "2022-02-22T18:10:48",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2419777,
        "Lon": 86.14198,
        "Speed": 10.7,
        "Height": 325,
        "Mileage": 40856024,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1496.125,
        "OnboardVoltage": 27847,
        "EngineSpeed": null,
        "TotalMileage": 416747040,
        "AcceleratorPedalPosition": 48,
        "LoadPercentage": 19,
        "FuelConsumption": 77,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 232,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27061604,
        "Time": "2022-02-22T18:43:39",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2561378,
        "Lon": 86.17313,
        "Speed": 8.7,
        "Height": 281,
        "Mileage": 40859344,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 82,
        "EngineRPM": 753.875,
        "OnboardVoltage": 27820,
        "EngineSpeed": null,
        "TotalMileage": 416750425,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 22,
        "FuelConsumption": 53,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 233,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27066456,
        "Time": "2022-02-22T19:17:44",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.25482,
        "Lon": 86.16155,
        "Speed": 16.1,
        "Height": 299,
        "Mileage": 40866648,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 84,
        "EngineRPM": 891.625,
        "OnboardVoltage": 27796,
        "EngineSpeed": null,
        "TotalMileage": 416757830,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 234,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27068746,
        "Time": "2022-02-22T19:35:15",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.265316,
        "Lon": 86.15657,
        "Speed": 38.8,
        "Height": 289,
        "Mileage": 40872540,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 85,
        "EngineRPM": 795.875,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 416763810,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 48,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 234,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27073018,
        "Time": "2022-02-22T20:04:49",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2429962,
        "Lon": 86.14876,
        "Speed": 20.1,
        "Height": 334,
        "Mileage": 40879532,
        "EngineOilPressure": 204,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 88,
        "EngineRPM": 774.75,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 416770875,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 36,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 234,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27075321,
        "Time": "2022-02-22T20:20:33",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.27597,
        "Lon": 86.1519,
        "Speed": 31.4,
        "Height": 229,
        "Mileage": 40884996,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 89,
        "EngineRPM": 722.0,
        "OnboardVoltage": 27802,
        "EngineSpeed": null,
        "TotalMileage": 416776545,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 28,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 234,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27080745,
        "Time": "2022-02-22T20:59:40",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.24292,
        "Lon": 86.1472,
        "Speed": 8.8,
        "Height": 339,
        "Mileage": 40890916,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 90,
        "EngineRPM": 1331.5,
        "OnboardVoltage": 27772,
        "EngineSpeed": null,
        "TotalMileage": 416782820,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 235,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27085443,
        "Time": "2022-02-22T21:35:14",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2702026,
        "Lon": 86.15537,
        "Speed": 34.0,
        "Height": 264,
        "Mileage": 40895520,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 1256.375,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 416787540,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 236,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27091466,
        "Time": "2022-02-22T22:10:19",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.24112,
        "Lon": 86.14506,
        "Speed": 17.7,
        "Height": 320,
        "Mileage": 40902424,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 1152.375,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 416794760,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 69,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 236,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27092528,
        "Time": "2022-02-22T22:28:34",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.28147,
        "Lon": 86.144455,
        "Speed": 13.7,
        "Height": 247,
        "Mileage": 40908448,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 93,
        "EngineRPM": 821.25,
        "OnboardVoltage": 27913,
        "EngineSpeed": null,
        "TotalMileage": 416800950,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 237,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27095534,
        "Time": "2022-02-22T22:49:34",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.24121,
        "Lon": 86.14544,
        "Speed": 16.2,
        "Height": 323,
        "Mileage": 40914380,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 761.25,
        "OnboardVoltage": 27775,
        "EngineSpeed": null,
        "TotalMileage": 416806850,
        "AcceleratorPedalPosition": 7,
        "LoadPercentage": 34,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 237,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27098256,
        "Time": "2022-02-22T23:13:42",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2550926,
        "Lon": 86.16154,
        "Speed": 18.8,
        "Height": 294,
        "Mileage": 40922948,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 93,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 416815645,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 237,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27100201,
        "Time": "2022-02-22T23:28:27",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.25618,
        "Lon": 86.16104,
        "Speed": 30.3,
        "Height": 290,
        "Mileage": 40927636,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 96,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27826,
        "EngineSpeed": null,
        "TotalMileage": 416820550,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 238,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27106853,
        "Time": "2022-02-23T00:00:04",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2487679,
        "Lon": 86.15719,
        "Speed": 18.1,
        "Height": 326,
        "Mileage": 40934944,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 96,
        "EngineRPM": 1001.75,
        "OnboardVoltage": 27872,
        "EngineSpeed": null,
        "TotalMileage": 416828130,
        "AcceleratorPedalPosition": 24,
        "LoadPercentage": 46,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 238,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27107256,
        "Time": "2022-02-23T00:22:56",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2560959,
        "Lon": 86.1652,
        "Speed": 11.4,
        "Height": 281,
        "Mileage": 40939356,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 98,
        "EngineRPM": 1325.875,
        "OnboardVoltage": 27821,
        "EngineSpeed": null,
        "TotalMileage": 416832550,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 64,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 239,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27112847,
        "Time": "2022-02-23T01:17:22",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2814369,
        "Lon": 86.14432,
        "Speed": 10.1,
        "Height": 228,
        "Mileage": 40944080,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 1289.875,
        "OnboardVoltage": 27944,
        "EngineSpeed": null,
        "TotalMileage": 416837500,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 60,
        "FuelConsumption": 156,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 239,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27115914,
        "Time": "2022-02-23T01:39:06",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2410927,
        "Lon": 86.1449,
        "Speed": 30.9,
        "Height": 318,
        "Mileage": 40950064,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 102,
        "EngineRPM": 909.25,
        "OnboardVoltage": 27968,
        "EngineSpeed": null,
        "TotalMileage": 416843525,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 240,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27119004,
        "Time": "2022-02-23T02:04:06",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.25866,
        "Lon": 86.1575851,
        "Speed": 38.7,
        "Height": 298,
        "Mileage": 40958408,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 99,
        "EngineRPM": 1368.375,
        "OnboardVoltage": 27890,
        "EngineSpeed": null,
        "TotalMileage": 416851875,
        "AcceleratorPedalPosition": 57,
        "LoadPercentage": 67,
        "FuelConsumption": 190,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 240,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27120885,
        "Time": "2022-02-23T02:18:03",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2556,
        "Lon": 86.1616,
        "Speed": 37.4,
        "Height": 290,
        "Mileage": 40963564,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 101,
        "EngineRPM": 1426.125,
        "OnboardVoltage": 27933,
        "EngineSpeed": null,
        "TotalMileage": 416857210,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 76,
        "FuelConsumption": 165,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 240,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27124604,
        "Time": "2022-02-23T02:44:15",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.24297,
        "Lon": 86.1473846,
        "Speed": 17.9,
        "Height": 339,
        "Mileage": 40971800,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 101,
        "EngineRPM": 1192.25,
        "OnboardVoltage": 27836,
        "EngineSpeed": null,
        "TotalMileage": 416865785,
        "AcceleratorPedalPosition": 21,
        "LoadPercentage": 47,
        "FuelConsumption": 92,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 241,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27127248,
        "Time": "2022-02-23T02:59:26",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.28523,
        "Lon": 86.14551,
        "Speed": 0.0,
        "Height": 142,
        "Mileage": 40978676,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1103.875,
        "OnboardVoltage": 27942,
        "EngineSpeed": null,
        "TotalMileage": 416872825,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 73,
        "FuelConsumption": 115,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 241,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27152384,
        "Time": "2022-02-23T06:11:26",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.28523,
        "Lon": 86.14551,
        "Speed": 0.0,
        "Height": 142,
        "Mileage": 40978676,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 102,
        "EngineRPM": 1305.125,
        "OnboardVoltage": 27993,
        "EngineSpeed": null,
        "TotalMileage": 416872825,
        "AcceleratorPedalPosition": 24,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 244,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27178405,
        "Time": "2022-02-23T09:29:04",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.28524,
        "Lon": 86.145546,
        "Speed": 0.0,
        "Height": 138,
        "Mileage": 40978680,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 105,
        "EngineRPM": 1339.0,
        "OnboardVoltage": 27948,
        "EngineSpeed": null,
        "TotalMileage": 416872825,
        "AcceleratorPedalPosition": 28,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 248,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27187387,
        "Time": "2022-02-23T10:37:57",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2602463,
        "Lon": 86.17277,
        "Speed": 0.0,
        "Height": 233,
        "Mileage": 40983780,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 107,
        "EngineRPM": 1118.75,
        "OnboardVoltage": 27865,
        "EngineSpeed": null,
        "TotalMileage": 416878075,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 249,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27189707,
        "Time": "2022-02-23T10:53:46",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2690849,
        "Lon": 86.17487,
        "Speed": 8.1,
        "Height": 54,
        "Mileage": 40987392,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 105,
        "EngineRPM": 1278.75,
        "OnboardVoltage": 27818,
        "EngineSpeed": null,
        "TotalMileage": 416881585,
        "AcceleratorPedalPosition": 47,
        "LoadPercentage": 62,
        "FuelConsumption": 185,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 249,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27191540,
        "Time": "2022-02-23T11:07:10",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2793427,
        "Lon": 86.1907,
        "Speed": 6.2,
        "Height": 254,
        "Mileage": 40991648,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 107,
        "EngineRPM": 704.625,
        "OnboardVoltage": 27916,
        "EngineSpeed": null,
        "TotalMileage": 416885795,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 51,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 249,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27213425,
        "Time": "2022-02-23T14:14:19",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.27904,
        "Lon": 86.1911545,
        "Speed": 0.0,
        "Height": 258,
        "Mileage": 40991672,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 103,
        "EngineRPM": 1125.25,
        "OnboardVoltage": 27879,
        "EngineSpeed": null,
        "TotalMileage": 416885980,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 252,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27238627,
        "Time": "2022-02-23T17:30:19",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.27904,
        "Lon": 86.1911545,
        "Speed": 0.0,
        "Height": 258,
        "Mileage": 40991672,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 104,
        "EngineRPM": 1148.625,
        "OnboardVoltage": 27928,
        "EngineSpeed": null,
        "TotalMileage": 416885980,
        "AcceleratorPedalPosition": 3,
        "LoadPercentage": 4,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 256,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27258092,
        "Time": "2022-02-23T19:57:35",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2778549,
        "Lon": 86.18974,
        "Speed": 13.3,
        "Height": 258,
        "Mileage": 40991952,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 102,
        "EngineRPM": 876.625,
        "OnboardVoltage": 27860,
        "EngineSpeed": null,
        "TotalMileage": 416886120,
        "AcceleratorPedalPosition": 9,
        "LoadPercentage": 24,
        "FuelConsumption": 67,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 258,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27262648,
        "Time": "2022-02-23T20:30:37",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.28776,
        "Lon": 86.1765,
        "Speed": 29.6,
        "Height": 277,
        "Mileage": 40994072,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 76,
        "EngineRPM": 1803.25,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 416888140,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27264311,
        "Time": "2022-02-23T20:43:02",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30537,
        "Lon": 86.1348648,
        "Speed": 6.8,
        "Height": 128,
        "Mileage": 40999848,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 65,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27719,
        "EngineSpeed": null,
        "TotalMileage": 416894265,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27266461,
        "Time": "2022-02-23T21:00:47",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.31411,
        "Lon": 86.1359558,
        "Speed": 4.8,
        "Height": 223,
        "Mileage": 41002128,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 67,
        "EngineRPM": 1321.75,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 416896715,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27268040,
        "Time": "2022-02-23T21:12:53",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.29968,
        "Lon": 86.14172,
        "Speed": 5.9,
        "Height": 11,
        "Mileage": 41005624,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 67,
        "EngineRPM": 1240.125,
        "OnboardVoltage": 27728,
        "EngineSpeed": null,
        "TotalMileage": 416900355,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 259,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27270946,
        "Time": "2022-02-23T21:34:53",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.31384,
        "Lon": 86.14184,
        "Speed": 14.4,
        "Height": 240,
        "Mileage": 41009144,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 64,
        "EngineRPM": 1783.375,
        "OnboardVoltage": 27846,
        "EngineSpeed": null,
        "TotalMileage": 416904060,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27273611,
        "Time": "2022-02-23T21:53:00",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.31197,
        "Lon": 86.15354,
        "Speed": 32.2,
        "Height": 292,
        "Mileage": 41013612,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 65,
        "EngineRPM": 1303.375,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 416908380,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27276515,
        "Time": "2022-02-23T22:14:23",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.29944,
        "Lon": 86.13792,
        "Speed": 5.3,
        "Height": 20,
        "Mileage": 41017728,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 70,
        "EngineRPM": 980.625,
        "OnboardVoltage": 27825,
        "EngineSpeed": null,
        "TotalMileage": 416912935,
        "AcceleratorPedalPosition": 20,
        "LoadPercentage": 8,
        "FuelConsumption": 62,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 260,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27279518,
        "Time": "2022-02-23T22:34:33",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30855,
        "Lon": 86.1331,
        "Speed": 14.4,
        "Height": 166,
        "Mileage": 41020428,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 1765.125,
        "OnboardVoltage": 27796,
        "EngineSpeed": null,
        "TotalMileage": 416915675,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 261,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27282230,
        "Time": "2022-02-23T22:53:09",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3078766,
        "Lon": 86.17092,
        "Speed": 13.1,
        "Height": 427,
        "Mileage": 41024384,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 79,
        "EngineRPM": 1240.75,
        "OnboardVoltage": 27795,
        "EngineSpeed": null,
        "TotalMileage": 416919770,
        "AcceleratorPedalPosition": 52,
        "LoadPercentage": 68,
        "FuelConsumption": 173,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 261,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27283867,
        "Time": "2022-02-23T23:04:30",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3005676,
        "Lon": 86.14021,
        "Speed": 19.6,
        "Height": 13,
        "Mileage": 41029696,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 81,
        "EngineRPM": 1081.875,
        "OnboardVoltage": 27850,
        "EngineSpeed": null,
        "TotalMileage": 416925410,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 261,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27286085,
        "Time": "2022-02-23T23:18:58",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3035851,
        "Lon": 86.13755,
        "Speed": 17.2,
        "Height": 105,
        "Mileage": 41031828,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 83,
        "EngineRPM": 1818.75,
        "OnboardVoltage": 27824,
        "EngineSpeed": null,
        "TotalMileage": 416927610,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 367,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 261,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27288890,
        "Time": "2022-02-23T23:38:33",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30834,
        "Lon": 86.1732559,
        "Speed": 4.8,
        "Height": 434,
        "Mileage": 41036092,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 90,
        "EngineRPM": 1513.125,
        "OnboardVoltage": 27705,
        "EngineSpeed": null,
        "TotalMileage": 416932530,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 1,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 262,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27290645,
        "Time": "2022-02-23T23:50:35",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30004,
        "Lon": 86.14524,
        "Speed": 22.4,
        "Height": 25,
        "Mileage": 41041328,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 87,
        "EngineRPM": 1023.625,
        "OnboardVoltage": 27743,
        "EngineSpeed": null,
        "TotalMileage": 416937775,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 117,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 262,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27292673,
        "Time": "2022-02-24T00:05:32",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30125,
        "Lon": 86.14162,
        "Speed": 13.1,
        "Height": 10,
        "Mileage": 41042724,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 89,
        "EngineRPM": 1626.75,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 416938995,
        "AcceleratorPedalPosition": 67,
        "LoadPercentage": 51,
        "FuelConsumption": 312,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 262,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27294584,
        "Time": "2022-02-24T00:18:58",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.31552,
        "Lon": 86.13435,
        "Speed": 4.6,
        "Height": 211,
        "Mileage": 41045788,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 706.375,
        "OnboardVoltage": 27773,
        "EngineSpeed": null,
        "TotalMileage": 416942570,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 262,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27298208,
        "Time": "2022-02-24T00:57:39",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3103943,
        "Lon": 86.13287,
        "Speed": 29.2,
        "Height": 188,
        "Mileage": 41048460,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 93,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27794,
        "EngineSpeed": null,
        "TotalMileage": 416944800,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 263,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27300626,
        "Time": "2022-02-24T01:18:51",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3072,
        "Lon": 86.13891,
        "Speed": 4.4,
        "Height": 153,
        "Mileage": 41050968,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 94,
        "EngineRPM": 756.5,
        "OnboardVoltage": 27893,
        "EngineSpeed": null,
        "TotalMileage": 416947595,
        "AcceleratorPedalPosition": 11,
        "LoadPercentage": 44,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 263,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27304026,
        "Time": "2022-02-24T01:42:28",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30699,
        "Lon": 86.17032,
        "Speed": 10.3,
        "Height": 414,
        "Mileage": 41055384,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 96,
        "EngineRPM": 1784.0,
        "OnboardVoltage": 27802,
        "EngineSpeed": null,
        "TotalMileage": 416951775,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 264,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27305860,
        "Time": "2022-02-24T01:55:30",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30355,
        "Lon": 86.13628,
        "Speed": 38.3,
        "Height": 111,
        "Mileage": 41060308,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 96,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 416956305,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 264,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27309198,
        "Time": "2022-02-24T02:15:29",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3016434,
        "Lon": 86.14215,
        "Speed": 12.4,
        "Height": 14,
        "Mileage": 41062852,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 96,
        "EngineRPM": 744.25,
        "OnboardVoltage": 27818,
        "EngineSpeed": null,
        "TotalMileage": 416958845,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 7,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 264,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27312182,
        "Time": "2022-02-24T02:36:58",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3073921,
        "Lon": 86.17102,
        "Speed": 11.4,
        "Height": 423,
        "Mileage": 41068060,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 98,
        "EngineRPM": 1776.125,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 416964560,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 390,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 265,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27313996,
        "Time": "2022-02-24T02:49:56",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30391,
        "Lon": 86.13552,
        "Speed": 37.5,
        "Height": 121,
        "Mileage": 41072632,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 99,
        "EngineRPM": 1303.5,
        "OnboardVoltage": 27745,
        "EngineSpeed": null,
        "TotalMileage": 416968845,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 265,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27316035,
        "Time": "2022-02-24T03:03:34",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.300396,
        "Lon": 86.1405945,
        "Speed": 9.0,
        "Height": 14,
        "Mileage": 41075056,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 96,
        "EngineRPM": 791.75,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 416971375,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 29,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 265,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27318922,
        "Time": "2022-02-24T03:23:50",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.30668,
        "Lon": 86.16369,
        "Speed": 13.5,
        "Height": 391,
        "Mileage": 41079916,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 101,
        "EngineRPM": 1784.0,
        "OnboardVoltage": 27749,
        "EngineSpeed": null,
        "TotalMileage": 416976720,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 266,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27320835,
        "Time": "2022-02-24T03:37:08",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.3042336,
        "Lon": 86.1353455,
        "Speed": 33.3,
        "Height": 129,
        "Mileage": 41085052,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 99,
        "EngineRPM": 1300.0,
        "OnboardVoltage": 27738,
        "EngineSpeed": null,
        "TotalMileage": 416981360,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 266,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27323686,
        "Time": "2022-02-24T03:53:56",
        "TruckId": 1026,
        "Imei": "868328058792827",
        "Lat": 54.2995224,
        "Lon": 86.13731,
        "Speed": 4.6,
        "Height": 7,
        "Mileage": 41087128,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 101,
        "EngineRPM": 1237.125,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 416983810,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 266,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27004154,
        "Time": "2022-02-22T10:53:37",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2742577,
        "Lon": 86.17758,
        "Speed": 24.0,
        "Height": 105,
        "Mileage": 55562236,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 83,
        "EngineRPM": 1001.75,
        "OnboardVoltage": 27825,
        "EngineSpeed": null,
        "TotalMileage": 57803145,
        "AcceleratorPedalPosition": 31,
        "LoadPercentage": 72,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3424,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27007048,
        "Time": "2022-02-22T11:14:23",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3080635,
        "Lon": 86.1713257,
        "Speed": 14.2,
        "Height": 425,
        "Mileage": 55568852,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27811,
        "EngineSpeed": null,
        "TotalMileage": 57810145,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 383,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3424,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27008947,
        "Time": "2022-02-22T11:28:59",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.27297,
        "Lon": 86.17801,
        "Speed": 25.3,
        "Height": 100,
        "Mileage": 55575952,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 86,
        "EngineRPM": 1484.375,
        "OnboardVoltage": 27780,
        "EngineSpeed": null,
        "TotalMileage": 57816845,
        "AcceleratorPedalPosition": 52,
        "LoadPercentage": 6,
        "FuelConsumption": 170,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3425,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27012604,
        "Time": "2022-02-22T11:57:28",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.276123,
        "Lon": 86.1842957,
        "Speed": 10.3,
        "Height": 260,
        "Mileage": 55578920,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 93,
        "EngineRPM": 1455.375,
        "OnboardVoltage": 27831,
        "EngineSpeed": null,
        "TotalMileage": 57820355,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3425,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27015121,
        "Time": "2022-02-22T12:20:10",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3029747,
        "Lon": 86.1703644,
        "Speed": 30.9,
        "Height": 392,
        "Mileage": 55583968,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 94,
        "EngineRPM": 1316.0,
        "OnboardVoltage": 27760,
        "EngineSpeed": null,
        "TotalMileage": 57825315,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3425,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27017447,
        "Time": "2022-02-22T12:41:31",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.274025,
        "Lon": 86.17783,
        "Speed": 36.6,
        "Height": 102,
        "Mileage": 55590216,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 91,
        "EngineRPM": 1639.125,
        "OnboardVoltage": 27740,
        "EngineSpeed": null,
        "TotalMileage": 57831205,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 63,
        "FuelConsumption": 226,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3426,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27018577,
        "Time": "2022-02-22T12:53:53",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2599564,
        "Lon": 86.15691,
        "Speed": 41.1,
        "Height": 305,
        "Mileage": 55596476,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 96,
        "EngineRPM": 1625.625,
        "OnboardVoltage": 27715,
        "EngineSpeed": null,
        "TotalMileage": 57837060,
        "AcceleratorPedalPosition": 74,
        "LoadPercentage": 37,
        "FuelConsumption": 150,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3426,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27021627,
        "Time": "2022-02-22T13:20:32",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2415237,
        "Lon": 86.14356,
        "Speed": 25.9,
        "Height": 322,
        "Mileage": 55604572,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 96,
        "EngineRPM": 1316.5,
        "OnboardVoltage": 27691,
        "EngineSpeed": null,
        "TotalMileage": 57845340,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3426,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27025049,
        "Time": "2022-02-22T13:51:56",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.28058,
        "Lon": 86.14498,
        "Speed": 8.5,
        "Height": 215,
        "Mileage": 55610568,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 1124.375,
        "OnboardVoltage": 27762,
        "EngineSpeed": null,
        "TotalMileage": 57851005,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3427,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27028962,
        "Time": "2022-02-22T14:18:26",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2425728,
        "Lon": 86.1415253,
        "Speed": 9.8,
        "Height": 323,
        "Mileage": 55616104,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 98,
        "EngineRPM": 886.75,
        "OnboardVoltage": 27670,
        "EngineSpeed": null,
        "TotalMileage": 57856665,
        "AcceleratorPedalPosition": 5,
        "LoadPercentage": 3,
        "FuelConsumption": 74,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3427,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27036190,
        "Time": "2022-02-22T15:13:00",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.28039,
        "Lon": 86.14537,
        "Speed": 0.0,
        "Height": 218,
        "Mileage": 55621564,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 1125.625,
        "OnboardVoltage": 27887,
        "EngineSpeed": null,
        "TotalMileage": 57862005,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3428,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27041754,
        "Time": "2022-02-22T15:55:50",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.24118,
        "Lon": 86.14499,
        "Speed": 17.9,
        "Height": 322,
        "Mileage": 55627000,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 101,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27700,
        "EngineSpeed": null,
        "TotalMileage": 57867235,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3429,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27045228,
        "Time": "2022-02-22T16:22:24",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.28129,
        "Lon": 86.1443253,
        "Speed": 8.7,
        "Height": 234,
        "Mileage": 55633000,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 101,
        "EngineRPM": 674.5,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 57872910,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3429,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27048384,
        "Time": "2022-02-22T16:43:26",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.24211,
        "Lon": 86.14174,
        "Speed": 5.1,
        "Height": 329,
        "Mileage": 55638544,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 102,
        "EngineRPM": 1751.125,
        "OnboardVoltage": 27843,
        "EngineSpeed": null,
        "TotalMileage": 57878475,
        "AcceleratorPedalPosition": 95,
        "LoadPercentage": 16,
        "FuelConsumption": 104,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3430,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27050370,
        "Time": "2022-02-22T17:03:57",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.25601,
        "Lon": 86.17229,
        "Speed": 14.6,
        "Height": 284,
        "Mileage": 55642152,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 101,
        "EngineRPM": 1127.375,
        "OnboardVoltage": 27673,
        "EngineSpeed": null,
        "TotalMileage": 57881755,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3430,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27053714,
        "Time": "2022-02-22T17:32:41",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.25323,
        "Lon": 86.1610641,
        "Speed": 18.5,
        "Height": 309,
        "Mileage": 55649908,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 78,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27693,
        "EngineSpeed": null,
        "TotalMileage": 57888975,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3431,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27055809,
        "Time": "2022-02-22T17:52:36",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.280365,
        "Lon": 86.14573,
        "Speed": 0.0,
        "Height": 225,
        "Mileage": 55657100,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 764.75,
        "OnboardVoltage": 27712,
        "EngineSpeed": null,
        "TotalMileage": 57896145,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3431,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.6
    },
    {
        "Id": 27063690,
        "Time": "2022-02-22T18:48:21",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.24444,
        "Lon": 86.151825,
        "Speed": 36.4,
        "Height": 329,
        "Mileage": 55661900,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 77,
        "EngineRPM": 1797.5,
        "OnboardVoltage": 27685,
        "EngineSpeed": null,
        "TotalMileage": 57900750,
        "AcceleratorPedalPosition": 88,
        "LoadPercentage": 74,
        "FuelConsumption": 351,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3432,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.200005
    },
    {
        "Id": 27065316,
        "Time": "2022-02-22T19:09:07",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2809639,
        "Lon": 86.1446,
        "Speed": 0.0,
        "Height": 222,
        "Mileage": 55668532,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 82,
        "EngineRPM": 739.25,
        "OnboardVoltage": 27866,
        "EngineSpeed": null,
        "TotalMileage": 57907225,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3432,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27069190,
        "Time": "2022-02-22T19:35:33",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.24249,
        "Lon": 86.14206,
        "Speed": 13.1,
        "Height": 325,
        "Mileage": 55674284,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 87,
        "EngineRPM": 817.75,
        "OnboardVoltage": 27710,
        "EngineSpeed": null,
        "TotalMileage": 57912825,
        "AcceleratorPedalPosition": 14,
        "LoadPercentage": 41,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3433,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27073431,
        "Time": "2022-02-22T20:08:18",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2762337,
        "Lon": 86.1516647,
        "Speed": 25.0,
        "Height": 228,
        "Mileage": 55680884,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1277.875,
        "OnboardVoltage": 27719,
        "EngineSpeed": null,
        "TotalMileage": 57918715,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3433,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27075841,
        "Time": "2022-02-22T20:24:18",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.24779,
        "Lon": 86.15546,
        "Speed": 37.2,
        "Height": 326,
        "Mileage": 55687040,
        "EngineOilPressure": 276,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 92,
        "EngineRPM": 973.5,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 57924670,
        "AcceleratorPedalPosition": 52,
        "LoadPercentage": 7,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3434,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.4
    },
    {
        "Id": 27079193,
        "Time": "2022-02-22T20:48:26",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.27665,
        "Lon": 86.15282,
        "Speed": 16.8,
        "Height": 208,
        "Mileage": 55693044,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 93,
        "EngineRPM": 1323.625,
        "OnboardVoltage": 27668,
        "EngineSpeed": null,
        "TotalMileage": 57930745,
        "AcceleratorPedalPosition": 43,
        "LoadPercentage": 51,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3434,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27083066,
        "Time": "2022-02-22T21:16:17",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2424431,
        "Lon": 86.14159,
        "Speed": 11.8,
        "Height": 330,
        "Mileage": 55699280,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 93,
        "EngineRPM": 1663.0,
        "OnboardVoltage": 27713,
        "EngineSpeed": null,
        "TotalMileage": 57936945,
        "AcceleratorPedalPosition": 82,
        "LoadPercentage": 69,
        "FuelConsumption": 264,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3434,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27084595,
        "Time": "2022-02-22T21:29:52",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2809677,
        "Lon": 86.14457,
        "Speed": 0.0,
        "Height": 232,
        "Mileage": 55705116,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 95,
        "EngineRPM": 759.625,
        "OnboardVoltage": 27756,
        "EngineSpeed": null,
        "TotalMileage": 57942640,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3435,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27088796,
        "Time": "2022-02-22T21:55:20",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.24125,
        "Lon": 86.1456146,
        "Speed": 18.1,
        "Height": 325,
        "Mileage": 55710860,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 96,
        "EngineRPM": 776.625,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 57948005,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 25,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3435,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27091416,
        "Time": "2022-02-22T22:18:41",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.25782,
        "Lon": 86.1582,
        "Speed": 40.0,
        "Height": 301,
        "Mileage": 55719424,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 96,
        "EngineRPM": 1606.125,
        "OnboardVoltage": 27698,
        "EngineSpeed": null,
        "TotalMileage": 57955635,
        "AcceleratorPedalPosition": 62,
        "LoadPercentage": 19,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3435,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27092919,
        "Time": "2022-02-22T22:31:38",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.256012,
        "Lon": 86.17281,
        "Speed": 5.9,
        "Height": 277,
        "Mileage": 55724928,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 97,
        "EngineRPM": 1320.625,
        "OnboardVoltage": 27675,
        "EngineSpeed": null,
        "TotalMileage": 57961155,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3436,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27109683,
        "Time": "2022-02-23T00:51:27",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.25626,
        "Lon": 86.17205,
        "Speed": 6.1,
        "Height": 282,
        "Mileage": 55725064,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 93,
        "EngineRPM": 661.625,
        "OnboardVoltage": 27657,
        "EngineSpeed": null,
        "TotalMileage": 57961460,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3329,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27110919,
        "Time": "2022-02-23T01:00:38",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2700653,
        "Lon": 86.1796646,
        "Speed": 21.2,
        "Height": 75,
        "Mileage": 55729748,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 89,
        "EngineRPM": 1495.5,
        "OnboardVoltage": 27630,
        "EngineSpeed": null,
        "TotalMileage": 57965660,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 61,
        "FuelConsumption": 236,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3329,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27115626,
        "Time": "2022-02-23T01:40:36",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.29348,
        "Lon": 86.15875,
        "Speed": 0.0,
        "Height": 144,
        "Mileage": 55735920,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 96,
        "EngineRPM": 1127.625,
        "OnboardVoltage": 27855,
        "EngineSpeed": null,
        "TotalMileage": 57971650,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3329,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27121284,
        "Time": "2022-02-23T02:20:41",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2923851,
        "Lon": 86.17408,
        "Speed": 33.1,
        "Height": 297,
        "Mileage": 55738832,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 97,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27733,
        "EngineSpeed": null,
        "TotalMileage": 57974320,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3330,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27123187,
        "Time": "2022-02-23T02:35:25",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3104,
        "Lon": 86.13291,
        "Speed": 36.8,
        "Height": 185,
        "Mileage": 55744268,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 100,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27773,
        "EngineSpeed": null,
        "TotalMileage": 57979635,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3330,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27125117,
        "Time": "2022-02-23T02:48:02",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.313736,
        "Lon": 86.14538,
        "Speed": 17.7,
        "Height": 253,
        "Mileage": 55747208,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 97,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27824,
        "EngineSpeed": null,
        "TotalMileage": 57982920,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3331,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27127071,
        "Time": "2022-02-23T03:02:52",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3110237,
        "Lon": 86.15362,
        "Speed": 36.8,
        "Height": 306,
        "Mileage": 55751404,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 101,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27812,
        "EngineSpeed": null,
        "TotalMileage": 57986740,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3331,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27128514,
        "Time": "2022-02-23T03:11:46",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3005753,
        "Lon": 86.14086,
        "Speed": 15.7,
        "Height": 11,
        "Mileage": 55755912,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 97,
        "EngineRPM": 1319.25,
        "OnboardVoltage": 27843,
        "EngineSpeed": null,
        "TotalMileage": 57991115,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 46,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3331,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27132361,
        "Time": "2022-02-23T03:39:51",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3100929,
        "Lon": 86.13259,
        "Speed": 15.0,
        "Height": 178,
        "Mileage": 55758708,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 100,
        "EngineRPM": 1810.125,
        "OnboardVoltage": 27774,
        "EngineSpeed": null,
        "TotalMileage": 57993975,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 389,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3331,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27135017,
        "Time": "2022-02-23T03:58:38",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3100967,
        "Lon": 86.15542,
        "Speed": 40.7,
        "Height": 317,
        "Mileage": 55763744,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 102,
        "EngineRPM": 1309.625,
        "OnboardVoltage": 27811,
        "EngineSpeed": null,
        "TotalMileage": 57998660,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3332,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27136647,
        "Time": "2022-02-23T04:08:39",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3004532,
        "Lon": 86.1387,
        "Speed": 6.4,
        "Height": 3,
        "Mileage": 55768320,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 100,
        "EngineRPM": 903.75,
        "OnboardVoltage": 27786,
        "EngineSpeed": null,
        "TotalMileage": 58003325,
        "AcceleratorPedalPosition": 18,
        "LoadPercentage": 0,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3332,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27139943,
        "Time": "2022-02-23T04:28:20",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3128,
        "Lon": 86.1462,
        "Speed": 4.4,
        "Height": 259,
        "Mileage": 55772256,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 106,
        "EngineRPM": 822.0,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 58007310,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3332,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27141889,
        "Time": "2022-02-23T04:42:22",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3069763,
        "Lon": 86.16929,
        "Speed": 33.1,
        "Height": 405,
        "Mileage": 55775316,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 105,
        "EngineRPM": 1014.625,
        "OnboardVoltage": 27809,
        "EngineSpeed": null,
        "TotalMileage": 58010010,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3332,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27143815,
        "Time": "2022-02-23T04:55:45",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30032,
        "Lon": 86.1401,
        "Speed": 0.0,
        "Height": 6,
        "Mileage": 55780548,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 103,
        "EngineRPM": 791.375,
        "OnboardVoltage": 27859,
        "EngineSpeed": null,
        "TotalMileage": 58015375,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 9,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3333,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27148770,
        "Time": "2022-02-23T05:44:31",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3060875,
        "Lon": 86.1347351,
        "Speed": 12.7,
        "Height": 147,
        "Mileage": 55782824,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 102,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27823,
        "EngineSpeed": null,
        "TotalMileage": 58017590,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 376,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3334,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27151115,
        "Time": "2022-02-23T06:02:20",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30895,
        "Lon": 86.1724243,
        "Speed": 15.9,
        "Height": 436,
        "Mileage": 55786848,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 107,
        "EngineRPM": 791.5,
        "OnboardVoltage": 27827,
        "EngineSpeed": null,
        "TotalMileage": 58021925,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3334,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27152597,
        "Time": "2022-02-23T06:12:23",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30132,
        "Lon": 86.14156,
        "Speed": 24.0,
        "Height": 12,
        "Mileage": 55792520,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 107,
        "EngineRPM": 1300.25,
        "OnboardVoltage": 27804,
        "EngineSpeed": null,
        "TotalMileage": 58027015,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3334,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27154979,
        "Time": "2022-02-23T06:30:47",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30876,
        "Lon": 86.13278,
        "Speed": 13.8,
        "Height": 165,
        "Mileage": 55795260,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 105,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27831,
        "EngineSpeed": null,
        "TotalMileage": 58030005,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3334,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 42.4
    },
    {
        "Id": 27157455,
        "Time": "2022-02-23T06:49:25",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30697,
        "Lon": 86.16533,
        "Speed": 34.8,
        "Height": 387,
        "Mileage": 55799644,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 107,
        "EngineRPM": 1318.625,
        "OnboardVoltage": 27831,
        "EngineSpeed": null,
        "TotalMileage": 58034105,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3335,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.0
    },
    {
        "Id": 27160990,
        "Time": "2022-02-23T07:13:24",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3043556,
        "Lon": 86.14363,
        "Speed": 29.8,
        "Height": 73,
        "Mileage": 55804200,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 78,
        "EngineRPM": 1297.375,
        "OnboardVoltage": 27761,
        "EngineSpeed": null,
        "TotalMileage": 58037755,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3335,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27164141,
        "Time": "2022-02-23T07:36:28",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3045044,
        "Lon": 86.1437454,
        "Speed": 15.9,
        "Height": 81,
        "Mileage": 55806640,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 74,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27817,
        "EngineSpeed": null,
        "TotalMileage": 58040850,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 91,
        "FuelConsumption": 377,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3335,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.8
    },
    {
        "Id": 27167097,
        "Time": "2022-02-23T07:56:29",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30907,
        "Lon": 86.1732559,
        "Speed": 6.4,
        "Height": 430,
        "Mileage": 55811512,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 72,
        "EngineRPM": 1086.125,
        "OnboardVoltage": 27865,
        "EngineSpeed": null,
        "TotalMileage": 58045905,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3336,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27170118,
        "Time": "2022-02-23T08:07:21",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3075447,
        "Lon": 86.13762,
        "Speed": 10.1,
        "Height": 165,
        "Mileage": 55815808,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 72,
        "EngineRPM": 1124.75,
        "OnboardVoltage": 27815,
        "EngineSpeed": null,
        "TotalMileage": 58050150,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3336,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27171074,
        "Time": "2022-02-23T08:28:58",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30994,
        "Lon": 86.15767,
        "Speed": 11.4,
        "Height": 334,
        "Mileage": 55819096,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 73,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27847,
        "EngineSpeed": null,
        "TotalMileage": 58053485,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3336,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27172672,
        "Time": "2022-02-23T08:42:00",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3103561,
        "Lon": 86.1328354,
        "Speed": 34.0,
        "Height": 186,
        "Mileage": 55823924,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 75,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27761,
        "EngineSpeed": null,
        "TotalMileage": 58057855,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3336,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27174528,
        "Time": "2022-02-23T08:56:18",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.310688,
        "Lon": 86.13664,
        "Speed": 13.5,
        "Height": 199,
        "Mileage": 55826284,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 58060325,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 377,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3337,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27176545,
        "Time": "2022-02-23T09:14:16",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30736,
        "Lon": 86.138504,
        "Speed": 4.0,
        "Height": 155,
        "Mileage": 55829008,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 86,
        "EngineRPM": 667.375,
        "OnboardVoltage": 27784,
        "EngineSpeed": null,
        "TotalMileage": 58063050,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 22,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3337,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27178283,
        "Time": "2022-02-23T09:28:21",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3059578,
        "Lon": 86.13477,
        "Speed": 14.4,
        "Height": 143,
        "Mileage": 55832420,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 86,
        "EngineRPM": 1297.125,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 58066140,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3337,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27180250,
        "Time": "2022-02-23T09:42:56",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3132362,
        "Lon": 86.13633,
        "Speed": 25.5,
        "Height": 219,
        "Mileage": 55834616,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 86,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 58068460,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3338,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27182234,
        "Time": "2022-02-23T09:55:41",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3079453,
        "Lon": 86.13612,
        "Speed": 20.5,
        "Height": 149,
        "Mileage": 55837164,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 90,
        "EngineRPM": 1376.625,
        "OnboardVoltage": 27827,
        "EngineSpeed": null,
        "TotalMileage": 58070860,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 167,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3338,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27184164,
        "Time": "2022-02-23T10:11:35",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3062439,
        "Lon": 86.1355743,
        "Speed": 15.7,
        "Height": 139,
        "Mileage": 55840452,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 92,
        "EngineRPM": 1311.5,
        "OnboardVoltage": 27831,
        "EngineSpeed": null,
        "TotalMileage": 58074035,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3338,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27186336,
        "Time": "2022-02-23T10:28:20",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3159027,
        "Lon": 86.13393,
        "Speed": 4.0,
        "Height": 216,
        "Mileage": 55842860,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 93,
        "EngineRPM": 1269.0,
        "OnboardVoltage": 27799,
        "EngineSpeed": null,
        "TotalMileage": 58076830,
        "AcceleratorPedalPosition": 2,
        "LoadPercentage": 0,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3338,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27187991,
        "Time": "2022-02-23T10:41:56",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3067131,
        "Lon": 86.13539,
        "Speed": 22.0,
        "Height": 142,
        "Mileage": 55845208,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 95,
        "EngineRPM": 1292.75,
        "OnboardVoltage": 27806,
        "EngineSpeed": null,
        "TotalMileage": 58078945,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3338,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27190196,
        "Time": "2022-02-23T10:57:19",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3073235,
        "Lon": 86.1380539,
        "Speed": 13.3,
        "Height": 161,
        "Mileage": 55848640,
        "EngineOilPressure": 208,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 769.0,
        "OnboardVoltage": 27767,
        "EngineSpeed": null,
        "TotalMileage": 58082420,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 62,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3339,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27192164,
        "Time": "2022-02-23T11:12:07",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.31091,
        "Lon": 86.1368942,
        "Speed": 29.6,
        "Height": 209,
        "Mileage": 55851220,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 94,
        "EngineRPM": 1113.25,
        "OnboardVoltage": 27777,
        "EngineSpeed": null,
        "TotalMileage": 58084950,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 57,
        "FuelConsumption": 199,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3339,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.4
    },
    {
        "Id": 27193700,
        "Time": "2022-02-23T11:24:03",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3110466,
        "Lon": 86.13732,
        "Speed": 15.9,
        "Height": 205,
        "Mileage": 55853912,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27762,
        "EngineSpeed": null,
        "TotalMileage": 58087625,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 387,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3339,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27195692,
        "Time": "2022-02-23T11:38:28",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3079,
        "Lon": 86.13655,
        "Speed": 18.3,
        "Height": 147,
        "Mileage": 55856576,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 767.75,
        "OnboardVoltage": 27800,
        "EngineSpeed": null,
        "TotalMileage": 58090375,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 12,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3339,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27197122,
        "Time": "2022-02-23T11:50:00",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3078728,
        "Lon": 86.1357651,
        "Speed": 17.7,
        "Height": 143,
        "Mileage": 55860000,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 97,
        "EngineRPM": 1363.75,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 58093865,
        "AcceleratorPedalPosition": 44,
        "LoadPercentage": 23,
        "FuelConsumption": 82,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3340,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27199201,
        "Time": "2022-02-23T12:08:24",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30985,
        "Lon": 86.1553955,
        "Speed": 12.7,
        "Height": 316,
        "Mileage": 55863124,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 100,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 58097350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3340,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27201979,
        "Time": "2022-02-23T12:38:01",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.28274,
        "Lon": 86.17831,
        "Speed": 4.6,
        "Height": 265,
        "Mileage": 55868268,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 727.625,
        "OnboardVoltage": 27651,
        "EngineSpeed": null,
        "TotalMileage": 58102285,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3340,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27209192,
        "Time": "2022-02-23T13:42:29",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2741051,
        "Lon": 86.1777954,
        "Speed": 26.1,
        "Height": 99,
        "Mileage": 55872244,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 1419.5,
        "OnboardVoltage": 27648,
        "EngineSpeed": null,
        "TotalMileage": 58106005,
        "AcceleratorPedalPosition": 46,
        "LoadPercentage": 13,
        "FuelConsumption": 188,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3342,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27211991,
        "Time": "2022-02-23T14:04:24",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3085022,
        "Lon": 86.17332,
        "Speed": 10.1,
        "Height": 428,
        "Mileage": 55878972,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 1108.125,
        "OnboardVoltage": 27686,
        "EngineSpeed": null,
        "TotalMileage": 58113175,
        "AcceleratorPedalPosition": 69,
        "LoadPercentage": 90,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3342,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27214195,
        "Time": "2022-02-23T14:19:35",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2723846,
        "Lon": 86.17775,
        "Speed": 12.4,
        "Height": 98,
        "Mileage": 55886000,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 790.75,
        "OnboardVoltage": 27766,
        "EngineSpeed": null,
        "TotalMileage": 58120000,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3342,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27218621,
        "Time": "2022-02-23T14:54:13",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2973862,
        "Lon": 86.17511,
        "Speed": 22.9,
        "Height": 342,
        "Mileage": 55891560,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 1806.75,
        "OnboardVoltage": 27725,
        "EngineSpeed": null,
        "TotalMileage": 58125805,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 393,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3343,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27220973,
        "Time": "2022-02-23T15:13:25",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2695,
        "Lon": 86.18341,
        "Speed": 30.3,
        "Height": 174,
        "Mileage": 55898592,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 99,
        "EngineRPM": 1300.25,
        "OnboardVoltage": 27665,
        "EngineSpeed": null,
        "TotalMileage": 58132890,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3343,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27225194,
        "Time": "2022-02-23T15:43:11",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2675934,
        "Lon": 86.18711,
        "Speed": 25.1,
        "Height": 206,
        "Mileage": 55901780,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27659,
        "EngineSpeed": null,
        "TotalMileage": 58136295,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 89,
        "FuelConsumption": 365,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3344,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27228072,
        "Time": "2022-02-23T16:03:13",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.29825,
        "Lon": 86.1748,
        "Speed": 33.7,
        "Height": 350,
        "Mileage": 55908268,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 1303.75,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 58142910,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3344,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.4
    },
    {
        "Id": 27230144,
        "Time": "2022-02-23T16:18:59",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2724953,
        "Lon": 86.17754,
        "Speed": 8.5,
        "Height": 102,
        "Mileage": 55914008,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 97,
        "EngineRPM": 983.75,
        "OnboardVoltage": 27769,
        "EngineSpeed": null,
        "TotalMileage": 58148650,
        "AcceleratorPedalPosition": 8,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3344,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.2
    },
    {
        "Id": 27236641,
        "Time": "2022-02-23T17:10:07",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2868729,
        "Lon": 86.17654,
        "Speed": 19.0,
        "Height": 278,
        "Mileage": 55918380,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 1810.375,
        "OnboardVoltage": 27681,
        "EngineSpeed": null,
        "TotalMileage": 58153350,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3345,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27238325,
        "Time": "2022-02-23T17:27:58",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2796555,
        "Lon": 86.1827545,
        "Speed": 41.2,
        "Height": 264,
        "Mileage": 55924912,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 99,
        "EngineRPM": 842.125,
        "OnboardVoltage": 27686,
        "EngineSpeed": null,
        "TotalMileage": 58159610,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3345,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27243262,
        "Time": "2022-02-23T18:06:33",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.27408,
        "Lon": 86.1792145,
        "Speed": 14.2,
        "Height": 114,
        "Mileage": 55928888,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27673,
        "EngineSpeed": null,
        "TotalMileage": 58163685,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3346,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27245982,
        "Time": "2022-02-23T18:28:46",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.30896,
        "Lon": 86.17241,
        "Speed": 14.0,
        "Height": 432,
        "Mileage": 55935148,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 102,
        "EngineRPM": 750.875,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 58170490,
        "AcceleratorPedalPosition": 8,
        "LoadPercentage": 0,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3346,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.4
    },
    {
        "Id": 27248308,
        "Time": "2022-02-23T18:46:35",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2722244,
        "Lon": 86.1772842,
        "Speed": 0.0,
        "Height": 103,
        "Mileage": 55941860,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 99,
        "EngineRPM": 780.125,
        "OnboardVoltage": 27873,
        "EngineSpeed": null,
        "TotalMileage": 58177315,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3347,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.4
    },
    {
        "Id": 27252644,
        "Time": "2022-02-23T19:17:53",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3035049,
        "Lon": 86.17033,
        "Speed": 17.5,
        "Height": 391,
        "Mileage": 55948168,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 103,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27681,
        "EngineSpeed": null,
        "TotalMileage": 58183725,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3347,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 35.600002
    },
    {
        "Id": 27254750,
        "Time": "2022-02-23T19:33:56",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2694969,
        "Lon": 86.1833954,
        "Speed": 33.5,
        "Height": 171,
        "Mileage": 55954672,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 100,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 58189950,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3347,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.4
    },
    {
        "Id": 27259687,
        "Time": "2022-02-23T20:09:55",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2820549,
        "Lon": 86.1793442,
        "Speed": 34.8,
        "Height": 265,
        "Mileage": 55959484,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 102,
        "EngineRPM": 1255.125,
        "OnboardVoltage": 27653,
        "EngineSpeed": null,
        "TotalMileage": 58194990,
        "AcceleratorPedalPosition": 36,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3348,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.8
    },
    {
        "Id": 27262213,
        "Time": "2022-02-23T20:27:57",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2903252,
        "Lon": 86.1743851,
        "Speed": 35.1,
        "Height": 301,
        "Mileage": 55965272,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 104,
        "EngineRPM": 1300.25,
        "OnboardVoltage": 27639,
        "EngineSpeed": null,
        "TotalMileage": 58200800,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3348,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.800001
    },
    {
        "Id": 27265580,
        "Time": "2022-02-23T20:53:49",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2754822,
        "Lon": 86.17628,
        "Speed": 22.7,
        "Height": 98,
        "Mileage": 55970172,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1298.25,
        "OnboardVoltage": 27703,
        "EngineSpeed": null,
        "TotalMileage": 58205560,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3349,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.4
    },
    {
        "Id": 27269535,
        "Time": "2022-02-23T21:24:35",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2855644,
        "Lon": 86.1734543,
        "Speed": 21.4,
        "Height": 260,
        "Mileage": 55974784,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 70,
        "EngineRPM": 1287.75,
        "OnboardVoltage": 27707,
        "EngineSpeed": null,
        "TotalMileage": 58210325,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3349,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27271893,
        "Time": "2022-02-23T21:41:44",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2863159,
        "Lon": 86.17529,
        "Speed": 34.0,
        "Height": 274,
        "Mileage": 55980580,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 75,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 58216050,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3349,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27276589,
        "Time": "2022-02-23T22:14:50",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.27582,
        "Lon": 86.17641,
        "Speed": 12.9,
        "Height": 100,
        "Mileage": 55985404,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 75,
        "EngineRPM": 1037.5,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 58220840,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3350,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27279690,
        "Time": "2022-02-23T22:35:44",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3084335,
        "Lon": 86.1733246,
        "Speed": 9.4,
        "Height": 426,
        "Mileage": 55992012,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 77,
        "EngineRPM": 1306.375,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 58227725,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 187,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3350,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27281977,
        "Time": "2022-02-23T22:51:31",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2758636,
        "Lon": 86.1762848,
        "Speed": 22.0,
        "Height": 96,
        "Mileage": 55998340,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 80,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27656,
        "EngineSpeed": null,
        "TotalMileage": 58234140,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3351,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27288979,
        "Time": "2022-02-23T23:39:32",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2833176,
        "Lon": 86.17777,
        "Speed": 33.7,
        "Height": 273,
        "Mileage": 56002708,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 88,
        "EngineRPM": 1652.5,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 58238360,
        "AcceleratorPedalPosition": 79,
        "LoadPercentage": 47,
        "FuelConsumption": 162,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3351,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.8
    },
    {
        "Id": 27291140,
        "Time": "2022-02-23T23:54:03",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.29906,
        "Lon": 86.17462,
        "Speed": 35.3,
        "Height": 354,
        "Mileage": 56007432,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 90,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27648,
        "EngineSpeed": null,
        "TotalMileage": 58243290,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3352,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27294749,
        "Time": "2022-02-24T00:20:12",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2724876,
        "Lon": 86.1775742,
        "Speed": 23.1,
        "Height": 103,
        "Mileage": 56013536,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 92,
        "EngineRPM": 719.875,
        "OnboardVoltage": 27674,
        "EngineSpeed": null,
        "TotalMileage": 58249105,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 35,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3352,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27297456,
        "Time": "2022-02-24T00:50:17",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.3065872,
        "Lon": 86.16999,
        "Speed": 18.5,
        "Height": 403,
        "Mileage": 56020052,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 93,
        "EngineRPM": 1594.625,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 58255905,
        "AcceleratorPedalPosition": 84,
        "LoadPercentage": 70,
        "FuelConsumption": 364,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3353,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27299985,
        "Time": "2022-02-24T01:13:40",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2666855,
        "Lon": 86.1866,
        "Speed": 27.4,
        "Height": 200,
        "Mileage": 56025944,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 92,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27704,
        "EngineSpeed": null,
        "TotalMileage": 58261370,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3353,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27302306,
        "Time": "2022-02-24T01:30:46",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.26067,
        "Lon": 86.1741943,
        "Speed": 27.4,
        "Height": 206,
        "Mileage": 56031392,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 92,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 58266675,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 363,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3353,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27306265,
        "Time": "2022-02-24T01:58:07",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.26834,
        "Lon": 86.15483,
        "Speed": 21.2,
        "Height": 277,
        "Mileage": 56038296,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 96,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27766,
        "EngineSpeed": null,
        "TotalMileage": 58273325,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 92,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3354,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27308488,
        "Time": "2022-02-24T02:08:52",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2419167,
        "Lon": 86.1461,
        "Speed": 25.9,
        "Height": 329,
        "Mileage": 56042540,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 97,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27821,
        "EngineSpeed": null,
        "TotalMileage": 58277440,
        "AcceleratorPedalPosition": 36,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3354,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27310782,
        "Time": "2022-02-24T02:27:01",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.27488,
        "Lon": 86.15223,
        "Speed": 4.6,
        "Height": 241,
        "Mileage": 56048668,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 99,
        "EngineRPM": 1366.0,
        "OnboardVoltage": 27818,
        "EngineSpeed": null,
        "TotalMileage": 58283405,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3354,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27313855,
        "Time": "2022-02-24T02:45:59",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2430458,
        "Lon": 86.14849,
        "Speed": 36.1,
        "Height": 334,
        "Mileage": 56054696,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 97,
        "EngineRPM": 1077.25,
        "OnboardVoltage": 27750,
        "EngineSpeed": null,
        "TotalMileage": 58289105,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3355,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27315464,
        "Time": "2022-02-24T03:00:07",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.2803421,
        "Lon": 86.1428452,
        "Speed": 20.7,
        "Height": 260,
        "Mileage": 56061004,
        "EngineOilPressure": 304,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 726.375,
        "OnboardVoltage": 27750,
        "EngineSpeed": null,
        "TotalMileage": 58295250,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 56,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3355,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27319282,
        "Time": "2022-02-24T03:26:42",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.25792,
        "Lon": 86.14101,
        "Speed": 25.9,
        "Height": 385,
        "Mileage": 56065480,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27625,
        "EngineSpeed": null,
        "TotalMileage": 58299995,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 378,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3355,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27323132,
        "Time": "2022-02-24T03:51:34",
        "TruckId": 1803,
        "Imei": "868328058793767",
        "Lat": 54.26886,
        "Lon": 86.15385,
        "Speed": 18.3,
        "Height": 275,
        "Mileage": 56070812,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 98,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27656,
        "EngineSpeed": null,
        "TotalMileage": 58305105,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 3356,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.2
    },
    {
        "Id": 27004224,
        "Time": "2022-02-22T10:54:06",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26995,
        "Lon": 86.1770248,
        "Speed": 0.0,
        "Height": 65,
        "Mileage": 42702504,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 69,
        "EngineRPM": 1145.125,
        "OnboardVoltage": 27198,
        "EngineSpeed": null,
        "TotalMileage": 14442650,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 7,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1786,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.0
    },
    {
        "Id": 27007312,
        "Time": "2022-02-22T11:15:50",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2619438,
        "Lon": 86.17173,
        "Speed": 15.5,
        "Height": 221,
        "Mileage": 42706204,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 68,
        "EngineRPM": 1802.25,
        "OnboardVoltage": 27018,
        "EngineSpeed": null,
        "TotalMileage": 14445940,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 367,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1786,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27009950,
        "Time": "2022-02-22T11:36:01",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2555122,
        "Lon": 86.16282,
        "Speed": 30.1,
        "Height": 289,
        "Mileage": 42712552,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 68,
        "EngineRPM": 1302.75,
        "OnboardVoltage": 27099,
        "EngineSpeed": null,
        "TotalMileage": 14451305,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1787,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27012936,
        "Time": "2022-02-22T11:53:35",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2703438,
        "Lon": 86.17723,
        "Speed": 7.4,
        "Height": 72,
        "Mileage": 42717396,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 77,
        "EngineRPM": 923.875,
        "OnboardVoltage": 27230,
        "EngineSpeed": null,
        "TotalMileage": 14456795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 80,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1787,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27014466,
        "Time": "2022-02-22T12:14:10",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2582169,
        "Lon": 86.17394,
        "Speed": 13.1,
        "Height": 255,
        "Mileage": 42721536,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1793.25,
        "OnboardVoltage": 27035,
        "EngineSpeed": null,
        "TotalMileage": 14460490,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1787,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27016568,
        "Time": "2022-02-22T12:30:12",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2432861,
        "Lon": 86.15029,
        "Speed": 25.7,
        "Height": 333,
        "Mileage": 42725976,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 88,
        "EngineRPM": 1093.0,
        "OnboardVoltage": 26987,
        "EngineSpeed": null,
        "TotalMileage": 14464450,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 111,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1788,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27019571,
        "Time": "2022-02-22T13:01:18",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26193,
        "Lon": 86.17189,
        "Speed": 21.2,
        "Height": 226,
        "Mileage": 42729780,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 87,
        "EngineRPM": 1306.75,
        "OnboardVoltage": 26999,
        "EngineSpeed": null,
        "TotalMileage": 14467910,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1788,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27028424,
        "Time": "2022-02-22T13:51:01",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2700233,
        "Lon": 86.17704,
        "Speed": 5.0,
        "Height": 68,
        "Mileage": 42733348,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 90,
        "EngineRPM": 795.0,
        "OnboardVoltage": 27165,
        "EngineSpeed": null,
        "TotalMileage": 14471445,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 25,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1789,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27027774,
        "Time": "2022-02-22T14:11:04",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.261116,
        "Lon": 86.17558,
        "Speed": 14.8,
        "Height": 175,
        "Mileage": 42736440,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 73,
        "FuelTemperature": 90,
        "EngineRPM": 1792.875,
        "OnboardVoltage": 26958,
        "EngineSpeed": null,
        "TotalMileage": 14474070,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 70,
        "FuelConsumption": 312,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1789,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27031066,
        "Time": "2022-02-22T14:25:08",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2412567,
        "Lon": 86.1442261,
        "Speed": 17.2,
        "Height": 313,
        "Mileage": 42740692,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 95,
        "EngineRPM": 1288.0,
        "OnboardVoltage": 27098,
        "EngineSpeed": null,
        "TotalMileage": 14478225,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1789,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27031456,
        "Time": "2022-02-22T14:36:42",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2600327,
        "Lon": 86.17694,
        "Speed": 30.7,
        "Height": 183,
        "Mileage": 42745504,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 95,
        "EngineRPM": 1294.0,
        "OnboardVoltage": 27080,
        "EngineSpeed": null,
        "TotalMileage": 14482625,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1790,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27034252,
        "Time": "2022-02-22T14:58:54",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2676048,
        "Lon": 86.17461,
        "Speed": 18.8,
        "Height": 40,
        "Mileage": 42748808,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 93,
        "EngineRPM": 1305.625,
        "OnboardVoltage": 27154,
        "EngineSpeed": null,
        "TotalMileage": 14485950,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1790,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27036783,
        "Time": "2022-02-22T15:16:49",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2530174,
        "Lon": 86.16072,
        "Speed": 16.4,
        "Height": 311,
        "Mileage": 42753776,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 94,
        "EngineRPM": 1799.375,
        "OnboardVoltage": 27082,
        "EngineSpeed": null,
        "TotalMileage": 14490690,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 359,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1790,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27038916,
        "Time": "2022-02-22T15:32:04",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2568245,
        "Lon": 86.17528,
        "Speed": 31.4,
        "Height": 266,
        "Mileage": 42759092,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 96,
        "EngineRPM": 1352.5,
        "OnboardVoltage": 26876,
        "EngineSpeed": null,
        "TotalMileage": 14495585,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 127,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1790,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27040281,
        "Time": "2022-02-22T15:44:03",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2758,
        "Lon": 86.176445,
        "Speed": 14.0,
        "Height": 95,
        "Mileage": 42763924,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 93,
        "EngineRPM": 1260.125,
        "OnboardVoltage": 27036,
        "EngineSpeed": null,
        "TotalMileage": 14500375,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1791,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27049269,
        "Time": "2022-02-22T16:55:20",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.277977,
        "Lon": 86.18986,
        "Speed": 13.8,
        "Height": 253,
        "Mileage": 42767376,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 95,
        "EngineRPM": 760.5,
        "OnboardVoltage": 27095,
        "EngineSpeed": null,
        "TotalMileage": 14503550,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 11,
        "FuelConsumption": 43,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1792,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27053107,
        "Time": "2022-02-22T17:17:12",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26952,
        "Lon": 86.17736,
        "Speed": 12.2,
        "Height": 60,
        "Mileage": 42771336,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 97,
        "EngineRPM": 1322.125,
        "OnboardVoltage": 27236,
        "EngineSpeed": null,
        "TotalMileage": 14507350,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1792,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27053754,
        "Time": "2022-02-22T17:33:04",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2562561,
        "Lon": 86.17518,
        "Speed": 16.4,
        "Height": 274,
        "Mileage": 42775448,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 98,
        "EngineRPM": 1802.625,
        "OnboardVoltage": 27136,
        "EngineSpeed": null,
        "TotalMileage": 14511275,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 352,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1793,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.0
    },
    {
        "Id": 27055414,
        "Time": "2022-02-22T17:48:25",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.25173,
        "Lon": 86.1596451,
        "Speed": 37.0,
        "Height": 323,
        "Mileage": 42780388,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 98,
        "EngineRPM": 953.125,
        "OnboardVoltage": 26937,
        "EngineSpeed": null,
        "TotalMileage": 14515900,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1793,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.8
    },
    {
        "Id": 27059295,
        "Time": "2022-02-22T18:23:59",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2689857,
        "Lon": 86.16511,
        "Speed": 10.0,
        "Height": 96,
        "Mileage": 42784652,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 96,
        "EngineRPM": 997.25,
        "OnboardVoltage": 27239,
        "EngineSpeed": null,
        "TotalMileage": 14519940,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 71,
        "FuelConsumption": 89,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1793,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27062722,
        "Time": "2022-02-22T18:41:30",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2430573,
        "Lon": 86.14875,
        "Speed": 28.1,
        "Height": 328,
        "Mileage": 42789824,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 97,
        "EngineRPM": 1501.75,
        "OnboardVoltage": 26900,
        "EngineSpeed": null,
        "TotalMileage": 14524660,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 141,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1794,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27063337,
        "Time": "2022-02-22T18:55:51",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2593346,
        "Lon": 86.17681,
        "Speed": 30.7,
        "Height": 188,
        "Mileage": 42794992,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1288.875,
        "OnboardVoltage": 27133,
        "EngineSpeed": null,
        "TotalMileage": 14529150,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1794,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27066262,
        "Time": "2022-02-22T19:16:38",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2563934,
        "Lon": 86.17516,
        "Speed": 15.5,
        "Height": 271,
        "Mileage": 42799108,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 100,
        "EngineRPM": 1804.75,
        "OnboardVoltage": 27117,
        "EngineSpeed": null,
        "TotalMileage": 14533440,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 349,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1794,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27069253,
        "Time": "2022-02-22T19:39:05",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26556,
        "Lon": 86.1564941,
        "Speed": 29.2,
        "Height": 284,
        "Mileage": 42806620,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 101,
        "EngineRPM": 1801.0,
        "OnboardVoltage": 27100,
        "EngineSpeed": null,
        "TotalMileage": 14540140,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 35,
        "FuelConsumption": 191,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1795,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27071199,
        "Time": "2022-02-22T19:52:18",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2686462,
        "Lon": 86.17473,
        "Speed": 18.8,
        "Height": 41,
        "Mileage": 42812872,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 100,
        "EngineRPM": 1176.25,
        "OnboardVoltage": 27176,
        "EngineSpeed": null,
        "TotalMileage": 14546050,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 97,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1795,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27074855,
        "Time": "2022-02-22T20:15:59",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.27249,
        "Lon": 86.164566,
        "Speed": 8.8,
        "Height": 50,
        "Mileage": 42814524,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 99,
        "EngineRPM": 947.625,
        "OnboardVoltage": 27149,
        "EngineSpeed": null,
        "TotalMileage": 14547675,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1795,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27077789,
        "Time": "2022-02-22T20:38:24",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2827225,
        "Lon": 86.13878,
        "Speed": 15.0,
        "Height": 283,
        "Mileage": 42821992,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 1271.375,
        "OnboardVoltage": 27065,
        "EngineSpeed": null,
        "TotalMileage": 14554570,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 134,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1796,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27080235,
        "Time": "2022-02-22T20:56:38",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2724838,
        "Lon": 86.16478,
        "Speed": 20.7,
        "Height": 54,
        "Mileage": 42829920,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 101,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27157,
        "EngineSpeed": null,
        "TotalMileage": 14561760,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1796,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27085887,
        "Time": "2022-02-22T21:38:46",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26746,
        "Lon": 86.1744,
        "Speed": 16.2,
        "Height": 41,
        "Mileage": 42831652,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 97,
        "EngineRPM": 1308.0,
        "OnboardVoltage": 27141,
        "EngineSpeed": null,
        "TotalMileage": 14563535,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1797,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.2
    },
    {
        "Id": 27088791,
        "Time": "2022-02-22T22:00:12",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2717628,
        "Lon": 86.15475,
        "Speed": 12.5,
        "Height": 258,
        "Mileage": 42838308,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 101,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27017,
        "EngineSpeed": null,
        "TotalMileage": 14569880,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1797,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.8
    },
    {
        "Id": 27091797,
        "Time": "2022-02-22T22:21:58",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.259407,
        "Lon": 86.17685,
        "Speed": 29.8,
        "Height": 192,
        "Mileage": 42846272,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1296.75,
        "OnboardVoltage": 26956,
        "EngineSpeed": null,
        "TotalMileage": 14577030,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1797,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27097679,
        "Time": "2022-02-22T23:09:14",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2623253,
        "Lon": 86.17214,
        "Speed": 18.3,
        "Height": 215,
        "Mileage": 42849816,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 101,
        "EngineRPM": 1805.5,
        "OnboardVoltage": 27162,
        "EngineSpeed": null,
        "TotalMileage": 14580340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 81,
        "FuelConsumption": 326,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1798,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.2
    },
    {
        "Id": 27099985,
        "Time": "2022-02-22T23:25:05",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2428246,
        "Lon": 86.14727,
        "Speed": 17.2,
        "Height": 341,
        "Mileage": 42854140,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 103,
        "EngineRPM": 774.25,
        "OnboardVoltage": 27109,
        "EngineSpeed": null,
        "TotalMileage": 14584640,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 6,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1798,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27102231,
        "Time": "2022-02-22T23:42:47",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.25641,
        "Lon": 86.175354,
        "Speed": 35.3,
        "Height": 271,
        "Mileage": 42857212,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 96,
        "EngineRPM": 1471.375,
        "OnboardVoltage": 27088,
        "EngineSpeed": null,
        "TotalMileage": 14587480,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 69,
        "FuelConsumption": 201,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1798,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27105561,
        "Time": "2022-02-22T23:58:08",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2702751,
        "Lon": 86.17738,
        "Speed": 4.2,
        "Height": 83,
        "Mileage": 42861568,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 80,
        "EngineRPM": 765.125,
        "OnboardVoltage": 27118,
        "EngineSpeed": null,
        "TotalMileage": 14591650,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1799,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27107024,
        "Time": "2022-02-23T00:18:42",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2593727,
        "Lon": 86.17634,
        "Speed": 11.6,
        "Height": 193,
        "Mileage": 42865168,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 76,
        "EngineRPM": 1643.25,
        "OnboardVoltage": 26930,
        "EngineSpeed": null,
        "TotalMileage": 14594520,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 81,
        "FuelConsumption": 315,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1799,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27111450,
        "Time": "2022-02-23T01:04:49",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.25644,
        "Lon": 86.1714,
        "Speed": 9.2,
        "Height": 284,
        "Mileage": 42867232,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 78,
        "EngineRPM": 1116.375,
        "OnboardVoltage": 27143,
        "EngineSpeed": null,
        "TotalMileage": 14596160,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 8,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1800,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27114510,
        "Time": "2022-02-23T01:27:18",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.24117,
        "Lon": 86.1455154,
        "Speed": 8.7,
        "Height": 321,
        "Mileage": 42870972,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 82,
        "EngineRPM": 1311.0,
        "OnboardVoltage": 27070,
        "EngineSpeed": null,
        "TotalMileage": 14599410,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 43,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1800,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27116608,
        "Time": "2022-02-23T01:41:36",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2695923,
        "Lon": 86.1646,
        "Speed": 0.0,
        "Height": 93,
        "Mileage": 42876656,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 85,
        "EngineRPM": 1135.125,
        "OnboardVoltage": 27283,
        "EngineSpeed": null,
        "TotalMileage": 14604800,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1801,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27117934,
        "Time": "2022-02-23T01:56:31",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26226,
        "Lon": 86.1719,
        "Speed": 19.6,
        "Height": 212,
        "Mileage": 42878712,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 87,
        "EngineRPM": 1708.375,
        "OnboardVoltage": 27072,
        "EngineSpeed": null,
        "TotalMileage": 14606500,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 339,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1801,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.6
    },
    {
        "Id": 27121081,
        "Time": "2022-02-23T02:14:47",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2412834,
        "Lon": 86.14562,
        "Speed": 9.2,
        "Height": 321,
        "Mileage": 42883188,
        "EngineOilPressure": 204,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 1429.125,
        "OnboardVoltage": 27165,
        "EngineSpeed": null,
        "TotalMileage": 14610620,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 27,
        "FuelConsumption": 116,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1801,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27122402,
        "Time": "2022-02-23T02:29:30",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2700577,
        "Lon": 86.16826,
        "Speed": 20.1,
        "Height": 36,
        "Mileage": 42889428,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 93,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27190,
        "EngineSpeed": null,
        "TotalMileage": 14616435,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 33,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1801,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27128195,
        "Time": "2022-02-23T03:09:14",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.27036,
        "Lon": 86.1767654,
        "Speed": 0.0,
        "Height": 72,
        "Mileage": 42890352,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 92,
        "EngineRPM": 1121.75,
        "OnboardVoltage": 27320,
        "EngineSpeed": null,
        "TotalMileage": 14617555,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 7,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1802,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27130872,
        "Time": "2022-02-23T03:29:47",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2560959,
        "Lon": 86.17509,
        "Speed": 14.8,
        "Height": 269,
        "Mileage": 42894800,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 96,
        "EngineRPM": 1801.0,
        "OnboardVoltage": 27195,
        "EngineSpeed": null,
        "TotalMileage": 14621475,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 366,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1802,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27137122,
        "Time": "2022-02-23T04:04:37",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2410431,
        "Lon": 86.1449661,
        "Speed": 17.0,
        "Height": 320,
        "Mileage": 42898660,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 101,
        "EngineRPM": 810.125,
        "OnboardVoltage": 27297,
        "EngineSpeed": null,
        "TotalMileage": 14624850,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 45,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1803,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27139961,
        "Time": "2022-02-23T04:16:45",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26847,
        "Lon": 86.167,
        "Speed": 10.5,
        "Height": 106,
        "Mileage": 42903888,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 97,
        "EngineRPM": 1295.375,
        "OnboardVoltage": 27232,
        "EngineSpeed": null,
        "TotalMileage": 14630005,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1803,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27141488,
        "Time": "2022-02-23T04:39:41",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2556038,
        "Lon": 86.1738739,
        "Speed": 14.6,
        "Height": 280,
        "Mileage": 42907200,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 100,
        "EngineRPM": 1803.625,
        "OnboardVoltage": 27185,
        "EngineSpeed": null,
        "TotalMileage": 14632885,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 357,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1804,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27143932,
        "Time": "2022-02-23T04:56:51",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2561836,
        "Lon": 86.17536,
        "Speed": 27.4,
        "Height": 275,
        "Mileage": 42913076,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 99,
        "EngineRPM": 1226.25,
        "OnboardVoltage": 27158,
        "EngineSpeed": null,
        "TotalMileage": 14637890,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1804,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 61.600002
    },
    {
        "Id": 27145700,
        "Time": "2022-02-23T05:10:10",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.27043,
        "Lon": 86.17707,
        "Speed": 0.0,
        "Height": 78,
        "Mileage": 42917348,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 100,
        "EngineRPM": 1122.875,
        "OnboardVoltage": 27272,
        "EngineSpeed": null,
        "TotalMileage": 14642350,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1804,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27147196,
        "Time": "2022-02-23T05:29:40",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2594643,
        "Lon": 86.17631,
        "Speed": 10.1,
        "Height": 194,
        "Mileage": 42920644,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1798.0,
        "OnboardVoltage": 27173,
        "EngineSpeed": null,
        "TotalMileage": 14645145,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1804,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27148972,
        "Time": "2022-02-23T05:45:38",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2426147,
        "Lon": 86.14131,
        "Speed": 5.0,
        "Height": 329,
        "Mileage": 42925212,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 1342.5,
        "OnboardVoltage": 27016,
        "EngineSpeed": null,
        "TotalMileage": 14649500,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 53,
        "FuelConsumption": 170,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1805,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27150962,
        "Time": "2022-02-23T06:01:17",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2723923,
        "Lon": 86.16471,
        "Speed": 12.2,
        "Height": 55,
        "Mileage": 42931412,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 101,
        "EngineRPM": 1294.375,
        "OnboardVoltage": 27214,
        "EngineSpeed": null,
        "TotalMileage": 14655185,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1805,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27154347,
        "Time": "2022-02-23T06:25:31",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2675972,
        "Lon": 86.17453,
        "Speed": 15.1,
        "Height": 33,
        "Mileage": 42933388,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 102,
        "EngineRPM": 1299.625,
        "OnboardVoltage": 27284,
        "EngineSpeed": null,
        "TotalMileage": 14657010,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1805,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27156789,
        "Time": "2022-02-23T06:44:22",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.255825,
        "Lon": 86.16307,
        "Speed": 17.4,
        "Height": 289,
        "Mileage": 42938192,
        "EngineOilPressure": 300,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 871.875,
        "OnboardVoltage": 27178,
        "EngineSpeed": null,
        "TotalMileage": 14661200,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1806,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.0
    },
    {
        "Id": 27159218,
        "Time": "2022-02-23T07:02:59",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2467957,
        "Lon": 86.15458,
        "Speed": 27.9,
        "Height": 333,
        "Mileage": 42942208,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 102,
        "EngineRPM": 788.375,
        "OnboardVoltage": 27154,
        "EngineSpeed": null,
        "TotalMileage": 14664740,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1806,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 50.4
    },
    {
        "Id": 27164350,
        "Time": "2022-02-23T07:37:57",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26195,
        "Lon": 86.17194,
        "Speed": 23.5,
        "Height": 212,
        "Mileage": 42945288,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 100,
        "EngineRPM": 1289.25,
        "OnboardVoltage": 27133,
        "EngineSpeed": null,
        "TotalMileage": 14667790,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1807,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27168860,
        "Time": "2022-02-23T07:51:17",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2702942,
        "Lon": 86.1770248,
        "Speed": 8.5,
        "Height": 74,
        "Mileage": 42948992,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 72,
        "FuelTemperature": 74,
        "EngineRPM": 1352.5,
        "OnboardVoltage": 27278,
        "EngineSpeed": null,
        "TotalMileage": 14671340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 48,
        "FuelConsumption": 190,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1807,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27169668,
        "Time": "2022-02-23T08:18:15",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2597923,
        "Lon": 86.17681,
        "Speed": 13.3,
        "Height": 189,
        "Mileage": 42952356,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 75,
        "EngineRPM": 1798.625,
        "OnboardVoltage": 27172,
        "EngineSpeed": null,
        "TotalMileage": 14674205,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 353,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1807,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.8
    },
    {
        "Id": 27171980,
        "Time": "2022-02-23T08:35:50",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2427635,
        "Lon": 86.14134,
        "Speed": 7.7,
        "Height": 329,
        "Mileage": 42957028,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 72,
        "EngineRPM": 798.625,
        "OnboardVoltage": 27138,
        "EngineSpeed": null,
        "TotalMileage": 14678615,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 17,
        "FuelConsumption": 45,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1808,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.0
    },
    {
        "Id": 27174064,
        "Time": "2022-02-23T08:52:04",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26968,
        "Lon": 86.1652756,
        "Speed": 0.0,
        "Height": 108,
        "Mileage": 42963032,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 73,
        "EngineRPM": 803.25,
        "OnboardVoltage": 27278,
        "EngineSpeed": null,
        "TotalMileage": 14684250,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 32,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1808,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.200005
    },
    {
        "Id": 27177287,
        "Time": "2022-02-23T09:20:02",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2565956,
        "Lon": 86.15999,
        "Speed": 19.4,
        "Height": 299,
        "Mileage": 42966868,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 72,
        "EngineRPM": 1791.625,
        "OnboardVoltage": 27158,
        "EngineSpeed": null,
        "TotalMileage": 14687695,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 76,
        "FuelConsumption": 328,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1808,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.200005
    },
    {
        "Id": 27180317,
        "Time": "2022-02-23T09:43:25",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.25542,
        "Lon": 86.1735458,
        "Speed": 25.9,
        "Height": 282,
        "Mileage": 42975572,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 77,
        "EngineRPM": 1208.375,
        "OnboardVoltage": 27141,
        "EngineSpeed": null,
        "TotalMileage": 14695355,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 105,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1809,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.4
    },
    {
        "Id": 27184369,
        "Time": "2022-02-23T10:13:18",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26736,
        "Lon": 86.16824,
        "Speed": 7.9,
        "Height": 113,
        "Mileage": 42978940,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 82,
        "EngineRPM": 1764.375,
        "OnboardVoltage": 27237,
        "EngineSpeed": null,
        "TotalMileage": 14698565,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 340,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1809,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27187273,
        "Time": "2022-02-23T10:36:50",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2831345,
        "Lon": 86.1379852,
        "Speed": 10.7,
        "Height": 294,
        "Mileage": 42985900,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 88,
        "EngineRPM": 1493.75,
        "OnboardVoltage": 27195,
        "EngineSpeed": null,
        "TotalMileage": 14705040,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 72,
        "FuelConsumption": 210,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1810,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27189968,
        "Time": "2022-02-23T10:55:48",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2653656,
        "Lon": 86.17013,
        "Speed": 24.4,
        "Height": 136,
        "Mileage": 42993148,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1302.875,
        "OnboardVoltage": 27167,
        "EngineSpeed": null,
        "TotalMileage": 14711330,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1810,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27192825,
        "Time": "2022-02-23T11:17:04",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.260952,
        "Lon": 86.17385,
        "Speed": 14.8,
        "Height": 211,
        "Mileage": 42995788,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1795.5,
        "OnboardVoltage": 27050,
        "EngineSpeed": null,
        "TotalMileage": 14713740,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 82,
        "FuelConsumption": 357,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1810,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27195855,
        "Time": "2022-02-23T11:39:35",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.27479,
        "Lon": 86.14959,
        "Speed": 29.8,
        "Height": 267,
        "Mileage": 43003024,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 93,
        "EngineRPM": 1226.25,
        "OnboardVoltage": 27116,
        "EngineSpeed": null,
        "TotalMileage": 14720040,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1811,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.4
    },
    {
        "Id": 27199498,
        "Time": "2022-02-23T12:11:41",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26967,
        "Lon": 86.16528,
        "Speed": 7.4,
        "Height": 103,
        "Mileage": 43008864,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 92,
        "EngineRPM": 1131.75,
        "OnboardVoltage": 27237,
        "EngineSpeed": null,
        "TotalMileage": 14725990,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 7,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1811,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27201060,
        "Time": "2022-02-23T12:27:05",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2569962,
        "Lon": 86.1715851,
        "Speed": 16.4,
        "Height": 274,
        "Mileage": 43011736,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 95,
        "EngineRPM": 1445.375,
        "OnboardVoltage": 27086,
        "EngineSpeed": null,
        "TotalMileage": 14728775,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 134,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1811,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.6
    },
    {
        "Id": 27205348,
        "Time": "2022-02-23T13:12:54",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2419739,
        "Lon": 86.14256,
        "Speed": 10.0,
        "Height": 319,
        "Mileage": 43014932,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 95,
        "EngineRPM": 1622.875,
        "OnboardVoltage": 27020,
        "EngineSpeed": null,
        "TotalMileage": 14731780,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 64,
        "FuelConsumption": 287,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1812,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27207033,
        "Time": "2022-02-23T13:25:41",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2621078,
        "Lon": 86.17247,
        "Speed": 13.1,
        "Height": 214,
        "Mileage": 43018928,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 95,
        "EngineRPM": 1309.375,
        "OnboardVoltage": 27140,
        "EngineSpeed": null,
        "TotalMileage": 14735680,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1812,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27210435,
        "Time": "2022-02-23T13:50:43",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.25986,
        "Lon": 86.1768,
        "Speed": 13.3,
        "Height": 183,
        "Mileage": 43022480,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 95,
        "EngineRPM": 1726.125,
        "OnboardVoltage": 27132,
        "EngineSpeed": null,
        "TotalMileage": 14738785,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 340,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1813,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27214640,
        "Time": "2022-02-23T14:17:33",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2422943,
        "Lon": 86.14179,
        "Speed": 7.4,
        "Height": 324,
        "Mileage": 43027048,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 95,
        "EngineRPM": 778.875,
        "OnboardVoltage": 27050,
        "EngineSpeed": null,
        "TotalMileage": 14743225,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1813,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.4
    },
    {
        "Id": 27216424,
        "Time": "2022-02-23T14:31:21",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26847,
        "Lon": 86.1656952,
        "Speed": 17.0,
        "Height": 100,
        "Mileage": 43032848,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 96,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27134,
        "EngineSpeed": null,
        "TotalMileage": 14748440,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1814,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27220037,
        "Time": "2022-02-23T15:05:07",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2561264,
        "Lon": 86.1644058,
        "Speed": 22.5,
        "Height": 283,
        "Mileage": 43036612,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 93,
        "EngineRPM": 812.375,
        "OnboardVoltage": 27153,
        "EngineSpeed": null,
        "TotalMileage": 14751760,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 16,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1814,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27222969,
        "Time": "2022-02-23T15:27:41",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.25626,
        "Lon": 86.17538,
        "Speed": 22.5,
        "Height": 280,
        "Mileage": 43042440,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 97,
        "EngineRPM": 1290.75,
        "OnboardVoltage": 27054,
        "EngineSpeed": null,
        "TotalMileage": 14757260,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1814,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.6
    },
    {
        "Id": 27225688,
        "Time": "2022-02-23T15:47:05",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26268,
        "Lon": 86.17433,
        "Speed": 11.6,
        "Height": 167,
        "Mileage": 43046488,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 97,
        "EngineRPM": 1760.375,
        "OnboardVoltage": 26951,
        "EngineSpeed": null,
        "TotalMileage": 14760940,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 349,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1815,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27228443,
        "Time": "2022-02-23T16:05:47",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.24195,
        "Lon": 86.14198,
        "Speed": 5.0,
        "Height": 326,
        "Mileage": 43051544,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 98,
        "EngineRPM": 780.375,
        "OnboardVoltage": 27128,
        "EngineSpeed": null,
        "TotalMileage": 14765515,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1815,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27230726,
        "Time": "2022-02-23T16:23:31",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2555161,
        "Lon": 86.1738739,
        "Speed": 17.2,
        "Height": 277,
        "Mileage": 43055016,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 99,
        "EngineRPM": 813.875,
        "OnboardVoltage": 26995,
        "EngineSpeed": null,
        "TotalMileage": 14768690,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1815,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27233082,
        "Time": "2022-02-23T16:42:43",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2670937,
        "Lon": 86.16845,
        "Speed": 9.0,
        "Height": 117,
        "Mileage": 43058536,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 97,
        "EngineRPM": 1744.0,
        "OnboardVoltage": 27165,
        "EngineSpeed": null,
        "TotalMileage": 14771850,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 91,
        "FuelConsumption": 347,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1816,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27235869,
        "Time": "2022-02-23T17:02:54",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.24207,
        "Lon": 86.14162,
        "Speed": 5.3,
        "Height": 326,
        "Mileage": 43064048,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 100,
        "EngineRPM": 793.0,
        "OnboardVoltage": 27101,
        "EngineSpeed": null,
        "TotalMileage": 14776935,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 217,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1816,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27237641,
        "Time": "2022-02-23T17:20:20",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2600021,
        "Lon": 86.1754456,
        "Speed": 5.5,
        "Height": 176,
        "Mileage": 43068416,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 750.875,
        "OnboardVoltage": 27051,
        "EngineSpeed": null,
        "TotalMileage": 14781145,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1816,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27240050,
        "Time": "2022-02-23T17:41:01",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2620926,
        "Lon": 86.17179,
        "Speed": 12.7,
        "Height": 220,
        "Mileage": 43072176,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 1765.0,
        "OnboardVoltage": 27176,
        "EngineSpeed": null,
        "TotalMileage": 14784410,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 348,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1817,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27244440,
        "Time": "2022-02-23T18:01:31",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2434349,
        "Lon": 86.15098,
        "Speed": 5.7,
        "Height": 325,
        "Mileage": 43077124,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 102,
        "EngineRPM": 942.0,
        "OnboardVoltage": 27013,
        "EngineSpeed": null,
        "TotalMileage": 14788900,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 17,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1817,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27246142,
        "Time": "2022-02-23T18:29:37",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26986,
        "Lon": 86.1645355,
        "Speed": 8.5,
        "Height": 97,
        "Mileage": 43082372,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 992.125,
        "OnboardVoltage": 27249,
        "EngineSpeed": null,
        "TotalMileage": 14793795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1817,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27248795,
        "Time": "2022-02-23T18:50:19",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2558,
        "Lon": 86.17473,
        "Speed": 12.9,
        "Height": 278,
        "Mileage": 43085256,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 101,
        "EngineRPM": 1786.0,
        "OnboardVoltage": 26981,
        "EngineSpeed": null,
        "TotalMileage": 14796375,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 360,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1818,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27251431,
        "Time": "2022-02-23T19:06:53",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2450142,
        "Lon": 86.15257,
        "Speed": 29.0,
        "Height": 333,
        "Mileage": 43089644,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 806.0,
        "OnboardVoltage": 27046,
        "EngineSpeed": null,
        "TotalMileage": 14800000,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 24,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1818,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27254955,
        "Time": "2022-02-23T19:35:32",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2575836,
        "Lon": 86.1748047,
        "Speed": 24.0,
        "Height": 256,
        "Mileage": 43092468,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 102,
        "EngineRPM": 1297.125,
        "OnboardVoltage": 27160,
        "EngineSpeed": null,
        "TotalMileage": 14802880,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1819,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.200005
    },
    {
        "Id": 27258031,
        "Time": "2022-02-23T19:57:03",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2662926,
        "Lon": 86.1691055,
        "Speed": 9.4,
        "Height": 125,
        "Mileage": 43095908,
        "EngineOilPressure": 472,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 72,
        "EngineRPM": 1802.875,
        "OnboardVoltage": 27113,
        "EngineSpeed": null,
        "TotalMileage": 14805980,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 357,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1819,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.0
    },
    {
        "Id": 27260496,
        "Time": "2022-02-23T20:16:06",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.24198,
        "Lon": 86.14273,
        "Speed": 11.6,
        "Height": 325,
        "Mileage": 43101340,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 1655.75,
        "OnboardVoltage": 27107,
        "EngineSpeed": null,
        "TotalMileage": 14810825,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 80,
        "FuelConsumption": 279,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1819,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.6
    },
    {
        "Id": 27263050,
        "Time": "2022-02-23T20:34:11",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2620239,
        "Lon": 86.1726456,
        "Speed": 20.5,
        "Height": 210,
        "Mileage": 43105612,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 74,
        "EngineRPM": 1304.0,
        "OnboardVoltage": 26992,
        "EngineSpeed": null,
        "TotalMileage": 14814795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1820,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.0
    },
    {
        "Id": 27268463,
        "Time": "2022-02-23T21:16:31",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2611542,
        "Lon": 86.17561,
        "Speed": 15.5,
        "Height": 174,
        "Mileage": 43109064,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 73,
        "EngineRPM": 1769.625,
        "OnboardVoltage": 27181,
        "EngineSpeed": null,
        "TotalMileage": 14817875,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 64,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1820,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27271158,
        "Time": "2022-02-23T21:35:26",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.24208,
        "Lon": 86.1424,
        "Speed": 12.4,
        "Height": 323,
        "Mileage": 43113656,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 72,
        "EngineRPM": 900.0,
        "OnboardVoltage": 26929,
        "EngineSpeed": null,
        "TotalMileage": 14822175,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 195,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1821,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27273091,
        "Time": "2022-02-23T21:49:37",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2599,
        "Lon": 86.1770554,
        "Speed": 23.7,
        "Height": 185,
        "Mileage": 43118240,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 72,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 26974,
        "EngineSpeed": null,
        "TotalMileage": 14826410,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1821,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.0
    },
    {
        "Id": 27275899,
        "Time": "2022-02-23T22:09:50",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2620354,
        "Lon": 86.1717148,
        "Speed": 13.8,
        "Height": 222,
        "Mileage": 43121868,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 80,
        "EngineRPM": 1791.625,
        "OnboardVoltage": 27136,
        "EngineSpeed": null,
        "TotalMileage": 14829750,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 85,
        "FuelConsumption": 355,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1821,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.200005
    },
    {
        "Id": 27278431,
        "Time": "2022-02-23T22:27:17",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2425575,
        "Lon": 86.1411362,
        "Speed": 6.8,
        "Height": 326,
        "Mileage": 43126064,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 831.625,
        "OnboardVoltage": 27100,
        "EngineSpeed": null,
        "TotalMileage": 14833645,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 38,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1821,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.4
    },
    {
        "Id": 27282511,
        "Time": "2022-02-23T22:54:57",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2567673,
        "Lon": 86.17134,
        "Speed": 7.2,
        "Height": 283,
        "Mileage": 43129528,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 87,
        "EngineRPM": 854.375,
        "OnboardVoltage": 26990,
        "EngineSpeed": null,
        "TotalMileage": 14836710,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 105,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1822,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27284586,
        "Time": "2022-02-23T23:06:32",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2682266,
        "Lon": 86.16618,
        "Speed": 14.2,
        "Height": 102,
        "Mileage": 43132916,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 87,
        "EngineRPM": 857.375,
        "OnboardVoltage": 27219,
        "EngineSpeed": null,
        "TotalMileage": 14839770,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 88,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1822,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27286852,
        "Time": "2022-02-23T23:24:39",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2707558,
        "Lon": 86.16751,
        "Speed": 16.2,
        "Height": 33,
        "Mileage": 43135020,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 87,
        "EngineRPM": 1567.375,
        "OnboardVoltage": 27181,
        "EngineSpeed": null,
        "TotalMileage": 14841635,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 75,
        "FuelConsumption": 293,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1822,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27289692,
        "Time": "2022-02-23T23:43:31",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2431221,
        "Lon": 86.1493759,
        "Speed": 19.0,
        "Height": 320,
        "Mileage": 43140476,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 90,
        "EngineRPM": 787.125,
        "OnboardVoltage": 26914,
        "EngineSpeed": null,
        "TotalMileage": 14846835,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1823,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27292696,
        "Time": "2022-02-24T00:05:36",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2621346,
        "Lon": 86.1721039,
        "Speed": 20.9,
        "Height": 216,
        "Mileage": 43145648,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 90,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27132,
        "EngineSpeed": null,
        "TotalMileage": 14851065,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1823,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27295333,
        "Time": "2022-02-24T00:24:19",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.27046,
        "Lon": 86.17003,
        "Speed": 14.8,
        "Height": 24,
        "Mileage": 43148956,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 90,
        "EngineRPM": 1434.0,
        "OnboardVoltage": 27040,
        "EngineSpeed": null,
        "TotalMileage": 14854540,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 15,
        "FuelConsumption": 201,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1823,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27296551,
        "Time": "2022-02-24T00:38:06",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.25697,
        "Lon": 86.1712341,
        "Speed": 5.9,
        "Height": 276,
        "Mileage": 43152584,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 92,
        "EngineRPM": 792.0,
        "OnboardVoltage": 27190,
        "EngineSpeed": null,
        "TotalMileage": 14858300,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1824,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.200005
    },
    {
        "Id": 27300393,
        "Time": "2022-02-24T01:16:29",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.24282,
        "Lon": 86.1410446,
        "Speed": 8.1,
        "Height": 332,
        "Mileage": 43155988,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 91,
        "EngineRPM": 1017.75,
        "OnboardVoltage": 27078,
        "EngineSpeed": null,
        "TotalMileage": 14861490,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 57,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1824,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27302313,
        "Time": "2022-02-24T01:30:50",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2771378,
        "Lon": 86.145256,
        "Speed": 21.8,
        "Height": 276,
        "Mileage": 43161596,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 93,
        "EngineRPM": 842.5,
        "OnboardVoltage": 27082,
        "EngineSpeed": null,
        "TotalMileage": 14866625,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1824,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27306665,
        "Time": "2022-02-24T02:00:20",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2470627,
        "Lon": 86.14547,
        "Speed": 22.5,
        "Height": 354,
        "Mileage": 43168012,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 94,
        "EngineRPM": 1750.5,
        "OnboardVoltage": 27070,
        "EngineSpeed": null,
        "TotalMileage": 14872750,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 47,
        "FuelConsumption": 201,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1825,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.4
    },
    {
        "Id": 27310749,
        "Time": "2022-02-24T02:26:45",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2824631,
        "Lon": 86.13856,
        "Speed": 0.0,
        "Height": 291,
        "Mileage": 43174032,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 95,
        "EngineRPM": 817.75,
        "OnboardVoltage": 27338,
        "EngineSpeed": null,
        "TotalMileage": 14878540,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1825,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.4
    },
    {
        "Id": 27313468,
        "Time": "2022-02-24T02:45:57",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2476349,
        "Lon": 86.1412048,
        "Speed": 9.4,
        "Height": 365,
        "Mileage": 43179760,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 94,
        "EngineRPM": 1263.125,
        "OnboardVoltage": 27156,
        "EngineSpeed": null,
        "TotalMileage": 14883865,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1826,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27315187,
        "Time": "2022-02-24T02:58:22",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.2686234,
        "Lon": 86.1660843,
        "Speed": 26.1,
        "Height": 106,
        "Mileage": 43185212,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 93,
        "EngineRPM": 1349.375,
        "OnboardVoltage": 27275,
        "EngineSpeed": null,
        "TotalMileage": 14888970,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 104,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1826,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27320732,
        "Time": "2022-02-24T03:36:29",
        "TruckId": 812,
        "Imei": "868328058796026",
        "Lat": 54.26938,
        "Lon": 86.17567,
        "Speed": 14.8,
        "Height": 63,
        "Mileage": 43187512,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 94,
        "EngineRPM": 1801.375,
        "OnboardVoltage": 27102,
        "EngineSpeed": null,
        "TotalMileage": 14891050,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 79,
        "FuelConsumption": 335,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1827,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27004163,
        "Time": "2022-02-22T10:53:38",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3066368,
        "Lon": 86.1639938,
        "Speed": 10.7,
        "Height": 385,
        "Mileage": 38540948,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 90,
        "EngineRPM": 1786.5,
        "OnboardVoltage": 27587,
        "EngineSpeed": null,
        "TotalMileage": 398815945,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11828,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27006207,
        "Time": "2022-02-22T11:08:57",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3108559,
        "Lon": 86.13649,
        "Speed": 28.7,
        "Height": 201,
        "Mileage": 38544924,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 92,
        "EngineRPM": 1299.875,
        "OnboardVoltage": 27646,
        "EngineSpeed": null,
        "TotalMileage": 398819770,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11828,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27009954,
        "Time": "2022-02-22T11:36:46",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.29634,
        "Lon": 86.14506,
        "Speed": 5.0,
        "Height": -52,
        "Mileage": 38548732,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 89,
        "EngineRPM": 1039.75,
        "OnboardVoltage": 27625,
        "EngineSpeed": null,
        "TotalMileage": 398823620,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 97,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11829,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27014187,
        "Time": "2022-02-22T12:11:12",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31028,
        "Lon": 86.13256,
        "Speed": 9.4,
        "Height": 188,
        "Mileage": 38552764,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 90,
        "EngineRPM": 1534.75,
        "OnboardVoltage": 27513,
        "EngineSpeed": null,
        "TotalMileage": 398826900,
        "AcceleratorPedalPosition": 71,
        "LoadPercentage": 70,
        "FuelConsumption": 262,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11829,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27019186,
        "Time": "2022-02-22T12:58:58",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3067741,
        "Lon": 86.1695251,
        "Speed": 17.4,
        "Height": 410,
        "Mileage": 38556252,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 92,
        "EngineRPM": 1775.25,
        "OnboardVoltage": 27309,
        "EngineSpeed": null,
        "TotalMileage": 398830090,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11830,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.0
    },
    {
        "Id": 27020841,
        "Time": "2022-02-22T13:12:17",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3034554,
        "Lon": 86.13768,
        "Speed": 34.6,
        "Height": 109,
        "Mileage": 38560860,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 92,
        "EngineRPM": 1296.0,
        "OnboardVoltage": 27318,
        "EngineSpeed": null,
        "TotalMileage": 398834575,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11830,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27025966,
        "Time": "2022-02-22T13:57:59",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.299057,
        "Lon": 86.14441,
        "Speed": 0.0,
        "Height": 0,
        "Mileage": 38562756,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 92,
        "EngineRPM": 774.25,
        "OnboardVoltage": 27451,
        "EngineSpeed": null,
        "TotalMileage": 398836870,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 37,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11830,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27029538,
        "Time": "2022-02-22T14:22:12",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31246,
        "Lon": 86.1528,
        "Speed": 13.5,
        "Height": 286,
        "Mileage": 38566788,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 89,
        "EngineRPM": 1783.625,
        "OnboardVoltage": 27307,
        "EngineSpeed": null,
        "TotalMileage": 398841185,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11832,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27031496,
        "Time": "2022-02-22T14:37:24",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3137932,
        "Lon": 86.14115,
        "Speed": 36.6,
        "Height": 230,
        "Mileage": 38571440,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 92,
        "FuelTemperature": 93,
        "EngineRPM": 1296.5,
        "OnboardVoltage": 27352,
        "EngineSpeed": null,
        "TotalMileage": 398845435,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11832,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27034169,
        "Time": "2022-02-22T14:58:28",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2990532,
        "Lon": 86.14441,
        "Speed": 4.6,
        "Height": -5,
        "Mileage": 38574816,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 93,
        "EngineRPM": 759.5,
        "OnboardVoltage": 27394,
        "EngineSpeed": null,
        "TotalMileage": 398849465,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11832,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27036875,
        "Time": "2022-02-22T15:17:33",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3126259,
        "Lon": 86.1394653,
        "Speed": 17.2,
        "Height": 228,
        "Mileage": 38577804,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 92,
        "EngineRPM": 1775.5,
        "OnboardVoltage": 27321,
        "EngineSpeed": null,
        "TotalMileage": 398852760,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11832,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27038968,
        "Time": "2022-02-22T15:32:48",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31226,
        "Lon": 86.15329,
        "Speed": 37.5,
        "Height": 293,
        "Mileage": 38582228,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 93,
        "EngineRPM": 1291.0,
        "OnboardVoltage": 27313,
        "EngineSpeed": null,
        "TotalMileage": 398857240,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27042529,
        "Time": "2022-02-22T16:03:56",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2991333,
        "Lon": 86.14459,
        "Speed": 6.6,
        "Height": -2,
        "Mileage": 38586664,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 664.625,
        "OnboardVoltage": 27440,
        "EngineSpeed": null,
        "TotalMileage": 398861845,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 52,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27045413,
        "Time": "2022-02-22T16:23:57",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3102036,
        "Lon": 86.13276,
        "Speed": 13.1,
        "Height": 184,
        "Mileage": 38589276,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 92,
        "EngineRPM": 1800.125,
        "OnboardVoltage": 27307,
        "EngineSpeed": null,
        "TotalMileage": 398864580,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27047701,
        "Time": "2022-02-22T16:43:29",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30986,
        "Lon": 86.15812,
        "Speed": 37.0,
        "Height": 341,
        "Mileage": 38593928,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 95,
        "EngineRPM": 1305.625,
        "OnboardVoltage": 27302,
        "EngineSpeed": null,
        "TotalMileage": 398869265,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27052417,
        "Time": "2022-02-22T17:21:36",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31077,
        "Lon": 86.13596,
        "Speed": 36.1,
        "Height": 199,
        "Mileage": 38596532,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 88,
        "EngineRPM": 1295.375,
        "OnboardVoltage": 27302,
        "EngineSpeed": null,
        "TotalMileage": 398871840,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 41.2
    },
    {
        "Id": 27055438,
        "Time": "2022-02-22T17:48:39",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.29911,
        "Lon": 86.1440659,
        "Speed": 5.7,
        "Height": 2,
        "Mileage": 38599472,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 691.625,
        "OnboardVoltage": 27246,
        "EngineSpeed": null,
        "TotalMileage": 398875185,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.4
    },
    {
        "Id": 27057858,
        "Time": "2022-02-22T18:11:09",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31382,
        "Lon": 86.14178,
        "Speed": 15.5,
        "Height": 237,
        "Mileage": 38602756,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 1792.125,
        "OnboardVoltage": 27295,
        "EngineSpeed": null,
        "TotalMileage": 398878785,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.8
    },
    {
        "Id": 27059716,
        "Time": "2022-02-22T18:28:03",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3129768,
        "Lon": 86.15248,
        "Speed": 36.6,
        "Height": 286,
        "Mileage": 38607268,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 95,
        "EngineRPM": 1294.25,
        "OnboardVoltage": 27385,
        "EngineSpeed": null,
        "TotalMileage": 398883050,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 35.2
    },
    {
        "Id": 27064316,
        "Time": "2022-02-22T19:01:57",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3034973,
        "Lon": 86.13792,
        "Speed": 36.6,
        "Height": 110,
        "Mileage": 38610392,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 69,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27309,
        "EngineSpeed": null,
        "TotalMileage": 398886270,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 35.600002
    },
    {
        "Id": 27067279,
        "Time": "2022-02-22T19:24:14",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.300457,
        "Lon": 86.14162,
        "Speed": 17.7,
        "Height": 5,
        "Mileage": 38612544,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 61,
        "EngineRPM": 1751.625,
        "OnboardVoltage": 27323,
        "EngineSpeed": null,
        "TotalMileage": 398888595,
        "AcceleratorPedalPosition": 94,
        "LoadPercentage": 99,
        "FuelConsumption": 367,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 87.200005
    },
    {
        "Id": 27069861,
        "Time": "2022-02-22T19:43:20",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30665,
        "Lon": 86.16361,
        "Speed": 14.0,
        "Height": 386,
        "Mileage": 38617324,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 61,
        "EngineRPM": 1789.875,
        "OnboardVoltage": 27359,
        "EngineSpeed": null,
        "TotalMileage": 398893770,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 403,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.8
    },
    {
        "Id": 27071347,
        "Time": "2022-02-22T19:53:13",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3119926,
        "Lon": 86.14675,
        "Speed": 12.5,
        "Height": 265,
        "Mileage": 38620436,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 67,
        "EngineRPM": 746.25,
        "OnboardVoltage": 27366,
        "EngineSpeed": null,
        "TotalMileage": 398897090,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27077896,
        "Time": "2022-02-22T20:39:07",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3012772,
        "Lon": 86.1437759,
        "Speed": 21.2,
        "Height": 23,
        "Mileage": 38623708,
        "EngineOilPressure": 312,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 62,
        "EngineRPM": 755.875,
        "OnboardVoltage": 27268,
        "EngineSpeed": null,
        "TotalMileage": 398900535,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27081098,
        "Time": "2022-02-22T21:01:49",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3001,
        "Lon": 86.14636,
        "Speed": 9.8,
        "Height": 29,
        "Mileage": 38625184,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 68,
        "EngineRPM": 1304.875,
        "OnboardVoltage": 27212,
        "EngineSpeed": null,
        "TotalMileage": 398902145,
        "AcceleratorPedalPosition": 52,
        "LoadPercentage": 20,
        "FuelConsumption": 230,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27083616,
        "Time": "2022-02-22T21:20:58",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3073044,
        "Lon": 86.1709747,
        "Speed": 11.2,
        "Height": 418,
        "Mileage": 38629972,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 72,
        "EngineRPM": 1787.25,
        "OnboardVoltage": 27403,
        "EngineSpeed": null,
        "TotalMileage": 398907405,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11833,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27085251,
        "Time": "2022-02-22T21:33:55",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3000031,
        "Lon": 86.14576,
        "Speed": 16.6,
        "Height": 30,
        "Mileage": 38635304,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 76,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27374,
        "EngineSpeed": null,
        "TotalMileage": 398913020,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 37,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27087985,
        "Time": "2022-02-22T21:54:44",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.29998,
        "Lon": 86.1457443,
        "Speed": 9.4,
        "Height": 37,
        "Mileage": 38636980,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 75,
        "EngineRPM": 1803.125,
        "OnboardVoltage": 27370,
        "EngineSpeed": null,
        "TotalMileage": 398914765,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 99,
        "FuelConsumption": 403,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27090772,
        "Time": "2022-02-22T22:14:21",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3068657,
        "Lon": 86.16772,
        "Speed": 14.4,
        "Height": 409,
        "Mileage": 38641828,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 1794.625,
        "OnboardVoltage": 27351,
        "EngineSpeed": null,
        "TotalMileage": 398919745,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27092415,
        "Time": "2022-02-22T22:27:36",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30432,
        "Lon": 86.14365,
        "Speed": 29.6,
        "Height": 75,
        "Mileage": 38646852,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 1292.625,
        "OnboardVoltage": 27279,
        "EngineSpeed": null,
        "TotalMileage": 398924725,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27096650,
        "Time": "2022-02-22T23:00:43",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2998238,
        "Lon": 86.1416245,
        "Speed": 17.4,
        "Height": 14,
        "Mileage": 38648512,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 83,
        "EngineRPM": 1796.0,
        "OnboardVoltage": 27293,
        "EngineSpeed": null,
        "TotalMileage": 398926530,
        "AcceleratorPedalPosition": 96,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27099107,
        "Time": "2022-02-22T23:20:50",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3067131,
        "Lon": 86.16365,
        "Speed": 12.9,
        "Height": 384,
        "Mileage": 38653448,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 84,
        "EngineRPM": 1771.125,
        "OnboardVoltage": 27295,
        "EngineSpeed": null,
        "TotalMileage": 398931750,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27100980,
        "Time": "2022-02-22T23:33:18",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3030853,
        "Lon": 86.14394,
        "Speed": 35.9,
        "Height": 68,
        "Mileage": 38659024,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 86,
        "EngineRPM": 1303.5,
        "OnboardVoltage": 27392,
        "EngineSpeed": null,
        "TotalMileage": 398937200,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.8
    },
    {
        "Id": 27106239,
        "Time": "2022-02-23T00:15:58",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.29946,
        "Lon": 86.14403,
        "Speed": 16.2,
        "Height": 1,
        "Mileage": 38660392,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 87,
        "EngineRPM": 1418.75,
        "OnboardVoltage": 27423,
        "EngineSpeed": null,
        "TotalMileage": 398938770,
        "AcceleratorPedalPosition": 56,
        "LoadPercentage": 46,
        "FuelConsumption": 141,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27108207,
        "Time": "2022-02-23T00:30:13",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31281,
        "Lon": 86.14724,
        "Speed": 9.6,
        "Height": 264,
        "Mileage": 38663912,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 86,
        "EngineRPM": 1719.125,
        "OnboardVoltage": 27611,
        "EngineSpeed": null,
        "TotalMileage": 398942720,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 404,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27111462,
        "Time": "2022-02-23T01:04:56",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3088226,
        "Lon": 86.17177,
        "Speed": 14.2,
        "Height": 434,
        "Mileage": 38666640,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 91,
        "EngineRPM": 1229.5,
        "OnboardVoltage": 27446,
        "EngineSpeed": null,
        "TotalMileage": 398945455,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27112823,
        "Time": "2022-02-23T01:17:06",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30165,
        "Lon": 86.14227,
        "Speed": 19.2,
        "Height": 11,
        "Mileage": 38672028,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 91,
        "EngineRPM": 1307.0,
        "OnboardVoltage": 27535,
        "EngineSpeed": null,
        "TotalMileage": 398950890,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11839,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27118626,
        "Time": "2022-02-23T02:01:01",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3008957,
        "Lon": 86.14176,
        "Speed": 15.5,
        "Height": 17,
        "Mileage": 38673072,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 88,
        "EngineRPM": 1553.875,
        "OnboardVoltage": 27577,
        "EngineSpeed": null,
        "TotalMileage": 398952035,
        "AcceleratorPedalPosition": 84,
        "LoadPercentage": 82,
        "FuelConsumption": 282,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11843,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.4
    },
    {
        "Id": 27120876,
        "Time": "2022-02-23T02:17:57",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3097534,
        "Lon": 86.158,
        "Speed": 10.3,
        "Height": 339,
        "Mileage": 38677328,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 89,
        "EngineRPM": 1787.625,
        "OnboardVoltage": 27515,
        "EngineSpeed": null,
        "TotalMileage": 398956760,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11843,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27123034,
        "Time": "2022-02-23T02:34:21",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3034325,
        "Lon": 86.13687,
        "Speed": 36.8,
        "Height": 115,
        "Mileage": 38682808,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 91,
        "EngineRPM": 1311.875,
        "OnboardVoltage": 27541,
        "EngineSpeed": null,
        "TotalMileage": 398962150,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 35,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11843,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27124811,
        "Time": "2022-02-23T02:46:04",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3044,
        "Lon": 86.14381,
        "Speed": 17.7,
        "Height": 79,
        "Mileage": 38685620,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 90,
        "EngineRPM": 1803.25,
        "OnboardVoltage": 27513,
        "EngineSpeed": null,
        "TotalMileage": 398965290,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11843,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.4
    },
    {
        "Id": 27127529,
        "Time": "2022-02-23T03:05:46",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3091354,
        "Lon": 86.17237,
        "Speed": 9.0,
        "Height": 434,
        "Mileage": 38690080,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 91,
        "EngineRPM": 817.625,
        "OnboardVoltage": 27489,
        "EngineSpeed": null,
        "TotalMileage": 398970570,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 40,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11843,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27129233,
        "Time": "2022-02-23T03:18:08",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2946,
        "Lon": 86.14757,
        "Speed": 22.9,
        "Height": -32,
        "Mileage": 38696012,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 88,
        "EngineRPM": 1308.25,
        "OnboardVoltage": 27553,
        "EngineSpeed": null,
        "TotalMileage": 398976700,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 34,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11843,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.2
    },
    {
        "Id": 27131398,
        "Time": "2022-02-23T03:32:59",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3003922,
        "Lon": 86.14615,
        "Speed": 16.6,
        "Height": 38,
        "Mileage": 38698176,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 87,
        "EngineRPM": 1787.625,
        "OnboardVoltage": 27416,
        "EngineSpeed": null,
        "TotalMileage": 398978800,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11843,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.8
    },
    {
        "Id": 27134243,
        "Time": "2022-02-23T03:53:15",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30947,
        "Lon": 86.17271,
        "Speed": 5.5,
        "Height": 429,
        "Mileage": 38703212,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 91,
        "EngineRPM": 1212.625,
        "OnboardVoltage": 27584,
        "EngineSpeed": null,
        "TotalMileage": 398984335,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 71,
        "FuelConsumption": 161,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11845,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.2
    },
    {
        "Id": 27136067,
        "Time": "2022-02-23T04:05:24",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30796,
        "Lon": 86.13591,
        "Speed": 19.2,
        "Height": 146,
        "Mileage": 38707240,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 93,
        "EngineRPM": 1350.625,
        "OnboardVoltage": 27575,
        "EngineSpeed": null,
        "TotalMileage": 398988590,
        "AcceleratorPedalPosition": 53,
        "LoadPercentage": 65,
        "FuelConsumption": 207,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11845,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 49.2
    },
    {
        "Id": 27139009,
        "Time": "2022-02-23T04:23:34",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3095551,
        "Lon": 86.15828,
        "Speed": 10.7,
        "Height": 341,
        "Mileage": 38710716,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 91,
        "EngineRPM": 1784.125,
        "OnboardVoltage": 27549,
        "EngineSpeed": null,
        "TotalMileage": 398992175,
        "AcceleratorPedalPosition": 83,
        "LoadPercentage": 79,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11845,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.8
    },
    {
        "Id": 27141320,
        "Time": "2022-02-23T04:37:59",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31071,
        "Lon": 86.15376,
        "Speed": 35.0,
        "Height": 307,
        "Mileage": 38713780,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 91,
        "EngineRPM": 1295.875,
        "OnboardVoltage": 27529,
        "EngineSpeed": null,
        "TotalMileage": 398994990,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 22,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11845,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 43.600002
    },
    {
        "Id": 27146179,
        "Time": "2022-02-23T05:18:49",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2994766,
        "Lon": 86.1421661,
        "Speed": 0.0,
        "Height": 9,
        "Mileage": 38717956,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 90,
        "EngineRPM": 1124.0,
        "OnboardVoltage": 27450,
        "EngineSpeed": null,
        "TotalMileage": 398999670,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11845,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27150257,
        "Time": "2022-02-23T05:56:03",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3101654,
        "Lon": 86.1328049,
        "Speed": 14.6,
        "Height": 183,
        "Mileage": 38720548,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 91,
        "EngineRPM": 1780.375,
        "OnboardVoltage": 27493,
        "EngineSpeed": null,
        "TotalMileage": 399002400,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11847,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.600002
    },
    {
        "Id": 27152730,
        "Time": "2022-02-23T06:13:16",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30675,
        "Lon": 86.16394,
        "Speed": 16.8,
        "Height": 389,
        "Mileage": 38724460,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 92,
        "EngineRPM": 1310.0,
        "OnboardVoltage": 27500,
        "EngineSpeed": null,
        "TotalMileage": 399006710,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11847,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.600002
    },
    {
        "Id": 27154531,
        "Time": "2022-02-23T06:27:05",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30034,
        "Lon": 86.13911,
        "Speed": 0.0,
        "Height": 17,
        "Mileage": 38729600,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 90,
        "EngineRPM": 1304.0,
        "OnboardVoltage": 27361,
        "EngineSpeed": null,
        "TotalMileage": 399012255,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 64,
        "FuelConsumption": 115,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11847,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.600002
    },
    {
        "Id": 27157131,
        "Time": "2022-02-23T06:46:58",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3095932,
        "Lon": 86.1325455,
        "Speed": 12.5,
        "Height": 175,
        "Mileage": 38732092,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 90,
        "EngineRPM": 1787.875,
        "OnboardVoltage": 27549,
        "EngineSpeed": null,
        "TotalMileage": 399014930,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11847,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.4
    },
    {
        "Id": 27159625,
        "Time": "2022-02-23T07:05:16",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3072128,
        "Lon": 86.1629257,
        "Speed": 34.8,
        "Height": 375,
        "Mileage": 38736268,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 92,
        "EngineRPM": 1294.375,
        "OnboardVoltage": 27523,
        "EngineSpeed": null,
        "TotalMileage": 399019270,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11848,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 33.2
    },
    {
        "Id": 27162668,
        "Time": "2022-02-23T07:25:35",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30039,
        "Lon": 86.13893,
        "Speed": 5.3,
        "Height": 4,
        "Mileage": 38741232,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 90,
        "EngineRPM": 927.75,
        "OnboardVoltage": 27504,
        "EngineSpeed": null,
        "TotalMileage": 399024680,
        "AcceleratorPedalPosition": 19,
        "LoadPercentage": 0,
        "FuelConsumption": 86,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11848,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.0
    },
    {
        "Id": 27165050,
        "Time": "2022-02-23T07:42:19",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31375,
        "Lon": 86.14562,
        "Speed": 15.9,
        "Height": 259,
        "Mileage": 38744640,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 92,
        "EngineRPM": 1786.0,
        "OnboardVoltage": 27569,
        "EngineSpeed": null,
        "TotalMileage": 399028410,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11848,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 28.800001
    },
    {
        "Id": 27167400,
        "Time": "2022-02-23T07:58:47",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31104,
        "Lon": 86.15365,
        "Speed": 32.7,
        "Height": 306,
        "Mileage": 38748632,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 93,
        "EngineRPM": 1293.625,
        "OnboardVoltage": 27609,
        "EngineSpeed": null,
        "TotalMileage": 399032500,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11848,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 28.4
    },
    {
        "Id": 27170765,
        "Time": "2022-02-23T08:26:16",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30004,
        "Lon": 86.14601,
        "Speed": 9.6,
        "Height": 32,
        "Mileage": 38752512,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 62,
        "EngineRPM": 1294.5,
        "OnboardVoltage": 27354,
        "EngineSpeed": null,
        "TotalMileage": 399036660,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.8
    },
    {
        "Id": 27174150,
        "Time": "2022-02-23T08:52:58",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30378,
        "Lon": 86.13916,
        "Speed": 19.0,
        "Height": 101,
        "Mileage": 38754828,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 56,
        "EngineRPM": 1788.625,
        "OnboardVoltage": 27596,
        "EngineSpeed": null,
        "TotalMileage": 399038995,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27176498,
        "Time": "2022-02-23T09:13:55",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3085632,
        "Lon": 86.1717148,
        "Speed": 9.8,
        "Height": 430,
        "Mileage": 38759392,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 59,
        "EngineRPM": 1356.625,
        "OnboardVoltage": 27575,
        "EngineSpeed": null,
        "TotalMileage": 399043865,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27178023,
        "Time": "2022-02-23T09:26:06",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30125,
        "Lon": 86.1415253,
        "Speed": 12.2,
        "Height": 15,
        "Mileage": 38764804,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 63,
        "EngineRPM": 1416.0,
        "OnboardVoltage": 27639,
        "EngineSpeed": null,
        "TotalMileage": 399049400,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27180823,
        "Time": "2022-02-23T09:46:54",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3036041,
        "Lon": 86.136734,
        "Speed": 16.2,
        "Height": 114,
        "Mileage": 38766948,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 58,
        "EngineRPM": 1789.875,
        "OnboardVoltage": 27604,
        "EngineSpeed": null,
        "TotalMileage": 399051630,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27192993,
        "Time": "2022-02-23T11:18:13",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31432,
        "Lon": 86.13549,
        "Speed": 4.4,
        "Height": 225,
        "Mileage": 38768892,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1116.875,
        "OnboardVoltage": 27590,
        "EngineSpeed": null,
        "TotalMileage": 399053790,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 4,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.4
    },
    {
        "Id": 27195412,
        "Time": "2022-02-23T11:36:10",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.28538,
        "Lon": 86.17343,
        "Speed": 34.4,
        "Height": 260,
        "Mileage": 38774748,
        "EngineOilPressure": 332,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 76,
        "EngineRPM": 1111.125,
        "OnboardVoltage": 27600,
        "EngineSpeed": null,
        "TotalMileage": 399059900,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 6,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.8
    },
    {
        "Id": 27204240,
        "Time": "2022-02-23T13:01:28",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2773132,
        "Lon": 86.1886444,
        "Speed": 0.0,
        "Height": 254,
        "Mileage": 38776452,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 80,
        "EngineRPM": 750.125,
        "OnboardVoltage": 27664,
        "EngineSpeed": null,
        "TotalMileage": 399061820,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 39,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27211791,
        "Time": "2022-02-23T14:02:30",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2776871,
        "Lon": 86.18978,
        "Speed": 0.0,
        "Height": 255,
        "Mileage": 38777872,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 82,
        "EngineRPM": 1125.75,
        "OnboardVoltage": 27601,
        "EngineSpeed": null,
        "TotalMileage": 399063175,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11850,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27237798,
        "Time": "2022-02-23T17:22:30",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2776871,
        "Lon": 86.18978,
        "Speed": 0.0,
        "Height": 255,
        "Mileage": 38777872,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 85,
        "EngineRPM": 1123.625,
        "OnboardVoltage": 27699,
        "EngineSpeed": null,
        "TotalMileage": 399063175,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11858,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.8
    },
    {
        "Id": 27255304,
        "Time": "2022-02-23T19:38:02",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2921448,
        "Lon": 86.17403,
        "Speed": 28.1,
        "Height": 301,
        "Mileage": 38780188,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 80,
        "EngineRPM": 1806.25,
        "OnboardVoltage": 27257,
        "EngineSpeed": null,
        "TotalMileage": 399065225,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 74,
        "FuelConsumption": 379,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11860,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27261836,
        "Time": "2022-02-23T20:24:33",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.27913,
        "Lon": 86.19151,
        "Speed": 0.0,
        "Height": 264,
        "Mileage": 38784060,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 77,
        "EngineRPM": 1128.375,
        "OnboardVoltage": 27647,
        "EngineSpeed": null,
        "TotalMileage": 399069670,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 5,
        "FuelConsumption": 43,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11862,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27271156,
        "Time": "2022-02-23T21:36:25",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3070068,
        "Lon": 86.16537,
        "Speed": 34.0,
        "Height": 387,
        "Mileage": 38788816,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 75,
        "EngineRPM": 1182.625,
        "OnboardVoltage": 27342,
        "EngineSpeed": null,
        "TotalMileage": 399074315,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 165,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11863,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27273552,
        "Time": "2022-02-23T21:52:41",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3064423,
        "Lon": 86.1355057,
        "Speed": 22.5,
        "Height": 142,
        "Mileage": 38793004,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 761.0,
        "OnboardVoltage": 27334,
        "EngineSpeed": null,
        "TotalMileage": 399078510,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11863,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.8
    },
    {
        "Id": 27275421,
        "Time": "2022-02-23T22:05:46",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30775,
        "Lon": 86.13544,
        "Speed": 6.2,
        "Height": 147,
        "Mileage": 38796188,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 76,
        "EngineRPM": 1721.25,
        "OnboardVoltage": 27321,
        "EngineSpeed": null,
        "TotalMileage": 399081900,
        "AcceleratorPedalPosition": 76,
        "LoadPercentage": 41,
        "FuelConsumption": 250,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11863,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27278498,
        "Time": "2022-02-23T22:27:37",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31571,
        "Lon": 86.13407,
        "Speed": 6.2,
        "Height": 218,
        "Mileage": 38798484,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 79,
        "EngineRPM": 802.5,
        "OnboardVoltage": 27550,
        "EngineSpeed": null,
        "TotalMileage": 399084380,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 76,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11863,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27280000,
        "Time": "2022-02-23T22:38:06",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3009453,
        "Lon": 86.14117,
        "Speed": 15.9,
        "Height": 17,
        "Mileage": 38801836,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 1245.25,
        "OnboardVoltage": 27526,
        "EngineSpeed": null,
        "TotalMileage": 399087880,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 157,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11863,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27282247,
        "Time": "2022-02-23T22:53:11",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30494,
        "Lon": 86.14299,
        "Speed": 14.4,
        "Height": 88,
        "Mileage": 38803652,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 78,
        "EngineRPM": 1762.25,
        "OnboardVoltage": 27501,
        "EngineSpeed": null,
        "TotalMileage": 399089665,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11863,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27284569,
        "Time": "2022-02-23T23:09:31",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.3002739,
        "Lon": 86.14608,
        "Speed": 25.5,
        "Height": 36,
        "Mileage": 38808524,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 80,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27330,
        "EngineSpeed": null,
        "TotalMileage": 399094750,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11864,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27287053,
        "Time": "2022-02-23T23:26:15",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2940559,
        "Lon": 86.15005,
        "Speed": 14.8,
        "Height": -17,
        "Mileage": 38810992,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 1774.875,
        "OnboardVoltage": 27538,
        "EngineSpeed": null,
        "TotalMileage": 399097375,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11864,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27290665,
        "Time": "2022-02-23T23:50:47",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30831,
        "Lon": 86.17153,
        "Speed": 14.0,
        "Height": 429,
        "Mileage": 38816896,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 80,
        "EngineRPM": 1767.375,
        "OnboardVoltage": 27571,
        "EngineSpeed": null,
        "TotalMileage": 399103405,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11864,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27292630,
        "Time": "2022-02-24T00:05:00",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30417,
        "Lon": 86.14358,
        "Speed": 25.3,
        "Height": 72,
        "Mileage": 38821824,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 81,
        "EngineRPM": 1292.0,
        "OnboardVoltage": 27389,
        "EngineSpeed": null,
        "TotalMileage": 399108185,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11864,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27295164,
        "Time": "2022-02-24T00:23:10",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30087,
        "Lon": 86.14174,
        "Speed": 19.6,
        "Height": 11,
        "Mileage": 38823716,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 80,
        "EngineRPM": 1758.875,
        "OnboardVoltage": 27338,
        "EngineSpeed": null,
        "TotalMileage": 399110245,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11865,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27298511,
        "Time": "2022-02-24T01:00:41",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.31389,
        "Lon": 86.1425858,
        "Speed": 18.5,
        "Height": 243,
        "Mileage": 38826796,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 82,
        "EngineRPM": 1788.75,
        "OnboardVoltage": 27481,
        "EngineSpeed": null,
        "TotalMileage": 399113740,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 397,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11865,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27300372,
        "Time": "2022-02-24T01:16:48",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.30696,
        "Lon": 86.16336,
        "Speed": 28.8,
        "Height": 382,
        "Mileage": 38830212,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 87,
        "EngineRPM": 1314.25,
        "OnboardVoltage": 27499,
        "EngineSpeed": null,
        "TotalMileage": 399117235,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 7,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11866,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.0
    },
    {
        "Id": 27302799,
        "Time": "2022-02-24T01:34:04",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2743454,
        "Lon": 86.16984,
        "Speed": 21.4,
        "Height": -32,
        "Mileage": 38837888,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 985.5,
        "OnboardVoltage": 27432,
        "EngineSpeed": null,
        "TotalMileage": 399125225,
        "AcceleratorPedalPosition": 39,
        "LoadPercentage": 30,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11866,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27304974,
        "Time": "2022-02-24T01:49:00",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.27018,
        "Lon": 86.17955,
        "Speed": 13.1,
        "Height": 74,
        "Mileage": 38843400,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 86,
        "EngineRPM": 1299.5,
        "OnboardVoltage": 27606,
        "EngineSpeed": null,
        "TotalMileage": 399130735,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11866,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.600002
    },
    {
        "Id": 27319151,
        "Time": "2022-02-24T03:26:15",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.27101,
        "Lon": 86.17082,
        "Speed": 0.0,
        "Height": 15,
        "Mileage": 38844616,
        "EngineOilPressure": 340,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 88,
        "EngineRPM": 1126.0,
        "OnboardVoltage": 27588,
        "EngineSpeed": null,
        "TotalMileage": 399132205,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11866,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.8
    },
    {
        "Id": 27322817,
        "Time": "2022-02-24T03:49:15",
        "TruckId": 1041,
        "Imei": "868328058798535",
        "Lat": 54.2668839,
        "Lon": 86.18597,
        "Speed": 17.5,
        "Height": 189,
        "Mileage": 38847444,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 90,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27530,
        "EngineSpeed": null,
        "TotalMileage": 399135365,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 83,
        "FuelConsumption": 348,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 11866,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.4
    },
    {
        "Id": 27004284,
        "Time": "2022-02-22T10:54:32",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3016052,
        "Lon": 86.14164,
        "Speed": 0.0,
        "Height": 13,
        "Mileage": 34677612,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 62,
        "EngineRPM": 1129.625,
        "OnboardVoltage": 27833,
        "EngineSpeed": null,
        "TotalMileage": 394684960,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2112,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27009366,
        "Time": "2022-02-22T11:31:58",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29635,
        "Lon": 86.14522,
        "Speed": 5.1,
        "Height": -53,
        "Mileage": 34679544,
        "EngineOilPressure": 280,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 67,
        "EngineRPM": 1581.75,
        "OnboardVoltage": 27838,
        "EngineSpeed": null,
        "TotalMileage": 394687160,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 129,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2113,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27012454,
        "Time": "2022-02-22T11:56:09",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3116455,
        "Lon": 86.15324,
        "Speed": 13.5,
        "Height": 295,
        "Mileage": 34684404,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 70,
        "EngineRPM": 1792.5,
        "OnboardVoltage": 27905,
        "EngineSpeed": null,
        "TotalMileage": 394693260,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2113,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27015408,
        "Time": "2022-02-22T12:22:42",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3130569,
        "Lon": 86.15245,
        "Speed": 14.6,
        "Height": 289,
        "Mileage": 34688360,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 78,
        "EngineRPM": 1170.125,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 394697665,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2114,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27019292,
        "Time": "2022-02-22T12:59:55",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29357,
        "Lon": 86.1496658,
        "Speed": 17.2,
        "Height": -15,
        "Mileage": 34692856,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 84,
        "EngineRPM": 1295.375,
        "OnboardVoltage": 27841,
        "EngineSpeed": null,
        "TotalMileage": 394702810,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2114,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27023678,
        "Time": "2022-02-22T13:39:49",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3048363,
        "Lon": 86.1432,
        "Speed": 14.0,
        "Height": 81,
        "Mileage": 34695492,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 88,
        "EngineRPM": 1796.375,
        "OnboardVoltage": 27838,
        "EngineSpeed": null,
        "TotalMileage": 394706270,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2115,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27026665,
        "Time": "2022-02-22T14:03:32",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3070755,
        "Lon": 86.1663,
        "Speed": 25.3,
        "Height": 388,
        "Mileage": 34700724,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 90,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27840,
        "EngineSpeed": null,
        "TotalMileage": 394712620,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2115,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27029071,
        "Time": "2022-02-22T14:20:50",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2964478,
        "Lon": 86.14452,
        "Speed": 5.5,
        "Height": -43,
        "Mileage": 34706880,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 90,
        "EngineRPM": 683.0,
        "OnboardVoltage": 27812,
        "EngineSpeed": null,
        "TotalMileage": 394720030,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2116,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27032290,
        "Time": "2022-02-22T14:44:09",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3135376,
        "Lon": 86.14103,
        "Speed": 13.7,
        "Height": 238,
        "Mileage": 34710988,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 91,
        "EngineRPM": 1807.125,
        "OnboardVoltage": 27843,
        "EngineSpeed": null,
        "TotalMileage": 394725015,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 404,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2116,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27034829,
        "Time": "2022-02-22T15:03:08",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31384,
        "Lon": 86.14723,
        "Speed": 4.4,
        "Height": 266,
        "Mileage": 34715968,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 97,
        "EngineRPM": 1304.375,
        "OnboardVoltage": 27859,
        "EngineSpeed": null,
        "TotalMileage": 394731140,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2116,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27036938,
        "Time": "2022-02-22T15:18:02",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2961349,
        "Lon": 86.14387,
        "Speed": 15.5,
        "Height": -41,
        "Mileage": 34720624,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 94,
        "EngineRPM": 1131.125,
        "OnboardVoltage": 27894,
        "EngineSpeed": null,
        "TotalMileage": 394736735,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2117,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27039880,
        "Time": "2022-02-22T15:40:27",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3103752,
        "Lon": 86.13342,
        "Speed": 12.2,
        "Height": 189,
        "Mileage": 34724104,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 1786.625,
        "OnboardVoltage": 27844,
        "EngineSpeed": null,
        "TotalMileage": 394741200,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2117,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27042106,
        "Time": "2022-02-22T16:00:08",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3104439,
        "Lon": 86.15404,
        "Speed": 30.7,
        "Height": 315,
        "Mileage": 34728928,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 100,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27890,
        "EngineSpeed": null,
        "TotalMileage": 394747020,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2117,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27045184,
        "Time": "2022-02-22T16:22:00",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2968254,
        "Lon": 86.14495,
        "Speed": 4.4,
        "Height": -45,
        "Mileage": 34734096,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 99,
        "EngineRPM": 977.75,
        "OnboardVoltage": 27863,
        "EngineSpeed": null,
        "TotalMileage": 394753290,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 35,
        "FuelConsumption": 93,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2118,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27048348,
        "Time": "2022-02-22T16:48:08",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3139,
        "Lon": 86.14183,
        "Speed": 15.3,
        "Height": 242,
        "Mileage": 34738140,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 101,
        "EngineRPM": 1787.0,
        "OnboardVoltage": 27888,
        "EngineSpeed": null,
        "TotalMileage": 394758270,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2118,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27050593,
        "Time": "2022-02-22T17:05:22",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31284,
        "Lon": 86.15278,
        "Speed": 35.5,
        "Height": 295,
        "Mileage": 34742508,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 103,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27841,
        "EngineSpeed": null,
        "TotalMileage": 394763485,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2118,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27054915,
        "Time": "2022-02-22T17:43:42",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29439,
        "Lon": 86.14562,
        "Speed": 25.3,
        "Height": -42,
        "Mileage": 34747112,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 101,
        "EngineRPM": 1303.75,
        "OnboardVoltage": 27807,
        "EngineSpeed": null,
        "TotalMileage": 394769265,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2119,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27063964,
        "Time": "2022-02-22T18:59:41",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2936134,
        "Lon": 86.14998,
        "Speed": 7.4,
        "Height": -18,
        "Mileage": 34748384,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 101,
        "EngineRPM": 1806.5,
        "OnboardVoltage": 27789,
        "EngineSpeed": null,
        "TotalMileage": 394770825,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2120,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27067031,
        "Time": "2022-02-22T19:22:26",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3083344,
        "Lon": 86.17182,
        "Speed": 14.2,
        "Height": 426,
        "Mileage": 34753872,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 105,
        "EngineRPM": 1774.5,
        "OnboardVoltage": 27859,
        "EngineSpeed": null,
        "TotalMileage": 394778115,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2121,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27069097,
        "Time": "2022-02-22T19:38:17",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2946548,
        "Lon": 86.14944,
        "Speed": 25.7,
        "Height": -12,
        "Mileage": 34759844,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 105,
        "EngineRPM": 1299.75,
        "OnboardVoltage": 27827,
        "EngineSpeed": null,
        "TotalMileage": 394784935,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2121,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27072494,
        "Time": "2022-02-22T20:01:39",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30446,
        "Lon": 86.1438446,
        "Speed": 16.2,
        "Height": 52,
        "Mileage": 34762688,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 107,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27872,
        "EngineSpeed": null,
        "TotalMileage": 394788595,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2121,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27075595,
        "Time": "2022-02-22T20:22:52",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30938,
        "Lon": 86.17089,
        "Speed": 6.2,
        "Height": 425,
        "Mileage": 34767720,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 108,
        "EngineRPM": 1427.25,
        "OnboardVoltage": 27880,
        "EngineSpeed": null,
        "TotalMileage": 394794435,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 70,
        "FuelConsumption": 236,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2122,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27077804,
        "Time": "2022-02-22T20:38:29",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2938,
        "Lon": 86.14999,
        "Speed": 14.8,
        "Height": -19,
        "Mileage": 34773716,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 106,
        "EngineRPM": 1300.0,
        "OnboardVoltage": 27842,
        "EngineSpeed": null,
        "TotalMileage": 394801285,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2122,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27080052,
        "Time": "2022-02-22T20:55:07",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.303257,
        "Lon": 86.14399,
        "Speed": 13.7,
        "Height": 62,
        "Mileage": 34776396,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1804.0,
        "OnboardVoltage": 27827,
        "EngineSpeed": null,
        "TotalMileage": 394804690,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 405,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2122,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27082871,
        "Time": "2022-02-22T21:15:18",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3096,
        "Lon": 86.17174,
        "Speed": 7.7,
        "Height": 435,
        "Mileage": 34781268,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 108,
        "EngineRPM": 1203.875,
        "OnboardVoltage": 27829,
        "EngineSpeed": null,
        "TotalMileage": 394810745,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 67,
        "FuelConsumption": 180,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2123,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27085069,
        "Time": "2022-02-22T21:32:58",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2937775,
        "Lon": 86.1499939,
        "Speed": 11.4,
        "Height": -25,
        "Mileage": 34787396,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1244.0,
        "OnboardVoltage": 27881,
        "EngineSpeed": null,
        "TotalMileage": 394817785,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 11,
        "FuelConsumption": 100,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2123,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27087415,
        "Time": "2022-02-22T21:50:50",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30477,
        "Lon": 86.14276,
        "Speed": 14.8,
        "Height": 78,
        "Mileage": 34790220,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 107,
        "EngineRPM": 1804.75,
        "OnboardVoltage": 27872,
        "EngineSpeed": null,
        "TotalMileage": 394821350,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2123,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27090499,
        "Time": "2022-02-22T22:10:35",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3093147,
        "Lon": 86.1728058,
        "Speed": 4.2,
        "Height": 434,
        "Mileage": 34794856,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 107,
        "EngineRPM": 1224.375,
        "OnboardVoltage": 27810,
        "EngineSpeed": null,
        "TotalMileage": 394827290,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 61,
        "FuelConsumption": 133,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2124,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27093846,
        "Time": "2022-02-22T22:40:11",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2777519,
        "Lon": 86.18431,
        "Speed": 27.9,
        "Height": 266,
        "Mileage": 34799472,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 91,
        "EngineRPM": 1191.375,
        "OnboardVoltage": 27763,
        "EngineSpeed": null,
        "TotalMileage": 394832500,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 17,
        "FuelConsumption": 134,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2124,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27096135,
        "Time": "2022-02-22T22:57:22",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3046074,
        "Lon": 86.1431046,
        "Speed": 25.7,
        "Height": 82,
        "Mileage": 34807420,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 74,
        "EngineRPM": 1300.0,
        "OnboardVoltage": 27854,
        "EngineSpeed": null,
        "TotalMileage": 394842005,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2124,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27099324,
        "Time": "2022-02-22T23:22:13",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2945976,
        "Lon": 86.14737,
        "Speed": 21.2,
        "Height": -34,
        "Mileage": 34810164,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 72,
        "EngineRPM": 1798.375,
        "OnboardVoltage": 27832,
        "EngineSpeed": null,
        "TotalMileage": 394845285,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 405,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2125,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27102092,
        "Time": "2022-02-22T23:42:20",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3030548,
        "Lon": 86.1636353,
        "Speed": 13.1,
        "Height": 314,
        "Mileage": 34815512,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 71,
        "EngineRPM": 1274.375,
        "OnboardVoltage": 27827,
        "EngineSpeed": null,
        "TotalMileage": 394852200,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2125,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27103804,
        "Time": "2022-02-22T23:55:19",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2947159,
        "Lon": 86.1475143,
        "Speed": 19.6,
        "Height": -35,
        "Mileage": 34820996,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 73,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27835,
        "EngineSpeed": null,
        "TotalMileage": 394859095,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2125,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27107322,
        "Time": "2022-02-23T00:23:26",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2939453,
        "Lon": 86.1500549,
        "Speed": 10.5,
        "Height": -12,
        "Mileage": 34822456,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 76,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27800,
        "EngineSpeed": null,
        "TotalMileage": 394860700,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 394,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2126,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27109577,
        "Time": "2022-02-23T00:50:20",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3089752,
        "Lon": 86.15925,
        "Speed": 10.9,
        "Height": 355,
        "Mileage": 34827096,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1791.375,
        "OnboardVoltage": 27777,
        "EngineSpeed": null,
        "TotalMileage": 394867030,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 398,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2126,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27111412,
        "Time": "2022-02-23T01:04:24",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3034859,
        "Lon": 86.13642,
        "Speed": 35.7,
        "Height": 120,
        "Mileage": 34832512,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 89,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27830,
        "EngineSpeed": null,
        "TotalMileage": 394873010,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2126,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27115138,
        "Time": "2022-02-23T01:36:40",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2956734,
        "Lon": 86.14383,
        "Speed": 17.7,
        "Height": -61,
        "Mileage": 34835316,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 90,
        "EngineRPM": 802.875,
        "OnboardVoltage": 27893,
        "EngineSpeed": null,
        "TotalMileage": 394876705,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 71,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2127,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118412,
        "Time": "2022-02-23T01:59:46",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3091049,
        "Lon": 86.15903,
        "Speed": 9.2,
        "Height": 345,
        "Mileage": 34840908,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 95,
        "EngineRPM": 1801.0,
        "OnboardVoltage": 27795,
        "EngineSpeed": null,
        "TotalMileage": 394883380,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 404,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2127,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27120492,
        "Time": "2022-02-23T02:14:35",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3045654,
        "Lon": 86.1432953,
        "Speed": 29.4,
        "Height": 77,
        "Mileage": 34847012,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27898,
        "EngineSpeed": null,
        "TotalMileage": 394890140,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2128,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27125564,
        "Time": "2022-02-23T02:51:26",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2943726,
        "Lon": 86.14572,
        "Speed": 17.4,
        "Height": -42,
        "Mileage": 34849716,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 97,
        "EngineRPM": 1285.25,
        "OnboardVoltage": 27837,
        "EngineSpeed": null,
        "TotalMileage": 394893360,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 73,
        "FuelConsumption": 223,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2128,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27129036,
        "Time": "2022-02-23T03:16:31",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3070068,
        "Lon": 86.17035,
        "Speed": 12.2,
        "Height": 419,
        "Mileage": 34855816,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 100,
        "EngineRPM": 1774.0,
        "OnboardVoltage": 27818,
        "EngineSpeed": null,
        "TotalMileage": 394900795,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2129,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27130426,
        "Time": "2022-02-23T03:26:57",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3045158,
        "Lon": 86.1423645,
        "Speed": 37.7,
        "Height": 85,
        "Mileage": 34860980,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 101,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27919,
        "EngineSpeed": null,
        "TotalMileage": 394906255,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2129,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27133397,
        "Time": "2022-02-23T03:47:14",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2936935,
        "Lon": 86.14964,
        "Speed": 9.6,
        "Height": -22,
        "Mileage": 34863972,
        "EngineOilPressure": 480,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 102,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27930,
        "EngineSpeed": null,
        "TotalMileage": 394910045,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 403,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2129,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27137235,
        "Time": "2022-02-23T04:11:49",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30686,
        "Lon": 86.16945,
        "Speed": 15.3,
        "Height": 404,
        "Mileage": 34869880,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 103,
        "EngineRPM": 1787.625,
        "OnboardVoltage": 27843,
        "EngineSpeed": null,
        "TotalMileage": 394917045,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2130,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27138801,
        "Time": "2022-02-23T04:22:27",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30603,
        "Lon": 86.13512,
        "Speed": 19.4,
        "Height": 147,
        "Mileage": 34874392,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 103,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27809,
        "EngineSpeed": null,
        "TotalMileage": 394922000,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2130,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27141495,
        "Time": "2022-02-23T04:39:45",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3098564,
        "Lon": 86.15771,
        "Speed": 9.0,
        "Height": 332,
        "Mileage": 34877940,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 106,
        "EngineRPM": 1796.375,
        "OnboardVoltage": 27987,
        "EngineSpeed": null,
        "TotalMileage": 394926485,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2130,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27143934,
        "Time": "2022-02-23T04:56:55",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31203,
        "Lon": 86.14635,
        "Speed": 0.0,
        "Height": 265,
        "Mileage": 34881720,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 101,
        "EngineRPM": 1129.25,
        "OnboardVoltage": 27876,
        "EngineSpeed": null,
        "TotalMileage": 394931185,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2130,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27148876,
        "Time": "2022-02-23T05:45:41",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30756,
        "Lon": 86.1373138,
        "Speed": 22.4,
        "Height": 157,
        "Mileage": 34884384,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 102,
        "EngineRPM": 807.25,
        "OnboardVoltage": 27875,
        "EngineSpeed": null,
        "TotalMileage": 394933980,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 9,
        "FuelConsumption": 76,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2131,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27151377,
        "Time": "2022-02-23T06:03:49",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3093452,
        "Lon": 86.17294,
        "Speed": 13.5,
        "Height": 434,
        "Mileage": 34888908,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 105,
        "EngineRPM": 1115.625,
        "OnboardVoltage": 27957,
        "EngineSpeed": null,
        "TotalMileage": 394939295,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 71,
        "FuelConsumption": 96,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2131,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27154551,
        "Time": "2022-02-23T06:27:11",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3059731,
        "Lon": 86.13488,
        "Speed": 11.4,
        "Height": 142,
        "Mileage": 34893308,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 100,
        "EngineRPM": 1299.625,
        "OnboardVoltage": 27877,
        "EngineSpeed": null,
        "TotalMileage": 394944170,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2132,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27158832,
        "Time": "2022-02-23T07:00:14",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.313606300000004,
        "Lon": 86.14932,
        "Speed": 20.7,
        "Height": 276,
        "Mileage": 34895996,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 101,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27900,
        "EngineSpeed": null,
        "TotalMileage": 394947645,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 332,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2132,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27161250,
        "Time": "2022-02-23T07:15:20",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3132172,
        "Lon": 86.14027,
        "Speed": 39.8,
        "Height": 233,
        "Mileage": 34900940,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 104,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27878,
        "EngineSpeed": null,
        "TotalMileage": 394953250,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2133,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27162459,
        "Time": "2022-02-23T07:24:03",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29498,
        "Lon": 86.1442642,
        "Speed": 23.8,
        "Height": -48,
        "Mileage": 34905020,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 101,
        "EngineRPM": 1294.0,
        "OnboardVoltage": 27855,
        "EngineSpeed": null,
        "TotalMileage": 394958075,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 28,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2133,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27168013,
        "Time": "2022-02-23T08:04:16",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2959328,
        "Lon": 86.1456,
        "Speed": 8.8,
        "Height": -36,
        "Mileage": 34905856,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 679.75,
        "OnboardVoltage": 27861,
        "EngineSpeed": null,
        "TotalMileage": 394959170,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2133,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27170576,
        "Time": "2022-02-23T08:24:11",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31042,
        "Lon": 86.15372,
        "Speed": 13.7,
        "Height": 311,
        "Mileage": 34910716,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 104,
        "EngineRPM": 1802.875,
        "OnboardVoltage": 27943,
        "EngineSpeed": null,
        "TotalMileage": 394965345,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 404,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2134,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27172211,
        "Time": "2022-02-23T08:38:15",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3102074,
        "Lon": 86.13257,
        "Speed": 32.0,
        "Height": 188,
        "Mileage": 34915900,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 106,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27919,
        "EngineSpeed": null,
        "TotalMileage": 394971105,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2134,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27174634,
        "Time": "2022-02-23T08:57:24",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30029,
        "Lon": 86.14609,
        "Speed": 12.9,
        "Height": 32,
        "Mileage": 34919272,
        "EngineOilPressure": 472,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 102,
        "EngineRPM": 1813.625,
        "OnboardVoltage": 27900,
        "EngineSpeed": null,
        "TotalMileage": 394975055,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 99,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2134,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27177383,
        "Time": "2022-02-23T09:21:00",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30834,
        "Lon": 86.17331,
        "Speed": 4.6,
        "Height": 438,
        "Mileage": 34924592,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 106,
        "EngineRPM": 827.625,
        "OnboardVoltage": 27916,
        "EngineSpeed": null,
        "TotalMileage": 394981660,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 45,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2135,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27181585,
        "Time": "2022-02-23T09:51:54",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3101273,
        "Lon": 86.13252,
        "Speed": 32.7,
        "Height": 178,
        "Mileage": 34928464,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 97,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27836,
        "EngineSpeed": null,
        "TotalMileage": 394985510,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2135,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27184618,
        "Time": "2022-02-23T10:15:22",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2944145,
        "Lon": 86.14471,
        "Speed": 20.9,
        "Height": -44,
        "Mileage": 34932284,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 68,
        "EngineRPM": 834.875,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 394989970,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 25,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2136,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27187445,
        "Time": "2022-02-23T10:38:29",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30676,
        "Lon": 86.16347,
        "Speed": 14.0,
        "Height": 379,
        "Mileage": 34937892,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 65,
        "EngineRPM": 1778.875,
        "OnboardVoltage": 27926,
        "EngineSpeed": null,
        "TotalMileage": 394997140,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2136,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27189358,
        "Time": "2022-02-23T10:51:29",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3043327,
        "Lon": 86.1435852,
        "Speed": 37.2,
        "Height": 76,
        "Mileage": 34943332,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 65,
        "EngineRPM": 1302.25,
        "OnboardVoltage": 27904,
        "EngineSpeed": null,
        "TotalMileage": 395003295,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2136,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27193185,
        "Time": "2022-02-23T11:19:43",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30467,
        "Lon": 86.14353,
        "Speed": 17.4,
        "Height": 82,
        "Mileage": 34945880,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 69,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27886,
        "EngineSpeed": null,
        "TotalMileage": 395006520,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 99,
        "FuelConsumption": 390,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2137,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27195885,
        "Time": "2022-02-23T11:39:48",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3081856,
        "Lon": 86.1716461,
        "Speed": 16.8,
        "Height": 432,
        "Mileage": 34950460,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 71,
        "EngineRPM": 745.875,
        "OnboardVoltage": 27842,
        "EngineSpeed": null,
        "TotalMileage": 395012565,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2137,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27197232,
        "Time": "2022-02-23T11:51:00",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29443,
        "Lon": 86.1483841,
        "Speed": 30.9,
        "Height": -33,
        "Mileage": 34956308,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 75,
        "EngineRPM": 731.75,
        "OnboardVoltage": 27849,
        "EngineSpeed": null,
        "TotalMileage": 395019520,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 76,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2137,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27200467,
        "Time": "2022-02-23T12:20:48",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30433,
        "Lon": 86.14389,
        "Speed": 14.6,
        "Height": 77,
        "Mileage": 34959140,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 81,
        "EngineRPM": 1805.875,
        "OnboardVoltage": 27774,
        "EngineSpeed": null,
        "TotalMileage": 395022985,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2138,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27205180,
        "Time": "2022-02-23T13:11:28",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3099136,
        "Lon": 86.1568756,
        "Speed": 10.7,
        "Height": 327,
        "Mileage": 34962608,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 90,
        "EngineRPM": 1780.75,
        "OnboardVoltage": 27883,
        "EngineSpeed": null,
        "TotalMileage": 395027345,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2139,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27206994,
        "Time": "2022-02-23T13:25:25",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31381,
        "Lon": 86.14123,
        "Speed": 28.5,
        "Height": 238,
        "Mileage": 34966628,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 92,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27820,
        "EngineSpeed": null,
        "TotalMileage": 395032070,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2139,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27209188,
        "Time": "2022-02-23T13:42:30",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2960052,
        "Lon": 86.14561,
        "Speed": 5.3,
        "Height": -36,
        "Mileage": 34970792,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 90,
        "EngineRPM": 1125.625,
        "OnboardVoltage": 27860,
        "EngineSpeed": null,
        "TotalMileage": 395037380,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2139,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27211618,
        "Time": "2022-02-23T14:01:21",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30991,
        "Lon": 86.132576,
        "Speed": 14.6,
        "Height": 176,
        "Mileage": 34974136,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 93,
        "EngineRPM": 1805.25,
        "OnboardVoltage": 27843,
        "EngineSpeed": null,
        "TotalMileage": 395041495,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 400,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2139,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27214028,
        "Time": "2022-02-23T14:18:24",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3072548,
        "Lon": 86.17061,
        "Speed": 21.6,
        "Height": 424,
        "Mileage": 34977808,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 96,
        "EngineRPM": 1287.25,
        "OnboardVoltage": 27894,
        "EngineSpeed": null,
        "TotalMileage": 395046155,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 10,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27215810,
        "Time": "2022-02-23T14:31:12",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2952843,
        "Lon": 86.14408,
        "Speed": 12.9,
        "Height": -51,
        "Mileage": 34983824,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 96,
        "EngineRPM": 1298.125,
        "OnboardVoltage": 27875,
        "EngineSpeed": null,
        "TotalMileage": 395053435,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27218479,
        "Time": "2022-02-23T14:52:56",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3036575,
        "Lon": 86.13638,
        "Speed": 11.8,
        "Height": 126,
        "Mileage": 34986640,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 98,
        "EngineRPM": 1795.875,
        "OnboardVoltage": 27832,
        "EngineSpeed": null,
        "TotalMileage": 395057110,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 404,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2140,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27220906,
        "Time": "2022-02-23T15:12:52",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3078575,
        "Lon": 86.17102,
        "Speed": 17.5,
        "Height": 429,
        "Mileage": 34991036,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 901.375,
        "OnboardVoltage": 27838,
        "EngineSpeed": null,
        "TotalMileage": 395062540,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 30,
        "FuelConsumption": 104,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2141,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27222516,
        "Time": "2022-02-23T15:24:44",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29481,
        "Lon": 86.14425,
        "Speed": 21.2,
        "Height": -39,
        "Mileage": 34996936,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 97,
        "EngineRPM": 1302.75,
        "OnboardVoltage": 27867,
        "EngineSpeed": null,
        "TotalMileage": 395069645,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2141,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27225586,
        "Time": "2022-02-23T15:46:18",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30363,
        "Lon": 86.13668,
        "Speed": 15.0,
        "Height": 116,
        "Mileage": 34999716,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1801.25,
        "OnboardVoltage": 27793,
        "EngineSpeed": null,
        "TotalMileage": 395073500,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2141,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27228416,
        "Time": "2022-02-23T16:05:34",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30894,
        "Lon": 86.17241,
        "Speed": 12.4,
        "Height": 434,
        "Mileage": 35003920,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 889.5,
        "OnboardVoltage": 27836,
        "EngineSpeed": null,
        "TotalMileage": 395079000,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 13,
        "FuelConsumption": 73,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2141,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27229861,
        "Time": "2022-02-23T16:17:14",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30144,
        "Lon": 86.1415558,
        "Speed": 13.5,
        "Height": 19,
        "Mileage": 35009208,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 100,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27813,
        "EngineSpeed": null,
        "TotalMileage": 395085385,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2142,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27234547,
        "Time": "2022-02-23T16:52:58",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30419,
        "Lon": 86.14035,
        "Speed": 13.8,
        "Height": 88,
        "Mileage": 35011336,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 102,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27835,
        "EngineSpeed": null,
        "TotalMileage": 395087995,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2142,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27239646,
        "Time": "2022-02-23T17:38:45",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3098335,
        "Lon": 86.15777,
        "Speed": 9.2,
        "Height": 330,
        "Mileage": 35014804,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 104,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27920,
        "EngineSpeed": null,
        "TotalMileage": 395092335,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2143,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27241676,
        "Time": "2022-02-23T17:54:01",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3060036,
        "Lon": 86.13469,
        "Speed": 33.1,
        "Height": 142,
        "Mileage": 35019828,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 103,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27834,
        "EngineSpeed": null,
        "TotalMileage": 395098390,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2143,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27243298,
        "Time": "2022-02-23T18:06:44",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29444,
        "Lon": 86.1447,
        "Speed": 17.5,
        "Height": -47,
        "Mileage": 35023076,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 105,
        "EngineRPM": 1159.375,
        "OnboardVoltage": 27847,
        "EngineSpeed": null,
        "TotalMileage": 395102440,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 64,
        "FuelConsumption": 153,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2143,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27245905,
        "Time": "2022-02-23T18:27:58",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.308033,
        "Lon": 86.16159,
        "Speed": 16.4,
        "Height": 366,
        "Mileage": 35028256,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 106,
        "EngineRPM": 1791.0,
        "OnboardVoltage": 27871,
        "EngineSpeed": null,
        "TotalMileage": 395109175,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2144,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27249021,
        "Time": "2022-02-23T18:51:25",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31304,
        "Lon": 86.14571,
        "Speed": 4.6,
        "Height": 270,
        "Mileage": 35031504,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 106,
        "EngineRPM": 1127.0,
        "OnboardVoltage": 27812,
        "EngineSpeed": null,
        "TotalMileage": 395113305,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2144,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27252388,
        "Time": "2022-02-23T19:15:43",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3003273,
        "Lon": 86.13849,
        "Speed": 6.2,
        "Height": 9,
        "Mileage": 35035280,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 88,
        "EngineRPM": 794.75,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 395117830,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2145,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27254998,
        "Time": "2022-02-23T19:35:48",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3101044,
        "Lon": 86.1327057,
        "Speed": 12.7,
        "Height": 172,
        "Mileage": 35038164,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 74,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27906,
        "EngineSpeed": null,
        "TotalMileage": 395121380,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2145,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27257539,
        "Time": "2022-02-23T19:54:06",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3068733,
        "Lon": 86.16381,
        "Speed": 26.4,
        "Height": 382,
        "Mileage": 35042360,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 75,
        "EngineRPM": 1294.75,
        "OnboardVoltage": 27894,
        "EngineSpeed": null,
        "TotalMileage": 395126295,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2145,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27259083,
        "Time": "2022-02-23T20:04:42",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3002739,
        "Lon": 86.13803,
        "Speed": 5.9,
        "Height": -1,
        "Mileage": 35047136,
        "EngineOilPressure": 232,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 75,
        "EngineRPM": 741.625,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 395132480,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 12,
        "FuelConsumption": 27,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2145,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27261281,
        "Time": "2022-02-23T20:20:34",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31011,
        "Lon": 86.1326752,
        "Speed": 14.4,
        "Height": 175,
        "Mileage": 35049940,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27866,
        "EngineSpeed": null,
        "TotalMileage": 395136010,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 98,
        "FuelConsumption": 392,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2146,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27264095,
        "Time": "2022-02-23T20:41:41",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31034,
        "Lon": 86.15441,
        "Speed": 33.5,
        "Height": 317,
        "Mileage": 35054880,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 1305.75,
        "OnboardVoltage": 27813,
        "EngineSpeed": null,
        "TotalMileage": 395141825,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2146,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27266524,
        "Time": "2022-02-23T21:01:20",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3062248,
        "Lon": 86.13569,
        "Speed": 20.1,
        "Height": 141,
        "Mileage": 35058096,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 78,
        "EngineRPM": 1296.75,
        "OnboardVoltage": 27827,
        "EngineSpeed": null,
        "TotalMileage": 395145855,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2146,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27268873,
        "Time": "2022-02-23T21:20:09",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30845,
        "Lon": 86.17243,
        "Speed": 8.5,
        "Height": 429,
        "Mileage": 35062128,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 833.75,
        "OnboardVoltage": 27865,
        "EngineSpeed": null,
        "TotalMileage": 395150985,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 14,
        "FuelConsumption": 35,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2147,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27270518,
        "Time": "2022-02-23T21:31:24",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3013039,
        "Lon": 86.1416855,
        "Speed": 18.7,
        "Height": 13,
        "Mileage": 35067428,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 84,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27907,
        "EngineSpeed": null,
        "TotalMileage": 395157360,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2147,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27273547,
        "Time": "2022-02-23T21:52:39",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30383,
        "Lon": 86.13621,
        "Speed": 9.6,
        "Height": 115,
        "Mileage": 35069704,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 89,
        "EngineRPM": 1806.25,
        "OnboardVoltage": 27882,
        "EngineSpeed": null,
        "TotalMileage": 395160270,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2147,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27276465,
        "Time": "2022-02-23T22:13:58",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3070145,
        "Lon": 86.17016,
        "Speed": 25.0,
        "Height": 421,
        "Mileage": 35074312,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 95,
        "EngineRPM": 1308.625,
        "OnboardVoltage": 27815,
        "EngineSpeed": null,
        "TotalMileage": 395165695,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2148,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27278299,
        "Time": "2022-02-23T22:26:22",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3003922,
        "Lon": 86.13853,
        "Speed": 0.0,
        "Height": 18,
        "Mileage": 35079544,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 91,
        "EngineRPM": 812.75,
        "OnboardVoltage": 27867,
        "EngineSpeed": null,
        "TotalMileage": 395172460,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 37,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2148,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27281737,
        "Time": "2022-02-23T22:49:58",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3037834,
        "Lon": 86.13628,
        "Speed": 11.1,
        "Height": 123,
        "Mileage": 35081640,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 93,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27864,
        "EngineSpeed": null,
        "TotalMileage": 395174980,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 399,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2148,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27284708,
        "Time": "2022-02-23T23:10:13",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30852,
        "Lon": 86.17283,
        "Speed": 14.0,
        "Height": 438,
        "Mileage": 35086036,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 97,
        "EngineRPM": 778.625,
        "OnboardVoltage": 27914,
        "EngineSpeed": null,
        "TotalMileage": 395180330,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 27,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2149,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27286408,
        "Time": "2022-02-23T23:21:00",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3016434,
        "Lon": 86.14238,
        "Speed": 22.2,
        "Height": 6,
        "Mileage": 35091340,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 96,
        "EngineRPM": 1296.0,
        "OnboardVoltage": 27848,
        "EngineSpeed": null,
        "TotalMileage": 395186630,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2149,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27289434,
        "Time": "2022-02-23T23:42:52",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3048439,
        "Lon": 86.14337,
        "Speed": 11.1,
        "Height": 70,
        "Mileage": 35093444,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 96,
        "EngineRPM": 1694.5,
        "OnboardVoltage": 27881,
        "EngineSpeed": null,
        "TotalMileage": 395189185,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 343,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2149,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27293116,
        "Time": "2022-02-24T00:08:45",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3088722,
        "Lon": 86.17344,
        "Speed": 4.0,
        "Height": 429,
        "Mileage": 35099056,
        "EngineOilPressure": 284,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 100,
        "EngineRPM": 880.875,
        "OnboardVoltage": 27782,
        "EngineSpeed": null,
        "TotalMileage": 395195165,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 7,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2150,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27295368,
        "Time": "2022-02-24T00:24:29",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3036041,
        "Lon": 86.13686,
        "Speed": 21.6,
        "Height": 107,
        "Mileage": 35104648,
        "EngineOilPressure": 476,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27871,
        "EngineSpeed": null,
        "TotalMileage": 395201050,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 54,
        "FuelConsumption": 256,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2150,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27300965,
        "Time": "2022-02-24T01:21:28",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.31375,
        "Lon": 86.14105,
        "Speed": 32.0,
        "Height": 237,
        "Mileage": 35107628,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 99,
        "EngineRPM": 1301.375,
        "OnboardVoltage": 27845,
        "EngineSpeed": null,
        "TotalMileage": 395204390,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2151,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27305422,
        "Time": "2022-02-24T01:51:59",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.2959,
        "Lon": 86.14616,
        "Speed": 6.6,
        "Height": -43,
        "Mileage": 35111712,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 101,
        "EngineRPM": 1125.625,
        "OnboardVoltage": 27889,
        "EngineSpeed": null,
        "TotalMileage": 395209600,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2151,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27308610,
        "Time": "2022-02-24T02:12:09",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.310173,
        "Lon": 86.1326,
        "Speed": 12.9,
        "Height": 180,
        "Mileage": 35115028,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 103,
        "EngineRPM": 1811.75,
        "OnboardVoltage": 27922,
        "EngineSpeed": null,
        "TotalMileage": 395213650,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 402,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2152,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27311177,
        "Time": "2022-02-24T02:29:52",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30701,
        "Lon": 86.1652451,
        "Speed": 34.4,
        "Height": 383,
        "Mileage": 35119088,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 104,
        "EngineRPM": 1299.125,
        "OnboardVoltage": 27869,
        "EngineSpeed": null,
        "TotalMileage": 395218505,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2152,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27312872,
        "Time": "2022-02-24T02:41:20",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.29625,
        "Lon": 86.14401,
        "Speed": 19.0,
        "Height": -38,
        "Mileage": 35124696,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 102,
        "EngineRPM": 765.375,
        "OnboardVoltage": 27817,
        "EngineSpeed": null,
        "TotalMileage": 395225650,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 74,
        "FuelConsumption": 99,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2152,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27317650,
        "Time": "2022-02-24T03:15:50",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3039131,
        "Lon": 86.14381,
        "Speed": 13.7,
        "Height": 86,
        "Mileage": 35126888,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 102,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27896,
        "EngineSpeed": null,
        "TotalMileage": 395228465,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 405,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2153,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27320756,
        "Time": "2022-02-24T03:36:12",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.3095741,
        "Lon": 86.173,
        "Speed": 9.2,
        "Height": 436,
        "Mileage": 35131804,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 105,
        "EngineRPM": 1093.875,
        "OnboardVoltage": 27907,
        "EngineSpeed": null,
        "TotalMileage": 395234570,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 74,
        "FuelConsumption": 83,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2153,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27322686,
        "Time": "2022-02-24T03:48:26",
        "TruckId": 821,
        "Imei": "868328058798675",
        "Lat": 54.30736,
        "Lon": 86.13868,
        "Speed": 8.8,
        "Height": 154,
        "Mileage": 35136272,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 105,
        "EngineRPM": 1204.75,
        "OnboardVoltage": 27839,
        "EngineSpeed": null,
        "TotalMileage": 395239865,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 77,
        "FuelConsumption": 166,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 2153,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27004165,
        "Time": "2022-02-22T10:53:37",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2423744,
        "Lon": 86.14184,
        "Speed": 4.4,
        "Height": 329,
        "Mileage": 53906856,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 721.25,
        "OnboardVoltage": 27767,
        "EngineSpeed": null,
        "TotalMileage": 95641380,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 19,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5772,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27005705,
        "Time": "2022-02-22T11:06:17",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2693748,
        "Lon": 86.16471,
        "Speed": 8.7,
        "Height": 107,
        "Mileage": 53912708,
        "EngineOilPressure": 336,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 851.75,
        "OnboardVoltage": 27749,
        "EngineSpeed": null,
        "TotalMileage": 95647140,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5772,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27010550,
        "Time": "2022-02-22T11:29:48",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2429428,
        "Lon": 86.1474,
        "Speed": 21.6,
        "Height": 340,
        "Mileage": 53917860,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1717.75,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 95652210,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 234,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5772,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27010923,
        "Time": "2022-02-22T11:41:31",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2594223,
        "Lon": 86.17676,
        "Speed": 34.0,
        "Height": 196,
        "Mileage": 53922748,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 82,
        "EngineRPM": 1305.125,
        "OnboardVoltage": 27724,
        "EngineSpeed": null,
        "TotalMileage": 95657240,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5773,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27014652,
        "Time": "2022-02-22T12:16:06",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26131,
        "Lon": 86.17342,
        "Speed": 20.1,
        "Height": 217,
        "Mileage": 53926104,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 80,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27675,
        "EngineSpeed": null,
        "TotalMileage": 95660745,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 396,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7068,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.4
    },
    {
        "Id": 27016664,
        "Time": "2022-02-22T12:30:56",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2425842,
        "Lon": 86.14707,
        "Speed": 16.2,
        "Height": 334,
        "Mileage": 53930512,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 85,
        "EngineRPM": 1497.25,
        "OnboardVoltage": 27717,
        "EngineSpeed": null,
        "TotalMileage": 95665420,
        "AcceleratorPedalPosition": 37,
        "LoadPercentage": 1,
        "FuelConsumption": 241,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5773,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.0
    },
    {
        "Id": 27021448,
        "Time": "2022-02-22T13:19:23",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25549,
        "Lon": 86.173645,
        "Speed": 25.9,
        "Height": 279,
        "Mileage": 53933624,
        "EngineOilPressure": 328,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1319.0,
        "OnboardVoltage": 27681,
        "EngineSpeed": null,
        "TotalMileage": 95668505,
        "AcceleratorPedalPosition": 55,
        "LoadPercentage": 56,
        "FuelConsumption": 116,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5774,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 55.600002
    },
    {
        "Id": 27025193,
        "Time": "2022-02-22T13:52:52",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26979,
        "Lon": 86.16495,
        "Speed": 9.8,
        "Height": 100,
        "Mileage": 53936868,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 87,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27773,
        "EngineSpeed": null,
        "TotalMileage": 95671860,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 18,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5775,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.0
    },
    {
        "Id": 27029456,
        "Time": "2022-02-22T14:13:11",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2431831,
        "Lon": 86.1493,
        "Speed": 30.0,
        "Height": 330,
        "Mileage": 53941960,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 87,
        "EngineRPM": 1733.625,
        "OnboardVoltage": 27635,
        "EngineSpeed": null,
        "TotalMileage": 95676950,
        "AcceleratorPedalPosition": 85,
        "LoadPercentage": 87,
        "FuelConsumption": 320,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5775,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 53.600002
    },
    {
        "Id": 27029966,
        "Time": "2022-02-22T14:26:15",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2620964,
        "Lon": 86.17227,
        "Speed": 27.0,
        "Height": 211,
        "Mileage": 53946880,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 85,
        "EngineRPM": 1298.0,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 95681630,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5775,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27034396,
        "Time": "2022-02-22T14:59:46",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2595673,
        "Lon": 86.17686,
        "Speed": 16.4,
        "Height": 188,
        "Mileage": 53950236,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1807.125,
        "OnboardVoltage": 27695,
        "EngineSpeed": null,
        "TotalMileage": 95685085,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 94,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7071,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 52.4
    },
    {
        "Id": 27036845,
        "Time": "2022-02-22T15:16:30",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.24266,
        "Lon": 86.14713,
        "Speed": 13.5,
        "Height": 334,
        "Mileage": 53954640,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 86,
        "EngineRPM": 1360.0,
        "OnboardVoltage": 27690,
        "EngineSpeed": null,
        "TotalMileage": 95689815,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 72,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7071,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 48.0
    },
    {
        "Id": 27040062,
        "Time": "2022-02-22T15:40:50",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26984,
        "Lon": 86.16509,
        "Speed": 6.8,
        "Height": 109,
        "Mileage": 53960304,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 86,
        "EngineRPM": 1158.875,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 95695270,
        "AcceleratorPedalPosition": 2,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5777,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 47.600002
    },
    {
        "Id": 27044684,
        "Time": "2022-02-22T16:06:49",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.24708,
        "Lon": 86.15461,
        "Speed": 38.7,
        "Height": 333,
        "Mileage": 53964792,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 84,
        "EngineRPM": 1543.75,
        "OnboardVoltage": 27690,
        "EngineSpeed": null,
        "TotalMileage": 95699755,
        "AcceleratorPedalPosition": 73,
        "LoadPercentage": 52,
        "FuelConsumption": 322,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5777,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.4
    },
    {
        "Id": 27044793,
        "Time": "2022-02-22T16:19:29",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.262104,
        "Lon": 86.17199,
        "Speed": 29.8,
        "Height": 220,
        "Mileage": 53969988,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1292.625,
        "OnboardVoltage": 27664,
        "EngineSpeed": null,
        "TotalMileage": 95704905,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7072,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 46.0
    },
    {
        "Id": 27049223,
        "Time": "2022-02-22T16:55:03",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2594948,
        "Lon": 86.17669,
        "Speed": 17.2,
        "Height": 187,
        "Mileage": 53973612,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 86,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27803,
        "EngineSpeed": null,
        "TotalMileage": 95708580,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5778,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 44.0
    },
    {
        "Id": 27051442,
        "Time": "2022-02-22T17:11:59",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25404,
        "Lon": 86.16165,
        "Speed": 33.1,
        "Height": 309,
        "Mileage": 53979620,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27680,
        "EngineSpeed": null,
        "TotalMileage": 95714785,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5778,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.8
    },
    {
        "Id": 27052520,
        "Time": "2022-02-22T17:22:30",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2688065,
        "Lon": 86.17098,
        "Speed": 31.4,
        "Height": 35,
        "Mileage": 53984176,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 959.625,
        "OnboardVoltage": 27722,
        "EngineSpeed": null,
        "TotalMileage": 95719600,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 122,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5778,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 40.8
    },
    {
        "Id": 27056166,
        "Time": "2022-02-22T17:55:52",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2725372,
        "Lon": 86.16532,
        "Speed": 21.1,
        "Height": 55,
        "Mileage": 53986328,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 85,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27734,
        "EngineSpeed": null,
        "TotalMileage": 95721570,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 376,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5779,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 39.600002
    },
    {
        "Id": 27058181,
        "Time": "2022-02-22T18:13:33",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2424355,
        "Lon": 86.1419144,
        "Speed": 8.7,
        "Height": 323,
        "Mileage": 53992208,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1800.125,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 95727755,
        "AcceleratorPedalPosition": 73,
        "LoadPercentage": 51,
        "FuelConsumption": 250,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7074,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.4
    },
    {
        "Id": 27061420,
        "Time": "2022-02-22T18:41:59",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2596626,
        "Lon": 86.17561,
        "Speed": 38.1,
        "Height": 197,
        "Mileage": 53996948,
        "EngineOilPressure": 280,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 1221.875,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 95732215,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 73,
        "FuelConsumption": 157,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5780,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 36.4
    },
    {
        "Id": 27066313,
        "Time": "2022-02-22T19:15:37",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2702751,
        "Lon": 86.17707,
        "Speed": 4.6,
        "Height": 76,
        "Mileage": 54000160,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 87,
        "EngineRPM": 819.875,
        "OnboardVoltage": 27741,
        "EngineSpeed": null,
        "TotalMileage": 95735670,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 27,
        "FuelConsumption": 15,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5780,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 34.0
    },
    {
        "Id": 27068041,
        "Time": "2022-02-22T19:30:09",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2558556,
        "Lon": 86.1748,
        "Speed": 15.3,
        "Height": 275,
        "Mileage": 54004364,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 85,
        "EngineRPM": 1810.875,
        "OnboardVoltage": 27681,
        "EngineSpeed": null,
        "TotalMileage": 95739915,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5780,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.8
    },
    {
        "Id": 27070148,
        "Time": "2022-02-22T19:45:00",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.255928,
        "Lon": 86.1637955,
        "Speed": 33.1,
        "Height": 288,
        "Mileage": 54010148,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 95745520,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5781,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.0
    },
    {
        "Id": 27074265,
        "Time": "2022-02-22T20:13:28",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2711868,
        "Lon": 86.16542,
        "Speed": 43.1,
        "Height": 60,
        "Mileage": 54014280,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 68,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27682,
        "EngineSpeed": null,
        "TotalMileage": 95749530,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5781,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 30.4
    },
    {
        "Id": 27078570,
        "Time": "2022-02-22T20:44:12",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26819,
        "Lon": 86.16637,
        "Speed": 16.8,
        "Height": 100,
        "Mileage": 54016040,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 69,
        "EngineRPM": 985.0,
        "OnboardVoltage": 27755,
        "EngineSpeed": null,
        "TotalMileage": 95751350,
        "AcceleratorPedalPosition": 48,
        "LoadPercentage": 61,
        "FuelConsumption": 41,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5782,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27081966,
        "Time": "2022-02-22T20:59:44",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.24243,
        "Lon": 86.14196,
        "Speed": 13.5,
        "Height": 327,
        "Mileage": 54021448,
        "EngineOilPressure": 320,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 65,
        "EngineRPM": 1522.375,
        "OnboardVoltage": 27712,
        "EngineSpeed": null,
        "TotalMileage": 95756990,
        "AcceleratorPedalPosition": 55,
        "LoadPercentage": 14,
        "FuelConsumption": 260,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5782,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27082375,
        "Time": "2022-02-22T21:11:10",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26387,
        "Lon": 86.17301,
        "Speed": 37.7,
        "Height": 157,
        "Mileage": 54026688,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 67,
        "EngineRPM": 1298.75,
        "OnboardVoltage": 27695,
        "EngineSpeed": null,
        "TotalMileage": 95762110,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5782,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.6
    },
    {
        "Id": 27084731,
        "Time": "2022-02-22T21:30:48",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25761,
        "Lon": 86.17456,
        "Speed": 12.5,
        "Height": 265,
        "Mileage": 54030056,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 63,
        "EngineRPM": 1809.75,
        "OnboardVoltage": 27741,
        "EngineSpeed": null,
        "TotalMileage": 95765715,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 390,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5782,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27086649,
        "Time": "2022-02-22T21:44:55",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2478065,
        "Lon": 86.155426,
        "Speed": 33.7,
        "Height": 336,
        "Mileage": 54034856,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 63,
        "EngineRPM": 936.75,
        "OnboardVoltage": 27778,
        "EngineSpeed": null,
        "TotalMileage": 95770320,
        "AcceleratorPedalPosition": 11,
        "LoadPercentage": 48,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5783,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.200005
    },
    {
        "Id": 27090424,
        "Time": "2022-02-22T22:10:29",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2696342,
        "Lon": 86.1766052,
        "Speed": 15.0,
        "Height": 47,
        "Mileage": 54040972,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 78,
        "EngineRPM": 723.25,
        "OnboardVoltage": 27787,
        "EngineSpeed": null,
        "TotalMileage": 95776740,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5783,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27099133,
        "Time": "2022-02-22T23:19:53",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.272583,
        "Lon": 86.16518,
        "Speed": 16.2,
        "Height": 59,
        "Mileage": 54042520,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 76,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27722,
        "EngineSpeed": null,
        "TotalMileage": 95778095,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5784,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.0
    },
    {
        "Id": 27101644,
        "Time": "2022-02-22T23:36:06",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2476234,
        "Lon": 86.15515,
        "Speed": 25.9,
        "Height": 333,
        "Mileage": 54047224,
        "EngineOilPressure": 292,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 78,
        "EngineRPM": 1411.0,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 95782660,
        "AcceleratorPedalPosition": 71,
        "LoadPercentage": 61,
        "FuelConsumption": 148,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5784,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 70.0
    },
    {
        "Id": 27102938,
        "Time": "2022-02-22T23:48:43",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25958,
        "Lon": 86.1771,
        "Speed": 30.3,
        "Height": 195,
        "Mileage": 54052520,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 78,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27711,
        "EngineSpeed": null,
        "TotalMileage": 95788320,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5785,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27107886,
        "Time": "2022-02-23T00:27:44",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.262352,
        "Lon": 86.17216,
        "Speed": 21.2,
        "Height": 222,
        "Mileage": 54055928,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 79,
        "EngineRPM": 1812.875,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 95791845,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 388,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5785,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 67.200005
    },
    {
        "Id": 27110689,
        "Time": "2022-02-23T00:57:35",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.24278,
        "Lon": 86.14711,
        "Speed": 18.1,
        "Height": 342,
        "Mileage": 54059408,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 1723.0,
        "OnboardVoltage": 27716,
        "EngineSpeed": null,
        "TotalMileage": 95795450,
        "AcceleratorPedalPosition": 85,
        "LoadPercentage": 69,
        "FuelConsumption": 279,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5786,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27111907,
        "Time": "2022-02-23T01:08:19",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2609062,
        "Lon": 86.17365,
        "Speed": 38.3,
        "Height": 211,
        "Mileage": 54064104,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 81,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27694,
        "EngineSpeed": null,
        "TotalMileage": 95800080,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5786,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27115280,
        "Time": "2022-02-23T01:37:22",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.269928,
        "Lon": 86.17738,
        "Speed": 10.7,
        "Height": 76,
        "Mileage": 54067648,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 86,
        "EngineRPM": 1090.875,
        "OnboardVoltage": 27770,
        "EngineSpeed": null,
        "TotalMileage": 95803760,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 75,
        "FuelConsumption": 136,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7081,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27117639,
        "Time": "2022-02-23T01:54:28",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2560463,
        "Lon": 86.16549,
        "Speed": 27.2,
        "Height": 278,
        "Mileage": 54072424,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1520.125,
        "OnboardVoltage": 27770,
        "EngineSpeed": null,
        "TotalMileage": 95808340,
        "AcceleratorPedalPosition": 83,
        "LoadPercentage": 53,
        "FuelConsumption": 160,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5787,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27119608,
        "Time": "2022-02-23T02:08:16",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2561836,
        "Lon": 86.17531,
        "Speed": 35.3,
        "Height": 276,
        "Mileage": 54078276,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 83,
        "EngineRPM": 772.25,
        "OnboardVoltage": 27739,
        "EngineSpeed": null,
        "TotalMileage": 95814270,
        "AcceleratorPedalPosition": 39,
        "LoadPercentage": 32,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5787,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.0
    },
    {
        "Id": 27124449,
        "Time": "2022-02-23T02:43:54",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26973,
        "Lon": 86.17705,
        "Speed": 8.5,
        "Height": 72,
        "Mileage": 54082420,
        "EngineOilPressure": 224,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 84,
        "EngineRPM": 705.875,
        "OnboardVoltage": 27735,
        "EngineSpeed": null,
        "TotalMileage": 95818650,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 43,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5788,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27127716,
        "Time": "2022-02-23T03:06:55",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26744,
        "Lon": 86.1743546,
        "Speed": 26.4,
        "Height": 46,
        "Mileage": 54084832,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 714.75,
        "OnboardVoltage": 27772,
        "EngineSpeed": null,
        "TotalMileage": 95820930,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5788,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 60.8
    },
    {
        "Id": 27130991,
        "Time": "2022-02-23T03:30:15",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2723274,
        "Lon": 86.16462,
        "Speed": 0.0,
        "Height": 63,
        "Mileage": 54086876,
        "EngineOilPressure": 348,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 86,
        "EngineRPM": 1203.625,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 95823045,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5788,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.2
    },
    {
        "Id": 27136579,
        "Time": "2022-02-23T03:47:49",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.269207,
        "Lon": 86.17492,
        "Speed": 22.0,
        "Height": 60,
        "Mileage": 54088776,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 84,
        "EngineRPM": 1323.125,
        "OnboardVoltage": 27751,
        "EngineSpeed": null,
        "TotalMileage": 95824655,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5789,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.2
    },
    {
        "Id": 27135001,
        "Time": "2022-02-23T03:57:30",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2702866,
        "Lon": 86.17741,
        "Speed": 4.0,
        "Height": 80,
        "Mileage": 54091548,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 86,
        "EngineRPM": 687.5,
        "OnboardVoltage": 27676,
        "EngineSpeed": null,
        "TotalMileage": 95827525,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 19,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5789,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27137864,
        "Time": "2022-02-23T04:15:28",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2704,
        "Lon": 86.1770248,
        "Speed": 10.9,
        "Height": 74,
        "Mileage": 54094436,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 86,
        "EngineRPM": 706.625,
        "OnboardVoltage": 27840,
        "EngineSpeed": null,
        "TotalMileage": 95830260,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5789,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.4
    },
    {
        "Id": 27140291,
        "Time": "2022-02-23T04:30:13",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.267952,
        "Lon": 86.17475,
        "Speed": 35.3,
        "Height": 44,
        "Mileage": 54097036,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 86,
        "EngineRPM": 1716.75,
        "OnboardVoltage": 27816,
        "EngineSpeed": null,
        "TotalMileage": 95832530,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 47,
        "FuelConsumption": 223,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5789,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.0
    },
    {
        "Id": 27144200,
        "Time": "2022-02-23T04:58:57",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26688,
        "Lon": 86.187294,
        "Speed": 13.3,
        "Height": 205,
        "Mileage": 54099808,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 85,
        "EngineRPM": 1809.0,
        "OnboardVoltage": 27752,
        "EngineSpeed": null,
        "TotalMileage": 95835370,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5790,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27145951,
        "Time": "2022-02-23T05:16:12",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.30882,
        "Lon": 86.17273,
        "Speed": 12.9,
        "Height": 437,
        "Mileage": 54105232,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 85,
        "EngineRPM": 664.25,
        "OnboardVoltage": 27758,
        "EngineSpeed": null,
        "TotalMileage": 95840890,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5790,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 56.8
    },
    {
        "Id": 27152154,
        "Time": "2022-02-23T06:09:43",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.313633,
        "Lon": 86.14733,
        "Speed": 20.9,
        "Height": 271,
        "Mileage": 54107728,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 70,
        "EngineRPM": 1109.375,
        "OnboardVoltage": 27833,
        "EngineSpeed": null,
        "TotalMileage": 95843280,
        "AcceleratorPedalPosition": 22,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5791,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 92.8
    },
    {
        "Id": 27154062,
        "Time": "2022-02-23T06:23:19",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.27561,
        "Lon": 86.1762848,
        "Speed": 23.3,
        "Height": 100,
        "Mileage": 54116088,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 66,
        "EngineRPM": 1289.875,
        "OnboardVoltage": 27815,
        "EngineSpeed": null,
        "TotalMileage": 95851330,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5791,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.4
    },
    {
        "Id": 27157655,
        "Time": "2022-02-23T06:51:14",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.27228,
        "Lon": 86.16478,
        "Speed": 5.9,
        "Height": 65,
        "Mileage": 54118544,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 69,
        "EngineRPM": 1431.25,
        "OnboardVoltage": 27780,
        "EngineSpeed": null,
        "TotalMileage": 95853990,
        "AcceleratorPedalPosition": 97,
        "LoadPercentage": 97,
        "FuelConsumption": 140,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5792,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 94.0
    },
    {
        "Id": 27160449,
        "Time": "2022-02-23T07:10:22",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2425842,
        "Lon": 86.1413956,
        "Speed": 12.7,
        "Height": 325,
        "Mileage": 54124684,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 64,
        "EngineRPM": 1310.75,
        "OnboardVoltage": 27747,
        "EngineSpeed": null,
        "TotalMileage": 95860160,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5792,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27164804,
        "Time": "2022-02-23T07:23:18",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2706451,
        "Lon": 86.1658554,
        "Speed": 31.2,
        "Height": 76,
        "Mileage": 54130848,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 66,
        "EngineRPM": 1303.375,
        "OnboardVoltage": 27751,
        "EngineSpeed": null,
        "TotalMileage": 95866070,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5792,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.8
    },
    {
        "Id": 27164751,
        "Time": "2022-02-23T07:40:42",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26746,
        "Lon": 86.1737442,
        "Speed": 29.6,
        "Height": 43,
        "Mileage": 54132932,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 71,
        "EngineRPM": 1297.125,
        "OnboardVoltage": 27786,
        "EngineSpeed": null,
        "TotalMileage": 95868285,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5793,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.4
    },
    {
        "Id": 27166217,
        "Time": "2022-02-23T07:48:54",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.27028,
        "Lon": 86.17692,
        "Speed": 5.3,
        "Height": 76,
        "Mileage": 54135324,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 71,
        "EngineRPM": 1111.25,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 95870780,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 233,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7088,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.8
    },
    {
        "Id": 27167858,
        "Time": "2022-02-23T08:01:33",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2674065,
        "Lon": 86.17384,
        "Speed": 25.7,
        "Height": 37,
        "Mileage": 54137868,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 71,
        "EngineRPM": 847.0,
        "OnboardVoltage": 27812,
        "EngineSpeed": null,
        "TotalMileage": 95873160,
        "AcceleratorPedalPosition": 30,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5793,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.8
    },
    {
        "Id": 27170347,
        "Time": "2022-02-23T08:22:36",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2720528,
        "Lon": 86.16474,
        "Speed": 12.7,
        "Height": 65,
        "Mileage": 54139836,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 76,
        "EngineRPM": 753.125,
        "OnboardVoltage": 27767,
        "EngineSpeed": null,
        "TotalMileage": 95875380,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5793,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27174169,
        "Time": "2022-02-23T08:52:55",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2696152,
        "Lon": 86.17728,
        "Speed": 20.3,
        "Height": 56,
        "Mileage": 54141460,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 77,
        "EngineRPM": 701.625,
        "OnboardVoltage": 27748,
        "EngineSpeed": null,
        "TotalMileage": 95876865,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5794,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.6
    },
    {
        "Id": 27177124,
        "Time": "2022-02-23T09:18:19",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2695541,
        "Lon": 86.17627,
        "Speed": 0.0,
        "Height": 69,
        "Mileage": 54144180,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 815.875,
        "OnboardVoltage": 27769,
        "EngineSpeed": null,
        "TotalMileage": 95879655,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 15,
        "FuelConsumption": 45,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5794,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27179639,
        "Time": "2022-02-23T09:38:43",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2724571,
        "Lon": 86.1647644,
        "Speed": 9.6,
        "Height": 62,
        "Mileage": 54145932,
        "EngineOilPressure": 256,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 76,
        "EngineRPM": 943.375,
        "OnboardVoltage": 27740,
        "EngineSpeed": null,
        "TotalMileage": 95881300,
        "AcceleratorPedalPosition": 12,
        "LoadPercentage": 0,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5795,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.200005
    },
    {
        "Id": 27182069,
        "Time": "2022-02-23T09:54:44",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2710152,
        "Lon": 86.16729,
        "Speed": 19.6,
        "Height": 52,
        "Mileage": 54148572,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 81,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27773,
        "EngineSpeed": null,
        "TotalMileage": 95883550,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 358,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7090,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.4
    },
    {
        "Id": 27188780,
        "Time": "2022-02-23T10:43:51",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.27035,
        "Lon": 86.17726,
        "Speed": 7.0,
        "Height": 64,
        "Mileage": 54150368,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 83,
        "EngineRPM": 983.75,
        "OnboardVoltage": 27835,
        "EngineSpeed": null,
        "TotalMileage": 95885565,
        "AcceleratorPedalPosition": 17,
        "LoadPercentage": 32,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5796,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27192394,
        "Time": "2022-02-23T11:14:09",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2703,
        "Lon": 86.1767654,
        "Speed": 9.2,
        "Height": 84,
        "Mileage": 54153180,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 84,
        "EngineRPM": 822.5,
        "OnboardVoltage": 27783,
        "EngineSpeed": null,
        "TotalMileage": 95888365,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 36,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5796,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27194224,
        "Time": "2022-02-23T11:26:41",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2695122,
        "Lon": 86.1762,
        "Speed": 0.0,
        "Height": 65,
        "Mileage": 54155988,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 80,
        "EngineRPM": 675.25,
        "OnboardVoltage": 27819,
        "EngineSpeed": null,
        "TotalMileage": 95891090,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5796,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.6
    },
    {
        "Id": 27200285,
        "Time": "2022-02-23T12:19:01",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2784653,
        "Lon": 86.188385,
        "Speed": 0.0,
        "Height": 260,
        "Mileage": 54159852,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 83,
        "EngineRPM": 1123.125,
        "OnboardVoltage": 27844,
        "EngineSpeed": null,
        "TotalMileage": 95894985,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5797,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 78.0
    },
    {
        "Id": 27201915,
        "Time": "2022-02-23T12:37:10",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.27246,
        "Lon": 86.16488,
        "Speed": 14.4,
        "Height": 50,
        "Mileage": 54164696,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 81,
        "EngineRPM": 1789.5,
        "OnboardVoltage": 27790,
        "EngineSpeed": null,
        "TotalMileage": 95899750,
        "AcceleratorPedalPosition": 96,
        "LoadPercentage": 82,
        "FuelConsumption": 302,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5798,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 77.200005
    },
    {
        "Id": 27204956,
        "Time": "2022-02-23T13:08:59",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26928,
        "Lon": 86.16957,
        "Speed": 27.9,
        "Height": 32,
        "Mileage": 54166928,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 85,
        "EngineRPM": 1303.875,
        "OnboardVoltage": 27689,
        "EngineSpeed": null,
        "TotalMileage": 95901790,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7093,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.0
    },
    {
        "Id": 27206754,
        "Time": "2022-02-23T13:23:45",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2849159,
        "Lon": 86.1785,
        "Speed": 16.1,
        "Height": 273,
        "Mileage": 54171932,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 85,
        "EngineRPM": 1615.0,
        "OnboardVoltage": 27721,
        "EngineSpeed": null,
        "TotalMileage": 95907270,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 383,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5798,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27208304,
        "Time": "2022-02-23T13:34:52",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2674942,
        "Lon": 86.17445,
        "Speed": 26.8,
        "Height": 39,
        "Mileage": 54176924,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 84,
        "EngineRPM": 1293.375,
        "OnboardVoltage": 27711,
        "EngineSpeed": null,
        "TotalMileage": 95912125,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 3,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7093,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27211514,
        "Time": "2022-02-23T14:00:40",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26969,
        "Lon": 86.1644,
        "Speed": 5.1,
        "Height": 138,
        "Mileage": 54179344,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 87,
        "EngineRPM": 674.625,
        "OnboardVoltage": 27744,
        "EngineSpeed": null,
        "TotalMileage": 95914655,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 44,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5799,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 73.6
    },
    {
        "Id": 27214484,
        "Time": "2022-02-23T14:17:39",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2411766,
        "Lon": 86.14502,
        "Speed": 17.2,
        "Height": 318,
        "Mileage": 54184708,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 85,
        "EngineRPM": 1305.875,
        "OnboardVoltage": 27722,
        "EngineSpeed": null,
        "TotalMileage": 95920240,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5799,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27215551,
        "Time": "2022-02-23T14:28:37",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.262043,
        "Lon": 86.1724854,
        "Speed": 20.5,
        "Height": 212,
        "Mileage": 54189184,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 86,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 95924640,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5799,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27219483,
        "Time": "2022-02-23T15:01:39",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2596626,
        "Lon": 86.17594,
        "Speed": 14.4,
        "Height": 202,
        "Mileage": 54192760,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 81,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27722,
        "EngineSpeed": null,
        "TotalMileage": 95928180,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 90,
        "FuelConsumption": 383,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5800,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27221893,
        "Time": "2022-02-23T15:17:48",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2415161,
        "Lon": 86.1438751,
        "Speed": 24.8,
        "Height": 323,
        "Mileage": 54197352,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 85,
        "EngineRPM": 706.625,
        "OnboardVoltage": 27645,
        "EngineSpeed": null,
        "TotalMileage": 95932960,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 39,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7095,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27222974,
        "Time": "2022-02-23T15:27:59",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2680664,
        "Lon": 86.16681,
        "Speed": 22.7,
        "Height": 112,
        "Mileage": 54202928,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 83,
        "EngineRPM": 1299.875,
        "OnboardVoltage": 27740,
        "EngineSpeed": null,
        "TotalMileage": 95938445,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5800,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.4
    },
    {
        "Id": 27225724,
        "Time": "2022-02-23T15:47:17",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25556,
        "Lon": 86.162674,
        "Speed": 18.8,
        "Height": 293,
        "Mileage": 54206792,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1273.5,
        "OnboardVoltage": 27706,
        "EngineSpeed": null,
        "TotalMileage": 95942290,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5801,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.600002
    },
    {
        "Id": 27227911,
        "Time": "2022-02-23T16:01:14",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2561264,
        "Lon": 86.16505,
        "Speed": 32.0,
        "Height": 284,
        "Mileage": 54211420,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1295.125,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 95947165,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5801,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27230233,
        "Time": "2022-02-23T16:19:53",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26964,
        "Lon": 86.17656,
        "Speed": 7.0,
        "Height": 68,
        "Mileage": 54216164,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 718.125,
        "OnboardVoltage": 27758,
        "EngineSpeed": null,
        "TotalMileage": 95952285,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7096,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27233787,
        "Time": "2022-02-23T16:46:01",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25973,
        "Lon": 86.1769,
        "Speed": 17.4,
        "Height": 186,
        "Mileage": 54219488,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 81,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27715,
        "EngineSpeed": null,
        "TotalMileage": 95955470,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 96,
        "FuelConsumption": 390,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5802,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 59.600002
    },
    {
        "Id": 27235384,
        "Time": "2022-02-23T16:58:24",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2412872,
        "Lon": 86.1444244,
        "Speed": 17.5,
        "Height": 325,
        "Mileage": 54223472,
        "EngineOilPressure": 260,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 82,
        "EngineRPM": 1295.75,
        "OnboardVoltage": 27710,
        "EngineSpeed": null,
        "TotalMileage": 95959755,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 37,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5802,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27236574,
        "Time": "2022-02-23T17:09:06",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26186,
        "Lon": 86.17275,
        "Speed": 28.7,
        "Height": 212,
        "Mileage": 54227828,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 83,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27723,
        "EngineSpeed": null,
        "TotalMileage": 95964015,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5802,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27238375,
        "Time": "2022-02-23T17:25:16",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26955,
        "Lon": 86.17719,
        "Speed": 10.5,
        "Height": 64,
        "Mileage": 54231560,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 85,
        "EngineRPM": 1286.875,
        "OnboardVoltage": 27720,
        "EngineSpeed": null,
        "TotalMileage": 95967750,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 65,
        "FuelConsumption": 58,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5802,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.4
    },
    {
        "Id": 27239829,
        "Time": "2022-02-23T17:39:43",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25581,
        "Lon": 86.17486,
        "Speed": 16.1,
        "Height": 273,
        "Mileage": 54235696,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 83,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27752,
        "EngineSpeed": null,
        "TotalMileage": 95971990,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 384,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5803,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.8
    },
    {
        "Id": 27241819,
        "Time": "2022-02-23T17:55:04",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2554131,
        "Lon": 86.17296,
        "Speed": 19.8,
        "Height": 280,
        "Mileage": 54241852,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 82,
        "EngineRPM": 758.625,
        "OnboardVoltage": 27720,
        "EngineSpeed": null,
        "TotalMileage": 95978235,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 7,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5803,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 54.0
    },
    {
        "Id": 27244472,
        "Time": "2022-02-23T18:15:35",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2693138,
        "Lon": 86.16463,
        "Speed": 10.1,
        "Height": 104,
        "Mileage": 54245100,
        "EngineOilPressure": 324,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 71,
        "EngineRPM": 1301.75,
        "OnboardVoltage": 27679,
        "EngineSpeed": null,
        "TotalMileage": 95981560,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 1,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5803,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 95.6
    },
    {
        "Id": 27247788,
        "Time": "2022-02-23T18:42:34",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2565842,
        "Lon": 86.1751862,
        "Speed": 16.6,
        "Height": 270,
        "Mileage": 54247796,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 66,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27651,
        "EngineSpeed": null,
        "TotalMileage": 95984280,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 98,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7098,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.4
    },
    {
        "Id": 27249804,
        "Time": "2022-02-23T18:56:58",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2561264,
        "Lon": 86.16455,
        "Speed": 32.4,
        "Height": 280,
        "Mileage": 54252928,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 67,
        "EngineRPM": 1299.5,
        "OnboardVoltage": 27665,
        "EngineSpeed": null,
        "TotalMileage": 95989440,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5804,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 89.6
    },
    {
        "Id": 27251886,
        "Time": "2022-02-23T19:11:21",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26911,
        "Lon": 86.16468,
        "Speed": 0.0,
        "Height": 90,
        "Mileage": 54256480,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 73,
        "EngineRPM": 686.75,
        "OnboardVoltage": 27820,
        "EngineSpeed": null,
        "TotalMileage": 95993200,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5804,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.0
    },
    {
        "Id": 27255915,
        "Time": "2022-02-23T19:42:42",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2553825,
        "Lon": 86.17303,
        "Speed": 25.0,
        "Height": 282,
        "Mileage": 54259436,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 71,
        "EngineRPM": 1804.375,
        "OnboardVoltage": 27660,
        "EngineSpeed": null,
        "TotalMileage": 95996110,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 93,
        "FuelConsumption": 386,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7099,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27257907,
        "Time": "2022-02-23T19:56:14",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2614021,
        "Lon": 86.1731339,
        "Speed": 34.4,
        "Height": 214,
        "Mileage": 54265656,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 69,
        "EngineRPM": 1301.0,
        "OnboardVoltage": 27687,
        "EngineSpeed": null,
        "TotalMileage": 96002205,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5805,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 88.4
    },
    {
        "Id": 27260903,
        "Time": "2022-02-23T20:18:17",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2594833,
        "Lon": 86.17638,
        "Speed": 13.1,
        "Height": 197,
        "Mileage": 54269060,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 75,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27664,
        "EngineSpeed": null,
        "TotalMileage": 96005615,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5805,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27263134,
        "Time": "2022-02-23T20:34:34",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2556,
        "Lon": 86.1693,
        "Speed": 37.2,
        "Height": 280,
        "Mileage": 54275168,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 73,
        "EngineRPM": 1171.75,
        "OnboardVoltage": 27658,
        "EngineSpeed": null,
        "TotalMileage": 96011525,
        "AcceleratorPedalPosition": 66,
        "LoadPercentage": 12,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5805,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.8
    },
    {
        "Id": 27266848,
        "Time": "2022-02-23T21:03:44",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26915,
        "Lon": 86.16487,
        "Speed": 8.1,
        "Height": 103,
        "Mileage": 54278468,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 79,
        "EngineRPM": 814.25,
        "OnboardVoltage": 27723,
        "EngineSpeed": null,
        "TotalMileage": 96015215,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 35,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5806,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 83.200005
    },
    {
        "Id": 27270507,
        "Time": "2022-02-23T21:31:18",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2621727,
        "Lon": 86.171814,
        "Speed": 19.0,
        "Height": 223,
        "Mileage": 54280576,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 79,
        "EngineRPM": 1813.0,
        "OnboardVoltage": 27734,
        "EngineSpeed": null,
        "TotalMileage": 96017265,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 95,
        "FuelConsumption": 385,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5806,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 84.0
    },
    {
        "Id": 27272942,
        "Time": "2022-02-23T21:48:37",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2621651,
        "Lon": 86.17214,
        "Speed": 27.4,
        "Height": 218,
        "Mileage": 54287304,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 78,
        "EngineRPM": 1298.125,
        "OnboardVoltage": 27713,
        "EngineSpeed": null,
        "TotalMileage": 96023995,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 11,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5807,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 79.6
    },
    {
        "Id": 27276719,
        "Time": "2022-02-23T22:15:49",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25972,
        "Lon": 86.1768341,
        "Speed": 17.9,
        "Height": 186,
        "Mileage": 54290884,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 81,
        "EngineRPM": 1815.625,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 96027815,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 401,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5807,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 82.0
    },
    {
        "Id": 27278957,
        "Time": "2022-02-23T22:29:55",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.24298,
        "Lon": 86.14877,
        "Speed": 34.0,
        "Height": 334,
        "Mileage": 54294852,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 80,
        "EngineRPM": 1209.625,
        "OnboardVoltage": 27686,
        "EngineSpeed": null,
        "TotalMileage": 96031945,
        "AcceleratorPedalPosition": 46,
        "LoadPercentage": 80,
        "FuelConsumption": 153,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5807,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 76.0
    },
    {
        "Id": 27282064,
        "Time": "2022-02-23T22:52:09",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.26977,
        "Lon": 86.16428,
        "Speed": 0.0,
        "Height": 103,
        "Mileage": 54300420,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 83,
        "EngineRPM": 1069.625,
        "OnboardVoltage": 27821,
        "EngineSpeed": null,
        "TotalMileage": 96037440,
        "AcceleratorPedalPosition": 25,
        "LoadPercentage": 30,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5808,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.6
    },
    {
        "Id": 27285027,
        "Time": "2022-02-23T23:11:22",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2426376,
        "Lon": 86.1470947,
        "Speed": 12.4,
        "Height": 341,
        "Mileage": 54305648,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 78,
        "EngineRPM": 1782.375,
        "OnboardVoltage": 27692,
        "EngineSpeed": null,
        "TotalMileage": 96042735,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 190,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5808,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27287885,
        "Time": "2022-02-23T23:32:10",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2696533,
        "Lon": 86.16414,
        "Speed": 5.5,
        "Height": 95,
        "Mileage": 54311264,
        "EngineOilPressure": 228,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 80,
        "EngineRPM": 787.875,
        "OnboardVoltage": 27727,
        "EngineSpeed": null,
        "TotalMileage": 96048425,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5808,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 72.0
    },
    {
        "Id": 27290462,
        "Time": "2022-02-23T23:49:34",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.25269,
        "Lon": 86.1606445,
        "Speed": 17.5,
        "Height": 315,
        "Mileage": 54315108,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 80,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27702,
        "EngineSpeed": null,
        "TotalMileage": 96052380,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 97,
        "FuelConsumption": 392,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5809,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27292513,
        "Time": "2022-02-24T00:04:17",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2657051,
        "Lon": 86.16969,
        "Speed": 35.9,
        "Height": 131,
        "Mileage": 54321540,
        "EngineOilPressure": 360,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 81,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27701,
        "EngineSpeed": null,
        "TotalMileage": 96058590,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7104,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27295315,
        "Time": "2022-02-24T00:24:12",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2562828,
        "Lon": 86.17531,
        "Speed": 17.2,
        "Height": 274,
        "Mileage": 54324796,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 81,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27684,
        "EngineSpeed": null,
        "TotalMileage": 96062215,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 391,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5809,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 71.200005
    },
    {
        "Id": 27298175,
        "Time": "2022-02-24T00:57:22",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.24231,
        "Lon": 86.14137,
        "Speed": 0.0,
        "Height": 324,
        "Mileage": 54328076,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 78,
        "EngineRPM": 1814.25,
        "OnboardVoltage": 27776,
        "EngineSpeed": null,
        "TotalMileage": 96065775,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 9,
        "FuelConsumption": 259,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 7105,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 68.0
    },
    {
        "Id": 27299902,
        "Time": "2022-02-24T01:13:03",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2803421,
        "Lon": 86.14572,
        "Speed": 19.4,
        "Height": 224,
        "Mileage": 54334820,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 81,
        "EngineRPM": 1322.625,
        "OnboardVoltage": 27690,
        "EngineSpeed": null,
        "TotalMileage": 96072275,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 74,
        "FuelConsumption": 127,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5810,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 66.4
    },
    {
        "Id": 27303053,
        "Time": "2022-02-24T01:35:48",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2426949,
        "Lon": 86.14105,
        "Speed": 5.1,
        "Height": 334,
        "Mileage": 54340644,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 83,
        "EngineRPM": 1556.875,
        "OnboardVoltage": 27685,
        "EngineSpeed": null,
        "TotalMileage": 96078680,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 7,
        "FuelConsumption": 82,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5810,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 65.200005
    },
    {
        "Id": 27304967,
        "Time": "2022-02-24T01:48:55",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2564545,
        "Lon": 86.16057,
        "Speed": 40.0,
        "Height": 291,
        "Mileage": 54347916,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 84,
        "EngineRPM": 1145.25,
        "OnboardVoltage": 27760,
        "EngineSpeed": null,
        "TotalMileage": 96085435,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5811,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.0
    },
    {
        "Id": 27308453,
        "Time": "2022-02-24T02:11:32",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2694359,
        "Lon": 86.16512,
        "Speed": 0.0,
        "Height": 105,
        "Mileage": 54352248,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 86,
        "EngineRPM": 792.125,
        "OnboardVoltage": 27835,
        "EngineSpeed": null,
        "TotalMileage": 96089905,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 47,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5811,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 62.8
    },
    {
        "Id": 27310780,
        "Time": "2022-02-24T02:26:59",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2735252,
        "Lon": 86.17958,
        "Speed": 18.1,
        "Height": 126,
        "Mileage": 54355440,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 82,
        "EngineRPM": 1814.125,
        "OnboardVoltage": 27737,
        "EngineSpeed": null,
        "TotalMileage": 96093060,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 383,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5811,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 63.2
    },
    {
        "Id": 27314051,
        "Time": "2022-02-24T02:50:17",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2722321,
        "Lon": 86.18498,
        "Speed": 38.3,
        "Height": 247,
        "Mileage": 54360056,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 75,
        "EngineRPM": 1296.375,
        "OnboardVoltage": 27742,
        "EngineSpeed": null,
        "TotalMileage": 96097740,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5812,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.8
    },
    {
        "Id": 27315410,
        "Time": "2022-02-24T02:59:46",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.2696571,
        "Lon": 86.1642,
        "Speed": 11.1,
        "Height": 105,
        "Mileage": 54364948,
        "EngineOilPressure": 352,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 70,
        "EngineRPM": 1412.875,
        "OnboardVoltage": 27799,
        "EngineSpeed": null,
        "TotalMileage": 96102740,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5812,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 99.6
    },
    {
        "Id": 27324080,
        "Time": "2022-02-24T03:57:18",
        "TruckId": 1753,
        "Imei": "868328058801818",
        "Lat": 54.27112,
        "Lon": 86.17105,
        "Speed": 4.8,
        "Height": 31,
        "Mileage": 54366768,
        "EngineOilPressure": 316,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 70,
        "EngineRPM": 1124.25,
        "OnboardVoltage": 27835,
        "EngineSpeed": null,
        "TotalMileage": 96104515,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 2,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 5813,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 97.200005
    },
    {
        "Id": 27004347,
        "Time": "2022-02-22T10:55:10",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.12119,
        "Lon": 86.4911041,
        "Speed": 5.5,
        "Height": 60,
        "Mileage": null,
        "EngineOilPressure": 188,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 58,
        "EngineRPM": 649.0,
        "OnboardVoltage": 28099,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 26,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 76.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27005921,
        "Time": "2022-02-22T11:07:31",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1160469,
        "Lon": 86.49238,
        "Speed": 11.1,
        "Height": 122,
        "Mileage": null,
        "EngineOilPressure": 176,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 59,
        "EngineRPM": 1177.0,
        "OnboardVoltage": 28079,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 42,
        "LoadPercentage": 44,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 78.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27008242,
        "Time": "2022-02-22T11:23:45",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1463432,
        "Lon": 86.43237,
        "Speed": 56.3,
        "Height": 334,
        "Mileage": null,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 63,
        "EngineRPM": 1889.0,
        "OnboardVoltage": 28081,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 80,
        "LoadPercentage": 76,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 84.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27017303,
        "Time": "2022-02-22T12:39:39",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1595764,
        "Lon": 86.4333038,
        "Speed": 6.8,
        "Height": 317,
        "Mileage": null,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 70,
        "FuelTemperature": 59,
        "EngineRPM": 651.0,
        "OnboardVoltage": 28142,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 29,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 63.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27032933,
        "Time": "2022-02-22T14:49:31",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1621361,
        "Lon": 86.43413,
        "Speed": 31.8,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": 212,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 64,
        "FuelTemperature": 56,
        "EngineRPM": 1488.0,
        "OnboardVoltage": 28042,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 27,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 59.0,
        "InstantOilConsumption": null,
        "FuelLevel": 57.600002
    },
    {
        "Id": 27035791,
        "Time": "2022-02-22T15:08:57",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1722069,
        "Lon": 86.452095,
        "Speed": 22.4,
        "Height": 309,
        "Mileage": null,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 51,
        "EngineRPM": 936.0,
        "OnboardVoltage": 28027,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 66.0,
        "InstantOilConsumption": null,
        "FuelLevel": 100.0
    },
    {
        "Id": 27038308,
        "Time": "2022-02-22T15:28:01",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1989822,
        "Lon": 86.4315643,
        "Speed": 0.0,
        "Height": 275,
        "Mileage": null,
        "EngineOilPressure": 188,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 50,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28169,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 26,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 72.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.4
    },
    {
        "Id": 27045373,
        "Time": "2022-02-22T16:23:39",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.20397,
        "Lon": 86.44309,
        "Speed": 40.9,
        "Height": 370,
        "Mileage": null,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 51,
        "EngineRPM": 1871.0,
        "OnboardVoltage": 28068,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 33,
        "LoadPercentage": 28,
        "FuelConsumption": 54,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 63.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.0
    },
    {
        "Id": 27048059,
        "Time": "2022-02-22T16:46:13",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.20256,
        "Lon": 86.44276,
        "Speed": 32.5,
        "Height": 368,
        "Mileage": null,
        "EngineOilPressure": 172,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 56,
        "EngineRPM": 622.0,
        "OnboardVoltage": 28056,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 29,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 76.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27054156,
        "Time": "2022-02-22T17:37:08",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.2015762,
        "Lon": 86.4380646,
        "Speed": 0.0,
        "Height": 254,
        "Mileage": null,
        "EngineOilPressure": 200,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 71,
        "FuelTemperature": 54,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28118,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 27,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 67.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27058616,
        "Time": "2022-02-22T18:17:37",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.19739,
        "Lon": 86.42879,
        "Speed": 0.0,
        "Height": 302,
        "Mileage": null,
        "EngineOilPressure": 176,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 55,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28206,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 27,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 68.0,
        "InstantOilConsumption": null,
        "FuelLevel": 91.200005
    },
    {
        "Id": 27062936,
        "Time": "2022-02-22T18:53:29",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1636124,
        "Lon": 86.45513,
        "Speed": 21.4,
        "Height": 304,
        "Mileage": null,
        "EngineOilPressure": 172,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 56,
        "EngineRPM": 690.0,
        "OnboardVoltage": 28058,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 25,
        "LoadPercentage": 67,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 74.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27066127,
        "Time": "2022-02-22T19:15:46",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1383858,
        "Lon": 86.48089,
        "Speed": 39.2,
        "Height": 302,
        "Mileage": null,
        "EngineOilPressure": 188,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 58,
        "EngineRPM": 1841.0,
        "OnboardVoltage": 28057,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 77,
        "LoadPercentage": 79,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 72.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.0
    },
    {
        "Id": 27068893,
        "Time": "2022-02-22T19:36:36",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.11956,
        "Lon": 86.49389,
        "Speed": 0.0,
        "Height": 48,
        "Mileage": null,
        "EngineOilPressure": 184,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 57,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28011,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 26,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 74.0,
        "InstantOilConsumption": null,
        "FuelLevel": 86.4
    },
    {
        "Id": 27072467,
        "Time": "2022-02-22T20:01:29",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1404572,
        "Lon": 86.47361,
        "Speed": 36.1,
        "Height": 325,
        "Mileage": null,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 61,
        "EngineRPM": 1717.0,
        "OnboardVoltage": 28077,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 100,
        "FuelConsumption": 60,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 86.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27080000,
        "Time": "2022-02-22T20:54:38",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.16075,
        "Lon": 86.4356461,
        "Speed": 0.0,
        "Height": 322,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 60,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25340,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 254,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 79.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27105458,
        "Time": "2022-02-23T00:10:38",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.16075,
        "Lon": 86.4356461,
        "Speed": 0.0,
        "Height": 322,
        "Mileage": null,
        "EngineOilPressure": 0,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 60,
        "EngineRPM": 0.0,
        "OnboardVoltage": 25005,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 254,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 79.0,
        "InstantOilConsumption": null,
        "FuelLevel": 81.200005
    },
    {
        "Id": 27123838,
        "Time": "2022-02-23T02:39:17",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.160244,
        "Lon": 86.43814,
        "Speed": 15.3,
        "Height": 316,
        "Mileage": null,
        "EngineOilPressure": 184,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 53,
        "EngineRPM": 825.0,
        "OnboardVoltage": 28148,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 22,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 69.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27128620,
        "Time": "2022-02-23T03:12:30",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1427269,
        "Lon": 86.44153,
        "Speed": 46.6,
        "Height": 326,
        "Mileage": null,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 56,
        "EngineRPM": 1486.0,
        "OnboardVoltage": 28108,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 35,
        "LoadPercentage": 30,
        "FuelConsumption": 1,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 72.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27133476,
        "Time": "2022-02-23T03:47:31",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1338,
        "Lon": 86.48834,
        "Speed": 15.0,
        "Height": 280,
        "Mileage": null,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 58,
        "EngineRPM": 1725.0,
        "OnboardVoltage": 27968,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 65,
        "LoadPercentage": 65,
        "FuelConsumption": 32,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 70.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27136636,
        "Time": "2022-02-23T04:08:36",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1115341,
        "Lon": 86.49908,
        "Speed": 17.0,
        "Height": 191,
        "Mileage": null,
        "EngineOilPressure": 192,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 58,
        "EngineRPM": 341.0,
        "OnboardVoltage": 28240,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 27,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 71.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27139803,
        "Time": "2022-02-23T04:27:50",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1267052,
        "Lon": 86.482605,
        "Speed": 35.0,
        "Height": 124,
        "Mileage": null,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 61,
        "EngineRPM": 1459.0,
        "OnboardVoltage": 28068,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 73.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.6
    },
    {
        "Id": 27151109,
        "Time": "2022-02-23T06:02:17",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1247139,
        "Lon": 86.4836349,
        "Speed": 33.7,
        "Height": 119,
        "Mileage": null,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 58,
        "EngineRPM": 1662.0,
        "OnboardVoltage": 28068,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 58,
        "LoadPercentage": 61,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 68.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27156828,
        "Time": "2022-02-23T06:44:44",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1375275,
        "Lon": 86.4772949,
        "Speed": 32.2,
        "Height": 301,
        "Mileage": null,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 60,
        "EngineRPM": 1395.0,
        "OnboardVoltage": 28004,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 46,
        "LoadPercentage": 42,
        "FuelConsumption": 51,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 75.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27158729,
        "Time": "2022-02-23T06:59:17",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1560173,
        "Lon": 86.422554,
        "Speed": 40.3,
        "Height": 321,
        "Mileage": null,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 60,
        "EngineRPM": 1446.0,
        "OnboardVoltage": 28085,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 41,
        "LoadPercentage": 39,
        "FuelConsumption": 38,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 80.0,
        "InstantOilConsumption": null,
        "FuelLevel": 58.8
    },
    {
        "Id": 27161182,
        "Time": "2022-02-23T07:14:45",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.15188,
        "Lon": 86.59249,
        "Speed": 60.9,
        "Height": 279,
        "Mileage": null,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 61,
        "EngineRPM": 1559.0,
        "OnboardVoltage": 28122,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 55,
        "LoadPercentage": 57,
        "FuelConsumption": 30,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 78.0,
        "InstantOilConsumption": null,
        "FuelLevel": 51.600002
    },
    {
        "Id": 27163931,
        "Time": "2022-02-23T07:35:01",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.01156,
        "Lon": 86.66006,
        "Speed": 63.8,
        "Height": 361,
        "Mileage": null,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 61,
        "EngineRPM": 1475.0,
        "OnboardVoltage": 28117,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 64,
        "LoadPercentage": 71,
        "FuelConsumption": 40,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 80.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27166275,
        "Time": "2022-02-23T07:50:30",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 53.97281,
        "Lon": 86.6301651,
        "Speed": 23.8,
        "Height": 328,
        "Mileage": null,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 59,
        "EngineRPM": 1660.0,
        "OnboardVoltage": 28111,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 40,
        "LoadPercentage": 35,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 75.0,
        "InstantOilConsumption": null,
        "FuelLevel": 45.600002
    },
    {
        "Id": 27178968,
        "Time": "2022-02-23T09:33:31",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 53.97477,
        "Lon": 86.63572,
        "Speed": 35.3,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 55,
        "EngineRPM": 1382.0,
        "OnboardVoltage": 28141,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 40,
        "LoadPercentage": 44,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 62.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27181084,
        "Time": "2022-02-23T09:48:27",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.01247,
        "Lon": 86.67747,
        "Speed": 43.3,
        "Height": 357,
        "Mileage": null,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 57,
        "EngineRPM": 969.0,
        "OnboardVoltage": 28123,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 20,
        "LoadPercentage": 17,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 74.0,
        "InstantOilConsumption": null,
        "FuelLevel": 38.4
    },
    {
        "Id": 27184167,
        "Time": "2022-02-23T10:11:40",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1611557,
        "Lon": 86.54379,
        "Speed": 63.1,
        "Height": 269,
        "Mileage": null,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 60,
        "EngineRPM": 1570.0,
        "OnboardVoltage": 28128,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 100,
        "LoadPercentage": 99,
        "FuelConsumption": 29,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 80.0,
        "InstantOilConsumption": null,
        "FuelLevel": 32.8
    },
    {
        "Id": 27185944,
        "Time": "2022-02-23T10:25:17",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1604,
        "Lon": 86.43286,
        "Speed": 33.1,
        "Height": 322,
        "Mileage": null,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 60,
        "EngineRPM": 1351.0,
        "OnboardVoltage": 28140,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 42,
        "LoadPercentage": 43,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 80.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.2
    },
    {
        "Id": 27200630,
        "Time": "2022-02-23T12:22:23",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.16076,
        "Lon": 86.43571,
        "Speed": 0.0,
        "Height": 322,
        "Mileage": null,
        "EngineOilPressure": 268,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 56,
        "FuelTemperature": 51,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28136,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 29,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 50.0,
        "InstantOilConsumption": null,
        "FuelLevel": 26.800001
    },
    {
        "Id": 27212306,
        "Time": "2022-02-23T14:06:59",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1655769,
        "Lon": 86.43825,
        "Speed": 19.4,
        "Height": 319,
        "Mileage": null,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 70,
        "FuelTemperature": 52,
        "EngineRPM": 1251.0,
        "OnboardVoltage": 28034,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 34,
        "LoadPercentage": 44,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 59.0,
        "InstantOilConsumption": null,
        "FuelLevel": 27.2
    },
    {
        "Id": 27216839,
        "Time": "2022-02-23T14:39:42",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1973953,
        "Lon": 86.4288,
        "Speed": 0.0,
        "Height": 307,
        "Mileage": null,
        "EngineOilPressure": 196,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 47,
        "EngineRPM": 652.0,
        "OnboardVoltage": 28165,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 25,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 70.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.0
    },
    {
        "Id": 27226417,
        "Time": "2022-02-23T15:52:11",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1985435,
        "Lon": 86.43127,
        "Speed": 12.4,
        "Height": 283,
        "Mileage": null,
        "EngineOilPressure": 196,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 49,
        "EngineRPM": 656.0,
        "OnboardVoltage": 28033,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 28,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 60.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.4
    },
    {
        "Id": 27228506,
        "Time": "2022-02-23T16:06:17",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1459,
        "Lon": 86.5004654,
        "Speed": 0.0,
        "Height": 290,
        "Mileage": null,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 53,
        "EngineRPM": 649.0,
        "OnboardVoltage": 28045,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 99,
        "LoadPercentage": 99,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 74.0,
        "InstantOilConsumption": null,
        "FuelLevel": 96.0
    },
    {
        "Id": 27234019,
        "Time": "2022-02-23T16:49:42",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.13265,
        "Lon": 86.49459,
        "Speed": 32.7,
        "Height": 297,
        "Mileage": null,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 52,
        "EngineRPM": 1697.0,
        "OnboardVoltage": 28073,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 72,
        "LoadPercentage": 69,
        "FuelConsumption": 50,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 61.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27241245,
        "Time": "2022-02-23T17:51:12",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1221161,
        "Lon": 86.4860153,
        "Speed": 39.6,
        "Height": 116,
        "Mileage": null,
        "EngineOilPressure": 484,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 66,
        "FuelTemperature": 51,
        "EngineRPM": 1580.0,
        "OnboardVoltage": 28084,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 17,
        "LoadPercentage": 0,
        "FuelConsumption": 36,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 61.0,
        "InstantOilConsumption": null,
        "FuelLevel": 90.8
    },
    {
        "Id": 27242993,
        "Time": "2022-02-23T18:04:16",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1206741,
        "Lon": 86.49097,
        "Speed": 11.2,
        "Height": 52,
        "Mileage": null,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 52,
        "EngineRPM": 1148.0,
        "OnboardVoltage": 28027,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 10,
        "LoadPercentage": 13,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 69.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27244949,
        "Time": "2022-02-23T18:19:52",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.115284,
        "Lon": 86.50193,
        "Speed": 4.6,
        "Height": 57,
        "Mileage": null,
        "EngineOilPressure": 184,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 52,
        "EngineRPM": 617.0,
        "OnboardVoltage": 28079,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 21,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 72.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27246762,
        "Time": "2022-02-23T18:35:25",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1453934,
        "Lon": 86.50121,
        "Speed": 24.4,
        "Height": 288,
        "Mileage": null,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 57,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28025,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 48,
        "LoadPercentage": 25,
        "FuelConsumption": 56,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 82.0,
        "InstantOilConsumption": null,
        "FuelLevel": 85.6
    },
    {
        "Id": 27249738,
        "Time": "2022-02-23T18:57:00",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.2100945,
        "Lon": 86.40903,
        "Speed": 27.9,
        "Height": 178,
        "Mileage": null,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 56,
        "EngineRPM": 1494.0,
        "OnboardVoltage": 28015,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 75.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27255905,
        "Time": "2022-02-23T19:42:38",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.21029,
        "Lon": 86.40867,
        "Speed": 32.2,
        "Height": 182,
        "Mileage": null,
        "EngineOilPressure": 484,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 56,
        "EngineRPM": 1886.0,
        "OnboardVoltage": 28043,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 98,
        "LoadPercentage": 95,
        "FuelConsumption": 48,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 64.0,
        "InstantOilConsumption": null,
        "FuelLevel": 80.4
    },
    {
        "Id": 27257881,
        "Time": "2022-02-23T19:56:05",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.16437,
        "Lon": 86.43759,
        "Speed": 37.5,
        "Height": 319,
        "Mileage": null,
        "EngineOilPressure": 424,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 58,
        "EngineRPM": 1840.0,
        "OnboardVoltage": 28097,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 95,
        "LoadPercentage": 100,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 81.0,
        "InstantOilConsumption": null,
        "FuelLevel": 75.200005
    },
    {
        "Id": 27267294,
        "Time": "2022-02-23T21:07:27",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.160553,
        "Lon": 86.43422,
        "Speed": 19.0,
        "Height": 323,
        "Mileage": null,
        "EngineOilPressure": 220,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 61,
        "FuelTemperature": 57,
        "EngineRPM": 650.0,
        "OnboardVoltage": 28085,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 30,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 58.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27293723,
        "Time": "2022-02-24T00:12:29",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1607857,
        "Lon": 86.4356461,
        "Speed": 0.0,
        "Height": 320,
        "Mileage": null,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 67,
        "FuelTemperature": 56,
        "EngineRPM": 0.0,
        "OnboardVoltage": 24883,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 254,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 58.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.4
    },
    {
        "Id": 27304095,
        "Time": "2022-02-24T01:43:00",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.16267,
        "Lon": 86.42879,
        "Speed": 7.0,
        "Height": 315,
        "Mileage": null,
        "EngineOilPressure": 436,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 74,
        "FuelTemperature": 48,
        "EngineRPM": 1256.0,
        "OnboardVoltage": 28096,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 29,
        "LoadPercentage": 29,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 55.0,
        "InstantOilConsumption": null,
        "FuelLevel": 74.8
    },
    {
        "Id": 27308303,
        "Time": "2022-02-24T02:10:30",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1449432,
        "Lon": 86.4392853,
        "Speed": 42.5,
        "Height": 333,
        "Mileage": null,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 51,
        "EngineRPM": 1483.0,
        "OnboardVoltage": 28084,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 30,
        "LoadPercentage": 28,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 68.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27314557,
        "Time": "2022-02-24T02:53:46",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1418724,
        "Lon": 86.49546,
        "Speed": 0.0,
        "Height": 287,
        "Mileage": null,
        "EngineOilPressure": 192,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 51,
        "EngineRPM": 652.0,
        "OnboardVoltage": 28168,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 26,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 68.0,
        "InstantOilConsumption": null,
        "FuelLevel": 69.200005
    },
    {
        "Id": 27320431,
        "Time": "2022-02-24T03:35:03",
        "TruckId": 1806,
        "Imei": "868328058801842",
        "Lat": 54.1271935,
        "Lon": 86.48338,
        "Speed": 32.4,
        "Height": 132,
        "Mileage": null,
        "EngineOilPressure": 432,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 55,
        "EngineRPM": 1362.0,
        "OnboardVoltage": 28001,
        "EngineSpeed": null,
        "TotalMileage": 0,
        "AcceleratorPedalPosition": 19,
        "LoadPercentage": 12,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 102,
        "TachographSpeed": 0,
        "DailyMileage": 0.0,
        "TotalEngineRunningTime": 0,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": 78.0,
        "InstantOilConsumption": null,
        "FuelLevel": 64.4
    },
    {
        "Id": 27004233,
        "Time": "2022-02-22T10:54:11",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.2823524,
        "Lon": 86.1793442,
        "Speed": 0.0,
        "Height": 270,
        "Mileage": 53643436,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 94,
        "EngineRPM": 1126.625,
        "OnboardVoltage": 27697,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1073,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27009638,
        "Time": "2022-02-22T11:34:33",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3059845,
        "Lon": 86.13473,
        "Speed": 37.4,
        "Height": 146,
        "Mileage": 53650356,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 96,
        "EngineRPM": 1300.125,
        "OnboardVoltage": 27545,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 7,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1074,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27015339,
        "Time": "2022-02-22T12:20:09",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30471,
        "Lon": 86.14325,
        "Speed": 10.7,
        "Height": 75,
        "Mileage": 53653180,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 96,
        "EngineRPM": 1809.125,
        "OnboardVoltage": 27380,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 366,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1074,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27018110,
        "Time": "2022-02-22T12:48:28",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.313,
        "Lon": 86.1520157,
        "Speed": 14.2,
        "Height": 288,
        "Mileage": 53656220,
        "EngineOilPressure": 476,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 100,
        "EngineRPM": 1807.375,
        "OnboardVoltage": 27325,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1075,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27019770,
        "Time": "2022-02-22T13:02:41",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31092,
        "Lon": 86.1537,
        "Speed": 41.4,
        "Height": 309,
        "Mileage": 53659952,
        "EngineOilPressure": 372,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 99,
        "EngineRPM": 1301.5,
        "OnboardVoltage": 27450,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1075,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27025816,
        "Time": "2022-02-22T13:56:57",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3079147,
        "Lon": 86.13688,
        "Speed": 12.2,
        "Height": 149,
        "Mileage": 53662872,
        "EngineOilPressure": 356,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 95,
        "EngineRPM": 1089.25,
        "OnboardVoltage": 27553,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 23,
        "FuelConsumption": 188,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1076,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27029614,
        "Time": "2022-02-22T14:24:07",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3067741,
        "Lon": 86.16845,
        "Speed": 17.2,
        "Height": 404,
        "Mileage": 53666928,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 97,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27357,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1076,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27031947,
        "Time": "2022-02-22T14:41:19",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30797,
        "Lon": 86.13688,
        "Speed": 0.0,
        "Height": 148,
        "Mileage": 53671412,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 98,
        "EngineRPM": 785.875,
        "OnboardVoltage": 27726,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 26,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1077,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27035607,
        "Time": "2022-02-22T15:08:39",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30658,
        "Lon": 86.16442,
        "Speed": 10.5,
        "Height": 381,
        "Mileage": 53675312,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 96,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27381,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1077,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27037335,
        "Time": "2022-02-22T15:20:24",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3064232,
        "Lon": 86.13542,
        "Speed": 23.1,
        "Height": 133,
        "Mileage": 53680112,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 97,
        "EngineRPM": 1299.875,
        "OnboardVoltage": 27385,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 21,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1077,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27042099,
        "Time": "2022-02-22T15:59:48",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3124962,
        "Lon": 86.1527557,
        "Speed": 13.7,
        "Height": 286,
        "Mileage": 53683016,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 97,
        "EngineRPM": 1811.0,
        "OnboardVoltage": 27365,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 92,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1078,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27044200,
        "Time": "2022-02-22T16:16:27",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3062248,
        "Lon": 86.13572,
        "Speed": 7.2,
        "Height": 136,
        "Mileage": 53688540,
        "EngineOilPressure": 392,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 98,
        "EngineRPM": 1288.625,
        "OnboardVoltage": 27412,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 5,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1078,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27048179,
        "Time": "2022-02-22T16:43:11",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31289,
        "Lon": 86.15227,
        "Speed": 15.1,
        "Height": 279,
        "Mileage": 53691428,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 97,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27431,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 92,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1079,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27049624,
        "Time": "2022-02-22T16:58:00",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.313488,
        "Lon": 86.14047,
        "Speed": 36.6,
        "Height": 230,
        "Mileage": 53695976,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 98,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27360,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1079,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27052756,
        "Time": "2022-02-22T17:24:31",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30953,
        "Lon": 86.1326447,
        "Speed": 10.9,
        "Height": 177,
        "Mileage": 53698620,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 95,
        "EngineRPM": 1812.5,
        "OnboardVoltage": 27414,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 361,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1080,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27054655,
        "Time": "2022-02-22T17:41:15",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3088226,
        "Lon": 86.17144,
        "Speed": 15.5,
        "Height": 433,
        "Mileage": 53702196,
        "EngineOilPressure": 296,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 98,
        "EngineRPM": 911.125,
        "OnboardVoltage": 27644,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1080,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27056617,
        "Time": "2022-02-22T17:59:57",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3072166,
        "Lon": 86.1379547,
        "Speed": 0.0,
        "Height": 158,
        "Mileage": 53706492,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 99,
        "EngineRPM": 689.0,
        "OnboardVoltage": 27735,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1080,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27058806,
        "Time": "2022-02-22T18:19:23",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3083725,
        "Lon": 86.17089,
        "Speed": 4.8,
        "Height": 425,
        "Mileage": 53710756,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 100,
        "EngineRPM": 1712.5,
        "OnboardVoltage": 27401,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 100,
        "FuelConsumption": 325,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1080,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27059899,
        "Time": "2022-02-22T18:29:13",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3079376,
        "Lon": 86.136,
        "Speed": 26.2,
        "Height": 145,
        "Mileage": 53714956,
        "EngineOilPressure": 428,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 100,
        "EngineRPM": 1799.375,
        "OnboardVoltage": 27379,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 40,
        "FuelConsumption": 224,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1081,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27062351,
        "Time": "2022-02-22T18:49:01",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30979,
        "Lon": 86.15783,
        "Speed": 9.8,
        "Height": 339,
        "Mileage": 53718244,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 100,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27345,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 91,
        "FuelConsumption": 376,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1081,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27064628,
        "Time": "2022-02-22T19:03:44",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3057671,
        "Lon": 86.13509,
        "Speed": 13.1,
        "Height": 142,
        "Mileage": 53723436,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 100,
        "EngineRPM": 1298.5,
        "OnboardVoltage": 27577,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1081,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27068649,
        "Time": "2022-02-22T19:34:24",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3098564,
        "Lon": 86.15759,
        "Speed": 10.9,
        "Height": 335,
        "Mileage": 53726968,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 100,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27414,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 364,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1082,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27070714,
        "Time": "2022-02-22T19:48:57",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3074455,
        "Lon": 86.1351,
        "Speed": 25.1,
        "Height": 143,
        "Mileage": 53732384,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 943.25,
        "OnboardVoltage": 27460,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1082,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27073477,
        "Time": "2022-02-22T20:08:32",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3066444,
        "Lon": 86.16398,
        "Speed": 8.8,
        "Height": 384,
        "Mileage": 53736348,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 101,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27361,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 380,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1082,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27077021,
        "Time": "2022-02-22T20:32:41",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31375,
        "Lon": 86.14704,
        "Speed": 24.0,
        "Height": 262,
        "Mileage": 53739504,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 716.625,
        "OnboardVoltage": 27437,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 14,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1083,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27079852,
        "Time": "2022-02-22T20:53:36",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31375,
        "Lon": 86.14162,
        "Speed": 15.3,
        "Height": 225,
        "Mileage": 53743468,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 97,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27449,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 369,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1083,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27082056,
        "Time": "2022-02-22T21:08:37",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.307888,
        "Lon": 86.1357651,
        "Speed": 24.6,
        "Height": 149,
        "Mileage": 53749312,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 84,
        "FuelTemperature": 71,
        "EngineRPM": 1765.375,
        "OnboardVoltage": 27492,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 72,
        "FuelConsumption": 255,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1083,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27084841,
        "Time": "2022-02-22T21:31:31",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3093758,
        "Lon": 86.15615,
        "Speed": 21.8,
        "Height": 325,
        "Mileage": 53752632,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 68,
        "EngineRPM": 1812.125,
        "OnboardVoltage": 27407,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 368,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1084,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27086740,
        "Time": "2022-02-22T21:45:41",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3072739,
        "Lon": 86.13801,
        "Speed": 8.3,
        "Height": 151,
        "Mileage": 53757728,
        "EngineOilPressure": 236,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 73,
        "EngineRPM": 688.5,
        "OnboardVoltage": 27543,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1084,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27089152,
        "Time": "2022-02-22T22:02:10",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3073158,
        "Lon": 86.15845,
        "Speed": 29.8,
        "Height": 321,
        "Mileage": 53762388,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 72,
        "EngineRPM": 1811.375,
        "OnboardVoltage": 27368,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 24,
        "FuelConsumption": 165,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1084,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27092991,
        "Time": "2022-02-22T22:32:26",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.307888,
        "Lon": 86.13622,
        "Speed": 9.2,
        "Height": 147,
        "Mileage": 53765904,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 75,
        "EngineRPM": 1297.625,
        "OnboardVoltage": 27412,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1085,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27094821,
        "Time": "2022-02-22T22:47:42",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30404,
        "Lon": 86.15998,
        "Speed": 33.8,
        "Height": 306,
        "Mileage": 53770036,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 81,
        "EngineRPM": 1416.125,
        "OnboardVoltage": 27422,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 71,
        "FuelConsumption": 243,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1085,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27096753,
        "Time": "2022-02-22T23:01:27",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30745,
        "Lon": 86.13519,
        "Speed": 23.8,
        "Height": 148,
        "Mileage": 53774384,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 85,
        "EngineRPM": 840.625,
        "OnboardVoltage": 27432,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1085,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27098949,
        "Time": "2022-02-22T23:19:37",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31357,
        "Lon": 86.14064,
        "Speed": 44.6,
        "Height": 236,
        "Mileage": 53780412,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 88,
        "EngineRPM": 1304.0,
        "OnboardVoltage": 27349,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1085,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27101393,
        "Time": "2022-02-22T23:36:37",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3104553,
        "Lon": 86.134285,
        "Speed": 15.3,
        "Height": 195,
        "Mileage": 53783432,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 1813.875,
        "OnboardVoltage": 27350,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1086,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27103470,
        "Time": "2022-02-22T23:52:26",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30604,
        "Lon": 86.1353455,
        "Speed": 14.2,
        "Height": 148,
        "Mileage": 53789612,
        "EngineOilPressure": 384,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 1294.125,
        "OnboardVoltage": 27469,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 10,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1086,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27104842,
        "Time": "2022-02-23T00:05:14",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31368,
        "Lon": 86.1493,
        "Speed": 20.9,
        "Height": 270,
        "Mileage": 53792372,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 89,
        "EngineRPM": 1818.75,
        "OnboardVoltage": 27364,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 353,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1086,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27106476,
        "Time": "2022-02-23T00:18:12",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3077,
        "Lon": 86.1374741,
        "Speed": 0.0,
        "Height": 152,
        "Mileage": 53798016,
        "EngineOilPressure": 216,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 92,
        "EngineRPM": 1017.875,
        "OnboardVoltage": 27768,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1086,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27109923,
        "Time": "2022-02-23T00:53:05",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3135338,
        "Lon": 86.14712,
        "Speed": 10.5,
        "Height": 262,
        "Mileage": 53800356,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 94,
        "EngineRPM": 1214.875,
        "OnboardVoltage": 27552,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 34,
        "FuelConsumption": 125,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1087,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27111833,
        "Time": "2022-02-23T01:07:57",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3070564,
        "Lon": 86.1654,
        "Speed": 28.3,
        "Height": 390,
        "Mileage": 53803608,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 96,
        "EngineRPM": 1300.5,
        "OnboardVoltage": 27373,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1087,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27113223,
        "Time": "2022-02-23T01:20:44",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30609,
        "Lon": 86.13559,
        "Speed": 11.6,
        "Height": 136,
        "Mileage": 53807604,
        "EngineOilPressure": 344,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 96,
        "EngineRPM": 1307.375,
        "OnboardVoltage": 27474,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 4,
        "FuelConsumption": 19,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1087,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27123440,
        "Time": "2022-02-23T01:41:49",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30714,
        "Lon": 86.17034,
        "Speed": 19.6,
        "Height": 417,
        "Mileage": 53812044,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 96,
        "EngineRPM": 1293.125,
        "OnboardVoltage": 27532,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1088,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27118573,
        "Time": "2022-02-23T02:00:23",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.300312,
        "Lon": 86.1405,
        "Speed": 4.8,
        "Height": 13,
        "Mileage": 53817224,
        "EngineOilPressure": 416,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 97,
        "EngineRPM": 1279.625,
        "OnboardVoltage": 27651,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 142,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1088,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27122959,
        "Time": "2022-02-23T02:29:24",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31388,
        "Lon": 86.14198,
        "Speed": 16.6,
        "Height": 241,
        "Mileage": 53820592,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 96,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27526,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 376,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1089,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27124835,
        "Time": "2022-02-23T02:46:16",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31309,
        "Lon": 86.15244,
        "Speed": 34.6,
        "Height": 287,
        "Mileage": 53824940,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 99,
        "EngineRPM": 1302.0,
        "OnboardVoltage": 27493,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1089,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27129606,
        "Time": "2022-02-23T03:20:40",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.2987442,
        "Lon": 86.14305,
        "Speed": 0.0,
        "Height": 2,
        "Mileage": 53828988,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 97,
        "EngineRPM": 1124.75,
        "OnboardVoltage": 27769,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 3,
        "FuelConsumption": 20,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1089,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27133681,
        "Time": "2022-02-23T03:49:28",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3137741,
        "Lon": 86.1461258,
        "Speed": 13.5,
        "Height": 257,
        "Mileage": 53832732,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 98,
        "EngineRPM": 1640.75,
        "OnboardVoltage": 27502,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 70,
        "FuelConsumption": 235,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1090,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27136146,
        "Time": "2022-02-23T04:05:51",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3101845,
        "Lon": 86.1551056,
        "Speed": 32.7,
        "Height": 320,
        "Mileage": 53836624,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 92,
        "FuelTemperature": 101,
        "EngineRPM": 1301.625,
        "OnboardVoltage": 27540,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1090,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27138076,
        "Time": "2022-02-23T04:17:05",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.2990227,
        "Lon": 86.1432,
        "Speed": 0.0,
        "Height": 8,
        "Mileage": 53841028,
        "EngineOilPressure": 388,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 100,
        "EngineRPM": 1250.625,
        "OnboardVoltage": 27728,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 45,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1090,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27141909,
        "Time": "2022-02-23T04:42:25",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31033,
        "Lon": 86.15376,
        "Speed": 16.1,
        "Height": 313,
        "Mileage": 53845408,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 89,
        "FuelTemperature": 101,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27558,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 97,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1091,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27144193,
        "Time": "2022-02-23T04:58:57",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.2839127,
        "Lon": 86.1768,
        "Speed": 24.4,
        "Height": 275,
        "Mileage": 53850336,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 93,
        "FuelTemperature": 102,
        "EngineRPM": 1702.875,
        "OnboardVoltage": 27500,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 46,
        "FuelConsumption": 192,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1091,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27148697,
        "Time": "2022-02-23T05:43:53",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30301,
        "Lon": 86.17061,
        "Speed": 20.0,
        "Height": 396,
        "Mileage": 53855408,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 96,
        "EngineRPM": 1492.25,
        "OnboardVoltage": 27445,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 57,
        "FuelConsumption": 236,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1092,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27150227,
        "Time": "2022-02-23T05:55:51",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30112,
        "Lon": 86.1413345,
        "Speed": 19.0,
        "Height": 21,
        "Mileage": 53860860,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 95,
        "EngineRPM": 1215.875,
        "OnboardVoltage": 27498,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 0,
        "LoadPercentage": 0,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1092,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27154344,
        "Time": "2022-02-23T06:25:27",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.310276,
        "Lon": 86.13302,
        "Speed": 8.1,
        "Height": 180,
        "Mileage": 53863928,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 96,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27447,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 382,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1092,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27156869,
        "Time": "2022-02-23T06:44:55",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3069649,
        "Lon": 86.16948,
        "Speed": 26.6,
        "Height": 410,
        "Mileage": 53867964,
        "EngineOilPressure": 364,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 90,
        "FuelTemperature": 99,
        "EngineRPM": 1316.125,
        "OnboardVoltage": 27458,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 6,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1093,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27163298,
        "Time": "2022-02-23T07:30:06",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3122749,
        "Lon": 86.146225,
        "Speed": 0.0,
        "Height": 263,
        "Mileage": 53870132,
        "EngineOilPressure": 368,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 97,
        "EngineRPM": 1127.125,
        "OnboardVoltage": 27760,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 2,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1094,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27174821,
        "Time": "2022-02-23T08:59:11",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3128357,
        "Lon": 86.1459656,
        "Speed": 0.0,
        "Height": 262,
        "Mileage": 53870224,
        "EngineOilPressure": 244,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 76,
        "FuelTemperature": 93,
        "EngineRPM": 101.0,
        "OnboardVoltage": 25356,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 0,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1094,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27187254,
        "Time": "2022-02-23T10:36:39",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3129654,
        "Lon": 86.14528,
        "Speed": 10.9,
        "Height": 267,
        "Mileage": 53870284,
        "EngineOilPressure": 288,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 54,
        "FuelTemperature": 76,
        "EngineRPM": 757.625,
        "OnboardVoltage": 27600,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 2,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1032,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27191655,
        "Time": "2022-02-23T11:08:00",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30148,
        "Lon": 86.1415253,
        "Speed": 5.3,
        "Height": 12,
        "Mileage": 53874012,
        "EngineOilPressure": 252,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 75,
        "FuelTemperature": 63,
        "EngineRPM": 812.5,
        "OnboardVoltage": 27512,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 3,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1033,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27195302,
        "Time": "2022-02-23T11:35:39",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31,
        "Lon": 86.13262,
        "Speed": 10.1,
        "Height": 184,
        "Mileage": 53876984,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 60,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27202,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 395,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1033,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27197941,
        "Time": "2022-02-23T11:57:29",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3069839,
        "Lon": 86.16978,
        "Speed": 20.5,
        "Height": 409,
        "Mileage": 53880900,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 71,
        "EngineRPM": 1261.875,
        "OnboardVoltage": 27008,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 4,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1034,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27199266,
        "Time": "2022-02-23T12:09:39",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.2945175,
        "Lon": 86.1482239,
        "Speed": 25.5,
        "Height": -36,
        "Mileage": 53886416,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 65,
        "EngineRPM": 1297.375,
        "OnboardVoltage": 27005,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 18,
        "FuelConsumption": 23,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1034,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27200997,
        "Time": "2022-02-23T12:26:39",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3045845,
        "Lon": 86.14341,
        "Speed": 13.7,
        "Height": 77,
        "Mileage": 53889336,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 63,
        "EngineRPM": 1805.25,
        "OnboardVoltage": 27031,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 93,
        "FuelConsumption": 374,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1034,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27202998,
        "Time": "2022-02-23T12:48:40",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3102455,
        "Lon": 86.15395,
        "Speed": 11.8,
        "Height": 310,
        "Mileage": 53892844,
        "EngineOilPressure": 452,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 71,
        "EngineRPM": 1809.375,
        "OnboardVoltage": 27004,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1035,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27206731,
        "Time": "2022-02-23T13:23:37",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3106766,
        "Lon": 86.15377,
        "Speed": 32.7,
        "Height": 309,
        "Mileage": 53896300,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 78,
        "EngineRPM": 1319.0,
        "OnboardVoltage": 26956,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 25,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1035,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27209421,
        "Time": "2022-02-23T13:43:53",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3003426,
        "Lon": 86.14075,
        "Speed": 12.9,
        "Height": 14,
        "Mileage": 53900636,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 79,
        "EngineRPM": 1274.625,
        "OnboardVoltage": 27389,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 57,
        "FuelConsumption": 182,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1036,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27211793,
        "Time": "2022-02-23T14:02:33",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3077126,
        "Lon": 86.16184,
        "Speed": 18.8,
        "Height": 364,
        "Mileage": 53905136,
        "EngineOilPressure": 440,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 83,
        "EngineRPM": 1805.25,
        "OnboardVoltage": 27369,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 95,
        "FuelConsumption": 389,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1036,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27214923,
        "Time": "2022-02-23T14:23:44",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.28501,
        "Lon": 86.17904,
        "Speed": 5.9,
        "Height": 278,
        "Mileage": 53909200,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 85,
        "EngineRPM": 726.375,
        "OnboardVoltage": 27452,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 13,
        "FuelConsumption": 12,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1036,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27228371,
        "Time": "2022-02-23T16:05:14",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.27786,
        "Lon": 86.18989,
        "Speed": 12.4,
        "Height": 270,
        "Mileage": 53911072,
        "EngineOilPressure": 240,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 88,
        "EngineRPM": 960.625,
        "OnboardVoltage": 27476,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 19,
        "FuelConsumption": 8,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1038,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27230739,
        "Time": "2022-02-23T16:23:33",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3034172,
        "Lon": 86.13709,
        "Speed": 36.4,
        "Height": 115,
        "Mileage": 53919052,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 79,
        "FuelTemperature": 87,
        "EngineRPM": 1298.125,
        "OnboardVoltage": 27349,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 9,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1038,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27235796,
        "Time": "2022-02-23T17:01:56",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3012772,
        "Lon": 86.14158,
        "Speed": 15.3,
        "Height": 13,
        "Mileage": 53921464,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1794.0,
        "OnboardVoltage": 27474,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 66,
        "FuelConsumption": 214,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1039,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27240390,
        "Time": "2022-02-23T17:44:15",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3099442,
        "Lon": 86.15722,
        "Speed": 11.8,
        "Height": 331,
        "Mileage": 53925644,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 90,
        "EngineRPM": 1636.5,
        "OnboardVoltage": 27307,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 68,
        "FuelConsumption": 352,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1040,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27242505,
        "Time": "2022-02-23T18:00:21",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3099442,
        "Lon": 86.13236,
        "Speed": 33.7,
        "Height": 180,
        "Mileage": 53930376,
        "EngineOilPressure": 396,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 94,
        "EngineRPM": 1287.0,
        "OnboardVoltage": 27338,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 5,
        "FuelConsumption": 31,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1040,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27244883,
        "Time": "2022-02-23T18:19:30",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.29935,
        "Lon": 86.1426849,
        "Speed": 9.8,
        "Height": 0,
        "Mileage": 53933408,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 93,
        "EngineRPM": 1590.25,
        "OnboardVoltage": 27355,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 76,
        "FuelConsumption": 275,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1040,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27247237,
        "Time": "2022-02-23T18:38:16",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3099365,
        "Lon": 86.1573,
        "Speed": 11.2,
        "Height": 339,
        "Mileage": 53937960,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 96,
        "EngineRPM": 1808.25,
        "OnboardVoltage": 27340,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 367,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1040,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27249514,
        "Time": "2022-02-23T18:55:19",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30388,
        "Lon": 86.13564,
        "Speed": 32.0,
        "Height": 125,
        "Mileage": 53943340,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 95,
        "EngineRPM": 1300.75,
        "OnboardVoltage": 27317,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1041,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27251917,
        "Time": "2022-02-23T19:12:01",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.2945557,
        "Lon": 86.14671,
        "Speed": 18.5,
        "Height": -37,
        "Mileage": 53946560,
        "EngineOilPressure": 420,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 95,
        "EngineRPM": 1803.5,
        "OnboardVoltage": 27350,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 79,
        "FuelConsumption": 335,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1041,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27254835,
        "Time": "2022-02-23T19:34:35",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3088379,
        "Lon": 86.1597,
        "Speed": 10.5,
        "Height": 353,
        "Mileage": 53951948,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 97,
        "EngineRPM": 1811.25,
        "OnboardVoltage": 27314,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 366,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1041,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27256967,
        "Time": "2022-02-23T19:50:15",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30645,
        "Lon": 86.1356,
        "Speed": 15.1,
        "Height": 139,
        "Mileage": 53956980,
        "EngineOilPressure": 272,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 81,
        "FuelTemperature": 97,
        "EngineRPM": 1283.125,
        "OnboardVoltage": 27352,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 48,
        "FuelConsumption": 142,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1042,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27259852,
        "Time": "2022-02-23T20:11:07",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3103676,
        "Lon": 86.15375,
        "Speed": 14.0,
        "Height": 309,
        "Mileage": 53960196,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 97,
        "EngineRPM": 1809.5,
        "OnboardVoltage": 27308,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 369,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1042,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27262249,
        "Time": "2022-02-23T20:28:04",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3110046,
        "Lon": 86.13698,
        "Speed": 35.7,
        "Height": 205,
        "Mileage": 53964828,
        "EngineOilPressure": 400,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 1287.75,
        "OnboardVoltage": 27299,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 13,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1042,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27264996,
        "Time": "2022-02-23T20:48:21",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.31376,
        "Lon": 86.1489,
        "Speed": 19.8,
        "Height": 263,
        "Mileage": 53968292,
        "EngineOilPressure": 464,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 99,
        "EngineRPM": 1817.375,
        "OnboardVoltage": 27390,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 84,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1043,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27266708,
        "Time": "2022-02-23T21:02:42",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30716,
        "Lon": 86.16323,
        "Speed": 32.0,
        "Height": 380,
        "Mileage": 53971380,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 85,
        "FuelTemperature": 101,
        "EngineRPM": 1314.875,
        "OnboardVoltage": 27331,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1043,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27268042,
        "Time": "2022-02-23T21:12:50",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3045959,
        "Lon": 86.14339,
        "Speed": 33.1,
        "Height": 77,
        "Mileage": 53975736,
        "EngineOilPressure": 408,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 98,
        "EngineRPM": 1298.875,
        "OnboardVoltage": 27372,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 1,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1043,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27271879,
        "Time": "2022-02-23T21:41:36",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.303688,
        "Lon": 86.1438751,
        "Speed": 13.3,
        "Height": 77,
        "Mileage": 53978276,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 80,
        "FuelTemperature": 97,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27308,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 90,
        "FuelConsumption": 369,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1044,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27274649,
        "Time": "2022-02-23T22:00:21",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3071747,
        "Lon": 86.17055,
        "Speed": 8.1,
        "Height": 413,
        "Mileage": 53982788,
        "EngineOilPressure": 456,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 98,
        "EngineRPM": 1808.625,
        "OnboardVoltage": 27320,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 86,
        "FuelConsumption": 369,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1044,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27276816,
        "Time": "2022-02-23T22:16:27",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30048,
        "Lon": 86.14594,
        "Speed": 26.2,
        "Height": 42,
        "Mileage": 53988156,
        "EngineOilPressure": 404,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 82,
        "FuelTemperature": 100,
        "EngineRPM": 1297.75,
        "OnboardVoltage": 27326,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 6,
        "FuelConsumption": 49,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1044,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27280624,
        "Time": "2022-02-23T22:43:04",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.2943649,
        "Lon": 86.1482849,
        "Speed": 12.7,
        "Height": -28,
        "Mileage": 53990620,
        "EngineOilPressure": 480,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 97,
        "EngineRPM": 1802.5,
        "OnboardVoltage": 27330,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 94,
        "FuelConsumption": 346,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1045,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27284175,
        "Time": "2022-02-23T23:07:00",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.306633,
        "Lon": 86.1642,
        "Speed": 9.0,
        "Height": 384,
        "Mileage": 53996348,
        "EngineOilPressure": 448,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 100,
        "EngineRPM": 1807.875,
        "OnboardVoltage": 27307,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 89,
        "FuelConsumption": 373,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1045,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27286568,
        "Time": "2022-02-23T23:22:11",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3034248,
        "Lon": 86.13698,
        "Speed": 33.7,
        "Height": 108,
        "Mileage": 54001284,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 86,
        "FuelTemperature": 102,
        "EngineRPM": 1299.375,
        "OnboardVoltage": 27298,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 14,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1045,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27289627,
        "Time": "2022-02-23T23:44:19",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3016167,
        "Lon": 86.14246,
        "Speed": 16.4,
        "Height": 13,
        "Mileage": 54003840,
        "EngineOilPressure": 460,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 97,
        "EngineRPM": 769.0,
        "OnboardVoltage": 27344,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 11,
        "FuelConsumption": 24,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1046,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27293031,
        "Time": "2022-02-24T00:08:11",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3065224,
        "Lon": 86.16393,
        "Speed": 10.0,
        "Height": 384,
        "Mileage": 54009512,
        "EngineOilPressure": 444,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 87,
        "FuelTemperature": 100,
        "EngineRPM": 1602.75,
        "OnboardVoltage": 27302,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 68,
        "FuelConsumption": 293,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1046,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27295888,
        "Time": "2022-02-24T00:28:24",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3131332,
        "Lon": 86.14673,
        "Speed": 0.0,
        "Height": 265,
        "Mileage": 54012948,
        "EngineOilPressure": 380,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 101,
        "EngineRPM": 948.375,
        "OnboardVoltage": 27497,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 40,
        "FuelConsumption": 62,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1046,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27300761,
        "Time": "2022-02-24T01:19:51",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3006325,
        "Lon": 86.13942,
        "Speed": 5.0,
        "Height": 17,
        "Mileage": 54016536,
        "EngineOilPressure": 248,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 98,
        "EngineRPM": 760.5,
        "OnboardVoltage": 27796,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 13,
        "FuelConsumption": 17,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1047,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27305394,
        "Time": "2022-02-24T01:51:45",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.30484,
        "Lon": 86.14329,
        "Speed": 10.5,
        "Height": 84,
        "Mileage": 54018380,
        "EngineOilPressure": 468,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 83,
        "FuelTemperature": 99,
        "EngineRPM": 1810.625,
        "OnboardVoltage": 27494,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 88,
        "FuelConsumption": 370,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1048,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27308984,
        "Time": "2022-02-24T02:13:27",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3087349,
        "Lon": 86.17342,
        "Speed": 5.3,
        "Height": 428,
        "Mileage": 54023340,
        "EngineOilPressure": 376,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 88,
        "FuelTemperature": 102,
        "EngineRPM": 781.125,
        "OnboardVoltage": 27615,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 176,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1048,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27314257,
        "Time": "2022-02-24T02:52:00",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3139648,
        "Lon": 86.1416,
        "Speed": 30.1,
        "Height": 242,
        "Mileage": 54026224,
        "EngineOilPressure": 412,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 77,
        "FuelTemperature": 69,
        "EngineRPM": 1298.125,
        "OnboardVoltage": 27419,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 0,
        "FuelConsumption": 16,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1049,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    },
    {
        "Id": 27316570,
        "Time": "2022-02-24T03:07:10",
        "TruckId": 603,
        "Imei": "868328058805546",
        "Lat": 54.3081551,
        "Lon": 86.1335449,
        "Speed": 13.1,
        "Height": 158,
        "Mileage": 54028916,
        "EngineOilPressure": 480,
        "BoostPressure": null,
        "CoolantPressure": null,
        "InjectorRailPressure": null,
        "EngineTemperature": 78,
        "FuelTemperature": 67,
        "EngineRPM": 1810.0,
        "OnboardVoltage": 27519,
        "EngineSpeed": null,
        "TotalMileage": 121039340,
        "AcceleratorPedalPosition": 102,
        "LoadPercentage": 87,
        "FuelConsumption": 362,
        "TransportSpeedOnWheels": null,
        "SeatBeltCondition": 0,
        "ServiceBrakePedalPosition": 0,
        "TachographSpeed": 0,
        "DailyMileage": -5.0,
        "TotalEngineRunningTime": 1049,
        "DailyFuelConsumption": 0.0,
        "TotalFuelConsumption": 0.0,
        "AxleLoad1": 0.0,
        "AxleLoad2": 0.0,
        "AxleLoad3": 0.0,
        "AxleLoad4": 0.0,
        "AxleLoad5": 0.0,
        "OilTemperature": -273.0,
        "InstantOilConsumption": null,
        "FuelLevel": 0.0
    }
];

mock.onGet('/controllers').reply(() => [200, data])